(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["able-react"] = factory();
	else
		root["able-react"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 4022:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  XTd: () => (/* reexport */ GeneratedPictoComponents_Accessories104),
  RSN: () => (/* reexport */ GeneratedPictoComponents_Accessories56),
  aco: () => (/* reexport */ GeneratedPictoComponents_AccountsPayments104),
  BaD: () => (/* reexport */ GeneratedPictoComponents_AccountsPayments56),
  x5q: () => (/* reexport */ GeneratedPictoComponents_Add104),
  DrC: () => (/* reexport */ GeneratedPictoComponents_Add56),
  N5_: () => (/* reexport */ GeneratedPictoComponents_AddPhone104),
  ZPK: () => (/* reexport */ GeneratedPictoComponents_AddPhone56),
  jrd: () => (/* reexport */ GeneratedPictoComponents_AdultFemale104),
  OGy: () => (/* reexport */ GeneratedPictoComponents_AdultFemale56),
  CDJ: () => (/* reexport */ GeneratedPictoComponents_AdultMale104),
  l1h: () => (/* reexport */ GeneratedPictoComponents_AdultMale56),
  i$: () => (/* reexport */ GeneratedPictoComponents_AppMyTelstra104),
  UNI: () => (/* reexport */ GeneratedPictoComponents_AppMyTelstra56),
  _qg: () => (/* reexport */ GeneratedPictoComponents_Appointment104),
  QaO: () => (/* reexport */ GeneratedPictoComponents_Appointment56),
  qiP: () => (/* reexport */ GeneratedPictoComponents_Australia104),
  nLT: () => (/* reexport */ GeneratedPictoComponents_Australia56),
  wDL: () => (/* reexport */ GeneratedPictoComponents_Baby104),
  d$r: () => (/* reexport */ GeneratedPictoComponents_Baby56),
  a95: () => (/* reexport */ GeneratedPictoComponents_Bank104),
  WwZ: () => (/* reexport */ GeneratedPictoComponents_Bank56),
  wf1: () => (/* reexport */ GeneratedPictoComponents_BillEmail56),
  brd: () => (/* reexport */ GeneratedPictoComponents_BillEmails104),
  X2R: () => (/* reexport */ GeneratedPictoComponents_BillEmails56),
  Bih: () => (/* reexport */ GeneratedPictoComponents_BillOverview104),
  Nhf: () => (/* reexport */ GeneratedPictoComponents_BillOverview56),
  Mz6: () => (/* reexport */ GeneratedPictoComponents_BillPaid104),
  xzN: () => (/* reexport */ GeneratedPictoComponents_BillPaid56),
  l2v: () => (/* reexport */ GeneratedPictoComponents_BillSummary104),
  JG$: () => (/* reexport */ GeneratedPictoComponents_BillSummary56),
  jxJ: () => (/* reexport */ GeneratedPictoComponents_BroadbandEnterpriseSim104),
  mWg: () => (/* reexport */ GeneratedPictoComponents_BroadbandEnterpriseSim56),
  HhU: () => (/* reexport */ GeneratedPictoComponents_BroadbandHome104),
  UBi: () => (/* reexport */ GeneratedPictoComponents_BroadbandHome56),
  mUK: () => (/* reexport */ GeneratedPictoComponents_BroadbandMobile104),
  ocJ: () => (/* reexport */ GeneratedPictoComponents_BroadbandMobile56),
  H$s: () => (/* reexport */ GeneratedPictoComponents_BroadbandMobileSim104),
  JZA: () => (/* reexport */ GeneratedPictoComponents_BroadbandMobileSim56),
  McE: () => (/* reexport */ GeneratedPictoComponents_Building104),
  Dy2: () => (/* reexport */ GeneratedPictoComponents_Building56),
  b$e: () => (/* reexport */ GeneratedPictoComponents_Bundles104),
  yMS: () => (/* reexport */ GeneratedPictoComponents_Bundles56),
  ai7: () => (/* reexport */ GeneratedPictoComponents_Bus104),
  pAV: () => (/* reexport */ GeneratedPictoComponents_Bus56),
  CQI: () => (/* reexport */ GeneratedPictoComponents_BusinessIdeas104),
  Cpv: () => (/* reexport */ GeneratedPictoComponents_BusinessIdeas56),
  bK0: () => (/* reexport */ GeneratedPictoComponents_BusinessOperation104),
  DRJ: () => (/* reexport */ GeneratedPictoComponents_BusinessOperation56),
  adf: () => (/* reexport */ GeneratedPictoComponents_BusinessSoftware104),
  CHF: () => (/* reexport */ GeneratedPictoComponents_BusinessSoftware56),
  ey7: () => (/* reexport */ GeneratedPictoComponents_BusinessStrategy104),
  mpB: () => (/* reexport */ GeneratedPictoComponents_BusinessStrategy56),
  brU: () => (/* reexport */ GeneratedPictoComponents_Calendar104),
  wNk: () => (/* reexport */ GeneratedPictoComponents_Calendar56),
  HGG: () => (/* reexport */ GeneratedPictoComponents_CardAdded104),
  ein: () => (/* reexport */ GeneratedPictoComponents_CardAdded56),
  s8S: () => (/* reexport */ GeneratedPictoComponents_Cart104),
  eDy: () => (/* reexport */ GeneratedPictoComponents_Cart56),
  RSg: () => (/* reexport */ GeneratedPictoComponents_ChangePlan104),
  wQf: () => (/* reexport */ GeneratedPictoComponents_ChangePlan56),
  lwL: () => (/* reexport */ GeneratedPictoComponents_Chat104),
  OWV: () => (/* reexport */ GeneratedPictoComponents_Chat56),
  YI6: () => (/* reexport */ GeneratedPictoComponents_Child104),
  r$N: () => (/* reexport */ GeneratedPictoComponents_Child56),
  lWq: () => (/* reexport */ GeneratedPictoComponents_Clock104),
  M1_: () => (/* reexport */ GeneratedPictoComponents_Clock56),
  DQC: () => (/* reexport */ GeneratedPictoComponents_Compare104),
  BUq: () => (/* reexport */ GeneratedPictoComponents_Compare56),
  aQe: () => (/* reexport */ GeneratedPictoComponents_CoverageMap104),
  _mb: () => (/* reexport */ GeneratedPictoComponents_CoverageMap56),
  ETy: () => (/* reexport */ GeneratedPictoComponents_CoverageMobile104),
  aSB: () => (/* reexport */ GeneratedPictoComponents_CoverageMobile56),
  fs4: () => (/* reexport */ GeneratedPictoComponents_CoverageNetwork104),
  t9q: () => (/* reexport */ GeneratedPictoComponents_CoverageNetwork56),
  W7S: () => (/* reexport */ GeneratedPictoComponents_DataPacks104),
  DSZ: () => (/* reexport */ GeneratedPictoComponents_DataPacks56),
  YE_: () => (/* reexport */ GeneratedPictoComponents_DataPool104),
  Xx6: () => (/* reexport */ GeneratedPictoComponents_DataPool56),
  Ok$: () => (/* reexport */ GeneratedPictoComponents_Deal104),
  SuH: () => (/* reexport */ GeneratedPictoComponents_Deal56),
  GTG: () => (/* reexport */ GeneratedPictoComponents_Delivery104),
  tRm: () => (/* reexport */ GeneratedPictoComponents_Delivery56),
  K5k: () => (/* reexport */ GeneratedPictoComponents_DeviceLocator104),
  bsC: () => (/* reexport */ GeneratedPictoComponents_DeviceLocator56),
  GvT: () => (/* reexport */ GeneratedPictoComponents_DeviceProtect104),
  Vtl: () => (/* reexport */ GeneratedPictoComponents_DeviceProtect56),
  oZ8: () => (/* reexport */ GeneratedPictoComponents_Devices104),
  IN7: () => (/* reexport */ GeneratedPictoComponents_Devices56),
  li3: () => (/* reexport */ GeneratedPictoComponents_Disruptions104),
  D5U: () => (/* reexport */ GeneratedPictoComponents_Disruptions56),
  qXr: () => (/* reexport */ GeneratedPictoComponents_Document104),
  rBW: () => (/* reexport */ GeneratedPictoComponents_Document56),
  zIi: () => (/* reexport */ GeneratedPictoComponents_Download104),
  ieA: () => (/* reexport */ GeneratedPictoComponents_Download56),
  Ajh: () => (/* reexport */ GeneratedPictoComponents_ESIM104),
  rZ2: () => (/* reexport */ GeneratedPictoComponents_ESIM56),
  IAd: () => (/* reexport */ GeneratedPictoComponents_EarnPoints104),
  n2T: () => (/* reexport */ GeneratedPictoComponents_EarnPoints56),
  CKo: () => (/* reexport */ GeneratedPictoComponents_Edit104),
  Z1W: () => (/* reexport */ GeneratedPictoComponents_Edit56),
  zJi: () => (/* reexport */ GeneratedPictoComponents_Electricity104),
  rzt: () => (/* reexport */ GeneratedPictoComponents_Electricity56),
  LwD: () => (/* reexport */ GeneratedPictoComponents_ElectricityMeter104),
  BRD: () => (/* reexport */ GeneratedPictoComponents_ElectricityMeter56),
  g$g: () => (/* reexport */ GeneratedPictoComponents_EmptyStateBox104),
  e$j: () => (/* reexport */ GeneratedPictoComponents_EmptyStateBox56),
  scW: () => (/* reexport */ GeneratedPictoComponents_EmptyStateTray104),
  LOC: () => (/* reexport */ GeneratedPictoComponents_EmptyStateTray56),
  mwz: () => (/* reexport */ GeneratedPictoComponents_Energy104),
  cxZ: () => (/* reexport */ GeneratedPictoComponents_Energy56),
  PEY: () => (/* reexport */ GeneratedPictoComponents_EnergySolar104),
  Eg3: () => (/* reexport */ GeneratedPictoComponents_EnergySolar56),
  IGW: () => (/* reexport */ GeneratedPictoComponents_EnergyWind104),
  uRb: () => (/* reexport */ GeneratedPictoComponents_EnergyWind56),
  Y0F: () => (/* reexport */ GeneratedPictoComponents_EnterpriseCloud104),
  Pae: () => (/* reexport */ GeneratedPictoComponents_EnterpriseCloud56),
  CVp: () => (/* reexport */ GeneratedPictoComponents_Entertainment104),
  Akg: () => (/* reexport */ GeneratedPictoComponents_Entertainment56),
  g2b: () => (/* reexport */ GeneratedPictoComponents_EntertainmentPackages104),
  rSd: () => (/* reexport */ GeneratedPictoComponents_EntertainmentPackages56),
  q3E: () => (/* reexport */ GeneratedPictoComponents_Error104),
  y8Q: () => (/* reexport */ GeneratedPictoComponents_Error56),
  kSh: () => (/* reexport */ GeneratedPictoComponents_FailedConnection104),
  bqd: () => (/* reexport */ GeneratedPictoComponents_FailedConnection56),
  Qo6: () => (/* reexport */ GeneratedPictoComponents_Feedback104),
  PzP: () => (/* reexport */ GeneratedPictoComponents_Feedback56),
  ozX: () => (/* reexport */ GeneratedPictoComponents_Foxtel104),
  R7k: () => (/* reexport */ GeneratedPictoComponents_Foxtel56),
  F_x: () => (/* reexport */ GeneratedPictoComponents_Gaming104),
  QbW: () => (/* reexport */ GeneratedPictoComponents_Gaming56),
  sxi: () => (/* reexport */ GeneratedPictoComponents_Gas104),
  SLv: () => (/* reexport */ GeneratedPictoComponents_Gas56),
  Jqg: () => (/* reexport */ GeneratedPictoComponents_GasMeter104),
  ciy: () => (/* reexport */ GeneratedPictoComponents_GasMeter56),
  ZeT: () => (/* reexport */ GeneratedPictoComponents_Gift104),
  ezu: () => (/* reexport */ GeneratedPictoComponents_Gift56),
  WHB: () => (/* reexport */ GeneratedPictoComponents_GlobalNetworks104),
  Ici: () => (/* reexport */ GeneratedPictoComponents_GlobalNetworks56),
  Vi6: () => (/* reexport */ GeneratedPictoComponents_GreenEnergy104),
  FMV: () => (/* reexport */ GeneratedPictoComponents_GreenEnergy56),
  iUm: () => (/* reexport */ GeneratedPictoComponents_Help104),
  wal: () => (/* reexport */ GeneratedPictoComponents_Help56),
  hF6: () => (/* reexport */ GeneratedPictoComponents_History104),
  a8D: () => (/* reexport */ GeneratedPictoComponents_History56),
  ri0: () => (/* reexport */ GeneratedPictoComponents_Home104),
  hjU: () => (/* reexport */ GeneratedPictoComponents_Home56),
  TdW: () => (/* reexport */ GeneratedPictoComponents_IOT104),
  lqr: () => (/* reexport */ GeneratedPictoComponents_IOT56),
  _bn: () => (/* reexport */ GeneratedPictoComponents_IOTUpdate104),
  Sb8: () => (/* reexport */ GeneratedPictoComponents_IOTUpdate56),
  BRu: () => (/* reexport */ GeneratedPictoComponents_Information104),
  Cuv: () => (/* reexport */ GeneratedPictoComponents_Information56),
  EAo: () => (/* reexport */ GeneratedPictoComponents_Installation104),
  vxn: () => (/* reexport */ GeneratedPictoComponents_Installation56),
  eN1: () => (/* reexport */ GeneratedPictoComponents_InternationalCalls104),
  fY1: () => (/* reexport */ GeneratedPictoComponents_InternationalCalls56),
  FbT: () => (/* reexport */ GeneratedPictoComponents_InternationalMobileCalls104),
  ONF: () => (/* reexport */ GeneratedPictoComponents_InternationalMobileCalls56),
  bJI: () => (/* reexport */ GeneratedPictoComponents_Internet104),
  I46: () => (/* reexport */ GeneratedPictoComponents_Internet56),
  SGn: () => (/* reexport */ GeneratedPictoComponents_InternetExtras104),
  NYS: () => (/* reexport */ GeneratedPictoComponents_InternetExtras56),
  B1: () => (/* reexport */ GeneratedPictoComponents_InternetOptimiser104),
  ert: () => (/* reexport */ GeneratedPictoComponents_InternetOptimiser56),
  lvw: () => (/* reexport */ GeneratedPictoComponents_Landline104),
  Bz: () => (/* reexport */ GeneratedPictoComponents_Landline56),
  SX5: () => (/* reexport */ GeneratedPictoComponents_Laptop104),
  Yon: () => (/* reexport */ GeneratedPictoComponents_Laptop56),
  iTQ: () => (/* reexport */ GeneratedPictoComponents_Legal104),
  TXk: () => (/* reexport */ GeneratedPictoComponents_Legal56),
  _To: () => (/* reexport */ GeneratedPictoComponents_MBBRoaming104),
  wpg: () => (/* reexport */ GeneratedPictoComponents_MBBRoaming56),
  bcY: () => (/* reexport */ GeneratedPictoComponents_Mail104),
  dSo: () => (/* reexport */ GeneratedPictoComponents_Mail56),
  BGl: () => (/* reexport */ GeneratedPictoComponents_MapMarkeGlobal104),
  _v0: () => (/* reexport */ GeneratedPictoComponents_MapMarkeGlobal56),
  WI3: () => (/* reexport */ GeneratedPictoComponents_MapMarker104),
  rnZ: () => (/* reexport */ GeneratedPictoComponents_MapMarker56),
  ZV$: () => (/* reexport */ GeneratedPictoComponents_Membership104),
  Btd: () => (/* reexport */ GeneratedPictoComponents_Membership56),
  hB6: () => (/* reexport */ GeneratedPictoComponents_Mobile104),
  Lvx: () => (/* reexport */ GeneratedPictoComponents_Mobile56),
  D7f: () => (/* reexport */ GeneratedPictoComponents_MobileAccelerator104),
  exz: () => (/* reexport */ GeneratedPictoComponents_MobileAccelerator56),
  qt4: () => (/* reexport */ GeneratedPictoComponents_MobileSim104),
  JqI: () => (/* reexport */ GeneratedPictoComponents_MobileSim56),
  jS_: () => (/* reexport */ GeneratedPictoComponents_MoveHouse104),
  PFt: () => (/* reexport */ GeneratedPictoComponents_MoveHouse56),
  Ll5: () => (/* reexport */ GeneratedPictoComponents_Movies104),
  rAw: () => (/* reexport */ GeneratedPictoComponents_Movies56),
  L6o: () => (/* reexport */ GeneratedPictoComponents_Music104),
  lck: () => (/* reexport */ GeneratedPictoComponents_Music56),
  btj: () => (/* reexport */ GeneratedPictoComponents_NBN104),
  VDp: () => (/* reexport */ GeneratedPictoComponents_NBN56),
  J6z: () => (/* reexport */ GeneratedPictoComponents_NetworkSpeed104),
  G0x: () => (/* reexport */ GeneratedPictoComponents_NetworkSpeed56),
  q_V: () => (/* reexport */ GeneratedPictoComponents_NetworkSpeeds104),
  g9s: () => (/* reexport */ GeneratedPictoComponents_NetworkSpeeds56),
  v_5: () => (/* reexport */ GeneratedPictoComponents_News104),
  w6e: () => (/* reexport */ GeneratedPictoComponents_News56),
  bYv: () => (/* reexport */ GeneratedPictoComponents_NotificationCall104),
  XHb: () => (/* reexport */ GeneratedPictoComponents_NotificationCall56),
  duM: () => (/* reexport */ GeneratedPictoComponents_NotificationEmail104),
  eE8: () => (/* reexport */ GeneratedPictoComponents_NotificationEmail56),
  or5: () => (/* reexport */ GeneratedPictoComponents_NotificationMessage104),
  vj9: () => (/* reexport */ GeneratedPictoComponents_NotificationMessage56),
  sow: () => (/* reexport */ GeneratedPictoComponents_NotificationReminder104),
  hSV: () => (/* reexport */ GeneratedPictoComponents_NotificationReminder56),
  P0R: () => (/* reexport */ GeneratedPictoComponents_Notifications104),
  Qt7: () => (/* reexport */ GeneratedPictoComponents_Notifications56),
  QDA: () => (/* reexport */ GeneratedPictoComponents_OneNumber104),
  IeU: () => (/* reexport */ GeneratedPictoComponents_OneNumber56),
  Anw: () => (/* reexport */ GeneratedPictoComponents_Payment104),
  Hql: () => (/* reexport */ GeneratedPictoComponents_Payment56),
  v5q: () => (/* reexport */ GeneratedPictoComponents_PaymentCalendar104),
  QvZ: () => (/* reexport */ GeneratedPictoComponents_PaymentCalendar56),
  i8x: () => (/* reexport */ GeneratedPictoComponents_PaymentHelp104),
  fVQ: () => (/* reexport */ GeneratedPictoComponents_PaymentHelp56),
  DoT: () => (/* reexport */ GeneratedPictoComponents_PaymentPlan104),
  R9p: () => (/* reexport */ GeneratedPictoComponents_PaymentPlan56),
  na2: () => (/* reexport */ GeneratedPictoComponents_PeaceOfMind104),
  Dj1: () => (/* reexport */ GeneratedPictoComponents_PeaceOfMind56),
  YuB: () => (/* reexport */ GeneratedPictoComponents_Perfect104),
  spX: () => (/* reexport */ GeneratedPictoComponents_Perfect56),
  rAN: () => (/* reexport */ GeneratedPictoComponents_Phone104),
  tcf: () => (/* reexport */ GeneratedPictoComponents_Phone56),
  BHA: () => (/* reexport */ GeneratedPictoComponents_Picto4G104),
  KXb: () => (/* reexport */ GeneratedPictoComponents_Picto4G56),
  NHx: () => (/* reexport */ GeneratedPictoComponents_Picto4GX104),
  Bfj: () => (/* reexport */ GeneratedPictoComponents_Picto4GX56),
  Wvn: () => (/* reexport */ GeneratedPictoComponents_Picto5G104),
  bOI: () => (/* reexport */ GeneratedPictoComponents_Picto5G56),
  gh0: () => (/* reexport */ GeneratedPictoComponents_Pin104),
  kbu: () => (/* reexport */ GeneratedPictoComponents_Pin56),
  TzK: () => (/* reexport */ GeneratedPictoComponents_Placeholder104),
  JN5: () => (/* reexport */ GeneratedPictoComponents_Placeholder56),
  Q8U: () => (/* reexport */ GeneratedPictoComponents_PortMobile104),
  OCc: () => (/* reexport */ GeneratedPictoComponents_PortMobile56),
  lep: () => (/* reexport */ GeneratedPictoComponents_PortPhone104),
  A8I: () => (/* reexport */ GeneratedPictoComponents_PortPhone56),
  $PY: () => (/* reexport */ GeneratedPictoComponents_PortSIM104),
  Ci1: () => (/* reexport */ GeneratedPictoComponents_PortSIM56),
  vE2: () => (/* reexport */ GeneratedPictoComponents_PostPaid104),
  raY: () => (/* reexport */ GeneratedPictoComponents_PostPaid56),
  GWJ: () => (/* reexport */ GeneratedPictoComponents_PrePaid104),
  FB_: () => (/* reexport */ GeneratedPictoComponents_PrePaid56),
  Xgg: () => (/* reexport */ GeneratedPictoComponents_Preferences104),
  rBF: () => (/* reexport */ GeneratedPictoComponents_Preferences56),
  qMn: () => (/* reexport */ GeneratedPictoComponents_Profile104),
  jih: () => (/* reexport */ GeneratedPictoComponents_Profile56),
  o2s: () => (/* reexport */ GeneratedPictoComponents_PromoCombined104),
  QDR: () => (/* reexport */ GeneratedPictoComponents_PromoCombined56),
  TzJ: () => (/* reexport */ GeneratedPictoComponents_PromoData104),
  Wao: () => (/* reexport */ GeneratedPictoComponents_PromoData56),
  cFO: () => (/* reexport */ GeneratedPictoComponents_PromoDiscount104),
  GDA: () => (/* reexport */ GeneratedPictoComponents_PromoDiscount56),
  rj2: () => (/* reexport */ GeneratedPictoComponents_RecurringPayment104),
  $Xz: () => (/* reexport */ GeneratedPictoComponents_RecurringPayment56),
  g42: () => (/* reexport */ GeneratedPictoComponents_RedeemPoints104),
  ytt: () => (/* reexport */ GeneratedPictoComponents_RedeemPoints56),
  b8o: () => (/* reexport */ GeneratedPictoComponents_Rewards104),
  Tp2: () => (/* reexport */ GeneratedPictoComponents_Rewards56),
  j9x: () => (/* reexport */ GeneratedPictoComponents_Roaming104),
  DLp: () => (/* reexport */ GeneratedPictoComponents_Roaming56),
  Pzb: () => (/* reexport */ GeneratedPictoComponents_RoamingOn104),
  Kzt: () => (/* reexport */ GeneratedPictoComponents_RoamingOn56),
  g09: () => (/* reexport */ GeneratedPictoComponents_SIM104),
  ZtF: () => (/* reexport */ GeneratedPictoComponents_SIM56),
  bGH: () => (/* reexport */ GeneratedPictoComponents_Search104),
  Js7: () => (/* reexport */ GeneratedPictoComponents_Search56),
  kQo: () => (/* reexport */ GeneratedPictoComponents_Security104),
  Wme: () => (/* reexport */ GeneratedPictoComponents_Security56),
  YY6: () => (/* reexport */ GeneratedPictoComponents_SecurityHome104),
  aU7: () => (/* reexport */ GeneratedPictoComponents_SecurityHome56),
  qnS: () => (/* reexport */ GeneratedPictoComponents_SecurityInternet104),
  CL6: () => (/* reexport */ GeneratedPictoComponents_SecurityInternet56),
  Sc0: () => (/* reexport */ GeneratedPictoComponents_SecurityMobile104),
  ylJ: () => (/* reexport */ GeneratedPictoComponents_SecurityMobile56),
  ANW: () => (/* reexport */ GeneratedPictoComponents_Services104),
  rFN: () => (/* reexport */ GeneratedPictoComponents_Services56),
  RXT: () => (/* reexport */ GeneratedPictoComponents_Settings104),
  OZf: () => (/* reexport */ GeneratedPictoComponents_Settings56),
  xOX: () => (/* reexport */ GeneratedPictoComponents_Shop104),
  KrX: () => (/* reexport */ GeneratedPictoComponents_Shop56),
  Bu9: () => (/* reexport */ GeneratedPictoComponents_SmartHome104),
  z2T: () => (/* reexport */ GeneratedPictoComponents_SmartHome56),
  it4: () => (/* reexport */ GeneratedPictoComponents_SomethingWentWrong104),
  phD: () => (/* reexport */ GeneratedPictoComponents_SomethingWentWrong56),
  hp9: () => (/* reexport */ GeneratedPictoComponents_Sporting104),
  W8u: () => (/* reexport */ GeneratedPictoComponents_Sporting56),
  VxG: () => (/* reexport */ GeneratedPictoComponents_Store104),
  Z72: () => (/* reexport */ GeneratedPictoComponents_Store56),
  O0i: () => (/* reexport */ GeneratedPictoComponents_StoreAddress104),
  qW$: () => (/* reexport */ GeneratedPictoComponents_StoreAddress56),
  vuq: () => (/* reexport */ GeneratedPictoComponents_Success104),
  RJ1: () => (/* reexport */ GeneratedPictoComponents_Success56),
  P7G: () => (/* reexport */ GeneratedPictoComponents_SupportPhone104),
  sBE: () => (/* reexport */ GeneratedPictoComponents_SupportPhone56),
  osG: () => (/* reexport */ GeneratedPictoComponents_Switch104),
  TSZ: () => (/* reexport */ GeneratedPictoComponents_Switch56),
  mjY: () => (/* reexport */ GeneratedPictoComponents_TV104),
  m1N: () => (/* reexport */ GeneratedPictoComponents_TV56),
  q9Z: () => (/* reexport */ GeneratedPictoComponents_Tablet104),
  lwP: () => (/* reexport */ GeneratedPictoComponents_Tablet56),
  TjP: () => (/* reexport */ GeneratedPictoComponents_TabletSim104),
  zbW: () => (/* reexport */ GeneratedPictoComponents_TabletSim56),
  GGM: () => (/* reexport */ GeneratedPictoComponents_Technician104),
  Pfq: () => (/* reexport */ GeneratedPictoComponents_Technician56),
  qDb: () => (/* reexport */ GeneratedPictoComponents_Teen104),
  qVu: () => (/* reexport */ GeneratedPictoComponents_Teen56),
  qrC: () => (/* reexport */ GeneratedPictoComponents_Telstra104),
  UeK: () => (/* reexport */ GeneratedPictoComponents_Telstra56),
  oE8: () => (/* reexport */ GeneratedPictoComponents_TelstraAir104),
  SkN: () => (/* reexport */ GeneratedPictoComponents_TelstraAir56),
  MJX: () => (/* reexport */ GeneratedPictoComponents_TelstraLocator104),
  EjF: () => (/* reexport */ GeneratedPictoComponents_TelstraLocator56),
  rJf: () => (/* reexport */ GeneratedPictoComponents_TelstraPlus104),
  Xlr: () => (/* reexport */ GeneratedPictoComponents_TelstraPlus56),
  O$r: () => (/* reexport */ GeneratedPictoComponents_TelstraTV104),
  L0t: () => (/* reexport */ GeneratedPictoComponents_TelstraTV56),
  VDC: () => (/* reexport */ GeneratedPictoComponents_Ticket104),
  WQb: () => (/* reexport */ GeneratedPictoComponents_Ticket56),
  Lx: () => (/* reexport */ GeneratedPictoComponents_TrackOrder104),
  ao0: () => (/* reexport */ GeneratedPictoComponents_TrackOrder56),
  wMQ: () => (/* reexport */ GeneratedPictoComponents_Train104),
  xuq: () => (/* reexport */ GeneratedPictoComponents_Train56),
  eUC: () => (/* reexport */ GeneratedPictoComponents_TransferRequest104),
  gYY: () => (/* reexport */ GeneratedPictoComponents_TransferRequest56),
  Sjn: () => (/* reexport */ GeneratedPictoComponents_Troubleshoot104),
  Bax: () => (/* reexport */ GeneratedPictoComponents_Troubleshoot56),
  N_L: () => (/* reexport */ GeneratedPictoComponents_TruckFire104),
  yFu: () => (/* reexport */ GeneratedPictoComponents_TruckFire56),
  WPl: () => (/* reexport */ GeneratedPictoComponents_UnifiedComms104),
  vzL: () => (/* reexport */ GeneratedPictoComponents_UnifiedComms56),
  zVv: () => (/* reexport */ GeneratedPictoComponents_Unlimited104),
  HLs: () => (/* reexport */ GeneratedPictoComponents_Unlimited56),
  Efi: () => (/* reexport */ GeneratedPictoComponents_VIP104),
  sHA: () => (/* reexport */ GeneratedPictoComponents_VIP56),
  x4L: () => (/* reexport */ GeneratedPictoComponents_Warning104),
  QrA: () => (/* reexport */ GeneratedPictoComponents_Warning56),
  kKL: () => (/* reexport */ GeneratedPictoComponents_WeCare104),
  N9Y: () => (/* reexport */ GeneratedPictoComponents_WeCare56),
  uHO: () => (/* reexport */ GeneratedPictoComponents_WiFi104),
  bDU: () => (/* reexport */ GeneratedPictoComponents_WiFi56),
  Fr0: () => (/* reexport */ GeneratedPictoComponents_WiFiBooster104),
  qdE: () => (/* reexport */ GeneratedPictoComponents_WiFiBooster56),
  orh: () => (/* reexport */ GeneratedPictoComponents_Window104),
  DLU: () => (/* reexport */ GeneratedPictoComponents_Window56)
});

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(8779);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);
// EXTERNAL MODULE: external "@babel/runtime/helpers/objectWithoutProperties"
var objectWithoutProperties_ = __webpack_require__(3838);
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties_);
// EXTERNAL MODULE: external "react/jsx-runtime"
var jsx_runtime_ = __webpack_require__(997);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/AdultFemale104.tsx


var _excluded = ["className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function AdultFemale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, _excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41.28 69.81a16.88 16.88 0 0 1-7-8.23c-.86-2.12-2.94-5-2.51-2.73a52.5 52.5 0 0 1 0 11.62l.23 5.06c-.37 1-.37 2 1.08 2l6.81-.13a1.86 1.86 0 0 0 1.3-3 1.85 1.85 0 0 0 1.12-1.1 1.88 1.88 0 0 0-.13-1.57 1.64 1.64 0 0 0-.88-1.91Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.25 9.86c-12.15.41-20.43 12-22.66 23-.39 2 .65 2.58 2 2.32a17.94 17.94 0 0 0 2.54 0c6.59 0 11.79.48 18 0 .33.2 1.22 0 1.69.16 1.09.45 2.25-.68 2.25-1.72 0-3.62-.12-7.23-.34-10.83.15.2.28.45.43.69.61 1.09 1.15 2.24 1.74 3.36a26.3 26.3 0 0 0 3.24 5.57c.16.19 0 1.15 0 1.19 0 1.54 2.45 2.23 3.56 1.5a16.77 16.77 0 0 0 6.84 0 1.75 1.75 0 0 0 1.3-1.71c-.48-11.03-8.35-23.92-20.59-23.53Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.76 40.65a6.14 6.14 0 0 1 8.08 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M55.9 40.61a6.14 6.14 0 0 1 8.08 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m31.72 55.39.07 22.22 9.68-.04"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.29 95.1c.47-.46 1-.9 1.48-1.32a123.76 123.76 0 0 1 12.09-8.11c5.64-3.58 6-7.34 6-15.52"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M62.05 70.15c0 8.13.47 11.89 6.13 15.4a126.31 126.31 0 0 1 12.12 8.14 19.43 19.43 0 0 1 1.6 1.41"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M65.84 83.81c-4.52 3.88-8 5.83-13.8 5.85s-9.29-1.86-13.86-5.76"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.2 55.1c-2.51-.25-5.07-2.32-6.38-5.45-1.72-4.12-.62-8.5 2.47-9.79a4.86 4.86 0 0 1 2.13-.35"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M74 39.4a4.75 4.75 0 0 1 2.42.3c3.1 1.27 4.23 5.65 2.54 9.78-1.32 3.2-4 5.32-6.52 5.51"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M73.26 35.07a41.4 41.4 0 0 1 .82 8.06c0 16.73-9.84 30.33-22.11 30.37S29.71 60 29.66 43.28a40.2 40.2 0 0 1 .76-8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M51.94 45.24c0 4.55 3 4.75 3 7.42s-3 2.73-3 2.73"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.92 62.8a5.3 5.3 0 0 0 6-.92"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M78.19 35.06a26.25 26.25 0 0 0-52.49.17l26.24-.1V23L58 35.11Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "43.66",
          cy: "45.22",
          r: "2.06"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "59.89",
          cy: "45.16",
          r: "2.06"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AdultFemale104 = (AdultFemale104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/AdultFemale56.tsx


var AdultFemale56_excluded = ["className"];
function AdultFemale56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function AdultFemale56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? AdultFemale56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AdultFemale56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function AdultFemale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AdultFemale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AdultFemale56_objectSpread(AdultFemale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.18 37.56a9 9 0 0 1-3.79-4.43c-.46-1.14-1.58-2.7-1.35-1.47a28.48 28.48 0 0 1 0 6.26l.13 2.72c-.2.57-.2 1.08.58 1.07l3.67-.07a1 1 0 0 0 .83-.59 1 1 0 0 0-.13-1 1 1 0 0 0 .6-.59 1 1 0 0 0-.07-.85.9.9 0 0 0-.47-1Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.93 5.28c-6.54.22-11 6.45-12.2 12.4-.21 1.09.35 1.39 1.09 1.25a7.84 7.84 0 0 0 1.37 0c3.55 0 6.35.26 9.67 0 .18.11.66 0 .91.09.59.24 1.21-.37 1.21-.93 0-1.94-.06-3.89-.18-5.83.08.11.15.24.23.37.33.59.62 1.21.94 1.81a13.81 13.81 0 0 0 1.74 3c.09.1 0 .62 0 .64 0 .83 1.32 1.2 1.92.81a9.12 9.12 0 0 0 3.68 0A.93.93 0 0 0 37 18c-.24-6-4.48-12.93-11.07-12.72Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.36 21.86a3.33 3.33 0 0 1 4.35 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.05 21.84a3.3 3.3 0 0 1 4.35 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m17.03 29.8.04 11.96 5.21-.02"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12 51.18c.25-.25.52-.48.8-.71a67.84 67.84 0 0 1 6.51-4.37c3-1.92 3.24-4 3.23-8.35"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.36 37.75c0 4.37.26 6.4 3.3 8.29a68.22 68.22 0 0 1 6.53 4.38 10.38 10.38 0 0 1 .86.76"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.4 45.1c-2.4 2.09-4.31 3.14-7.4 3.15s-5-1-7.46-3.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.75 29.65a4.55 4.55 0 0 1-3.44-2.94c-.92-2.22-.33-4.58 1.33-5.27a2.68 2.68 0 0 1 1.15-.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.82 21.19a2.41 2.41 0 0 1 1.3.17c1.67.68 2.28 3 1.37 5.26a4.49 4.49 0 0 1-3.51 3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.4 18.86a22.64 22.64 0 0 1 .44 4.34c0 9-5.3 16.33-11.91 16.35s-12-7.26-12-16.27a21.76 21.76 0 0 1 .4-4.28"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.92 24.33c0 2.45 1.61 2.56 1.61 4s-1.62 1.47-1.62 1.47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.83 33.79a2.86 2.86 0 0 0 3.26-.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.05 18.85a14.13 14.13 0 0 0-28.26.09l14.13-.05v-6.52l3.28 6.51Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.46",
        cy: "24.32",
        r: "1.11"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "32.2",
        cy: "24.29",
        r: "1.11"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AdultFemale56 = (AdultFemale56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/AdultMale104.tsx


var AdultMale104_excluded = ["className"];
function AdultMale104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function AdultMale104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? AdultMale104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AdultMale104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function AdultMale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AdultMale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", AdultMale104_objectSpread(AdultMale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M75.07 38.05a23.3 23.3 0 0 0-2.85-12.24 6.25 6.25 0 0 1 0-1.06A15.54 15.54 0 0 0 73.38 17a7.37 7.37 0 0 0-1.08-2.49s-.78-1.76-.82-1.56l-.33-.37c-4.79 3.09-13.17.75-18.44 0-4.94-.65-10.05-1.11-14.4 1.64-7.43 4.66-8.91 13.37-9.64 21.56V37s.62 3.29.62 3.43c1.19 2.9 1.85-.53 2-2.71v-.09S36.08 17.43 51.8 17s19.35 18.61 19.35 18.61c.11.69 1.17 3.4 1.19 3.81.29 3.9 2.58 2.17 2.73 0 .01-.52.01-.95 0-1.37Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M12.93 96.55a23.13 23.13 0 0 1 3-2.31 149.83 149.83 0 0 1 14.5-7.68c6.63-3.31 11-6.88 11.87-14.49"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M61.82 71.77c.75 7.82 5.2 11.44 11.91 14.86a149.92 149.92 0 0 1 14.5 7.69 22.8 22.8 0 0 1 2.84 2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.9 57.35c-2.41-.23-4.88-2.23-6.13-5.24-1.63-3.94-.56-8.13 2.4-9.35a4.38 4.38 0 0 1 2.14-.32"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M73.46 42.42a4.57 4.57 0 0 1 1.74.34c3 1.23 4 5.42 2.4 9.36-1.26 3-3.74 5-6.16 5.24"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "51.8",
          cy: "46.03",
          rx: "21.34",
          ry: "28.97"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M51.74 48c0 4.35 2.84 4.55 2.84 7.06s-2.9 2.6-2.9 2.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40.1 43.54a5.87 5.87 0 0 1 7.72 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M55.55 43.54a5.87 5.87 0 0 1 7.72 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.75 64.77a5.11 5.11 0 0 0 5.8-.87"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M73.19 42.17s1.86.15 1.86-6.37a16.71 16.71 0 0 0-3.35-10.44c6.54-10.53-6.18-18-6.18-18-3.53 3.07-9.56 3-13.59 3-16.5 0-23.22 13-23.22 25.41 0 6.52 1.86 6.37 1.86 6.37"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M69.9 85.48a27.21 27.21 0 0 1-17.83 7 27.19 27.19 0 0 1-17.82-7"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "43.81",
          cy: "47.93",
          r: "1.97"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "59.34",
          cy: "47.93",
          r: "1.97"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AdultMale104 = (AdultMale104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/AdultMale56.tsx


var AdultMale56_excluded = ["className"];
function AdultMale56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function AdultMale56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? AdultMale56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AdultMale56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function AdultMale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AdultMale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", AdultMale56_objectSpread(AdultMale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40.42 20.48a12.59 12.59 0 0 0-1.53-6.59 2.72 2.72 0 0 1 0-.57 8.32 8.32 0 0 0 .62-4.15 3.82 3.82 0 0 0-.58-1.34s-.42-1-.44-.84l-.18-.2c-2.58 1.66-7.09.4-9.93 0-2.66-.35-5.41-.6-7.75.88-4 2.51-4.8 7.2-5.19 11.61v.63s.33 1.77.33 1.85c.64 1.56 1-.29 1.07-1.46v-.05S19.43 9.38 27.89 9.17s10.42 10 10.42 10c.06.37.63 1.83.64 2 .16 2.1 1.39 1.17 1.47 0 .01-.23.01-.46 0-.69Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M7 52a12.09 12.09 0 0 1 1.61-1.24 79.84 79.84 0 0 1 7.81-4.14c3.57-1.78 5.95-3.7 6.39-7.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.29 38.64c.4 4.21 2.8 6.16 6.41 8a79.84 79.84 0 0 1 7.81 4.14A10.9 10.9 0 0 1 49 51.87"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M17.18 30.87a4.32 4.32 0 0 1-3.3-2.82c-.88-2.12-.3-4.38 1.29-5a2.52 2.52 0 0 1 1.15-.17"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.55 22.83a2.53 2.53 0 0 1 .94.18c1.59.66 2.17 2.92 1.29 5a4.29 4.29 0 0 1-3.31 2.82"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "27.89",
          cy: "24.78",
          rx: "11.49",
          ry: "15.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.86 25.82c0 2.34 1.53 2.45 1.53 3.8S27.83 31 27.83 31"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21.59 23.44a3.14 3.14 0 0 1 4.16 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29.91 23.44a3.14 3.14 0 0 1 4.16 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.79 34.87a2.77 2.77 0 0 0 3.12-.47"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.41 22.7s1 .08 1-3.43a9 9 0 0 0-1.8-5.62C42.13 8 35.28 4 35.28 4c-1.9 1.63-5.15 1.59-7.28 1.59-8.88 0-12.5 7-12.5 13.68 0 3.51 1 3.43 1 3.43"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.64 46A14.75 14.75 0 0 1 28 49.79 14.75 14.75 0 0 1 18.44 46"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "23.59",
          cy: "25.8",
          r: "1.06"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "31.95",
          cy: "25.8",
          r: "1.06"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AdultMale56 = (AdultMale56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Baby104.tsx


var Baby104_excluded = ["className"];
function Baby104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Baby104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Baby104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Baby104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Baby104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Baby104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Baby104_objectSpread(Baby104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M59.6 68.2c-3.2-.4-4.3 2.5-7.6 2.5s-4.4-3-7.6-2.5c-3.4.5-7.1 4.3-4.7 10.9 1.1 3.1 5.3 6.6 12.3 6.7 7-.1 11.2-3.6 12.3-6.7 2.4-6.6-1.2-10.4-4.7-10.9zM52 81c-1.8 0-3.3-1.5-3.3-3.3 0-1.8 1.5-3.3 3.3-3.3 1.8 0 3.3 1.5 3.3 3.3S53.8 81 52 81z",
      className: "shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M81.2 73.2c3.8.1 7.8-2.9 9.8-7.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.9 52.2c-1.7-.7-3.6-.7-5.4-.1-4.3 1.8-5.9 7.8-3.5 13.5 1.9 4.5 5.8 7.5 9.4 7.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M91 65.6c2.4-5.7.8-11.7-3.5-13.5-1.7-.7-3.6-.6-5.3.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 95.9c-17.2 0-31.1-15.6-31.1-34.9S34.8 26.2 52 26.2 83.1 41.8 83.1 61 69.2 95.9 52 95.9z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 26.2s-9.6-2.6-7.5-10 11.4-4.5 8.9 1.5S32 20.1 42.1 5.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.1 57.9c-1.4 2.7-4.7 3.9-7.4 2.5-1.2-.6-2.2-1.6-2.7-2.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70 57.9c-1.3 2.8-4.7 3.9-7.4 2.6-1.2-.6-2.2-1.7-2.7-3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 85.8c7-.1 11.2-3.6 12.3-6.7 2.4-6.6-1.3-10.4-4.7-10.9-3.2-.4-4.3 2.5-7.6 2.5s-4.4-3-7.6-2.5c-3.4.5-7.1 4.3-4.7 10.9 1.1 3.1 5.3 6.6 12.3 6.7z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.3 76.7c3.9 1.8 5.6 6.5 3.8 10.4-1.8 3.9-6.5 5.6-10.4 3.8-3.9-1.8-5.6-6.5-3.8-10.4.8-1.7 2.1-3 3.8-3.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.3 77.7c0 1.8-1.5 3.3-3.3 3.3-1.8 0-3.3-1.5-3.3-3.3 0-1.8 1.5-3.3 3.3-3.3 1.8 0 3.3 1.5 3.3 3.3z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "43.5",
        cy: "73.8",
        r: "1.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "60.7",
        cy: "73.8",
        r: "1.9"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Baby104 = (Baby104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Baby56.tsx


var Baby56_excluded = ["className"];
function Baby56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Baby56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Baby56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Baby56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Baby56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Baby56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Baby56_objectSpread(Baby56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.11 36.71c-1.72-.23-2.34 1.34-4.11 1.37s-2.38-1.6-4.11-1.37-3.82 2.29-2.53 5.88c.6 1.66 2.89 3.55 6.64 3.62s6-2 6.64-3.62C35.93 39 34 37 32.11 36.71ZM28 43.6a1.78 1.78 0 1 1 1.78-1.77A1.78 1.78 0 0 1 28 43.6Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.72 39.39c2 0 4.2-1.57 5.26-4.09"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M11.79 28.07a3.88 3.88 0 0 0-2.88 0C6.58 29 5.73 32.24 7 35.3c1 2.44 3.1 4 5.08 4.08"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49 35.3c1.29-3.06.44-6.31-1.89-7.26a3.88 3.88 0 0 0-2.88 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28 51.64c-9.25 0-16.76-8.41-16.76-18.78S18.75 14.08 28 14.08s16.76 8.41 16.76 18.78S37.25 51.64 28 51.64Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28 14.08s-5.15-1.38-4-5.41 6.15-2.43 4.79.79S17.25 10.79 22.65 3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.76 31.18A3 3 0 0 1 18.3 31"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.7 31.18a3 3 0 0 1-5.46-.18"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28 46.21c3.75-.07 6-2 6.64-3.62C35.93 39 34 37 32.11 36.71s-2.34 1.34-4.11 1.37-2.38-1.6-4.11-1.37-3.82 2.29-2.53 5.88c.64 1.66 2.89 3.55 6.64 3.62Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29.78 41.31a4.23 4.23 0 1 1-3.56 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29.78 41.83A1.78 1.78 0 1 1 28 40.05a1.78 1.78 0 0 1 1.78 1.78Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "23.42",
          cy: "39.73",
          r: "1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "32.67",
          cy: "39.73",
          r: "1"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Baby56 = (Baby56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Child104.tsx


var Child104_excluded = ["className"];
function Child104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Child104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Child104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Child104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Child104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Child104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Child104_objectSpread(Child104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.7 86.4c-4.3 0-4.8 4.1-4.5 6.1.2 1.6.3 3.3.2 4.9 3.7-.6 6.1-1.8 7.2-3.7 2-3.2 0-7.3-2.9-7.3z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82 86.4c4.3 0 4.8 4.1 4.5 6.1-.2 1.6-.3 3.3-.2 4.9-3.7-.6-6.1-1.8-7.2-3.7-2-3.2 0-7.3 2.9-7.3z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.4 43c-2.8.3-4.6 1.9-5.5 4.9-.9 3.1-.6 6.4.8 9.3l-1.1 3.7c-1.1 2.8-.4 5.5 2.3 8.1-.6 4.2-.6 9.2 1.1 10.8 1.2 1.1 3.1 1.6 5.6 1.6 1-.5 1.9-1.2 2.7-2 .8-1 1.4-2.1 1.9-3.3L24 66.4l-1.9-20.5v-2.3l-1.7-.6z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.3 43c2.8.3 4.6 1.9 5.5 4.9.9 3.1.6 6.4-.8 9.3l1.1 3.7c1.1 2.8.4 5.5-2.3 8.1.7 4.2.7 9.2-1.1 10.8-1.2 1.1-3.1 1.6-5.7 1.6-1.2.1-2.4-.4-3.2-1.2-.6-.7-.3-1.8-.6-3.9l5-11 1.4-17.7-1.2-4 1.9-.6z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.2 39.8c-.9 3.8 3.6 2.5 6 2.4 3.3-.5 6.5-1.1 9.7-2 5.4-1.2 11-2.7 15.6-5.6 3-1.8 5.6-3.1 7.7-6 .4-.5 1.9-5.2 2.6-6.8.2 1.2.6 5 .8 5.5.8 2.4 2.8 4.3 4.3 6.4 3.4 4.6 7.3 6.5 12.7 7.6 1 .2 6.4 1 6.4 1-.7-18.7-16.4-34-33.5-34.6-24.1-.5-28.6 15.5-32.3 32.1z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.2 62.4c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1 1 .4 1 1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.3 63.2c0 .6-.5 1-1 1s-1-.5-1-1 .5-1 1-1 1 .4 1 1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.8 67.3c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1 1 .4 1 1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.5 65.2c0 .6-.5 1-1 1-.6 0-1-.5-1-1s.5-1 1-1 1 .4 1 1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.7 62.4c0 .6.5 1 1 1s1-.5 1-1-.5-1-1-1-1 .4-1 1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.6 63.2c0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1-1 .4-1 1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65 67.3c0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1-1 .4-1 1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.4 65.2c0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1-1 .4-1 1"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.7 86.4c-4.3 0-4.8 4.1-4.5 6.1.2 1.6.3 3.3.2 4.9 3.7-.6 6.1-1.8 7.2-3.7 2-3.2 0-7.3-2.9-7.3z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.4 43c-1.4 1.2-2.4 3.2-2.9 6s.4 5.4 2.9 8c-2.2 1.3-3.6 3.7-3.6 6.2 0 2.6 1.4 4.9 4.3 6.8-3.2 4.6-2.6 8.5 1.8 11.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.2 76c-.1 2.1-1.4 4-3.8 5.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82 86.4c4.3 0 4.8 4.1 4.5 6.1-.2 1.6-.3 3.3-.2 4.9-3.7-.6-6.1-1.8-7.2-3.7-2-3.2 0-7.3 2.9-7.3z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M86.7 43.4c1.2 1 2.1 2.9 2.6 5.7s-.4 5.4-2.9 8c2.2 1.3 3.6 3.7 3.7 6.2 0 2.6-1.4 4.9-4.3 6.8 3.2 4.6 2.5 8.5-1.9 11.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75.5 77.5c.6 1.9 1.8 3.6 3.5 4.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82 43.3c.4 2.8.7 5.6.7 8.3 0 21.9-13.6 39.7-30.3 39.7S22.2 73.6 22.2 51.7c0-2.8.2-5.6.7-8.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.5 55.8c0 6.2 4 6.5 4 10 0 3.6-4.1 3.7-4.1 3.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.9 49.5c3.2-2.7 7.8-2.7 11 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.9 49.5c3.2-2.7 7.8-2.7 11 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.7 7.3C17.1 9.1 17.1 43.2 17.1 43.2c4 1.4 40.3-4.3 41.6-23 0 0 1.4 23.5 27.5 23 .5 0 1.5.9 1.5.7C90.2 22.6 77 8.5 60.5 9.6c-2.3-.5-4.7-3-14.8-2.3z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.2 79.3c3.3 1.8 6.7.2 8.2-1.2"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.7 81.3c-.1-.1-.2-.1-.4-.1l-6.8-.4h-.4c-1.1.3-2 1.3-2 2.5s.7 2.2 1.8 2.5c.1 0 .2 0 .2.1l6.7.4h.2c1.1-.1 2-1.1 2.1-2.2.3-1.3-.3-2.4-1.4-2.8zM85.6 80.8h-.4l-6.8.4c-.1 0-.2 0-.4.1-1.1.4-1.7 1.5-1.6 2.7.1 1.1 1 2 2.2 2.2h.2l6.7-.4c.1 0 .2 0 .2-.1 1.1-.3 1.8-1.3 1.8-2.4 0-1.2-.8-2.2-1.9-2.5z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44 55.7c0 1.5-1.2 2.8-2.8 2.8-1.5 0-2.8-1.2-2.8-2.8 0-1.5 1.2-2.8 2.8-2.8 1.5 0 2.8 1.3 2.8 2.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.1 55.7c0 1.5-1.2 2.8-2.8 2.8-1.5 0-2.8-1.2-2.8-2.8 0-1.5 1.2-2.8 2.8-2.8 1.6 0 2.8 1.3 2.8 2.8"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Child104 = (Child104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Child56.tsx


var Child56_excluded = ["className"];
function Child56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Child56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Child56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Child56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Child56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Child56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Child56_objectSpread(Child56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M11.7 46.52c-2.33 0-2.57 2.2-2.44 3.27a22.2 22.2 0 0 1 .13 2.67c2-.32 3.29-1 3.88-2 1.06-1.75 0-3.94-1.57-3.94Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.14 46.52c2.33 0 2.57 2.2 2.45 3.27a22.2 22.2 0 0 0-.13 2.67c-2-.32-3.29-1-3.88-2-1.07-1.75 0-3.94 1.56-3.94Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M11 23.14a3.27 3.27 0 0 0-3 2.64 7.17 7.17 0 0 0 .42 5l-.58 2Q7 35 9.11 37.11c-.35 2.26-.35 4.92.62 5.79a4.42 4.42 0 0 0 3 .87 5.24 5.24 0 0 0 1.44-1.06 8.29 8.29 0 0 0 1-1.82L13 35.65l-1-11v-1.24Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.85 23.14a3.26 3.26 0 0 1 2.95 2.64 7.11 7.11 0 0 1-.42 5l.59 2q.9 2.27-1.23 4.35c.34 2.26.34 4.92-.62 5.79a4.42 4.42 0 0 1-3 .87 2.3 2.3 0 0 1-1.74-.65c-.34-.4-.16-1-.3-2.08l2.7-5.95.77-9.55-.62-2.13Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M9.25 21.45c-.45 2.06 1.92 1.37 3.26 1.3a44.79 44.79 0 0 0 5.25-1.06 27 27 0 0 0 8.41-3c1.6-1 3-1.69 4.17-3.2.22-.3 1-2.81 1.39-3.64.13.65.32 2.71.4 3 .4 1.31 1.51 2.33 2.34 3.44a10.21 10.21 0 0 0 6.82 4.08c.54.1 3.43.54 3.42.51-.4-10.12-8.83-18.37-18.08-18.7-12.93-.34-15.39 8.29-17.38 17.27Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20.55 33.58A.56.56 0 1 1 20 33a.56.56 0 0 1 .56.56"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.85 34a.56.56 0 1 1-1.12 0 .56.56 0 0 1 1.12 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21.45 36.21a.56.56 0 1 1-.56-.56.56.56 0 0 1 .56.56"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18 35.09a.56.56 0 1 1-.56-.56.56.56 0 0 1 .56.56"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.91 33.58a.56.56 0 1 0 .56-.56.56.56 0 0 0-.56.56"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.62 34a.56.56 0 0 0 1.12 0 .56.56 0 1 0-1.12 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35 36.21a.56.56 0 1 0 .56-.56.56.56 0 0 0-.56.56"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.44 35.09a.56.56 0 1 0 .56-.56.56.56 0 0 0-.56.56"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M11.7 46.52c-2.33 0-2.57 2.2-2.44 3.27a22.2 22.2 0 0 1 .13 2.67c2-.32 3.29-1 3.88-2 1.06-1.75 0-3.94-1.57-3.94Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M9.35 23.13a5.81 5.81 0 0 0-1.58 3.26 4.68 4.68 0 0 0 1.58 4.3 3.93 3.93 0 0 0-1.94 3.36 4.36 4.36 0 0 0 2.32 3.68q-2.6 3.74 1 6.25"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M15.17 40.89a4.11 4.11 0 0 1-2 3.09"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.14 46.52c2.33 0 2.57 2.2 2.45 3.27a22.2 22.2 0 0 0-.13 2.67c-2-.32-3.29-1-3.88-2-1.07-1.75 0-3.94 1.56-3.94Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.66 23.34a5.29 5.29 0 0 1 1.41 3.05 4.67 4.67 0 0 1-1.57 4.3 3.92 3.92 0 0 1 1.93 3.36c0 1.41-.74 2.63-2.31 3.68q2.58 3.74-1 6.25"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40.64 41.72a4.32 4.32 0 0 0 1.89 2.47"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.16 23.33a27.52 27.52 0 0 1 .36 4.5c0 11.81-7.29 21.38-16.29 21.38s-16.29-9.57-16.29-21.38a28 28 0 0 1 .37-4.54"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28.28 30c0 3.32 2.17 3.47 2.17 5.38s-2.22 2-2.22 2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19.35 26.64a4.52 4.52 0 0 1 5.92 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.2 26.64a4.52 4.52 0 0 1 5.92 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.63 3.9C9.2 4.9 9.2 23.24 9.2 23.24c2.14.75 21.69-2.3 22.4-12.38 0 0 .73 12.65 14.81 12.38.28 0 .81.49.82.37 1.36-11.48-5.76-19.06-14.64-18.48C31.36 4.9 30 3.55 24.63 3.9Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.52 42.69A3.89 3.89 0 0 0 31 42"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M13.82 43.76a.41.41 0 0 0-.19 0L10 43.48a.69.69 0 0 0-.2 0 1.38 1.38 0 0 0-1.1 1.36 1.35 1.35 0 0 0 1 1.32h.14l3.6.23h.12a1.29 1.29 0 0 0 1.16-1.16 1.41 1.41 0 0 0-.9-1.47ZM46.09 43.51a.63.63 0 0 0-.19 0l-3.68.23a.46.46 0 0 0-.2 0 1.39 1.39 0 0 0-.86 1.48 1.29 1.29 0 0 0 1.16 1.16h.11l3.57-.2h.13a1.36 1.36 0 0 0 1-1.32 1.38 1.38 0 0 0-1.04-1.35Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.71 30a1.51 1.51 0 1 1-1.51-1.5 1.51 1.51 0 0 1 1.51 1.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.61 30a1.51 1.51 0 1 1-1.51-1.5 1.51 1.51 0 0 1 1.51 1.5"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Child56 = (Child56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Teen104.tsx


var Teen104_excluded = ["className"];
function Teen104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Teen104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Teen104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Teen104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Teen104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Teen104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Teen104_objectSpread(Teen104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.8 57.3c0 1.5-1.2 2.8-2.8 2.8-1.5 0-2.8-1.2-2.8-2.8 0-1.5 1.2-2.8 2.8-2.8s2.8 1.3 2.8 2.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.8 57.3c0 1.5-1.2 2.8-2.8 2.8-1.5 0-2.8-1.2-2.8-2.8 0-1.5 1.2-2.8 2.8-2.8 1.5 0 2.8 1.3 2.8 2.8"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.2 59.8s4.9-1.1 5.3-2.6-1.7 12.4-.6 14c0 0 3.4-6 4.4-5 0 0-.8 11.3 1.3 12.3 0 0 1.1-3.7 3.1-3.7-.7 2.8 2.1 8.3 2.8 11.2.5 2 3-3.6 3-3.6L25.2 73 23 65.3c-2.4-10.1 1.9-19.5 8.1-28.5.4-.6 1.2-1 1.6-1.5.6-.2.2-1.5.8-1.6.1 0 .2.7.3.7.6.3 1.1 2.3 1.5 2.9 1.2 2 4.2 3.9 5.6 5.8 3.3 4.3 5.1 4.5 9.3 7.9 1.1.9 7.1 3.9 7.8 3.1s-2.8-2.9-3.6-4c-1.3-1.9-1.9-5.7 2.1-1 1 1 2 1.9 3.1 2.8 2.2 2.1 5 3.6 6.9 6 .7 1 2.3 2.9 3.2 3.1s-1-4-1-4.9c0-1.3-.7-1.8-1.2-3-.3-.7.2-1.9-.1-2.2.1.1 1.1 1.4 1.4 1.7 3.2 3 4.4 6.3 6.3 10.3 1 2.1.3 2.8.8 2.8s4.7-7.4 4.7-7.8c1.3.1 2.4 3 2.4 3C88.9 34 68.4-1.3 35.5 11.6c-12.1 4.8-18.5 18-21.3 30-.5 2.5-.9 4.9-1.1 7.5l-2.9 10.7z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m30.8 83.6-.9-1.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82.1 60.1c-2 20.1-14.6 35.6-29.9 35.6-8.3 0-15.9-4.6-21.4-12.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.7 51.1c3.1-2.8 7.9-2.8 11 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m51.5 57.4 3.7 7.4c.8 1.6.4 3.5-1 4.6L52 71.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M81.9 60.9c0-1.9-1.5-3.6-1.6-3.4-1.9 5.9-4.9 8.5-4.9 8.5.7-6.3-9.3-17-9-16s6 13.4 2.8 10.7-16.1-14.5-16.1-14.5c.6 3.5 2.7 6.5 5.6 8.5 0 0-2.8-.9-9.2-4.6C38.8 44 33.5 33 33.5 33c-1.4 3.3-5.8 8.5-8.2 13.5-2.7 5.6-3.1 14.4-1.6 20.5 1.2 5.2 3.2 10.2 5.8 14.9-.9 3.3-3 4.4-3 3.6s.3-2.1-1.7-5.5-1.1-5.7-1.1-5.7c-2-.2-3.1 3.7-3.1 3.7-1.9-3.4-1.3-12.3-1.3-12.3-3 1.1-4.3 5.4-4.3 5.4-1.4-7.1 1.3-16.2.5-14.5s-5.3 2.6-5.3 2.6c2.6-6.3 4.1-18 4.1-18C16.8 29 24.2 12 45.4 8.8 51 8 57.7 7.6 65.1 10.2 84.8 17.3 90.3 43.7 91.2 49c1.3 7.5 2.6 7.9 2.6 7.9-2.2 0-4.3-.9-6-2.3 0 0 3.5 6.2 2.2 12.1 0 0-2-2.8-3.5-2.5s-.2 8.5 1.8 11.4c-2.2-.2-4.2-1.2-5.8-2.7 0 0 .2 8-4.2 13.3 0 0-.3-5-2.2-6.1.1.1 5.7-11.4 5.8-19.2z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.1 78.2s-2.9 5.5-11 5.5"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Teen104 = (Teen104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Teen56.tsx


var Teen56_excluded = ["className"];
function Teen56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Teen56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Teen56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Teen56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Teen56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Teen56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Teen56_objectSpread(Teen56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.58 30.86a1.5 1.5 0 1 1-1.5-1.5 1.5 1.5 0 0 1 1.5 1.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.44 30.86a1.5 1.5 0 1 1-1.5-1.5 1.5 1.5 0 0 1 1.5 1.5"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M5.49 32.22s2.64-.59 2.86-1.43-.93 6.71-.35 7.54c0 0 1.83-3.24 2.34-2.67 0 0-.4 6.09.7 6.61 0 0 .61-2 1.69-2-.4 1.49 1.16 4.49 1.51 6.06.24 1.08 1.64-2 1.64-2l-2.34-5-1.19-4.13c-1.31-5.47 1-10.55 4.36-15.36.23-.32.65-.56.85-.82s.11-.78.43-.85c.06 0 .11.36.18.4.31.18.6 1.24.8 1.57.65 1.08 2.23 2.1 3 3.11 1.77 2.3 2.77 2.43 5 4.26.57.47 3.82 2.1 4.18 1.67s-1.49-1.56-1.91-2.18c-.73-1-1-3.05 1.13-.52A18 18 0 0 0 32.05 28c1.19 1.14 2.68 1.92 3.69 3.22.4.5 1.23 1.54 1.72 1.67s-.56-2.18-.55-2.65c0-.71-.35-.95-.66-1.61-.16-.35.11-1 0-1.16.07.07.59.76.77.93 1.73 1.6 2.38 3.4 3.39 5.52.55 1.14.19 1.54.44 1.49a27.94 27.94 0 0 0 2.52-4.18c.69.05 1.28 1.63 1.28 1.63C47.78 18.37 36.76-.62 19.05 6.3c-6.43 2.52-9.91 9.61-11.39 16.1a28.94 28.94 0 0 0-.59 4Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M16.58 45c-.16-.22-.31-.45-.46-.67"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.18 32.36c-1 10.83-7.86 19.19-16.09 19.19-4.5 0-8.57-2.5-11.51-6.52"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19.24 27.51a4.48 4.48 0 0 1 5.9 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m27.72 30.88 2 4a2 2 0 0 1-.52 2.48l-1.2.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.08 32.77c0-1-.8-2-.85-1.81a10.41 10.41 0 0 1-2.63 4.58c.35-3.42-5-9.17-4.86-8.63s3.26 7.19 1.53 5.75-8.69-7.82-8.69-7.82a7.13 7.13 0 0 0 3 4.57 30.49 30.49 0 0 1-5-2.45A23.73 23.73 0 0 1 18 17.74c-.77 1.8-3.11 4.55-4.42 7.27a18.41 18.41 0 0 0-.85 11 29 29 0 0 0 3.15 8c-.49 1.8-1.64 2.37-1.64 1.95a4.35 4.35 0 0 0-.94-3 3.53 3.53 0 0 1-.57-3.09c-1.08-.1-1.69 2-1.69 2-1-1.81-.7-6.61-.7-6.61-1.54.74-2.27 3-2.27 3-.77-3.82.69-8.69.28-7.79s-2.86 1.42-2.86 1.42c1.39-3.37 2.23-9.66 2.23-9.66C9 15.61 13 6.46 24.43 4.75A20.91 20.91 0 0 1 35 5.51c10.62 3.85 13.56 18 14.07 20.89.72 4.06 1.41 4.26 1.41 4.26a5.11 5.11 0 0 1-3.26-1.25s1.89 3.33 1.18 6.51c0 0-1.1-1.53-1.9-1.33s-.13 4.57 1 6.14a5.12 5.12 0 0 1-3.07-1.44s.12 4.33-2.25 7.2c0 0-.15-2.68-1.16-3.31-.02 0 3.05-6.18 3.06-10.41Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.9 42.09A6.59 6.59 0 0 1 27 45"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Teen56 = (Teen56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/AccountsPayments104.tsx


var AccountsPayments104_excluded = ["className"];
function AccountsPayments104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function AccountsPayments104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? AccountsPayments104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AccountsPayments104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function AccountsPayments104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AccountsPayments104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", AccountsPayments104_objectSpread(AccountsPayments104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41 43.4a10.88 10.88 0 0 0 5.38-1.4 17.67 17.67 0 0 1-14.85-14.86A10.88 10.88 0 0 0 41 43.4ZM23 53a21.69 21.69 0 0 0-3.52 9.1 30.49 30.49 0 0 0 14.08 8l-.29-8.1A44.51 44.51 0 0 1 23 53ZM33.5 57h60v6h-60zM38.5 68h24v6h-24z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.51 70.07A30.49 30.49 0 1 1 69.64 51"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "41",
          cy: "32.51",
          r: "10.89"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M57.52 51a21.78 21.78 0 0 0-38.09 11.06 30.42 30.42 0 0 0 14.08 8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "33.5",
          y: "51",
          width: "60",
          height: "38",
          rx: "3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.5 57h60v6h-60zM38.5 68h24v6h-24z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AccountsPayments104 = (AccountsPayments104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/AccountsPayments56.tsx


var AccountsPayments56_excluded = ["className"];
function AccountsPayments56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function AccountsPayments56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? AccountsPayments56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AccountsPayments56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function AccountsPayments56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AccountsPayments56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", AccountsPayments56_objectSpread(AccountsPayments56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M12.45 28.11A11.67 11.67 0 0 0 10.56 33 16.37 16.37 0 0 0 16 36.58V33.7a4.71 4.71 0 0 0-1.53-3.46 23.89 23.89 0 0 1-2.02-2.13ZM24.81 22.21a9.47 9.47 0 0 1-8-8A5.85 5.85 0 0 0 21.92 23a5.78 5.78 0 0 0 2.89-.79ZM18 31h32v4H18zM21 37.5h14v3H21z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28.7 25a11.69 11.69 0 0 0-18.14 8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M16 36.84A16 16 0 1 1 38 22a16.41 16.41 0 0 1-.28 3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "22",
          cy: "17",
          r: "6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "18",
          y: "27",
          width: "32",
          height: "20",
          rx: "2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18 31h32v4H18zM21 37.5h14v3H21z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AccountsPayments56 = (AccountsPayments56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Bank104.tsx


var Bank104_excluded = ["className"];
function Bank104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Bank104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Bank104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Bank104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Bank104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Bank104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Bank104_objectSpread(Bank104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M92.9 45.15a2.77 2.77 0 0 1-1.63-.54L52 16.06 12.73 44.61a2.79 2.79 0 0 1-3.28-4.51l40.91-29.75a2.79 2.79 0 0 1 3.28 0L94.55 40.1a2.79 2.79 0 0 1-1.65 5ZM11.52 90.58h80.85v2.26H11.52zM23.06 81.62c0 2.45 3.06 6 3.06 6H14.81V82ZM51 81.62c0 2.45 3.06 6 3.06 6H42.7V82ZM78.84 81.62c0 2.45 3.06 6 3.06 6H70.59V82ZM18.65 58.43c0 6.58 11.43 23 11.43 23H18.53ZM46.35 62.33c0 5.46 11.42 19.08 11.42 19.08H46.23ZM74.05 58.43c0 6.58 11.42 23 11.42 23H73.92Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m30.24 30.59-.66 1.63c-1.24 3.08-.48 7.05 1.68 8.77l4 3.22-23.79.84A2.93 2.93 0 0 1 8.61 43l-.31-1 19.81-14.18c1.27-1.38 2.89.77 2.13 2.77ZM41.45 36.35c1.16 7.36 3.82 15.86 11 19-7 2.34-11.57-4.94-14-10.79A15.48 15.48 0 0 1 37.33 36c.45-2.43 3.74-2.09 4.12.35Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M92.9 45.15a2.77 2.77 0 0 1-1.63-.54L52 16.06 12.73 44.61a2.79 2.79 0 0 1-3.28-4.51l40.91-29.75a2.79 2.79 0 0 1 3.28 0L94.55 40.1a2.79 2.79 0 0 1-1.65 5ZM18.53 81.41V44.22M29.69 44.22v37.19M46.42 81.41V54.38M57.58 54.38v27.03M74.63 81.41V44.22M85.78 44.22v37.19M14.81 87v-3.74a1.85 1.85 0 0 1 1.86-1.85h14.88a1.86 1.86 0 0 1 1.86 1.85V87"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M14.81 87v-3.74a1.85 1.85 0 0 1 1.86-1.85h14.88a1.86 1.86 0 0 1 1.86 1.85V87M42.7 87v-3.74a1.86 1.86 0 0 1 1.86-1.85h14.88a1.86 1.86 0 0 1 1.86 1.85V87"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42.7 87v-3.74a1.86 1.86 0 0 1 1.86-1.85h14.88a1.86 1.86 0 0 1 1.86 1.85V87M70.59 87v-3.74a1.86 1.86 0 0 1 1.86-1.85h14.88a1.85 1.85 0 0 1 1.86 1.85V87"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M70.59 87v-3.74a1.86 1.86 0 0 1 1.86-1.85h14.88a1.85 1.85 0 0 1 1.86 1.85V87"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "52",
          cy: "40.5",
          r: "14.88"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M66.4 44.22h24.65M12.95 44.22H37.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "11.52",
          y: "88",
          width: "80.95",
          height: "5.18",
          rx: "1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47.63 44.38a4.4 4.4 0 0 0 8.74 0A4.15 4.15 0 0 0 52 40.5a4.15 4.15 0 0 1-4.37-3.88 4.4 4.4 0 0 1 8.74 0M52 29.93v2.81M52 48.26v2.81"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Bank104 = (Bank104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Bank56.tsx


var Bank56_excluded = ["className"];
function Bank56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Bank56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Bank56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Bank56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Bank56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Bank56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Bank56_objectSpread(Bank56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.28 24.49a1.4 1.4 0 0 1-.85-.28L28 9.36 7.57 24.21a1.45 1.45 0 0 1-1.7-2.34L27.15 6.39a1.44 1.44 0 0 1 1.7 0l21.28 15.48a1.45 1.45 0 0 1-.85 2.62ZM10.65 31.4c0 3.42 6 12 6 12h-6ZM25.06 33.43c0 2.84 5.94 9.92 5.94 9.92h-6ZM39.47 31.4c0 3.42 5.94 12 5.94 12h-6Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m16.68 16.92-.34.84a4.19 4.19 0 0 0 .87 4.57l2.1 1.67-12.38.44a1.52 1.52 0 0 1-1.5-1.07l-.16-.52 10.3-7.37c.66-.72 1.53.4 1.11 1.44ZM22.51 19.92c.61 3.83 2 8.24 5.74 9.89-3.63 1.21-6-2.57-7.3-5.61a8 8 0 0 1-.58-4.5 1.09 1.09 0 0 1 2.14.22Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M10.59 43.35V24.01M16.39 24.01v19.34M25.1 43.35V29.3M30.9 29.3v14.05M39.77 43.35V24.01M45.57 24.01v19.34M8.65 46.26v-1.94a1 1 0 0 1 1-1h7.74a1 1 0 0 1 1 1v1.94"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M8.65 46.26v-1.94a1 1 0 0 1 1-1h7.74a1 1 0 0 1 1 1v1.94M23.16 46.26v-1.94a1 1 0 0 1 1-1h7.74a1 1 0 0 1 1 1v1.94"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.16 46.26v-1.94a1 1 0 0 1 1-1h7.74a1 1 0 0 1 1 1v1.94M37.67 46.26v-1.94a1 1 0 0 1 1-1h7.74a1 1 0 0 1 1 1v1.94"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.67 46.26v-1.94a1 1 0 0 1 1-1h7.74a1 1 0 0 1 1 1v1.94M49.28 24.49a1.4 1.4 0 0 1-.85-.28L28 9.36 7.57 24.21a1.45 1.45 0 0 1-1.7-2.34L27.15 6.39a1.44 1.44 0 0 1 1.7 0l21.28 15.48a1.45 1.45 0 0 1-.85 2.62ZM35.49 24.01h12.82M7.69 24.01h12.82"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "7.21",
          y: "46.62",
          width: "41.57",
          height: "2.9",
          rx: ".5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "28",
          cy: "22.19",
          r: "7.62"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M25.76 24.18a2.26 2.26 0 0 0 4.48 0 2.13 2.13 0 0 0-2.24-2 2.12 2.12 0 0 1-2.24-2 2.26 2.26 0 0 1 4.48 0M28 16.78v1.44M28 26.17v1.44"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Bank56 = (Bank56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BillEmail56.tsx


var BillEmail56_excluded = ["className"];
function BillEmail56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BillEmail56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BillEmail56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BillEmail56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BillEmail56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BillEmail56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", BillEmail56_objectSpread(BillEmail56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6 25.73v19.21a3 3 0 0 0 3 3h13.51A1 1 0 0 0 22.9 46C16.25 43.22 6 37.07 6 25.73Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49 21.55a2.48 2.48 0 0 1 .87 1.88v21.76a2.47 2.47 0 0 1-2.47 2.47H8.5A2.47 2.47 0 0 1 6 45.19V23.45a2.47 2.47 0 0 1 .9-1.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m47 19.83 2 1.72a2.48 2.48 0 0 1 .87 1.88v21.76a2.47 2.47 0 0 1-2.47 2.47H8.5A2.47 2.47 0 0 1 6 45.19V23.45a2.47 2.47 0 0 1 .9-1.9l1.53-1.27M6.69 46.87l9.23-5.18M39.95 41.67l9.26 5.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.65 22.42 29.19 34.26a2.49 2.49 0 0 1-2.48 0L6.26 22.42M28 24.04h11.01M28 16.79h11.01"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M16.54 23.69a2.9 2.9 0 0 0 3.05 2.72 2.9 2.9 0 0 0 3.05-2.72A2.9 2.9 0 0 0 19.59 21a2.89 2.89 0 0 1-3.05-2.71 2.9 2.9 0 0 1 3.05-2.72 2.9 2.9 0 0 1 3.05 2.72M19.59 13.95v1.6M19.59 26.41v1.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M10.84 22.08V7.65a2.1 2.1 0 0 1 2.07-2.13h24.6a1 1 0 0 1 .75.33l6.61 7.2a1.05 1.05 0 0 1 .29.73V22"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.68 5.92v6a2.14 2.14 0 0 0 2.06 2.21h5.41"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BillEmail56 = (BillEmail56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BillEmails104.tsx


var BillEmails104_excluded = ["className"];
function BillEmails104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BillEmails104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BillEmails104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BillEmails104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BillEmails104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BillEmails104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BillEmails104_objectSpread(BillEmails104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.07 32.89v1.55L11.48 43 21 49.21l-.1-1.54L53.65 66.9S20.07 45.57 20.07 32.89ZM82.92 27.82H72.83A3 3 0 0 1 70 24.69V12.82a1 1 0 1 0-2 0v11.87a5 5 0 0 0 4.86 5.13h10.06a1 1 0 0 0 0-2ZM84.17 35.19l-.02 13.07 8.39-4.86-8.37-8.21zM42.58 87.47c-12.4-5.23-31.49-16.71-31.49-37.88v35.86a5.59 5.59 0 0 0 5.6 5.6h25.17a1.86 1.86 0 0 0 .72-3.58Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M91.32 41.78A4.62 4.62 0 0 1 93 45.29v40.64a4.61 4.61 0 0 1-4.61 4.61H15.7a4.6 4.6 0 0 1-4.61-4.61v-40.6a4.61 4.61 0 0 1 1.67-3.55"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m84.17 35.19 7.15 6.59A4.62 4.62 0 0 1 93 45.29v40.64a4.61 4.61 0 0 1-4.61 4.61H15.7a4.6 4.6 0 0 1-4.61-4.61v-40.6a4.61 4.61 0 0 1 1.67-3.55L20.08 35M12.31 89.06l17.25-9.66M74.43 79.35l17.29 9.71"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M92.54 43.4 54.33 65.52a4.65 4.65 0 0 1-4.62 0l-38.2-22.11M52.11 46.44h20.56M52.11 32.89h20.56"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.7 43.78c0 2.8 2.55 5.07 5.7 5.07s5.71-2.27 5.71-5.07-2.56-5.07-5.71-5.07-5.7-2.26-5.7-5.06 2.55-5.07 5.7-5.07 5.71 2.27 5.71 5.07"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.07 48.29V15.82a3.92 3.92 0 0 1 3.86-4h45.93a1.88 1.88 0 0 1 1.4.62L83.62 25.9a2 2 0 0 1 .53 1.37v21"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.18 12.6v11.21A4 4 0 0 0 74 27.94h10.13M36.4 24.58v4M36.4 48.85v4"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BillEmails104 = (BillEmails104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BillEmails56.tsx


var BillEmails56_excluded = ["className"];
function BillEmails56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BillEmails56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BillEmails56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BillEmails56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BillEmails56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BillEmails56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", BillEmails56_objectSpread(BillEmails56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6 25.73v19.21a3 3 0 0 0 3 3h13.51A1 1 0 0 0 22.9 46C16.25 43.22 6 37.07 6 25.73Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49 21.55a2.48 2.48 0 0 1 .87 1.88v21.76a2.47 2.47 0 0 1-2.47 2.47H8.5A2.47 2.47 0 0 1 6 45.19V23.45a2.47 2.47 0 0 1 .9-1.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m47 19.83 2 1.72a2.48 2.48 0 0 1 .87 1.88v21.76a2.47 2.47 0 0 1-2.47 2.47H8.5A2.47 2.47 0 0 1 6 45.19V23.45a2.47 2.47 0 0 1 .9-1.9l1.53-1.27M6.69 46.87l9.23-5.18M39.95 41.67l9.26 5.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.65 22.42 29.19 34.26a2.49 2.49 0 0 1-2.48 0L6.26 22.42M28 24.04h11.01M28 16.79h11.01"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M16.54 23.69a2.9 2.9 0 0 0 3.05 2.72 2.9 2.9 0 0 0 3.05-2.72A2.9 2.9 0 0 0 19.59 21a2.89 2.89 0 0 1-3.05-2.71 2.9 2.9 0 0 1 3.05-2.72 2.9 2.9 0 0 1 3.05 2.72M19.59 13.95v1.6M19.59 26.41v1.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M10.84 22.08V7.65a2.1 2.1 0 0 1 2.07-2.13h24.6a1 1 0 0 1 .75.33l6.61 7.2a1.05 1.05 0 0 1 .29.73V22"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.68 5.92v6a2.14 2.14 0 0 0 2.06 2.21h5.41"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BillEmails56 = (BillEmails56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BillOverview104.tsx


var BillOverview104_excluded = ["className"];
function BillOverview104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BillOverview104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BillOverview104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BillOverview104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BillOverview104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BillOverview104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BillOverview104_objectSpread(BillOverview104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.9 26h-10c-1.6 0-2.9-1.5-2.9-3.4V10c0-.6-.4-1-1-1s-1 .4-1 1v12.6c0 3 2.2 5.4 4.9 5.4H84c.6 0 1-.5 1-1s-.5-1-1.1-1zM19 60.5l1.1 26.7c0 3.1 2.5 5.6 5.6 5.6H51c2 0 2.6-2.8.7-3.6-10.5-4.4-24.8-12.1-29.2-27.6-1.1-4.1-3.5-1.8-3.5-1.1z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.4 46.4h21.1M51.4 33.9h21.1M29.2 65h43.3M29.2 78.1h43.3M71 9.9v11.4c0 2.3 1.8 4.2 3.9 4.2h10.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.1 92.7h33.2c2.2 0 3.9-1.8 3.9-4.1V24.9c0-.5-.2-1-.5-1.4L72.1 9.8c-.4-.4-.9-.6-1.4-.6H23.8c-2.2 0-3.9 1.8-3.9 4.1v75.4c0 2.2 1.8 4.1 3.9 4.1H57"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M35.5 47.1v-6l-.9-.2c-3.2-.7-4.8-2.4-4.8-5 0-3.3 2.4-5.4 5.7-5.7v-2.3h2.1v2.4c2.8.4 5.2 2.2 5.5 5.5H40c-.1-1.4-.9-2.5-2.4-2.9v5.7l1.3.3c2.9.7 4.6 2.4 4.6 5.2 0 3.4-2.3 5.5-5.9 5.8v2.8h-2.1v-2.8c-3.6-.4-6-2.6-6-6.1h3.2c0 1.6 1 2.9 2.8 3.3zm.1-9.1v-5.3c-1.7.3-2.7 1.4-2.7 2.9 0 1.2.7 1.9 2.7 2.4zm2 3.5v5.7c1.8-.3 2.9-1.3 2.9-2.9 0-1.4-.7-2.3-2.9-2.8z",
      className: "strokeinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BillOverview104 = (BillOverview104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BillOverview56.tsx


var BillOverview56_excluded = ["className"];
function BillOverview56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BillOverview56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BillOverview56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BillOverview56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BillOverview56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BillOverview56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BillOverview56_objectSpread(BillOverview56_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m11 32.9.4 13.9c0 1.7 1.3 3 3 3h15.8c2.5 0 1.5-1.8.4-1.9-7.9-.7-17.4-5.9-18.6-14.8 0-.9-1-.8-1-.2z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45 14.2v33.1c0 1.2-.9 2.1-2 2.1H13.1c-1.1 0-2.1-1-2.1-2.1V8.1c0-1.2.9-2.1 2.1-2.1h24.3c.3 0 .5.1.7.3l6.5 7.1c.3.3.4.5.4.8z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.6 6.4v5.9c0 1.2.9 2.2 2 2.2H45M27.4 25.4h11M27.4 18.9h11M15.9 35h22.5M15.9 41.8h22.5"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.1 25.7v-3.1l-.5-.1c-1.7-.4-2.5-1.2-2.5-2.6 0-1.7 1.3-2.8 3-3v-1.2h1.1v1.2c1.5.2 2.7 1.1 2.9 2.9h-1.6c-.1-.7-.5-1.3-1.2-1.5v3l.6.1c1.5.4 2.4 1.2 2.4 2.7 0 1.8-1.2 2.9-3.1 3v1.4h-1.1V27c-1.9-.2-3.1-1.4-3.1-3.2h1.7c0 1 .5 1.7 1.4 1.9zm.1-4.7v-2.8c-.9.1-1.4.7-1.4 1.5 0 .6.3 1 1.4 1.3zm1.1 1.8v2.9c.9-.1 1.5-.7 1.5-1.5 0-.7-.4-1.2-1.5-1.4z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BillOverview56 = (BillOverview56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BillPaid104.tsx


var BillPaid104_excluded = ["className"];
function BillPaid104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BillPaid104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BillPaid104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BillPaid104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BillPaid104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BillPaid104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", BillPaid104_objectSpread(BillPaid104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M54 73.68a21 21 0 0 1 4.93-13.56A19 19 0 0 0 69 93.91a21.15 21.15 0 0 1-15-20.23ZM51.69 89.15c-12.41-5.23-31.5-16.71-31.5-37.88v35.86a5.6 5.6 0 0 0 5.6 5.6H51a1.86 1.86 0 0 0 .69-3.58ZM84 26H73.86A3.16 3.16 0 0 1 71 22.61V10a1 1 0 0 0-2 0v12.61A5.15 5.15 0 0 0 73.86 28H84a1 1 0 0 0 0-2Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M75.35 90.47c-9.12-3.4-14.43-12-16.36-20a1.62 1.62 0 0 0-3.14-.07c-.87 2.87-1.17 7.15 1 12.84 2.83 7.33 11.73 10.14 17.85 10.36a1.62 1.62 0 0 0 .65-3.13Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29.19 78.12h25.5M29.19 65.02h27.28M52.53 46.38h20.98M52.53 32.56h20.98M68 92.68H23.78a4 4 0 0 1-3.93-4.06V13.24a4 4 0 0 1 3.93-4.06h46.86a1.92 1.92 0 0 1 1.43.63l12.61 13.72a2.07 2.07 0 0 1 .54 1.39v30.61"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M71 10v11.39a4.08 4.08 0 0 0 3.9 4.21h10.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "75.11",
          cy: "73.68",
          r: "20.14"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m65.72 74.24 6.52 6.52L86.8 66.2M30.7 43.78c0 2.8 2.55 5.07 5.7 5.07s5.71-2.27 5.71-5.07-2.56-5.07-5.71-5.07-5.7-2.26-5.7-5.06 2.55-5.07 5.7-5.07 5.71 2.27 5.71 5.07M36.4 24.58v4M36.4 48.85v4"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BillPaid104 = (BillPaid104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BillPaid56.tsx


var BillPaid56_excluded = ["className"];
function BillPaid56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BillPaid56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BillPaid56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BillPaid56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BillPaid56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BillPaid56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", BillPaid56_objectSpread(BillPaid56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.88 48C21.24 45.15 11 39 11 27.67v19.2a3 3 0 0 0 3 3h13.49a1 1 0 0 0 .39-1.87ZM27.83 36.29a.77.77 0 0 0 .28-1.49c-4.3-1.6-6.81-5.66-7.73-9.44a.76.76 0 0 0-1.48 0 9.22 9.22 0 0 0 .49 6.07c1.34 3.43 5.54 4.75 8.44 4.86Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m23.56 27.14 3.09 3.08 6.88-6.88"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45 14.18v33.1a2.09 2.09 0 0 1-2.05 2.11H13.06A2.09 2.09 0 0 1 11 47.28V8.1A2.09 2.09 0 0 1 13.06 6h24.35a1 1 0 0 1 .74.33l6.56 7.13a1.09 1.09 0 0 1 .29.72Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.58 6.4v5.94a2.12 2.12 0 0 0 2.05 2.19H45"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "28",
          cy: "26.87",
          r: "9.49"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BillPaid56 = (BillPaid56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BillSummary104.tsx


var BillSummary104_excluded = ["className"];
function BillSummary104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BillSummary104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BillSummary104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BillSummary104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BillSummary104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BillSummary104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", BillSummary104_objectSpread(BillSummary104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M10.08 16.38v.41a5.38 5.38 0 0 0 5.38 5.39h3.87V11h-3.87a5.38 5.38 0 0 0-5.38 5.38ZM88.54 11h-3.87v11.18h3.87a5.38 5.38 0 0 0 5.38-5.39v-.41A5.38 5.38 0 0 0 88.54 11ZM20.2 40.17v-5.23L20 92.3s13.56-2.84 13.75-3.43c-6.25-.28-9.57-19.15-13.55-48.7ZM19.95 11h64.42v4.3H19.95z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m81.53 93.07-11.28-3.19a7.51 7.51 0 0 0-4.15 0l-12.21 3.59a7.43 7.43 0 0 1-4 .07l-14.5-3.71a7.54 7.54 0 0 0-4.21.15L22.4 92.9a2.33 2.33 0 0 1-3.07-2.2V11h65.16v79.85a2.31 2.31 0 0 1-2.96 2.22Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.48 71.89h42.17M30.48 60.06h42.17M51.56 43.22h18.95M51.56 30.74h18.95M30.7 43.78c0 2.8 2.55 5.07 5.7 5.07s5.71-2.27 5.71-5.07-2.56-5.07-5.71-5.07-5.7-2.26-5.7-5.06 2.55-5.07 5.7-5.07 5.71 2.27 5.71 5.07M36.4 24.58v4M36.4 48.85v4M15.46 11h3.87v11.18h-3.87a5.38 5.38 0 0 1-5.38-5.38v-.41A5.38 5.38 0 0 1 15.46 11ZM84.67 11h3.87a5.38 5.38 0 0 1 5.38 5.38v.41a5.38 5.38 0 0 1-5.38 5.38h-3.87V11Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BillSummary104 = (BillSummary104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BillSummary56.tsx


var BillSummary56_excluded = ["className"];
function BillSummary56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BillSummary56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BillSummary56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BillSummary56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BillSummary56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BillSummary56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", BillSummary56_objectSpread(BillSummary56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11 21.92c2.33 1 2 22.43 3 23.49.76.81 3.82-.22 5.25-.76a2 2 0 0 1 1.51 0l9.71 4.24L28 50l-9.77-2.62L13.69 49A2 2 0 0 1 11 47.12Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.16 28.41A3.65 3.65 0 0 0 28 31.83a3.66 3.66 0 0 0 3.85-3.42A3.67 3.67 0 0 0 28 25a3.65 3.65 0 0 1-3.85-3.42A3.66 3.66 0 0 1 28 18.14a3.66 3.66 0 0 1 3.85 3.42"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m43.44 49.49-6.68-1.93a1 1 0 0 0-.56 0l-7.93 2.36a1.06 1.06 0 0 1-.53 0l-9.15-2.38a1 1 0 0 0-.57 0l-5.4 1.82A1.22 1.22 0 0 1 11 48.23V6h34v42.31a1.22 1.22 0 0 1-1.56 1.18ZM28.01 15.1v3M28.01 31.83v3"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BillSummary56 = (BillSummary56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/CardAdded104.tsx


var CardAdded104_excluded = ["className"];
function CardAdded104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function CardAdded104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CardAdded104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CardAdded104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function CardAdded104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, CardAdded104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", CardAdded104_objectSpread(CardAdded104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M81.5 45a12.45 12.45 0 0 1-9.15-4H10v8h72v-4h-.5ZM58 76c-6 0-31 0-36-3s-6.5-5.5-8-9c-1.38-3.22-4-3-4-3v14a4 4 0 0 0 4 4h50s0-3-6-3ZM15 54h29v6H15z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M82 45v30a4 4 0 0 1-4 4H14a4 4 0 0 1-4-4V39a4 4 0 0 1 4-4h55M81.5 49h.5-.5Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M82 49H10v-8h62M15 54h29v6H15z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "81.5",
          cy: "32.5",
          r: "12.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m75.92 32.88 3.47 3.47 7.69-7.7"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_CardAdded104 = (CardAdded104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/CardAdded56.tsx


var CardAdded56_excluded = ["className"];
function CardAdded56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function CardAdded56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CardAdded56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CardAdded56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function CardAdded56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, CardAdded56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", CardAdded56_objectSpread(CardAdded56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.67 42.33c-3.34 0-17.23 0-20-1.66a9.35 9.35 0 0 1-4.45-5A2.36 2.36 0 0 0 6 34v7.78A2.21 2.21 0 0 0 8.22 44H36s0-1.67-3.33-1.67ZM35.52 24H6v4h36v-.06A9 9 0 0 1 35.52 24Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M9 31h16v4H9z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42 28v14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V22a2 2 0 0 1 2-2h26"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M9 31h16v4H9z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "43",
          cy: "19",
          r: "7"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m39.63 19.46 1.93 1.94 4.31-4.3M35.52 24H6v4h36"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_CardAdded56 = (CardAdded56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Cart104.tsx


var Cart104_excluded = ["className"];
function Cart104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Cart104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Cart104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Cart104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Cart104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Cart104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Cart104_objectSpread(Cart104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M72.15 79.09c-3.71 4.8.64 7.52.64 7.52A5 5 0 0 0 79.58 85c-7.43.8-7.43-5.91-7.43-5.91ZM78.47 67.17C55.1 64.73 31.19 43.86 31.19 43.86l6.73 24.59ZM31.23 79.09c-3.72 4.8.64 7.52.64 7.52A5 5 0 0 0 38.65 85c-7.42.8-7.42-5.91-7.42-5.91Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "75.74",
          cy: "82.27",
          rx: "5.09",
          ry: "5.01"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "34.37",
          cy: "82.27",
          rx: "5.09",
          ry: "5.01"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M13 20.43h10.4a1.86 1.86 0 0 1 1.81 1.43l11.8 46-3.94 7.35a1.63 1.63 0 0 0 1.57 2.08h41.1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.57 67.83h40.06a1.87 1.87 0 0 0 1.77-1.27l5.2-24.5a1.87 1.87 0 0 0-1.77-2.46l-53.17-1.85"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Cart104 = (Cart104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Cart56.tsx


var Cart56_excluded = ["className"];
function Cart56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Cart56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Cart56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Cart56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Cart56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Cart56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Cart56_objectSpread(Cart56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.85 42.59c-2 2.58.35 4 .35 4a2.67 2.67 0 0 0 3.65-.89c-4 .5-4-3.11-4-3.11ZM19.84 36.52 36.42 36c-9.56-1-19.34-9.54-19.34-9.54ZM16.81 42.59c-2 2.58.35 4 .35 4a2.67 2.67 0 0 0 3.65-.89c-4 .5-4-3.11-4-3.11Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "40.78",
          cy: "44.3",
          rx: "2.74",
          ry: "2.7"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "18.51",
          cy: "44.3",
          rx: "2.74",
          ry: "2.7"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M7 11h5.6a1 1 0 0 1 1 .77l6.35 24.75-2.12 4a.88.88 0 0 0 .84 1.12h22.11"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20.23 36.52H41.8a1 1 0 0 0 1-.68l2.8-13.19a1 1 0 0 0-.95-1.33l-28.65-1"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Cart56 = (Cart56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Deal104.tsx


var Deal104_excluded = ["className"];
function Deal104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Deal104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Deal104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Deal104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Deal104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Deal104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Deal104_objectSpread(Deal104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m32 61.86 8-22.34L20 66.2a7.06 7.06 0 0 0 1.41 10l19.3 14.59a7.2 7.2 0 0 0 4.85 1.38l-11.2-12.09c-2.65-3.84-5.63-6.26-2.36-18.22Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M64.67 41.85a5.29 5.29 0 0 1-3-6.65 5.48 5.48 0 0 0-.67 1.18A5.17 5.17 0 0 0 70.24 41a5.28 5.28 0 0 1-5.57.9Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M78.92 30a5 5 0 0 1-.72 1.11 5.45 5.45 0 0 0 1.8-2.05 14.09 14.09 0 0 0 .92-8.82c-.12-.3-2.43-5 .23-8.19h-.18c-3.86 3.19-1.76 8.72-1.76 9a11.85 11.85 0 0 1-.29 8.95Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M72.89 36.2a9.2 9.2 0 0 1-3.14 0c-1 0-1.92-.47-1.91-1.5A1.86 1.86 0 0 1 68 34a1.91 1.91 0 0 0-1.18 1.76 1.77 1.77 0 0 0 1.77 1.77c.16 0 1.46-.21 3.31-.3 3.3-.18 6.64-2.53 9.18-5.42a18.92 18.92 0 0 1-8.17 4.39Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M73 26.62a14.33 14.33 0 0 0 1-2.22c1.62-4.62-1.18-9.42-3.37-12.23a21.46 21.46 0 0 0-2.19-2.48 1.76 1.76 0 1 0-2.44 2.5c1.76 1.77 6.06 7.06 4.67 11a11.5 11.5 0 0 1-1 2.06"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M76 32.13A7.06 7.06 0 0 0 67.68 26l-17.44 3a7.06 7.06 0 0 0-4.45 2.74L19.89 66.2a7.06 7.06 0 0 0 1.41 10l19.41 14.59a7 7 0 0 0 10-1.41l25.78-34.51a7.05 7.05 0 0 0 1.37-5.1l-1.4-13.25"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M70.47 37.35a4.41 4.41 0 1 1-4.41-4.41 4.35 4.35 0 0 1 3 1.19"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M71.21 38a25.91 25.91 0 0 1-3.3.27 1.77 1.77 0 0 1 0-3.53c2.46 0 9.21-.81 11-4.66a11.89 11.89 0 0 0 .26-8.91c-.12-.32-2.13-5.84 1.76-9a1.76 1.76 0 0 1 1.75-.3 1.77 1.77 0 0 1 .51 3c-1.92 1.59-.72 5-.72 5a15.06 15.06 0 0 1-.32 11.69c-2.06 4.38-7.41 5.86-10.94 6.44Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M73 26.62a14.33 14.33 0 0 0 1-2.22c1.62-4.62-1.18-9.42-3.37-12.23a21.46 21.46 0 0 0-2.19-2.48 1.76 1.76 0 1 0-2.44 2.5c1.76 1.77 6.06 7.06 4.67 11a11.5 11.5 0 0 1-1 2.06"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.73 62.31c-1.72 2.21-1.1 5.56 1.38 7.5s5.9 1.72 7.62-.49 1.09-5.57-1.39-7.5-3.1-5.3-1.38-7.51 5.12-2.43 7.61-.49 3.1 5.3 1.39 7.5M56.03 50.66l-2.46 3.16M41.11 69.81l-2.45 3.16"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m32.79 37.56-7.96-3.77"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m37.16 30.81-6.7-5.72"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m43.13 25.41-5-7.25"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m50.29 21.74-2.95-8.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m58.16 20.04-.71-8.78"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Deal104 = (Deal104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Deal56.tsx


var Deal56_excluded = ["className"];
function Deal56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Deal56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Deal56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Deal56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Deal56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Deal56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Deal56_objectSpread(Deal56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.85 13.14c.87-2.49-.64-5.07-1.82-6.58a10.77 10.77 0 0 0-1.18-1.34 1 1 0 0 0-1.34 0 .93.93 0 0 0-.28.67 1 1 0 0 0 .28.68c1 .95 3.27 3.79 2.52 5.91a6.43 6.43 0 0 1-.77 1.44 3.82 3.82 0 0 1 1.93.61 8.44 8.44 0 0 0 .66-1.39Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m17.22 33.31 4.28-12-10.79 14.33a3.81 3.81 0 0 0 .76 5.41l10.45 7.84a3.92 3.92 0 0 0 2.61.74l-6-6.51c-1.46-2.07-3.06-3.37-1.31-9.81Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.82 22.53A2.86 2.86 0 0 1 33.23 19a3.77 3.77 0 0 0-.39.64 2.78 2.78 0 0 0 5 2.46 2.84 2.84 0 0 1-3 .48Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42.5 16.17a3.09 3.09 0 0 1-.39.6 3.11 3.11 0 0 0 1-1.12 7.61 7.61 0 0 0 .49-4.75c-.06-.16-1.31-2.67.12-4.41h-.09c-2.08 1.72-.95 4.69-.95 4.86a6.39 6.39 0 0 1-.18 4.82Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41 17.67v-.37a3.79 3.79 0 0 0-4.55-3.3l-9.4 1.66a3.75 3.75 0 0 0-2.39 1.47L10.71 35.64a3.81 3.81 0 0 0 .76 5.41l10.45 7.84a3.76 3.76 0 0 0 2.84.74 3.8 3.8 0 0 0 2.53-1.5l13.9-18.58a3.86 3.86 0 0 0 .74-2.75l-.76-7.13"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38 20.11a2.37 2.37 0 1 1-.52-1.48"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.35 20.43a13.36 13.36 0 0 1-1.78.15 1 1 0 1 1 0-1.9c1.32 0 5-.44 5.92-2.51a6.38 6.38 0 0 0 .14-4.8c-.07-.17-1.15-3.14.95-4.86a1 1 0 0 1 1.55.57 1 1 0 0 1-.33.92c-1 .86-.39 2.67-.39 2.69a8.15 8.15 0 0 1-.17 6.3c-1.12 2.36-3.99 3.16-5.89 3.44Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.35 20.43a13.36 13.36 0 0 1-1.78.15 1 1 0 1 1 0-1.9c1.32 0 5-.44 5.92-2.51a6.38 6.38 0 0 0 .14-4.8c-.07-.17-1.15-3.14.95-4.86a1 1 0 0 1 1.55.57 1 1 0 0 1-.33.92c-1 .86-.39 2.67-.39 2.69a8.15 8.15 0 0 1-.17 6.3c-1.12 2.36-3.99 3.16-5.89 3.44Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.85 13.14c.87-2.49-.64-5.07-1.82-6.58a10.77 10.77 0 0 0-1.18-1.34 1 1 0 0 0-1.34 0 .93.93 0 0 0-.28.67 1 1 0 0 0 .28.68c1 .95 3.27 3.79 2.52 5.91a6.43 6.43 0 0 1-.77 1.44 3.82 3.82 0 0 1 1.93.61 8.44 8.44 0 0 0 .66-1.39ZM21.39 33.55a2.92 2.92 0 0 0 .75 4 2.75 2.75 0 1 0 3.35-4.3A2.75 2.75 0 1 1 28.85 29a2.92 2.92 0 0 1 .74 4M30.17 27.28l-1.32 1.7M22.14 37.59l-1.33 1.7"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m17.65 20.23-4.28-2.04"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m20.01 16.59-3.61-3.08"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m23.22 13.68-2.69-3.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m27.08 11.7-1.59-4.46"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m31.32 10.79-.38-4.73"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Deal56 = (Deal56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Delivery104.tsx


var Delivery104_excluded = ["className"];
function Delivery104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Delivery104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Delivery104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Delivery104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Delivery104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Delivery104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Delivery104_objectSpread(Delivery104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40.86 63.14c8.57-1 2.48-.93-5.48-.67a11.48 11.48 0 0 0 5.48.67ZM20.43 33.43l-1.86 29.71s9.25-.44 16.81-.67c-12.07-4.62-14.95-29.04-14.95-29.04ZM49.33 76.4c-20.89 0-37.83.78-37.83 1.73s16.94 1.74 37.83 1.74 37.83-.78 37.83-1.74-16.94-1.73-37.83-1.73Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M89.34 68.71h4l2.56-14a7.45 7.45 0 0 0-.93-3.92C93.81 48.71 88.55 40 88.55 40A5.69 5.69 0 0 0 87 38.57C86 38 84 38 81.37 38c-5.91-.07-11.07.22-11.07.22"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.99 68.66h30.09v-5.65H19.07v5.65h4.48"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M68.07 63.08H17.95l3.11-39h50.4l-3.39 39z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M91.18 52.43c-.11.22-17.35.14-17.35.14a1.17 1.17 0 0 1-1.21-1.28l.71-8.56a1.45 1.45 0 0 1 1.42-1.29h9.13a2.51 2.51 0 0 1 2 1.13s5.41 9.66 5.3 9.86Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.3 70.67a7.38 7.38 0 1 1-7.37-7.36 7.37 7.37 0 0 1 7.37 7.36Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.75 70.71a3.87 3.87 0 1 1-3.87-3.85"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M89.61 70.67a7.38 7.38 0 1 1-7.38-7.36 7.37 7.37 0 0 1 7.38 7.36Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M86.1 70.71a3.87 3.87 0 1 1-3.87-3.85"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28.37 42.36H6.03"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M16.43 36.19h-5.78"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M68.42 68.66h6.44"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M15.71 30.41h-.66"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.33 30.41h-4.12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.08 49.68h-3.81"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.11 49.68H31.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M17.35 49.68h-3.81"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M8.15 49.68H6.41"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Delivery104 = (Delivery104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Delivery56.tsx


var Delivery56_excluded = ["className"];
function Delivery56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Delivery56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Delivery56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Delivery56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Delivery56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Delivery56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Delivery56_objectSpread(Delivery56_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22 34c4.6-.5 1.3-.5-3-.4 1 .4 2 .5 3 .4zM11 18l-1 16s5-.2 9-.4C12.6 31.1 11 18 11 18zM26.6 41.1c-11.2 0-20.4.4-20.4.9s9.1 1 20.4 1 20.4-.4 20.4-.9-9.2-1-20.4-1z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.1 37h2.1l1.4-7.5c0-.7-.1-1.5-.5-2.1-.6-1.1-3.4-5.8-3.4-5.8-.2-.3-.5-.6-.8-.8-1-.3-2-.4-3-.3-3.2 0-6 .1-6 .1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36.8 37h3.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20.6 37h16.1v-3.1H10.3V37h2.4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36.7 34h-27l1.6-21h27.2z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.1 28.2c-.1.1-9.3.1-9.3.1-.4 0-.6-.3-.7-.6v-.1l.4-4.6c0-.4.4-.7.8-.7h4.9c.4 0 .8.3 1 .6 0 0 3 5.2 2.9 5.3z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20.6 38c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4 4 1.8 4 4z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.7 38.1c0 1.1-.9 2.1-2.1 2.1s-2.1-.9-2.1-2.1c0-1.1.9-2.1 2.1-2.1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.2 38c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4 4 1.8 4 4z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.4 38.1c0 1.1-.9 2.1-2.1 2.1s-2.1-.9-2.1-2.1c0-1.1.9-2.1 2.1-2.1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M13.1 16.4H9.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M9.8 26.8H6.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.8 26.8h-3.7"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M15.3 22.8H3.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M8.9 19.5H5.7"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Delivery56 = (Delivery56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Payment104.tsx


var Payment104_excluded = ["className"];
function Payment104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Payment104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Payment104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Payment104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Payment104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Payment104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Payment104_objectSpread(Payment104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22 29v6h56a4 4 0 0 1 3.45 2H94v-8ZM58 76c-6 0-31 0-36-3s-6.5-5.5-8-9c-1.38-3.22-4-3-4-3v14a4 4 0 0 0 4 4h50s0-3-6-3ZM10 41h72v8H10zM15 54h30v6H15z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22 34v-7a4 4 0 0 1 4-4h64a4 4 0 0 1 4 4v36a4 4 0 0 1-4 4h-8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22 29h72v8H82"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "10",
          y: "35",
          width: "72",
          height: "44",
          rx: "4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M10 41h72v8H10zM15 54h30v6H15z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Payment104 = (Payment104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Payment56.tsx


var Payment56_excluded = ["className"];
function Payment56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Payment56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Payment56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Payment56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Payment56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Payment56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Payment56_objectSpread(Payment56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.78 42.39c-3.22 0-16.65 0-19.34-1.61a9 9 0 0 1-4.29-4.84A2.3 2.3 0 0 0 6 34.33v7.52A2.15 2.15 0 0 0 8.15 44H35s0-1.61-3.22-1.61ZM14 16v2h26a4 4 0 0 1 3.44 2H50v-4ZM6 23h36v4H6zM9 30h16v4H9z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M14 18v-3a2 2 0 0 1 2-2h32a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2h-4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M14 16h36v4h-6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "6",
          y: "20",
          width: "36",
          height: "24",
          rx: "2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M6 23h36v4H6zM9 30h16v4H9z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Payment56 = (Payment56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/PaymentCalendar104.tsx


var PaymentCalendar104_excluded = ["className"];
function PaymentCalendar104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PaymentCalendar104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PaymentCalendar104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PaymentCalendar104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function PaymentCalendar104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PaymentCalendar104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", PaymentCalendar104_objectSpread(PaymentCalendar104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m87.1 18.9-2.4-.9h-8.6v1c0 2.2-1.3 4-3 4s-3-1.8-3-4v-1h-4.6v1c0 2.2-1.3 4-3 4s-3-1.8-3-4v-1H55v1c0 2.2-1.3 4-3 4s-3-1.8-3-4v-1h-4.6v1c0 2.2-1.3 4-3 4s-3-1.8-3-4v-1h-4.6v1c0 2.2-1.3 4-3 4s-3-1.8-3-4v-1h-8.9l-2.1 1-1.2 2.2v16.9h72.9v-17l-1.4-2.2z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.9 43.8c-3.7.1-7.2 1.4-10.1 3.7-2.7 2.2-3.6 5.9-2.4 9.2 1.9 5 7.1 7.3 12.1 6.8 4.8-.4 9.2-2.7 12.1-6.5 3-4.1 2.6-9.8-1.1-13.4-2.4-2.2-5.7-3-8.8-3.2-3.4-.2-6.7 0-10 .5-.8 0-1.4.6-1.4 1.4 0 .7.6 1.4 1.4 1.4 2.7-.4 5.5-.6 8.3-.6 2.3-.1 4.6.4 6.8 1.3 2 .9 3.4 2.7 3.9 4.8.2.8.3 1.7.2 2.6v.1c0 .1 0 .3-.1.4s-.1.4-.1.6-.1.4-.2.6-.1.2-.1.3c.1-.3-.1.1-.1.1-.8 1.6-2 3-3.5 4.1-1.6 1.1-3.4 2-5.3 2.4-.9.2-1.9.4-2.8.4-.9 0-1.8 0-2.7-.2-1.8-.3-3.3-1.2-4.5-2.5-1.9-2.1-2.6-5.5-.6-7.7 2.2-2.5 5.8-3.6 9-3.8 1.8-.1 1.8-2.9 0-2.8"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M15.6 31.4h72.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M15.6 38.5h72.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22 63.6h60"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M52 44.5v40"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m72.8 91.1 15.7-15h-7c-4.8 0-8.7 3.9-8.7 8.7v6.3z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M76 18h6.7c3.2 0 5.7 2.6 5.7 5.7v52.4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M72.8 91.1H21.3c-3.2 0-5.7-2.6-5.7-5.7V23.7c0-3.1 2.6-5.7 5.7-5.7H28"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.4 19.1c0 2.3-1.2 4.1-2.6 4.1s-2.6-1.9-2.6-4.1V17c0-2.3 1.2-4.1 2.6-4.1 1.4 0 2.6 1.9 2.6 4.1v2.1z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44 19.1c0 2.3-1.2 4.1-2.6 4.1s-2.6-1.9-2.6-4.1V17c0-2.3 1.2-4.1 2.6-4.1S44 14.8 44 17v2.1z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M54.6 19.1c0 2.3-1.2 4.1-2.6 4.1s-2.6-1.9-2.6-4.1V17c0-2.3 1.2-4.1 2.6-4.1s2.6 1.9 2.6 4.1v2.1z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M65.2 19.1c0 2.3-1.2 4.1-2.6 4.1S60 21.4 60 19.1V17c0-2.3 1.2-4.1 2.6-4.1s2.6 1.9 2.6 4.1v2.1z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M75.8 19.1c0 2.3-1.2 4.1-2.6 4.1s-2.6-1.9-2.6-4.1V17c0-2.3 1.2-4.1 2.6-4.1s2.6 1.9 2.6 4.1v2.1z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M65.6 18h5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M55 18h5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.4 18h5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.8 18h5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.7 55.2c.1 1.9 1.7 3.3 3.6 3.2 1.8.2 3.4-1.1 3.6-2.9S38.8 52.1 37 52h-.7c-1.8.2-3.4-1-3.6-2.8-.2-1.8 1-3.4 2.8-3.6h.8c1.9-.1 3.5 1.3 3.6 3.2M36.3 43v2.5M36.3 58.4V61"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PaymentCalendar104 = (PaymentCalendar104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/PaymentCalendar56.tsx


var PaymentCalendar56_excluded = ["className"];
function PaymentCalendar56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PaymentCalendar56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PaymentCalendar56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PaymentCalendar56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function PaymentCalendar56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PaymentCalendar56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", PaymentCalendar56_objectSpread(PaymentCalendar56_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m46.9 10.2-1.3-.5h-4.8v.6c0 1.2-.6 2.2-1.4 2.2s-1.4-1-1.4-2.2v-.6h-2.9v.6c0 1.2-.6 2.2-1.4 2.2s-1.4-1-1.4-2.2v-.6h-2.9v.6c0 1.2-.6 2.2-1.4 2.2s-1.4-1-1.4-2.2v-.6h-2.9v.6c0 1.2-.6 2.2-1.4 2.2s-1.4-1-1.4-2.2v-.6H18v.6c0 1.2-.6 2.2-1.4 2.2s-1.4-1-1.4-2.2v-.6h-5l-1.2.5-.7 1.2v9.1h39.3v-9.2l-.7-1.1z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19.2 23.7c-1.8.1-3.5.7-4.9 1.9-1.3 1.1-1.8 3-1.2 4.6 1 2.4 3.4 3.8 5.9 3.4 2.3-.2 4.5-1.4 5.9-3.3 1.5-2.1 1.2-4.9-.5-6.7-1.2-1-2.7-1.6-4.3-1.6-1.6-.1-3.2 0-4.9.3-.4 0-.7.3-.7.7 0 .3.3.7.7.7 1.3-.2 2.7-.3 4-.3 1.1 0 2.2.2 3.3.6 1 .5 1.7 1.4 1.9 2.4.1.4.1.9.1 1.3 0 0 0 .2 0 0v.2c0 .1 0 .2-.1.3s-.1.2-.1.3c0 .1 0 .1-.1.2.1-.1 0 .1 0 .1-.4.8-1 1.5-1.7 2-.8.6-1.7 1-2.6 1.2-.4.1-.9.2-1.4.2-.4 0-.9 0-1.3-.1-.8-.2-1.6-.6-2.2-1.3-1-1-1.1-2.7-.3-3.9 1.2-1.2 2.7-1.9 4.3-1.9 1 .1 1-1.4.2-1.3"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M8.4 16.9h39.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M8.4 20.7h39.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M11.9 34.2h32.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28 24v21.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41 9.7h3.5c1.7 0 3.1 1.4 3.1 3.1V41"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.1 9.7H38"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29.5 9.7h2.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.8 9.7h2.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18 9.7h2.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.2 49.1H11.5c-1.7 0-3.1-1.4-3.1-3.1V12.8c0-1.7 1.4-3.1 3.1-3.1H15"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18 10.3c0 1.2-.6 2.2-1.4 2.2s-1.4-1-1.4-2.2V9.2c0-1.2.6-2.2 1.4-2.2.8 0 1.4 1 1.4 2.2v1.1z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.7 10.3c0 1.2-.6 2.2-1.4 2.2s-1.4-1-1.4-2.2V9.2c0-1.2.6-2.2 1.4-2.2s1.4 1 1.4 2.2v1.1z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29.4 10.3c0 1.2-.6 2.2-1.4 2.2s-1.4-1-1.4-2.2V9.2C26.6 8 27.2 7 28 7s1.4 1 1.4 2.2v1.1z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.1 10.3c0 1.2-.6 2.2-1.4 2.2s-1.4-1-1.4-2.2V9.2c0-1.2.6-2.2 1.4-2.2s1.4 1 1.4 2.2v1.1z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40.8 10.3c0 1.2-.6 2.2-1.4 2.2s-1.4-1-1.4-2.2V9.2C38 8 38.6 7 39.4 7s1.4 1 1.4 2.2v1.1z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m39.2 49.1 8.5-8.1h-3.8c-2.6 0-4.7 2.1-4.7 4.7v3.4z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M17.2 29.6c.1 1 .9 1.8 2 1.7 1 .1 1.8-.6 1.9-1.6.1-1-.6-1.8-1.6-1.9h-.4c-1 .1-1.8-.5-2-1.5s.5-1.8 1.5-2h.5c1-.1 1.9.7 2 1.7M19.1 23v1.4M19.1 31.4v1.3"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PaymentCalendar56 = (PaymentCalendar56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/PaymentHelp104.tsx


var PaymentHelp104_excluded = ["className"];
function PaymentHelp104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PaymentHelp104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PaymentHelp104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PaymentHelp104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function PaymentHelp104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PaymentHelp104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", PaymentHelp104_objectSpread(PaymentHelp104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m39.84 73.68.4-.26-.75-.66-2.22 1.5c-1.27.74-2.51 1.12-3.33.74a3.56 3.56 0 0 0 3.34.89c1.35-.37 1.49-.91 1.44-1.23a3.26 3.26 0 0 1 1.12-.98ZM45 77.56l-1.64 1.21c-1.47.88-2.9 1.29-3.86.89a4.3 4.3 0 0 0 2.32 1.13l-.1.19a4 4 0 0 0 2.62-.46c0-.09.06-.18.09-.27.05-.79.66-.86.59-1.1a8.25 8.25 0 0 1 .73-.94ZM93.92 45.82c-2-.38-4 .81-5.69 2l-6.88 4.56a14.93 14.93 0 0 0-4.12 3.53 31.43 31.43 0 0 0-2.31 5c-.16.32-.33.64-.5.95l.18.25c1.25 1.78 2.94 3.46 3.93 5a16.2 16.2 0 0 0 4.08-9l8.1-4.43a22.8 22.8 0 0 0 4.39-3.2c1.9-1.84 2.8-3.9-1.18-4.66Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.92 74c-1.62-1.81-3.91-2.84-5.8-4.35-4.6-3.66-6.62-9.91-11.37-13.36a26 26 0 0 0-6.23-3 51.14 51.14 0 0 0-10.81-3.1c-1.72-.24-6.07-1.22-7.32.32 4.54 2.19 9.11 4.38 13.65 6.59l8.17 4 .36.78c.36.78 2.36 3.43 3.27 4.94s5.41 5.77 5.41 5.77l6.86 6 .72.6A5.78 5.78 0 0 0 45.46 81c-1.22 2.92 1.08 4.52 3.75 3.8a5.78 5.78 0 0 0 2-1c.25-.18.78-.48 1.19-.71h-.07a6.8 6.8 0 0 0 .85.39 4.39 4.39 0 0 0 3.78-.25c-3.48-.05-5.1-7.11-7.04-9.23ZM69.73 52.91c-2.69-.37-6.15-4.09-8.79-5.13s-9.9.42-12.71.3a5.35 5.35 0 0 1-1.76-.43c-1.43-.58-2.21-.3-2.7.2a3.66 3.66 0 0 0 .5.55A2.8 2.8 0 0 0 46 51.29c1.06.55 5.79.12 8.91.79s8.5 4 13.28 3.73l-.51-.56a17.24 17.24 0 0 0 6 .58 4.46 4.46 0 0 0-3.95-2.92ZM52 50l2.55-.18-1 .1A13.3 13.3 0 0 1 52 50Zm6.1-.48 1.07-.09.63.66a3.55 3.55 0 0 0-.76-.56 6 6 0 0 0-.98.03Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.25 63.19a3.56 3.56 0 0 0 .33 3.49l.09.13a3.72 3.72 0 0 0 3 1.57"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m34.69 68.38-.88.56a3.59 3.59 0 0 0-1 5l.09.13c1.14 1.64 3.71 2.61 5.39 1.48"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.7 73.76a3.58 3.58 0 0 0-1 5l.08.13c1.15 1.64 3.85 2.72 5.53 1.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45.91 78.27a3.58 3.58 0 0 0-1 5l.09.13a3.77 3.77 0 0 0 5.14.94l2-1.41"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m97.53 50-14.92 8.11a17.4 17.4 0 0 1-3.86 8.72"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m21.55 28.94 18.21 14.11s2.06 1.6 3.88 1.06"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m70.42 71 1 1s3.26 3.15 6.17.75c2.36-1.93 1.83-4.3.66-6 0 0-4.37-6.06-7.06-8.23a24.53 24.53 0 0 1-3.59-3.34"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M65.71 77.34a4.71 4.71 0 0 1-1.78 3.43c-3.16 2.54-7.13-.72-7.13-.72l-1.9-1.72"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M72.9 73.05a5.48 5.48 0 0 1-2.35 4.37c-2.77 1.67-5.78-.65-5.78-.65l-1.88-1.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M85.78 26.74C70 40.66 69.73 40.51 68.23 41.09c-2.25.86-3.65.08-6.44-.31S54 41.56 51 42.15s-7.62.66-8 3.06 2.21 5 6.16 5h.5c3.92 0 7.69-.84 9.16-.65s5.45 7 14.8 6.29"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M58.51 81.27a3.4 3.4 0 0 1-.88 1.36l-.11.09a4.47 4.47 0 0 1-5.39.24 92.12 92.12 0 0 1-12-9.66C32.2 66.26 30.2 61 30.2 61L8.39 50.46"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PaymentHelp104 = (PaymentHelp104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/PaymentHelp56.tsx


var PaymentHelp56_excluded = ["className"];
function PaymentHelp56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PaymentHelp56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PaymentHelp56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PaymentHelp56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function PaymentHelp56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PaymentHelp56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", PaymentHelp56_objectSpread(PaymentHelp56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m21.45 38.28.22-.14-.41-.36-.49.33-.7.48a2.23 2.23 0 0 1-1.79.42 1.89 1.89 0 0 0 1.79.47c.73-.2.8-.49.78-.66a1.54 1.54 0 0 1 .29-.32 1.62 1.62 0 0 1 .31-.22ZM24.24 40.37l-.63.46-.25.18a2.57 2.57 0 0 1-2.08.49 2.23 2.23 0 0 0 1.24.6 1.17 1.17 0 0 1-.05.11 2.19 2.19 0 0 0 1.41-.21.58.58 0 0 1 .05-.14.66.66 0 0 1 .26-.49s.07-.07 0-.11a5.39 5.39 0 0 1 .4-.5ZM50.57 23.28a4.34 4.34 0 0 0-3.06 1l-3.71 2.5a7.93 7.93 0 0 0-2.21 1.9 16.06 16.06 0 0 0-1.25 2.69c-.08.17-.19.33-.28.5l.11.14c.68 1 1.58 1.87 2.11 2.72a8.68 8.68 0 0 0 2.2-4.84l4.37-2.38a12.55 12.55 0 0 0 2.36-1.73c1.02-.99 1.51-2.1-.64-2.5Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.88 38.42a23.3 23.3 0 0 0-3.12-2.34c-2.48-2-3.57-5.34-6.13-7.19a13.48 13.48 0 0 0-3.35-1.62 28.24 28.24 0 0 0-5.82-1.67c-.93-.13-3.27-.65-3.94.17l7.35 3.55 4.4 2.14.19.42c.2.43 1.27 1.85 1.76 2.66a30.13 30.13 0 0 0 2.91 3.11l3.7 3.22.39.33a3.86 3.86 0 0 0-.49.58 2 2 0 0 0-.25.45c-.66 1.57.58 2.44 2 2.05a3 3 0 0 0 1.05-.56c.13-.09.4-.25.62-.37l-.08-.06a3.74 3.74 0 0 0 .51.24 2.36 2.36 0 0 0 2-.14c-1.78 0-2.66-3.8-3.7-4.97ZM37.55 27.09c-1.45-.2-3.31-2.2-4.74-2.76s-5.33.23-6.84.16a3.07 3.07 0 0 1-.95-.23c-.77-.32-1.19-.16-1.45.11a1.82 1.82 0 0 0 .27.29 1.5 1.5 0 0 0 .92 1.56c.57.3 3.12.07 4.8.42s4.58 2.16 7.15 2l-.28-.31a9.46 9.46 0 0 0 3.24.33 2.4 2.4 0 0 0-2.12-1.57ZM28 25.55l1.38-.1-.56.05a7.37 7.37 0 0 1-.82.05Zm3.27-.26.58-.05s.12.14.34.36a1.79 1.79 0 0 0-.41-.3 2.31 2.31 0 0 0-.52-.01Zm3.93 2.55c.2.11.41.2.62.29a6.45 6.45 0 0 1-.63-.29Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M16.83 32.63a1.9 1.9 0 0 0 .17 1.88v.07a2 2 0 0 0 1.63.84"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m18.68 35.42-.47.31a1.91 1.91 0 0 0-.52 2.7v.07a2.26 2.26 0 0 0 2.9.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21.38 38.32a1.92 1.92 0 0 0-.52 2.68l.05.07a2.4 2.4 0 0 0 3 .86"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28.19 43.35 27 44a2 2 0 0 1-2.76-.51l-.05-.07a1.91 1.91 0 0 1 .52-2.7"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m52.52 25.5-8 4.39a9.3 9.3 0 0 1-2.24 4.89"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.51 42.36a1.93 1.93 0 0 1-.48.73l-.06.06a2.41 2.41 0 0 1-2.9.12 48.31 48.31 0 0 1-6.47-5.2c-4.26-3.79-5.34-6.63-5.34-6.63L4.52 25.77"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m11.6 14.18 9.81 7.6a2.8 2.8 0 0 0 2.09.58"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m37.92 36.85.55.53s1.75 1.7 3.32.41a2.23 2.23 0 0 0 .36-3.24 32 32 0 0 0-3.81-4.43 13.31 13.31 0 0 1-1.93-1.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.38 40.25a2.51 2.51 0 0 1-1 1.84c-1.71 1.37-3.84-.38-3.84-.38l-1-.93"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.25 37.93A3 3 0 0 1 38 40.29a3 3 0 0 1-3.12-.35l-1-.7"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.19 13c-8.52 7.5-8.64 7.42-9.45 7.72-1.21.47-2 .05-3.47-.16s-4.2.42-5.8.74-4.1.35-4.29 1.65 1.19 2.68 3.32 2.67h.27c2.11 0 4.14-.45 4.93-.34s2.93 3.78 8 3.39"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PaymentHelp56 = (PaymentHelp56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/PaymentPlan104.tsx


var PaymentPlan104_excluded = ["className"];
function PaymentPlan104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PaymentPlan104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PaymentPlan104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PaymentPlan104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function PaymentPlan104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PaymentPlan104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", PaymentPlan104_objectSpread(PaymentPlan104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M65.5 67.8S61.6 84.5 76.8 92c0 0-9.8.3-13.3-9 0 0-3.5-8.8 2-15.2z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.1 41.8c-3.5.1-6.8 1.3-9.5 3.5-2.5 2.1-3.4 5.6-2.3 8.6 1.8 4.7 6.7 6.9 11.4 6.4 4.5-.3 8.6-2.6 11.4-6.1 2.9-3.8 2.4-9.2-1-12.6-2.2-2.1-5.3-2.8-8.3-3-3.2-.2-6.3 0-9.4.5-.7 0-1.3.6-1.3 1.3 0 .7.6 1.3 1.3 1.3 2.6-.4 5.2-.5 7.8-.5 2.2-.1 4.3.3 6.3 1.2 1.9.9 3.2 2.5 3.7 4.5.2.8.3 1.6.2 2.5v.1l-.1.4c0 .2-.1.4-.1.6l-.2.4c0 .1-.1.2-.1.3.1-.2-.1.1-.1.1-.8 1.5-1.9 2.8-3.3 3.8-1.5 1.1-3.2 1.9-5 2.3-.9.2-1.7.4-2.6.4-.9.1-1.7 0-2.6-.2-1.6-.3-3.1-1.1-4.3-2.4-1.8-2-2.4-5.1-.5-7.3 2-2.3 5.5-3.4 8.5-3.5 1.7-.1 1.7-2.7.1-2.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m76.8 17.4-2.2-.9h-8.1v1.1c0 2.1-1.1 3.8-2.3 3.8s-2.4-1.7-2.4-3.8v-1.1h-4.9v1.1c0 2.1-1.1 3.8-2.3 3.8s-2.4-1.7-2.4-3.8v-1.1h-4.9v1.1c0 2.1-1.1 3.8-2.4 3.8s-2.3-1.7-2.3-3.8v-1.1h-4.9v1.1c0 2.1-1.1 3.8-2.3 3.8S33 19.7 33 17.6v-1.1h-4.9v1.1c0 2.1-1.1 3.8-2.4 3.8s-2.4-1.7-2.4-3.8v-1.1H15l-1.9 1-1.1 2v15.3h66V19.5l-1.2-2.1z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M66.8 16.6h6c2.9 0 5.2 2.3 5.2 5.2v32.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "77.1",
          cy: "77.1",
          r: "14.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M12 28.8h66"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M12 35.2h66"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M56.9 16.6h4.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47.6 16.6h4.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.9 16.6h4.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28.2 16.6h4.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M54.7 82.9H17.2c-2.9 0-5.2-2.3-5.2-5.2V21.8c0-2.9 2.3-5.2 5.2-5.2h6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28.2 17.7c0 2.1-1.1 3.8-2.4 3.8s-2.4-1.7-2.4-3.8v-1.9c0-2.1 1.1-3.8 2.4-3.8s2.4 1.7 2.4 3.8v1.9z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.8 17.7c0 2.1-1.1 3.8-2.3 3.8s-2.4-1.7-2.4-3.8v-1.9c0-2.1 1.1-3.8 2.4-3.8s2.3 1.7 2.3 3.8v1.9z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47.4 17.7c0 2.1-1.1 3.8-2.4 3.8s-2.3-1.7-2.3-3.8v-1.9c0-2.1 1.1-3.8 2.3-3.8s2.4 1.7 2.4 3.8v1.9z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M56.9 17.7c0 2.1-1.1 3.8-2.3 3.8s-2.4-1.7-2.4-3.8v-1.9c0-2.1 1.1-3.8 2.4-3.8s2.3 1.7 2.3 3.8v1.9z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M66.5 17.7c0 2.1-1.1 3.8-2.3 3.8s-2.4-1.7-2.4-3.8v-1.9c0-2.1 1.1-3.8 2.4-3.8 1.3 0 2.3 1.7 2.3 3.8v1.9z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.1 53.8c.1 1.7 1.6 3 3.3 2.9 1.6.2 3.1-.9 3.3-2.5.2-1.6-.9-3.1-2.5-3.3h-.8c-1.6.2-3.1-1-3.3-2.6s1-3.1 2.6-3.3h.7c1.7-.1 3.2 1.2 3.3 2.9M30.4 42.7V45M30.4 56.7V59M69.7 77.7l4.6 4.5L84.6 72"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PaymentPlan104 = (PaymentPlan104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/PaymentPlan56.tsx


var PaymentPlan56_excluded = ["className"];
function PaymentPlan56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PaymentPlan56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PaymentPlan56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PaymentPlan56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function PaymentPlan56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PaymentPlan56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", PaymentPlan56_objectSpread(PaymentPlan56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.27 36.5s-2.12 9 6.06 13c0 0-5.28.17-7.17-4.82 0-.01-1.85-4.68 1.11-8.18Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41.33 9.43 40.16 9h-4.35v.57c0 1.12-.57 2-1.27 2s-1.26-.9-1.26-2V9h-2.62v.57c0 1.12-.57 2-1.27 2s-1.26-.9-1.26-2V9H25.5v.57c0 1.12-.56 2-1.26 2s-1.27-.9-1.27-2V9h-2.62v.57c0 1.12-.57 2-1.26 2s-1.27-.9-1.27-2V9H15.2v.57c0 1.12-.57 2-1.27 2s-1.26-.9-1.26-2V9H8.13l-1 .52-.61 1.07v8.23H42v-8.31Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M16.22 23a8.55 8.55 0 0 0-5.09 1.87 4.14 4.14 0 0 0-1.22 4.63A5.78 5.78 0 0 0 16 33a8.61 8.61 0 0 0 6.13-3.3 5.16 5.16 0 0 0-.56-6.76 7.3 7.3 0 0 0-4.45-1.63 25.23 25.23 0 0 0-5.06.26.72.72 0 0 0-.7.7.69.69 0 0 0 .7.69 30.83 30.83 0 0 1 4.19-.29 8.15 8.15 0 0 1 3.4.65 3.64 3.64 0 0 1 2 2.43 3.34 3.34 0 0 1 .1 1.32s0 .17 0 0a1.62 1.62 0 0 1 0 .19c0 .1 0 .2-.07.31s-.06.2-.1.3l-.07.18c.05-.13 0 .06 0 .07a5.77 5.77 0 0 1-1.76 2.05A7.52 7.52 0 0 1 17 31.39a6.23 6.23 0 0 1-1.42.2 5 5 0 0 1-1.38-.11 4 4 0 0 1-2.29-1.27 3 3 0 0 1-.28-3.91 6.54 6.54 0 0 1 4.56-1.91c.89 0 .9-1.44 0-1.4"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M14.64 29.41A1.68 1.68 0 0 0 16.41 31a1.58 1.58 0 1 0 0-3.14 1.58 1.58 0 1 1 0-3.14 1.68 1.68 0 0 1 1.77 1.57M16.41 23.46v1.24M16.41 30.98v1.24"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "41.51",
          cy: "41.5",
          r: "8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M6.49 15.52h35.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M6.49 18.95h35.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36 9h3.21A2.81 2.81 0 0 1 42 11.76V29.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.66 9h2.61"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M25.64 9h2.49"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20.42 9H23"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M15.2 9h2.62"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29.46 44.59H9.29a2.81 2.81 0 0 1-2.8-2.79v-30A2.81 2.81 0 0 1 9.29 9h3.23"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M15.2 9.54c0 1.12-.57 2-1.27 2s-1.26-.9-1.26-2v-1c0-1.11.57-2 1.26-2s1.27.91 1.27 2Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20.35 9.54c0 1.12-.57 2-1.26 2s-1.27-.9-1.27-2v-1c0-1.11.57-2 1.27-2s1.26.91 1.26 2Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M25.5 9.54c0 1.12-.56 2-1.26 2s-1.27-.9-1.27-2v-1c0-1.11.57-2 1.27-2s1.26.91 1.26 2Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.66 9.54c0 1.12-.57 2-1.27 2s-1.26-.9-1.26-2v-1c0-1.11.57-2 1.26-2s1.27.91 1.27 2Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.81 9.54c0 1.12-.57 2-1.27 2s-1.26-.9-1.26-2v-1c0-1.11.57-2 1.26-2s1.27.91 1.27 2Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m37.51 41.78 2.47 2.48 5.53-5.52"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PaymentPlan56 = (PaymentPlan56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/PromoCombined104.tsx


var PromoCombined104_excluded = ["className"];
function PromoCombined104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PromoCombined104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PromoCombined104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PromoCombined104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function PromoCombined104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PromoCombined104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", PromoCombined104_objectSpread(PromoCombined104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.86 24.58a.77.77 0 0 0 .71-.72 5.56 5.56 0 0 1 5.54-5.53c.53-.18.89-.54.89-.9a.77.77 0 0 0-.71-.71 5.57 5.57 0 0 1-5.54-5.54c-.18-.53-.54-.89-.89-.89s-.9.36-.9.72a5.56 5.56 0 0 1-5.53 5.53 1.2 1.2 0 0 0-.72.89.77.77 0 0 0 .72.72A5.48 5.48 0 0 1 18 23.68a.66.66 0 0 0 .18.54c.18.36.36.36.72.36"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M91.87 83.7a3.69 3.69 0 0 1-3.69-3.7.58.58 0 1 0-1.18 0 3.69 3.69 0 0 1-3.69 3.69.52.52 0 0 0-.59.58.52.52 0 0 0 .59.59A3.79 3.79 0 0 1 86 86a3.84 3.84 0 0 1 1.17 2.72.51.51 0 0 0 .58.58.52.52 0 0 0 .59-.58 3.68 3.68 0 0 1 3.69-3.69.51.51 0 0 0 .58-.58.84.84 0 0 0-.78-.78"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m24.38 47.21-2.63 2.59a3.17 3.17 0 0 0-.89 2.2 3.13 3.13 0 0 0 .9 2.2L27 59.37a2.37 2.37 0 0 1 .67 2.08l-1.33 7.38a3.2 3.2 0 0 0 .5 2.36 2.8 2.8 0 0 0 1.92 1.19l7.13 1a2.26 2.26 0 0 1 1.76 1.32l3.07 6.78A2.94 2.94 0 0 0 42.39 83a2.88 2.88 0 0 0 2.21-.22l6.3-3.6a2.33 2.33 0 0 1 1.1-.28 2.22 2.22 0 0 1 1.09.29l6.31 3.6a2.72 2.72 0 0 0 2.21.22 2.87 2.87 0 0 0 1.68-1.56l1.06-2.34c-11.71-3.15-32.77-15.67-40-31.9"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M82.93 54.92a4.14 4.14 0 0 0 0-5.83l-5.22-5.16a1.31 1.31 0 0 1-.37-1.19l1.32-7.38a4.12 4.12 0 0 0-.67-3.1 3.83 3.83 0 0 0-2.6-1.62l-7.14-1a1.32 1.32 0 0 1-1-.74l-3.05-6.75a3.9 3.9 0 0 0-2.28-2.09 3.71 3.71 0 0 0-3 .29L52.59 24a1.19 1.19 0 0 1-1.21 0l-6.3-3.6a3.72 3.72 0 0 0-3-.29 3.89 3.89 0 0 0-2.29 2.09l-3.09 6.74a1.29 1.29 0 0 1-1 .74l-7.12 1A3.82 3.82 0 0 0 26 32.26a4.15 4.15 0 0 0-.67 3.09l1.32 7.39a1.32 1.32 0 0 1-.38 1.19L21 49.09a4.14 4.14 0 0 0 0 5.83l5.22 5.16a1.33 1.33 0 0 1 .38 1.2l-1.32 7.37a4.2 4.2 0 0 0 .72 3.11 3.81 3.81 0 0 0 2.61 1.61l7.12 1a1.24 1.24 0 0 1 1 .74l3.07 6.78A4 4 0 0 0 42.05 84a3.64 3.64 0 0 0 1.18.18 3.75 3.75 0 0 0 1.85-.48l6.3-3.6a1.24 1.24 0 0 1 1.21 0l6.31 3.6a3.72 3.72 0 0 0 3 .3 3.9 3.9 0 0 0 2.28-2.1l3.07-6.78a1.28 1.28 0 0 1 1-.74l7.14-1A3.73 3.73 0 0 0 78 71.74a4.11 4.11 0 0 0 .67-3.09l-1.32-7.37a1.33 1.33 0 0 1 .37-1.2Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M65.49 50.36h-27M51.99 64.86l-13.5-14.5 5.86-6.34h15.27l5.87 6.34-13.5 14.5z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m46.7 50.36 5.29-6.34 5.28 6.34-5.28 14.5-5.29-14.5zM44.36 44.02l2.34 6.34M59.62 44.02l-2.35 6.34"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PromoCombined104 = (PromoCombined104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/PromoCombined56.tsx


var PromoCombined56_excluded = ["className"];
function PromoCombined56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PromoCombined56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PromoCombined56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PromoCombined56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function PromoCombined56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PromoCombined56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", PromoCombined56_objectSpread(PromoCombined56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m12.87 25.42-1.43 1.41a1.73 1.73 0 0 0 0 2.41l2.84 2.81a1.27 1.27 0 0 1 .37 1.13l-.73 4a1.74 1.74 0 0 0 .28 1.28 1.51 1.51 0 0 0 1 .65l3.89.53a1.22 1.22 0 0 1 .95.72l1.68 3.69a1.5 1.5 0 0 0 2.13.74l3.43-2a1.28 1.28 0 0 1 .6-.16 1.19 1.19 0 0 1 .6.17l3.43 2a1.51 1.51 0 0 0 1.21.11 1.55 1.55 0 0 0 .91-.85l.58-1.27c-6.38-1.72-17.86-8.54-21.78-17.38"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M9.61 13.7a.42.42 0 0 0 .38-.39 3 3 0 0 1 3-3c.29-.1.49-.29.49-.48a.43.43 0 0 0-.39-.39 3 3 0 0 1-3-3C10 6.2 9.8 6 9.61 6s-.48.2-.48.39a3 3 0 0 1-3 3 .64.64 0 0 0-.39.48.42.42 0 0 0 .39.38 3 3 0 0 1 2.11.87 3 3 0 0 1 .87 2.11.36.36 0 0 0 .09.29c.1.2.2.2.39.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.92 45.53a2 2 0 0 1-2-2 .28.28 0 0 0-.32-.31.28.28 0 0 0-.31.31 2 2 0 0 1-2 2 .28.28 0 0 0-.31.31.28.28 0 0 0 .31.32 2.06 2.06 0 0 1 1.47.63 2 2 0 0 1 .63 1.46.31.31 0 1 0 .62 0 2 2 0 0 1 2-2 .27.27 0 0 0 .31-.31.45.45 0 0 0-.42-.42"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.65 29.57a2.19 2.19 0 0 0 .64-1.57 2.22 2.22 0 0 0-.64-1.57l-2.81-2.77a.74.74 0 0 1-.2-.65l.71-4a2.23 2.23 0 0 0-.35-1.64 2 2 0 0 0-1.4-.87l-3.86-.5a.67.67 0 0 1-.52-.4l-1.66-3.65a2.08 2.08 0 0 0-1.22-1.13 2 2 0 0 0-1.63.16l-3.4 1.94a.68.68 0 0 1-.65 0L24.27 11a2 2 0 0 0-1.63-.16 2.07 2.07 0 0 0-1.23 1.13l-1.66 3.65a.65.65 0 0 1-.52.4l-3.84.52a2 2 0 0 0-1.4.87 2.22 2.22 0 0 0-.36 1.59l.71 4a.72.72 0 0 1-.21.65l-2.81 2.77a2.22 2.22 0 0 0-.64 1.58 2.19 2.19 0 0 0 .64 1.57l2.81 2.78a.72.72 0 0 1 .21.65l-.71 4a2.24 2.24 0 0 0 .37 1.64 2.05 2.05 0 0 0 1.4.87l3.84.52a.65.65 0 0 1 .52.4l1.66 3.65a2.12 2.12 0 0 0 1.22 1.13 2 2 0 0 0 .64.1 2.07 2.07 0 0 0 1-.26l3.39-1.94a.63.63 0 0 1 .65 0l3.4 1.94a2 2 0 0 0 1.63.16 2.09 2.09 0 0 0 1.22-1.13l1.66-3.65a.67.67 0 0 1 .52-.4l3.85-.52a2 2 0 0 0 1.4-.88 2.22 2.22 0 0 0 .35-1.63l-.71-4a.74.74 0 0 1 .2-.65Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.26 27.12H20.72M27.99 34.93l-7.27-7.81 3.16-3.42h8.21l3.17 3.42-7.27 7.81z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m25.14 27.12 2.85-3.42 2.84 3.42-2.84 7.81-2.85-7.81zM23.88 23.7l1.26 3.42M32.09 23.7l-1.26 3.42"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PromoCombined56 = (PromoCombined56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/PromoData104.tsx


var PromoData104_excluded = ["className"];
function PromoData104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PromoData104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PromoData104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PromoData104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function PromoData104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PromoData104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", PromoData104_objectSpread(PromoData104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m24.38 47.21-2.63 2.59a3.17 3.17 0 0 0-.89 2.2 3.13 3.13 0 0 0 .9 2.2L27 59.37a2.34 2.34 0 0 1 .66 2.08l-1.32 7.38a3.2 3.2 0 0 0 .5 2.36 2.8 2.8 0 0 0 1.92 1.19l7.13 1a2.23 2.23 0 0 1 1.75 1.32l3.08 6.78A2.94 2.94 0 0 0 42.39 83a2.88 2.88 0 0 0 2.21-.22l6.3-3.6a2.33 2.33 0 0 1 1.1-.28 2.22 2.22 0 0 1 1.09.29l6.31 3.6a2.72 2.72 0 0 0 2.21.22 2.9 2.9 0 0 0 1.68-1.56l1.06-2.34c-11.71-3.15-32.77-15.67-40-31.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.86 24.58a.77.77 0 0 0 .71-.72 5.56 5.56 0 0 1 5.54-5.53c.53-.18.89-.54.89-.9a.77.77 0 0 0-.71-.71 5.57 5.57 0 0 1-5.54-5.54c-.18-.53-.54-.89-.89-.89s-.9.36-.9.72a5.56 5.56 0 0 1-5.53 5.53 1.2 1.2 0 0 0-.72.89.77.77 0 0 0 .72.72A5.48 5.48 0 0 1 18 23.68a.66.66 0 0 0 .18.54c.18.36.36.36.72.36"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M91.87 83.7a3.69 3.69 0 0 1-3.69-3.7.58.58 0 1 0-1.18 0 3.69 3.69 0 0 1-3.69 3.69.52.52 0 0 0-.59.58.52.52 0 0 0 .59.59A3.79 3.79 0 0 1 86 86a3.84 3.84 0 0 1 1.17 2.72.51.51 0 0 0 .58.58.52.52 0 0 0 .59-.58 3.68 3.68 0 0 1 3.69-3.69.51.51 0 0 0 .58-.58.84.84 0 0 0-.78-.78"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m49.62 59.91-.33-1.74a4.66 4.66 0 0 1-4 2 6.05 6.05 0 0 1-4.7-1.76C39 56.72 38.56 54.6 38.56 52s.34-4.64 2.06-6.36a6.79 6.79 0 0 1 4.7-1.85A6.54 6.54 0 0 1 50 45.62a4.84 4.84 0 0 1 1.45 3.19h-2.94a2.51 2.51 0 0 0-.69-1.45 3.18 3.18 0 0 0-2.52-1 3.7 3.7 0 0 0-2.59 1.07c-1.09 1.14-1.23 3.1-1.23 4.55s.16 3.48 1.25 4.61a3.62 3.62 0 0 0 2.57 1 3.19 3.19 0 0 0 2.36-.92 4 4 0 0 0 1-3.07h-3.74v-2.34h6.55v8.65ZM63.83 58.86a6.6 6.6 0 0 1-4.21 1.07h-6.29V44.1h6.29a6.67 6.67 0 0 1 3.65.87 4.12 4.12 0 0 1 1.83 3.44 3.59 3.59 0 0 1-1.94 3.34 3.87 3.87 0 0 1 2.28 3.57 4.25 4.25 0 0 1-1.61 3.54Zm-4.1-12.28h-3.55v4h3.62c1.29 0 2.38-.47 2.38-2s-1.18-2-2.45-2Zm.09 6.42h-3.64v4.4h3.55c1.34 0 2.79-.49 2.79-2.1s-1.19-2.3-2.7-2.3Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M83 54.92a4.17 4.17 0 0 0 0-5.83l-5.22-5.16a1.34 1.34 0 0 1-.38-1.19l1.33-7.38a4.17 4.17 0 0 0-.67-3.1 3.85 3.85 0 0 0-2.61-1.62l-7.14-1a1.29 1.29 0 0 1-1-.74l-3.08-6.79a3.89 3.89 0 0 0-2.27-2.09 3.71 3.71 0 0 0-3 .29L52.6 24a1.17 1.17 0 0 1-1.2 0l-6.3-3.6a3.75 3.75 0 0 0-3-.29 3.88 3.88 0 0 0-2.28 2.09l-3.08 6.79a1.27 1.27 0 0 1-1 .74l-7.13 1A3.82 3.82 0 0 0 26 32.26a4.2 4.2 0 0 0-.67 3.09l1.33 7.39a1.32 1.32 0 0 1-.39 1.19l-5.22 5.16a4.17 4.17 0 0 0 0 5.83l5.22 5.16a1.34 1.34 0 0 1 .39 1.2l-1.33 7.37a4.25 4.25 0 0 0 .67 3.11 3.81 3.81 0 0 0 2.61 1.61l7.13 1a1.23 1.23 0 0 1 1 .74l3.08 6.78A3.94 3.94 0 0 0 42.06 84a3.68 3.68 0 0 0 1.18.18 3.79 3.79 0 0 0 1.86-.48l6.3-3.6a1.22 1.22 0 0 1 1.2 0l6.32 3.6a3.71 3.71 0 0 0 3 .3 3.91 3.91 0 0 0 2.27-2.1l3.08-6.78a1.24 1.24 0 0 1 1-.74l7.14-1A3.77 3.77 0 0 0 78 71.74a4.15 4.15 0 0 0 .67-3.09l-1.33-7.37a1.36 1.36 0 0 1 .38-1.2Z"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PromoData104 = (PromoData104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/PromoData56.tsx


var PromoData56_excluded = ["className"];
function PromoData56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PromoData56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PromoData56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PromoData56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function PromoData56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PromoData56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", PromoData56_objectSpread(PromoData56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m12.87 25.42-1.43 1.41A1.75 1.75 0 0 0 11 28a1.72 1.72 0 0 0 .49 1.21l2.84 2.81a1.23 1.23 0 0 1 .36 1.13l-.72 4a1.69 1.69 0 0 0 .28 1.28 1.51 1.51 0 0 0 1 .65l3.89.53a1.23 1.23 0 0 1 .95.72l1.67 3.69a1.64 1.64 0 0 0 .93.86 1.59 1.59 0 0 0 1.2-.12l3.43-2a1.32 1.32 0 0 1 .61-.16 1.15 1.15 0 0 1 .59.17l3.44 2a1.48 1.48 0 0 0 1.2.11 1.54 1.54 0 0 0 .92-.85l.58-1.27c-6.38-1.72-17.86-8.54-21.79-17.38"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M9.62 13.7a.42.42 0 0 0 .38-.39 3 3 0 0 1 3-3c.29-.1.48-.29.48-.48a.42.42 0 0 0-.38-.39 3 3 0 0 1-3-3C10 6.2 9.81 6 9.62 6s-.49.2-.49.39a3 3 0 0 1-3 3 .63.63 0 0 0-.38.48.41.41 0 0 0 .38.38 3 3 0 0 1 3 3 .34.34 0 0 0 .1.29c.1.2.19.2.39.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.93 45.53a2 2 0 0 1-2-2 .31.31 0 0 0-.62 0 2 2 0 0 1-2 2 .28.28 0 0 0-.31.31.28.28 0 0 0 .31.32 2.15 2.15 0 0 1 2.09 2.09.28.28 0 0 0 .32.31.28.28 0 0 0 .31-.31 2 2 0 0 1 2-2 .27.27 0 0 0 .31-.31.45.45 0 0 0-.42-.42"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.66 29.57a2.2 2.2 0 0 0 .65-1.57 2.23 2.23 0 0 0-.65-1.57l-2.81-2.77a.74.74 0 0 1-.2-.65l.72-4a2.24 2.24 0 0 0-.37-1.64 2 2 0 0 0-1.4-.87l-3.84-.5a.7.7 0 0 1-.53-.4l-1.65-3.65a2.13 2.13 0 0 0-1.23-1.13 2 2 0 0 0-1.62.16l-3.4 1.94a.7.7 0 0 1-.66 0L24.28 11a2 2 0 0 0-1.63-.16 2.13 2.13 0 0 0-1.23 1.13l-1.65 3.65a.68.68 0 0 1-.53.4l-3.83.52a2 2 0 0 0-1.41.87 2.26 2.26 0 0 0-.36 1.59l.71 4a.71.71 0 0 1-.2.65l-2.81 2.77a2.23 2.23 0 0 0-.65 1.58 2.2 2.2 0 0 0 .65 1.57l2.81 2.78a.71.71 0 0 1 .2.65l-.71 4a2.29 2.29 0 0 0 .36 1.64 2.07 2.07 0 0 0 1.41.87l3.83.52a.68.68 0 0 1 .53.4l1.65 3.65a2.16 2.16 0 0 0 1.23 1.13 2 2 0 0 0 .64.1 2 2 0 0 0 1-.26l3.39-1.94a.65.65 0 0 1 .66 0l3.4 1.94a2 2 0 0 0 1.62.16 2.13 2.13 0 0 0 1.23-1.13l1.65-3.65a.7.7 0 0 1 .53-.4l3.84-.52a2 2 0 0 0 1.4-.88 2.22 2.22 0 0 0 .36-1.63l-.72-4a.74.74 0 0 1 .2-.65Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m26.72 32.26-.18-.94a2.53 2.53 0 0 1-2.14 1.1 3.29 3.29 0 0 1-2.53-1 4.63 4.63 0 0 1-1.1-3.42 4.41 4.41 0 0 1 1.1-3.42 3.66 3.66 0 0 1 2.53-1 3.53 3.53 0 0 1 2.52 1 2.61 2.61 0 0 1 .78 1.72h-1.58a1.36 1.36 0 0 0-.37-.78 1.71 1.71 0 0 0-1.36-.52 2 2 0 0 0-1.39.58 3.61 3.61 0 0 0-.66 2.42 3.7 3.7 0 0 0 .66 2.49 2 2 0 0 0 1.38.54 1.7 1.7 0 0 0 1.27-.49 2.17 2.17 0 0 0 .56-1.65h-2V27.6h3.53v4.66ZM34.37 31.69a3.53 3.53 0 0 1-2.27.58h-3.38v-8.52h3.38a3.53 3.53 0 0 1 2 .47 2.19 2.19 0 0 1 1 1.84 2 2 0 0 1-1 1.81 2.07 2.07 0 0 1 1.22 1.92 2.27 2.27 0 0 1-.95 1.9Zm-2.21-6.61h-1.91v2.14h2c.69 0 1.28-.25 1.28-1.06s-.67-1.08-1.37-1.08Zm.05 3.43h-2v2.37h1.91c.72 0 1.5-.27 1.5-1.13s-.62-1.24-1.41-1.24Z"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PromoData56 = (PromoData56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/PromoDiscount104.tsx


var PromoDiscount104_excluded = ["className"];
function PromoDiscount104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PromoDiscount104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PromoDiscount104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PromoDiscount104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function PromoDiscount104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PromoDiscount104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", PromoDiscount104_objectSpread(PromoDiscount104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.86 24.58a.77.77 0 0 0 .71-.72 5.56 5.56 0 0 1 5.54-5.53c.53-.18.89-.54.89-.9a.77.77 0 0 0-.71-.71 5.57 5.57 0 0 1-5.54-5.54c-.18-.53-.54-.89-.89-.89s-.9.36-.9.72a5.56 5.56 0 0 1-5.53 5.53 1.2 1.2 0 0 0-.72.89.77.77 0 0 0 .72.72A5.48 5.48 0 0 1 18 23.68a.66.66 0 0 0 .18.54c.18.36.36.36.72.36"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M91.87 83.7a3.69 3.69 0 0 1-3.69-3.7.58.58 0 1 0-1.18 0 3.69 3.69 0 0 1-3.69 3.69.52.52 0 0 0-.59.58.52.52 0 0 0 .59.59A3.79 3.79 0 0 1 86 86a3.84 3.84 0 0 1 1.17 2.72.51.51 0 0 0 .58.58.52.52 0 0 0 .59-.58 3.68 3.68 0 0 1 3.69-3.69.51.51 0 0 0 .58-.58.84.84 0 0 0-.78-.78"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m24.38 47.21-2.63 2.59a3.17 3.17 0 0 0-.89 2.2 3.13 3.13 0 0 0 .9 2.2L27 59.37a2.34 2.34 0 0 1 .66 2.08l-1.32 7.38a3.2 3.2 0 0 0 .5 2.36 2.8 2.8 0 0 0 1.92 1.19l7.13 1a2.23 2.23 0 0 1 1.75 1.32l3.08 6.78A2.94 2.94 0 0 0 42.39 83a2.88 2.88 0 0 0 2.21-.22l6.3-3.6a2.33 2.33 0 0 1 1.1-.28 2.22 2.22 0 0 1 1.09.29l6.31 3.6a2.72 2.72 0 0 0 2.21.22 2.9 2.9 0 0 0 1.68-1.56l1.06-2.34c-11.71-3.15-32.77-15.67-40-31.9"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M83 54.92a4.17 4.17 0 0 0 0-5.83l-5.22-5.16a1.34 1.34 0 0 1-.38-1.19l1.33-7.38a4.17 4.17 0 0 0-.67-3.1 3.85 3.85 0 0 0-2.61-1.62l-7.14-1a1.29 1.29 0 0 1-1-.74l-3.08-6.79a3.89 3.89 0 0 0-2.27-2.09 3.71 3.71 0 0 0-3 .29L52.6 24a1.17 1.17 0 0 1-1.2 0l-6.3-3.6a3.75 3.75 0 0 0-3-.29 3.88 3.88 0 0 0-2.28 2.09l-3.08 6.79a1.27 1.27 0 0 1-1 .74l-7.13 1A3.82 3.82 0 0 0 26 32.26a4.2 4.2 0 0 0-.67 3.09l1.33 7.39a1.32 1.32 0 0 1-.39 1.19l-5.22 5.16a4.17 4.17 0 0 0 0 5.83l5.22 5.16a1.34 1.34 0 0 1 .39 1.2l-1.33 7.37a4.25 4.25 0 0 0 .67 3.11 3.81 3.81 0 0 0 2.61 1.61l7.13 1a1.23 1.23 0 0 1 1 .74l3.08 6.78A3.94 3.94 0 0 0 42.06 84a3.68 3.68 0 0 0 1.18.18 3.79 3.79 0 0 0 1.86-.48l6.3-3.6a1.22 1.22 0 0 1 1.2 0l6.32 3.6a3.71 3.71 0 0 0 3 .3 3.91 3.91 0 0 0 2.27-2.1l3.08-6.78a1.24 1.24 0 0 1 1-.74l7.14-1A3.77 3.77 0 0 0 78 71.74a4.15 4.15 0 0 0 .67-3.09l-1.33-7.37a1.36 1.36 0 0 1 .38-1.2Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.75 56.67c0 2.57 2.35 4.66 5.25 4.66s5.25-2.09 5.25-4.66S54.89 52 52 52s-5.25-2.09-5.25-4.66 2.35-4.65 5.25-4.65 5.25 2.08 5.25 4.66M52 39.01v3.68M52 61.33v3.68"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PromoDiscount104 = (PromoDiscount104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/PromoDiscount56.tsx


var PromoDiscount56_excluded = ["className"];
function PromoDiscount56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PromoDiscount56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PromoDiscount56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PromoDiscount56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function PromoDiscount56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PromoDiscount56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", PromoDiscount56_objectSpread(PromoDiscount56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m12.87 25.42-1.43 1.41A1.75 1.75 0 0 0 11 28a1.72 1.72 0 0 0 .49 1.21l2.84 2.81a1.23 1.23 0 0 1 .36 1.13l-.72 4a1.69 1.69 0 0 0 .28 1.28 1.51 1.51 0 0 0 1 .65l3.89.53a1.23 1.23 0 0 1 .95.72l1.67 3.69a1.64 1.64 0 0 0 .93.86 1.59 1.59 0 0 0 1.2-.12l3.43-2a1.32 1.32 0 0 1 .61-.16 1.15 1.15 0 0 1 .59.17l3.44 2a1.48 1.48 0 0 0 1.2.11 1.54 1.54 0 0 0 .92-.85l.58-1.27c-6.38-1.72-17.86-8.54-21.79-17.38"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M9.62 13.7a.42.42 0 0 0 .38-.39 3 3 0 0 1 3-3c.29-.1.48-.29.48-.48a.42.42 0 0 0-.38-.39 3 3 0 0 1-3-3C10 6.2 9.81 6 9.62 6s-.49.2-.49.39a3 3 0 0 1-3 3 .63.63 0 0 0-.38.48.41.41 0 0 0 .38.38 3 3 0 0 1 3 3 .34.34 0 0 0 .1.29c.1.2.19.2.39.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.93 45.53a2 2 0 0 1-2-2 .31.31 0 0 0-.62 0 2 2 0 0 1-2 2 .28.28 0 0 0-.31.31.28.28 0 0 0 .31.32 2.15 2.15 0 0 1 2.09 2.09.28.28 0 0 0 .32.31.28.28 0 0 0 .31-.31 2 2 0 0 1 2-2 .27.27 0 0 0 .31-.31.45.45 0 0 0-.42-.42"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.66 29.57a2.2 2.2 0 0 0 .65-1.57 2.23 2.23 0 0 0-.65-1.57l-2.81-2.77a.74.74 0 0 1-.2-.65l.72-4a2.24 2.24 0 0 0-.37-1.64 2 2 0 0 0-1.4-.87l-3.84-.5a.7.7 0 0 1-.53-.4l-1.65-3.65a2.13 2.13 0 0 0-1.23-1.13 2 2 0 0 0-1.62.16l-3.4 1.94a.68.68 0 0 1-.65 0L24.28 11a2 2 0 0 0-1.63-.16 2.13 2.13 0 0 0-1.23 1.13l-1.65 3.65a.68.68 0 0 1-.53.4l-3.83.52a2 2 0 0 0-1.41.87 2.26 2.26 0 0 0-.36 1.59l.71 4a.71.71 0 0 1-.2.65l-2.81 2.77a2.23 2.23 0 0 0-.65 1.58 2.2 2.2 0 0 0 .65 1.57l2.81 2.78a.71.71 0 0 1 .2.65l-.71 4a2.29 2.29 0 0 0 .36 1.64 2.07 2.07 0 0 0 1.41.87l3.83.52a.68.68 0 0 1 .53.4l1.65 3.65a2.16 2.16 0 0 0 1.23 1.13 2 2 0 0 0 .64.1 2 2 0 0 0 1-.26l3.4-1.94a.63.63 0 0 1 .65 0l3.4 1.94a2 2 0 0 0 1.62.16 2.13 2.13 0 0 0 1.23-1.13l1.65-3.65a.7.7 0 0 1 .53-.4l3.84-.52a2 2 0 0 0 1.4-.88 2.22 2.22 0 0 0 .36-1.63l-.72-4a.74.74 0 0 1 .2-.65Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M25.18 30.51A2.67 2.67 0 0 0 28 33a2.67 2.67 0 0 0 2.82-2.51A2.68 2.68 0 0 0 28 28a2.67 2.67 0 0 1-2.82-2.51A2.68 2.68 0 0 1 28 23a2.68 2.68 0 0 1 2.82 2.51M28 21v1.98M28 33.02V35"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PromoDiscount56 = (PromoDiscount56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/RecurringPayment104.tsx


var RecurringPayment104_excluded = ["className"];
function RecurringPayment104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function RecurringPayment104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? RecurringPayment104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RecurringPayment104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function RecurringPayment104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, RecurringPayment104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", RecurringPayment104_objectSpread(RecurringPayment104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m44.2 54.22 5 7s1.31-.56.37-3.67a1.07 1.07 0 0 1 .66-1.41c1.41-.38 4.86-.46 12.18-.68 0 0 2.78-.07 2.77-1.13ZM60.39 74l-5 7s-1.31-.57-.37-3.67a1.07 1.07 0 0 0-.66-1.41c-1.42-.39-4.86-.47-12.19-.69 0 0-2.77-.06-2.76-1.12Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m87.63 18.14-2.43-1h-9.08v1.21c0 2.33-1.18 4.24-2.64 4.24s-2.63-1.91-2.63-4.24v-1.17h-5.47v1.21c0 2.33-1.19 4.24-2.64 4.24s-2.64-1.91-2.64-4.24v-1.21h-5.46v1.21c0 2.33-1.19 4.24-2.64 4.24s-2.64-1.91-2.64-4.24v-1.21H43.9v1.21c0 2.33-1.19 4.24-2.64 4.24s-2.64-1.91-2.64-4.24v-1.21h-5.47v1.21c0 2.33-1.18 4.24-2.63 4.24s-2.64-1.91-2.64-4.24v-1.21h-9.46l-2.15 1.1L15 20.51V37.8h74V20.41Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M15 30.94h74"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M15 38.15h74"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M76.48 17.18h6.69A5.86 5.86 0 0 1 89 23.05v53.59"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M65.38 17.18h5.44"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M54.93 17.18h5.17"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44 17.18h5.33"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.15 17.18h5.47"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M73.06 92H20.83A5.86 5.86 0 0 1 15 86.13V23.05a5.86 5.86 0 0 1 5.83-5.87h6.74"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.15 18.39c0 2.33-1.18 4.24-2.63 4.24s-2.64-1.91-2.64-4.24v-2.14c0-2.34 1.18-4.25 2.64-4.25s2.63 1.91 2.63 4.25Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.9 18.39c0 2.33-1.19 4.24-2.64 4.24s-2.64-1.91-2.64-4.24v-2.14c0-2.34 1.19-4.25 2.64-4.25s2.64 1.91 2.64 4.25Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M54.64 18.39c0 2.33-1.19 4.24-2.64 4.24s-2.64-1.91-2.64-4.24v-2.14c0-2.34 1.19-4.25 2.64-4.25s2.64 1.91 2.64 4.25Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M65.38 18.39c0 2.33-1.19 4.24-2.64 4.24s-2.64-1.91-2.64-4.24v-2.14c0-2.34 1.19-4.25 2.64-4.25s2.64 1.91 2.64 4.25Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M76.12 18.39c0 2.33-1.18 4.24-2.64 4.24s-2.63-1.91-2.63-4.24v-2.14c0-2.34 1.15-4.25 2.63-4.25s2.64 1.91 2.64 4.25Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M73.06 92 89 76.64h-7.09a8.88 8.88 0 0 0-8.85 8.9V92Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M65 73.13c4.47 0 5.1-3.23 5.1-7.21v-5.05c0-4-.63-7.21-5.11-7.21H43.37"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m48.77 46.45-5.4 7.21 5.4 7.21M39.05 53.66c-4.48 0-5.11 3.23-5.11 7.21v5.05c0 4 .62 7.21 5.1 7.21h21.62"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m55.25 80.34 5.41-7.21-5.41-7.21"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_RecurringPayment104 = (RecurringPayment104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/RecurringPayment56.tsx


var RecurringPayment56_excluded = ["className"];
function RecurringPayment56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function RecurringPayment56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? RecurringPayment56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RecurringPayment56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function RecurringPayment56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, RecurringPayment56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", RecurringPayment56_objectSpread(RecurringPayment56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m19.07 17.42 5.53 7.84s1.45-.63.41-4.12a1.21 1.21 0 0 1 .73-1.58c1.56-.43 5.38-.52 13.48-.77 0 0 3.07-.07 3.06-1.26ZM37.27 39l-5.53 7.8s-1.46-.63-.41-4.11a1.21 1.21 0 0 0-.73-1.58c-1.57-.43-5.39-.52-13.49-.77 0 0-3.06-.07-3.06-1.26Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42.34 38.91c5 0 5.65-3.62 5.65-8.08v-5.66c0-4.46-.7-8.08-5.65-8.08h-23.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m24.41 9-5.97 8.09 5.97 8.08M13.66 17.09c-5 0-5.65 3.62-5.65 8.08v5.66c0 4.46.7 8.08 5.65 8.08h23.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m31.59 47 5.97-8.09-5.97-8.08"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_RecurringPayment56 = (RecurringPayment56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Shop104.tsx


var Shop104_excluded = ["className"];
function Shop104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Shop104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Shop104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Shop104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Shop104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Shop104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Shop104_objectSpread(Shop104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.41 32.16c-4.08-1.47-10.14-4.24-11.22-8l3.4 9.66 7.33-.29ZM32.56 51.58c-.14 1 3.56 1.09 3.36 1.08l1.47-5v3.35a3.79 3.79 0 0 1-3.61 3.94 3.81 3.81 0 0 1-3.6-4v-3.44l.08-10.25c0-1 0-2.56.16-3.49l2.14.19-.34 2ZM66.1 51.58c-.14 1 3.56 1.09 3.35 1.08l1.48-5v3.35a3.62 3.62 0 1 1-7.21 0v-3.44l.08-10.25c0-1 .05-2.56.15-3.49l2.15.19-.34 2ZM54.89 91.88H30.82a8.72 8.72 0 0 1-8.71-8.72v-30.5c9.99 8.98 18.57 35.71 32.78 39.22Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m46.64 23.52 1.37 4.79M25.56 33.81l-2.42-8.44a2.58 2.58 0 0 1 1.77-3.19l17.24-4.95a2.59 2.59 0 0 1 2.72.86 2.75 2.75 0 0 1 .19.28M31.72 24.67l5.98-1.72M47.36 33.69l1.69-10.83M49.94 17.13l.44-2.82a2.6 2.6 0 0 1 3-2.16l27.19 4.25a2.58 2.58 0 0 1 2.15 3l-2.26 14.48M61.69 18.12l9.11 1.42"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M70.71 33.88h9.74a1.76 1.76 0 0 1 1.8 1.71v44.35c0 6.59-5.63 11.94-12.58 11.94H33.79c-6.95 0-12.57-5.35-12.57-11.94V35.59A1.75 1.75 0 0 1 23 33.88h9.91M37.92 33.88h27.64"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.42 50.82v-3l.08-9.7c.07-11.73 8.77-20.89 19.39-20.81s19.22 9.34 19.14 21.06L71 47.82v3a2.39 2.39 0 1 1-4.77 0v-3l.07-9.1c0-9.41-6.42-16.81-14.41-16.86s-14.56 7.24-14.6 16.65l-.07 9.31v3a2.38 2.38 0 1 1-4.76 0"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Shop104 = (Shop104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Shop56.tsx


var Shop56_excluded = ["className"];
function Shop56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Shop56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Shop56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Shop56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Shop56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Shop56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Shop56_objectSpread(Shop56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.8 49.09H16a5 5 0 0 1-5-5V26.6c5.73 5.15 10.65 20.48 18.8 22.49Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.21 15.82h6.25a1 1 0 0 1 1 1v25.42a7 7 0 0 1-7.21 6.85H17.7a7 7 0 0 1-7.21-6.85V16.8a1 1 0 0 1 1-1h6.24M20.58 15.82H35.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M17.76 24.24V17.51c0-6.2 4.64-11 10.26-11s10.17 4.94 10.13 11.15v6.59a1.26 1.26 0 0 1-2.52 0v-6.43c0-5-3.39-8.9-7.63-8.93s-7.7 3.83-7.72 8.82v6.52a1.26 1.26 0 0 1-2.52 0"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Shop56 = (Shop56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/TrackOrder104.tsx


var TrackOrder104_excluded = ["className"];
function TrackOrder104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function TrackOrder104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TrackOrder104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TrackOrder104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function TrackOrder104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TrackOrder104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", TrackOrder104_objectSpread(TrackOrder104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.32 42.44H18.86c-5.11 0-9.25 4.61-9.25 10.3 0 5.68 4.14 10.26 9.25 10.26h64a10.09 10.09 0 0 1 10 10.16 10.09 10.09 0 0 1-10 10.16H48",
        className: "shadeinverted"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M81.8 47.2c-3.28-4.26-8.87-8.9-11.4-14.45a19.64 19.64 0 0 1 2.06-20.41c-2.84.72-10.74 6-8.71 16.33s14.41 23.1 14.41 23.1ZM10.75 82.78v9.36A1.85 1.85 0 0 0 12.6 94h11.2a1.37 1.37 0 0 0 .72-2.53C21 89.27 16.09 85.82 13.19 82a1.36 1.36 0 0 0-2.44.78ZM30.66 75.89a2.05 2.05 0 0 1-.49-.06l-4.31-1.1-4.32 1.1a1.94 1.94 0 0 1-1.66-.35 1.83 1.83 0 0 1-.72-1.48v-5.56a1 1 0 0 1 2 0v5.45l4.45-1.16a1 1 0 0 1 .49 0l4.47 1.13a1 1 0 0 1 2 .15 1.84 1.84 0 0 1-.73 1.47 1.87 1.87 0 0 1-1.18.41Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M62.49 41H19.85c-5.13 0-9.29 4.6-9.29 10.27 0 5.68 4.16 10.28 9.29 10.28h64.24a10.11 10.11 0 0 1 10.07 10.17 10.11 10.11 0 0 1-10.07 10.14H49.14"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M76.51 50.43a1.8 1.8 0 0 0 3.26 0L90.33 34A14.69 14.69 0 1 0 66 34Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M84.47 25.76a6.3 6.3 0 1 1-6.3-6.3 6.3 6.3 0 0 1 6.3 6.3Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32 67.44V73a.88.88 0 0 1-1.1.85l-4.37-1.15-4.4 1.16A.88.88 0 0 1 21 73v-5.56"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "13.36",
          y: "65.1",
          width: "26.34",
          height: "31.02",
          rx: "1",
          transform: "rotate(90 26.535 80.615)"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TrackOrder104 = (TrackOrder104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/TrackOrder56.tsx


var TrackOrder56_excluded = ["className"];
function TrackOrder56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function TrackOrder56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TrackOrder56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TrackOrder56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function TrackOrder56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TrackOrder56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", TrackOrder56_objectSpread(TrackOrder56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36.12 21a9.17 9.17 0 0 1-1.29-4.75 8.42 8.42 0 0 1 5.26-8.09 7.48 7.48 0 0 0-5.77 11.67l5.37 8.4a1 1 0 0 0 .81.53Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.16 26.65H12.09a4.8 4.8 0 0 0-4.56 5 4.8 4.8 0 0 0 4.56 5h31.49a4.94 4.94 0 0 1 4.94 4.93 4.94 4.94 0 0 1-4.94 4.94h-27"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.69 28.25a.93.93 0 0 0 .83.53 1 1 0 0 0 .84-.53l5.38-8.4a7.42 7.42 0 0 0 1.26-4.2 7.5 7.5 0 1 0-13.71 4.2Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.75 15.65a3.21 3.21 0 1 1-3.21-3.21 3.22 3.22 0 0 1 3.21 3.21Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m12.63 46.52 1-1a.76.76 0 0 0-1.07-1.07l-1 1-1-1a.75.75 0 0 0-1.08 1.05l1 1-1 1a.75.75 0 1 0 1.06 1.07l1-1 1 1a.76.76 0 1 0 1.07-1.07Z",
        className: "strokeinverted"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TrackOrder56 = (TrackOrder56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Chat104.tsx


var Chat104_excluded = ["className"];
function Chat104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Chat104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Chat104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Chat104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Chat104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Chat104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Chat104_objectSpread(Chat104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11 32.38v24.74A12.38 12.38 0 0 0 23.38 69.5V86l24.74-16.5S11 68.67 11 32.38",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M81.12 20H23.38A12.38 12.38 0 0 0 11 32.38v24.74A12.38 12.38 0 0 0 23.38 69.5V86l24.74-16.5h33A12.38 12.38 0 0 0 93.5 57.12V32.38A12.38 12.38 0 0 0 81.12 20Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40.66 44.5a5.16 5.16 0 1 1-5.16-5.16 5.16 5.16 0 0 1 5.16 5.16Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M57.16 44.5A5.16 5.16 0 1 1 52 39.34a5.16 5.16 0 0 1 5.16 5.16Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M73.66 44.5a5.16 5.16 0 1 1-5.16-5.16 5.16 5.16 0 0 1 5.16 5.16Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Chat104 = (Chat104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Chat56.tsx


var Chat56_excluded = ["className"];
function Chat56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Chat56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Chat56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Chat56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Chat56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Chat56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Chat56_objectSpread(Chat56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6 18.6v13.2a6.61 6.61 0 0 0 6.6 6.6v8.8l13.2-8.8S6 38 6 18.6",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.4 12H12.6A6.61 6.61 0 0 0 6 18.6v13.2a6.61 6.61 0 0 0 6.6 6.6v8.8l13.2-8.8h17.6a6.61 6.61 0 0 0 6.6-6.6V18.6a6.61 6.61 0 0 0-6.6-6.6Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22 25a2.75 2.75 0 1 1-2.75-2.75A2.75 2.75 0 0 1 22 25Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.75 25A2.75 2.75 0 1 1 28 22.25 2.75 2.75 0 0 1 30.75 25Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.55 25a2.75 2.75 0 1 1-2.75-2.75A2.75 2.75 0 0 1 39.55 25Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Chat56 = (Chat56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Disruptions104.tsx


var Disruptions104_excluded = ["className"];
function Disruptions104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Disruptions104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Disruptions104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Disruptions104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Disruptions104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Disruptions104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Disruptions104_objectSpread(Disruptions104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.83 57.59S24.21 88.17 53 87.79c1.69.64-44-.38-44-.38ZM50.71 42.52l-4.84 15.57a1.18 1.18 0 0 0 1.13 1.5h5.79A1.18 1.18 0 0 1 54 61.06l-4.39 17 .84-16-8.56.19 5.94-19.56Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m59.76 43.57-4.37 11.67h5.86a1.2 1.2 0 0 1 .81 1.87L50.49 78.19c-.62 1-2 .35-1.81-.88L50.4 62h-7.55a1.16 1.16 0 0 1-.94-1.6l5.87-17.77a1 1 0 0 1 .94-.75h10.12a1.18 1.18 0 0 1 .92 1.69Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m8 88.32 44.45-73.7L96 88.32H8z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Disruptions104 = (Disruptions104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Disruptions56.tsx


var Disruptions56_excluded = ["className"];
function Disruptions56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Disruptions56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Disruptions56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Disruptions56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Disruptions56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Disruptions56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Disruptions56_objectSpread(Disruptions56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m26.47 8-5.55 17.27a1.33 1.33 0 0 0 1.31 1.67h6.63a1.32 1.32 0 0 1 1.32 1.66l-5.77 18.52 1.71-17.46-9.81.2 6.8-21.69Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m36.83 9.8-5 12.73h6.7a1.31 1.31 0 0 1 .94 2l-13.25 23a1.16 1.16 0 0 1-2.08-1l2-16.66h-8.67a1.27 1.27 0 0 1-1.08-1.75l6.72-19.3A1.17 1.17 0 0 1 24.19 8h11.58a1.27 1.27 0 0 1 1.06 1.8Z",
        className: "stroke"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Disruptions56 = (Disruptions56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Mail104.tsx


var Mail104_excluded = ["className"];
function Mail104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Mail104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Mail104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Mail104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Mail104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Mail104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Mail104_objectSpread(Mail104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.24 74.87c-2.37-1.37-3.31.31-1.83 1.29 1.27.85 4.15 2.81 4 4.58-.19 2.26-4.93 1.89-6.4 2.07-.44 0-.92.2-1 .68-.31 1.13 1.31 1 2 1h14.86a7.34 7.34 0 0 0 3.52-1l-4-2.57s-8.78-4.68-11.15-6.05ZM20.63 44.68v-8.9l-5.68 5.24 5.68 3.66zM83.82 35.78v8.9l5.67-3.66-5.67-5.24zM48.75 61l1.13.65a4.25 4.25 0 0 0 4.25 0l28-16.15Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m83.38 35.63 4.83 4.11A4.25 4.25 0 0 1 89.7 43v37.41a4.24 4.24 0 0 1-4.24 4.25H18.54a4.24 4.24 0 0 1-4.24-4.25V43a4.25 4.25 0 0 1 1.54-3.28l4.78-4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m14.69 41.24 35.18 20.37a4.26 4.26 0 0 0 4.26 0l35.2-20.38"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m15.43 83.29 15.88-8.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m72.65 74.35 15.92 8.95"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.93 31h6.2a4.25 4.25 0 0 1 4.25 4.25v9.46l-29.25 16.9a4.26 4.26 0 0 1-4.26 0L20.62 44.68v-9.46A4.25 4.25 0 0 1 24.87 31h6.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.93 31h6.2a4.25 4.25 0 0 1 4.25 4.25v9.46l-29.25 16.9a4.26 4.26 0 0 1-4.26 0L20.62 44.68v-9.46A4.25 4.25 0 0 1 24.87 31h6.2"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.93 29.06c-2.82 0-3.72 3-3.72 5.34 0 2.15.74 4.62 3.33 4.62 3.1 0 3.92-2.86 3.92-5.45 0-2.35-.82-4.51-3.53-4.51M59.58 42c-2 0-3.57-.94-3.84-3A5.27 5.27 0 0 1 51 41.89c-4 0-6.16-3.22-6.16-7.49s2.55-8 7.22-8a4.41 4.41 0 0 1 3.76 2.08l.27-1a.86.86 0 0 1 .82-.63H58a.85.85 0 0 1 .85.91l-.64 9c-.08 1.18.12 2.47 1.61 2.47 3.41 0 4.51-5.1 4.51-7.73A10 10 0 0 0 61.5 24a11.94 11.94 0 0 0-8.63-3.14A13 13 0 0 0 44 24.08c-2.67 2.35-4.16 5.84-4.16 10.16a13 13 0 0 0 3.49 9.14 11.6 11.6 0 0 0 8.51 3.37 23.94 23.94 0 0 0 8.7-1.42.85.85 0 0 1 1.15.79v1.07a.84.84 0 0 1-.49.77 22.47 22.47 0 0 1-9.4 1.74 15.14 15.14 0 0 1-10.47-3.77 16 16 0 0 1-4.82-12 15.27 15.27 0 0 1 4.55-11.42A16.66 16.66 0 0 1 52.83 18a15.44 15.44 0 0 1 11 4.08 12.63 12.63 0 0 1 3.65 9.34c0 4.74-2.2 10.55-7.93 10.55"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Mail104 = (Mail104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Mail56.tsx


var Mail56_excluded = ["className"];
function Mail56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Mail56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Mail56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Mail56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Mail56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Mail56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Mail56_objectSpread(Mail56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M6.5 19.54v4.38c0-1.78 1.13-4.14 3.62-3s12.75 6.77 13.53 7.29 3.4 1.37 4.27.2q-2.54-1.59-20-11.13C7 17.26 6.5 18 6.5 19.54ZM49.49 39.52c-1.12-.45-14.07-7.39-14.72-7.39s-.88.65-.59.91 6 3.43 7.15 4.13 1 2.35-.49 2.35-2.77 0-2.77.71 9 .29 9.85.29 2.68-.52 1.57-1Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M9.06 16.37h38.88a2.5 2.5 0 0 1 2.56 2.44v19.12a2.5 2.5 0 0 1-2.56 2.44H9.06a2.5 2.5 0 0 1-2.56-2.44V18.81a2.5 2.5 0 0 1 2.56-2.44Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M8.23 17.37 27.79 28a1.81 1.81 0 0 0 1.72 0l19.26-10.63"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m33.15 31.37 16.25 8.21"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.85 31.37 7.6 39.58"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Mail56 = (Mail56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/NotificationCall104.tsx


var NotificationCall104_excluded = ["className"];
function NotificationCall104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function NotificationCall104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NotificationCall104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NotificationCall104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function NotificationCall104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NotificationCall104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", NotificationCall104_objectSpread(NotificationCall104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.2 32.9c1.89 2.17-.32 16.35 3.54 21.91 3.12 4.49 8.86 3.65 9.8 5.66s-6.1 1.36-7.47.41-8-5.71-9-16.81 1.73-13 3.17-11.17"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.53 77.68c-1.33-2.57-3.87-4.19-5.37-6.66-6.56-10.36-2-22.85 2.05-33.24 1-2.63 1.75-4.23-.89-6.05l-.12.21-18 31.25a6.19 6.19 0 0 0 2.26 8.44l20.06 11.61a5.5 5.5 0 0 0 .01-5.56Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.07 60.88c-2.56-1.47-6-4.92-8.19-13.09-4.09-15.26 3.68-18.73 4-18.87l2.3-.61a3.14 3.14 0 0 1 3.72 2.14l1.26 4.7a3 3 0 0 1-2.11 3.71l-2.14.62a27.61 27.61 0 0 0 .84 5.85l.18.67a26.24 26.24 0 0 0 2.19 5.48l2.11-.56a3.16 3.16 0 0 1 3.72 2.14l1.26 4.71a3.11 3.11 0 0 1-.3 2.34A3.23 3.23 0 0 1 50 61.55s-4.42.77-6.92-.67Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "23.7",
          y: "13.91",
          width: "37.58",
          height: "68.62",
          rx: "6",
          transform: "rotate(30 42.485 48.236)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m54.99 16.77 8.49 4.9M19.84 71.94l13.44 7.76"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M60.32 88.36A34.91 34.91 0 0 0 86 46.18"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M57.32 76a22.21 22.21 0 0 0 16.34-26.81"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M63.32 100.69a47.61 47.61 0 0 0 35-57.51"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NotificationCall104 = (NotificationCall104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/NotificationCall56.tsx


var NotificationCall56_excluded = ["className"];
function NotificationCall56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function NotificationCall56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NotificationCall56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NotificationCall56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function NotificationCall56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NotificationCall56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", NotificationCall56_objectSpread(NotificationCall56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.29 14.22c-.9 1.78-10.56 4-13.12 8-2.06 3.17 0 6.63-1.08 7.75s-2.46-3.55-2.21-4.68 1.58-6.63 8.43-10.15 8.78-2.27 8-.87"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.91 42.06a16.94 16.94 0 0 0 20.75-12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20.51 36.11a10.78 10.78 0 0 0 13.2-7.62"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M17.32 48a23.09 23.09 0 0 0 28.29-16.32"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M9.89 25.24c.28-2 1.59-5.12 6.26-8.64 8.72-6.58 13-2.51 13.13-2.34l1 1.32a2.17 2.17 0 0 1-.41 2.93l-2.69 2a2.08 2.08 0 0 1-2.92-.39l-1-1.21A19.63 19.63 0 0 0 19.75 21l-.38.29a18 18 0 0 0-2.95 2.83l.91 1.2a2.18 2.18 0 0 1-.4 2.94l-2.69 2a2.14 2.14 0 0 1-1.58.42 2.22 2.22 0 0 1-1.41-.84s-1.64-2.63-1.37-4.61Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NotificationCall56 = (NotificationCall56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/NotificationEmail104.tsx


var NotificationEmail104_excluded = ["className"];
function NotificationEmail104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function NotificationEmail104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NotificationEmail104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NotificationEmail104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function NotificationEmail104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NotificationEmail104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", NotificationEmail104_objectSpread(NotificationEmail104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.53 77.68c-1.33-2.57-3.87-4.19-5.37-6.66-6.56-10.36-2-22.85 2.05-33.24 1-2.63 1.75-4.23-.89-6.05l-.12.21-18 31.25a6.19 6.19 0 0 0 2.26 8.44l20.06 11.61a5.5 5.5 0 0 0 .01-5.56ZM36.35 35.21l-1.26 2.18c.51-.88 1.75-1.74 2.65-.43s4.4 7 4.64 7.52 1.3 1.65 2.07 1.32q-.81-1.52-6.76-11.29c-.45-.3-.9-.07-1.34.7ZM52 57.51c-.43-.54-4.88-7.72-5.21-7.91s-.62.08-.55.29 2 3.42 2.37 4.11-.2 1.44-.92 1-1.38-.78-1.58-.44 4.38 2.72 4.82 3 1.5.5 1.07-.05Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "23.7",
          y: "13.91",
          width: "37.58",
          height: "68.62",
          rx: "6",
          transform: "rotate(30 42.485 48.236)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m54.99 16.77 8.49 4.9M19.84 71.94l13.44 7.76"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M60.32 88.36A34.91 34.91 0 0 0 86 46.18"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M57.32 76a22.21 22.21 0 0 0 16.34-26.81"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M63.32 100.69a47.61 47.61 0 0 0 35-57.51"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.63 34.3 57 45.47a1.45 1.45 0 0 1 .58 2L52.06 57a1.44 1.44 0 0 1-2 .47L30.73 46.25a1.44 1.44 0 0 1-.58-2l5.5-9.52a1.44 1.44 0 0 1 1.98-.43Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m36.92 34.56 6.68 10.93a1.06 1.06 0 0 0 .86.49l12.65.23"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m45.31 48.69 5.73 8.76"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m40.67 46.02-10.44-.59"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NotificationEmail104 = (NotificationEmail104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/NotificationEmail56.tsx


var NotificationEmail56_excluded = ["className"];
function NotificationEmail56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function NotificationEmail56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NotificationEmail56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NotificationEmail56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function NotificationEmail56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NotificationEmail56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", NotificationEmail56_objectSpread(NotificationEmail56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m7.72 21.4 1.08 2.17c-.44-.88-.47-2.33 1.06-2.36s8 .2 8.51.26 2-.16 2.17-1q-1.66-.12-12.67-.47c-.48.15-.54.64-.15 1.4ZM34 20.65c-.67.06-8.8-.18-9.12 0s-.27.54-.07.6 3.81.21 4.57.27 1.05.93.33 1.28-1.36.7-1.19 1 4.52-2.08 4.95-2.29 1.15-.91.53-.86Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.91 42.06a16.94 16.94 0 0 0 20.75-12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20.51 36.11a10.78 10.78 0 0 0 13.2-7.62"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M17.32 48a23.09 23.09 0 0 0 28.29-16.32"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m8.2 19.2 19.26-9.63a1.39 1.39 0 0 1 1.87.57l4.74 9.48a1.39 1.39 0 0 1-.67 1.84l-19.26 9.63a1.38 1.38 0 0 1-1.87-.58L7.54 21a1.38 1.38 0 0 1 .66-1.8Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m8 19.9 12.33.43a1 1 0 0 0 .85-.42l6.91-10"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m23.85 20.66 10.08.04"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m19.24 22.97-6.02 8.09"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NotificationEmail56 = (NotificationEmail56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/NotificationMessage104.tsx


var NotificationMessage104_excluded = ["className"];
function NotificationMessage104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function NotificationMessage104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NotificationMessage104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NotificationMessage104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function NotificationMessage104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NotificationMessage104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", NotificationMessage104_objectSpread(NotificationMessage104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.53 77.68c-1.33-2.57-3.87-4.19-5.37-6.66-6.56-10.36-2-22.85 2.05-33.24 1-2.63 1.75-4.23-.89-6.05l-.12.21-18 31.25a6.19 6.19 0 0 0 2.26 8.44l20.06 11.61a5.5 5.5 0 0 0 .01-5.56Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m33.66 34.59-4.18 7.24a4.17 4.17 0 0 0 1.52 5.7l-2.79 4.83 10-.65s-10.68-6.51-4.55-17.12"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "23.7",
          y: "13.91",
          width: "37.58",
          height: "68.62",
          rx: "6",
          transform: "rotate(30 42.485 48.236)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m54.99 16.77 8.49 4.9M19.84 71.94l13.44 7.76"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M60.32 88.36A34.91 34.91 0 0 0 86 46.18"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M57.32 76a22.21 22.21 0 0 0 16.34-26.81"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M63.32 100.69a47.61 47.61 0 0 0 35-57.51"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m57 42.67-16.93-9.75a4.18 4.18 0 0 0-5.71 1.53l-4.17 7.24a4.17 4.17 0 0 0 1.52 5.7l-2.78 4.83 10-.65 9.65 5.57a4.17 4.17 0 0 0 5.7-1.53l4.18-7.23A4.18 4.18 0 0 0 57 42.67Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41.08 43a1.74 1.74 0 1 1-.64-2.38 1.74 1.74 0 0 1 .64 2.38Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45.9 45.79a1.74 1.74 0 1 1-.63-2.38 1.74 1.74 0 0 1 .63 2.38Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.73 48.58a1.74 1.74 0 1 1-.64-2.38 1.74 1.74 0 0 1 .64 2.38Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NotificationMessage104 = (NotificationMessage104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/NotificationMessage56.tsx


var NotificationMessage56_excluded = ["className"];
function NotificationMessage56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function NotificationMessage56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NotificationMessage56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NotificationMessage56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function NotificationMessage56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NotificationMessage56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", NotificationMessage56_objectSpread(NotificationMessage56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m10.09 22.11 2.54 5.28a2.93 2.93 0 0 0 3.91 1.37l1.69 3.51 3.58-6.05s-8 3.63-11.72-4.11"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.91 42.06a16.94 16.94 0 0 0 20.75-12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20.51 36.11a10.78 10.78 0 0 0 13.2-7.62"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M17.32 48a23.09 23.09 0 0 0 28.29-16.32"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m23.77 12.28-12.31 5.93a2.92 2.92 0 0 0-1.37 3.9l2.54 5.28a2.93 2.93 0 0 0 3.91 1.37l1.69 3.51 3.58-6.05 7-3.39a2.93 2.93 0 0 0 1.37-3.91l-2.54-5.28a2.93 2.93 0 0 0-3.87-1.36Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M17.7 21.6a1.22 1.22 0 1 1-1.63-.6 1.23 1.23 0 0 1 1.63.6Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21.21 19.91a1.22 1.22 0 1 1-1.63-.57 1.22 1.22 0 0 1 1.63.57Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.73 18.21a1.22 1.22 0 1 1-1.63-.57 1.22 1.22 0 0 1 1.63.57Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NotificationMessage56 = (NotificationMessage56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/NotificationReminder104.tsx


var NotificationReminder104_excluded = ["className"];
function NotificationReminder104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function NotificationReminder104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NotificationReminder104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NotificationReminder104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function NotificationReminder104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NotificationReminder104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", NotificationReminder104_objectSpread(NotificationReminder104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.53 77.68c-1.33-2.57-3.87-4.19-5.37-6.66-6.56-10.36-2-22.85 2.05-33.24 1-2.63 1.75-4.23-.89-6.05l-.12.21-18 31.25a6.19 6.19 0 0 0 2.26 8.44l20.06 11.61a5.5 5.5 0 0 0 .01-5.56ZM42 56.32a3.69 3.69 0 1 1-6.39-3.69"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36.75 52.16c-.27-1.57-1.42-5.94 1.18-10.44a15.45 15.45 0 0 1 5.68-5.63c1.24-.77.67-2.69-.71-2.41a7.54 7.54 0 0 0-5.09 3.15c-.71 1.13-1.62 2.41-2.6 3.69A18.59 18.59 0 0 1 32.56 45a8.3 8.3 0 0 1-1.87 1.73c-.29.2-.59.38-.88.56a1.75 1.75 0 0 0 .74 2l2.18 1.26.11.07c.48.3 4.16 3.01 3.91 1.54Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m48.87 33 .8-1.39a1.91 1.91 0 0 1 2.61-.7l.25.15a1.9 1.9 0 0 1 .7 2.61L52.44 35M42 56.32a3.69 3.69 0 1 1-6.39-3.69"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M53.71 48.53c3.07-5.27 1.69-11.77-3.05-14.53s-11.06-.68-14.11 4.6c-2.55 4.4-4.88 7.58-6.74 8.73a.86.86 0 0 0 0 1.45l18.49 10.7a.86.86 0 0 0 1.24-.76c.07-2.18 1.66-5.84 4.17-10.19Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "23.7",
          y: "13.91",
          width: "37.58",
          height: "68.62",
          rx: "6",
          transform: "rotate(30 42.485 48.236)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m54.99 16.77 8.49 4.9M19.84 71.94l13.44 7.76"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M60.32 88.36A34.91 34.91 0 0 0 86 46.18"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M57.32 76a22.21 22.21 0 0 0 16.34-26.81"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M63.32 100.69a47.61 47.61 0 0 0 35-57.51"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NotificationReminder104 = (NotificationReminder104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/NotificationReminder56.tsx


var NotificationReminder56_excluded = ["className"];
function NotificationReminder56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function NotificationReminder56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NotificationReminder56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NotificationReminder56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function NotificationReminder56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NotificationReminder56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", NotificationReminder56_objectSpread(NotificationReminder56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.17 25.16a3 3 0 0 1-5.23 3M21.06 27.2a11.73 11.73 0 0 1-6.91-5.1 12.7 12.7 0 0 1-1.66-6.32c0-1.19-1.63-1.57-2-.48a6.11 6.11 0 0 0 .16 4.88c.51 1 1 2.14 1.55 3.36a15.14 15.14 0 0 1 2.05 3.69 7 7 0 0 1 .46 2v.85a1.42 1.42 0 0 0 1.7.29l1.79-1h.09c.49-.25 3.91-1.74 2.77-2.17Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m12.45 10.79-.66-1.13a1.58 1.58 0 0 1 .57-2.14l.21-.12a1.57 1.57 0 0 1 2.14.6l.65 1.13M26.17 25.16a3 3 0 0 1-5.23 3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M25.43 13.71c-2.49-4.32-7.66-6-11.53-3.77s-5 7.55-2.51 11.87c2.06 3.56 3.36 6.55 3.41 8.33a.7.7 0 0 0 1 .62L31 22a.71.71 0 0 0 0-1.19c-1.58-.92-3.52-3.54-5.57-7.1Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.6 42.06a16.94 16.94 0 0 0 20.75-12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20.2 36.11a10.78 10.78 0 0 0 13.2-7.62"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M17 48a23.09 23.09 0 0 0 28.3-16.32"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NotificationReminder56 = (NotificationReminder56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Notifications104.tsx


var Notifications104_excluded = ["className"];
function Notifications104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Notifications104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Notifications104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Notifications104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Notifications104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Notifications104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Notifications104_objectSpread(Notifications104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M61.59 88.09c-3-1.9-6.66-2.07-9.77-3.77-13.3-7-16.13-23-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46A7.57 7.57 0 0 0 36.56 94H65c.18-2.38-1.4-4.62-3.41-5.91ZM79.71 56.61a4.71 4.71 0 1 1-9.42 0M71.21 55.39c-1.29-1.56-5.35-5.65-5.35-12.29a19.69 19.69 0 0 1 2.69-9.84c.87-1.64-1-3.4-2.33-2.21a9.57 9.57 0 0 0-3.61 6.72c-.07 1.71-.26 3.71-.52 5.75A23.78 23.78 0 0 1 62 50.1a10.6 10.6 0 0 1-1 3.11c-.19.4-.41.79-.61 1.18a2.21 2.21 0 0 0 2.08 1.72h3.38c.78.1 6.57.75 5.36-.72Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M75 18v-2a6 6 0 0 0-6-6H35a6 6 0 0 0-6 6v72a6 6 0 0 0 6 6h34a6 6 0 0 0 6-6V66M50 14h4M46 90h12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M72.37 26.48v-2A2.44 2.44 0 0 1 74.81 22h.38a2.44 2.44 0 0 1 2.44 2.44v2M79.71 56.61a4.71 4.71 0 1 1-9.42 0M87.64 40.56C87.66 32.78 82 26.48 75 26.48s-12.65 6.3-12.65 14.08c0 6.42-.57 11.47-1.89 13.92a1.1 1.1 0 0 0 .88 1.63h27.3a1.1 1.1 0 0 0 .88-1.63C88.21 52 87.64 47 87.64 40.56Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Notifications104 = (Notifications104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Notifications56.tsx


var Notifications56_excluded = ["className"];
function Notifications56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Notifications56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Notifications56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Notifications56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Notifications56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Notifications56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Notifications56_objectSpread(Notifications56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.89 43.66a5 5 0 0 1-10 0M23.89 42.37c-1.38-1.66-5.67-6-5.67-13a20.88 20.88 0 0 1 2.84-10.42c.93-1.74-1-3.6-2.46-2.34a10.1 10.1 0 0 0-3.82 7.12c-.07 1.8-.28 3.92-.55 6.08a25.43 25.43 0 0 1-.12 7 10.94 10.94 0 0 1-1 3.29c-.2.43-.43.84-.65 1.25a2.35 2.35 0 0 0 2.21 1.82h3.58c.75.06 6.92.75 5.64-.8Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M25.12 11.74V9.58A2.58 2.58 0 0 1 27.7 7h.4a2.59 2.59 0 0 1 2.58 2.58v2.16M32.89 43.66a5 5 0 0 1-10 0M41.28 26.66c0-8.24-6-14.92-13.4-14.92s-13.4 6.68-13.4 14.92c0 6.79-.61 12.14-2 14.74a1.16 1.16 0 0 0 .94 1.72h28.9a1.16 1.16 0 0 0 .94-1.72c-1.37-2.6-1.98-7.95-1.98-14.74Z"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Notifications56 = (Notifications56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Phone104.tsx


var Phone104_excluded = ["className"];
function Phone104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Phone104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Phone104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Phone104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Phone104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Phone104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Phone104_objectSpread(Phone104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.9 32.4c7.4 2.6 21.3 38.7 37.8 46.5 13.3 6.3 25.7-3.4 30.6 0S74.9 90.3 70.4 90s-26.5-2.6-43.8-27.2-13.5-32.7-7.7-30.4"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M70.4 90c-8 0-20.7-3.4-36.8-19.6C3.4 40.2 16.9 21.6 17.5 20.9c.3-.4 4.6-4.5 4.6-4.5 3.3-3 8.3-3 11.6 0l9.3 9.3c3.2 3.2 3.2 8.3.1 11.5l-.1.1-4.2 4.4c2.8 4.5 6.1 8.7 9.9 12.5l1.4 1.3c3.8 3.8 8 7.1 12.5 9.9l4.2-4.2c3.3-3 8.3-3 11.6 0l9.3 9.3c1.6 1.6 2.4 3.7 2.4 5.9s-.9 4.3-2.5 5.9c-.1-.1-9.4 7.7-17.2 7.7z",
          className: "stroke"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Phone104 = (Phone104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Phone56.tsx


var Phone56_excluded = ["className"];
function Phone56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Phone56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Phone56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Phone56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Phone56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Phone56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Phone56_objectSpread(Phone56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M11.48 18.22c3.68 1.27 10.66 19.33 18.91 23.22 6.68 3.14 12.82-1.71 15.28 0s-6.21 5.71-8.45 5.56S24 45.71 15.31 33.42s-6.75-16.36-3.83-15.2"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.21 47c-4 0-10.33-1.7-18.39-9.77-15.08-15.11-8.35-24.41-8.06-24.79.16-.18 2.27-2.27 2.27-2.27a4.25 4.25 0 0 1 5.79 0l4.64 4.64a4.06 4.06 0 0 1 0 5.75l-2.08 2.18A37.53 37.53 0 0 0 26.31 29l.66.66a35 35 0 0 0 6.26 4.93l2.09-2.08a4.23 4.23 0 0 1 5.78 0l4.65 4.65A4.14 4.14 0 0 1 47 40.14a4.37 4.37 0 0 1-1.24 2.94S41.1 47 37.22 47Z"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Phone56 = (Phone56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Window104.tsx


var Window104_excluded = ["className"];
function Window104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Window104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Window104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Window104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Window104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Window104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Window104_objectSpread(Window104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "104",
    height: "104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.29 29.71v46.11h16.37c-8.35-3.54-14.81-21.18-16.37-46.11ZM59.43 76.14h22.29V27.86c-2.34 28.19-9.77 44.28-22.29 48.29Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m63.14 40.86 10.51 10.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m68.71 40.86 5.26 5.25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m63.14 46.43 5.26 5.25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.57 42.71 10.51 10.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m37.14 42.71 5.26 5.26"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.57 48.29 5.25 5.25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11 92.93h82"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.86 20.43h27.86v55.71H53.86z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.29 20.43h27.85v55.71H22.29V20.43z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.02 14.29h69.96c.56 0 1.02.46 1.02 1.02v65.96c0 .56-.46 1.02-1.02 1.02H17.02c-.56 0-1.02-.46-1.02-1.02V15.3c0-.56.46-1.02 1.02-1.02Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Window104 = (Window104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Window56.tsx


var Window56_excluded = ["className"];
function Window56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Window56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Window56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Window56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Window56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Window56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Window56_objectSpread(Window56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "56",
    height: "56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12 16v24.83h8.82C16.33 38.92 12.84 29.43 12 16ZM32 41h12V15c-1.26 15.18-5.26 23.85-12 26Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m34 22 5.66 5.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m37 22 2.83 2.83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m34 25 2.83 2.83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m17 23 5.66 5.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m20 23 2.83 2.83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m17 26 2.83 2.83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6.5 49.5h43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29 11h15v30H29z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12 11h15v30H12V11z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10 8h36c.55 0 1 .45 1 1v34c0 .55-.45 1-1 1H10c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Window56 = (Window56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Picto4G104.tsx


var Picto4G104_excluded = ["className"];
function Picto4G104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Picto4G104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Picto4G104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Picto4G104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Picto4G104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Picto4G104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Picto4G104_objectSpread(Picto4G104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M61.46 88.82c-11.75-1.77-25.19-4.09-34.22-12.06-8-9-10.29-22.47-12.06-34.22-.66-3.76-.81-6.19-5.17-6.54v50.43c0 .14.05.27.07.4s0 .29.06.44l.09.35.12.46c0 .1.08.2.11.3s.11.32.17.47l.16.32c.06.14.13.28.2.42l.19.32.23.37.24.32.25.33c.09.11.19.21.28.31s.17.2.26.29l.32.29.28.25.37.28.28.21c.13.09.28.17.41.25l.28.17.46.22.28.13.51.19.26.1.5.13.31.08.49.07.35.06.46.04h50c-.35-4.37-2.78-4.52-6.54-5.18Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "10",
          y: "10",
          width: "84",
          height: "84",
          rx: "8"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45.18 62.3V69h-6v-6.7H24.3v-5.67l12.24-21h6.53L30.64 56.87h8.54v-7.82h6v7.82h4.23v5.43ZM75.71 69 75 65.27c-1 2-4.27 4.32-8.54 4.37-3.94 0-7.44-1-10.13-3.79-3.56-3.7-4.43-8.26-4.43-13.85s.72-10 4.42-13.68a14.64 14.64 0 0 1 10.13-4 14 14 0 0 1 10.08 3.89 10.41 10.41 0 0 1 3.12 6.86h-6.34A5.28 5.28 0 0 0 71.82 42a6.85 6.85 0 0 0-5.42-2.06 8 8 0 0 0-5.57 2.3c-2.35 2.45-2.64 6.67-2.64 9.79s.34 7.49 2.69 9.94a7.75 7.75 0 0 0 5.52 2.16 6.86 6.86 0 0 0 5.09-2c1.82-1.92 2.21-4 2.21-6.62h-8.12v-5.12H79.7V69Z"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Picto4G104 = (Picto4G104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Picto4G56.tsx


var Picto4G56_excluded = ["className"];
function Picto4G56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Picto4G56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Picto4G56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Picto4G56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Picto4G56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Picto4G56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Picto4G56_objectSpread(Picto4G56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33 47.29c-6.2-.93-13.24-2.15-18-6.29-4.14-4.76-5.36-11.8-6.29-18-.34-2-.42-3.24-2.71-3.42V45.83A1.48 1.48 0 0 1 6 46a1.3 1.3 0 0 0 0 .21v.23a1.05 1.05 0 0 0 0 .19l.06.24.06.16a2.34 2.34 0 0 0 .09.24 1.3 1.3 0 0 0 .08.17l.1.22.11.17a2 2 0 0 0 .12.19 1.77 1.77 0 0 0 .12.17 1.09 1.09 0 0 0 .13.17l.15.17.13.15.17.15.15.13.19.15.15.1.22.14.14.09.24.11.15.07.26.1h.14l.26.07H9.64L10 50h26.38c-.18-2.29-1.45-2.37-3.38-2.71Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "6",
          y: "6",
          width: "44",
          height: "44",
          rx: "4"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.59 33.15v3.36h-3v-3.36h-7.44v-2.83l6.12-10.49h3.27l-6.22 10.61h4.27v-3.92h3v3.92h2.11v2.71ZM39.86 36.51l-.36-1.87a5 5 0 0 1-4.28 2.18 6.51 6.51 0 0 1-5.06-1.9C28.38 33.08 28 30.8 28 28s.36-5 2.21-6.84a7.3 7.3 0 0 1 5.06-2 7 7 0 0 1 5 1.94 5.28 5.28 0 0 1 1.57 3.43h-3.18a2.65 2.65 0 0 0-.75-1.53 3.41 3.41 0 0 0-2.71-1 4 4 0 0 0-2.78 1.15c-1.18 1.23-1.32 3.34-1.32 4.9s.16 3.75 1.34 5a3.88 3.88 0 0 0 2.76 1.08 3.41 3.41 0 0 0 2.54-1 4.35 4.35 0 0 0 1.11-3.32h-4.06V27.2h7.06v9.31Z"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Picto4G56 = (Picto4G56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Picto4GX104.tsx


var Picto4GX104_excluded = ["className"];
function Picto4GX104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Picto4GX104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Picto4GX104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Picto4GX104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Picto4GX104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Picto4GX104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Picto4GX104_objectSpread(Picto4GX104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M61.46 88.82c-11.75-1.77-25.19-4.09-34.22-12.06-8-9-10.29-22.47-12.06-34.22-.66-3.76-.81-6.19-5.17-6.54v50.43c0 .14.05.27.07.4s0 .29.06.44l.09.35.12.46c0 .1.08.2.11.3s.11.32.17.47l.16.32c.06.14.13.28.2.42l.19.32.23.37.24.32.25.33c.09.11.19.21.28.31s.17.2.26.29l.32.29.28.25.37.28.28.21c.13.09.28.17.41.25l.28.17.46.22.28.13.51.19.26.1.5.13.31.08.49.07.35.06.46.04h50c-.35-4.37-2.78-4.52-6.54-5.18Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "10",
          y: "10",
          width: "84",
          height: "84",
          rx: "8"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.11 59.72v5h-4.49v-5H19.46v-4.25l9.18-15.73h4.89l-9.32 15.91h6.41v-5.86h4.49v5.86h3.17v4.07ZM58 64.76 57.47 62c-.76 1.48-3.2 3.24-6.41 3.28a9.75 9.75 0 0 1-7.59-2.85c-2.66-2.77-3.31-6.19-3.31-10.36s.54-7.49 3.31-10.26a11 11 0 0 1 7.59-3 10.53 10.53 0 0 1 7.56 2.92 7.79 7.79 0 0 1 2.38 5.1h-4.79a4.05 4.05 0 0 0-1.11-2.34A5.17 5.17 0 0 0 51 43a6 6 0 0 0-4.18 1.72c-1.76 1.84-2 5-2 7.35s.25 5.61 2 7.45A5.82 5.82 0 0 0 51 61.09a5.14 5.14 0 0 0 3.81-1.48 6.53 6.53 0 0 0 1.66-5h-6.05v-3.82H61v14ZM79.43 64.76l-5.72-9.29L68 64.76h-5l8-13-8-12.53h5.08l5.72 8.93 5.54-8.93h5L76.59 51.8l8 13Z"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Picto4GX104 = (Picto4GX104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Picto4GX56.tsx


var Picto4GX56_excluded = ["className"];
function Picto4GX56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Picto4GX56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Picto4GX56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Picto4GX56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Picto4GX56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Picto4GX56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Picto4GX56_objectSpread(Picto4GX56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33 47.29c-6.2-.93-13.24-2.15-18-6.29-4.14-4.76-5.36-11.8-6.29-18-.34-2-.42-3.24-2.71-3.42V45.83A1.48 1.48 0 0 1 6 46a1.3 1.3 0 0 0 0 .21v.23a1.05 1.05 0 0 0 0 .19l.06.24.06.16a2.34 2.34 0 0 0 .09.24 1.3 1.3 0 0 0 .08.17l.1.22.11.17a2 2 0 0 0 .12.19 1.77 1.77 0 0 0 .12.17 1.09 1.09 0 0 0 .13.17l.15.17.13.15.17.15.15.13.19.15.15.1.22.14.14.09.24.11.15.07.26.1h.14l.26.07H9.64L10 50h26.38c-.18-2.29-1.45-2.37-3.38-2.71Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "6",
          y: "6",
          width: "44",
          height: "44",
          rx: "4"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19.56 31.86v2.52h-2.25v-2.52h-5.58v-2.12l4.59-7.87h2.45l-4.67 8h3.21v-2.98h2.25v2.94h1.58v2ZM31 34.38 30.74 33a3.75 3.75 0 0 1-3.21 1.64 4.9 4.9 0 0 1-3.8-1.43c-1.33-1.4-1.65-3.11-1.65-5.21s.27-3.75 1.65-5.13a5.47 5.47 0 0 1 3.8-1.5 5.27 5.27 0 0 1 3.78 1.46 3.92 3.92 0 0 1 1.17 2.58h-2.37a2 2 0 0 0-.56-1.17 2.55 2.55 0 0 0-2-.78 3 3 0 0 0-2.08.87c-.89.91-1 2.5-1 3.67s.12 2.81 1 3.73a2.93 2.93 0 0 0 2.07.81 2.57 2.57 0 0 0 1.91-.74 3.25 3.25 0 0 0 .83-2.49h-3V27.4h5.22v7ZM41.72 34.38l-2.87-4.64L36 34.38h-2.5l4-6.5-4-6.26h2.54l2.87 4.46 2.77-4.46h2.52l-3.91 6.28 4 6.48Z"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Picto4GX56 = (Picto4GX56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Picto5G104.tsx


var Picto5G104_excluded = ["className"];
function Picto5G104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Picto5G104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Picto5G104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Picto5G104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Picto5G104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Picto5G104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Picto5G104_objectSpread(Picto5G104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M61.46 88.82c-11.75-1.77-25.19-4.09-34.22-12.06-8-9-10.29-22.47-12.06-34.22-.66-3.76-.81-6.19-5.17-6.54v50.43c0 .14.05.27.07.4s0 .29.06.44l.09.35.12.46c0 .1.08.2.11.3s.11.32.17.47l.16.32c.06.14.13.28.2.42l.19.32.23.37.24.32.25.33c.09.11.19.21.28.31s.17.2.26.29l.32.29.28.25.37.28.28.21c.13.09.28.17.41.25l.28.17.46.22.28.13.51.19.26.1.5.13.31.08.49.07.35.06.46.04h50c-.35-4.37-2.78-4.52-6.54-5.18Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36.42 70.16c-6.62 0-11.23-4.13-11.57-10.42h6c.15 3.31 2.45 5.09 5.62 5.09 4 0 5.47-2.93 5.47-6.53s-1.63-6-5.47-6a6 6 0 0 0-5 2.69h-5.9l.71-18.82h20.27v5.33H31.48l-.39 7.63c1.54-1.44 3.65-2.13 6.63-2.13C44.44 47 48 51.82 48 58.15c0 7.06-4.14 12.01-11.58 12.01ZM75.16 69.48l-.72-3.74c-1 2-4.27 4.32-8.54 4.37-3.94 0-7.45-1-10.13-3.79-3.56-3.7-4.42-8.26-4.42-13.83s.72-10 4.42-13.68a14.64 14.64 0 0 1 10.13-4 14.08 14.08 0 0 1 10.1 3.9 10.45 10.45 0 0 1 3.12 6.87h-6.36a5.25 5.25 0 0 0-1.49-3.12 6.82 6.82 0 0 0-5.42-2.07 8 8 0 0 0-5.57 2.31c-2.35 2.45-2.64 6.67-2.64 9.79S58 60 60.33 62.43a7.75 7.75 0 0 0 5.52 2.16 6.87 6.87 0 0 0 5.09-2c1.82-1.92 2.2-4 2.2-6.63H65v-5.1h14.15v18.62Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "10",
          y: "10",
          width: "84",
          height: "84",
          rx: "8"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Picto5G104 = (Picto5G104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Picto5G56.tsx


var Picto5G56_excluded = ["className"];
function Picto5G56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Picto5G56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Picto5G56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Picto5G56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Picto5G56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Picto5G56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Picto5G56_objectSpread(Picto5G56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33 47.29c-6.2-.93-13.24-2.15-18-6.29-4.14-4.76-5.36-11.8-6.29-18-.34-2-.42-3.24-2.71-3.42V45.83A1.48 1.48 0 0 1 6 46a1.3 1.3 0 0 0 0 .21v.23a1.05 1.05 0 0 0 0 .19l.06.24.06.16a2.34 2.34 0 0 0 .09.24 1.3 1.3 0 0 0 .08.17l.1.22.11.17a2 2 0 0 0 .12.19 1.77 1.77 0 0 0 .12.17 1.09 1.09 0 0 0 .13.17l.15.17.13.15.17.15.15.13.19.15.15.1.22.14.14.09.24.11.15.07.26.1h.14l.26.07H9.64L10 50h26.38c-.18-2.29-1.45-2.37-3.38-2.71Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "6",
          y: "6",
          width: "44",
          height: "44",
          rx: "4"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20.21 35.82c-3.31 0-5.61-2.07-5.78-5.21h3a2.55 2.55 0 0 0 2.81 2.55c2 0 2.73-1.47 2.73-3.27s-.81-3-2.73-3a3 3 0 0 0-2.5 1.34h-2.95l.36-9.41h10.13v2.69h-7.54l-.19 3.82a4.58 4.58 0 0 1 3.31-1.08c3.36 0 5.16 2.42 5.16 5.59-.02 3.51-2.09 5.98-5.81 5.98ZM39.58 35.48l-.36-1.87A5 5 0 0 1 35 35.8a6.53 6.53 0 0 1-5.07-1.9c-1.77-1.85-2.2-4.13-2.2-6.91s.36-5 2.2-6.84a7.32 7.32 0 0 1 5.07-2 7 7 0 0 1 5 2 5.23 5.23 0 0 1 1.56 3.43h-3.18a2.66 2.66 0 0 0-.74-1.58 3.42 3.42 0 0 0-2.72-1 4 4 0 0 0-2.78 1.15C31 23.31 30.82 25.43 30.82 27s.17 3.74 1.34 5a3.94 3.94 0 0 0 2.76 1 3.44 3.44 0 0 0 2.55-1 4.36 4.36 0 0 0 1.1-3.31h-4v-2.52h7v9.31Z"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Picto5G56 = (Picto5G56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/CoverageMobile104.tsx


var CoverageMobile104_excluded = ["className"];
function CoverageMobile104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function CoverageMobile104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CoverageMobile104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CoverageMobile104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function CoverageMobile104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, CoverageMobile104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", CoverageMobile104_objectSpread(CoverageMobile104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.62 21.62a26 26 0 0 0 0 36.76"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28 16a34 34 0 0 0 0 48M76 64a34 34 0 0 0 0-48"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.3 10.3a42 42 0 0 0 0 59.4M81.7 69.7a42 42 0 0 0 0-59.4M70.38 58.38a26 26 0 0 0 0-36.76"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.73 42.27a8.13 8.13 0 0 1-2.17-7.63 6.54 6.54 0 0 0-.51.41A7 7 0 0 0 57 45a6.54 6.54 0 0 0 .41-.51 8.13 8.13 0 0 1-7.68-2.22Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M54.19 46.65 68 94M49.81 46.65 36 94"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "52",
          cy: "40",
          r: "7"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M54.84 51 47 57l14 13-24 21"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.16 51 57 57 43 70l24 21"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_CoverageMobile104 = (CoverageMobile104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/CoverageMobile56.tsx


var CoverageMobile56_excluded = ["className"];
function CoverageMobile56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function CoverageMobile56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CoverageMobile56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CoverageMobile56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function CoverageMobile56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, CoverageMobile56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", CoverageMobile56_objectSpread(CoverageMobile56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.81 22.56a4.28 4.28 0 0 1-1.14-4 2.65 2.65 0 0 0-.26.21A3.67 3.67 0 1 0 30.59 24a1.86 1.86 0 0 0 .22-.27 4.27 4.27 0 0 1-4-1.17Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.37 11.74a13.62 13.62 0 0 0 0 19.26M37.63 31a13.62 13.62 0 0 0 0-19.26"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M15.41 8.77a17.8 17.8 0 0 0 0 25.19M40.59 34a17.8 17.8 0 0 0 0-25.19"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M12.44 5.81a22 22 0 0 0 0 31.11M43.56 36.92a22 22 0 0 0 0-31.11"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m29.15 24.85 7.23 24.8M26.86 24.85l-7.24 24.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "28",
          cy: "21.37",
          r: "3.67"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m29.49 27.13-4.11 3.14 7.33 6.81-12.57 11"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m26.51 27.13 4.11 3.14-7.33 6.81 12.57 11"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_CoverageMobile56 = (CoverageMobile56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/CoverageNetwork104.tsx


var CoverageNetwork104_excluded = ["className"];
function CoverageNetwork104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function CoverageNetwork104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CoverageNetwork104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CoverageNetwork104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function CoverageNetwork104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, CoverageNetwork104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", CoverageNetwork104_objectSpread(CoverageNetwork104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m64.9 48-.07.32v39.89A1.86 1.86 0 0 0 67.2 90l10.38-3C66.9 85.94 64.9 48 64.9 48ZM42.87 89.67c-2.18-1.4-4.88-1.52-7.16-2.77C26 81.8 23.89 70.07 22.4 60.16c-.4-2.47-.54-4.06-3.4-4.29v32.58A5.55 5.55 0 0 0 24.53 94h20.83a5 5 0 0 0-2.49-4.33Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.76 10.55H14.7a2 2 0 0 0-2 2v69.61a2 2 0 0 0 2 2H19M64.83 18.57l23.48-7.22a2 2 0 0 1 2.59 1.91v68a2 2 0 0 1-1.42 1.91l-24.65 7.58M51 86l13.83 4.75V18.57l-26.07-8.02V34"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "18.91",
          y: "34.42",
          width: "32",
          height: "60",
          rx: "4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.77 38.79h2M30.77 90.25h8M28.08 63.76v4.76M32.36 62.17v6.35M36.64 60.59v7.93M40.92 59v9.52"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_CoverageNetwork104 = (CoverageNetwork104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/CoverageNetwork56.tsx


var CoverageNetwork56_excluded = ["className"];
function CoverageNetwork56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function CoverageNetwork56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CoverageNetwork56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CoverageNetwork56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function CoverageNetwork56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, CoverageNetwork56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", CoverageNetwork56_objectSpread(CoverageNetwork56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35 25.68V47.3a1 1 0 0 0 1.27 1l5.58-1.59C36.11 46.08 35 25.68 35 25.68ZM23.29 48.1c-1.17-.75-2.61-.81-3.82-1.48-5.2-2.72-6.31-9-7.11-14.26-.23-1.32-.28-2.17-1.81-2.3v17.39a3 3 0 0 0 2.95 3h11.12a2.65 2.65 0 0 0-1.33-2.35Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21 5.59H8a1 1 0 0 0-1 1v37.54a1 1 0 0 0 1 1h.77M35 9.9 47.71 6A1 1 0 0 1 49 7v36.62a1 1 0 0 1-.71 1L35 48.67M29.36 46.93 35 48.67V9.9L21 5.59v10.54"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "10.5",
          y: "18",
          width: "17",
          height: "32",
          rx: "2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18 20h2M17 48h4M14.96 33.19v3M17.65 32.19v4M20.35 31.19v5M23.04 30.19v6"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_CoverageNetwork56 = (CoverageNetwork56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/FailedConnection104.tsx


var FailedConnection104_excluded = ["className"];
function FailedConnection104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function FailedConnection104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? FailedConnection104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FailedConnection104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function FailedConnection104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, FailedConnection104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", FailedConnection104_objectSpread(FailedConnection104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.9 62.8C26.4 45 40 34 40 34c-11.3.9-20.8 13-19.5 29.2 1 12.1 7.8 21.2 15.5 25.6h6.3c-4.1-3.2-13.3-12.4-14.4-26z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M68.8 91.7h11"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36.3 87.8c-14.7-8.5-19.7-27.3-11.1-42 3.3-5.7 8.4-10.2 14.5-12.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M54.6 30.2c10.5 1.8 21.1 8.9 25.4 19 6.7 15.6-.6 33.7-16.2 40.3-2.2 1-4.4 1.7-6.7 2.2H20"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M91 94.7h2.9v-5.9H91z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M93.9 90.8h7.4v-2h-7.4z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M93.9 92.7h7.4v-2h-7.4z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M93.9 94.7h7.4v-2h-7.4z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M11.6 94.7h2.9v-5.9h-2.9z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M4.2 94.7h7.4v-2H4.2z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M4.2 92.7h7.4v-2H4.2z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M4.2 90.8h7.4v-2H4.2z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m39 76.7 24.4-2.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m37 51 6-1.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m64.7 50.5-6.1-1.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M78.8 91.7H91M14.4 91.7h6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.3 31.6c-1.2.3-2.3.7-3.5 1.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M53.9 30.3c-1.2-.1-2.4-.1-3.6 0"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m54.5 9.3-7 6.9 5.5 1.5-3.6 5.5-.7 1.1 11-8.1-5.6-1.3 4.3-4.7z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m36.8 16.9 5.7 4.3-3.9 1.6 3.1 3.6.6.7-8.5-4.8 3.8-1.5-3.5-2.9z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M60.4 55.5c1.5.4 2.3 2 1.9 3.5-.4 1.5-2 2.3-3.5 1.9-1.5-.4-2.3-2-1.9-3.5.5-1.5 2-2.4 3.5-1.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41.8 55.8c1.5.4 2.3 2 1.9 3.5-.4 1.5-2 2.3-3.5 1.9-1.5-.4-2.3-2-1.9-3.5.4-1.5 2-2.4 3.5-1.9"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_FailedConnection104 = (FailedConnection104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/FailedConnection56.tsx


var FailedConnection56_excluded = ["className"];
function FailedConnection56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function FailedConnection56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? FailedConnection56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FailedConnection56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function FailedConnection56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, FailedConnection56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", FailedConnection56_objectSpread(FailedConnection56_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M15 33.9c-.8-9.7 7.5-16.4 7.5-16.4-6.1.5-12.2 7.9-11.4 16.7.5 6.6 4.1 11.9 8.3 13.9h3.4c-2.2-1.9-7.2-6.8-7.8-14.2z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.1 49.4H43"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19.5 47.3c-7.9-4.6-10.6-14.7-6-22.6 1.8-3.1 4.5-5.5 7.8-6.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29.4 16.3c5.7 1 11.4 4.8 13.7 10.2 3.6 8.4-.3 18.1-8.7 21.7-1.2.5-2.4.9-3.6 1.2h-20"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49 51h1.6v-3.2H49z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.5 48.9h4v-1.1h-4z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.5 49.9h4v-1h-4z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.5 51h4v-1.1h-4z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M6.2 51h1.6v-3.2H6.2z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M2.2 51h4v-1.1h-4z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M2.2 49.9h4v-1h-4z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M2.2 48.9h4v-1.1h-4z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m21 41.3 13.2-1.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m19.9 27.5 3.3-.7"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m34.8 27.2-3.2-.7"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42.5 49.4H49M7.7 49.4H11"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.3 17c-.6.2-1.3.4-1.9.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29 16.3h-2"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m29.3 5-3.7 3.7 2.9.9-1.9 2.9-.4.6 5.9-4.3-3-.8 2.4-2.5z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m19.8 9.1 3.1 2.3-2.1.9 1.6 1.9.4.4-4.6-2.6 2-.8-1.8-1.6z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.5 29.9c.8.2 1.2 1.1 1 1.9s-1.1 1.2-1.9 1c-.8-.2-1.2-1.1-1-1.9.3-.8 1.1-1.3 1.9-1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.5 30c.8.2 1.2 1.1 1 1.9-.2.8-1.1 1.2-1.9 1s-1.2-1.1-1-1.9c.2-.8 1.1-1.2 1.9-1"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_FailedConnection56 = (FailedConnection56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/InternetOptimiser104.tsx


var InternetOptimiser104_excluded = ["className"];
function InternetOptimiser104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function InternetOptimiser104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InternetOptimiser104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InternetOptimiser104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function InternetOptimiser104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternetOptimiser104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", InternetOptimiser104_objectSpread(InternetOptimiser104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "56.76",
        y: "19.72",
        width: "8.17",
        height: "8.17",
        rx: "2.52",
        ry: "2.52"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.62 44.04c2.93-.32 4.58 25.39 4.86 29.47.25 3.74 1.82 8.74 4.52 11.57 2.42 2.57 5.93 3.77 9.37 4.18 2.96.35 8.2-.26 11.27.33 3.42.66 4.43 4.41-.09 4.41H17.93c-2.34-.18-7.37-2.56-7.31-9.96v-40Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "10",
        y: "10",
        width: "84",
        height: "84",
        rx: "11.91",
        ry: "11.91"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.71 79.4V84M23.71 37.68v30.25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.71",
        cy: "73.66",
        r: "5.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.71",
        cy: "73.66",
        r: "5.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.3 68.23V84M79.3 37.68v18.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "79.3",
        cy: "62.21",
        r: "5.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.24 79.39V84M42.24 37.68v29.59"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "42.24",
        cy: "73.66",
        r: "5.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.77 41.33v-3.65M60.77 84V52.79"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "60.77",
        cy: "47.06",
        r: "5.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "10",
        y: "10",
        width: "84",
        height: "84",
        rx: "11.91",
        ry: "11.91"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "19.63",
        y: "19.72",
        width: "8.17",
        height: "8.17",
        rx: "2.52",
        ry: "2.52"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "38.16",
        y: "19.72",
        width: "8.17",
        height: "8.17",
        rx: "2.52",
        ry: "2.52"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "56.76",
        y: "19",
        width: "8.17",
        height: "8.17",
        rx: "2.52",
        ry: "2.52"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "75.21",
        y: "19.72",
        width: "8.17",
        height: "8.17",
        rx: "2.52",
        ry: "2.52"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_InternetOptimiser104 = (InternetOptimiser104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/InternetOptimiser56.tsx


var InternetOptimiser56_excluded = ["className"];
function InternetOptimiser56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function InternetOptimiser56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InternetOptimiser56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InternetOptimiser56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function InternetOptimiser56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternetOptimiser56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", InternetOptimiser56_objectSpread(InternetOptimiser56_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.6 11.1c1.2 0 2.1 1 2.1 2.1 0 1.2-1 2.1-2.1 2.1-1.2 0-2.1-1-2.1-2.1 0-1.2 1-2.1 2.1-2.1zM6.3 23.8c1.5-.2 2.4 13.3 2.5 15.4.1 2 .9 4.6 2.4 6.1 1.3 1.3 3.1 2 4.9 2.2 1.5.2 4.3-.1 5.9.2 1.8.3 2.3 2.3 0 2.3H10.2c-1.2-.1-3.9-1.3-3.8-5.2v-21z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.2 6h31.5c3.4 0 6.2 2.8 6.2 6.2v31.5c0 3.4-2.8 6.2-6.2 6.2H12.2C8.8 50 6 47.2 6 43.8V12.2C6 8.8 8.8 6 12.2 6zM13.2 42.3v2.5M13.2 20.5v15.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "13.2",
        cy: "39.3",
        r: "3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "13.2",
        cy: "39.3",
        r: "3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.3 36.5v8.3M42.3 20.5V30"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "42.3",
        cy: "33.3",
        r: "3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.9 42.3v2.5M22.9 20.5V36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.9",
        cy: "39.3",
        r: "3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.6 22.4v-1.9M32.6 44.8V28.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "32.6",
        cy: "25.4",
        r: "3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.2 6h31.5c3.4 0 6.2 2.8 6.2 6.2v31.5c0 3.4-2.8 6.2-6.2 6.2H12.2C8.8 50 6 47.2 6 43.8V12.2C6 8.8 8.8 6 12.2 6z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.2 11.1c1.2 0 2.1 1 2.1 2.1 0 1.2-1 2.1-2.1 2.1-1.2 0-2.1-1-2.1-2.1-.1-1.2.9-2.1 2.1-2.1zM22.9 11.1c1.2 0 2.1 1 2.1 2.1 0 1.2-1 2.1-2.1 2.1-1.2 0-2.1-1-2.1-2.1 0-1.2.9-2.1 2.1-2.1zM32.6 10.7c1.2 0 2.1 1 2.1 2.1 0 1.2-1 2.1-2.1 2.1-1.2 0-2.1-1-2.1-2.1s1-2.1 2.1-2.1zM42.3 11.1c1.2 0 2.1 1 2.1 2.1 0 1.2-1 2.1-2.1 2.1-1.2 0-2.1-1-2.1-2.1 0-1.2.9-2.1 2.1-2.1z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_InternetOptimiser56 = (InternetOptimiser56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/NetworkSpeed104.tsx


var NetworkSpeed104_excluded = ["className"];
function NetworkSpeed104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function NetworkSpeed104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NetworkSpeed104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NetworkSpeed104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function NetworkSpeed104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NetworkSpeed104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", NetworkSpeed104_objectSpread(NetworkSpeed104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.26 50.35a5 5 0 1 0 5 5 5 5 0 0 0-5-5Zm1 5.69a1.23 1.23 0 1 1-.26-1.71 1.22 1.22 0 0 1 .26 1.67ZM72.86 32c3.76 3.79 14.33.81 7.56-6.93a38 38 0 0 0-46.29-8.4C27.22 20.31 21 26 17.61 33.14c-3.52 7.45-4 15.74-3.91 23.86.07 5.32 8.35 5.34 8.28 0-.08-6.27 1.64-12.34 4-18.26 2.43-6.13 7.72-8.52 13.39-11.71C49.15 23 62.94 22.06 72.86 32ZM78.54 54.71C76 69.27 67.51 80 52.26 81.7c-3.49.39-3.53 5.91 0 5.52 17.64-2 28.59-13.82 31.6-31 .61-3.52-4.71-5.01-5.32-1.51Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M90.31 51.83C90.4 73.93 73.43 91.91 52.42 92S14.3 74.26 14.21 52.17 31.09 12.09 52.1 12s38.12 17.74 38.21 39.83Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.33 55.17a31.07 31.07 0 1 1-31.2-30.95 31.06 31.06 0 0 1 31.2 30.95Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m74.12 77-2.53-2.53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.14 55.16h-5.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m74.07 33.33-2.53 2.54"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.23 24.32v5.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m30.41 33.38 2.53 2.54"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.39 55.23h5.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m30.46 77.05 2.53-2.53"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M71.18 68.37c-4-3.9-16-14.82-17.08-15.62a3.13 3.13 0 0 0-3.64 5.09c1.11.8 15.31 8.56 20.3 11.11a.36.36 0 0 0 .42-.58ZM53.26 56a1.23 1.23 0 1 1-.26-1.67 1.22 1.22 0 0 1 .26 1.67Z",
      className: "strokeinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NetworkSpeed104 = (NetworkSpeed104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/NetworkSpeed56.tsx


var NetworkSpeed56_excluded = ["className"];
function NetworkSpeed56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function NetworkSpeed56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NetworkSpeed56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NetworkSpeed56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function NetworkSpeed56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NetworkSpeed56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", NetworkSpeed56_objectSpread(NetworkSpeed56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.24 17.16c2 2 7.73.44 4.08-3.74a20.51 20.51 0 0 0-25-4.52 20 20 0 0 0-8.91 8.86c-1.9 4-2.17 8.49-2.11 12.86 0 2.88 4.5 2.88 4.47 0A25.89 25.89 0 0 1 14 20.78c1.31-3.31 4.16-4.6 7.22-6.31 5.24-2.16 12.67-2.69 18.02 2.69ZM46.53 29.49c-1.59 9-6.85 15.7-16.32 16.76-2.17.24-2.19 3.67 0 3.43C41.16 48.45 48 41.1 49.83 30.4c.38-2.16-2.92-3.08-3.3-.91Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28.08 24.67a3.46 3.46 0 1 0 3.46 3.45 3.46 3.46 0 0 0-3.46-3.45Zm.69 3.95a.85.85 0 1 1-1.38-1 .85.85 0 1 1 1.38 1Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.66 28A21.58 21.58 0 1 1 28 6.52 21.58 21.58 0 0 1 49.66 28Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m43.45 43.18-1.66-1.66"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.45 28h-3.57"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m43.29 12.97-1.66 1.66"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28.24 6.5v3.57"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m13.1 12.9 1.67 1.66"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M6.58 28.05h3.57"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m12.92 43.4 1.67-1.66"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.22 37.18c-2.8-2.7-11.09-10.29-11.86-10.84a2.17 2.17 0 0 0-2.53 3.53c.77.55 10.63 5.94 14.1 7.72a.25.25 0 0 0 .29-.41Zm-12.45-8.56a.85.85 0 1 1-1.38-1 .85.85 0 1 1 1.38 1Z",
        className: "strokeinverted"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NetworkSpeed56 = (NetworkSpeed56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/NetworkSpeeds104.tsx


var NetworkSpeeds104_excluded = ["className"];
function NetworkSpeeds104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function NetworkSpeeds104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NetworkSpeeds104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NetworkSpeeds104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function NetworkSpeeds104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NetworkSpeeds104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", NetworkSpeeds104_objectSpread(NetworkSpeeds104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.26 50.35a5 5 0 1 0 5 5 5 5 0 0 0-5-5Zm1 5.69a1.23 1.23 0 1 1-.26-1.71 1.22 1.22 0 0 1 .26 1.67ZM72.86 32c3.76 3.79 14.33.81 7.56-6.93a38 38 0 0 0-46.29-8.4C27.22 20.31 21 26 17.61 33.14c-3.52 7.45-4 15.74-3.91 23.86.07 5.32 8.35 5.34 8.28 0-.08-6.27 1.64-12.34 4-18.26 2.43-6.13 7.72-8.52 13.39-11.71C49.15 23 62.94 22.06 72.86 32ZM78.54 54.71C76 69.27 67.51 80 52.26 81.7c-3.49.39-3.53 5.91 0 5.52 17.64-2 28.59-13.82 31.6-31 .61-3.52-4.71-5.01-5.32-1.51Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M90.31 51.83C90.4 73.93 73.43 91.91 52.42 92S14.3 74.26 14.21 52.17 31.09 12.09 52.1 12s38.12 17.74 38.21 39.83Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.33 55.17a31.07 31.07 0 1 1-31.2-30.95 31.06 31.06 0 0 1 31.2 30.95Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m74.12 77-2.53-2.53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.14 55.16h-5.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m74.07 33.33-2.53 2.54"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.23 24.32v5.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m30.41 33.38 2.53 2.54"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.39 55.23h5.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m30.46 77.05 2.53-2.53"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M71.18 68.37c-4-3.9-16-14.82-17.08-15.62a3.13 3.13 0 0 0-3.64 5.09c1.11.8 15.31 8.56 20.3 11.11a.36.36 0 0 0 .42-.58ZM53.26 56a1.23 1.23 0 1 1-.26-1.67 1.22 1.22 0 0 1 .26 1.67Z",
      className: "strokeinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NetworkSpeeds104 = (NetworkSpeeds104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/NetworkSpeeds56.tsx


var NetworkSpeeds56_excluded = ["className"];
function NetworkSpeeds56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function NetworkSpeeds56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NetworkSpeeds56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NetworkSpeeds56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function NetworkSpeeds56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NetworkSpeeds56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", NetworkSpeeds56_objectSpread(NetworkSpeeds56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.24 17.16c2 2 7.73.44 4.08-3.74a20.51 20.51 0 0 0-25-4.52 20 20 0 0 0-8.91 8.86c-1.9 4-2.17 8.49-2.11 12.86 0 2.88 4.5 2.88 4.47 0A25.89 25.89 0 0 1 14 20.78c1.31-3.31 4.16-4.6 7.22-6.31 5.24-2.16 12.67-2.69 18.02 2.69ZM46.53 29.49c-1.59 9-6.85 15.7-16.32 16.76-2.17.24-2.19 3.67 0 3.43C41.16 48.45 48 41.1 49.83 30.4c.38-2.16-2.92-3.08-3.3-.91Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28.08 24.67a3.46 3.46 0 1 0 3.46 3.45 3.46 3.46 0 0 0-3.46-3.45Zm.69 3.95a.85.85 0 1 1-1.38-1 .85.85 0 1 1 1.38 1Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.66 28A21.58 21.58 0 1 1 28 6.52 21.58 21.58 0 0 1 49.66 28Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m43.45 43.18-1.66-1.66"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.45 28h-3.57"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m43.29 12.97-1.66 1.66"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28.24 6.5v3.57"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m13.1 12.9 1.67 1.66"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M6.58 28.05h3.57"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m12.92 43.4 1.67-1.66"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.22 37.18c-2.8-2.7-11.09-10.29-11.86-10.84a2.17 2.17 0 0 0-2.53 3.53c.77.55 10.63 5.94 14.1 7.72a.25.25 0 0 0 .29-.41Zm-12.45-8.56a.85.85 0 1 1-1.38-1 .85.85 0 1 1 1.38 1Z",
        className: "strokeinverted"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NetworkSpeeds56 = (NetworkSpeeds56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/TelstraAir104.tsx


var TelstraAir104_excluded = ["className"];
function TelstraAir104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function TelstraAir104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TelstraAir104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TelstraAir104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function TelstraAir104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TelstraAir104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", TelstraAir104_objectSpread(TelstraAir104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M58.12 87.39A41.51 41.51 0 0 1 25.65 20 41.51 41.51 0 1 0 84 78.35a41.3 41.3 0 0 1-25.88 9.04Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "52",
          cy: "52",
          r: "42"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m45.32 69.74-7.43-24.48a1.62 1.62 0 0 0-1.62-1.08h-.08a1.62 1.62 0 0 0-1.54 1.08L27.2 69.74a1.31 1.31 0 0 0 1.31 1.73 1.39 1.39 0 0 0 1.39-1l1.75-5.83h9.22l1.75 5.83a1.36 1.36 0 0 0 1.39 1 1.3 1.3 0 0 0 1.31-1.73ZM32.56 62l3.77-12.72L40.11 62Zm18.09 8.25A1.33 1.33 0 0 0 52 71.47a1.34 1.34 0 0 0 1.45-1.27V53.08A1.34 1.34 0 0 0 52 51.81a1.31 1.31 0 0 0-1 .34 1.33 1.33 0 0 0-.43.93Zm26.22-18.17v-.36a7.46 7.46 0 0 0-7.52-7.38H62.6a1.3 1.3 0 0 0-1.36 1.28v24.62a1.33 1.33 0 0 0 1.39 1.28 1.36 1.36 0 0 0 1-.32 1.38 1.38 0 0 0 .5-1V59.38h4.13l5.47 11.41a1.32 1.32 0 0 0 1.2.73 1.37 1.37 0 0 0 1.1-.29 1.4 1.4 0 0 0 .52-1 1.26 1.26 0 0 0-.13-.63l-5.06-10.44a7.22 7.22 0 0 0 5.51-7.08Zm-2.9 0a4.59 4.59 0 0 1-4.62 4.67h-5.19v-9.7h5.19A4.63 4.63 0 0 1 74 51.72Zm-22-7.6a1.75 1.75 0 1 0 1.75 1.75A1.75 1.75 0 0 0 52 44.48M64.4 35a1.38 1.38 0 0 1-1-.39 16.22 16.22 0 0 0-22.8 0 1.36 1.36 0 1 1-1.93-1.92 18.87 18.87 0 0 1 26.66 0 1.35 1.35 0 0 1 .29 1.48 1.38 1.38 0 0 1-1.22.83Zm-3.58 4.2a1.39 1.39 0 0 1-1-.4 11.12 11.12 0 0 0-15.75 0 1.36 1.36 0 0 1-1.93-1.93 13.89 13.89 0 0 1 19.61 0 1.37 1.37 0 0 1-1 2.33Zm-3.64 4.17a1.37 1.37 0 0 1-1-.4 5.92 5.92 0 0 0-8.37 0A1.36 1.36 0 0 1 45.92 41a8.68 8.68 0 0 1 12.23 0 1.41 1.41 0 0 1 0 1.93 1.37 1.37 0 0 1-1 .4Z"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TelstraAir104 = (TelstraAir104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/TelstraAir56.tsx


var TelstraAir56_excluded = ["className"];
function TelstraAir56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function TelstraAir56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TelstraAir56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TelstraAir56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function TelstraAir56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TelstraAir56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", TelstraAir56_objectSpread(TelstraAir56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.51 46.49A22 22 0 0 1 14.3 10.78 22 22 0 1 0 45.22 41.7a21.89 21.89 0 0 1-13.71 4.79Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "28",
          cy: "28",
          r: "22"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m24.4 37.55-4-13.18a.87.87 0 0 0-.87-.58.87.87 0 0 0-.83.58l-4 13.18a.71.71 0 0 0 .1.66.73.73 0 0 0 .6.28.75.75 0 0 0 .7-.49l.9-3.18h5L23 38a.74.74 0 0 0 .75.53.73.73 0 0 0 .6-.28.71.71 0 0 0 .1-.66Zm-6.87-4.17 2-6.85 2 6.85Zm9.74 4.44a.73.73 0 0 0 .73.67.79.79 0 0 0 .53-.18.72.72 0 0 0 .24-.51v-9.22a.68.68 0 0 0-.24-.5.86.86 0 0 0-1.05 0 .69.69 0 0 0-.23.5ZM41.39 28v-.19a4 4 0 0 0-4-4h-3.68a.72.72 0 0 0-.51.19.68.68 0 0 0-.22.5v13.32a.66.66 0 0 0 .23.5.7.7 0 0 0 .52.19.73.73 0 0 0 .55-.17.8.8 0 0 0 .27-.52V32h2.22l2.95 6.14a.71.71 0 0 0 .64.39.73.73 0 0 0 .6-.16.75.75 0 0 0 .27-.54.57.57 0 0 0-.07-.34l-2.73-5.62A3.87 3.87 0 0 0 41.39 28Zm-1.56 0a2.48 2.48 0 0 1-2.49 2.52h-2.79v-5.18h2.79a2.48 2.48 0 0 1 1.77.74 2.45 2.45 0 0 1 .72 1.77ZM28 24a.94.94 0 1 0 .94.94A.94.94 0 0 0 28 24m6.68-5.13a.72.72 0 0 1-.52-.21 8.74 8.74 0 0 0-12.28 0 .74.74 0 0 1-1 0 .75.75 0 0 1 0-1 10.17 10.17 0 0 1 14.35 0 .72.72 0 0 1 .15.8.73.73 0 0 1-.67.45Zm-1.93 2.26a.74.74 0 0 1-.52-.22 6 6 0 0 0-8.48 0 .73.73 0 0 1-1-1 7.46 7.46 0 0 1 10.56 0 .72.72 0 0 1 .15.8.73.73 0 0 1-.67.45Zm-2 2.25a.73.73 0 0 1-.52-.22 3.2 3.2 0 0 0-4.51 0 .72.72 0 0 1-1 0 .73.73 0 0 1 0-1 4.67 4.67 0 0 1 6.58 0 .74.74 0 0 1-.52 1.26Z"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TelstraAir56 = (TelstraAir56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/WiFi104.tsx


var WiFi104_excluded = ["className"];
function WiFi104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function WiFi104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WiFi104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WiFi104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function WiFi104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WiFi104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", WiFi104_objectSpread(WiFi104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M56.1 80.11a8.41 8.41 0 0 1-7.67-11.88 8.41 8.41 0 1 0 11.12 11.12 8.29 8.29 0 0 1-3.45.76",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M82.77 48.92a43.68 43.68 0 0 0-61.76 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M71.54 60.15a27.79 27.79 0 0 0-39.3 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M94 37.69a59.56 59.56 0 0 0-84.22 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M60.31 75.9a8.42 8.42 0 1 1-8.42-8.42 8.42 8.42 0 0 1 8.42 8.42Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WiFi104 = (WiFi104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/WiFi56.tsx


var WiFi56_excluded = ["className"];
function WiFi56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function WiFi56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WiFi56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WiFi56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function WiFi56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WiFi56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", WiFi56_objectSpread(WiFi56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.2 42.54a4.4 4.4 0 0 1-4.4-4.4 4.52 4.52 0 0 1 .39-1.81A4.4 4.4 0 1 0 32 42.14a4.43 4.43 0 0 1-1.81.4",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.13 26.24a22.81 22.81 0 0 0-32.26 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.27 32.11a14.53 14.53 0 0 0-20.54 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50 20.38a31.11 31.11 0 0 0-44 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.4 40.34a4.4 4.4 0 1 1-4.4-4.4 4.4 4.4 0 0 1 4.4 4.4Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WiFi56 = (WiFi56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Add104.tsx


var Add104_excluded = ["className"];
function Add104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Add104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Add104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Add104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Add104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Add104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Add104_objectSpread(Add104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M22.63 22.52c-.68 1.69-12.32 32.04 5.79 54.96C36.31 87.47 46.48 91.77 52 93.59c-4.12.05-10.3-.46-17.01-3.37-16.15-7.01-21.84-22.1-22.6-24.22-2.77-7.73-2.5-14.34-2.28-17 1.17-14.38 9.73-23.68 12.52-26.48Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "10",
        y: "10",
        width: "84",
        height: "84",
        rx: "42",
        ry: "42"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 37v30M67 52H37"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Add104 = (Add104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Add56.tsx


var Add56_excluded = ["className"];
function Add56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Add56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Add56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Add56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Add56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Add56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Add56_objectSpread(Add56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M12.9 12.76C8.53 22.91 9.5 34.04 15.69 41.6c4.19 5.11 9.6 7.15 12.45 7.97-2.04.14-5.37.1-9.05-1.37C11.3 45.09 8.18 38.08 7.5 36.42c-.45-1.09-1.81-4.68-1.57-9.43.1-1.96.39-7.71 4.59-12.18a15.5 15.5 0 0 1 2.38-2.06Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "6.14",
        y: "6",
        width: "44",
        height: "44",
        rx: "22",
        ry: "22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.14 20v16M36.14 28h-16"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Add56 = (Add56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/ChangePlan104.tsx


var ChangePlan104_excluded = ["className"];
function ChangePlan104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function ChangePlan104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ChangePlan104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ChangePlan104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function ChangePlan104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ChangePlan104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", ChangePlan104_objectSpread(ChangePlan104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M11.1 49.43c0-.2 1.24.42 1.33.47a3.17 3.17 0 0 1 1.44 1.54c1.25 2.54.85 5.32.72 8a60.31 60.31 0 0 0 .48 9.78c.33 2.84.63 5.79 1.95 8.37 1.2 2.32 3.55 3.24 5.86 4.11a3.83 3.83 0 0 1 2.52 3.34H12.63s-1.54-.51-1.54-3.58c0 .04 0-31.89.01-32.03ZM63.29 23.89s-6.7-11.13-17.75-10c0 0 12.14-7 21.16 9.2l-.13 1.15ZM56.86 57.06c0-.2 1.25.42 1.34.47a3.11 3.11 0 0 1 1.43 1.54c1.26 2.54.86 5.32.73 8a60.43 60.43 0 0 0 .48 9.79c.33 2.84.63 5.78 1.95 8.37 1.19 2.32 3.55 3.24 5.86 4.11a3.83 3.83 0 0 1 2.52 3.34H58.39s-1.53-.52-1.53-3.58Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m68.05 15.93-1.01 8.41-8.42-1.01"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36.74 20.71c2.79-5.63 9.77-9.07 16.36-8.28S65.67 18.21 67 24.34"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "11",
          y: "26.24",
          width: "36.23",
          height: "59.12",
          rx: "1.43"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.25 62.38h23.26M18.25 71.77h23.26M18.25 47.06a3.36 3.36 0 0 0 3.54 3.14 3.17 3.17 0 1 0 0-6.29 3.35 3.35 0 0 1-3.54-3.14 3.36 3.36 0 0 1 3.54-3.14 3.35 3.35 0 0 1 3.53 3.14M21.79 35.77v1.86M21.79 50.2v1.85"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "56.77",
          y: "33.87",
          width: "36.23",
          height: "59.12",
          rx: "1.43"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M64.02 70.01h23.26M64.02 79.39h23.26M64 54.69a3.56 3.56 0 1 0 3.53-3.15 3.17 3.17 0 1 1 3.54-3.14M67.55 43.4v1.85M67.55 57.83v1.85"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ChangePlan104 = (ChangePlan104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/ChangePlan56.tsx


var ChangePlan56_excluded = ["className"];
function ChangePlan56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function ChangePlan56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ChangePlan56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ChangePlan56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function ChangePlan56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ChangePlan56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", ChangePlan56_objectSpread(ChangePlan56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M6.55 26.66c0-.1.65.22.7.25a1.6 1.6 0 0 1 .75.81c.66 1.33.45 2.79.39 4.21a31.43 31.43 0 0 0 .24 5.13 12.75 12.75 0 0 0 1 4.39 5 5 0 0 0 3.07 2.15 2 2 0 0 1 1.32 1.76H7.35s-.8-.27-.8-1.88ZM33.92 13.27s-3.51-5.84-9.31-5.22c0 0 6.37-3.68 11.1 4.82l-.07.61ZM30.55 30.66c0-.1.65.22.7.25a1.6 1.6 0 0 1 .75.81c.66 1.33.45 2.79.39 4.21a31.43 31.43 0 0 0 .24 5.13 12.75 12.75 0 0 0 1 4.39 5 5 0 0 0 3.07 2.15 2 2 0 0 1 1.32 1.76h-6.7s-.8-.27-.8-1.88Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m36.41 9.09-.52 4.42-4.42-.53"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20 11.6a8.67 8.67 0 0 1 15.89 1.91"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "6.5",
          y: "14.5",
          width: "19",
          height: "31",
          rx: "1.43"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M10.3 33.45h12.2M10.3 38.37h12.2M10.3 25.42a1.76 1.76 0 0 0 1.86 1.65 1.66 1.66 0 1 0 0-3.3 1.76 1.76 0 0 1-1.86-1.65 1.76 1.76 0 0 1 1.86-1.65A1.76 1.76 0 0 1 14 22.12M12.16 19.5v.97M12.16 27.07v.97"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "30.5",
          y: "18.5",
          width: "19",
          height: "31",
          rx: "1.43"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.3 37.45h12.2M34.3 42.37h12.2M34.3 29.42a1.87 1.87 0 1 0 1.86-1.65A1.66 1.66 0 1 1 38 26.12M36.16 23.5v.97M36.16 31.07v.97"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ChangePlan56 = (ChangePlan56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Compare104.tsx


var Compare104_excluded = ["className"];
function Compare104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Compare104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Compare104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Compare104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Compare104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Compare104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Compare104_objectSpread(Compare104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M12.1 34c0-.29 1.83.62 2 .69A4.64 4.64 0 0 1 16.17 37c1.84 3.71 1.25 7.8 1.07 11.78a87.18 87.18 0 0 0 .7 14.35c.48 4.17.92 8.48 2.86 12.27 1.75 3.4 5.2 4.76 8.59 6a5.61 5.61 0 0 1 3.7 4.91H14.35S12.1 85.53 12.1 81ZM78.25 45.66a.37.37 0 0 1 .24.64L71.66 53s-1.82-1.45 1.9-5.19a.38.38 0 0 0-.27-.64c-3.19.1-12.9.33-14.4-.5a1.49 1.49 0 0 1-.25-2.2ZM48 58.27a.38.38 0 0 0-.26.63l6.41 6.91s2.31-1.43-1.67-5.25a.37.37 0 0 1 .28-.62c3-.08 11.65.29 13.36-.37 1-.39 1.79-1.63 1.44-1.86Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M60.39 31.58V14.73a2.68 2.68 0 0 0-2.68-2.68H14.78a2.68 2.68 0 0 0-2.68 2.68v68.93a2.68 2.68 0 0 0 2.68 2.68h42.93a2.68 2.68 0 0 0 2.68-2.68V72.43M65.9 92h23.21a2.76 2.76 0 0 0 2.79-2.72v-67a2.75 2.75 0 0 0-2.79-2.71H65.93M79.72 44.69H59.29M66.95 57.71H46.52"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m72.05 52.35 7.67-7.66-7.67-7.67M54.18 65.37l-7.66-7.66 7.66-7.66M21.32 52.83h15.82M21.32 63.82h15.82M21.3 36.34a3.82 3.82 0 0 0 4 3.58 3.83 3.83 0 0 0 4-3.58 3.84 3.84 0 0 0-4-3.59 3.82 3.82 0 0 1-4-3.59 3.83 3.83 0 0 1 4-3.58 3.84 3.84 0 0 1 4 3.58M25.33 23.46v2.12M25.33 39.92v2.12"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Compare104 = (Compare104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Compare56.tsx


var Compare56_excluded = ["className"];
function Compare56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Compare56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Compare56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Compare56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Compare56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Compare56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Compare56_objectSpread(Compare56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M6.52 18.3c0-.15 1 .33 1.05.38a2.49 2.49 0 0 1 1.14 1.21c1 2 .67 4.2.57 6.35A47.62 47.62 0 0 0 9.66 34a19.17 19.17 0 0 0 1.54 6.6c.94 1.84 2.8 2.57 4.63 3.25a3 3 0 0 1 2 2.64H7.73s-1.21-.41-1.21-2.83ZM42.14 24.59a.2.2 0 0 1 .13.34l-3.68 3.61s-1-.78 1-2.8a.2.2 0 0 0-.15-.34c-1.72.05-6.94.18-7.75-.27a.8.8 0 0 1-.13-1.19ZM25.86 31.38a.2.2 0 0 0-.14.34l3.45 3.72s1.24-.78-.9-2.83a.2.2 0 0 1 .15-.34c1.62 0 6.27.16 7.19-.19.54-.21 1-.88.78-1Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.52 17V7.93a1.45 1.45 0 0 0-1.45-1.44H8a1.44 1.44 0 0 0-1.48 1.44v37.12A1.44 1.44 0 0 0 8 46.49h23.07a1.45 1.45 0 0 0 1.45-1.44V39M35.48 49.51H48a1.48 1.48 0 0 0 1.5-1.46V12a1.48 1.48 0 0 0-1.5-1.49H35.5M42.92 24.06h-11M36.05 31.08h-11"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m38.8 28.19 4.12-4.13-4.12-4.12M29.17 35.2l-4.12-4.12 4.12-4.13M11.48 28.44H20M11.48 34.37H20M11.47 19.57a2.06 2.06 0 0 0 2.17 1.93 2.06 2.06 0 0 0 2.17-1.93 2.06 2.06 0 0 0-2.17-1.94 2.06 2.06 0 0 1-2.17-1.93 2.06 2.06 0 0 1 2.17-1.93 2.06 2.06 0 0 1 2.17 1.93M13.64 12.63v1.14M13.64 21.5v1.13"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Compare56 = (Compare56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Download104.tsx


var Download104_excluded = ["className"];
function Download104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Download104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Download104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Download104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Download104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Download104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Download104_objectSpread(Download104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M55.59 88.09c-3-1.9-6.66-2.07-9.77-3.77-13.3-7-16.13-23-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46A7.57 7.57 0 0 0 30.56 94H59c.18-2.38-1.4-4.62-3.41-5.91Z",
      className: "shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M86.75 46.12v9.33H51.24v-9.33"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.32 39.71 69 48.03l-8.32-8.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69 28.06v19.97"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69 61v27a6 6 0 0 1-6 6H29a6 6 0 0 1-6-6V16a6 6 0 0 1 6-6h34a6 6 0 0 1 6 6v6M40 90h12M44 14h4"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Download104 = (Download104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Download56.tsx


var Download56_excluded = ["className"];
function Download56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Download56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Download56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Download56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Download56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Download56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Download56_objectSpread(Download56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30 46.86c-1.54-1-3.45-1.07-5.05-2C18 41.31 16.56 33 15.51 26c-.31-1.74-.38-2.87-2.4-3v24c0 2.16.74 2.91 2.9 2.91h15.71A3.49 3.49 0 0 0 30 46.86Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37 34v13a3 3 0 0 1-3 3H16a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v2M24 8h2M22 48h6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.71 24.83v5.03H27.59v-5.03"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m41.63 21.38-4.48 4.48-4.48-4.48"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.15 15.11v10.75"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Download56 = (Download56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Edit104.tsx


var Edit104_excluded = ["className"];
function Edit104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Edit104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Edit104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Edit104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Edit104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Edit104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Edit104_objectSpread(Edit104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M92.24 30.77c4.4-4.4-.48-10.96-4.24-14.75-3.79-3.76-10.35-8.64-14.75-4.24l-4.49 4.49 18.98 18.98 4.49-4.49Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82.26 29.77 30.45 82.56s-9.11 7.6-19.7 10.77 24.7-5.77 24.7-5.77l52.3-52.29-5.5-5.5Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m11.41 86.1 6.51 6.51-7.84 1.34 1.33-7.85z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m87.76 35.26-52.31 52.3c-12.83 4.99-25.37 6.4-25.37 6.4s1.41-12.54 6.4-25.37l52.29-52.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m16.48 68.58 18.97 18.98M68.49 26.53 21.46 73.56M77.48 35.53 30.45 82.56M64.28 20.76l18.98 18.98 4.49-4.47-18.98-18.99-4.49 4.48z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m87.75 35.26 4.49-4.49c4.4-4.4-.48-10.96-4.24-14.75-3.79-3.76-10.35-8.64-14.75-4.24l-4.49 4.49",
        className: "strokesecondary"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Edit104 = (Edit104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Edit56.tsx


var Edit56_excluded = ["className"];
function Edit56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Edit56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Edit56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Edit56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Edit56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Edit56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Edit56_objectSpread(Edit56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.41 16.9c2.31-2.31-.25-5.74-2.22-7.73-1.99-1.97-5.42-4.53-7.73-2.22L37.11 9.3l9.95 9.95 2.35-2.35Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.18 16.37 17.02 44.04s-4.78 3.98-10.33 5.65c-5.55 1.66 12.95-3.02 12.95-3.02l27.42-27.41-2.88-2.88Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m7.04 45.9 3.41 3.41-4.1.7.69-4.11z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47.06 19.25 19.64 46.66c-6.73 2.61-13.3 3.35-13.3 3.35s.74-6.57 3.35-13.3L37.1 9.29"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m9.7 36.72 9.94 9.94M36.96 14.67 12.31 39.33M41.68 19.39 17.02 44.04M34.75 11.65l9.95 9.95 2.36-2.35-9.95-9.95-2.36 2.35z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m47.06 19.25 2.35-2.35c2.31-2.31-.25-5.74-2.22-7.73-1.99-1.97-5.42-4.53-7.73-2.22L37.11 9.3"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Edit56 = (Edit56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Home104.tsx


var Home104_excluded = ["className"];
function Home104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Home104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Home104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Home104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Home104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Home104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Home104_objectSpread(Home104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.09 11.76a2.77 2.77 0 0 1 3.61-.17l.21.17 40.54 38.7a2.76 2.76 0 0 1-3.6 4.18l-.22-.18L52 17.58 13.37 54.46a2.76 2.76 0 0 1-3.7.1l-.21-.19a2.76 2.76 0 0 1-.1-3.7l.19-.21ZM35.34 87.47q5.19 2.76 14.82 3.87V93H28v-5.53ZM58.28 56.15Q61.07 72.28 76 74.57H58.28Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "43.71",
        cy: "72.73",
        r: "1.84",
        className: "strokeinverted"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M85.17 49.29V93H18.91v-3.33l-.08-40.38"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M57.53 56.15h18.43v18.43H57.53zM29.89 56.15h18.43v31.33H29.89z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28.04 87.47h22.11V93H28.04zM11.46 93h81.08M23.76 36.85V19.3h9.59v8.46l-9.59 9.09z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.09 11.76a2.77 2.77 0 0 1 3.61-.17l.21.17 40.54 38.7a2.76 2.76 0 0 1-3.6 4.18l-.22-.18L52 17.58 13.37 54.46a2.76 2.76 0 0 1-3.7.1l-.21-.19a2.76 2.76 0 0 1-.1-3.7l.19-.21Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Home104 = (Home104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Home56.tsx


var Home56_excluded = ["className"];
function Home56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Home56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Home56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Home56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Home56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Home56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Home56_objectSpread(Home56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.42 6a1.49 1.49 0 0 1 2-.09l.11.09 22 21a1.5 1.5 0 0 1-2 2.27l-.12-.1-21-20-21 20a1.49 1.49 0 0 1-2 .06l-.12-.11a1.5 1.5 0 0 1 0-2l.1-.11ZM19.42 47.13a23.06 23.06 0 0 0 8 2.1v.9h-12v-3ZM31.87 30.13q1.52 8.75 9.59 10h-9.59Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.96",
        cy: "39.13",
        r: "1",
        className: "strokeinverted"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.46 26.41v23.72H10.5v-1.81l-.04-21.91"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.46 30.13h10v10h-10zM16.46 30.13h10v17h-10zM15.46 47.13h12v3h-12zM6.46 50.13h44M13.13 19.66v-9.53h5.21v4.6l-5.21 4.93z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.42 6a1.49 1.49 0 0 1 2-.09l.11.09 22 21a1.5 1.5 0 0 1-2 2.27l-.12-.1-21-20-21 20a1.49 1.49 0 0 1-2 .06l-.12-.11a1.5 1.5 0 0 1 0-2l.1-.11Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Home56 = (Home56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/IOTUpdate104.tsx


var IOTUpdate104_excluded = ["className"];
function IOTUpdate104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function IOTUpdate104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? IOTUpdate104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : IOTUpdate104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function IOTUpdate104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, IOTUpdate104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", IOTUpdate104_objectSpread(IOTUpdate104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.95 61.24c0-2.83-6.78-4.47-9.61-4.47l-9.91-.7a12.75 12.75 0 0 1-11.98-8.54c-1.78-5.1-.14-10.76 4.07-14.14a5.149 5.149 0 0 0 2.01-3.37c.3-2.41 1.16-6.22 3.81-8.02 2.65-2.15 5.88-3.46 9.28-3.75 2.01 0 2.49 1.2 5.53 1.72 3.39.6 6.46-4.13-.98-6.96A22.626 22.626 0 0 0 38.29 11a17.27 17.27 0 0 0-12.41 4.99 17.748 17.748 0 0 0-5.29 12.45v.98a16.847 16.847 0 0 0-8.4 18.99c1.9 7.51 8.67 12.75 16.42 12.71h25.33v.1Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.29 30.27s-1.14 1.86.16 2.75c1.3.88 7.12 2.93 7.88 8.02.62 4.01 3.09 5.23 3.79 4.57.7-.66 1.18-4.93-3.23-9.4a25.71 25.71 0 0 0-8.6-5.94Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.94 20.35s1 2.33 2.71 2.01c1.7-.32 8.94-3.73 13.42-.12 3.53 2.83 6.42 2.01 6.5.86.08-1.14-2.79-4.95-9.71-5.27-4.44-.1-8.84.77-12.91 2.53Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M81.28 82.72c-.21.04-.42.06-.63.07a3.175 3.175 0 0 1-3.11-3.85c.13-.3 0-.4-.37-.3a3.2 3.2 0 0 0-1.28 3.01 3.182 3.182 0 0 0 5.72 1.44c.11-.34-.03-.44-.33-.37Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.98 90.81c-.21.04-.42.06-.63.07a3.175 3.175 0 0 1-3.11-3.85c.13-.3 0-.4-.37-.3a3.2 3.2 0 0 0-1.28 3.01 3.182 3.182 0 0 0 5.72 1.44c.11-.34-.03-.44-.33-.37Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.06 86.02c-.21.04-.42.06-.63.07a3.175 3.175 0 0 1-3.11-3.85c.13-.3 0-.4-.37-.3a3.2 3.2 0 0 0-1.28 3.01 3.182 3.182 0 0 0 5.72 1.44c.11-.34-.03-.44-.33-.37Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.11 61.26h3.51c8.05.2 14.88-5.86 15.62-13.88.75-8.02-4.85-15.24-12.8-16.52-.9-5.52-4.61-10.17-9.79-12.28s-11.08-1.37-15.58 1.96a17.488 17.488 0 0 0-15.38-9.4c-4.64-.07-9.11 1.73-12.41 4.99a17.748 17.748 0 0 0-5.29 12.45v.98a16.847 16.847 0 0 0-8.4 18.99c1.9 7.51 8.67 12.75 16.42 12.71h34.16"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.03 23.07c-.89-2.87-2.49-5.37-4.57-7.34"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m29.32 83.25 2.35-1.12.3-.16a9.6 9.6 0 0 0 4.41-8.14V61.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "25.15",
        cy: "84.14",
        r: "4.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68 61.36v9.47a9.624 9.624 0 0 0 4.41 8.14l.3.16 2.49 1.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "79.21",
        cy: "81.07",
        r: "4.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52.08",
        cy: "88.99",
        r: "4.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.88 61.72v22.66"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_IOTUpdate104 = (IOTUpdate104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/IOTUpdate56.tsx


var IOTUpdate56_excluded = ["className"];
function IOTUpdate56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function IOTUpdate56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? IOTUpdate56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : IOTUpdate56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function IOTUpdate56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, IOTUpdate56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", IOTUpdate56_objectSpread(IOTUpdate56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.04 32.96c0-1.52-3.64-2.4-5.15-2.4l-5.32-.38a6.844 6.844 0 0 1-6.43-4.58 6.815 6.815 0 0 1 2.19-7.58c.58-.44.97-1.09 1.08-1.81.16-1.29.62-3.34 2.04-4.3a9.128 9.128 0 0 1 4.98-2.01c1.08 0 1.33.65 2.97.93 1.82.32 3.46-2.22-.53-3.73a12.17 12.17 0 0 0-4.23-1.08c-2.49-.04-4.89.93-6.66 2.68a9.557 9.557 0 0 0-2.84 6.68v.53a9.035 9.035 0 0 0 4.3 17.01h13.59v.05Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.64 16.34s-.61 1 .09 1.47 3.82 1.57 4.23 4.3c.33 2.15 1.66 2.81 2.03 2.45.38-.36.63-2.65-1.73-5.05-1.3-1.37-2.87-2.45-4.62-3.19Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.51 11.02s.54 1.25 1.45 1.08c.91-.17 4.8-2 7.2-.06 1.89 1.52 3.44 1.08 3.49.46.04-.61-1.5-2.66-5.21-2.83-2.38-.05-4.74.41-6.93 1.36Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.71 44.5c-.11.02-.23.04-.34.04a1.73 1.73 0 0 1-1.69-2.09c.07-.16 0-.22-.2-.16-.51.37-.79 1-.7 1.64a1.74 1.74 0 0 0 3.12.79c.06-.19-.01-.24-.18-.2Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.2 48.76c-.11.02-.23.04-.34.04a1.73 1.73 0 0 1-1.69-2.09c.07-.16 0-.22-.2-.16-.51.37-.79 1-.7 1.64a1.74 1.74 0 0 0 3.12.79c.06-.19-.01-.24-.18-.2Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.67 46.17c-.11.02-.23.04-.34.04a1.73 1.73 0 0 1-1.69-2.09c.07-.16 0-.22-.2-.16-.51.37-.79 1-.7 1.64a1.74 1.74 0 0 0 3.12.79c.06-.19-.01-.24-.18-.2Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.33 32.97h1.89a8.21 8.21 0 0 0 8.38-7.45c.4-4.3-2.6-8.18-6.87-8.87-.48-2.96-2.47-5.46-5.25-6.59s-5.95-.73-8.36 1.05a9.4 9.4 0 0 0-8.25-5.05c-2.49-.04-4.89.93-6.66 2.68a9.557 9.557 0 0 0-2.84 6.68v.53a9.035 9.035 0 0 0 4.3 17.01h18.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.63 12.48a9.28 9.28 0 0 0-1.21-2.49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m15.83 44.77 1.26-.6.16-.09c1.48-.96 2.38-2.6 2.37-4.37v-6.46"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.59 33.02v5.08c0 1.77.88 3.41 2.37 4.37l.16.09 1.33.63"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "13.59",
        cy: "45.24",
        r: "2.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "42.6",
        cy: "43.6",
        r: "2.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28.04",
        cy: "47.85",
        r: "2.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.94 33.21v12.16"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_IOTUpdate56 = (IOTUpdate56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Pin104.tsx


var Pin104_excluded = ["className"];
function Pin104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Pin104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Pin104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Pin104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Pin104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Pin104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Pin104_objectSpread(Pin104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M61.6 88.1c-3-1.9-6.7-2.1-9.8-3.8-13.3-7-16.1-23-18.2-36.5-.6-3.4-.7-5.5-4.6-5.9v44.5c0 4.2 3.4 7.6 7.5 7.6H65c.2-2.4-1.4-4.6-3.4-5.9zM55.3 44.6c-3.1-.3-6-1.8-8-4.2-.5.7-.8 1.6-1 2.4 1.5 1.5 3.6 2.4 5.8 2.4 1.1 0 2.2-.2 3.2-.6zM51.1 38.5c1.4 0 2.6-.1 2.8-1.5h-.4c-1.6 0-2.8-1.3-2.8-2.8v-.4c-1.3.2-1.5 1.4-1.5 2.8 0 .9 1.9 1.9 1.9 1.9z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35 10h34c3.3 0 6 2.7 6 6v72c0 3.3-2.7 6-6 6H35c-3.3 0-6-2.7-6-6V16c0-3.3 2.7-6 6-6zM50 14h4M46 90h12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M57.8 43.5c-.5-3.2-3.5-5.4-6.7-4.9-2.5.4-4.5 2.4-4.9 4.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M60 38c0 4.4-3.6 8-8 8s-8-3.6-8-8 3.6-8 8-8 8 3.6 8 8z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M54.8 35.7c0 1.6-1.3 2.8-2.8 2.8-1.6 0-2.8-1.3-2.8-2.8 0-1.6 1.3-2.8 2.8-2.8 1.6-.1 2.8 1.2 2.8 2.8 0-.1 0-.1 0 0z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M65.2 51.7h4.6c.6 0 1 .4 1 1V61c0 .6-.4 1-1 1h-4.6c-.6 0-1-.4-1-1v-8.3c0-.6.5-1 1-1z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.2 51.7h4.6c.6 0 1 .4 1 1V61c0 .6-.4 1-1 1h-4.6c-.6 0-1-.4-1-1v-8.3c0-.6.4-1 1-1z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.5 51.7h4.6c.6 0 1 .4 1 1V61c0 .6-.4 1-1 1h-4.6c-.6 0-1-.4-1-1v-8.3c0-.6.5-1 1-1z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M54.9 51.7h4.6c.6 0 1 .4 1 1V61c0 .6-.4 1-1 1h-4.6c-.6 0-1-.4-1-1v-8.3c0-.6.4-1 1-1z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M67.5 58.2c-.8 0-1.4-.6-1.4-1.4 0-.8.6-1.4 1.4-1.4.8 0 1.4.6 1.4 1.4 0 .8-.6 1.4-1.4 1.4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M58.6 56.8c-.1-.8-.8-1.4-1.5-1.3-.7.1-1.2.6-1.3 1.3-.1.8.5 1.5 1.3 1.5.8.1 1.5-.5 1.5-1.3v-.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.9 56.8c0-.8-.6-1.4-1.4-1.4-.8 0-1.4.6-1.4 1.4 0 .8.6 1.4 1.4 1.4.7 0 1.4-.6 1.4-1.4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.2 56.8c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4.6 1.4 1.4 1.4c.8 0 1.4-.6 1.4-1.4"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Pin104 = (Pin104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Pin56.tsx


var Pin56_excluded = ["className"];
function Pin56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Pin56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Pin56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Pin56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Pin56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Pin56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Pin56_objectSpread(Pin56_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M10.8 39.8s-.7 6.2-.1 6.2h4.9c-2.9-.6-4.9-3.2-4.8-6.2zM20.5 39.8s-.7 6.2-.1 6.2h4.9c-2.9-.6-4.9-3.2-4.8-6.2zM30.3 39.8s-.7 6.2-.1 6.2h4.9c-2.9-.6-4.9-3.2-4.8-6.2zM40 39.8s-.7 6.2-.1 6.2h4.9c-2.9-.6-4.9-3.2-4.8-6.2zM23.6 26.5c-.5.7-.8 1.5-.9 2.3 2.2 2.2 5.5 2.9 8.4 1.7-2.9-.4-5.6-1.8-7.5-4zM27.1 23.9c1.3 0 2.5-.1 2.6-1.4h-.4c-1.5 0-2.6-1.2-2.6-2.6v-.4c-1.3.2-1.4 1.3-1.4 2.6.1 1 1.8 1.8 1.8 1.8z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.5 28.6c-.4-3-3.2-5.1-6.2-4.6-2.4.4-4.3 2.2-4.6 4.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.5 23.5c0 4.1-3.4 7.5-7.5 7.5s-7.5-3.4-7.5-7.5S23.9 16 28 16s7.5 3.4 7.5 7.5z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.6 21.3c0 1.5-1.2 2.7-2.6 2.7-1.5 0-2.7-1.2-2.7-2.6 0-1.5 1.2-2.7 2.6-2.7 1.6-.1 2.7 1.1 2.7 2.6z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M7 47.7V13c0-3.3 2.7-6 6-6h30c3.3 0 6 2.7 6 6v34.7M26.2 10.6h3.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40.4 36.3h4.3c.5 0 .9.4.9.9V45c0 .5-.4.9-.9.9h-4.3c-.5 0-.9-.4-.9-.9v-7.8c0-.5.4-.9.9-.9z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M11.3 36.3h4.3c.5 0 .9.4.9.9V45c0 .5-.4.9-.9.9h-4.3c-.5 0-.9-.4-.9-.9v-7.8c0-.5.4-.9.9-.9z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21 36.3h4.3c.5 0 .9.4.9.9V45c0 .5-.4.9-.9.9H21c-.5 0-.9-.4-.9-.9v-7.8c0-.5.4-.9.9-.9z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.7 36.3H35c.5 0 .9.4.9.9V45c0 .5-.4.9-.9.9h-4.3c-.5 0-.9-.4-.9-.9v-7.8c0-.5.4-.9.9-.9z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42.6 42.1c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9-.4.9-.9.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.8 41.2c0-.5-.4-.9-.9-.9s-.9.4-.9.9.4.9.9.9.9-.4.9-.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M14.4 41.2c0-.5-.4-.9-.9-.9s-.9.4-.9.9.4.9.9.9.9-.4.9-.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.1 41.2c0-.5-.4-.9-.9-.9s-.9.4-.9.9.4.9.9.9.9-.4.9-.9"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Pin56 = (Pin56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Preferences104.tsx


var Preferences104_excluded = ["className"];
function Preferences104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Preferences104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Preferences104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Preferences104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Preferences104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Preferences104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Preferences104_objectSpread(Preferences104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.69 50.18c0-.69 1.36-1.67 1.95-1.73C24.06 48.08 23.36 61.51 24 64c1.06 4.25 2 9.24 5.15 12.55 2.83 3 6.93 4.4 10.94 4.88 3.46.41 9.58-.3 13.17.38 4 .77 5.17 5.15-.1 5.15H26.74S18.2 81.3 18.2 75.32c0 0 .49-24.7.49-25.14",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.18 55.9v17.92"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.18 31.3v12.59"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M52.72 66.68v7.14"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M52.72 31.3v23.36"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M70.54 48.44v25.38"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M70.54 31.3v6.33"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M76 43a5.41 5.41 0 1 1-5.41-5.41A5.41 5.41 0 0 1 76 43Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M58.72 60.67a6 6 0 1 1-6-6 6 6 0 0 1 6 6Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41.18 49.89a6 6 0 1 1-6-6 6 6 0 0 1 6 6Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "18.72",
          y: "19.76",
          width: "67.6",
          height: "66.56",
          rx: "12.48"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Preferences104 = (Preferences104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Preferences56.tsx


var Preferences56_excluded = ["className"];
function Preferences56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Preferences56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Preferences56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Preferences56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Preferences56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Preferences56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Preferences56_objectSpread(Preferences56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.74 24.77c0-.38.73-.9 1-.94 1.83-.19 1.45 7 1.78 8.35.57 2.28 1.09 5 2.76 6.75a9.5 9.5 0 0 0 5.86 2.62c1.85.22 5.13-.16 7 .2 2.17.41 2.77 2.77 0 2.77l-12.93-.26s-5.78-2.76-5.78-6c0 0 .26-13.28.26-13.51",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36.76 44.52H19.24a7.76 7.76 0 0 1-7.76-7.76V19.24a7.75 7.75 0 0 1 7.76-7.76h17.52a7.76 7.76 0 0 1 7.76 7.76v17.52a7.77 7.77 0 0 1-7.76 7.76Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19.64 29.6v8.62"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19.64 17.78v6.05"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28.08 17.78v11.23"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36.64 26.02v12.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.24 23.42a2.6 2.6 0 1 1-2.6-2.6 2.59 2.59 0 0 1 2.6 2.6Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31 31.9a2.89 2.89 0 1 1-2.92-2.9A2.89 2.89 0 0 1 31 31.9Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.53 26.72a2.89 2.89 0 1 1-2.89-2.89 2.88 2.88 0 0 1 2.89 2.89Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28.08 34.79v3.43"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36.64 17.78v3.04"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Preferences56 = (Preferences56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Profile104.tsx


var Profile104_excluded = ["className"];
function Profile104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Profile104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Profile104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Profile104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Profile104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Profile104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Profile104_objectSpread(Profile104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M52 55.89A14.52 14.52 0 0 0 59.2 54a23.66 23.66 0 0 1-19.88-19.9A14.58 14.58 0 0 0 52 55.89ZM27.83 68.7a29 29 0 0 0-4.72 12.19 40.86 40.86 0 0 0 44.6 8.83A59.24 59.24 0 0 1 27.83 68.7Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "52",
          cy: "52",
          r: "40.86"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "52",
          cy: "41.3",
          r: "14.59"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M52 92.86a40.74 40.74 0 0 0 28.87-12 29.18 29.18 0 0 0-57.76 0 40.74 40.74 0 0 0 28.89 12Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Profile104 = (Profile104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Profile56.tsx


var Profile56_excluded = ["className"];
function Profile56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Profile56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Profile56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Profile56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Profile56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Profile56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Profile56_objectSpread(Profile56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28 30.1a7.86 7.86 0 0 0 3.88-1 12.75 12.75 0 0 1-10.71-10.74A7.85 7.85 0 0 0 28 30.1ZM15 37a15.81 15.81 0 0 0-2.54 6.57 22 22 0 0 0 24 4.75A31.94 31.94 0 0 1 15 37Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "28",
          cy: "28",
          r: "22"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "28",
          cy: "22.24",
          r: "7.86"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28 50a22 22 0 0 0 15.55-6.43 15.72 15.72 0 0 0-31.11 0A21.9 21.9 0 0 0 28 50Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Profile56 = (Profile56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Search104.tsx


var Search104_excluded = ["className"];
function Search104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Search104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Search104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Search104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Search104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Search104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Search104_objectSpread(Search104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M77.14 64.27a51.76 51.76 0 0 1-7.81 9.13c-18.09 13.09-52.41 2.6-59-28.8a35.93 35.93 0 0 0 51.61 33.87C72.42 90.3 74.07 91.94 74.07 91.94s3.88 1.94 7.35 0c-1.94-2.79 3.66-24.86-4.28-27.67ZM62 78.44a35.49 35.49 0 0 0 5-3c-2.45 2.05-4.4 3.22-5 3Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M54.51 74.31c-23.95 7-43.8-48-16.47-56a29.2 29.2 0 0 0 16.47 56Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m78.91 61.88 12.57 11.17a6.56 6.56 0 0 1 .77 9.13c-1.33 1.63-3 3.47-4.77 5.3s-3.67 3.44-5.3 4.77a6.56 6.56 0 0 1-9.13-.77L62.17 78.94"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M66.83 25.54a29.2 29.2 0 1 1-41.29 0 29.18 29.18 0 0 1 41.29 0Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M71.59 20.78a35.93 35.93 0 1 1-50.81 0 35.93 35.93 0 0 1 50.81 0Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Search104 = (Search104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Search56.tsx


var Search56_excluded = ["className"];
function Search56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Search56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Search56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Search56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Search56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Search56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Search56_objectSpread(Search56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.58 35.55c-1.43 2.73-4.92 5-5.4 4.54 5.15 5.59 7 7.36 7 7.36s1.71 1.08 3 .56c-3.03-2.13-1.18-10.73-4.6-12.46ZM19.16 14.94c-5.86 5.28-8 11.09-2.69 18.36 5.35 5.85 12.68 4.52 18.54-.76-9.07 8.17-26.2-8.27-15.85-17.6Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m40 33.24 7 6.4c1.48 1.34 2 3.31 1.13 4.44a18.77 18.77 0 0 1-4 4c-1.13.85-3.09.35-4.44-1.13L33.38 40"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.06 13.4a16.73 16.73 0 1 1-23.66 0 16.72 16.72 0 0 1 23.66 0Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.58 16.88a11.81 11.81 0 1 1-16.7 0 11.81 11.81 0 0 1 16.7 0Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Search56 = (Search56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Services104.tsx


var Services104_excluded = ["className"];
function Services104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Services104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Services104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Services104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Services104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Services104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Services104_objectSpread(Services104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M76 57.46a17.42 17.42 0 0 1-9.09-.05c-6.79-1.82-11.51-7.18-12-13a13.67 13.67 0 0 0 10.01 15.81A14.12 14.12 0 0 0 73 60l3-1c.62-.11 3.2-3 3.39-3.58Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M67.72 51.57a8.12 8.12 0 0 0 5.07-.31l1.84-.74A9.07 9.07 0 0 0 76.82 48l-2.16 1.46a9.91 9.91 0 0 1-5.67.15 9.68 9.68 0 0 1-7.25-8.77c-1.02 4.8 1.56 9.55 5.98 10.73ZM55.59 88.09c-3-1.9-6.66-2.07-9.77-3.77-13.3-7-16.13-23-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46A7.57 7.57 0 0 0 30.56 94H59c.18-2.38-1.4-4.62-3.41-5.91Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M69.15 30.16A15.16 15.16 0 1 1 54 45.31"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M76.73 45.31a7.58 7.58 0 1 1-7.58-7.57 7.58 7.58 0 0 1 7.58 7.57Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M69 67v21a6 6 0 0 1-6 6H29a6 6 0 0 1-6-6V16a6 6 0 0 1 6-6h34a6 6 0 0 1 6 6v8M44 14h4M40 90h12"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Services104 = (Services104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Services56.tsx


var Services56_excluded = ["className"];
function Services56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Services56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Services56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Services56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Services56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Services56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Services56_objectSpread(Services56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30 46.86c-1.54-1-3.45-1.07-5.05-2C18 41.31 16.56 33 15.51 26c-.31-1.74-.38-2.87-2.4-3v24c0 2.16.74 2.91 2.9 2.91h15.71A3.49 3.49 0 0 0 30 46.86ZM40.9 30.94a9.37 9.37 0 0 1-4.9 0c-3.65-1-6.2-3.86-6.47-7A7.37 7.37 0 0 0 35 32.43a7.58 7.58 0 0 0 4.36-.12l1.58-.52a6.81 6.81 0 0 0 1.82-1.92Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36.46 27.77a4.31 4.31 0 0 0 2.73-.17l1-.4a4.91 4.91 0 0 0 1.17-1.37l-1.16.78a5.3 5.3 0 0 1-7-4.63 4.83 4.83 0 0 0 3.26 5.79Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37 36v11a3 3 0 0 1-3 3H16a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v4M24 8h2M22 48h6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.24 16.24a8.16 8.16 0 1 1-8.16 8.16"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41.32 24.4a4.08 4.08 0 1 1-4.08-4.08 4.08 4.08 0 0 1 4.08 4.08Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Services56 = (Services56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Settings104.tsx


var Settings104_excluded = ["className"];
function Settings104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Settings104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Settings104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Settings104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Settings104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Settings104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Settings104_objectSpread(Settings104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M55.59 88.09c-3-1.9-6.66-2.07-9.77-3.77-13.3-7-16.13-23-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46A7.57 7.57 0 0 0 30.56 94H59c.18-2.38-1.4-4.62-3.41-5.91ZM65.17 31.23l-.09-.09a3 3 0 0 0-4.21 0 3 3 0 0 0 0 4.21l.09.09a2.45 2.45 0 0 1 .49 2.71v.11a2.44 2.44 0 0 1-2.24 1.49h-.09A3.1 3.1 0 0 0 56 42.42a3 3 0 0 0 3 3.28h.14a2.48 2.48 0 0 1 1.75 4.2l-.09.09a3 3 0 0 0 0 4.21 3 3 0 0 0 4.21 0l.09-.09a2.45 2.45 0 0 1 2.71-.49c-7.62-7.06-2.64-22.39-2.64-22.39Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M69 65v23a6 6 0 0 1-6 6H29a6 6 0 0 1-6-6V16a6 6 0 0 1 6-6h34a6 6 0 0 1 6 6v5M44 14h4M40 90h12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M71.67 37.27a5.46 5.46 0 1 1-5.46 5.46 5.45 5.45 0 0 1 5.46-5.46Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M82.67 47.19a2.46 2.46 0 0 0 .5 2.71l.08.09a3 3 0 0 1 0 4.2 3 3 0 0 1-4.2 0l-.05-.08a2.48 2.48 0 0 0-4.2 1.75v.26a3 3 0 0 1-6 0V56a2.58 2.58 0 0 0-4.31-1.75l-.09.09a3 3 0 0 1-4.21 0 3 3 0 0 1 0-4.21l.09-.09a2.48 2.48 0 0 0-1.76-4.2h-.25a3 3 0 1 1 0-6h.13a2.57 2.57 0 0 0 1.76-4.31l-.09-.09a3 3 0 0 1 0-4.21 3 3 0 0 1 4.21 0l.09.09a2.45 2.45 0 0 0 2.7.49h.12a2.46 2.46 0 0 0 1.49-2.25v-.25a3 3 0 1 1 6 0v.13a2.48 2.48 0 0 0 4.2 1.76l.09-.09a3 3 0 0 1 4.2 0 3 3 0 0 1 0 4.21l-.09.09a2.44 2.44 0 0 0-.49 2.71v.11a2.43 2.43 0 0 0 2.24 1.49h.25a3 3 0 1 1 0 6h-.13a2.47 2.47 0 0 0-2.28 1.47Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Settings104 = (Settings104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Settings56.tsx


var Settings56_excluded = ["className"];
function Settings56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Settings56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Settings56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Settings56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Settings56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Settings56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Settings56_objectSpread(Settings56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30 46.86c-1.54-1-3.45-1.07-5.05-2C18 41.31 16.56 33 15.51 26c-.31-1.74-.38-2.87-2.4-3v24c0 2.16.74 2.91 2.9 2.91h15.71A3.49 3.49 0 0 0 30 46.86ZM35.09 16.81h-.05a1.59 1.59 0 0 0-2.26 0 1.59 1.59 0 0 0 0 2.26 1.32 1.32 0 0 1 .27 1.46v.06a1.31 1.31 0 0 1-1.21.8 1.67 1.67 0 0 0-1.69 1.44 1.6 1.6 0 0 0 1.59 1.77h.08a1.33 1.33 0 0 1 .94 2.26v.05a1.61 1.61 0 0 0 0 2.26 1.6 1.6 0 0 0 2.27 0l.05-.05a1.33 1.33 0 0 1 1.46-.26c-4.13-3.79-1.45-12.05-1.45-12.05Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37 35v12a3 3 0 0 1-3 3H16a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v2M24 8h2M22 48h6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.59 20.07A2.94 2.94 0 1 1 35.65 23a2.94 2.94 0 0 1 2.94-2.93Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.52 25.41a1.32 1.32 0 0 0 .26 1.46v.05a1.59 1.59 0 0 1 0 2.26 1.6 1.6 0 0 1-2.27 0l-.05-.05a1.33 1.33 0 0 0-2.25.95v.14a1.61 1.61 0 0 1-3.21 0v-.08a1.32 1.32 0 0 0-.86-1.21 1.34 1.34 0 0 0-1.46.27v.05a1.61 1.61 0 0 1-2.26 0 1.62 1.62 0 0 1 0-2.27l.05-.05a1.33 1.33 0 0 0 .27-1.46 1.35 1.35 0 0 0-1.21-.8h-.14a1.6 1.6 0 1 1 0-3.2h.07a1.39 1.39 0 0 0 .95-2.32 1.6 1.6 0 0 1 0-2.27 1.6 1.6 0 0 1 2.27 0v.05a1.32 1.32 0 0 0 1.46.26h.07a1.31 1.31 0 0 0 .8-1.21v-.18a1.6 1.6 0 0 1 3.2 0v.07a1.33 1.33 0 0 0 2.26.94 1.59 1.59 0 0 1 2.26 0 1.61 1.61 0 0 1 0 2.26h-.05a1.34 1.34 0 0 0-.27 1.46v.06a1.34 1.34 0 0 0 1.21.81h.14a1.6 1.6 0 0 1 0 3.2h-.07a1.32 1.32 0 0 0-1.17.81Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Settings56 = (Settings56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Switch104.tsx


var Switch104_excluded = ["className"];
function Switch104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Switch104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Switch104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Switch104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Switch104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Switch104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Switch104_objectSpread(Switch104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.45 69.35c-4 .57-5.87-1.16-7.68-3a11.12 11.12 0 0 1-3.71.64 11.4 11.4 0 0 1-11.4-11.31 14.07 14.07 0 0 0-6.18 1.53 17.06 17.06 0 0 0 17 15.44h22.31s-.95-4.65-10.34-3.3Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M62.37 28.66V20.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M69.49 29.59 71.52 22"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m76.12 32.34 3.94-6.81"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m81.83 36.7 5.56-5.56"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m86.2 42.4 6.81-3.93"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m88.96 49.03 7.59-2.04"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M89.9 56.15h7.87"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M63 72.6H27.46a17.07 17.07 0 0 1 0-34.13H63a17.07 17.07 0 1 1 0 34.13Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.46 55.54a11.4 11.4 0 1 1-11.4-11.4 11.41 11.41 0 0 1 11.4 11.4Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M51.13 55.54h15.83"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m60.44 49.02 6.52 6.52-6.52 6.52"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Switch104 = (Switch104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Switch56.tsx


var Switch56_excluded = ["className"];
function Switch56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Switch56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Switch56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Switch56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Switch56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Switch56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Switch56_objectSpread(Switch56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.77 37c-2.81.4-4.1-.81-5.36-2.13a7.93 7.93 0 0 1-10.54-7.39 9.74 9.74 0 0 0-4.32 1.06A11.91 11.91 0 0 0 15.4 39.31H31s-.68-3.2-7.23-2.31Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40.2 39.3H15.4a11.9 11.9 0 0 1 0-23.8h24.8a11.9 11.9 0 1 1 0 23.8Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.77 27.4a8 8 0 1 1-7.95-7.95 8 8 0 0 1 7.95 7.95Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.91 27.4h11.05"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m38.41 22.85 4.55 4.55-4.55 4.55"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Switch56 = (Switch56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/TransferRequest104.tsx


var TransferRequest104_excluded = ["className"];
function TransferRequest104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function TransferRequest104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TransferRequest104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TransferRequest104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function TransferRequest104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TransferRequest104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", TransferRequest104_objectSpread(TransferRequest104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.44 40.44v25.75a4 4 0 0 0 4 4h18.1a1.34 1.34 0 0 0 .52-2.57c-8.91-3.75-22.62-12-22.62-27.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47.31 64v25.75a4 4 0 0 0 4 4H69.4a1.34 1.34 0 0 0 .52-2.57C61 87.44 47.31 79.2 47.31 64"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M59.87 60.91C61.1 66 64.46 71.42 70.23 73.57a1 1 0 0 1-.38 2C66 75.42 60.33 73.64 58.54 69a12.32 12.32 0 0 1-.66-8.14 1 1 0 0 1 2 0"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m30.89 81.8 6.1 6.1-6.1 6.1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.65 87.9h-15.8q-6.77 0-6.77-6.77V61.56"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m64.08 63.24 4.14 4.14 9.25-9.25"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M92.86 45.83v44.46a2.79 2.79 0 0 1-2.75 2.83H50a2.8 2.8 0 0 1-2.75-2.83V37.67A2.79 2.79 0 0 1 50 34.84h32.7a1.36 1.36 0 0 1 1 .44l8.8 9.57a1.48 1.48 0 0 1 .36.98Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M82.22 35.64v8A2.85 2.85 0 0 0 85 46.56h7.18"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.81 69.28h-21.6a2.74 2.74 0 0 1-2.79-2.68V13.69A2.74 2.74 0 0 1 25.21 11h41.08a2.73 2.73 0 0 1 2.78 2.69v20.73"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "70.04",
          cy: "62.76",
          r: "12.87"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TransferRequest104 = (TransferRequest104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/TransferRequest56.tsx


var TransferRequest56_excluded = ["className"];
function TransferRequest56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function TransferRequest56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TransferRequest56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TransferRequest56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function TransferRequest56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TransferRequest56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", TransferRequest56_objectSpread(TransferRequest56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M13 21.6v13.71a2.14 2.14 0 0 0 2.14 2.15h9.66a.72.72 0 0 0 .28-1.38c-4.74-2-12-6.38-12-14.48"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M25.74 34.15v13.71A2.14 2.14 0 0 0 27.89 50h9.62a.71.71 0 0 0 .28-1.37c-4.75-2-12-6.39-12-14.48"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.43 32.5A9.4 9.4 0 0 0 38 39.24a.55.55 0 0 1-.2 1.06c-2.07-.07-5.07-1-6-3.49a6.5 6.5 0 0 1-.35-4.34.54.54 0 0 1 1.05 0"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m17.06 43.64 3.24 3.24-3.24 3.24"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19.06 46.88h-8.4q-3.6 0-3.6-3.6v-10.4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m34.7 33.77 2.21 2.2 4.91-4.91"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50 24.51v23.64a1.48 1.48 0 0 1-1.46 1.5H27.2a1.48 1.48 0 0 1-1.46-1.5v-28a1.49 1.49 0 0 1 1.46-1.51h17.39a.73.73 0 0 1 .53.24L49.8 24a.74.74 0 0 1 .2.51Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.35 19.1v4.24a1.51 1.51 0 0 0 1.46 1.56h3.82"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M25.52 37H14a1.45 1.45 0 0 1-1.48-1.43V7.43A1.45 1.45 0 0 1 14 6h21.88a1.45 1.45 0 0 1 1.48 1.43v11"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "37.87",
          cy: "33.51",
          r: "6.84"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TransferRequest56 = (TransferRequest56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Electricity104.tsx


var Electricity104_excluded = ["className"];
function Electricity104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Electricity104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Electricity104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Electricity104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Electricity104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Electricity104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Electricity104_objectSpread(Electricity104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.33 55.91c2.8.59 2.46.47 3.13.11-3.27-2.24-8.77-4.68-8.76-13.68 0-12.27 6.74-20 6.45-20.12C32.91 26.7 27 31.37 26.42 43a31.82 31.82 0 0 0 .65 9l-.27-.16a27.15 27.15 0 0 0 7.67 13.26 23.64 23.64 0 0 1 6.88 13.3A1.81 1.81 0 0 0 43 79.94l-.37 6.17c0 .76 1.38 1.59 2.14 1.59l.75.06c1.75 5.62 5 5.44 7.27 5.63-1.49-1.39-2.29-3.69-.4-5.69h-1.6c-2.74-2.7-.88-6.7-.42-7.7h12.68a1.81 1.81 0 0 0 1.78-1.51A24.88 24.88 0 0 1 72 64.85a27.77 27.77 0 0 0 7.23-13.38c-18.69 7.41-32.99 6.53-41.9 4.44Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m89.55 53.16-6.45-2.35m6.32-21.17-6.19 3M73.67 11.5 69.53 17M52.92 5v6.87M33.1 11l3.68 5.8m-19.9 9.38 5.93 3.46m-8.36 21.83 6.84-.59"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.82 51.88a27.15 27.15 0 0 0 7.67 13.26 23.67 23.67 0 0 1 6.88 13.3A1.81 1.81 0 0 0 43.16 80h19.89a1.81 1.81 0 0 0 1.78-1.51A24.82 24.82 0 0 1 72 64.85a27.77 27.77 0 0 0 7.23-13.38c-33.07 13.11-52.41.41-52.41.41Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26 42.5A27.14 27.14 0 0 1 49.83 18a27.5 27.5 0 0 1 3.17-.18 26.62 26.62 0 0 1 18 7 27.39 27.39 0 0 1 9 20.31 27.11 27.11 0 0 1-8.15 19.49 24.88 24.88 0 0 0-7.18 13.6 1.81 1.81 0 0 1-1.78 1.51H43a1.81 1.81 0 0 1-1.78-1.52 23.65 23.65 0 0 0-6.89-13.3A27.3 27.3 0 0 1 26 42.5Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M60.79 87.7H44.62a2.14 2.14 0 0 1-2.13-2.14v-5.37a.24.24 0 0 1 .23-.23h20.22a.41.41 0 0 1 .41.41v4.77a2.56 2.56 0 0 1-2.56 2.56Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.14 87.7a6.68 6.68 0 0 0 13.22 0Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Electricity104 = (Electricity104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Electricity56.tsx


var Electricity56_excluded = ["className"];
function Electricity56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Electricity56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Electricity56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Electricity56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Electricity56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Electricity56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Electricity56_objectSpread(Electricity56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.1 30.11c1.51.31 1.33.25 1.68.06C20 29 17.06 27.64 17.07 22.8A20.05 20.05 0 0 1 20.54 12c-2.82 2.42-6 4.93-6.31 11.22a16.89 16.89 0 0 0 .35 4.78l-.15-.09a14.7 14.7 0 0 0 4.13 7.15 12.71 12.71 0 0 1 3.71 7.16 1 1 0 0 0 .85.79l-.19 3.34c0 .4.74.85 1.15.85h.4c.94 3 2.67 2.93 3.92 3a2.05 2.05 0 0 1-.22-3.07h-.84c-1.48-1.46-.48-3.62-.23-4.17H34a1 1 0 0 0 1-.81 13.4 13.4 0 0 1 3.86-7.32 15 15 0 0 0 3.9-7.21C32.6 31.71 24.9 31.25 20.1 30.11Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m48.22 28.62-3.48-1.26M48.15 16l-3.33 1.61M39.67 6.19l-2.23 3M28.5 2.66v3.7m-10.68-.44 2 3.12M9.09 14.09 12.28 16m-4.5 11.71 3.69-.31"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M14.44 27.93a14.7 14.7 0 0 0 4.13 7.15 12.71 12.71 0 0 1 3.71 7.16 1 1 0 0 0 1 .81H34a1 1 0 0 0 1-.81 13.4 13.4 0 0 1 3.86-7.32 15 15 0 0 0 3.9-7.21c-17.9 7.07-28.32.22-28.32.22Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M14 22.88A14.61 14.61 0 0 1 26.83 9.69a16 16 0 0 1 1.68-.09 14.36 14.36 0 0 1 9.7 3.74 14.74 14.74 0 0 1 .47 21.43 13.38 13.38 0 0 0-3.87 7.32 1 1 0 0 1-1 .81H23.14a1 1 0 0 1-1-.81 12.7 12.7 0 0 0-3.7-7.16A14.68 14.68 0 0 1 14 22.88Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.73 47.22H24a1.14 1.14 0 0 1-1.15-1.15v-2.89a.12.12 0 0 1 .12-.12h10.92a.22.22 0 0 1 .22.22v2.56a1.38 1.38 0 0 1-1.38 1.38Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.85 47.22a3.6 3.6 0 0 0 7.12 0Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Electricity56 = (Electricity56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/ElectricityMeter104.tsx


var ElectricityMeter104_excluded = ["className"];
function ElectricityMeter104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function ElectricityMeter104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ElectricityMeter104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ElectricityMeter104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function ElectricityMeter104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ElectricityMeter104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", ElectricityMeter104_objectSpread(ElectricityMeter104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M58.2 35.1 29 33.6c-1.5 0-2.9-1.7-3.3-4.5L24 21.4c0-.2.2-.1-.4-.1h-.3c-.6 0-1.1.2-1.1.4v9.6c0 1 0 4.7 1.1 5.3 1.7 1 4.1 0 6.1 0l6.8-.2 8.3-.2 7.9-.2 5.4-.1c.5.1 1-.8.4-.8ZM17.2 73.4c4.2 8.2 17.4 8 15.2 8.6-12.1 3.5-17.4-.6-19-2.8S12 56 13.3 52.7c1.1-2.7 2.1 17.1 3.9 20.7ZM80.8 72.8c-3.3-4.3-8.9-8.9-11.4-14.5a19.56 19.56 0 0 1 2.1-20.4c-2.8.7-10.7 6-8.7 16.3s14.4 23.1 14.4 23.1Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36.4 59.6a10.05 10.05 0 0 1 1.7-5.4c-1.4 1.2-3 2.5-3.2 5.6a6.52 6.52 0 0 0 .2 2.4H35a6.65 6.65 0 0 0 2.1 3.6 6.21 6.21 0 0 1 1.8 3.6.43.43 0 0 0 .4.4l-.1 1.7c0 .2.4.4.6.4h.2c.5 1.5 1.3 1.5 2 1.5a1 1 0 0 1-.1-1.5h-.4c-.7-.7 3.7-1.3 3.7-1.5a9.91 9.91 0 0 1 2-4.7 7 7 0 0 0 1.9-3.6c-4.9 1.9-12.7 1.4-12.7-2.5Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m54.2 26.8-1.9-2.5M48 24.1l5.4 7M25 20.4h34a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H25a2 2 0 0 1-2-2v-12a1.89 1.89 0 0 1 2-2Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M73.8 32V19.5a6.27 6.27 0 0 0-6.3-6.3H18.8a6.27 6.27 0 0 0-6.3 6.3v57.1a6.27 6.27 0 0 0 6.3 6.3h48.8a6 6 0 0 0 5-2.6M28.6 83.6v5.8a1.2 1.2 0 0 0 1.2 1.1H33a1.13 1.13 0 0 0 1.2-1.1v-5.8M49.6 83.6v5.8a1.2 1.2 0 0 0 1.2 1.1H54a1.13 1.13 0 0 0 1.2-1.1v-5.8M39.1 83.6v5.8a1.2 1.2 0 0 0 1.2 1.1h3.1a1.13 1.13 0 0 0 1.2-1.1v-5.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M75.5 76a1.83 1.83 0 0 0 2.4.9 2 2 0 0 0 .9-.9l10.6-16.4a14.73 14.73 0 1 0-24.4 0Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M83.5 51.3a6.3 6.3 0 1 1-6.3-6.3 6.27 6.27 0 0 1 6.3 6.3Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.15 67.54a7.87 7.87 0 1 1 6.12 0M44.4 71.21a2.19 2.19 0 0 1-4.38 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45.27 67.53v2.25a1 1 0 0 1-1 1h-4.12a1 1 0 0 1-1-1v-2.25M31.49 60.28h-1.31M52.91 60.28h1.31M33.13 54.92l-1.31-.76M33.13 65.53l-1.31.76M51.51 65.53l1.31.76M51.51 54.92l1.31-.76"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ElectricityMeter104 = (ElectricityMeter104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/ElectricityMeter56.tsx


var ElectricityMeter56_excluded = ["className"];
function ElectricityMeter56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function ElectricityMeter56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ElectricityMeter56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ElectricityMeter56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function ElectricityMeter56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ElectricityMeter56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", ElectricityMeter56_objectSpread(ElectricityMeter56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m31.52 18.9-15.73-.81c-.8 0-1.56-.91-1.77-2.42l-.92-4.15c0-.1.11 0-.21 0h-.17c-.32 0-.59.11-.59.21v5.17c0 .54 0 2.53.59 2.86.92.54 2.21 0 3.29 0l3.66-.11 4.47-.11 4.25-.11 2.91-.05c.27.05.54-.43.22-.43ZM9.44 39.52c2.26 4.42 9.37 4.31 8.18 4.63-6.51 1.89-9.37-.32-10.23-1.5s-.75-12.5 0-14.27c.59-1.46 1.13 9.2 2.1 11.14ZM43.69 39.2c-1.78-2.32-4.8-4.79-6.14-7.81a10.49 10.49 0 0 1 1.13-11A7.54 7.54 0 0 0 34 29.18c1.08 5.55 7.76 12.44 7.76 12.44Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19.78 32.09a5.54 5.54 0 0 1 .91-2.91 3.94 3.94 0 0 0-1.72 3 3.53 3.53 0 0 0 .11 1.29H19a3.64 3.64 0 0 0 1.13 1.94 3.31 3.31 0 0 1 1 1.94.23.23 0 0 0 .22.21l-.05.92c0 .11.21.22.32.22h.11c.27.8.7.8 1.07.8a.53.53 0 0 1-.05-.8h-.22c-.37-.38 2-.7 2-.81a5.22 5.22 0 0 1 1.07-2.53 3.86 3.86 0 0 0 1-1.94c-2.6 1.04-6.82.77-6.82-1.33Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m29.36 14.43-1.02-1.35M26.02 12.98l2.91 3.77M13.64 11H32a1.08 1.08 0 0 1 1 1.06v6.46a1.07 1.07 0 0 1-1 1.08H13.64a1.08 1.08 0 0 1-1.08-1.08v-6.46A1 1 0 0 1 13.64 11Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.92 17.23V10.5a3.38 3.38 0 0 0-3.4-3.39H10.3a3.38 3.38 0 0 0-3.39 3.39v30.75a3.38 3.38 0 0 0 3.39 3.39h26.28a3.22 3.22 0 0 0 2.69-1.4M15.58 45v3.12a.64.64 0 0 0 .64.59H18a.61.61 0 0 0 .64-.59V45M26.89 45v3.12a.64.64 0 0 0 .64.59h1.72a.61.61 0 0 0 .65-.59V45M21.23 45v3.12a.65.65 0 0 0 .65.59h1.67a.61.61 0 0 0 .64-.59V45"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40.83 40.92a1 1 0 0 0 1.29.49 1.06 1.06 0 0 0 .49-.49l5.71-8.83a7.93 7.93 0 1 0-13.14 0Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45.14 27.62a3.4 3.4 0 1 1-3.39-3.39 3.38 3.38 0 0 1 3.39 3.39Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21.26 36.37a4.24 4.24 0 1 1 3.3 0M24.08 38.35a1.18 1.18 0 0 1-2.35 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.56 36.36v.88a.94.94 0 0 1-1 .87h-1.3a.94.94 0 0 1-1-.87v-.88M17.13 32.46h-.7M28.67 32.46h.71M18.02 29.57l-.71-.41M18.02 35.29l-.71.4M27.91 35.29l.71.4M27.91 29.57l.71-.41"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ElectricityMeter56 = (ElectricityMeter56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Energy104.tsx


var Energy104_excluded = ["className"];
function Energy104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Energy104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Energy104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Energy104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Energy104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Energy104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Energy104_objectSpread(Energy104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.12 57.35a53.89 53.89 0 0 1-23.62.1c2.38.51 2.09.41 2.66.1-2.78-1.91-7.47-4-7.47-11.67 0-10.46 5.75-17.05 5.5-17.16-4.46 3.83-9.5 7.81-10 17.73a27.08 27.08 0 0 0 .56 7.67l-.23-.12a23.14 23.14 0 0 0 6.54 11.31 20.17 20.17 0 0 1 5.86 11.34A1.55 1.55 0 0 0 31.33 78L31 83.21c0 .65 1.17 1.35 1.82 1.35l.64.06c1.49 4.79 4.26 4.63 6.2 4.8-1.27-1.19-2-3.15-.34-4.86H38c-2.33-2.3-.75-5.71-.35-6.56h10.78A1.55 1.55 0 0 0 50 76.71c0-.14.06-.27.08-.41a23.14 23.14 0 0 1 .04-18.95ZM74 52c2 8.13 1 18.32-5 18.38-1.62 0-4.56-2.72-5.82-4.21a1.28 1.28 0 0 0-1.81-.11 1.8 1.8 0 0 0-.19.2c-5.74 7.51-1.32 15.77 1.83 20a9.37 9.37 0 0 0 6.75 3.8 15.91 15.91 0 0 0 3.38-.1 9.72 9.72 0 0 0 4.89-2.26C95.06 73.14 72.1 44.14 74 52Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M56.77 54.65s5.92-8.25 8.39-15.54a2.59 2.59 0 0 0-.59-.44 39.69 39.69 0 0 1-9.95 11.74 22.48 22.48 0 0 0-3 3.58 23.08 23.08 0 0 0 6.12 32 22.31 22.31 0 0 0 2.63 1.54 5.57 5.57 0 0 0 .58-.51C56.12 81.93 47 68.86 56.77 54.65Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m58.15 19.58-3.53 4.69M40.46 14.04v5.86M23.56 19.16l3.14 4.94M9.73 32.1l5.05 2.95M7.65 53.67l5.84-.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.8 57.57C29.66 61.54 18.2 54 18.2 54"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M61.24 38.12a23.17 23.17 0 0 1 1.53 4.12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.68 84.56a5.69 5.69 0 0 0 11.27 0Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M70.22 90a9.37 9.37 0 0 1-6.76-3.8c-3.14-4.24-7.57-12.48-1.82-20a1.29 1.29 0 0 1 1.8-.24l.19.17c1.26 1.51 4.19 4.22 5.81 4.21 6 0 7-10.25 5-18.38-1.93-7.85 21 21.15 4 35.71a9.62 9.62 0 0 1-4.89 2.25 15 15 0 0 1-3.33.08Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M66.91 23.84c2.3 7.51-.64 17.15-11.86 26.51a23.4 23.4 0 0 0-3 3.58 23.09 23.09 0 1 0 42.18 13c0-23.65-27.32-43.09-27.32-43.09Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.48 76.48A1.55 1.55 0 0 1 49 77.77H32a1.55 1.55 0 0 1-1.52-1.3 20.18 20.18 0 0 0-5.87-11.34 23.31 23.31 0 0 1 13.22-40 22.11 22.11 0 0 1 2.7-.16 22.72 22.72 0 0 1 15.35 6 23.28 23.28 0 0 1 5.36 7.18"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47.17 84.56H33.38a1.82 1.82 0 0 1-1.81-1.82v-4.58a.21.21 0 0 1 .19-.2H49a.35.35 0 0 1 .35.35v4.07a2.17 2.17 0 0 1-2.18 2.18Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Energy104 = (Energy104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Energy56.tsx


var Energy56_excluded = ["className"];
function Energy56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Energy56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Energy56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Energy56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Energy56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Energy56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Energy56_objectSpread(Energy56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27 30.88a29.08 29.08 0 0 1-12.72.06c1.28.27 1.13.21 1.43 0-1.5-1-4-2.15-4-6.28a16.94 16.94 0 0 1 3-9.24c-2.4 2-5.12 4.2-5.38 9.54a14.32 14.32 0 0 0 .3 4.13l-.13-.07a12.56 12.56 0 0 0 3.5 6.14 10.81 10.81 0 0 1 3.16 6.1.83.83 0 0 0 .76.71l-.22 2.83c0 .35.63.73 1 .73h.35c.8 2.58 2.29 2.5 3.34 2.59a1.75 1.75 0 0 1-.19-2.62h-.73c-1.26-1.24-.41-3.07-.2-3.53h5.83a.83.83 0 0 0 .81-.69 1.89 1.89 0 0 0 .05-.23A12.43 12.43 0 0 1 27 30.88ZM39.87 28c1.07 4.38.51 9.87-2.7 9.9-.87 0-2.45-1.46-3.13-2.26a.67.67 0 0 0-1-.06l-.1.1c-3.1 4-.71 8.49 1 10.77a5.06 5.06 0 0 0 3.64 2.05 7.94 7.94 0 0 0 1.82-.06 5.14 5.14 0 0 0 2.6-1.22c9.19-7.84-3.18-23.45-2.13-19.22Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.57 29.43a39.7 39.7 0 0 0 4.52-8.37 2.43 2.43 0 0 0-.32-.24 21.39 21.39 0 0 1-5.36 6.32 12.46 12.46 0 0 0-1.62 1.93 12.42 12.42 0 0 0 3.3 17.25 11.08 11.08 0 0 0 1.41.83 2 2 0 0 0 .31-.27c-2.59-2.77-7.5-9.8-2.24-17.45Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m31.31 10.54-1.9 2.53M21.79 7.56v3.15M12.69 10.32l1.69 2.66M5.24 17.29l2.72 1.58M4.12 28.9l3.14-.27"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.82 31c-10.85 2.14-17-1.91-17-1.91"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33 20.53a13.32 13.32 0 0 1 .82 2.21"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.67 45.53a3.07 3.07 0 0 0 6.07 0Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.81 48.45a5.06 5.06 0 0 1-3.64-2.05c-1.69-2.28-4.07-6.72-1-10.77a.7.7 0 0 1 1-.13l.1.09c.68.81 2.26 2.28 3.13 2.27 3.21 0 3.77-5.52 2.69-9.9-1-4.23 11.32 11.39 2.17 19.23a5.14 5.14 0 0 1-2.63 1.21 8.43 8.43 0 0 1-1.82.05Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36 12.84c1.24 4-.35 9.23-6.39 14.27A12.46 12.46 0 0 0 28 29a12.43 12.43 0 1 0 22.72 7C50.74 23.31 36 12.84 36 12.84Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.18 41.18a.83.83 0 0 1-.82.69h-9.13a.83.83 0 0 1-.82-.69 10.81 10.81 0 0 0-3.16-6.11 12.56 12.56 0 0 1 7.12-21.54 11.75 11.75 0 0 1 1.45-.08 12.24 12.24 0 0 1 8.27 3.21A12.7 12.7 0 0 1 33 20.53"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M25.4 45.53H18a1 1 0 0 1-1-1v-2.44a.11.11 0 0 1 .1-.11h9.29a.19.19 0 0 1 .19.19v2.19a1.17 1.17 0 0 1-1.18 1.17Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Energy56 = (Energy56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/EnergySolar104.tsx


var EnergySolar104_excluded = ["className"];
function EnergySolar104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function EnergySolar104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? EnergySolar104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EnergySolar104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function EnergySolar104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EnergySolar104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", EnergySolar104_objectSpread(EnergySolar104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M55.75 36.78c-4.49-2.11-6.4-5.15-6.38-10.16 0-2.76-1.8-3.17-2.21-3.25a2.71 2.71 0 0 0-2.9 1.89c-1.25 3.83-1.14 7.2.4 9.92 2 3.67 4.45 5.24 6.63 6a11.85 11.85 0 0 0 3.28.54 2.61 2.61 0 0 0 2.91-1.89 2.81 2.81 0 0 0-1.73-3.05ZM10.79 83.2s.76-3.27.75-3.3a.07.07 0 0 1 0-.06s3.62-13.64 3.89-13.56.54.26.54.48c-.07 2.39-.51 4.12-.58 6.52-.06 2-.35 4 .86 5.54 1 1.3 5.48 2.71 5.46 4.18a.28.28 0 0 1-.1.21.32.32 0 0 1-.23.06ZM72.39 84.1s-.13-3.4-.14-3.42v-.06s-1.38-14.39-1.1-14.38.59.11.65.32c.58 2.36 3.18 10.57 4.79 11.8 1.33 1 7.18 2.83 7.55 4.27a.28.28 0 0 1 0 .23.27.27 0 0 1-.2.12ZM38.31 84.17s.56-3.65.55-3.68a.07.07 0 0 1 0-.06S41.73 65.15 42 65.22s.61.24.63.48c.12 2.63-.23 4.57-.11 7.2.1 2.18 0 4.37 1.41 6 1.21 1.36 6.24 2.54 6.33 4.15a.31.31 0 0 1-.1.24.3.3 0 0 1-.24.08Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M52.83 21.24a9.9 9.9 0 1 1-9.9 9.89 9.89 9.89 0 0 1 9.9-9.89M45.76 18.89l-1.87-3.23M40.58 24.07l-3.23-1.87M38.69 31.14h-3.73M40.58 38.21l-3.23 1.87M45.76 43.39l-1.87 3.23M52.83 45.28v3.74M59.9 43.39l1.87 3.23M65.08 38.21l3.23 1.87M66.98 31.14h3.72M65.08 24.07l3.23-1.87M59.9 18.89l1.87-3.23M52.83 13.23v3.73M65.67 84H38.13a.66.66 0 0 1-.73-.58.53.53 0 0 1 0-.13L41.77 61a.68.68 0 0 1 .72-.54h20.62a.68.68 0 0 1 .72.54l2.57 22.29a.61.61 0 0 1-.57.7.42.42 0 0 1-.16.01ZM40.05 72.93h25.18M56.26 60.54l2.1 23.35M48.87 60.9l-2.12 22.99M70.95 73.83h21.23M83.25 62.49l4.09 21.46M76.44 62.62l2.32 21.08M93.32 84H72.81a.61.61 0 0 1-.67-.54s0-.08 0-.11l-2.65-20.51a.62.62 0 0 1 .66-.49H89.5a.62.62 0 0 1 .66.49L94 83.37a.56.56 0 0 1-.52.64.38.38 0 0 1-.16-.01ZM33.24 73.94H12.3M22.06 62.76l-6.38 21.22M28.86 62.87l-4.7 20.83M10.32 84h20.23a.67.67 0 0 0 .71-.53v-.11l4.34-20.25a.56.56 0 0 0-.61-.49H15.9a.67.67 0 0 0-.69.49L9.72 83.36a.5.5 0 0 0 .46.63ZM20.15 84.58v4.2M52.43 84.17l-.03 4.37M81.83 84.17v4.62M81.83 88.79H20.15M68.83 88.93l-.04 1.79M39.7 88.98l-.03 1.79"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EnergySolar104 = (EnergySolar104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/EnergySolar56.tsx


var EnergySolar56_excluded = ["className"];
function EnergySolar56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function EnergySolar56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? EnergySolar56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EnergySolar56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function EnergySolar56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EnergySolar56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", EnergySolar56_objectSpread(EnergySolar56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19.82 46.92s.33-2.1.32-2.12S21.79 36 22 36s.35.14.36.28c.07 1.51-.13 2.62-.06 4.13.06 1.26 0 2.51.81 3.46.7.77 3.58 1.45 3.64 2.38a.16.16 0 0 1-.06.13.16.16 0 0 1-.14.05ZM29.58 18.84a5.43 5.43 0 0 1-3.47-5.54c0-1.51-1-1.73-1.21-1.77a1.48 1.48 0 0 0-1.58 1 6.56 6.56 0 0 0 .22 5.4 6.37 6.37 0 0 0 3.62 3.25 6.7 6.7 0 0 0 1.78.3 1.45 1.45 0 0 0 1.59-1 1.53 1.53 0 0 0-.95-1.64Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.54 46.82H19.72a.39.39 0 0 1-.42-.34.17.17 0 0 1 0-.07l2.5-12.8a.4.4 0 0 1 .42-.31h11.85a.38.38 0 0 1 .41.31L36 46.41a.35.35 0 0 1-.33.4ZM20.83 40.46h14.46M30.14 33.34l1.2 13.41M25.88 33.42l-1.21 13.33M28.01 46.84l-.02 2.68M31.53 49.57h-7.06M28 10.37a5.39 5.39 0 1 1-5.39 5.39A5.39 5.39 0 0 1 28 10.37M24.14 9.09l-1.02-1.76M21.32 11.91l-1.76-1.02M20.28 15.76h-2.02M21.32 19.62l-1.76 1.01M24.14 22.44l-1.02 1.76M27.99 23.47v2.03M31.85 22.44l1.01 1.76M34.67 19.62l1.76 1.01M35.7 15.76h2.03M34.67 11.91l1.76-1.02M31.85 9.09l1.01-1.76M27.99 6v2.03"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EnergySolar56 = (EnergySolar56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/EnergyWind104.tsx


var EnergyWind104_excluded = ["className"];
function EnergyWind104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function EnergyWind104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? EnergyWind104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EnergyWind104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function EnergyWind104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EnergyWind104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", EnergyWind104_objectSpread(EnergyWind104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M72.6 35.56a2.66 2.66 0 0 1 .74-1.85c-2.3-.41-6.08 1.34-9.58 4.45-3.09 2.64-5.74 5.11-7.2 6.57a.51.51 0 0 0 .5.86l.28-.09c.51-1.5 3.48-3.93 7.49-5.85 3.57-1.7 7.18-2.2 9.28-1.16a4 4 0 0 0 .32-.4 2.68 2.68 0 0 1-1.83-2.53ZM94.21 44.66l-.22-.2c-1.56.31-5.14-1.05-8.81-3.55-3.28-2.24-5.59-5-5.93-7.09a5.4 5.4 0 0 0-2-.12 2.67 2.67 0 0 1 .75 1.85 2.71 2.71 0 0 1-1.28 2.29 20.34 20.34 0 0 0 7.75 4.65q4.55 1.74 9.25 3a.51.51 0 0 0 .49-.86ZM75.3 32.85a2.65 2.65 0 0 1 1.61.55 6.85 6.85 0 0 0 1.21-3.25 1.87 1.87 0 0 1-1.21.45c-2.13-.11-3-4.56-2.38-9.83a29.55 29.55 0 0 1 1.36-6.44 1.71 1.71 0 0 0 0-1.05.51.51 0 0 0-.61-.38.52.52 0 0 0-.38.38q-1.23 4.71-2 9.52c-.79 4.61-.44 8.75.89 10.54a2.62 2.62 0 0 1 1.51-.47ZM29.37 38.1a3.25 3.25 0 0 1 .89-2.26c-2.8-.49-7.39 1.63-11.65 5.41-3.76 3.22-7 6.23-8.76 8a.62.62 0 0 0 0 .87.61.61 0 0 0 .61.17l.35-.11c.62-1.83 4.23-4.78 9.11-7.11 4.34-2.07 8.74-2.67 11.28-1.4.14-.16.27-.33.4-.49a3.27 3.27 0 0 1-2.23-3.08ZM55.66 49.17l-.26-.25c-1.9.38-6.26-1.28-10.73-4.32-4-2.71-6.79-6.06-7.21-8.62a6.49 6.49 0 0 0-2.46-.15 3.26 3.26 0 0 1-.65 5c1.82 2 5.25 4.12 9.43 5.66 3.68 1.41 7.44 2.64 11.25 3.68a.62.62 0 0 0 .77-.42.6.6 0 0 0-.14-.58ZM32.65 34.8a3.18 3.18 0 0 1 2 .67 8.32 8.32 0 0 0 1.48-4s0 0-.05 0a2.3 2.3 0 0 1-1.48.55c-2.59-.13-3.67-5.55-2.9-12a36.77 36.77 0 0 1 1.66-7.83 2.15 2.15 0 0 0 0-1.28.62.62 0 0 0-1.2 0 117.53 117.53 0 0 0-2.44 11.59c-1 5.6-.53 10.64 1.09 12.82a3.2 3.2 0 0 1 1.83-.57ZM73.36 41.86l-4.2 37.61c-.07.56-.28 1.76.28 1.85h6.76a.78.78 0 0 0 .8-1.13l-1.39-2.79a10.86 10.86 0 0 1-1.1-4.88c0-2.83.23-32 .23-32a.59.59 0 0 0-1.16-.14s-.22 1.48-.22 1.48Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "75.3",
          cy: "35.55",
          r: ".8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m30.29 45.77-5.11 45.76c-.09.68-.33 2.14.34 2.25h8.23a.93.93 0 0 0 1.08-.78.92.92 0 0 0-.08-.57L33 89a13.27 13.27 0 0 1-1.34-5.94c0-3.45.29-38.95.29-38.95a.72.72 0 0 0-1.39-.11s-.27 1.76-.27 1.77Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "32.65",
          cy: "38.08",
          r: ".97"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m76.77 38.51 4.15 41.88c-1.29.79-12.1.81-11 0l3.78-41.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M73.54 33.43h-.2C70.93 33 67.13 35 63.63 38c-3 2.56-5.6 5-7.22 6.6a.74.74 0 0 0-.22.52.73.73 0 0 0 .72.73.64.64 0 0 0 .2 0c2.2-.6 5.6-1.62 9.33-2.95 3.55-1.24 6.5-3 8-4.76M76.44 38c1.52 1.74 4.43 3.45 7.91 4.73 3.9 1.47 7.5 2.52 9.3 3a.76.76 0 0 0 .21 0 .7.7 0 0 0 .51-.22.72.72 0 0 0 0-1C93 43.2 90.32 40.61 87.1 38c-3.55-2.93-7.38-4.9-9.73-4.56h-.13M77.24 33.43c1.44-1.88 1.69-6.07.89-10.68-.67-4.12-1.57-7.76-2-9.56a.73.73 0 0 0-.53-.53.72.72 0 0 0-.88.53c-.59 2.21-1.41 5.65-2.05 9.56-.79 4.61-.53 8.81.91 10.68"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M75.29 32.85a2.7 2.7 0 1 0 2.71 2.7 2.7 2.7 0 0 0-2.71-2.7ZM34.46 42l5 50.69c-1.57 1-14.73 1-13.44 0l4.68-50.55"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.56 35.57v-.06a2.27 2.27 0 0 0-.25-.06c-2.97-.45-7.6 1.92-11.86 5.55-3.68 3.12-6.81 6.08-8.78 8a.9.9 0 0 0-.27.63.88.88 0 0 0 .87.89 1 1 0 0 0 .25 0c2.68-.74 6.81-2 11.35-3.6 4.32-1.5 7.91-3.6 9.72-5.78M34 41.05c1.85 2.12 5.4 4.2 9.62 5.76 4.75 1.79 9.13 3.07 11.32 3.65a.73.73 0 0 0 .25 0 .88.88 0 0 0 .65-1.46c-1.61-1.61-4.91-4.76-8.83-8-4.32-3.57-9-6-11.83-5.55a1 1 0 0 0-.17 0l-.14.18"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35 35.5c1.76-2.28 2.06-7.38 1.09-13-.82-5-1.92-9.44-2.49-11.63a.9.9 0 0 0-.64-.65.88.88 0 0 0-1.07.65c-.72 2.68-1.72 6.88-2.5 11.63-.95 5.6-.64 10.72 1.11 13"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.64 34.8a3.29 3.29 0 1 0 3.3 3.28 3.28 3.28 0 0 0-3.3-3.28Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M16.35 33.34a13 13 0 0 1-.05-2.25 11.66 11.66 0 0 1 6.53-9.64M43.05 21.87a11.69 11.69 0 0 1 7.33 11M21.71 32.13v-.67A8.37 8.37 0 0 1 24 26.37M41.57 26.85a8.4 8.4 0 0 1 4.13 4.8"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EnergyWind104 = (EnergyWind104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/EnergyWind56.tsx


var EnergyWind56_excluded = ["className"];
function EnergyWind56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function EnergyWind56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? EnergyWind56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EnergyWind56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function EnergyWind56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EnergyWind56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", EnergyWind56_objectSpread(EnergyWind56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26 20.78a1.71 1.71 0 0 1 .48-1.2c-1.48-.26-3.92.86-6.17 2.87-2 1.7-3.71 3.3-4.64 4.24a.33.33 0 0 0 .31.55l.19-.06c.32-1 2.24-2.53 4.82-3.76 2.31-1.11 4.64-1.42 6-.75l.21-.26a1.74 1.74 0 0 1-1.2-1.63ZM39.94 26.64l-.13-.13c-1 .2-3.32-.68-5.69-2.29-2.12-1.44-3.6-3.22-3.82-4.56a3.19 3.19 0 0 0-1.3-.08 1.73 1.73 0 0 1-.35 2.66 12.89 12.89 0 0 0 5 3q2.94 1.13 6 2a.32.32 0 0 0 .31-.55ZM27.76 19a1.69 1.69 0 0 1 1 .35 4.26 4.26 0 0 0 .78-2.09 1.25 1.25 0 0 1-.78.29c-1.38-.07-1.95-2.94-1.54-6.34a18.94 18.94 0 0 1 .88-4.15 1.21 1.21 0 0 0 0-.68.31.31 0 0 0-.39-.24.34.34 0 0 0-.25.24q-.79 3-1.29 6.14c-.51 3-.28 5.64.58 6.79a1.69 1.69 0 0 1 1-.3ZM26.5 24.84l-2.7 24.24c-.05.36-.18 1.14.17 1.19h4.37a.51.51 0 0 0 .57-.42.45.45 0 0 0-.05-.3l-.9-1.8a7 7 0 0 1-.71-3.15c0-1.82.15-20.63.15-20.63 0-.46-.69-.54-.75-.09 0 .01-.15.96-.15.96Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "27.75",
          cy: "20.77",
          r: ".51"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19.12 18.25a5.9 5.9 0 0 1 0-1.19A6.19 6.19 0 0 1 22.55 12M33.27 12.18A6.2 6.2 0 0 1 37.15 18M22 17.61v-.35a4.42 4.42 0 0 1 1.17-2.69M32.48 14.82a4.46 4.46 0 0 1 2.19 2.54"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m28.66 22.24 2.72 27.43c-.83.51-7.8.52-7.12 0l2.46-26.76"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.66 19.43h-.14c-1.55-.25-4 1-6.26 3a79.077 79.077 0 0 0-4.65 4.26.45.45 0 0 0-.15.33.47.47 0 0 0 .47.47H16a84.67 84.67 0 0 0 6-1.91 12.11 12.11 0 0 0 5.15-3.06M28.5 22.34a13 13 0 0 0 5.09 3.05c2.51.95 4.83 1.63 6 1.94h.14a.47.47 0 0 0 .32-.8c-.85-.85-2.6-2.52-4.68-4.23-2.29-1.89-4.75-3.16-6.27-2.94H29l-.08.08"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28.85 19.43h.14c.94-1.2 1.11-3.9.59-6.88-.44-2.66-1-5-1.32-6.16a.48.48 0 0 0-.34-.39.48.48 0 0 0-.57.35C27 7.78 26.45 10 26 12.52c-.51 3-.33 5.69.6 6.89"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.75 19a1.74 1.74 0 1 0 1.74 1.74A1.74 1.74 0 0 0 27.75 19Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EnergyWind56 = (EnergyWind56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Gas104.tsx


var Gas104_excluded = ["className"];
function Gas104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Gas104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Gas104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Gas104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Gas104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Gas104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Gas104_objectSpread(Gas104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M56.44 45.33c2.66 10.83 1.28 24.41-6.66 24.48-2.16 0-6.07-3.62-7.75-5.6a1.71 1.71 0 0 0-2.66.12c-7.65 10-1.76 21 2.43 26.64a12.47 12.47 0 0 0 9 5.06 20.76 20.76 0 0 0 4.5-.14 12.83 12.83 0 0 0 6.51-3c22.63-19.39-7.95-58.02-5.37-47.56Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.44 48.88s7.88-11 11.18-20.71a4.11 4.11 0 0 0-.79-.58c-2.69 5.12-7 10.4-13.26 15.63a30.59 30.59 0 0 0-4 4.77 30.73 30.73 0 0 0 11.65 44.74 8.15 8.15 0 0 0 .77-.68c-6.42-6.84-18.55-24.25-5.55-43.17Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.78 96a12.47 12.47 0 0 1-9-5.06c-4.19-5.65-10.08-16.62-2.43-26.64a1.71 1.71 0 0 1 2.65-.09c1.68 2 5.59 5.62 7.75 5.6 7.94-.07 9.32-13.65 6.66-24.48-2.58-10.46 28 28.17 5.35 47.57a12.83 12.83 0 0 1-6.51 3 20.76 20.76 0 0 1-4.47.1Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.37 7.91c3.07 10-.85 22.85-15.8 35.31a30.59 30.59 0 0 0-4 4.77 30.76 30.76 0 1 0 56.19 17.27c.01-31.45-36.39-57.35-36.39-57.35Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Gas104 = (Gas104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Gas56.tsx


var Gas56_excluded = ["className"];
function Gas56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Gas56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Gas56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Gas56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Gas56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Gas56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Gas56_objectSpread(Gas56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.39 24.41c1.44 5.83.69 13.14-3.59 13.18-1.16 0-3.26-2-4.17-3a.91.91 0 0 0-1.43.06C17.08 40 20.25 45.94 22.51 49a6.71 6.71 0 0 0 4.84 2.72 11.68 11.68 0 0 0 2.42-.07 7 7 0 0 0 3.5-1.65c12.2-10.42-4.27-31.23-2.88-25.59Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18 26.32s4.24-5.94 6-11.15a1.73 1.73 0 0 0-.42-.31 28.53 28.53 0 0 1-7.14 8.41 17.26 17.26 0 0 0-2.17 2.57 16.55 16.55 0 0 0 6.29 24.08q.21-.16.42-.36C17.54 45.88 11 36.51 18 26.32Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.35 51.71A6.71 6.71 0 0 1 22.51 49c-2.26-3.05-5.43-9-1.31-14.35a.91.91 0 0 1 1.43-.06c.91 1.06 3 3 4.17 3 4.28 0 5-7.35 3.59-13.18C29 18.77 45.47 39.58 33.27 50a7 7 0 0 1-3.5 1.62 11.68 11.68 0 0 1-2.42.09Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M25 4.26c1.65 5.4-.46 12.3-8.51 19a17.26 17.26 0 0 0-2.17 2.57 16.56 16.56 0 1 0 30.27 9.29C44.57 18.21 25 4.26 25 4.26Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Gas56 = (Gas56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/GasMeter104.tsx


var GasMeter104_excluded = ["className"];
function GasMeter104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function GasMeter104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GasMeter104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GasMeter104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function GasMeter104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, GasMeter104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", GasMeter104_objectSpread(GasMeter104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M80.82 82.16c-3.28-4.26-8.87-8.9-11.4-14.45a19.64 19.64 0 0 1 2.06-20.41c-2.84.72-10.74 6-8.71 16.33s14.41 23.1 14.41 23.1ZM44.24 73.45c.57 2.32.28 5.24-1.43 5.25-.46 0-1.3-.8-1.66-1.2a.36.36 0 0 0-.51 0l-.06.06c-1.64 2.13-.38 4.5.52 5.72a2.67 2.67 0 0 0 1.9 1.04 5.11 5.11 0 0 0 1 0 2.76 2.76 0 0 0 1.4-.66c4.86-4.15-1.7-12.45-1.15-10.2ZM18.35 78.7C22 90.12 44.19 89.89 41.26 90.63 22.17 95.5 16.2 86 14.17 83.38s-2.32-20.88-.69-24.92c1.4-3.46 3.33 15.44 4.87 20.24ZM60.21 44.44 30.94 43c-1.54 0-2.87-1.68-3.32-4.48l-1.73-7.69c0-.21.19-.13-.43-.13h-.28c-.63 0-1.14.18-1.14.39v9.64c0 1 0 4.71 1.1 5.34 1.72 1 4.1 0 6.09-.05l6.84-.15 8.35-.18 7.86-.17 5.38-.12c.61 0 1.08-.93.56-.93Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M75.53 85.39a1.8 1.8 0 0 0 2.39.87 1.84 1.84 0 0 0 .87-.87L89.35 69A14.69 14.69 0 1 0 65 69Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M83.49 60.72a6.3 6.3 0 1 1-6.3-6.3 6.3 6.3 0 0 1 6.3 6.3Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m56.16 36.08-1.91-2.45M49.91 33.44l5.44 6.98M74.41 41.05V27.87a6.26 6.26 0 0 0-6.26-6.26H19.44a6.26 6.26 0 0 0-6.26 6.26v50.85A12.52 12.52 0 0 0 25.7 91.24h36.19a12.47 12.47 0 0 0 8.82-3.64M24 12.42h6.16a3.5 3.5 0 0 1 3.5 3.5v5.65H20.47v-5.65a3.5 3.5 0 0 1 3.5-3.5ZM20.45 16.36h13.21M57.45 12.42h6.16a3.5 3.5 0 0 1 3.5 3.5v5.65H53.94v-5.65a3.5 3.5 0 0 1 3.5-3.5ZM53.93 16.36h13.21"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "24.63",
          y: "29.68",
          width: "38.01",
          height: "16.06",
          rx: "2.03"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.18 84.39a2.85 2.85 0 0 1-2-1.15c-1-1.3-2.31-3.8-.56-6.09a.39.39 0 0 1 .61 0c.39.45 1.28 1.29 1.77 1.28 1.82 0 2.13-3.12 1.52-5.59s6.4 6.43 1.22 10.87a2.92 2.92 0 0 1-1.48.68 4.85 4.85 0 0 1-1.08 0Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42.07 60.41c.87 2.73-.24 6.21-4.48 9.61a8.77 8.77 0 0 0-1.14 1.29A8.06 8.06 0 0 0 35 76a8.73 8.73 0 0 0 17.44 0c-.05-8.55-10.37-15.59-10.37-15.59Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_GasMeter104 = (GasMeter104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/GasMeter56.tsx


var GasMeter56_excluded = ["className"];
function GasMeter56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function GasMeter56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GasMeter56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GasMeter56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function GasMeter56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, GasMeter56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", GasMeter56_objectSpread(GasMeter56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.52 44.24c-1.77-2.29-4.78-4.79-6.14-7.78a10.58 10.58 0 0 1 1.11-11 7.53 7.53 0 0 0-4.69 8.79c1.09 5.56 7.76 12.44 7.76 12.44ZM23.82 39.55c.31 1.25.15 2.82-.77 2.83-.25 0-.7-.43-.89-.65a.2.2 0 0 0-.28 0 2.53 2.53 0 0 0 .28 3.08 1.42 1.42 0 0 0 1 .58 3 3 0 0 0 .52 0 1.5 1.5 0 0 0 .75-.36c2.62-2.23-.91-6.7-.62-5.49ZM9.88 42.38c2 6.15 13.91 6 12.34 6.42-10.28 2.62-13.5-2.49-14.59-3.9s-1.25-11.25-.37-13.42c.74-1.86 1.79 8.31 2.62 10.9ZM32.42 23.93l-15.76-.8c-.83 0-1.55-.91-1.79-2.42l-.93-4.14c0-.11.1-.07-.23-.07h-.15c-.34 0-.62.1-.62.21v5.19c0 .54 0 2.54.6 2.88.92.53 2.2 0 3.28 0l3.68-.08 4.5-.09 4.23-.1 2.89-.06c.33 0 .59-.5.31-.5Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40.67 46a1 1 0 0 0 1.29.47 1.07 1.07 0 0 0 .47-.47l5.68-8.85a7.91 7.91 0 1 0-13.1 0Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45 32.7a3.4 3.4 0 1 1-3.4-3.4 3.4 3.4 0 0 1 3.4 3.4Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m30.24 19.43-1.03-1.32M26.87 18.01l2.93 3.75M40.07 22.1V15a3.37 3.37 0 0 0-3.37-3.37H10.47A3.36 3.36 0 0 0 7.1 15v27.39a6.74 6.74 0 0 0 6.74 6.74h19.49a6.69 6.69 0 0 0 4.74-2M12.91 6.69h3.32a1.88 1.88 0 0 1 1.88 1.88v3H11v-3a1.89 1.89 0 0 1 1.89-1.88ZM11.01 8.81h7.11M30.93 6.69h3.32a1.89 1.89 0 0 1 1.89 1.88v3H29v-3a1.89 1.89 0 0 1 1.89-1.88ZM29.04 8.81h7.11"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "13.26",
          y: "15.98",
          width: "20.47",
          height: "8.65",
          rx: "1.09"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.25 45.44a1.52 1.52 0 0 1-1.1-.62 2.67 2.67 0 0 1-.3-3.28.21.21 0 0 1 .32 0c.21.24.69.69 1 .69 1 0 1.14-1.68.82-3s3.44 3.46.65 5.85a1.54 1.54 0 0 1-.8.36 1.93 1.93 0 0 1-.59 0Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.66 32.53c.46 1.47-.14 3.34-2.42 5.17a5.1 5.1 0 0 0-.61.7 4.36 4.36 0 0 0-.81 2.53 4.7 4.7 0 0 0 9.39 0c0-4.61-5.55-8.4-5.55-8.4Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_GasMeter56 = (GasMeter56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/GreenEnergy104.tsx


var GreenEnergy104_excluded = ["className"];
function GreenEnergy104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function GreenEnergy104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GreenEnergy104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GreenEnergy104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function GreenEnergy104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, GreenEnergy104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", GreenEnergy104_objectSpread(GreenEnergy104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M60.41 46.25c-1.36-1-3.4-.79-4.61-2-.6-.59-.89-1.44-1.44-2.07-1.52-1.71-4.21-1.18-6.43-1.65a13.55 13.55 0 0 1-4.34-2.11 5 5 0 0 1-2-1.91 1.74 1.74 0 0 1 .77-2.36c1.14-.35 2.25 1 3.39.69S47 33 47.37 31.93C48 30.1 49.75 29 51.38 28L56 25.22c.6-.36 1.29-.92 1.14-1.61-.2-.93-1.7-1.12-1.77-2.06-.09-1.38 2.85-1.29 2.7-2.66-.08-.72-1-.95-1.71-1-1.55-.07-3.11-.11-4.66-.12a3.68 3.68 0 0 0-2.89.85 10.38 10.38 0 0 0-.87 1.61c-.32.51-1 1-1.52.7a2.1 2.1 0 0 0-2.57-2.64 21.2 21.2 0 0 1-2.94 13.4 11.09 11.09 0 0 1-5.19 4.4c.66.6 1.08 1.47 1.78 2 1.73 1.34 4.58.25 6.16 1.77 1.07 1 1 2.76.82 4.24s-.4 3.16.51 4.34A11.52 11.52 0 0 0 46.74 50c1.79 1.57 2.21 4.18 2.43 6.56s.45 5 2 6.77a1.77 1.77 0 0 0 1.82.74c.83-.31.9-1.44 1-2.33.33-2.29 1.84-4.21 3.46-5.83a16.93 16.93 0 0 0 3.71-4.36c.84-1.76.78-4.15-.75-5.3ZM26.44 84.45 12.67 70.51a1.17 1.17 0 0 0-1.64 0l-3.92 3.71a.9.9 0 0 0 .44 1.54l3.5.69a11.83 11.83 0 0 1 5.18 2.45l10.45 7.78c.63.51 1.5-.38.94-1-.01.03-1.17-1.23-1.18-1.23ZM75.87 34.34c-2-.36-4.05-1-6.12-1.28a6.2 6.2 0 0 0-4.54.81c-1.86 1.38-2.1 4.07-2.17 6.42a4.23 4.23 0 0 0 .58 2.76 3.19 3.19 0 0 0 2.59.94 13.57 13.57 0 0 1 2.85 0 5 5 0 0 1 3.28 2.82 14.92 14.92 0 0 1 1.2 4.32l1.24 7.12a1.08 1.08 0 0 0 1.63.75 7.34 7.34 0 0 0 2.32-2.69 34.49 34.49 0 0 0 4.35-17.21c0-1.23-.2-3-1.53-3.56-.73-.33-1.63-.42-2-1a13.14 13.14 0 0 1-3.68-.2ZM64.18 74.16A1.23 1.23 0 0 1 63 75.4l-15.88.6a.92.92 0 0 1-.91-.92.92.92 0 0 1 .91-.93Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M93.16 63.16a1 1 0 0 0-1.27-1.46l-20.3 16.49a10.26 10.26 0 0 1-6.89 2.67h-33a5.08 5.08 0 0 0-3.56 1.46l-1.45 1.41L14.4 71.36l-.34.33 16.46 16.62 2-2a3.15 3.15 0 0 1 2.22-.91H64.7a10.27 10.27 0 0 0 6.89-2.68L92.9 63.38a3.09 3.09 0 0 0 .26-.22ZM27.53 34.7l1-4.59-2.63.82a2.09 2.09 0 0 1-2.51-1.14 9.13 9.13 0 0 1 0-7.74 11 11 0 0 1 4.8-4.41c-3.2 1.51-6.06 3.11-7.33 5.69-2.47 5.67.62 10.4 4.95 13.24l.78.53.45-.14.24-1.13Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.12 57a27.87 27.87 0 0 1-5-18.21c.05-.6.11-1.19.19-1.78M85.32 30.08a4.3 4.3 0 0 1-2.72 5.51 4.43 4.43 0 0 1-5.6-2.78M86.72 28.43l-11.67 3.92M73.44 12.77l-4.93 10.31M73.19 21.46 70 20M66.13 15l-3.41-1.51M75.15 17.5l-2.89-1.4M65.61 16.19l-3.41-1.51M43.42 15.45a27.88 27.88 0 0 1 22.22-.22"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M82.18 35.73a28.57 28.57 0 0 1 .4 7.3A27.73 27.73 0 0 1 75 60.13M68.67 68.06c3.67-.31 17-9.67 17-9.67s3.6-2.43 6.59.1.61 4.89.61 4.89L71.59 82.77a10.27 10.27 0 0 1-6.89 2.68H35.54A5.13 5.13 0 0 0 32 86.9l-1.45 1.41M9.66 71.94l2.5-2.18 21.41 21.62-2.49 2.17"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.54 74h17.3a4.9 4.9 0 0 0 4.86-4.94 4.9 4.9 0 0 0-4.86-4.94H50.48a6.58 6.58 0 0 1-4.56-1.92 15.53 15.53 0 0 0-10.81-4 14.92 14.92 0 0 0-9.52 2.94c-2.52 2.1-7.35 6.6-11.53 10.59M68 21.41a4.29 4.29 0 0 1-1.85-5.86 4.44 4.44 0 0 1 6-1.85M33.6 36.6a11.5 11.5 0 0 0 7.4-5.11c4.13-6.84 4-15.49 0-21.39a.91.91 0 0 0-1.4-.13c-5.63 5.5-16.24 6.69-19.14 12.6-2.69 6.17.68 11.32 5.39 14.4l.92.61"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27 41.1v-1a27.7 27.7 0 0 1 9.88-21.3"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_GreenEnergy104 = (GreenEnergy104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/GreenEnergy56.tsx


var GreenEnergy56_excluded = ["className"];
function GreenEnergy56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function GreenEnergy56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GreenEnergy56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GreenEnergy56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function GreenEnergy56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, GreenEnergy56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", GreenEnergy56_objectSpread(GreenEnergy56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.67 24.9c-.74-.55-1.84-.42-2.49-1.06-.32-.32-.47-.78-.77-1.12-.82-.92-2.27-.63-3.46-.89a7.14 7.14 0 0 1-2.34-1.13 2.66 2.66 0 0 1-1.07-1 .94.94 0 0 1 .46-1.3c.61-.19 1.22.54 1.83.37s.66-1 .86-1.58a4.5 4.5 0 0 1 2.16-2.12l2.49-1.49c.32-.2.69-.5.61-.87s-.95-.6-.95-1.11c-.05-.74 1.53-.69 1.45-1.43 0-.39-.54-.51-.92-.52-.84 0-1.67-.07-2.51-.07a2 2 0 0 0-1.56.45 8 8 0 0 0-.47.87c-.17.28-.51.52-.81.38a1.13 1.13 0 0 0-1.39-1.42 11.37 11.37 0 0 1-1.58 7.21 6 6 0 0 1-2.79 2.38c.35.32.58.78 1 1.08.92.73 2.46.14 3.31.95a2.64 2.64 0 0 1 .44 2.29 3.15 3.15 0 0 0 .28 2.33 5.28 5.28 0 0 0 .95.81 5.21 5.21 0 0 1 1.3 3.53 6.4 6.4 0 0 0 1.08 3.65 1 1 0 0 0 1 .4c.45-.17.49-.78.56-1.26a5.77 5.77 0 0 1 1.86-3.13 9.32 9.32 0 0 0 2-2.35 2.37 2.37 0 0 0-.53-2.85ZM14.38 45.47 7 38a.63.63 0 0 0-.88 0L4 40a.48.48 0 0 0 .23.83l1.89.38a6.27 6.27 0 0 1 2.79 1.32l5.63 4.18a.36.36 0 0 0 .5-.52ZM41 18.49c-1.1-.19-2.18-.55-3.3-.69a3.34 3.34 0 0 0-2.44.44c-1 .74-1.13 2.19-1.17 3.45a2.3 2.3 0 0 0 .31 1.49 1.77 1.77 0 0 0 1.4.51 7.11 7.11 0 0 1 1.53 0 2.76 2.76 0 0 1 1.77 1.52 8.4 8.4 0 0 1 .65 2.33l.66 3.83a.59.59 0 0 0 .88.41 4 4 0 0 0 1.25-1.45 18.36 18.36 0 0 0 2.34-9.28c0-.66-.1-1.59-.82-1.91-.39-.18-.88-.23-1.09-.55a6.85 6.85 0 0 1-1.97-.1ZM34.7 39.93a.66.66 0 0 1-.64.67l-8.55.33a.49.49 0 0 1-.49-.5.49.49 0 0 1 .49-.5Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.3 34a.52.52 0 0 0-.68-.79L38.68 42.1A5.46 5.46 0 0 1 35 43.54H17.19a2.78 2.78 0 0 0-1.92.78l-.78.76-6.6-6.66-.18.18 8.86 8.95 1.09-1a1.73 1.73 0 0 1 1.2-.49H35a5.46 5.46 0 0 0 3.7-1.44l11.46-10.49ZM15 18.69l.53-2.47-1.42.44a1.13 1.13 0 0 1-1.39-.66 4.9 4.9 0 0 1 0-4.17 5.86 5.86 0 0 1 2.6-2.33c-1.72.81-3.26 1.68-3.94 3.06-1.34 3.06.33 5.6 2.66 7.13l.42.28.24-.07.13-.61Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M17.43 30.68a14.91 14.91 0 0 1-2.71-9.8c0-.33 0-.65.1-1M46.08 16.2a2.31 2.31 0 0 1-1.46 3 2.39 2.39 0 0 1-3-1.49M46.83 15.31l-6.28 2.11M39.69 6.88 37 12.43M39.55 11.55l-1.71-.81M35.75 8.08l-1.84-.82M40.6 9.43l-1.55-.76M35.47 8.72l-1.84-.82M23.52 8.32a15 15 0 0 1 12-.12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.39 19.24a15.1 15.1 0 0 1 .21 3.93 14.94 14.94 0 0 1-4.07 9.21M37.11 36.65c2-.17 9.17-5.21 9.17-5.21a3.07 3.07 0 0 1 3.55.06 1.69 1.69 0 0 1 .33 2.63L38.68 44.57A5.46 5.46 0 0 1 35 46H19.28a2.78 2.78 0 0 0-1.93.78l-.78.76M5.34 38.74l1.34-1.18 11.53 11.65-1.34 1.16"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M25.2 39.85h9.31a2.64 2.64 0 0 0 2.62-2.66 2.64 2.64 0 0 0-2.62-2.66h-7.19a3.5 3.5 0 0 1-2.45-1A8.41 8.41 0 0 0 19 31.32a8 8 0 0 0-5.12 1.58c-1.36 1.13-4 3.55-6.21 5.7M36.77 11.53a2.32 2.32 0 0 1-1-3.16 2.4 2.4 0 0 1 3.21-1M18.23 19.71a6.15 6.15 0 0 0 4-2.76 10.79 10.79 0 0 0 0-11.51.49.49 0 0 0-.75-.07c-3 3-8.74 3.6-10.3 6.78-1.45 3.33.36 6.1 2.9 7.76l.49.32"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M14.7 22.13v-.52A14.93 14.93 0 0 1 20 10.14"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_GreenEnergy56 = (GreenEnergy56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BroadbandEnterpriseSim104.tsx


var BroadbandEnterpriseSim104_excluded = ["className"];
function BroadbandEnterpriseSim104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BroadbandEnterpriseSim104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BroadbandEnterpriseSim104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BroadbandEnterpriseSim104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BroadbandEnterpriseSim104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BroadbandEnterpriseSim104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BroadbandEnterpriseSim104_objectSpread(BroadbandEnterpriseSim104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34 21.45c0-.78.84-1.26 1.52-.86 5.04 2.95 6.03 10.52 6.4 15.75.53 7.31-.53 14.63-.04 21.94.42 6.34 1.04 17.39 8.71 19.39 7.41 1.93 20.9 2.19 19.28 13.57-.15 1.02-1.07 2.75-2.29 2.75H37.36c-1.82 0-3.31-1.2-3.36-3.06-.01-.44 0-.88 0-1.32V21.44Z",
        className: "shade"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47 85h10M70 82.05V92c0 1.1-.9 2-2 2H36c-1.1 0-2-.9-2-2V12c0-1.1.9-2 2-2h32c1.1 0 2 .9 2 2v22.94"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m56.45 50.39.04 24.86c-.31 2.7 1.2 2.74 2.68 2.74l21.43.02c.79 0 1.23-.98.68-1.56-.47-.49-1.23-.93-2.27-1.3-3.05-1.09-13.1-5.73-16.6-14.14-3.5-8.41-2.8-11.23-4.59-11.77-1.19-.36-1.37.44-1.37 1.16Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M88.45 28.83c3.5 5.15 5.55 11.34 5.55 18s-2.05 12.85-5.55 18M82 33.07c1.62 2.38 2.83 5.06 3.53 7.93M15.55 64.83c-3.5-5.15-5.55-11.34-5.55-18 0-6.67 2.05-12.85 5.55-18M22 60.6c-2.67-3.94-4.24-8.67-4.24-13.76s1.57-9.83 4.24-13.77M66.01 68.15l-.01 5.3M71.41 68.17l-.01 5.3M71.42 61.16l.01-5.34M66.02 61.14l.01-5.34M76.89 58.81l-.02 11.68c0 1.52-1.26 2.75-2.82 2.74l-10.73-.05c-1.55 0-2.81-1.25-2.81-2.77l.02-11.68c0-1.52 1.26-2.75 2.82-2.74l10.73.05c1.55 0 2.81 1.25 2.81 2.77Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m73.61 68.09-9.82-.04c-1.79 0-3.26-1.39-3.26-3.06v-.8c0-1.68 1.47-3.04 3.27-3.03l9.82.04c1.79 0 3.26 1.39 3.26 3.06v.8c0 1.68-1.47 3.04-3.27 3.03Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m83.99 48-.16 27.86c0 1-.94 1.81-2.1 1.81l-23.67-.03c-1.15 0-2.08-.81-2.08-1.82l.18-34.19c0-1.17 1.1-2.11 2.45-2.11l17.31.02c1.28 0 2.07.32 2.72.89l4.28 4.29c.8.82 1.06 1.63 1.05 3.27Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BroadbandEnterpriseSim104 = (BroadbandEnterpriseSim104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BroadbandEnterpriseSim56.tsx


var BroadbandEnterpriseSim56_excluded = ["className"];
function BroadbandEnterpriseSim56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BroadbandEnterpriseSim56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BroadbandEnterpriseSim56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BroadbandEnterpriseSim56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BroadbandEnterpriseSim56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BroadbandEnterpriseSim56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BroadbandEnterpriseSim56_objectSpread(BroadbandEnterpriseSim56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.76 12.74c0-.4.43-.65.78-.44 2.59 1.52 3.1 5.4 3.29 8.09.27 3.75-.27 7.51-.02 11.27.22 3.25.53 8.93 4.48 9.96 3.81.99 10.74 1.13 9.9 6.97-.07.52-.55 1.41-1.17 1.41H20.5c-.93 0-1.7-.62-1.73-1.57V12.74Z",
        className: "shade"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.44 44.89h5.12M37.21 44.83v3.67c0 .55-.45 1-1 1H19.78c-.55 0-1-.45-1-1v-41c0-.55.45-1 1-1h16.43c.55 0 1 .45 1 1v12.1"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m30.57 28.06.02 12.54c-.15 1.36.61 1.38 1.35 1.38h10.81c.4 0 .62-.49.34-.78-.24-.25-.62-.47-1.15-.65-1.54-.55-6.61-2.89-8.37-7.14-1.76-4.24-1.41-5.66-2.32-5.94-.6-.18-.69.22-.69.59Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.66 16.14a16.365 16.365 0 0 1 0 18.43M43.36 18.31c.95 1.39 1.62 2.98 1.95 4.69M9.34 34.57a16.365 16.365 0 0 1 0-18.43M12.64 32.4c-1.37-2.02-2.17-4.44-2.17-7.04s.8-5.03 2.17-7.05M35.4 37.02l-.01 2.68M38.12 37.03v2.68M38.13 33.5v-2.69M35.4 33.49l.01-2.7M40.92 32.29v5.94c-.01.77-.65 1.4-1.44 1.39l-5.45-.02c-.79 0-1.43-.63-1.43-1.41v-5.94c.01-.77.65-1.4 1.44-1.39l5.45.02c.79 0 1.43.63 1.43 1.41Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m39.2 37-4.9-.02c-.9 0-1.63-.7-1.62-1.55v-.41c0-.85.74-1.55 1.63-1.54l4.9.02c.9 0 1.63.7 1.62 1.55v.41c0 .85-.74 1.55-1.63 1.54Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m44.41 26.86-.08 14.06c0 .51-.47.91-1.05.91H31.45c-.58-.01-1.04-.42-1.04-.93l.09-17.25c0-.59.55-1.07 1.22-1.07h8.66c.64.01 1.04.17 1.36.46l2.14 2.17c.4.41.53.82.53 1.65Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BroadbandEnterpriseSim56 = (BroadbandEnterpriseSim56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BroadbandMobileSim104.tsx


var BroadbandMobileSim104_excluded = ["className"];
function BroadbandMobileSim104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BroadbandMobileSim104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BroadbandMobileSim104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BroadbandMobileSim104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BroadbandMobileSim104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BroadbandMobileSim104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BroadbandMobileSim104_objectSpread(BroadbandMobileSim104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.49 40.43s4.87 1.8 5.26 1.97c2.72 1.19 4.56 2.21 6.22 4.41 4.03 5.33 3.78 11.84 5.32 17.76.98 3.79 2.37 7.95 5.47 11.1 4.06 4.13 10.02 4.29 16.01 5.29 4.69.78 12.77 2.67 13.53 7.22H57.22c-9.23 0-18.45.16-27.69.04-1.77-.02-4.48-1.4-5.57-2.65-1.59-1.83-1.46-2.67-1.45-4.79.01-3.07.01-6.14.01-9.2V40.43Z",
        className: "shade"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.09 65.89H31.91c-1.1 0-2-.9-2-2V43.75c0-1.1.9-2 2-2h27.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52.2",
        cy: "77.56",
        r: "2.47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M81.69 82.06c-.85 3.51-4.01 6.12-7.78 6.12H30.49c-4.42 0-8-3.58-8-8V36.75c0-4.42 3.58-8 8-8h43.44c3.82 0 7.01 2.67 7.81 6.24"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m65.45 50.39.04 24.86c-.31 2.7 1.2 2.74 2.68 2.74l21.43.02c.79 0 1.23-.98.68-1.56-.47-.49-1.23-.93-2.27-1.3-3.05-1.09-13.1-5.73-16.6-14.14-3.5-8.41-2.8-11.23-4.59-11.77-1.19-.36-1.37.44-1.37 1.16Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.23 15.81c3-.3 6.04.29 8.73 1.9s4.65 4 5.82 6.78M77.24 19.67c2.29-.23 4.61.23 6.67 1.45 2.06 1.23 3.56 3.06 4.45 5.19M26.77 15.81c-3-.3-6.04.29-8.73 1.9-2.69 1.61-4.65 4-5.82 6.78M26.76 19.67c-2.29-.23-4.61.23-6.67 1.45-2.06 1.23-3.56 3.06-4.45 5.19M75.02 68.15l-.01 5.3M80.42 68.17l-.01 5.3M80.43 61.16l.01-5.34M75.03 61.14l.01-5.34M85.9 58.81l-.02 11.68c0 1.52-1.26 2.75-2.82 2.74l-10.73-.05c-1.55 0-2.81-1.25-2.81-2.77l.02-11.68c0-1.52 1.26-2.75 2.82-2.74l10.73.05c1.55 0 2.81 1.25 2.81 2.77Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m82.61 68.09-9.82-.04c-1.79 0-3.26-1.39-3.26-3.06v-.8c0-1.68 1.47-3.04 3.27-3.03l9.82.04c1.79 0 3.26 1.39 3.26 3.06v.8c0 1.68-1.47 3.04-3.27 3.03Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m93 48-.16 27.86c0 1-.94 1.81-2.1 1.81l-23.67-.03c-1.15 0-2.08-.81-2.08-1.82l.18-34.19c0-1.17 1.1-2.11 2.45-2.11l17.31.02c1.28 0 2.07.32 2.72.89l4.28 4.29c.8.82 1.06 1.63 1.05 3.27Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BroadbandMobileSim104 = (BroadbandMobileSim104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BroadbandMobileSim56.tsx


var BroadbandMobileSim56_excluded = ["className"];
function BroadbandMobileSim56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BroadbandMobileSim56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BroadbandMobileSim56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BroadbandMobileSim56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BroadbandMobileSim56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BroadbandMobileSim56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BroadbandMobileSim56_objectSpread(BroadbandMobileSim56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.11 21.77s2.62.97 2.83 1.06c1.47.64 2.45 1.19 3.35 2.37 2.17 2.87 2.04 6.38 2.86 9.56.53 2.04 1.28 4.28 2.94 5.98 2.18 2.22 5.4 2.31 8.62 2.85 2.52.42 6.87 1.44 7.28 3.89h-9.2c-4.97 0-9.94.08-14.91.02-.95-.01-2.41-.75-3-1.43-.86-.99-.79-1.44-.78-2.58V21.76Z",
        className: "shade"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.44 35.48H17.11c-.55 0-1-.45-1-1v-11c0-.55.45-1 1-1h15.33"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28.11",
        cy: "41.76",
        r: "1.33"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.54 44.83a4.987 4.987 0 0 1-4.41 2.65H17.11c-2.76 0-5-2.24-5-5v-22c0-2.76 2.24-5 5-5h21.98c2.46 0 4.51 1.78 4.92 4.12"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m35.58 28.06.02 12.54c-.15 1.36.61 1.38 1.35 1.38h10.81c.4 0 .62-.49.34-.78-.24-.25-.62-.47-1.15-.65-1.54-.55-6.61-2.89-8.37-7.14-1.76-4.24-1.41-5.66-2.32-5.94-.6-.18-.69.22-.69.59Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.58 8.51c1.62-.16 3.25.16 4.7 1.02s2.51 2.15 3.13 3.65M41.59 10.59c1.23-.12 2.48.12 3.59.78s1.92 1.65 2.4 2.79M14.42 8.51c-1.62-.16-3.25.16-4.7 1.02s-2.51 2.15-3.13 3.65M14.41 10.59c-1.23-.12-2.48.12-3.59.78s-1.92 1.65-2.4 2.79M40.4 37.02v2.68M43.13 37.03l-.01 2.68M43.13 33.5l.01-2.69M40.41 33.49v-2.7M45.92 32.29v5.94c-.01.77-.65 1.4-1.44 1.39l-5.45-.02c-.79 0-1.43-.63-1.43-1.41v-5.94c.01-.77.65-1.4 1.44-1.39l5.45.02c.79 0 1.43.63 1.43 1.41Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m44.21 37-4.9-.02c-.9 0-1.63-.7-1.62-1.55v-.41c0-.85.74-1.55 1.63-1.54l4.9.02c.9 0 1.63.7 1.62 1.55v.41c0 .85-.74 1.55-1.63 1.54Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m49.42 26.86-.08 14.06c0 .51-.47.91-1.05.91H36.46c-.58-.01-1.04-.42-1.04-.93l.09-17.25c0-.59.55-1.07 1.22-1.07h8.66c.64.01 1.04.17 1.36.46l2.14 2.17c.4.41.53.82.53 1.65Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BroadbandMobileSim56 = (BroadbandMobileSim56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Document104.tsx


var Document104_excluded = ["className"];
function Document104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Document104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Document104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Document104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Document104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Document104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Document104_objectSpread(Document104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.95 26H73.86C72.28 26 71 24.48 71 22.61V10c0-.55-.45-1-1-1s-1 .45-1 1v12.61c0 2.97 2.18 5.39 4.86 5.39h10.09c.55 0 1-.45 1-1s-.45-1-1-1ZM19.04 60.45l1.15 26.68c0 3.09 2.51 5.6 5.6 5.6h25.17c2.04 0 2.61-2.79.73-3.58-10.53-4.43-24.81-12.09-29.22-27.58-1.02-4.07-3.45-1.78-3.43-1.11Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.19 52.39h43.33M29.19 65.26h43.33M29.19 78.12H54.3M70.97 9.95v11.43c0 2.33 1.76 4.21 3.94 4.21h10.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.06 92.68h33.22c2.16 0 3.94-1.83 3.94-4.06V24.93c0-.52-.19-1.02-.54-1.4L72.07 9.81c-.37-.4-.89-.63-1.43-.63H23.78c-2.17 0-3.94 1.82-3.94 4.06v75.38c0 2.23 1.77 4.06 3.94 4.06H57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.19 39.53h43.33"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Document104 = (Document104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Document56.tsx


var Document56_excluded = ["className"];
function Document56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Document56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Document56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Document56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Document56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Document56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Document56_objectSpread(Document56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m11.01 32.94.45 13.85c0 1.66 1.34 3 3 3h15.77c2.55 0 1.48-1.83.39-1.92-7.9-.63-17.44-5.88-18.65-14.81 0-.83-.95-.78-.95-.12Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.99 14.18v33.1c0 1.17-.92 2.11-2.05 2.11H13.06c-1.12 0-2.05-.95-2.05-2.11V8.1c0-1.17.92-2.11 2.05-2.11h24.35a1 1 0 0 1 .74.33l6.55 7.13c.18.2.28.46.28.73Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.58 6.4v5.94c0 1.21.92 2.19 2.05 2.19h5.35"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.87 28.68h22.52M15.87 35.25h22.52M15.87 41.82h13.48"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.87 22.11h22.52"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Document56 = (Document56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/EnterpriseCloud104.tsx


var EnterpriseCloud104_excluded = ["className"];
function EnterpriseCloud104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function EnterpriseCloud104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? EnterpriseCloud104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EnterpriseCloud104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function EnterpriseCloud104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EnterpriseCloud104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", EnterpriseCloud104_objectSpread(EnterpriseCloud104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.57 78.84c2.53.27 26.11.76 28.17-.43-35.8-4.89-37.03-9.02-37.03-23.58-2.22 1.62-5.7 6.69-5.1 10.76 1.17 7.83 5.1 12.29 13.95 13.24Z",
        className: "shade"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.93 51.36a14.52 14.52 0 0 1-1.01-5.33c0-8.04 6.52-14.56 14.56-14.56 2.9 0 5.61.85 7.88 2.31 3.21-5.48 9.17-9.17 15.98-9.17 10.22 0 18.51 8.29 18.51 18.51v.54c8.13 1.97 14.16 9.1 14.16 17.59 0 10.01-8.38 18.13-18.72 18.13H25.1c-7.79 0-14.1-6.31-14.1-14.1 0-7.05 5.17-12.89 11.93-13.93Z",
        className: "stroke"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m20.28 31.5-7.69-4.3m6.19-8.3 6.31 6.15m6.31-4.99-4.5-7.57"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EnterpriseCloud104 = (EnterpriseCloud104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/EnterpriseCloud56.tsx


var EnterpriseCloud56_excluded = ["className"];
function EnterpriseCloud56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function EnterpriseCloud56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? EnterpriseCloud56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EnterpriseCloud56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function EnterpriseCloud56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EnterpriseCloud56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", EnterpriseCloud56_objectSpread(EnterpriseCloud56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.97 41.83c1.29.14 13.35.39 14.4-.22C10.07 39.11 9.45 37 9.45 29.56c-1.13.83-2.92 3.42-2.6 5.5.6 4 2.6 6.28 7.13 6.77Z",
        className: "shade"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.97 27.67c-.34-.85-.52-1.78-.52-2.76 0-4.16 3.37-7.53 7.53-7.53 1.5 0 2.9.44 4.07 1.2a9.575 9.575 0 0 1 8.26-4.74c5.29 0 9.57 4.28 9.57 9.57v.28c4.2 1.02 7.32 4.7 7.32 9.09 0 5.18-4.33 9.37-9.68 9.37H14.09c-4.03 0-7.29-3.26-7.29-7.29 0-3.64 2.67-6.66 6.17-7.2Z",
        className: "stroke"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m11.12 16.86-3.93-2.2m3.17-4.24 3.22 3.14m3.22-2.55-2.3-3.87"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EnterpriseCloud56 = (EnterpriseCloud56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/GlobalNetworks104.tsx


var GlobalNetworks104_excluded = ["className"];
function GlobalNetworks104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function GlobalNetworks104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GlobalNetworks104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GlobalNetworks104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function GlobalNetworks104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, GlobalNetworks104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", GlobalNetworks104_objectSpread(GlobalNetworks104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "41.06",
        cy: "45.38",
        r: "4.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "70.97",
        cy: "39.88",
        r: "4.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "60.54",
        cy: "74.17",
        r: "4.5"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M87.44 52a35.202 35.202 0 0 1-5.93 19.64c-6.35 9.53-17.2 15.8-29.51 15.8-.7 0-1.4-.02-2.09-.06-.42-.02-.83-.06-1.24-.09-14.2-1.32-25.96-11.02-30.31-24.11-.56-1.67-.99-3.4-1.29-5.18-.33-1.95-.51-3.96-.51-6 0-7.29 2.2-14.06 5.97-19.69 6.36-9.5 17.18-15.75 29.47-15.75a35.206 35.206 0 0 1 15.29 3.46c8.82 4.22 15.63 11.99 18.57 21.46a35.55 35.55 0 0 1 1.59 10.53Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.34 50.36c-.01.16-.03.31-.04.47-.62 7.88.15 15.43 2.03 22.21 1.47 5.29 3.62 10.11 6.33 14.25M49.91 87.38c.69.04 1.39.06 2.09.06 12.31 0 23.15-6.28 29.51-15.8A35.202 35.202 0 0 0 87.44 52c0-3.67-.56-7.2-1.59-10.53C82.91 32 76.1 24.23 67.28 20.01a35.294 35.294 0 0 0-13.58-3.42c-3.45 3.99-6.41 8.82-8.68 14.26a61.75 61.75 0 0 0-2.98 9.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.73 34.37c-.48-5.17-1.65-10.03-3.44-14.36A35.294 35.294 0 0 0 52 16.55c-12.29 0-23.12 6.25-29.47 15.75a35.262 35.262 0 0 0-5.97 19.69c0 2.05.17 4.05.51 6 .3 1.77.74 3.5 1.29 5.18 4.35 13.09 16.11 22.78 30.31 24.11M63.67 69.64c1.7-3.33 3.16-6.91 4.33-10.7 1.41-4.57 2.3-9.12 2.71-13.57M49.91 87.38c2.84-2.4 5.51-5.22 7.93-8.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.12 75.18c-4.46-.31-8.75-1.04-12.79-2.14-8.95-2.43-16.69-6.66-22.4-12.04-1.02-.96-1.98-1.97-2.87-3-.33-1.95-.51-3.96-.51-6 0-7.29 2.2-14.06 5.97-19.69 6.36-9.5 17.18-15.75 29.47-15.75a35.206 35.206 0 0 1 15.29 3.46c8.82 4.22 15.63 11.99 18.57 21.46a35.55 35.55 0 0 1 1.59 10.53 35.202 35.202 0 0 1-5.93 19.64c-4.77 1.74-10.01 2.92-15.54 3.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.24 37.04c-3.89-1.88-8.1-3.43-12.57-4.56a66.98 66.98 0 0 0-8.65-1.62c-8-.96-15.69-.4-22.5 1.45A35.262 35.262 0 0 0 16.55 52c0 2.05.17 4.05.51 6 .3 1.77.74 3.5 1.29 5.18 4.35 13.09 16.11 22.78 30.31 24.11M49.91 87.38c.69.04 1.39.06 2.09.06 12.31 0 23.15-6.28 29.51-15.8 3.3-4.95 5.39-10.77 5.84-17.05-2.94-4.35-6.9-8.4-11.66-11.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.94 47.42C29.4 51.14 23.95 55.81 19.93 61c-.55.72-1.08 1.44-1.58 2.18 4.35 13.09 16.11 22.78 30.31 24.11M65.56 38.85c-4.68.22-9.52.98-14.38 2.31-1.79.49-3.54 1.05-5.24 1.66M49.91 87.38c.69.04 1.39.06 2.09.06 12.31 0 23.15-6.28 29.51-15.8A35.202 35.202 0 0 0 87.44 52c0-3.67-.56-7.2-1.59-10.53-2.96-.99-6.11-1.72-9.41-2.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.57 45.38c0 3.04-2.47 5.51-5.51 5.51s-5.51-2.47-5.51-5.51 2.47-5.51 5.51-5.51 5.51 2.47 5.51 5.51ZM76.47 39.88c0 3.04-2.47 5.51-5.51 5.51s-5.51-2.47-5.51-5.51 2.47-5.51 5.51-5.51 5.51 2.47 5.51 5.51ZM66.04 74.16c0 3.04-2.47 5.51-5.51 5.51s-5.51-2.47-5.51-5.51 2.47-5.51 5.51-5.51 5.51 2.47 5.51 5.51Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.91 87.38c.69.04 1.39.06 2.09.06 12.31 0 23.15-6.28 29.51-15.8A35.202 35.202 0 0 0 87.44 52c0-3.67-.56-7.2-1.59-10.53C82.91 32 76.1 24.23 67.28 20.01a35.294 35.294 0 0 0-15.29-3.46c-12.29 0-23.12 6.25-29.47 15.75a35.262 35.262 0 0 0-5.97 19.69c0 2.05.17 4.05.51 6 .3 1.77.74 3.5 1.29 5.18 4.35 13.09 16.11 22.78 30.31 24.11"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_GlobalNetworks104 = (GlobalNetworks104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/GlobalNetworks56.tsx


var GlobalNetworks56_excluded = ["className"];
function GlobalNetworks56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function GlobalNetworks56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? GlobalNetworks56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : GlobalNetworks56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function GlobalNetworks56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, GlobalNetworks56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", GlobalNetworks56_objectSpread(GlobalNetworks56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.56",
        cy: "24.71",
        r: "2.24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "37.44",
        cy: "21.97",
        r: "2.24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "32.25",
        cy: "39.02",
        r: "2.24"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.63 28c0 .43-.02.86-.05 1.29-.23 3.12-1.26 6.02-2.91 8.48-3.16 4.74-8.55 7.86-14.68 7.86-.35 0-.7-.01-1.04-.03-.21-.01-.41-.03-.62-.05-7.06-.66-12.92-5.48-15.08-11.99-.28-.83-.49-1.69-.64-2.58-.17-.97-.25-1.97-.25-2.99 0-3.62 1.09-6.99 2.97-9.8 3.16-4.73 8.55-7.84 14.66-7.84.28 0 .57 0 .85.02 2.41.11 4.69.71 6.75 1.7a17.72 17.72 0 0 1 9.24 10.67c.51 1.65.79 3.41.79 5.24Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.2 27.19c0 .08-.01.16-.02.24-.31 3.92.07 7.68 1.01 11.05.73 2.63 1.8 5.03 3.15 7.09M26.96 45.6c.34.02.69.03 1.04.03 6.12 0 11.52-3.12 14.68-7.86 1.64-2.46 2.68-5.36 2.91-8.48.03-.43.05-.85.05-1.29 0-1.82-.28-3.58-.79-5.24-1.46-4.71-4.85-8.57-9.24-10.67-2.06-.99-4.34-1.58-6.75-1.7-1.72 1.99-3.19 4.39-4.32 7.1-.6 1.43-1.09 2.94-1.48 4.53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.31 19.23c-.24-2.57-.82-4.99-1.71-7.14a17.554 17.554 0 0 0-7.6-1.72c-6.11 0-11.5 3.11-14.66 7.84-1.88 2.8-2.97 6.17-2.97 9.8 0 1.02.09 2.02.25 2.99.15.88.37 1.74.64 2.58 2.16 6.51 8.01 11.33 15.08 11.99M33.81 36.77c.85-1.66 1.57-3.44 2.15-5.32.7-2.27 1.14-4.54 1.35-6.75M26.96 45.6a26.39 26.39 0 0 0 3.95-4.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.55 39.53c-2.22-.15-4.35-.52-6.36-1.06-4.45-1.21-8.3-3.31-11.14-5.99-.51-.48-.99-.98-1.43-1.49-.17-.97-.25-1.97-.25-2.99 0-3.62 1.09-6.99 2.97-9.8 3.16-4.73 8.55-7.84 14.66-7.84.28 0 .57 0 .85.02 2.41.11 4.69.71 6.75 1.7a17.72 17.72 0 0 1 9.24 10.67c.51 1.65.79 3.41.79 5.24 0 .43-.02.86-.05 1.29-.23 3.12-1.26 6.02-2.91 8.48-2.37.87-4.98 1.45-7.73 1.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.09 20.56a33.77 33.77 0 0 0-6.25-2.27c-1.44-.37-2.88-.63-4.3-.81-3.98-.48-7.81-.2-11.19.72-1.88 2.8-2.97 6.17-2.97 9.8 0 1.02.09 2.02.25 2.99.15.88.37 1.74.64 2.58 2.16 6.51 8.01 11.33 15.08 11.99M26.96 45.6c.34.02.69.03 1.04.03 6.12 0 11.52-3.12 14.68-7.86 1.64-2.46 2.68-5.36 2.91-8.48-1.46-2.17-3.43-4.18-5.8-5.91"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.01 25.72c-3.25 1.85-5.97 4.18-7.96 6.76-.28.36-.54.72-.79 1.08 2.16 6.51 8.01 11.33 15.08 11.99M34.74 21.46c-2.33.11-4.74.49-7.16 1.15-.89.24-1.76.52-2.6.83M26.96 45.6c.34.02.69.03 1.04.03 6.12 0 11.52-3.12 14.68-7.86 1.64-2.46 2.68-5.36 2.91-8.48.03-.43.05-.85.05-1.29 0-1.82-.28-3.58-.79-5.24a25.57 25.57 0 0 0-4.68-1.08"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.3 24.71c0 1.51-1.23 2.74-2.74 2.74s-2.74-1.23-2.74-2.74 1.23-2.74 2.74-2.74 2.74 1.23 2.74 2.74ZM40.18 21.97c0 1.51-1.23 2.74-2.74 2.74s-2.74-1.23-2.74-2.74 1.23-2.74 2.74-2.74 2.74 1.23 2.74 2.74ZM34.99 39.03c0 1.51-1.23 2.74-2.74 2.74s-2.74-1.23-2.74-2.74 1.23-2.74 2.74-2.74 2.74 1.23 2.74 2.74Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.96 45.6c.34.02.69.03 1.04.03 6.12 0 11.52-3.12 14.68-7.86 1.64-2.46 2.68-5.36 2.91-8.48.03-.43.05-.85.05-1.29 0-1.82-.28-3.58-.79-5.24-1.46-4.71-4.85-8.57-9.24-10.67a17.554 17.554 0 0 0-7.6-1.72c-6.11 0-11.5 3.11-14.66 7.84-1.88 2.8-2.97 6.17-2.97 9.8 0 1.02.09 2.02.25 2.99.15.88.37 1.74.64 2.58 2.16 6.51 8.01 11.33 15.08 11.99"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_GlobalNetworks56 = (GlobalNetworks56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/IOT104.tsx


var IOT104_excluded = ["className"];
function IOT104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function IOT104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? IOT104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : IOT104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function IOT104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, IOT104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", IOT104_objectSpread(IOT104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "52.71",
        cy: "51.58",
        rx: "13.66",
        ry: "13.76",
        className: "shade"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52.55",
        cy: "51.77",
        r: "14.57",
        transform: "rotate(-77.15 52.544 51.765)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "78.17",
        cy: "23.92",
        r: "6.41",
        transform: "rotate(-80.88 78.169 23.921)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "74.98",
        cy: "73.27",
        r: "6.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "29.34",
        cy: "17.51",
        r: "6.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.8",
        cy: "37.9",
        r: "6.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.8",
        cy: "78.59",
        r: "6.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.48 74.22 41.9 61.7M70.35 68.84l-7.29-6.99M73.83 28.63 62.41 41.04M44.37 39.7 32.93 22.82M29.57 40.68l9.85 4.75"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_IOT104 = (IOT104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/IOT56.tsx


var IOT56_excluded = ["className"];
function IOT56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function IOT56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? IOT56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : IOT56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function IOT56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, IOT56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", IOT56_objectSpread(IOT56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "27.79",
        cy: "27.91",
        rx: "6.86",
        ry: "6.91",
        className: "shade"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "27.79",
        cy: "27.91",
        rx: "7.37",
        ry: "7.49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "40.76",
        cy: "13.59",
        rx: "3.24",
        ry: "3.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "39.14",
        cy: "38.97",
        rx: "3.24",
        ry: "3.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "16.04",
        cy: "10.3",
        rx: "3.24",
        ry: "3.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "13.24",
        cy: "20.78",
        rx: "3.24",
        ry: "3.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "13.24",
        cy: "41.7",
        rx: "3.24",
        ry: "3.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m15.61 39.46 6.79-6.44M36.8 36.69l-3.69-3.6M38.56 16.01l-5.78 6.39M23.65 21.71l-5.79-8.69M16.16 22.21l4.99 2.44"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_IOT56 = (IOT56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/MobileSim104.tsx


var MobileSim104_excluded = ["className"];
function MobileSim104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function MobileSim104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MobileSim104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MobileSim104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function MobileSim104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MobileSim104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", MobileSim104_objectSpread(MobileSim104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.59 88.09c-2.98-1.91-6.66-2.07-9.77-3.78-13.3-6.96-16.13-22.97-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46c0 4.18 3.38 7.56 7.56 7.57h28.42c.2-2.38-1.38-4.62-3.4-5.91Z",
        className: "shade"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43 14h4M39 90h12M68 82.05V88c0 3.31-2.69 6-6 6H28c-3.31 0-6-2.69-6-6V16c0-3.31 2.69-6 6-6h34c3.31 0 6 2.69 6 6v18.96"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m54.45 50.39.04 24.86c-.31 2.7 1.2 2.74 2.68 2.74l21.43.02c.79 0 1.23-.98.68-1.56-.47-.49-1.23-.93-2.27-1.3-3.05-1.09-13.1-5.73-16.6-14.14-3.5-8.41-2.8-11.23-4.59-11.77-1.19-.36-1.37.44-1.37 1.16Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m64.02 68.15-.01 5.3M69.42 68.17l-.01 5.3M69.43 61.16l.01-5.34M64.03 61.14l.01-5.34M74.9 58.81l-.02 11.68c0 1.52-1.26 2.75-2.82 2.74l-10.73-.05c-1.55 0-2.81-1.25-2.81-2.77l.02-11.68c0-1.52 1.26-2.75 2.82-2.74l10.73.05c1.55 0 2.81 1.25 2.81 2.77Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m71.61 68.09-9.82-.04c-1.79 0-3.26-1.39-3.26-3.06v-.8c0-1.68 1.47-3.04 3.27-3.03l9.82.04c1.79 0 3.26 1.39 3.26 3.06v.8c0 1.68-1.47 3.04-3.27 3.03Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m82 48-.16 27.86c0 1-.94 1.81-2.1 1.81l-23.67-.03c-1.15 0-2.08-.81-2.08-1.82l.18-34.19c0-1.17 1.1-2.11 2.45-2.11l17.31.02c1.28 0 2.07.32 2.72.89l4.28 4.29c.8.82 1.06 1.63 1.05 3.27Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MobileSim104 = (MobileSim104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/MobileSim56.tsx


var MobileSim56_excluded = ["className"];
function MobileSim56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function MobileSim56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MobileSim56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MobileSim56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function MobileSim56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MobileSim56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", MobileSim56_objectSpread(MobileSim56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.21 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z",
        className: "shade"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.25 8h2M21.25 48h6M36.25 44.83V47c0 1.66-1.34 3-3 3h-18c-1.66 0-3-1.34-3-3V9c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v10.6"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m29.91 28.06.02 12.54c-.15 1.36.61 1.38 1.35 1.38h10.81c.4 0 .62-.49.34-.78-.24-.25-.62-.47-1.15-.65-.46-.16-1.23-.49-2.13-.97-2.13-1.14-5-3.19-6.24-6.17-.3-.72-.54-1.36-.73-1.93-.95-2.76-.83-3.78-1.58-4.01-.6-.18-.69.22-.69.59Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.73 37.02v2.68M37.46 37.03l-.01 2.68M37.46 33.5l.01-2.69M34.74 33.49v-2.7M40.25 32.29v5.94c-.01.77-.65 1.4-1.44 1.39l-5.45-.02c-.79 0-1.43-.63-1.43-1.41v-5.94c.01-.77.65-1.4 1.44-1.39l5.45.02c.79 0 1.43.63 1.43 1.41Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m38.54 37-4.9-.02c-.9 0-1.63-.7-1.62-1.55v-.41c0-.85.74-1.55 1.63-1.54l4.9.02c.9 0 1.63.7 1.62 1.55v.41c0 .85-.74 1.55-1.63 1.54Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m43.75 26.86-.08 14.06c0 .51-.47.91-1.05.91H30.79c-.58-.01-1.04-.42-1.04-.93l.09-17.25c0-.59.55-1.07 1.22-1.07h8.66c.64.01 1.04.17 1.36.46l2.14 2.17c.4.41.53.82.53 1.65Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MobileSim56 = (MobileSim56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/TabletSim104.tsx


var TabletSim104_excluded = ["className"];
function TabletSim104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function TabletSim104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TabletSim104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TabletSim104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function TabletSim104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TabletSim104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TabletSim104_objectSpread(TabletSim104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.7 93.8v-1s-4.1 0-15.5-8.3-13.5-20.8-14.5-33.2 0-17.4-5.2-17.4V85.1c0 6.7 1 8.7 8.7 8.7h26.5c.1-.4.1.3 0 0z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.8 89h11.7M76.1 82.2v6.6c0 2.8-2.2 5-5 5H18.3c-2.8 0-5-2.2-5-5V15.2c0-2.8 2.2-5 5-5H71c2.8 0 5 2.2 5 5v19.6"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "44.7",
      cy: "15",
      r: "1"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.1 50.4v24.9c-.3 2.7 1.2 2.7 2.7 2.7h21.4c.8 0 1.2-1 .7-1.6-.5-.5-1.2-.9-2.3-1.3C82.5 74 72.5 69.4 69 61s-2.8-11.2-4.6-11.8c-1.1-.3-1.3.5-1.3 1.2z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.7 68.2v5.2M78.1 68.2v5.3M78.1 61.2v-5.4M72.7 61.1v-5.3M83.6 58.8v11.7c0 1.5-1.3 2.8-2.8 2.7H70c-1.6 0-2.8-1.2-2.8-2.8V58.7c0-1.5 1.3-2.8 2.8-2.7h10.7c1.6 0 2.9 1.3 2.9 2.8z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M80.3 68.1h-9.8c-1.8 0-3.3-1.4-3.3-3.1v-.8c0-1.7 1.5-3 3.3-3h9.8c1.8 0 3.3 1.4 3.3 3.1v.8c0 1.6-1.5 3-3.3 3z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m90.7 48-.2 27.9c0 1-.9 1.8-2.1 1.8H64.7c-1.2 0-2.1-.8-2.1-1.8l.2-34.2c0-1.2 1.1-2.1 2.4-2.1h17.3c1.3 0 2.1.3 2.7.9l4.3 4.3c.9.7 1.2 1.6 1.2 3.2z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TabletSim104 = (TabletSim104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/TabletSim56.tsx


var TabletSim56_excluded = ["className"];
function TabletSim56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function TabletSim56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TabletSim56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TabletSim56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function TabletSim56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TabletSim56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TabletSim56_objectSpread(TabletSim56_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.6 49.9v-.5s-2.2 0-8.1-4.3-7.1-10.8-7.6-17.4 0-9.1-2.7-9.1v26.8c0 3.5.5 4.6 4.6 4.6h13.8v-.1z",
        className: "shade"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.4 47.3h6.1M40.9 44.8v2.6c0 1.4-1.1 2.5-2.5 2.5H10.6c-1.4 0-2.5-1.1-2.5-2.5V8.6c0-1.4 1.1-2.5 2.5-2.5h27.8c1.4 0 2.5 1.1 2.5 2.5v11"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "24.5",
      cy: "8.6",
      r: ".5"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.1 28.1v12.5c-.1 1.4.7 1.4 1.4 1.4h10.8c.4 0 .6-.5.3-.8-.2-.2-.6-.5-1.2-.7-1.5-.5-6.6-2.9-8.4-7.1-1.8-4.2-1.4-5.7-2.3-5.9-.5-.2-.6.2-.6.6z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m39 37-.1 2.7M41.7 37v2.7M41.7 33.5v-2.7M39 33.5v-2.7M44.5 32.3v5.9c0 .8-.7 1.4-1.4 1.4h-5.5c-.8 0-1.4-.6-1.4-1.4v-5.9c0-.8.7-1.4 1.4-1.4h5.5c.7 0 1.4.6 1.4 1.4z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.8 37h-4.9c-.9 0-1.6-.7-1.6-1.5V35c0-.8.7-1.5 1.6-1.5h4.9c.9 0 1.6.7 1.6 1.5v.4c0 .9-.8 1.6-1.6 1.6z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48 26.9 47.9 41c0 .5-.5.9-1 .9H35c-.6 0-1-.4-1-.9V23.7c0-.6.5-1.1 1.2-1.1h8.7c.6 0 1 .2 1.4.5l2.1 2.2c.4.3.6.7.6 1.6z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TabletSim56 = (TabletSim56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/UnifiedComms104.tsx


var UnifiedComms104_excluded = ["className"];
function UnifiedComms104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function UnifiedComms104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? UnifiedComms104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : UnifiedComms104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function UnifiedComms104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, UnifiedComms104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", UnifiedComms104_objectSpread(UnifiedComms104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.78 33.81c1.04 0 2.01-.28 2.85-.75a9.356 9.356 0 0 1-7.86-7.86c-.48.84-.75 1.81-.75 2.85 0 3.19 2.58 5.77 5.77 5.77ZM77.47 33.81c1.04 0 2.01-.28 2.85-.75a9.356 9.356 0 0 1-7.86-7.86c-.48.84-.75 1.81-.75 2.85 0 3.19 2.58 5.77 5.77 5.77ZM52.45 82.61c1.04 0 2.01-.28 2.85-.75A9.356 9.356 0 0 1 47.44 74c-.48.84-.75 1.81-.75 2.85 0 3.19 2.58 5.77 5.77 5.77Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52.43",
        cy: "77.02",
        r: "6.44"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "51.99",
        cy: "76.5",
        r: "15.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.08 88c3.2-2.22 5.03-4 10.4-4 4.36 0 6.8 1.63 9.53 4 .24.2-4.71 3.98-9.53 4-5.48.02-11.12-3.5-10.4-4Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "77.33",
        cy: "28.02",
        r: "6.44"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "76.9",
        cy: "27.5",
        r: "15.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.99 39c3.2-2.22 5.03-4 10.4-4 4.36 0 6.8 1.63 9.53 4 .24.2-4.71 3.98-9.53 4-5.48.02-11.12-3.5-10.4-4Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28.93",
        cy: "28.02",
        r: "6.44"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28.5",
        cy: "27.5",
        r: "15.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.59 39c3.2-2.22 5.03-4 10.4-4 4.36 0 6.8 1.63 9.53 4 .24.2-4.71 3.98-9.53 4-5.48.02-11.12-3.5-10.4-4Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m60.06 40.51-7.91 7.9M43.71 40.33l7.91 7.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.99 56.67v-8.42"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_UnifiedComms104 = (UnifiedComms104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/UnifiedComms56.tsx


var UnifiedComms56_excluded = ["className"];
function UnifiedComms56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function UnifiedComms56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? UnifiedComms56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : UnifiedComms56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function UnifiedComms56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, UnifiedComms56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", UnifiedComms56_objectSpread(UnifiedComms56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.03 18.91c.52 0 1-.14 1.42-.38-2.03-.3-3.63-1.9-3.93-3.93-.24.42-.38.91-.38 1.42a2.89 2.89 0 0 0 2.88 2.89ZM40.38 18.91c.52 0 1-.14 1.42-.38-2.03-.3-3.63-1.9-3.93-3.93-.24.42-.38.91-.38 1.42a2.89 2.89 0 0 0 2.88 2.89ZM27.87 44.32c.52 0 1-.14 1.42-.38-2.03-.3-3.63-1.9-3.93-3.93-.24.42-.38.91-.38 1.42a2.89 2.89 0 0 0 2.88 2.89Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "27.86",
        cy: "41.53",
        r: "3.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "27.64",
        cy: "41.27",
        r: "7.75"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.68 47.02c1.6-1.11 2.52-2 5.2-2 2.18 0 3.4.82 4.77 2 .12.1-2.35 1.99-4.77 2-2.74.01-5.56-1.75-5.2-2Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "40.31",
        cy: "16.02",
        r: "3.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "40.1",
        cy: "15.75",
        r: "7.75"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.14 21.51c1.6-1.11 2.52-2 5.2-2 2.18 0 3.4.82 4.77 2 .12.1-2.35 1.99-4.77 2-2.74.01-5.56-1.75-5.2-2Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "16.1",
        cy: "16.02",
        r: "3.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "15.89",
        cy: "15.75",
        r: "7.75"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.93 21.51c1.6-1.11 2.52-2 5.2-2 2.18 0 3.4.82 4.77 2 .12.1-2.35 1.99-4.77 2-2.74.01-5.56-1.75-5.2-2Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.67 23.26-3.95 3.96M23.5 23.17l3.95 3.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.64 31.35v-4.22"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_UnifiedComms56 = (UnifiedComms56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Entertainment104.tsx


var Entertainment104_excluded = ["className"];
function Entertainment104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Entertainment104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Entertainment104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Entertainment104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Entertainment104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Entertainment104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Entertainment104_objectSpread(Entertainment104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.1 50.4 25 60.9h5.2c-3.1-3.2-5.8-6.7-8.1-10.5zM77.4 44.2s-9.2 14.1-10.8 17.4c3.2-7.9 8.6-20.2 8.6-20.2l2.2 2.8z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M78.7 30.9c-3.9 1.9-5.5 6.6-3.6 10.5.8 1.6 2.1 2.8 3.6 3.6 1 .5 2.2.8 3.3.8l.2-.1c-10.2-5.6-3.6-14.8-3.5-14.8M59.7 57.2c-.2 0-.5-.1-.6-.2-.4-.3-.5-1-.1-1.4.3-.3.5-.7.8-1 .3-.5.9-.6 1.4-.3s.6.9.3 1.4l-.9 1.2c-.3.1-.6.3-.9.3zM62 53.1h-.3c-.5-.1-.8-.7-.7-1.2.3-.9.5-1.9.5-2.9 0-.6.4-1 1-1.1.5 0 1 .4 1 .9v.1c0 1.2-.2 2.4-.5 3.6-.2.3-.6.6-1 .6zM61.9 46.5c-.5 0-.9-.3-1-.7-.3-1-.7-1.9-1.2-2.8-.3-.4-.2-1.1.2-1.4.4-.3 1.1-.2 1.4.2.7 1 1.2 2.2 1.6 3.3.2.5-.1 1.1-.7 1.2-.1.1-.2.2-.3.2zM41.9 15.8c-1.8 3.7-1.4 9.4 1.6 14.7 3 5.5 7.9 9 12.1 9.1-10.4-7.7-13.1-19.7-13.7-23.8M56.5 73.3l-4.1-11.5-.4 29.5h8.6s5.4-13.6 23-13.2v-4.9l-27.1.1zM19.3 76.5h26.5c.6.1 1.2-.2 1.5-.8l.8-2.2H19.3v3z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m29.6 53.5-3.1.9-1-3.1 3.1-.9z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m31.8 60.4-3.1.9-1-3.1 3.1-.9z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m44.1 48.9-3.1 1-1-3.1 3.1-1z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m46.3 55.8-3.1 1-1-3.1 3.1-1z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m51.7 60.5-.7-2.3-5-16c-.7-2.2-3-3.4-5.2-2.7L23.5 45 16 47.3c2.2-.7 4.5.5 5.2 2.6l3.3 10.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m75.3 60.7 8.5-15.1c-3.5.7-7-1-8.6-4.2l-8.2 19"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M84.5 33.8c2.1 1 3 3.5 2 5.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M89.2 41.3c-1.9 3.9-6.6 5.5-10.5 3.6s-5.5-6.6-3.6-10.5 6.6-5.5 10.5-3.6c3.9 1.9 5.5 6.6 3.6 10.5z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m55.1 31.2-6.1-11"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m49.8 26.9 4.4-2.4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m51.3 29.6 4.4-2.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m48.3 24.3 4.5-2.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M60.6 20.9c4 7.2 3.4 15.2-1.3 17.8s-11.8-1.1-15.8-8.3-3.5-15.1 1.3-17.7 11.8 1 15.8 8.2z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20.1 60.7H52v30.6H20.1V74M83.9 74.2v17.1H52V60.7h31.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20.1 60.8 13 73.3h34.5L52 60.8zM83.9 60.8 91 73.3H56.5L52 60.8z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Entertainment104 = (Entertainment104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Entertainment56.tsx


var Entertainment56_excluded = ["className"];
function Entertainment56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Entertainment56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Entertainment56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Entertainment56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Entertainment56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Entertainment56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Entertainment56_objectSpread(Entertainment56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "10.29",
        y: "7.14",
        width: "38.63",
        height: "40.84",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M10.29 47.98h38.64V7.14H10.29v40.84z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "8.15",
        y: "5.86",
        width: "41.93",
        height: "44.33",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M8.15 50.18h41.94V5.86H8.15v44.32z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "18.48",
        y: "10.07",
        width: "29.65",
        height: "31.34",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M18.48 41.41h29.65V10.07H18.48v31.34z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "10.29",
        y: "7.14",
        width: "38.67",
        height: "40.84",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M10.29 47.98h38.64V7.14H10.29v40.84z"
          })
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m11.89 27.16 1.57 5.64h2.78a37.56 37.56 0 0 1-4.35-5.64Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41.66 23.77s-5 7.62-5.81 9.4c1.71-4.27 4.6-10.86 4.6-10.86Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42.35 16.63a4.15 4.15 0 0 0-1.92 1.94 4.22 4.22 0 0 0 3.76 6.07h.12c-5.56-3-2-8-2-8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.14 30.79a.53.53 0 0 1-.41-.88c.14-.18.28-.36.4-.54A.54.54 0 0 1 33 30c-.14.21-.3.42-.46.62a.55.55 0 0 1-.4.17ZM33.37 28.59a.45.45 0 0 1-.16 0 .54.54 0 0 1-.35-.67 5.18 5.18 0 0 0 .24-1.56.56.56 0 0 1 .53-.57.52.52 0 0 1 .54.5 6.08 6.08 0 0 1-.3 1.92.53.53 0 0 1-.5.38ZM33.35 25a.56.56 0 0 1-.52-.38 6.19 6.19 0 0 0-.69-1.49.54.54 0 0 1 .87-.63 7 7 0 0 1 .85 1.8.54.54 0 0 1-.35.67Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.55 8.51c-1 2-.73 5.06.85 7.9s4.26 4.82 6.54 4.9c-5.58-4.12-7-10.59-7.39-12.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m30.45 39.46-2.24-6.2L28 49.17h4.61s2.93-7.3 12.37-7.09v-2.62ZM10.37 41.17h14.29a.83.83 0 0 0 .8-.41l.44-1.18H10.37Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m15.94 28.79-1.67.52-.52-1.67 1.67-.52.52 1.67z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m17.11 32.51-1.67.52-.52-1.67 1.67-.52.52 1.67z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m23.75 26.33-1.66.52-.53-1.67 1.67-.52.52 1.67z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m24.93 30.05-1.67.52-.53-1.67 1.67-.52.53 1.67z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m27.86 32.59-.4-1.25-2.7-8.6A2.22 2.22 0 0 0 22 21.29l-9.3 2.93-4.08 1.27a2.23 2.23 0 0 1 2.78 1.45l1.79 5.69"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m40.52 32.71 4.56-8.16a4.15 4.15 0 0 1-2.69-.33 4.27 4.27 0 0 1-1.94-1.91L36 32.55"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45.52 18.21a2.27 2.27 0 0 1 1.06 3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48 22.25a4.23 4.23 0 1 1-2-5.64 4.23 4.23 0 0 1 2 5.64Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m29.68 16.82-3.32-5.96"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m26.83 14.5 2.38-1.32"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.62 15.93 30 14.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m26.04 13.08 2.37-1.33"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.64 11.27c2.16 3.88 1.84 8.17-.71 9.59s-6.37-.57-8.53-4.45-1.84-8.17.71-9.59 6.37.57 8.53 4.45Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M10.82 32.7h17.19v16.47H10.82v-9.32"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45.16 39.93v9.24H27.99V32.7h17.17"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m10.83 32.71-3.82 6.75h18.57l2.44-6.75H10.83zM45.18 32.71l3.81 6.75H30.45l-2.43-6.75h17.16z"
        })]
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Entertainment56 = (Entertainment56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/EntertainmentPackages104.tsx


var EntertainmentPackages104_excluded = ["className"];
function EntertainmentPackages104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function EntertainmentPackages104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? EntertainmentPackages104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EntertainmentPackages104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function EntertainmentPackages104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EntertainmentPackages104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", EntertainmentPackages104_objectSpread(EntertainmentPackages104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m49.8 61.5 12.5-2.1c.7-.1 1.4-.3 2-.5l11.2-4.1c1.5-.4 3-.4 4.4-.1l11-4v-25c0-1.3-1.1-2.4-2.4-2.4H60.1L27.4 70.2h10.3l5.4-2c.7-3.4 3.3-6 6.7-6.7z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M62.5 79.8c-1 .3-1.9.9-2.5 1.8-1.1 1.7-3.1 4.9-4.8 7.9-2.6 4.4-6.2 3.2-6.2 3.2-2.9-.7-4.9-3.3-4.8-6.2l-1.3-13.8c-.4-2.4 0-4.9 1.1-7l1.3 13.9c-.1 3.1 2 5.9 5 6.7 0 0 3.1.8 6.5-3.4 2.4-2.9 2.5-3.6 6.9-4.2l-1.2 1.1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M75 76c1.9 1 6.2 4.2 9.3 5.9 4.4 2.6 7-.2 7-.2 2.2-2 2.7-5.2 1.2-7.8L87 61.3c-.7-1.8-1.8-3.4-3.2-4.7.3.6.6 1.2.8 1.9l5.6 12.8c1.5 2.6 1 5.8-1.2 7.8 0 0-2.6 2.8-7 .2-2.2-1.1-4.5-2.1-6.9-3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m54.2 75.7-.1-.4c-.2-1-1.2-1.6-2.2-1.4h-.3c-1.1.3-2.2-.3-2.6-1.4v-.1c-.1-.4-.1-.9.1-1.3H49c-1.1.3-1.8 1.4-1.5 2.6.3 1.1 1.4 1.8 2.5 1.5l2-.4.6 2.1c.3 1.1 1.4 1.8 2.6 1.5.6-.2 1.1-.6 1.4-1.2-1.1.2-2.1-.5-2.4-1.5z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "76.5",
          cy: "61.9",
          r: "2.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "78.8",
          cy: "71.3",
          r: "2.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "82.4",
          cy: "65.5",
          r: "2.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "73",
          cy: "67.7",
          r: "2.3"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.8 81.4h21"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42.7 73.6H13.8c-2 0-3.6-1.6-3.6-3.6V23.4c0-2 1.6-3.6 3.6-3.6h76.4c2 0 3.6 1.6 3.6 3.6V70c0 1.2-.6 2.3-1.6 3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.8 81.4v-7.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m57.4 69-2.2.6-.6-2.2c-.3-1.2-1.5-2-2.7-1.7-1.2.3-1.9 1.5-1.6 2.7l.6 2.2-2.2.6c-.6.1-1.1.5-1.3 1-.3.5-.4 1.1-.2 1.7.1.6.5 1.1 1 1.4.5.3 1.1.4 1.7.2L52 75l.6 2.2c.3 1.2 1.5 1.9 2.7 1.6.6-.1 1.1-.5 1.4-1 .3-.5.4-1.1.2-1.7l-.6-2.2 2.2-.6c1.2-.3 1.9-1.5 1.6-2.7-.3-1.1-1.5-1.9-2.7-1.6z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M75.5 54.8s7.8-2.6 11.5 6.5L92.5 74c1.5 2.6 1 5.8-1.2 7.8 0 0-2.6 2.8-7 .2-3-1.8-6.2-3.6-8-4.6-.9-.5-2-.6-3-.4l-2.8.7-5 1.3-2.8.7c-1 .3-1.9.9-2.5 1.8-1.1 1.8-3.1 4.9-4.9 7.9-2.6 4.4-6.2 3.2-6.2 3.2-2.9-.7-4.9-3.3-4.8-6.2L43 72.6c-1.1-9.8 6.9-11.1 6.9-11.1l12.5-2.1c.7-.1 1.4-.3 2-.5l11.1-4.1z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EntertainmentPackages104 = (EntertainmentPackages104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/EntertainmentPackages56.tsx


var EntertainmentPackages56_excluded = ["className"];
function EntertainmentPackages56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function EntertainmentPackages56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? EntertainmentPackages56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EntertainmentPackages56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function EntertainmentPackages56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EntertainmentPackages56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", EntertainmentPackages56_objectSpread(EntertainmentPackages56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.83 33.09 33.54 32a4.85 4.85 0 0 0 1.06-.27l6-2.21a5.11 5.11 0 0 1 2.4-.07l6-2.22V13.85a1.31 1.31 0 0 0-1.3-1.31H32.35l-17.6 25.27h5.55l2.9-1.07a4.74 4.74 0 0 1 3.63-3.65Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.64 42.94a2.21 2.21 0 0 0-1.32 1c-.59.93-1.66 2.63-2.61 4.24-1.42 2.38-3.36 1.72-3.36 1.72a3.35 3.35 0 0 1-2.59-3.35l-.69-7.44a6.06 6.06 0 0 1 .6-3.76l.71 7.5a3.51 3.51 0 0 0 2.72 3.58s1.66.41 3.53-1.82c1.31-1.61 1.37-1.98 3.73-2.29l-.71.66"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40.38 40.94c1 .53 3.36 2.24 5 3.19 2.38 1.41 3.77-.09 3.77-.09a3.36 3.36 0 0 0 .67-4.19l-3-6.87a6.52 6.52 0 0 0-1.72-2.53 8.15 8.15 0 0 1 .46 1l3 6.87a3.34 3.34 0 0 1-.66 4.18s-1.39 1.51-3.77.1c-1.21-.6-2.45-1.13-3.71-1.61"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m29.21 40.76-.05-.19a1 1 0 0 0-.46-.57 1 1 0 0 0-.76-.12h-.17a1.09 1.09 0 0 1-.85-.11 1.14 1.14 0 0 1-.52-.7 1.09 1.09 0 0 1 .06-.71h-.1a1.14 1.14 0 0 0-.82 1.37 1.13 1.13 0 0 0 1.38.82l1.08-.28.34 1.11a1.13 1.13 0 0 0 1.38.82 1.13 1.13 0 0 0 .74-.64 1.11 1.11 0 0 1-1.25-.8Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "41.2",
          cy: "33.34",
          r: "1.22"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "42.45",
          cy: "38.38",
          r: "1.22"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "44.35",
          cy: "35.27",
          r: "1.22"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "39.3",
          cy: "36.45",
          r: "1.22"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M12.28 43.84h11.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23 39.62H7.42A1.92 1.92 0 0 1 5.5 37.7V12.61a1.92 1.92 0 0 1 1.92-1.92h41.16a1.92 1.92 0 0 1 1.92 1.92V37.7a1.93 1.93 0 0 1-.87 1.61"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20.92 43.84v-4.21"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m30.92 37.13-1.17.3-.3-1.17a1.21 1.21 0 0 0-1.45-.88 1.19 1.19 0 0 0-.86 1.44l.3 1.17-1.18.3a1.2 1.2 0 0 0-.73.55 1.18 1.18 0 0 0-.12.9 1.23 1.23 0 0 0 .54.74 1.18 1.18 0 0 0 .9.12l1.15-.22.3 1.17a1.2 1.2 0 0 0 1.45.86 1.15 1.15 0 0 0 .73-.54 1.2 1.2 0 0 0 .13-.91l-.3-1.17 1.17-.3a1.15 1.15 0 0 0 .73-.54 1.18 1.18 0 0 0 .13-.9 1.19 1.19 0 0 0-1.42-.92Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40.65 29.48s4.18-1.39 6.17 3.5l3 6.87a3.36 3.36 0 0 1-.67 4.15s-1.39 1.5-3.77.09c-1.6-1-3.34-1.92-4.32-2.46a2.25 2.25 0 0 0-1.63-.2l-1.53.39-2.68.68-1.53.39a2.24 2.24 0 0 0-1.33 1c-.6.94-1.67 2.63-2.61 4.23-1.42 2.38-3.36 1.72-3.36 1.72a3.35 3.35 0 0 1-2.59-3.35l-.69-7.44c-.61-5.25 3.7-6 3.72-6L33.54 32a4.85 4.85 0 0 0 1.06-.27Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EntertainmentPackages56 = (EntertainmentPackages56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Foxtel104.tsx


var Foxtel104_excluded = ["className"];
function Foxtel104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Foxtel104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Foxtel104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Foxtel104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Foxtel104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Foxtel104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Foxtel104_objectSpread(Foxtel104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m27.4 70.2 32.7-46.9h28.4c1.3 0 2.4 1.1 2.4 2.4v24.9L37.7 70.2H27.4z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M84.5 68.4v14.3c0 3.7 3 3.2 3 3.2h3.9c-6.5-5.7-6.9-17.5-6.9-17.5z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.8 81.4h57.4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M84 73.6H13.8c-2 0-3.6-1.6-3.6-3.6V23.4c0-2 1.6-3.6 3.6-3.6h76.4c2 0 3.6 1.6 3.6 3.6V62"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M65.2 73.6v7.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.8 81.4v-7.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M92.7 86h-6.4c-1.2 0-2.2-1-2.2-2.2V64.2c0-1.2.9-2.2 2.1-2.2h6.4c1.2 0 2.2 1 2.2 2.2v19.6c.1 1.2-.8 2.2-2.1 2.2z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M92.3 66.5h-1.7v-1.8c0-.3-.2-.5-.5-.6h-1.2c-.3 0-.5.2-.6.5v1.8h-1.7c-.3 0-.5.3-.5.6v1.2c0 .3.2.5.5.5h1.7v1.7c0 .3.2.6.5.6H90c.3 0 .6-.2.6-.5v-1.7h1.7c.3 0 .5-.2.5-.5V67c.1-.3-.2-.5-.5-.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M88.6 74.3c0 .7-.6 1.2-1.3 1.2s-1.2-.6-1.2-1.3c0-.7.6-1.2 1.2-1.2.8 0 1.3.6 1.3 1.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M92.9 74.3c0 .7-.6 1.2-1.3 1.2s-1.2-.6-1.2-1.3c0-.7.6-1.2 1.2-1.2.7 0 1.3.6 1.3 1.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M88.6 78.4c0 .7-.6 1.2-1.2 1.2s-1.2-.6-1.2-1.2c0-.7.6-1.2 1.2-1.2.7 0 1.2.6 1.2 1.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M92.9 78.4c0 .7-.6 1.2-1.2 1.2s-1.2-.6-1.2-1.2c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M88.6 82.6c0 .7-.6 1.2-1.2 1.2s-1.2-.6-1.2-1.2c0-.7.6-1.2 1.2-1.2.7 0 1.2.5 1.2 1.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M92.9 82.6c0 .7-.6 1.2-1.2 1.2s-1.2-.6-1.2-1.2c0-.7.6-1.2 1.2-1.2s1.2.5 1.2 1.2"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Foxtel104 = (Foxtel104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Foxtel56.tsx


var Foxtel56_excluded = ["className"];
function Foxtel56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Foxtel56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Foxtel56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Foxtel56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Foxtel56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Foxtel56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Foxtel56_objectSpread(Foxtel56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m15 39 17.42-25.1H47.6a1.3 1.3 0 0 1 1.3 1.29v13.29L20.45 39Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.58 40.58H8.42a1.92 1.92 0 0 1-1.92-1.92V14.22a1.92 1.92 0 0 1 1.92-1.92h40.16a1.92 1.92 0 0 1 1.92 1.92v24.44a1.92 1.92 0 0 1-1.92 1.92Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21.58 44.7v-4.12h13.84v4.12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M13.13 44.7h30.74"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Foxtel56 = (Foxtel56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Gaming104.tsx


var Gaming104_excluded = ["className"];
function Gaming104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Gaming104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Gaming104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Gaming104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Gaming104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Gaming104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Gaming104_objectSpread(Gaming104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.11 44.22c2.85 4 5.78 4.34 5.78 4.34l-3 1.82-2.86-1.47s0-3.65.06-4.69"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m98.37 67.73-.43-3.2c0 2.11-.5 7.33-5.78 9.42A12.08 12.08 0 0 1 87 75.09a8.85 8.85 0 0 1-7.13-3.66L68.41 59.94c-.35-.77-2-3.12-6-3.17l-17.63-.23c-4.25-.06-5.85 2.64-6.09 3.09L27 70.73a8.88 8.88 0 0 1-7.24 3.47 12.14 12.14 0 0 1-5-1.23h-.05a10.33 10.33 0 0 1-6.1-9.64L8 66.07c0 .33-.49 8.57 6.39 11.52a12.23 12.23 0 0 0 4.41.69c3.05 0 6.36-2 8.39-4.44L39.14 63c.06-.11 1.43-2.9 5.64-2.85l17.62.24c4.2 0 5.5 2.88 5.51 2.92l12.33 12c2 2.52 3.71 3.75 6.76 3.79h2.46c3.29-1.15 2.79-.54 2.85-.57 6.92-2.75 6.1-10.54 6.06-10.87"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M67.7 40.61C69.91 45 73.48 45 73.48 45l-2.69.66L68 44.54a29.55 29.55 0 0 1-.26-3.93"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M75 33.26c2.21 4.36 5.78 4.33 5.78 4.33l-2.69.66-2.79-1.06a29.69 29.69 0 0 1-.3-3.93"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M82.38 40.81c2.21 4.36 5.78 4.33 5.78 4.33l-2.69.66-2.83-1.06a29.69 29.69 0 0 1-.26-3.93"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M74.84 47.87c2.22 4.36 5.78 4.34 5.78 4.34l-2.69.66-2.82-1.07a30.91 30.91 0 0 1-.27-3.93"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "77.76",
          cy: "49.55",
          r: "3.29"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36.43 23.7a80 80 0 0 0-8.37-.57 15.62 15.62 0 0 0-11.42 4.62c-3.27 3.23-4.59 7.81-5 11.75C11.2 43 8 67.61 8 67.61c0 .32-.79 7.79 5.64 10.4a13 13 0 0 0 5.15 1.17c2.81 0 4.91-1.43 7-3.66s11-10.9 12.23-12.13a12.87 12.87 0 0 1 8.73-3.78h12.91a12.87 12.87 0 0 1 8.73 3.78c1.24 1.23 10.16 9.9 12.23 12.13s4.16 3.62 7 3.66A13 13 0 0 0 92.74 78c6.43-2.61 5.67-10.08 5.63-10.4 0 0-3.18-24.6-3.58-28.11-.46-3.94-1.77-8.52-5-11.75a15.62 15.62 0 0 0-11.42-4.62 80.5 80.5 0 0 0-8.37.58c-3 .3-30.56.3-33.57 0Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M12 61.17c.32-2.45.66-5.1 1-7.62M11.22 67.12c.11-.86.23-1.83.37-2.89"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "42.91",
          y: "40.83",
          width: "7.18",
          height: "4.19",
          rx: ".1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "53.9",
          y: "40.83",
          width: "7.18",
          height: "4.19",
          rx: ".1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "77.76",
          cy: "34.96",
          r: "3.29"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "85.05",
          cy: "42.26",
          r: "3.29"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "70.46",
          cy: "42.26",
          r: "3.29"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.82 38.47h-2.39v-2.15a3.23 3.23 0 0 0-6.45 0v2.15h-2.29a3.23 3.23 0 0 0 0 6.46H24v2.37a3.23 3.23 0 1 0 6.45 0v-2.37h2.39a3.23 3.23 0 0 0 0-6.46Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Gaming104 = (Gaming104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Gaming56.tsx


var Gaming56_excluded = ["className"];
function Gaming56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Gaming56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Gaming56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Gaming56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Gaming56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Gaming56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Gaming56_objectSpread(Gaming56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13 23.81a5.06 5.06 0 0 0 3.12 2.34l-1.61 1-1.51-.81v-2.53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m53 36.47-.23-1.72a5.17 5.17 0 0 1-3.11 5.07 6.47 6.47 0 0 1-2.75.6 4.75 4.75 0 0 1-3.84-2l-6.18-6.18a3.42 3.42 0 0 0-3.2-1.71l-9.49-.13a3.48 3.48 0 0 0-3.28 1.67l-6.31 6A4.76 4.76 0 0 1 10.65 40a6.39 6.39 0 0 1-2.71-.66 5.57 5.57 0 0 1-3.29-5.19l-.3 1.49c0 .17-.26 4.61 3.44 6.2a6.68 6.68 0 0 0 2.38.37 6.26 6.26 0 0 0 4.51-2.39l6.4-5.82a3.15 3.15 0 0 1 3-1.54l9.49.13a3.14 3.14 0 0 1 3 1.57l6.65 6.48a4.3 4.3 0 0 0 3.64 2h1.32c1.77-.62 1.5-.29 1.53-.31 3.72-1.49 3.29-5.68 3.29-5.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.45 21.87a3.74 3.74 0 0 0 3.11 2.33l-1.44.36L36.6 24a16 16 0 0 1-.15-2.11"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.4 17.91a3.76 3.76 0 0 0 3.12 2.33l-1.45.36-1.52-.6a16 16 0 0 1-.15-2.11"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.36 22a3.77 3.77 0 0 0 3.11 2.34l-1.47.32-1.52-.57a15 15 0 0 1-.12-2.09"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.3 25.78a3.74 3.74 0 0 0 3.11 2.33l-1.41.36-1.52-.58a16.49 16.49 0 0 1-.14-2.11"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "41.87",
        cy: "26.68",
        r: "1.77"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.62 12.76a42.49 42.49 0 0 0-4.51-.3A8.38 8.38 0 0 0 9 14.94a10.57 10.57 0 0 0-2.72 6.33C6 23.16 4.32 36.41 4.32 36.41c0 .17-.43 4.19 3 5.6a7 7 0 0 0 2.77.63 5.11 5.11 0 0 0 3.76-2c1.11-1.2 5.91-5.88 6.58-6.54a7 7 0 0 1 4.7-2h7a7 7 0 0 1 4.71 2c.66.66 5.47 5.34 6.58 6.54a5.09 5.09 0 0 0 3.75 2 7 7 0 0 0 2.77-.64c3.46-1.41 3.05-5.43 3-5.6 0 0-1.71-13.25-1.93-15.14a10.5 10.5 0 0 0-2.71-6.33 8.38 8.38 0 0 0-6.15-2.48 42.28 42.28 0 0 0-4.51.3c-1.59.19-16.4.19-18.02.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6.45 32.94c.17-1.32.36-2.75.53-4.1M6 36.14l.2-1.55"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "23.11",
        y: "21.99",
        width: "3.87",
        height: "2.25",
        rx: ".1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "29.02",
        y: "21.99",
        width: "3.87",
        height: "2.25",
        rx: ".1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "41.87",
        cy: "18.83",
        r: "1.77"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "45.8",
        cy: "22.75",
        r: "1.77"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "37.94",
        cy: "22.75",
        r: "1.77"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.67 20.72h-1.28v-1.16a1.74 1.74 0 0 0-3.48 0v1.16h-1.23a1.74 1.74 0 1 0 0 3.47h1.23v1.28a1.74 1.74 0 0 0 3.48 0v-1.28h1.28a1.74 1.74 0 1 0 0-3.47Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Gaming56 = (Gaming56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Movies104.tsx


var Movies104_excluded = ["className"];
function Movies104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Movies104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Movies104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Movies104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Movies104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Movies104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Movies104_objectSpread(Movies104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.56 65.28a23.19 23.19 0 0 1-17.85-18l-5.2-25a3.9 3.9 0 0 0-.26 1.35v46.25a2.64 2.64 0 0 0 2.62 2.64H57l-1.17-2.7ZM56.15 70.21l9.22 21.23a2.49 2.49 0 0 0 3.24 1.37l17.81-7.74a.88.88 0 0 0 0-1.58 5.27 5.27 0 0 0-2.42-.28c-2.93.17-13-.16-19-6.09s-6.47-8.58-8.16-8.4c-1.11.13-.95.88-.69 1.49Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M88.2 83.58 77.05 57.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.81 81.42h37.92"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M57 73.58H13.78A3.57 3.57 0 0 1 10.21 70V23.42a3.57 3.57 0 0 1 3.57-3.57h76.44a3.57 3.57 0 0 1 3.57 3.57V70a3.57 3.57 0 0 1-3.57 3.57"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.85 81.42V73.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "59.2",
          y: "59.62",
          width: "29.6",
          height: "29.6",
          rx: "2",
          transform: "rotate(-23.47 74.002 74.428)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m83.52 60.26-4.58 1.99M90.9 77.24l-4.59 1.99M69.11 86.7l-4.58 1.99M61.74 69.72l-4.59 1.99M63.58 73.96l-4.58 2M86.85 68.91 61.16 80.06M71 91.05 59.85 65.37M67.27 82.45l-4.59 2M85.37 64.5l-4.59 2M89.05 72.99l-4.58 2"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Movies104 = (Movies104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Movies56.tsx


var Movies56_excluded = ["className"];
function Movies56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Movies56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Movies56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Movies56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Movies56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Movies56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Movies56_objectSpread(Movies56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M9.37 13.69v29.62a3.18 3.18 0 0 0 3.1 3.26h24.86a1.12 1.12 0 0 0 .79-1.86 6.72 6.72 0 0 0-2.63-1.54C32 41.88 20.3 36.35 16.26 26.33S13 13 11 12.3c-1.43-.43-1.63.53-1.63 1.39Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "9.43",
          y: "9.43",
          width: "37.15",
          height: "37.15",
          rx: "2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.21 16.03h-6M46.21 40.13h-6M15.79 40.13H9.74M15.79 16.03H9.74M15.79 22.05H9.74M46.21 28.08H9.74M40.21 46.32V9.84M15.79 46.32V9.84M15.79 34.11H9.74M46.21 22.05h-6M46.21 34.11h-6"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Movies56 = (Movies56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Music104.tsx


var Music104_excluded = ["className"];
function Music104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Music104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Music104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Music104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Music104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Music104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Music104_objectSpread(Music104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M74.14 27.71a1.27 1.27 0 0 0-.47-.91 1.24 1.24 0 0 0-1-.28L40.28 30.9a.86.86 0 0 0-.78.86v2.36l31.7-4.28a1.24 1.24 0 0 1 1 .28 1.2 1.2 0 0 1 .45.91l-.31 31.83c.52.12 1.13 1.19 1.61 1.38Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29.58 86.38a9.75 9.75 0 0 1-11.53-9.85 12 12 0 0 1 .52-3.36 12.59 12.59 0 0 0-1.86 6.54 9.77 9.77 0 0 0 11.54 9.86 14 14 0 0 0 11.14-9.73 13.85 13.85 0 0 1-9.81 6.54Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M68 81a9.77 9.77 0 0 1-11.55-9.86 12.31 12.31 0 0 1 .5-3.36 12.62 12.62 0 0 0-1.86 6.55 9.74 9.74 0 0 0 11.53 9.84 13.91 13.91 0 0 0 11.15-9.71A13.91 13.91 0 0 1 68 81Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.89 24.94v42.34a10.7 10.7 0 0 0-5.57-.65 13.76 13.76 0 0 0-11.61 13 9.78 9.78 0 0 0 11.54 9.87 13.75 13.75 0 0 0 11.6-13v-.13L40 35.51a.85.85 0 0 1 .75-.82l30.36-4.25a1.25 1.25 0 0 1 .93.27 1.24 1.24 0 0 1 .43.86V62a10.82 10.82 0 0 0-5.57-.67 13.75 13.75 0 0 0-11.85 12.96 9.74 9.74 0 0 0 11.53 9.84 13.73 13.73 0 0 0 11.61-13V71l.16-52.54a2.32 2.32 0 0 0-2.65-2.23l-38.87 5.41a3.31 3.31 0 0 0-2.94 3.3Z",
        className: "stroke"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Music104 = (Music104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Music56.tsx


var Music56_excluded = ["className"];
function Music56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Music56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Music56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Music56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Music56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Music56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Music56_objectSpread(Music56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.92 14.92a.67.67 0 0 0-.25-.49.68.68 0 0 0-.53-.15l-17.45 2.36a.46.46 0 0 0-.42.46v1.27l17.07-2.3a.64.64 0 0 1 .53.15.66.66 0 0 1 .24.49l-.17 17.14c.28.06.61.64.87.74Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M15.93 46.51a5.25 5.25 0 0 1-6.21-5.3A6.57 6.57 0 0 1 10 39.4a6.74 6.74 0 0 0-1 3.52 5.27 5.27 0 0 0 6.21 5.31 7.51 7.51 0 0 0 6-5.24 7.46 7.46 0 0 1-5.28 3.52Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36.62 43.62a5.26 5.26 0 0 1-6.22-5.31 6.56 6.56 0 0 1 .27-1.81 6.75 6.75 0 0 0-1 3.53 5.25 5.25 0 0 0 6.21 5.3 7.49 7.49 0 0 0 6-5.23 7.5 7.5 0 0 1-5.26 3.52Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.25 13.43v22.8a5.8 5.8 0 0 0-3-.35 7.41 7.41 0 0 0-6.25 7 5.27 5.27 0 0 0 6.21 5.31 7.41 7.41 0 0 0 6.25-7v-.07l.07-22a.44.44 0 0 1 .4-.44l16.35-2.29a.65.65 0 0 1 .5.15.63.63 0 0 1 .22.46v16.4a5.81 5.81 0 0 0-3-.4 7.4 7.4 0 0 0-6.37 7 5.25 5.25 0 0 0 6.21 5.3 7.38 7.38 0 0 0 6.25-7v-.07l.09-28.29a1.22 1.22 0 0 0-.44-.94 1.24 1.24 0 0 0-1-.28l-20.91 2.93a1.79 1.79 0 0 0-1.58 1.78Z",
        className: "stroke"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Music56 = (Music56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Sporting104.tsx


var Sporting104_excluded = ["className"];
function Sporting104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Sporting104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Sporting104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Sporting104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Sporting104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Sporting104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Sporting104_objectSpread(Sporting104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M82.59 67.23c-8.16 12.66-30.37 12.89-49.61.5a57.59 57.59 0 0 1-16.84-16.29 53.33 53.33 0 0 0 20.63 23.38C56 87.29 78.22 87 86.39 74.29c5.13-8 3.46-19-3.25-29.09 3.29 7.99 3.4 15.9-.55 22.03Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M16.71 29.45C24.85 16.71 47.06 16.57 66.3 29s28.25 32.68 20.09 45.29-30.38 13-49.62.53-28.23-32.7-20.06-45.37"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M17.79 28.54C28.93 24.2 45.37 27 60.28 36.92c15.86 10.57 25.37 26.22 25 38.93"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m52.17 28.77-3.68 5.98"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m56.59 31.4-3.68 5.98"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m60.6 33.56-3.68 5.98"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m64.29 36.08-3.67 5.98"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m68.31 39.07-3.68 5.98"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Sporting104 = (Sporting104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Sporting56.tsx


var Sporting56_excluded = ["className"];
function Sporting56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Sporting56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Sporting56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Sporting56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Sporting56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Sporting56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Sporting56_objectSpread(Sporting56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.47 36.2c-4.39 6.82-16.35 6.94-26.71.27a31.07 31.07 0 0 1-9.07-8.77A28.79 28.79 0 0 0 19.8 40.29C30.16 47 42.12 46.85 46.52 40c2.76-4.29 1.86-10.2-1.75-15.66 1.77 4.3 1.83 8.56-.3 11.86Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M9 15.86C13.38 9 25.34 8.92 35.7 15.6S50.91 33.21 46.52 40s-16.36 7-26.72.29S4.6 22.68 9 15.86"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M9.58 15.37c6-2.34 14.85-.83 22.88 4.51C41 25.57 46.12 34 45.93 40.84"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m28.09 15.49-1.98 3.22"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m30.47 16.91-1.98 3.22"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m32.63 18.07-1.98 3.22"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m34.62 19.43-1.98 3.22"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m36.78 21.04-1.98 3.22"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Sporting56 = (Sporting56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/TV104.tsx


var TV104_excluded = ["className"];
function TV104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function TV104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TV104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TV104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function TV104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TV104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", TV104_objectSpread(TV104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.56 65.28a23.19 23.19 0 0 1-17.85-18l-5.2-25a3.9 3.9 0 0 0-.26 1.35v46.25a2.64 2.64 0 0 0 2.62 2.64h54.64Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.81 81.42h58.38"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "10.21",
          y: "19.85",
          width: "83.57",
          height: "53.73",
          rx: "3.57"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M65.15 73.6v7.82"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.85 81.42V73.6"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TV104 = (TV104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/TV56.tsx


var TV56_excluded = ["className"];
function TV56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function TV56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TV56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TV56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function TV56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TV56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", TV56_objectSpread(TV56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.61 35.15A12.48 12.48 0 0 1 9 25.47L6.2 12a2 2 0 0 0-.14.73v24.9a1.42 1.42 0 0 0 1.41 1.42h29.42Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M12.28 43.84h31.44"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "5.5",
          y: "10.69",
          width: "45",
          height: "28.93",
          rx: "1.92"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.08 39.63v4.21"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20.92 43.84v-4.21"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TV56 = (TV56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/TelstraTV104.tsx


var TelstraTV104_excluded = ["className"];
function TelstraTV104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function TelstraTV104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TelstraTV104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TelstraTV104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function TelstraTV104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TelstraTV104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", TelstraTV104_objectSpread(TelstraTV104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.6 65.3c-9-1.9-16-9-17.9-18l-5.2-25c-.2.4-.3.9-.3 1.4v46.2c0 1.5 1.2 2.6 2.6 2.6h54.6l-33.8-7.2z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M65.9 91.8c-1.1-3.4-2.4-9.3-.3-14.3 2.7-6.4 4.6-7.6 4-8.8-.4-.8-1-.5-1.4-.1l-12.9 13c-.4.4-.3 1.7-.3 2.2 0 .6.2 1.2.5 1.6l5.6 6.2 4.8.2z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.8 81.4h32.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M63 73.6H13.8c-2 0-3.6-1.6-3.6-3.6V23.4c0-2 1.6-3.6 3.6-3.6h76.4c2 0 3.6 1.6 3.6 3.6V70c0 2-1.6 3.6-3.6 3.6H84"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.8 81.4v-7.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m82.9 59.5 4.8 4.8c1.6 1.6 1.6 4.1 0 5.7L66.8 90.8c-1.6 1.6-4.1 1.6-5.7 0L56.4 86c-1.6-1.6-1.6-4.1 0-5.7l20.9-20.9c1.5-1.5 4-1.5 5.6.1zM83.7 66.8l-3.3-3.3M74.6 75.9l-3.3-3.3M72.1 78.3 68.8 75M58 92.5l-3.3-3.3M78.8 71.7l-3.4-3.3M75.4 71.7l3.4-3.3"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TelstraTV104 = (TelstraTV104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/TelstraTV56.tsx


var TelstraTV56_excluded = ["className"];
function TelstraTV56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function TelstraTV56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TelstraTV56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TelstraTV56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function TelstraTV56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TelstraTV56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", TelstraTV56_objectSpread(TelstraTV56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.55 45.45c-1.2-3.54-2.53-9.78-.28-15.08 2.87-6.75 4.87-8 4.19-9.27-.46-.87-1-.51-1.43-.1L10.52 34.61c-.46.46-.35 1.76-.34 2.35a2.87 2.87 0 0 0 .58 1.72l5.91 6.5Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "20.25",
          y: "8.29",
          width: "15.5",
          height: "39.41",
          rx: "4",
          transform: "rotate(45 28.002 27.999)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m40.28 19.2-3.48-3.48M30.72 28.76l-3.48-3.48M28.11 31.38l-3.49-3.49M14.18 45.3l-3.48-3.48M35.07 24.41l-3.48-3.48M31.59 24.41l3.48-3.48"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TelstraTV56 = (TelstraTV56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Ticket104.tsx


var Ticket104_excluded = ["className"];
function Ticket104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Ticket104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Ticket104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Ticket104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Ticket104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Ticket104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Ticket104_objectSpread(Ticket104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m14.05 57.18-2.53-9.44a2.57 2.57 0 0 1 1.82-3.15l.61-.16-.28-1.36-7.16 4.59L9 55l4.6 4.51 2.09-.51a2.6 2.6 0 0 1-1.64-1.82ZM82.11 54.41a1 1 0 0 1-1-.74A11.41 11.41 0 0 1 87 40.61a1 1 0 1 1 .9 1.78 9.41 9.41 0 0 0-4.77 10.76 1 1 0 0 1-.71 1.22.78.78 0 0 1-.31.04ZM20.35 77.9s3.85 13.87 29.85 6.46l-24.45 6.55s-2.17.78-2.81-1.09-3.46-8.9-2.59-11.92ZM46.06 51.07 48.62 54a.6.6 0 0 0 .52.2l3.86-.47a.6.6 0 0 1 .59.91L51.6 58a.62.62 0 0 0 0 .56l1.62 3.52a.6.6 0 0 1-.68.84l-3.78-.85a.58.58 0 0 0-.54.14l-2.85 2.63a.6.6 0 0 1-1-.38L44 60.57a.61.61 0 0 0-.31-.47l-3.38-1.89a.61.61 0 0 1 .06-1.09l3.56-1.53a.61.61 0 0 0 .35-.43l.72-3.81a.61.61 0 0 1 1.06-.28ZM35.59 60.91l1.27 1.46a.65.65 0 0 0 .53.2l1.92-.23a.61.61 0 0 1 .59.91l-1 1.66a.62.62 0 0 0 0 .56l.81 1.76a.6.6 0 0 1-.68.84l-1.89-.42a.59.59 0 0 0-.54.14l-1.44 1.31a.6.6 0 0 1-1-.39L34 66.79a.58.58 0 0 0-.31-.47L32 65.37a.6.6 0 0 1 0-1.08l1.78-.76a.63.63 0 0 0 .35-.44l.38-1.9a.61.61 0 0 1 1.08-.28ZM60.38 54.52 61.66 56a.58.58 0 0 0 .52.2l1.92-.2a.6.6 0 0 1 .59.91l-1 1.66a.59.59 0 0 0 0 .56l.81 1.76a.61.61 0 0 1-.69.84l-1.88-.43a.61.61 0 0 0-.55.15L60 62.71a.6.6 0 0 1-1-.39l-.17-1.92a.6.6 0 0 0-.31-.47l-1.69-1a.6.6 0 0 1 .06-1.08l1.78-.77a.59.59 0 0 0 .33-.38l.38-1.9a.6.6 0 0 1 1-.28Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m85 57.26 7.59-4.38a2.57 2.57 0 0 0 .94-3.51L88.72 41a2.55 2.55 0 0 0-2.51-1.28M73.73 28.61a9.45 9.45 0 0 1 2.83-4.71 2.52 2.52 0 0 0 .44-3.14l-4.89-8.48a2.59 2.59 0 0 0-3.51-.94L7.8 46.46A2.57 2.57 0 0 0 6.86 50l4.89 8.47a2.54 2.54 0 0 0 3 1.17 9.47 9.47 0 0 1 4.15-.37"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M16.6 59.08a9.42 9.42 0 0 1 4.77 17.8 2.55 2.55 0 0 0-1.26 2.92l2.49 9.3a2.57 2.57 0 0 0 3.15 1.81l67.83-18.17a2.58 2.58 0 0 0 1.82-3.15l-2.49-9.29a2.54 2.54 0 0 0-2.55-1.9 9.42 9.42 0 0 1-4.77-17.8 2.54 2.54 0 0 0 1.26-2.92l-2.54-9.45a2.57 2.57 0 0 0-3.14-1.82L13.34 44.59a2.57 2.57 0 0 0-1.82 3.15l2.53 9.44a2.53 2.53 0 0 0 2.55 1.9M58.31 29.28l.97 1.66M55.86 25.02l.99 1.72M53.34 20.66l.99 1.72M75.66 74.95l.53 2M74.36 70.11l.51 1.89M73.06 65.26l.52 1.96M71.76 60.42l.53 1.97M70.47 55.59l.51 1.92M69.18 50.79l.51 1.89M67.9 46l.5 1.86M66.6 41.16l.5 1.84M65.31 36.32l.49 1.85M64 31.46l.53 1.95"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Ticket104 = (Ticket104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Ticket56.tsx


var Ticket56_excluded = ["className"];
function Ticket56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Ticket56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Ticket56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Ticket56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Ticket56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Ticket56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Ticket56_objectSpread(Ticket56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M9.84 38.55s2.16 7.61 16.37 3.54L12.8 45.68s-1.19.43-1.54-.59-1.9-4.89-1.42-6.54ZM23.94 23.84l1.4 1.6a.36.36 0 0 0 .29.11l2.11-.25a.33.33 0 0 1 .33.5L27 27.62a.34.34 0 0 0 0 .31l.89 1.93a.32.32 0 0 1-.37.46l-2.07-.46a.3.3 0 0 0-.3.08l-1.56 1.44a.34.34 0 0 1-.56-.21l-.19-2.12a.34.34 0 0 0-.17-.26l-1.86-1a.33.33 0 0 1 0-.59l2-.84a.35.35 0 0 0 .19-.24l.37-2.12a.33.33 0 0 1 .57-.16ZM18.2 29.23l.7.8a.34.34 0 0 0 .29.11l1-.12a.33.33 0 0 1 .32.5l-.54.91a.32.32 0 0 0 0 .3l.44 1a.33.33 0 0 1-.38.46l-1-.23a.3.3 0 0 0-.3.08l-.78.72a.33.33 0 0 1-.55-.22l-.1-1a.32.32 0 0 0-.17-.26l-.92-.52a.33.33 0 0 1 0-.59l1-.42a.37.37 0 0 0 .2-.24l.21-1a.33.33 0 0 1 .58-.28ZM31.8 25.73l.7.79a.32.32 0 0 0 .28.12l1.06-.13a.33.33 0 0 1 .32.5l-.54.91a.34.34 0 0 0 0 .31l.45 1a.33.33 0 0 1-.38.46l-1-.23a.36.36 0 0 0-.3.08l-.78.72A.33.33 0 0 1 31 30l-.09-1a.33.33 0 0 0-.17-.26l-.92-.52a.33.33 0 0 1 0-.59l1-.42a.35.35 0 0 0 .2-.24l.2-1a.33.33 0 0 1 .58-.24Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43 24a5.17 5.17 0 0 1 2.64-5.94 1.38 1.38 0 0 0 .69-1.6l-1.39-5.18a1.39 1.39 0 0 0-1.72-1L6 20.28A1.42 1.42 0 0 0 5 22l1.39 5.18a1.4 1.4 0 0 0 1.4 1A5.17 5.17 0 0 1 10.4 38a1.4 1.4 0 0 0-.69 1.6l1.37 5.1a1.39 1.39 0 0 0 1.72 1l37.2-10a1.42 1.42 0 0 0 1-1.7l-1.37-5.1a1.38 1.38 0 0 0-1.4-1A5.17 5.17 0 0 1 43 24ZM40 36.3l.47 1.73M39.22 33.36l.26 1M38.45 30.49l.25.95M37.67 27.6l.25.94M36.88 24.64l.26.97M36.1 21.74l.27.99M35.33 18.88l.26.97M34.55 15.95l.28 1.03M33.78 13.08l.26.95"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Ticket56 = (Ticket56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Feedback104.tsx


var Feedback104_excluded = ["className"];
function Feedback104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Feedback104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Feedback104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Feedback104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Feedback104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Feedback104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Feedback104_objectSpread(Feedback104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.19 42.52C25.71 42.52 15.6 53 15.6 66s10.11 23.44 22.59 23.44c0 0-16.32-9.21-16.32-23.46s16.32-23.46 16.32-23.46ZM48.91 39c0-14.21 16.32-23.4 16.32-23.4-12.48 0-22.59 10.48-22.59 23.4s10.11 23.4 22.59 23.4c0 0-16.32-9.19-16.32-23.4Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62.4 66A23.4 23.4 0 1 1 39 42.52"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.12 74.88a9.78 9.78 0 0 1 14.53 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M89.44 39A23.4 23.4 0 1 1 66 15.6 23.4 23.4 0 0 1 89.44 39Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.3 44.65a9.78 9.78 0 0 1-14.52 0"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35 59.51a2.43 2.43 0 1 1-2.43-2.43A2.43 2.43 0 0 1 35 59.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.26 59.51a2.42 2.42 0 1 1-2.42-2.43 2.42 2.42 0 0 1 2.42 2.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62 32.55a2.43 2.43 0 1 1-2.43-2.43A2.43 2.43 0 0 1 62 32.55"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.3 32.55a2.42 2.42 0 1 1-2.42-2.43 2.42 2.42 0 0 1 2.42 2.43"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Feedback104 = (Feedback104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Feedback56.tsx


var Feedback56_excluded = ["className"];
function Feedback56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Feedback56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Feedback56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Feedback56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Feedback56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Feedback56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Feedback56_objectSpread(Feedback56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19 22A14.26 14.26 0 0 0 5 36.5 14.26 14.26 0 0 0 19 51S8.88 45.31 8.88 36.5 19 22 19 22ZM25.88 19.5C25.88 10.69 36 5 36 5a14.26 14.26 0 0 0-14 14.5A14.26 14.26 0 0 0 36 34s-10.12-5.69-10.12-14.5Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34 36.5A14.5 14.5 0 1 1 19.5 22"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M14 42a6.06 6.06 0 0 1 9 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M51 19.5A14.5 14.5 0 1 1 36.5 5 14.5 14.5 0 0 1 51 19.5Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41 23a6.06 6.06 0 0 1-9 0"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M17 32.5a1.5 1.5 0 1 1-1.5-1.5 1.5 1.5 0 0 1 1.5 1.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24 32.5a1.5 1.5 0 1 1-1.5-1.5 1.5 1.5 0 0 1 1.5 1.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34 15.5a1.5 1.5 0 1 1-1.5-1.5 1.5 1.5 0 0 1 1.5 1.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41 15.5a1.5 1.5 0 1 1-1.5-1.5 1.5 1.5 0 0 1 1.5 1.5"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Feedback56 = (Feedback56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/EarnPoints104.tsx


var EarnPoints104_excluded = ["className"];
function EarnPoints104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function EarnPoints104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? EarnPoints104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EarnPoints104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function EarnPoints104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EarnPoints104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", EarnPoints104_objectSpread(EarnPoints104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M17.4 48.91c-3.58 4-9.53 19.46 3.05 32.18 11.91 12 29.71 3.29 29.71 3.29-33.34-.81-32.76-35.47-32.76-35.47ZM41.21 38.59A23.8 23.8 0 0 1 59 51.6v-22A62.38 62.38 0 0 1 41.23 25ZM62.16 77.89l5.03.3V30.24h-5.03v47.65zM91.05 25.04l-3.43 1.61V74.6l3.7-1.65-.27-47.91z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "66.27",
          cy: "22.83",
          rx: "25.06",
          ry: "6.73"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M91.32 22.83v9.58c0 3.72-11.21 6.74-25 6.74s-25.06-3-25.06-6.74V22.32"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "37.33",
          cy: "63.25",
          r: "24.65"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41.21 23.36v15.23s16 1.68 20.36 20.08A24.39 24.39 0 0 1 57.08 78S81 80.51 91.32 73"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M61.47 68.47S85.94 69.8 91.32 63M61.47 58.55s24.47 1.32 29.85-5.45M57.4 48.46s28.54 2 33.92-4.81M91.32 72.81V25.04"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m33.9 72 1.28-6.78h-6.91l.45-2.45a1.57 1.57 0 0 1 1.54-1.29h5.6l1-5.64a1.58 1.58 0 0 1 1.55-1.29h2.32l-1.28 6.93h6.9l-.45 2.45a1.56 1.56 0 0 1-1.54 1.29h-5.55l-1 5.51A1.57 1.57 0 0 1 36.22 72Z",
        className: "strokeinverted"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EarnPoints104 = (EarnPoints104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/EarnPoints56.tsx


var EarnPoints56_excluded = ["className"];
function EarnPoints56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function EarnPoints56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? EarnPoints56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EarnPoints56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function EarnPoints56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EarnPoints56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", EarnPoints56_objectSpread(EarnPoints56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M9.37 26.33C7.44 28.49 4.24 36.82 11 43.67c6.42 6.48 16 1.76 16 1.76C9.06 45 9.37 26.33 9.37 26.33ZM22.19 20.78a12.82 12.82 0 0 1 9.58 7V15.92a33.57 33.57 0 0 1-9.57-2.43ZM33.47 41.94l2.71.16V16.28h-2.71v25.66zM49.02 13.48l-1.84.87v25.82l1.99-.89-.15-25.8z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "35.68",
          cy: "12.29",
          rx: "13.49",
          ry: "3.62"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.17 12.29v5.16c0 2-6 3.63-13.49 3.63s-13.49-1.62-13.49-3.63V12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "20.1",
          cy: "34.06",
          r: "13.28"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.19 12.58v8.2s8.64.9 11 10.81A13.16 13.16 0 0 1 30.73 42s12.89 1.35 18.44-2.72"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.1 36.87s13.18.72 16.07-2.93M33.1 31.53s13.18.71 16.07-2.94M30.91 26.09s15.37 1.06 18.26-2.59M49.17 39.21V13.49"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m18.25 38.76.69-3.66h-3.72l.24-1.32a.86.86 0 0 1 .84-.69h3l.56-3a.84.84 0 0 1 .83-.69H22l-.69 3.73H25l-.24 1.32a.84.84 0 0 1-.83.69h-3l-.56 3a.85.85 0 0 1-.83.69Z",
        className: "strokeinverted"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EarnPoints56 = (EarnPoints56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Membership104.tsx


var Membership104_excluded = ["className"];
function Membership104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Membership104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Membership104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Membership104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Membership104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Membership104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Membership104_objectSpread(Membership104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M52 55.89A14.52 14.52 0 0 0 59.2 54a23.66 23.66 0 0 1-19.88-19.9A14.58 14.58 0 0 0 52 55.89ZM27.83 68.7a29 29 0 0 0-4.72 12.19 40.86 40.86 0 0 0 44.6 8.83A59.24 59.24 0 0 1 27.83 68.7Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "52",
          cy: "52",
          r: "40.86"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "52",
          cy: "41.3",
          r: "14.59"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M52 92.86a40.74 40.74 0 0 0 28.87-12 29.18 29.18 0 0 0-57.76 0 40.74 40.74 0 0 0 28.89 12Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m23.54 55.71.92-5.06h-5l.32-1.82a1.13 1.13 0 0 1 1.11-1h4l.75-4.2a1.14 1.14 0 0 1 1.11-1h1.67l-.92 5.16h5l-.32 1.82a1.13 1.13 0 0 1-1.11 1h-4l-.75 4.11a1.13 1.13 0 0 1-1.1 1Z",
        className: "strokeinverted"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Membership104 = (Membership104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Membership56.tsx


var Membership56_excluded = ["className"];
function Membership56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Membership56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Membership56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Membership56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Membership56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Membership56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Membership56_objectSpread(Membership56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28 30.1a7.86 7.86 0 0 0 3.88-1 12.75 12.75 0 0 1-10.71-10.74A7.85 7.85 0 0 0 28 30.1ZM15 37a15.81 15.81 0 0 0-2.54 6.57 22 22 0 0 0 24 4.75A31.94 31.94 0 0 1 15 37Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "28",
          cy: "28",
          r: "22"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "28",
          cy: "22.24",
          r: "7.86"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28 50a22 22 0 0 0 15.55-6.43 15.72 15.72 0 0 0-31.11 0A21.9 21.9 0 0 0 28 50Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m12.67 30 .5-2.73H10.5l.17-1a.62.62 0 0 1 .6-.52h2.16l.4-2.26a.62.62 0 0 1 .6-.51h.9l-.5 2.77h2.67l-.17 1a.61.61 0 0 1-.6.51h-2.16l-.4 2.21a.63.63 0 0 1-.6.52Z",
        className: "strokeinverted"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Membership56 = (Membership56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/RedeemPoints104.tsx


var RedeemPoints104_excluded = ["className"];
function RedeemPoints104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function RedeemPoints104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? RedeemPoints104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RedeemPoints104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function RedeemPoints104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, RedeemPoints104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", RedeemPoints104_objectSpread(RedeemPoints104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M75.3 77.2c-3.71 4.8.65 7.52.65 7.52a5 5 0 0 0 6.78-1.64c-7.43.83-7.43-5.88-7.43-5.88ZM40 65.94 70.8 65C53 63.11 34.88 47.26 34.88 47.26ZM34.38 77.2c-3.72 4.8.64 7.52.64 7.52a5 5 0 0 0 6.79-1.64c-7.43.83-7.43-5.88-7.43-5.88Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "78.89",
          cy: "80.38",
          rx: "5.09",
          ry: "5.01"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "37.53",
          cy: "80.38",
          rx: "5.09",
          ry: "5.01"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M16.15 18.54h10.4A1.86 1.86 0 0 1 28.36 20l11.8 46-3.94 7.35a1.63 1.63 0 0 0 1.57 2.08h41.1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40.72 65.94h40.06a1.88 1.88 0 0 0 1.77-1.26l5.2-24.5A1.87 1.87 0 0 0 86 37.71l-53.19-1.85"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m57.42 55.82.84-4.44h-4.52l.29-1.6a1 1 0 0 1 1-.85h3.67l.68-3.69a1 1 0 0 1 1-.84h1.52l-.84 4.53h4.52l-.29 1.61a1 1 0 0 1-1 .84h-3.66L60 55a1 1 0 0 1-1 .84Z",
        className: "strokeinverted"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_RedeemPoints104 = (RedeemPoints104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/RedeemPoints56.tsx


var RedeemPoints56_excluded = ["className"];
function RedeemPoints56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function RedeemPoints56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? RedeemPoints56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RedeemPoints56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function RedeemPoints56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, RedeemPoints56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", RedeemPoints56_objectSpread(RedeemPoints56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40.55 41.57c-2 2.59.34 4 .34 4a2.68 2.68 0 0 0 3.66-.88c-4 .49-4-3.12-4-3.12ZM21.53 35.51 38.12 35c-9.56-1-19.34-9.53-19.34-9.53ZM18.51 41.57c-2 2.59.35 4 .35 4a2.67 2.67 0 0 0 3.65-.88c-4 .49-4-3.12-4-3.12Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "42.48",
          cy: "43.28",
          rx: "2.74",
          ry: "2.7"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "20.21",
          cy: "43.28",
          rx: "2.74",
          ry: "2.7"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M8.7 10h5.6a1 1 0 0 1 1 .77l6.36 24.76-2.13 4a.88.88 0 0 0 .85 1.12h22.1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21.92 35.51H43.5a1 1 0 0 0 1-.68l2.8-13.2a1 1 0 0 0-1-1.32l-28.63-1"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m30.92 30.06.45-2.39h-2.43l.15-.87a.56.56 0 0 1 .55-.45h2l.37-2a.54.54 0 0 1 .54-.45h.82l-.45 2.44h2.43l-.16.86a.56.56 0 0 1-.54.46h-2l-.37 1.94a.56.56 0 0 1-.54.45Z",
        className: "strokeinverted"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_RedeemPoints56 = (RedeemPoints56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Rewards104.tsx


var Rewards104_excluded = ["className"];
function Rewards104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Rewards104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Rewards104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Rewards104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Rewards104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Rewards104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Rewards104_objectSpread(Rewards104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M56.55 73.28 52.4 61.77 52 91.32h8.57s5.44-13.55 23-13.17v-4.87ZM19.26 76.47h26.53a1.56 1.56 0 0 0 1.5-.78l.81-2.19H19.26ZM36.72 60.73l7.72-3.37a.81.81 0 0 0-.16-1.36 4.46 4.46 0 0 0-2-.14c-2.48.28-11.08.44-16.75-4.55s-6.31-7.34-7.74-7.1c-.94.16-.74.82-.46 1.35l8.26 15.24s9.71-.31 11.13-.07ZM50.93 34.25a5.32 5.32 0 0 1-2.46-.84l-.13-.09a4.12 4.12 0 0 1-.93-1 3.41 3.41 0 0 1-.31-.6 2.85 2.85 0 0 1-.12-.31c0-.08 0-.15-.12-.18a.33.33 0 0 0-.38.15 1.54 1.54 0 0 0-.16.71 5.47 5.47 0 0 0 0 1.4 2.91 2.91 0 0 0 .52 1.27 2.71 2.71 0 0 0 2.46 1A3 3 0 0 0 51 35c.2-.17.42-.69-.07-.75ZM62 32.54a2.71 2.71 0 0 0 2.45 1 2.94 2.94 0 0 0 1.63-.76c.23-.22.45-.74 0-.79a5.45 5.45 0 0 1-2.45-.85l-.13-.09a3.61 3.61 0 0 1-.93-1 3.77 3.77 0 0 1-.32-.59c0-.11-.08-.21-.11-.32A.25.25 0 0 0 62 29a.36.36 0 0 0-.39.15 1.54 1.54 0 0 0-.15.71 5 5 0 0 0 0 1.4 3.14 3.14 0 0 0 .54 1.28ZM62.14 61.48l-.81-.27c-1.51-1.26-.42-11.14-.42-11.14 0-3.55-1.41-3-1.41-3-3.26 4.59-2.82 14.24-2.82 14.24Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m21.52 45.15-3.86 2.06M23.53 48.93l-3.86 2.05M39.85 35.38l-3.86 2.05M47.91 50.49l-3.86 2.06M43.58 43.09 22.93 54.1M46.11 56.42 33.93 33.56M29.77 60.63 19.45 41.27M27.56 56.48l-3.86 2.06M41.87 39.15l-3.86 2.06M45.89 46.71l-3.86 2.06M20.09 60.73h31.92v30.59H20.09V74"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M83.86 74.15v17.17H51.99V60.73h31.87"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m20.11 60.75-7.1 12.53h34.5l4.52-12.53H20.11zM83.9 60.75l7.09 12.53H56.55l-4.52-12.53H83.9zM67.55 29.74V14.49a1.82 1.82 0 0 0-1.81-1.81h-.32l-11.75 2.11a1.64 1.64 0 0 0-1.29 1.78v15.81M52.66 20.55l14.72-2.59"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "49.18",
          cy: "32.7",
          r: "3.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "64.39",
          cy: "30.29",
          r: "3.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m61.11 60.49 20.63-20.62M71.05 52.67l-2.18-2.19M69.34 54.37l-2.18-2.18M72.74 50.98l-2.19-2.18M57.18 60.63h20.65c.32 0 1.11-1.08 1.3-1.29a21.12 21.12 0 0 0 2.69-3.69 15.68 15.68 0 0 0 1.46-12.82c-1.36-4.1-6-4.93-9.78-4.65a17.86 17.86 0 0 0-12.38 6.33 19.83 19.83 0 0 0-4 11.39 32.51 32.51 0 0 0 .06 4.73ZM16.19 43.09l20.95-11.52 12.49 22.8-11.62 6.36-12.46.02-9.36-17.66z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m33.37 88.32.72-4h-3.88l.25-1.42a.9.9 0 0 1 .87-.76h3.14l.59-3.28a.89.89 0 0 1 .86-.75h1.31l-.72 4h3.87l-.25 1.43a.88.88 0 0 1-.86.75h-3.14l-.59 3.21a.88.88 0 0 1-.86.75Z",
        className: "strokeinverted"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Rewards104 = (Rewards104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Rewards56.tsx


var Rewards56_excluded = ["className"];
function Rewards56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Rewards56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Rewards56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Rewards56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Rewards56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Rewards56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Rewards56_objectSpread(Rewards56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m30.45 39.46-2.24-6.2L28 49.17h4.61s2.93-7.3 12.37-7.09v-2.62ZM10.37 41.17h14.29a.83.83 0 0 0 .8-.41l.44-1.18H10.37ZM19.77 32.7l4.16-1.82a.43.43 0 0 0-.09-.75 2.34 2.34 0 0 0-1.1-.08c-1.33.15-6 .24-9-2.45s-3.39-4-4.16-3.82c-.51.08-.4.44-.25.73l4.45 8.2s5.22-.14 5.99-.01ZM27.42 18.44A2.93 2.93 0 0 1 26.1 18h-.07a1.81 1.81 0 0 1-.5-.53 2 2 0 0 1-.17-.32l-.06-.17s0-.08-.07-.09-.16 0-.2.08a.82.82 0 0 0-.09.38A3.13 3.13 0 0 0 25 18a1.68 1.68 0 0 0 .28.69 1.47 1.47 0 0 0 1.33.55 1.6 1.6 0 0 0 .87-.41c.09-.08.2-.36-.06-.39ZM33.39 17.52a1.47 1.47 0 0 0 1.33.55 1.6 1.6 0 0 0 .87-.41c.13-.12.25-.4 0-.43a2.93 2.93 0 0 1-1.32-.45l-.07-.05a1.81 1.81 0 0 1-.5-.53 2 2 0 0 1-.17-.32l-.06-.17s0-.08-.07-.09-.16 0-.2.08a.82.82 0 0 0-.09.38 3.13 3.13 0 0 0 0 .75 1.68 1.68 0 0 0 .28.69ZM33.46 33.1 33 33c-.81-.68-.22-6-.22-6 0-1.91-.76-1.59-.76-1.59-1.73 2.43-1.5 7.59-1.5 7.59Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m21.46 19.05-2.08 1.11M25.8 27.19l-2.08 1.1M11.59 24.31l-2.08 1.11M12.67 26.35l-2.08 1.1M23.46 23.2l-11.11 5.93M24.83 30.38l-6.56-12.31M16.03 32.65l-5.55-10.43M14.84 30.41l-2.08 1.11M22.54 21.08l-2.07 1.11M24.71 25.15l-2.08 1.11M10.82 32.7h17.19v16.47H10.82v-9.59"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45.16 39.66v9.51H27.99V32.7h17.17"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m10.83 32.71-3.82 6.75h18.57l2.44-6.75H10.83zM45.18 32.71l3.81 6.75H30.45l-2.43-6.75h17.16zM36.37 16V7.8a1 1 0 0 0-1-1h-.17L28.9 8a.89.89 0 0 0-.7 1v8.51M28.35 11.07l7.93-1.4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "26.48",
          cy: "17.61",
          r: "1.72"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "34.67",
          cy: "16.31",
          r: "1.72"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m32.9 32.57 11.11-11.1M38.26 28.36l-1.18-1.18M37.34 29.28l-1.18-1.18M39.17 27.45l-1.18-1.17M41.91 32.65c.17 0 .6-.59.7-.7a11.32 11.32 0 0 0 1.45-2 8.46 8.46 0 0 0 .78-6.91c-.73-2.21-3.21-2.65-5.26-2.5A9.61 9.61 0 0 0 32.91 24a10.66 10.66 0 0 0-2.17 6.13 16.08 16.08 0 0 0 .05 2.55M13.76 32.71 8.72 23.2 20 17l6.72 12.28-6.26 3.42"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m18 47.56.39-2.13h-2.12l.13-.77a.48.48 0 0 1 .47-.41h1.69l.32-1.77a.48.48 0 0 1 .46-.4h.71l-.39 2.17h2.09l-.14.77a.48.48 0 0 1-.47.41h-1.69l-.31 1.73a.48.48 0 0 1-.47.4Z",
        className: "strokeinverted"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Rewards56 = (Rewards56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/TelstraPlus104.tsx


var TelstraPlus104_excluded = ["className"];
function TelstraPlus104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function TelstraPlus104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TelstraPlus104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TelstraPlus104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function TelstraPlus104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TelstraPlus104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", TelstraPlus104_objectSpread(TelstraPlus104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.15 32.25C6.9 34.85 17.76 57 23 64.06c-11-26.86 3.15-31.81 3.15-31.81ZM24.75 65.17a.17.17 0 0 0-.25.22C40 85.4 64 93.7 73.7 87.48c2.64-8.05-22.12 3.14-48.95-22.31ZM43.09 47.64c.47-2.26.28-3.31.16-3.21s-4.32 24.22-4.32 24.22h13c-8.19.14-11.34-8.91-8.84-21.01ZM67.09 16c8.13.59 11.87 4.14 11.49 6.54L80 14.69H59s.17.76 8.09 1.31Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m78 47.53 1.11-6.08h-6l.39-2.2a1.38 1.38 0 0 1 1.33-1.16h4.83l.9-5.05A1.37 1.37 0 0 1 82 31.89h2l-1.1 6.2h6l-.39 2.2a1.38 1.38 0 0 1-1.33 1.16h-4.9l-.9 4.93a1.37 1.37 0 0 1-1.33 1.15ZM58.74 47.45l-2.88 17.26c-.6 3.1-2.6 3.94-4.38 3.94H38.14L43.76 37c-5.61-2.62-11.34-4.33-15.9-4.33-4.34 0-7.87 1.2-10.21 4.07a11.63 11.63 0 0 0-2.48 7.55c0 9 6.93 21.46 18.79 31.63 10.58 9 22.21 14 30.67 14 4.22 0 7.63-1.32 9.87-3.95a11.37 11.37 0 0 0 2.5-7.61c0-8.73-7-20.97-18.26-30.91Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.79 14a4.41 4.41 0 0 0-4.34 3.72l-1.88 10.43h16.77l-7.2 40.5h13.34c1.78 0 3.78-.84 4.38-3.94L62 28.15h12a4.42 4.42 0 0 0 4.35-3.71L80.25 14Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TelstraPlus104 = (TelstraPlus104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/TelstraPlus56.tsx


var TelstraPlus56_excluded = ["className"];
function TelstraPlus56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function TelstraPlus56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TelstraPlus56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TelstraPlus56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function TelstraPlus56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TelstraPlus56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", TelstraPlus56_objectSpread(TelstraPlus56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M14.08 17.36c-10.36 1.41-4.52 13.35-1.72 17.13C6.44 20 14.08 17.36 14.08 17.36ZM13.34 35.09a.09.09 0 0 0-.14.12C21.56 46 34.47 50.44 39.68 47.1c1.42-4.33-11.91 1.69-26.34-12.01ZM23.2 25.65c.26-1.22.15-1.78.09-1.73S21 37 21 37h7c-4.45 0-6.14-4.83-4.8-11.35ZM36.12 8.63c4.38.32 6.4 2.23 6.19 3.52l.78-4.24H31.76s.1.41 4.36.72Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m42 25.59.6-3.27h-3.19l.2-1.19a.75.75 0 0 1 .72-.62h2.6l.49-2.72a.73.73 0 0 1 .72-.62h1.08l-.6 3.34h3.21l-.21 1.19a.73.73 0 0 1-.72.62h-2.6L43.82 25a.74.74 0 0 1-.72.61ZM31.63 25.55l-1.55 9.29A2.3 2.3 0 0 1 27.72 37h-7.18l3-17A21.89 21.89 0 0 0 15 17.61a6.72 6.72 0 0 0-5.5 2.19 6.27 6.27 0 0 0-1.33 4.07c0 4.84 3.73 11.56 10.12 17 5.69 4.85 12 7.56 16.51 7.56a6.64 6.64 0 0 0 5.31-2.13 6.11 6.11 0 0 0 1.33-4.13c0-4.68-3.76-11.27-9.81-16.62Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.73 7.54a2.39 2.39 0 0 0-2.34 2l-1 5.61h9L20.54 37h7.18a2.3 2.3 0 0 0 2.36-2.13l3.28-19.68h6.5a2.38 2.38 0 0 0 2.34-2l1-5.62Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TelstraPlus56 = (TelstraPlus56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/VIP104.tsx


var VIP104_excluded = ["className"];
function VIP104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function VIP104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? VIP104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : VIP104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function VIP104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, VIP104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", VIP104_objectSpread(VIP104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.86 61.29s1.14 8.47-5.31 10.15c0 0-6.35 1.13-9-1.42 0 0-1.76 4.47-2.37 4.27l2 3.3s2.36-1.39 2.27-2.6c0 0 11.53 3.86 15.72-8.13ZM28.05 63.14l-3.49 5.57s7.76 10.16 16.3 6.56A3.1 3.1 0 0 0 44 77.59l1.51-3L43 70s-12.9 8-14.95-6.86ZM34.64 30.7c-3.32 3.71-8.84 18 2.82 29.84 11 11.15 25.93 1.8 25.93 1.8-30.9-.75-28.75-31.64-28.75-31.64Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.73 60.24 18.23 81.6l13.38-3.19L37.17 91l8.29-16.4M75.27 60.24 85.78 81.6l-13.39-3.19L66.83 91l-8.29-16.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "51.8",
        cy: "44.37",
        r: "21.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.28 18.42a8.95 8.95 0 0 1 17 0v.18l.16-.11a9.05 9.05 0 0 1 10.64-.15 8.56 8.56 0 0 1 3.15 9.92l-.07.19h.2a8.86 8.86 0 0 1 8.69 6 8.58 8.58 0 0 1-3.42 9.84l-.17.11.17.11a8.56 8.56 0 0 1 3.42 9.83 8.89 8.89 0 0 1-8.69 6h-.2l.07.18a8.56 8.56 0 0 1-3.15 9.92 9.07 9.07 0 0 1-10.64-.14l-.16-.12v.19a8.95 8.95 0 0 1-17 0l-.06-.19-.16.12a9.05 9.05 0 0 1-10.63.14 8.55 8.55 0 0 1-3.15-9.92l.07-.18h-.2a8.9 8.9 0 0 1-8.7-6 8.57 8.57 0 0 1 3.43-9.83l.17-.11-.17-.11a8.58 8.58 0 0 1-3.43-9.84 8.88 8.88 0 0 1 8.7-6h.2l-.07-.19a8.55 8.55 0 0 1 3.15-9.92 9 9 0 0 1 10.63.15l.16.11Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m48.48 53.14 1.24-6.82H43l.43-2.47A1.53 1.53 0 0 1 45 42.56h5.41l1-5.67a1.53 1.53 0 0 1 1.5-1.29h2.24l-1.24 7h6.68l-.46 2.4a1.54 1.54 0 0 1-1.49 1.3h-5.41l-1 5.53a1.54 1.54 0 0 1-1.49 1.29Z",
      className: "strokeinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_VIP104 = (VIP104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/VIP56.tsx


var VIP56_excluded = ["className"];
function VIP56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function VIP56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? VIP56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : VIP56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function VIP56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, VIP56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", VIP56_objectSpread(VIP56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40.31 33s.6 4.56-2.86 5.47c0 0-3.42.6-4.84-.77 0 0-.95 2.41-1.28 2.3l1.08 1.78s1.27-.75 1.22-1.4c0 0 6.21 2.08 8.47-4.38ZM15.1 34l-1.87 3s4.17 5.47 8.77 3.53a1.67 1.67 0 0 0 1.66 1.25l.82-1.61-1.31-2.49S16.21 42 15.1 34ZM18.65 16.53c-1.79 2-4.76 9.72 1.52 16.07 5.95 6 14 1 14 1-16.67-.44-15.52-17.07-15.52-17.07Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m15.47 32.44-5.66 11.5 7.21-1.72L20.01 49l4.47-8.83M40.53 32.44l5.66 11.5-7.21-1.72L35.99 49l-4.47-8.83"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "27.89",
          cy: "23.89",
          r: "11.53"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.31 9.94a4.81 4.81 0 0 1 9.16 0v.1l.09-.07a4.88 4.88 0 0 1 5.72-.08A4.61 4.61 0 0 1 40 15.23v.1h.11a4.8 4.8 0 0 1 4.68 3.22 4.62 4.62 0 0 1-1.84 5.29l-.1.06.1.06a4.62 4.62 0 0 1 1.84 5.29 4.8 4.8 0 0 1-4.68 3.22H40v.1a4.61 4.61 0 0 1-1.69 5.34 4.88 4.88 0 0 1-5.72-.08l-.09-.07v.1a4.81 4.81 0 0 1-9.16 0v-.1l-.09.07a4.88 4.88 0 0 1-5.72.08 4.61 4.61 0 0 1-1.69-5.34v-.1h-.11A4.8 4.8 0 0 1 11 29.24 4.61 4.61 0 0 1 12.88 24l.09-.06-.09-.06A4.61 4.61 0 0 1 11 18.54a4.8 4.8 0 0 1 4.68-3.22h.11v-.1a4.61 4.61 0 0 1 1.69-5.34 4.88 4.88 0 0 1 5.72.08l.09.07Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m26.1 28.61.67-3.67h-3.6l.23-1.33a.83.83 0 0 1 .81-.69h2.91l.55-3.06a.82.82 0 0 1 .8-.69h1.21L29 22.92h3.6l-.23 1.32a.82.82 0 0 1-.81.7h-2.9l-.54 3a.83.83 0 0 1-.81.69Z",
        className: "strokeinverted"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_VIP56 = (VIP56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Australia104.tsx


var Australia104_excluded = ["className"];
function Australia104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Australia104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Australia104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Australia104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Australia104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Australia104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Australia104_objectSpread(Australia104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M91.15 42.44c-.21 1.45 0 3.13-.15 4.55a35.43 35.43 0 0 1-5.11 15.74c-1.41 2.29-3 4.5-5.93 4.61a9.83 9.83 0 0 1-5-1.48c-4.06-2.2-8.2-4.21-12.19-6.57-3.56-2.11-7.08-5.41-11.06-6.64a11.14 11.14 0 0 0-8.14 1L33 59.58a17.75 17.75 0 0 1-5.16 2.19c-4 .77-7.16-2.06-8.77-5.44a26.41 26.41 0 0 1-1.84-16.8 15.25 15.25 0 0 1 2.94-6.17c-4.58 4-9.35 9-10 12.9-1.1 6.46 3.12 16.93 4.9 20s3.75 3.65 4.84 3.86C27.79 72 38.1 54.28 56 62.77 60.71 65 74.26 77.05 83.12 75.38c5-1 14.64-20.84 9.32-30.63-.44-.85-.88-1.6-1.29-2.31ZM82.75 89.34A5.06 5.06 0 0 1 79.68 88c-4.07-3.54-3.49-7.35-2.81-7.66.26-.1 1.71.52 3.49.57a12.15 12.15 0 0 0 4.37-.73c1.83-.88 1.57 2.71.47 5.42-.83 2.08-1.09 3.64-2.45 3.74Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M10.18 46.26c-1.1 6.46 3.12 16.93 4.9 20s3.75 3.65 4.84 3.86C27.79 72 38.1 54.28 56 62.77 60.71 65 74.26 77.05 83.12 75.38c5-1 14.64-20.84 9.32-30.63-4.58-8.44-6.2-9-9.43-13.81-3.85-5.89-9.9-15.63-12.4-16.93-3.07-1.56-2.55 3.59-2.76 5.31-.26 2.3 0 4.69-.57 7-.42 1.62-.37 1.72-1.82 1.51-2.14-.31-9.23-4.32-10.53-5.31-2.19-1.72.16-4.06 1.2-6a.59.59 0 0 0 .1-.42c.06-1.41-10-.88-11.25-.94S31.8 24.38 27.84 27.24 11.27 39.8 10.18 46.26ZM82.75 89.34A5.06 5.06 0 0 1 79.68 88c-4.07-3.54-3.49-7.35-2.81-7.66.26-.1 1.71.52 3.49.57a12.15 12.15 0 0 0 4.37-.73c1.83-.88 1.57 2.71.47 5.42-.83 2.08-1.09 3.64-2.45 3.74Z"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Australia104 = (Australia104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Australia56.tsx


var Australia56_excluded = ["className"];
function Australia56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Australia56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Australia56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Australia56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Australia56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Australia56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Australia56_objectSpread(Australia56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.51 23.24c-.11.76 0 1.64-.08 2.38a18.73 18.73 0 0 1-2.68 8.25c-.74 1.2-1.55 2.35-3.1 2.41a5.09 5.09 0 0 1-2.65-.77c-2.13-1.16-4.3-2.21-6.39-3.45-1.86-1.1-3.71-2.83-5.79-3.48a5.93 5.93 0 0 0-4.27.55l-5.54 3.08a9.06 9.06 0 0 1-2.7 1.15c-2.07.4-3.75-1.08-4.59-2.85a13.81 13.81 0 0 1-1-8.8 8.08 8.08 0 0 1 1.54-3.23c-2.4 2.11-4.89 4.73-5.24 6.76-.57 3.38 1.64 8.87 2.57 10.48a3.68 3.68 0 0 0 2.54 2c4.12 1 9.52-8.3 18.91-3.85 2.45 1.17 9.55 7.48 14.19 6.6C47 40 52 29.58 49.18 24.45c-.24-.45-.46-.84-.67-1.21ZM44.11 47.81a2.7 2.7 0 0 1-1.61-.71c-2.13-1.86-1.83-3.85-1.48-4 .14-.06.91.27 1.83.3a6.75 6.75 0 0 0 2.3-.39c1-.46.81 1.42.24 2.84-.39 1.08-.57 1.9-1.28 1.96Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M6.09 25.24c-.57 3.38 1.64 8.87 2.57 10.48a3.68 3.68 0 0 0 2.54 2c4.12 1 9.52-8.3 18.91-3.85 2.45 1.17 9.55 7.48 14.19 6.6C47 40 52 29.58 49.18 24.45c-2.4-4.42-3.24-4.7-4.94-7.24-2-3.08-5.18-8.18-6.49-8.86-1.61-.82-1.34 1.88-1.45 2.78a26.69 26.69 0 0 1-.3 3.66c-.22.84-.19.9-1 .79a25 25 0 0 1-5.51-2.79c-1.15-.9.08-2.13.62-3.16a.29.29 0 0 0 .06-.22c0-.74-5.27-.46-5.9-.49s-6.9 4.86-9 6.36-8.6 6.57-9.18 9.96ZM44.11 47.81a2.7 2.7 0 0 1-1.61-.71c-2.13-1.86-1.83-3.85-1.48-4 .14-.06.91.27 1.83.3a6.75 6.75 0 0 0 2.3-.39c1-.46.81 1.42.24 2.84-.39 1.08-.57 1.9-1.28 1.96Z"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Australia56 = (Australia56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/CoverageMap104.tsx


var CoverageMap104_excluded = ["className"];
function CoverageMap104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function CoverageMap104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CoverageMap104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CoverageMap104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function CoverageMap104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, CoverageMap104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", CoverageMap104_objectSpread(CoverageMap104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M90.88 46c-.21 1.42 0 3.08-.15 4.48a34.17 34.17 0 0 1-.86 5.42 34.7 34.7 0 0 1-4.18 10.11c-1.39 2.26-2.92 4.43-5.85 4.55a9.75 9.75 0 0 1-4.91-1.46c-4-2.18-8.09-4.16-12-6.49-3.52-2.08-7-5.33-10.91-6.55a11.08 11.08 0 0 0-8 1l-10.49 5.88a17.55 17.55 0 0 1-5.09 2.16c-3.9.75-7.06-2-8.65-5.37A26 26 0 0 1 18 43.16a15 15 0 0 1 2.89-6.08C16.36 41.05 11.65 46 11 49.8c-1.08 6.37 3.08 16.7 4.83 19.73s3.7 3.6 4.78 3.8c7.76 1.85 17.93-15.62 35.61-7.24 4.63 2.21 18 14.08 26.72 12.43 5-1 14.44-20.55 9.2-30.21-.44-.84-.86-1.58-1.26-2.31ZM82.59 92.3a5 5 0 0 1-3-1.34c-4-3.49-3.44-7.24-2.77-7.55.25-.11 1.69.51 3.44.56a12.43 12.43 0 0 0 4.32-.72c1.8-.87 1.54 2.67.46 5.35-.85 2.05-1.11 3.59-2.45 3.7Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M14.82 68.78h-.83M93.58 45.11l-.81.32M21.34 32.66c-.15-.24-.29-.48-.42-.73M58.89 26.75l.45-.53M45.33 65.73v-.68M11 49.8c-1.08 6.37 3.08 16.7 4.83 19.73s3.7 3.6 4.78 3.8c7.76 1.85 17.93-15.62 35.61-7.24 4.63 2.21 18 14.08 26.72 12.43 5-1 14.44-20.55 9.2-30.21C87.63 40 86 39.47 82.85 34.69c-3.8-5.81-9.76-15.42-12.23-16.7-3-1.54-2.52 3.54-2.72 5.24-.26 2.26 0 4.63-.57 6.89-.41 1.59-.36 1.69-1.8 1.49-2.1-.31-9.09-4.27-10.38-5.25-2.16-1.69.16-4 1.19-6a.55.55 0 0 0 .1-.41c.05-1.38-9.92-.87-11.1-.92C44 19 32.34 28.21 28.43 31S12.09 43.43 11 49.8ZM82.59 92.3a5 5 0 0 1-3-1.34c-4-3.49-3.44-7.24-2.77-7.55.25-.11 1.69.51 3.44.56a12.43 12.43 0 0 0 4.32-.72c1.8-.87 1.54 2.67.46 5.35-.85 2.05-1.11 3.59-2.45 3.7ZM92 83.62a5.11 5.11 0 0 1-1.3.7M93 78.47a10.18 10.18 0 0 1 .27 1.43M90.85 73.49c.22.41.44.81.63 1.21"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M88 68.87c.27.38.53.76.78 1.13M84.63 64.46l.91 1.14M81 60.23l1 1.1M77.34 56.24l1 1M73.45 52.34l1 1M69.46 48.6l1.05 1M65.26 44.89l1.09 1M61 41.38l1.2 1M56.7 38l1.21.93M52.21 34.67l1.27.92M47.7 31.58l1.32.88M43.09 28.67l1.29.78M38.29 25.93l1.32.72M33.37 23.51c.46.21.93.42 1.4.65M28.25 21.56c.46.14.94.3 1.43.47M23 20.6a10.64 10.64 0 0 1 1.34.09M18.61 23a3.26 3.26 0 0 1 .58-1l.11-.12M19.34 28.62c-.22-.57-.41-1.11-.56-1.62M11.15 68.5l-.73-.16M99.72 38.58a1.57 1.57 0 0 1 .22.45 1.72 1.72 0 0 1-.07 1.11M94.66 37q.86 0 1.59.15M89.2 37.13c.57 0 1.13-.08 1.67-.1M83.76 37.71l1.59-.2M78.4 38.56l1.54-.27M73.17 39.56l1.41-.28M67.7 40.77l1.59-.36M62.62 42l1.38-.31M57.11 43.51l1.58-.44M51.94 45l1.51-.45M46.68 46.65q.75-.26 1.5-.48M41.45 48.39l1.66-.57M36.33 50.21l1.52-.55M31.26 52.15l1.48-.58M26.22 54.24l1.42-.61M21.2 56.52l1.53-.72M16.37 59l1.36-.74M11.79 61.84c.4-.29.83-.58 1.29-.88M8.09 65.75a4.19 4.19 0 0 1 .74-1.28M97.33 43.09l-.59.46M45.73 69.78c0-.12-.07-.24-.1-.38M49.82 69.91a8.48 8.48 0 0 1-1.09.93M53.3 65.08c-.34.57-.67 1.11-1 1.61M55.64 60.62c-.2.41-.39.81-.59 1.21M57.91 55.44c-.2.5-.4 1-.61 1.48M59.83 50.31c-.18.5-.35 1-.53 1.49M61.49 45.07q-.21.75-.45 1.5M62.86 39.81c-.1.46-.22.94-.33 1.41M63.9 34.36c-.07.47-.15.94-.23 1.43M64.33 29v1.71M62.43 24.21h.28a1.69 1.69 0 0 1 .91.83"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_CoverageMap104 = (CoverageMap104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/CoverageMap56.tsx


var CoverageMap56_excluded = ["className"];
function CoverageMap56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function CoverageMap56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CoverageMap56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CoverageMap56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function CoverageMap56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, CoverageMap56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", CoverageMap56_objectSpread(CoverageMap56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.93 24.79c-.11.77 0 1.66-.08 2.42a18 18 0 0 1-.46 2.91 18.85 18.85 0 0 1-2.25 5.45C45.39 36.78 44.57 38 43 38a5.2 5.2 0 0 1-2.64-.78C38.19 36.06 36 35 33.87 33.74 32 32.61 30.11 30.86 28 30.21a6 6 0 0 0-4.33.55l-5.62 3.13a9.31 9.31 0 0 1-2.74 1.16c-2.09.41-3.8-1.09-4.65-2.89a14 14 0 0 1-1-8.92A8.08 8.08 0 0 1 11.24 20c-2.43 2.13-5 4.79-5.31 6.84-.58 3.44 1.66 9 2.6 10.63a3.71 3.71 0 0 0 2.57 2.05c4.18 1 9.66-8.41 19.18-3.9 2.49 1.19 9.68 7.58 14.39 6.69 2.68-.52 7.77-11.07 4.95-16.27-.24-.48-.47-.88-.69-1.25ZM44.47 49.7a2.68 2.68 0 0 1-1.63-.7c-2.16-1.88-1.85-3.9-1.49-4.07.14 0 .91.28 1.85.31a6.9 6.9 0 0 0 2.33-.39c1-.47.83 1.44.24 2.88-.44 1.08-.58 1.91-1.3 1.97Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M7.98 37.04h-.45M50.39 24.29l-.44.17M11.49 17.59c-.08-.13-.15-.26-.22-.4M31.71 14.4l.24-.28M24.41 35.39V35M5.93 26.81c-.58 3.44 1.66 9 2.6 10.63a3.71 3.71 0 0 0 2.57 2.05c4.18 1 9.66-8.41 19.18-3.9 2.49 1.19 9.68 7.58 14.39 6.69 2.68-.52 7.77-11.07 4.95-16.27-2.43-4.48-3.29-4.76-5-7.33-2-3.13-5.26-8.3-6.58-9-1.64-.83-1.36 1.91-1.47 2.82a29 29 0 0 1-.3 3.71c-.23.85-.2.91-1 .8-1.14-.17-4.9-2.3-5.59-2.82-1.16-.92.08-2.16.63-3.21a.29.29 0 0 0 .06-.22c0-.75-5.34-.47-6-.5s-7 4.92-9.1 6.44-8.76 6.68-9.34 10.11ZM44.47 49.7a2.68 2.68 0 0 1-1.63-.7c-2.16-1.88-1.85-3.9-1.49-4.07.14 0 .91.28 1.85.31a6.9 6.9 0 0 0 2.33-.39c1-.47.83 1.44.24 2.88-.44 1.08-.58 1.91-1.3 1.97ZM49.52 45a2.61 2.61 0 0 1-.7.37M50.05 42.25a4.66 4.66 0 0 1 .14.77M48.92 39.57l.34.65M47.36 37.08l.42.61"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45.57 34.71c.17.2.33.41.49.61M43.64 32.43l.52.6M41.65 30.28c.17.18.34.37.52.55M39.55 28.18l.55.54M37.4 26.17l.56.51M35.14 24.17l.59.51M32.87 22.28l.64.53M30.53 20.45l.65.5M28.11 18.67l.69.49M25.69 17l.7.47M23.2 15.44l.7.42M20.62 14l.71.39M18 12.66l.75.35M15.21 11.61c.25.07.51.16.77.25M12.38 11.09a6.4 6.4 0 0 1 .73.05M10 12.38a1.79 1.79 0 0 1 .31-.56l.06-.07M10.41 15.41a9 9 0 0 1-.3-.87M6 36.88l-.39-.08M53.69 20.77a.64.64 0 0 1 .12.25.93.93 0 0 1 0 .59M51 19.94c.31 0 .59 0 .86.07M48 20h.9M45.1 20.31l.9-.11M42.21 20.76l.83-.14M39.4 21.3l.76-.15M36.45 22l.86-.2M33.72 22.63l.71-.18M30.75 23.43l.85-.24M28 24.24l.81-.25M25.13 25.12l.81-.26M22.32 26.05l.89-.3M19.56 27l.82-.3M16.83 28.08l.8-.31M14.12 29.2l.76-.32M11.41 30.43l.83-.39M8.81 31.77l.74-.4M6.35 33.3c.21-.16.45-.31.69-.47M4.36 35.41a2.21 2.21 0 0 1 .4-.7M52.41 23.2l-.32.25M24.63 37.58l-.06-.21M26.82 37.64a3.54 3.54 0 0 1-.58.5M28.7 35c-.18.31-.36.6-.53.87M30 32.64c-.11.22-.21.44-.32.65M31.18 29.85c-.11.27-.21.54-.32.8M32.21 27.09c-.09.27-.18.54-.28.8M33.11 24.27l-.24.81M33.85 21.43l-.18.77M34.41 18.5c0 .25-.08.51-.13.77M34.64 15.6v.93M33.61 13h.16a.88.88 0 0 1 .49.45"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_CoverageMap56 = (CoverageMap56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/MapMarkeGlobal104.tsx


var MapMarkeGlobal104_excluded = ["className"];
function MapMarkeGlobal104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function MapMarkeGlobal104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MapMarkeGlobal104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MapMarkeGlobal104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function MapMarkeGlobal104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MapMarkeGlobal104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", MapMarkeGlobal104_objectSpread(MapMarkeGlobal104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.9 47.71S21.72 83.67 60.39 94c0 0-37.07 9.9-40.44-34.2a57.6 57.6 0 0 1 3.95-12.09ZM51.9 64.26 40 43.13a25.15 25.15 0 0 1-3.55-12.93c0-10.34 6-19.09 14.32-22A20.37 20.37 0 0 0 35.07 40l14.62 22.83a2.56 2.56 0 0 0 2.21 1.43Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M70.83 36.63a32.08 32.08 0 1 1-37.83.14"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.74 42.71a8.14 8.14 0 0 0 8.37-.79"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.69 62.83a2.51 2.51 0 0 0 4.53 0L68.89 40a20.42 20.42 0 1 0-33.82 0Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M60.75 28.53A8.75 8.75 0 1 1 52 19.78a8.75 8.75 0 0 1 8.75 8.75Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.68 50.91c1.24 3.24 2.27 6.54 3.63 9.76 2.12 5 3.21.44 7.29 2.7s6.82 4.9 7.42 9c.33 2.21-.06 8.78 2 9.56 2.88 1.08 6.76-.39 9.76-.37 3.3 0 7.13.34 9.25-2.25a96 96 0 0 0 6.44-9.49c1.05-1.65 6.22-.32 7.5.6s2.33 3.59 2.47 6.44c.09 1.63 1.17 1.62.9 2.61"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MapMarkeGlobal104 = (MapMarkeGlobal104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/MapMarkeGlobal56.tsx


var MapMarkeGlobal56_excluded = ["className"];
function MapMarkeGlobal56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function MapMarkeGlobal56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MapMarkeGlobal56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MapMarkeGlobal56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function MapMarkeGlobal56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MapMarkeGlobal56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", MapMarkeGlobal56_objectSpread(MapMarkeGlobal56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M12.54 24.2S11.35 44 32.61 49.67c0 0-20.38 5.44-22.24-18.81a32 32 0 0 1 2.17-6.66ZM28 33.3l-6.62-11.62a13.8 13.8 0 0 1-1.93-7.11c0-5.69 3.31-10.5 7.87-12.11a11.2 11.2 0 0 0-8.63 17.47l8 12.58a1.41 1.41 0 0 0 1.31.79Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.36 18.11a17.63 17.63 0 1 1-20.83.08"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M14.66 21.45a4.48 4.48 0 0 0 4.6-.44"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.73 32.51a1.38 1.38 0 0 0 2.49 0l8.07-12.58a11.23 11.23 0 1 0-18.6 0Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.81 13.65A4.81 4.81 0 1 1 28 8.84a4.81 4.81 0 0 1 4.81 4.81Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M11.81 25.75c.68 1.79 1.25 3.61 2 5.38 1.18 2.78 1.78.25 4 1.49s3.77 2.71 4.1 5c.18 1.22 0 4.84 1.12 5.28 1.58.59 3.72-.22 5.38-.2 1.82 0 3.93.18 5.1-1.25a52.5 52.5 0 0 0 3.56-5.24c.57-.9 3.42-.17 4.13.34a5 5 0 0 1 1.37 3.55c0 .9.64.9.49 1.44"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MapMarkeGlobal56 = (MapMarkeGlobal56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/MapMarker104.tsx


var MapMarker104_excluded = ["className"];
function MapMarker104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function MapMarker104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MapMarker104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MapMarker104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function MapMarker104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MapMarker104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", MapMarker104_objectSpread(MapMarker104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "52.28",
        cy: "85.01",
        rx: "15.69",
        ry: "2.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.18 82.2 36.61 54.66A32.72 32.72 0 0 1 32 37.8c0-13.49 7.89-24.9 18.7-28.72a26.57 26.57 0 0 0-20.47 41.43L49.3 80.34a3.3 3.3 0 0 0 2.88 1.86Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.3 80.34a3.26 3.26 0 0 0 5.91 0l19.12-29.83a26.62 26.62 0 1 0-44.1 0Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.72 35.62a11.41 11.41 0 1 1-11.41-11.41 11.41 11.41 0 0 1 11.41 11.41Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.5 76c-7.74 1.69-12.93 4.79-12.93 8.33C26.57 89.66 38.38 94 53 94s26.39-4.34 26.39-9.69c0-3.54-5.87-6.82-13.6-8.51"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MapMarker104 = (MapMarker104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/MapMarker56.tsx


var MapMarker56_excluded = ["className"];
function MapMarker56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function MapMarker56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MapMarker56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MapMarker56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function MapMarker56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MapMarker56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", MapMarker56_objectSpread(MapMarker56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.76 31.29a17.2 17.2 0 0 1-2.41-8.87c0-7.09 4.13-13.09 9.82-15.1A14 14 0 0 0 16.4 29.11l10 15.68a1.74 1.74 0 0 0 1.52 1Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.43 44.79a1.72 1.72 0 0 0 3.11 0L39.6 29.11a14 14 0 1 0-23.2 0Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34 21.28a6 6 0 1 1-6-6 6 6 0 0 1 6 6Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MapMarker56 = (MapMarker56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Placeholder104.tsx


var Placeholder104_excluded = ["className"];
function Placeholder104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Placeholder104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Placeholder104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Placeholder104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Placeholder104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Placeholder104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Placeholder104_objectSpread(Placeholder104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.31 60.15C28.83 56.76 31.65 48 31.65 48c-7.56 7.52-4.49 14.22 4.66 12.15Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m27.39 38.08 34.21.44c-15.7-9.55-17.36-16-17.36-16s-6.91 2.78-26.47 6.27c-16.78 3-1.42 26.36.29 36.55L19 43.93c0-4.93 3-5.85 8.39-5.85Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.75 90.16C53.8 85.61 71 56.43 71 56.43c-5.63.48-24.44 29.31-25.54 32.47Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.92 64.93C41 66.19 24.75 86.31 25.27 88.59c3.95 2.07 22.45 1.61 22.45 1.61-16.09-6.01-2.8-25.27-2.8-25.27Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "18.96",
        y: "38.8",
        width: "75.04",
        height: "50.61",
        rx: "3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "34.25",
        cy: "54.28",
        r: "7.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.85 89.41 67.2 57.84a4 4 0 0 1 6.6 0L94 86.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m24 89.41 17.55-22.77a4 4 0 0 1 6.61 0l7.12 8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m19 72.05-8.82-35.37a6.08 6.08 0 0 1 4.43-7.36l61-15.16A6.09 6.09 0 0 1 83 18.6l5 20.18"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Placeholder104 = (Placeholder104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Placeholder56.tsx


var Placeholder56_excluded = ["className"];
function Placeholder56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Placeholder56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Placeholder56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Placeholder56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Placeholder56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Placeholder56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Placeholder56_objectSpread(Placeholder56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.78 32.27c-3.92-1.78-2.44-6.35-2.44-6.35-3.96 3.92-2.34 7.44 2.44 6.35Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m15.11 20.71 17.89.23c-8.22-5-9.1-8.37-9.1-8.37S20.31 14 10.07 15.86c-8.79 1.56-.74 13.81.15 19.15l.48-10.92c0-2.61 1.59-3.38 4.41-3.38Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.87 48c-9.93-2.38-.9-17.67-.9-17.67-2.95.26-12.8 15.36-13.38 17Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.29 34.77C22.24 35.44 13.73 46 14 47.17c2.07 1.08 11.76.84 11.76.84-8.43-3.15-1.47-13.24-1.47-13.24Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "10.7",
        y: "21.09",
        width: "39.3",
        height: "26.51",
        rx: "3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "18.7",
        cy: "29.19",
        r: "3.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.25 47.6 36 31.06a2.13 2.13 0 0 1 3.46 0l10.29 14.59"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m13.33 47.6 9.2-11.93a2.11 2.11 0 0 1 3.46 0l3.73 4.21"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.7 38.5 6.09 20a3.19 3.19 0 0 1 2.33-3.86l32-7.94a3.18 3.18 0 0 1 3.85 2.32L46.9 21.1"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Placeholder56 = (Placeholder56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Accessories104.tsx


var Accessories104_excluded = ["className"];
function Accessories104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Accessories104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Accessories104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Accessories104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Accessories104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Accessories104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Accessories104_objectSpread(Accessories104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M59.61 35.18c.08-.36 2 .39 2.09.47 1.64 1.05 2 3.39 1.74 5.16-.7 4.19-1.68 8.89-1.1 13.19a4.82 4.82 0 0 0 2.36 3.69c1 .66 2.43 1.47 2.13 2.88l-12.32-.81ZM39.93 52.1s5 .38 6.19-.81l-.28-1.56s-4.28 1.41-6.3 0Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36.9 40.67s1.48 6.15 11.37 7.63a7.22 7.22 0 0 1-9.11.79S35 46.68 36.9 40.67ZM21.12 39.63c.5 1.09 3 5.38 5.34 3.84l1.15 7.25s-2.82 3.54-4.86-.82ZM13.93 34.45s3.32 2.89 6.15 1.4l.35 2.2a3.4 3.4 0 0 1-4.74.75s-2.19-1.87-1.76-4.35ZM29.89 25.74c.2 1.21 1.83 3 4.59 2.12l-.83 7.48s-3.74 2.73-4.58-2.13ZM34.82 17.86s3.74 3.14 6.88 1.47l.42 2.45a3.8 3.8 0 0 1-5.28.91s-2.47-2.06-2.02-4.83ZM52.4 61.15 52 90.7h8.57s5.44-13.55 23-13.17v-4.86h-27ZM19.26 75.85h26.53a1.56 1.56 0 0 0 1.5-.78l.81-2.18H19.26Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "64.29",
          y: "24.39",
          width: "10.99",
          height: "11.68",
          rx: "1.38",
          transform: "rotate(11.5 69.876 31.202)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m39.52 37.38-.01-5.42 6.96-.01.01 5.4M39.54 49.42l.01 5.4 6.96-.01-.01-5.44"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "43.01",
          cy: "43.39",
          r: "6.96"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "21.51",
          y: "29.17",
          width: "4.98",
          height: "22.98",
          rx: "2.49",
          transform: "rotate(-9 23.97 40.625)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.42 30.19a2.12 2.12 0 0 1 2.12 2.12v6a1.64 1.64 0 0 1-1.64 1.59h-.48a4.86 4.86 0 0 1-4.85-4.9 4.86 4.86 0 0 1 4.86-4.86Z",
          transform: "rotate(-9 17.06 35.03)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "29.83",
          y: "13.2",
          width: "5.03",
          height: "22.98",
          rx: "2.52",
          transform: "rotate(-173.74 32.338 24.69)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40.45 13.9h.38a1.64 1.64 0 0 1 1.64 1.64V22a1.64 1.64 0 0 1-1.64 1.64h-.38a4.86 4.86 0 0 1-4.86-4.86 4.86 4.86 0 0 1 4.86-4.86Z",
          transform: "rotate(-173.74 39.034 18.753)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m20.11 60.13-7.1 12.54h34.5l4.52-12.54H20.11zM83.9 60.13l7.09 12.54H56.55l-4.52-12.54H83.9z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M51.99 60.11V90.7h31.87V72.89M51.93 60.11V90.7H20.06V72.89M54.24 59.93l8.51-39.22A1.87 1.87 0 0 1 65 19.29l22.35 4.87a1.87 1.87 0 0 1 1.42 2.23L81.15 60Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Accessories104 = (Accessories104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Accessories56.tsx


var Accessories56_excluded = ["className"];
function Accessories56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Accessories56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Accessories56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Accessories56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Accessories56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Accessories56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Accessories56_objectSpread(Accessories56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.1 18.94c0-.19 1 .21 1.12.26a2.79 2.79 0 0 1 .94 2.8 24.48 24.48 0 0 0-.59 7.08 2.59 2.59 0 0 0 1.27 2c.52.36 1.31.79 1.15 1.55l-6.64-.43ZM21.5 28.06s2.7.2 3.33-.44l-.15-.84s-2.3.76-3.39 0Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19.87 21.9s.8 3.31 6.13 4.1a3.88 3.88 0 0 1-4.9.42s-2.26-1.28-1.23-4.52ZM11.63 22.3c.21.46 1.24 2.26 2.24 1.61l.48 3s-1.18 1.48-2-.34ZM7.66 18.48s1.55 1.36 2.88.66l.16 1a1.6 1.6 0 0 1-2.22.36 2.43 2.43 0 0 1-.82-2.02ZM16.63 14.7a1.35 1.35 0 0 0 1.87.87l-.33 3.06s-1.53 1.12-1.88-.87ZM19.27 10.14s1.7 1.32 3.15.58l.17 1a1.85 1.85 0 0 1-2.42.42 2.31 2.31 0 0 1-.9-2ZM28.21 32.93 28 48.84h4.61s2.93-7.3 12.37-7.09v-2.62H30.45ZM10.37 40.84h14.29a.82.82 0 0 0 .8-.42l.44-1.17H10.37Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "34.98",
          y: "13.52",
          width: "5.18",
          height: "5.5",
          rx: "1",
          transform: "rotate(12.18 37.569 16.278)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m21.28 20.13-.01-2.92 3.75-.01.01 2.91M21.29 26.61l.01 2.91 3.74-.01v-2.92"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "23.16",
          cy: "23.36",
          r: "3.75"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "16.42",
          y: "7.44",
          width: "2.46",
          height: "11.26",
          rx: "1.23",
          transform: "rotate(-173.74 17.65 13.067)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21.4 7.72a1.47 1.47 0 0 1 1.47 1.47V11a1.47 1.47 0 0 1-1.47 1.47 2.17 2.17 0 0 1-2.17-2.17v-.41a2.17 2.17 0 0 1 2.17-2.17Z",
          transform: "rotate(-173.74 21.049 10.103)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m10.83 32.38-3.82 6.75h18.57l2.44-6.75H10.83zM45.18 32.38l3.81 6.75H30.45l-2.43-6.75h17.16z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.99 32.37v16.47h17.17v-9.59M27.96 32.37v16.47H10.8v-9.59M29.2 32.27l4.59-21.12a1 1 0 0 1 1.21-.76L47 13a1 1 0 0 1 .76 1.2L43.7 32.28Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "11.34",
          y: "16.27",
          width: "2.46",
          height: "11.26",
          rx: "1.23",
          transform: "rotate(-6.26 12.56 21.872)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M9.52 16.55A1.47 1.47 0 0 1 11 18v1.82a1.47 1.47 0 0 1-1.47 1.47 2.17 2.17 0 0 1-2.17-2.17v-.42a2.17 2.17 0 0 1 2.16-2.15Z",
          transform: "rotate(-6.26 9.144 18.934)"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Accessories56 = (Accessories56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BroadbandHome104.tsx


var BroadbandHome104_excluded = ["className"];
function BroadbandHome104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BroadbandHome104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BroadbandHome104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BroadbandHome104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BroadbandHome104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BroadbandHome104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", BroadbandHome104_objectSpread(BroadbandHome104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34 21.45a1 1 0 0 1 1.52-.86c5 2.95 6 10.52 6.4 15.75.53 7.31-.52 14.63 0 21.95.42 6.33 1 17.38 8.72 19.39C58 79.61 71.5 79.87 69.87 91.25c-.14 1-1.07 2.75-2.28 2.75H37.36A3.17 3.17 0 0 1 34 90.94V21.45Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "34",
          y: "10",
          width: "36",
          height: "84",
          rx: "2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M88.45 28.83a32 32 0 0 1 0 36M82 33.07a24.46 24.46 0 0 1 0 27.53M15.55 64.83a32 32 0 0 1 0-36M22 60.6a24.46 24.46 0 0 1 0-27.53M47 85h10"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BroadbandHome104 = (BroadbandHome104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BroadbandHome56.tsx


var BroadbandHome56_excluded = ["className"];
function BroadbandHome56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BroadbandHome56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BroadbandHome56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BroadbandHome56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BroadbandHome56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BroadbandHome56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", BroadbandHome56_objectSpread(BroadbandHome56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.76 12.74a.51.51 0 0 1 .77-.44c2.59 1.51 3.1 5.4 3.29 8.09.28 3.75-.27 7.51 0 11.27.22 3.25.54 8.93 4.48 10s10.74 1.12 9.9 7c-.1.45-.57 1.34-1.2 1.34H20.48a1.62 1.62 0 0 1-1.72-1.57V12.75Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "18.79",
          y: "6.5",
          width: "18.43",
          height: "43",
          rx: "1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.66 16.14a16.37 16.37 0 0 1 0 18.43M43.36 18.31a12.52 12.52 0 0 1 0 14.09M9.34 34.57a16.37 16.37 0 0 1 0-18.43M12.64 32.4a12.52 12.52 0 0 1 0-14.09M25.44 44.89h5.12"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BroadbandHome56 = (BroadbandHome56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BroadbandMobile104.tsx


var BroadbandMobile104_excluded = ["className"];
function BroadbandMobile104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BroadbandMobile104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BroadbandMobile104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BroadbandMobile104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BroadbandMobile104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BroadbandMobile104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", BroadbandMobile104_objectSpread(BroadbandMobile104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.49 40.43s4.87 1.81 5.26 2c2.73 1.19 4.56 2.21 6.22 4.41 4 5.32 3.78 11.84 5.31 17.76 1 3.79 2.38 7.94 5.47 11.09 4.06 4.13 10 4.3 16 5.29 4.68.78 12.76 2.68 13.53 7.22H57.2c-9.23 0-18.45.16-27.69 0a9.39 9.39 0 0 1-5.58-2.65c-1.59-1.84-1.46-2.68-1.45-4.79V40.43Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "22.49",
          y: "28.75",
          width: "59.43",
          height: "59.43",
          rx: "8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M77.23 15.81a14 14 0 0 1 14.54 8.68M77.24 19.67a10.82 10.82 0 0 1 6.68 1.45 11 11 0 0 1 4.45 5.19M26.77 15.81a14 14 0 0 0-14.54 8.68M26.76 19.67a10.82 10.82 0 0 0-6.68 1.45 11 11 0 0 0-4.45 5.19"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "29.92",
          y: "41.75",
          width: "45.19",
          height: "24.14",
          rx: "2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "52.2",
          cy: "77.56",
          r: "2.47"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BroadbandMobile104 = (BroadbandMobile104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BroadbandMobile56.tsx


var BroadbandMobile56_excluded = ["className"];
function BroadbandMobile56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BroadbandMobile56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BroadbandMobile56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BroadbandMobile56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BroadbandMobile56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BroadbandMobile56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", BroadbandMobile56_objectSpread(BroadbandMobile56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.11 21.77s2.62 1 2.83 1.07a7.37 7.37 0 0 1 3.35 2.37c2.17 2.87 2 6.38 2.86 9.56a12.85 12.85 0 0 0 3 6c2.18 2.22 5.39 2.31 8.62 2.84C35.24 44 39.59 45 40 47.48h-9.2c-5 0-9.94.09-14.91 0a5.07 5.07 0 0 1-3-1.43 2.93 2.93 0 0 1-.78-2.58v-21.7Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "12.11",
          y: "15.48",
          width: "32",
          height: "32",
          rx: "5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41.58 8.51a7.56 7.56 0 0 1 7.84 4.68M41.59 10.59a5.76 5.76 0 0 1 6 3.58M14.42 8.51a7.56 7.56 0 0 0-7.84 4.68M14.41 10.59a5.76 5.76 0 0 0-6 3.58"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "16.11",
          y: "22.48",
          width: "24.33",
          height: "13",
          rx: "1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "28.11",
          cy: "41.76",
          r: "1.33"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BroadbandMobile56 = (BroadbandMobile56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Devices104.tsx


var Devices104_excluded = ["className"];
function Devices104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Devices104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Devices104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Devices104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Devices104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Devices104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Devices104_objectSpread(Devices104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M78.72 90.75c-2.09-1.33-4.67-1.45-6.85-2.64C62.55 83.23 60.56 72 59.13 62.52c-.41-2.36-.51-3.89-3.25-4.11V85.8a9.2 9.2 0 0 0-1.67-1.39c-3.33-2.12-7.43-2.31-10.89-4.2-14.82-7.76-18-25.61-20.26-40.67-.65-3.76-.81-6.19-5.17-6.54v49.56C17.87 90 20 91 26.3 91h29.79a5.3 5.3 0 0 0 5.08 3.9H81.1a4.75 4.75 0 0 0-2.38-4.15Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M55 91H22a4 4 0 0 1-4-4V14a4 4 0 0 1 4-4h50a4 4 0 0 1 4 4v22M40 86h12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "56",
          y: "36",
          width: "32",
          height: "58",
          rx: "4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M70.5 40h3M68 90h8"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "46",
        cy: "14",
        r: "1",
        className: "strokeinverted"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Devices104 = (Devices104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Devices56.tsx


var Devices56_excluded = ["className"];
function Devices56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Devices56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Devices56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Devices56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Devices56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Devices56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Devices56_objectSpread(Devices56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28 49ZM20 44.18c-5.83-4.24-6.89-10.6-7.42-17s0-8.91-2.65-8.91v26.22c0 3.42.52 4.46 4.45 4.46H28v-.53s-2.13 0-8-4.24ZM28 49c0-.14 0-.1 0 0ZM43.14 47.8c-1.1-.7-2.47-.77-3.63-1.4-4.94-2.59-6-8.54-6.75-13.56-.22-1.25-.27-2.06-1.73-2.18v16.53A2.81 2.81 0 0 0 33.84 50h10.57a2.53 2.53 0 0 0-1.27-2.2Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.03 47h6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "31.1",
          y: "20",
          width: "16",
          height: "30",
          rx: "2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.53 22h1M37.03 48h4M29 49H12a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h28a2 2 0 0 1 2 2v10"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "26.03",
        cy: "8",
        r: ".5",
        className: "strokeinverted"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Devices56 = (Devices56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/ESIM104.tsx


var ESIM104_excluded = ["className"];
function ESIM104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function ESIM104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ESIM104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ESIM104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function ESIM104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ESIM104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", ESIM104_objectSpread(ESIM104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.47 88c-2.95-1.88-6.58-2-9.65-3.73-13.13-6.87-15.93-22.68-17.94-36-.58-3.33-.72-5.48-4.59-5.79v45.79c0 4.13 1.4 5.56 5.53 5.57h30c.18-2.35-1.37-4.57-3.35-5.84Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "29",
          y: "10",
          width: "46",
          height: "84",
          rx: "5.74"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.09 13.82h3.82M46.27 90.18h11.46"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42.76 53.4a.28.28 0 0 0 0 .09.68.68 0 0 0 .09.35.87.87 0 0 0 .23.27 1.2 1.2 0 0 0 .34.17 1.58 1.58 0 0 0 .38 0 1.47 1.47 0 0 0 .64-.13 1.88 1.88 0 0 0 .49-.36l1 .75a2.87 2.87 0 0 1-1 .7 3.36 3.36 0 0 1-1.2.21 3 3 0 0 1-.92-.14A2.09 2.09 0 0 1 42 55a1.93 1.93 0 0 1-.5-.66 2.21 2.21 0 0 1-.18-.91 3 3 0 0 1 .22-1.14 2.8 2.8 0 0 1 .59-.91 2.69 2.69 0 0 1 .89-.62 3.06 3.06 0 0 1 1.15-.22 2.86 2.86 0 0 1 .85.13 2 2 0 0 1 .66.39 1.7 1.7 0 0 1 .42.62 2.08 2.08 0 0 1 .16.85 2.64 2.64 0 0 1 0 .44 3.41 3.41 0 0 1-.09.48Zm2.15-.93a.28.28 0 0 0 0-.09v-.1a.69.69 0 0 0-.22-.52.91.91 0 0 0-.64-.21 1.11 1.11 0 0 0-.46.09 1.31 1.31 0 0 0-.36.23 1.37 1.37 0 0 0-.25.29 1.58 1.58 0 0 0-.13.31ZM50.66 50.39a1.41 1.41 0 0 0-.54-.42 1.48 1.48 0 0 0-.65-.16 1.84 1.84 0 0 0-.33 0 .77.77 0 0 0-.3.11.63.63 0 0 0-.22.21.53.53 0 0 0-.09.32.52.52 0 0 0 .07.29.81.81 0 0 0 .21.2 1.7 1.7 0 0 0 .33.15l.42.15.71.25a2.36 2.36 0 0 1 .68.37 1.92 1.92 0 0 1 .5.56 1.66 1.66 0 0 1 .2.84 2 2 0 0 1-.79 1.7 2.53 2.53 0 0 1-.82.41 3.83 3.83 0 0 1-1 .13 4.17 4.17 0 0 1-1.4-.25 3 3 0 0 1-1.11-.72l1.06-1.08a2 2 0 0 0 .65.51 1.82 1.82 0 0 0 .8.2 1.34 1.34 0 0 0 .35 0 .79.79 0 0 0 .3-.12.64.64 0 0 0 .2-.23.71.71 0 0 0 .08-.34.49.49 0 0 0-.1-.32.8.8 0 0 0-.27-.24 1.72 1.72 0 0 0-.43-.2l-.6-.2q-.31-.11-.63-.24a2.31 2.31 0 0 1-.55-.37 1.78 1.78 0 0 1-.39-.54 2 2 0 0 1-.14-.77 1.89 1.89 0 0 1 .22-1 2.24 2.24 0 0 1 .6-.66 2.66 2.66 0 0 1 .84-.37 3.73 3.73 0 0 1 .94-.12 3.47 3.47 0 0 1 1.16.21 3 3 0 0 1 1 .62ZM52.56 48.64h1.63v6.72h-1.63zM61.31 55.36l.04-4.75h-.03l-1.74 4.75h-1.14l-1.7-4.75h-.03l.04 4.75h-1.53v-6.72h2.31l1.53 4.31h.04l1.46-4.31h2.34v6.72h-1.59zM63.82 60.67a.36.36 0 1 1 .36.35.36.36 0 0 1-.36-.35M62.62 60.67a.36.36 0 1 1 .71 0 .36.36 0 0 1-.71 0M61.41 60.67a.36.36 0 1 1 .36.35.36.36 0 0 1-.36-.35M60.21 60.67a.36.36 0 1 1 .35.35.36.36 0 0 1-.35-.35M59 60.67a.36.36 0 1 1 .36.35.36.36 0 0 1-.36-.35M57.8 60.67a.36.36 0 1 1 .35.35.36.36 0 0 1-.35-.35M56.59 60.67A.36.36 0 1 1 57 61a.36.36 0 0 1-.36-.35M55.38 60.67a.36.36 0 0 1 .36-.36.36.36 0 1 1 0 .71.36.36 0 0 1-.36-.35M54.18 60.67a.36.36 0 1 1 .36.35.36.36 0 0 1-.36-.35M53 60.67a.36.36 0 1 1 .36.35.36.36 0 0 1-.36-.35M51.77 60.67a.36.36 0 1 1 .71 0 .36.36 0 0 1-.71 0M50.56 60.67a.36.36 0 1 1 .36.35.36.36 0 0 1-.36-.35M49.36 60.67a.36.36 0 1 1 .71 0 .36.36 0 0 1-.71 0M48.15 60.67a.36.36 0 1 1 .36.35.36.36 0 0 1-.36-.35M47 60.67a.36.36 0 1 1 .35.35.36.36 0 0 1-.35-.35M45.74 60.67a.36.36 0 1 1 .36.35.36.36 0 0 1-.36-.35M67 46.5a.36.36 0 1 1 .36-.36.36.36 0 0 1-.36.36M67 47.67a.36.36 0 1 1 .36-.36.36.36 0 0 1-.36.36M67 48.83a.36.36 0 0 1 0-.71.36.36 0 1 1 0 .71M67 50a.36.36 0 1 1 .36-.36.36.36 0 0 1-.36.36M67 51.17a.36.36 0 1 1 .36-.36.36.36 0 0 1-.36.36M67 52.34a.36.36 0 1 1 .36-.36.36.36 0 0 1-.36.36M67 53.51a.36.36 0 1 1 .36-.36.36.36 0 0 1-.36.36M67 54.68a.36.36 0 1 1 .36-.36.36.36 0 0 1-.36.36M67 55.84a.36.36 0 0 1 0-.71.36.36 0 1 1 0 .71M67 57a.36.36 0 1 1 .36-.36.36.36 0 0 1-.36.36M67 58.18a.36.36 0 1 1 .36-.36.36.36 0 0 1-.36.36M37.32 47.71a.36.36 0 1 1 .35-.36.32.32 0 0 1-.1.25.33.33 0 0 1-.25.11M38.07 46.87a.36.36 0 0 1-.36-.35.36.36 0 1 1 .71 0 .36.36 0 0 1-.35.36M38.86 46.08a.37.37 0 0 1-.36-.36.36.36 0 1 1 .36.36M39.66 45.28a.36.36 0 1 1 .36-.36.36.36 0 0 1-.36.36M40.46 44.49a.36.36 0 0 1-.36-.36.36.36 0 0 1 .36-.36.36.36 0 0 1 0 .72M37.26 48.83a.36.36 0 0 1 0-.71.36.36 0 1 1 0 .71M37.26 50a.36.36 0 1 1 .36-.36.36.36 0 0 1-.36.36M37.26 51.17a.36.36 0 1 1 .36-.36.36.36 0 0 1-.36.36M37.26 52.34a.36.36 0 1 1 .36-.36.36.36 0 0 1-.36.36M37.26 53.51a.36.36 0 1 1 .36-.36.36.36 0 0 1-.36.36M37.26 54.68a.36.36 0 1 1 .36-.36.36.36 0 0 1-.36.36M37.26 55.84a.36.36 0 0 1 0-.71.36.36 0 1 1 0 .71M37.26 57a.36.36 0 1 1 .36-.36.36.36 0 0 1-.36.36M37.26 58.18a.36.36 0 1 1 .36-.36.36.36 0 0 1-.36.36M44.54 60.67a.36.36 0 1 1 .35.35.36.36 0 0 1-.35-.35M43.33 60.67a.36.36 0 1 1 .36.35.36.36 0 0 1-.36-.35M42.12 60.67a.36.36 0 0 1 .36-.36.36.36 0 1 1 0 .71.36.36 0 0 1-.36-.35M40.92 60.67a.36.36 0 1 1 .36.35.36.36 0 0 1-.36-.35M39.71 60.67a.36.36 0 1 1 .36.35.36.36 0 0 1-.36-.35M63.82 43.33a.36.36 0 1 1 .36.36.36.36 0 0 1-.36-.36M62.62 43.33a.36.36 0 1 1 .36.36.36.36 0 0 1-.36-.36M61.41 43.33a.36.36 0 1 1 .36.36.36.36 0 0 1-.36-.36M60.21 43.33a.36.36 0 0 1 .71 0 .36.36 0 1 1-.71 0M59 43.33a.36.36 0 1 1 .36.36.36.36 0 0 1-.36-.36M57.8 43.33a.36.36 0 0 1 .71 0 .36.36 0 1 1-.71 0M56.59 43.33a.36.36 0 1 1 .36.36.36.36 0 0 1-.36-.36M55.38 43.33a.36.36 0 0 1 .36-.35.36.36 0 1 1 0 .71.36.36 0 0 1-.36-.36M54.18 43.33a.36.36 0 1 1 .36.36.36.36 0 0 1-.36-.36M53 43.33a.36.36 0 1 1 .36.36.36.36 0 0 1-.36-.36M51.77 43.33a.36.36 0 1 1 .36.36.36.36 0 0 1-.36-.36M50.56 43.33a.36.36 0 1 1 .36.36.36.36 0 0 1-.36-.36M49.36 43.33a.36.36 0 1 1 .36.36.36.36 0 0 1-.36-.36M48.15 43.33a.36.36 0 1 1 .36.36.36.36 0 0 1-.36-.36M47 43.33a.36.36 0 0 1 .71 0 .36.36 0 1 1-.71 0M45.74 43.33a.36.36 0 1 1 .36.36.36.36 0 0 1-.36-.36M44.54 43.33a.36.36 0 0 1 .71 0 .36.36 0 1 1-.71 0M43.33 43.33a.36.36 0 1 1 .36.36.36.36 0 0 1-.36-.36M42.12 43.33a.36.36 0 0 1 .36-.35.36.36 0 1 1 0 .71.36.36 0 0 1-.36-.36M40.94 43.39a.36.36 0 1 1 .71 0 .36.36 0 0 1-.71 0M65 60.64a.36.36 0 1 1 .36.36.36.36 0 0 1-.36-.36M66.11 60.08a.36.36 0 1 1 .36.36.36.36 0 0 1-.36-.36M66.6 59a.36.36 0 1 1 .36.36.36.36 0 0 1-.36-.36"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M65 60.64a.36.36 0 1 1 .36.36.36.36 0 0 1-.36-.36M66.11 60.08a.36.36 0 1 1 .36.36.36.36 0 0 1-.36-.36M66.6 59a.36.36 0 1 1 .36.36.36.36 0 0 1-.36-.36M65 43.33a.36.36 0 1 0 .71 0 .36.36 0 0 0-.71 0M66.11 43.9a.36.36 0 1 0 .36-.36.36.36 0 0 0-.36.36M66.6 45a.36.36 0 1 0 .36-.36.36.36 0 0 0-.36.36M39.2 60.65a.36.36 0 1 0-.36.35.36.36 0 0 0 .36-.35M38.12 60.08a.36.36 0 0 0-.36-.36.36.36 0 0 0 0 .72.36.36 0 0 0 .36-.36M37.63 59a.36.36 0 1 0-.36.36.36.36 0 0 0 .36-.36"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ESIM104 = (ESIM104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/ESIM56.tsx


var ESIM56_excluded = ["className"];
function ESIM56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function ESIM56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ESIM56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ESIM56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function ESIM56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ESIM56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", ESIM56_objectSpread(ESIM56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.61 46.86c-1.54-1-3.45-1.07-5.05-2C16.68 41.31 15.21 33 14.16 26c-.31-1.74-.38-2.87-2.4-3v24c0 2.16.74 2.91 2.9 2.91h15.71a3.49 3.49 0 0 0-1.76-3.05Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.65 31.48V47a3 3 0 0 1-3 3h-18a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v7.48M22.65 8h2M20.65 48h6M22.65 8h2M20.65 48h6"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22 25.67a.31.31 0 0 0 0 .1.82.82 0 0 0 .11.42 1 1 0 0 0 .28.32 1.79 1.79 0 0 0 .39.2 1.76 1.76 0 0 0 .46.06 1.81 1.81 0 0 0 .76-.15 2.19 2.19 0 0 0 .58-.43l1.14.89a3.24 3.24 0 0 1-1.21.83 4 4 0 0 1-1.43.25A3.5 3.5 0 0 1 22 28a2.48 2.48 0 0 1-.87-.49 2.19 2.19 0 0 1-.58-.79 2.53 2.53 0 0 1-.22-1.09 3.67 3.67 0 0 1 .25-1.34 3.52 3.52 0 0 1 .7-1.09 3.33 3.33 0 0 1 1.07-.73 3.54 3.54 0 0 1 1.36-.26 2.93 2.93 0 0 1 1 .16 2 2 0 0 1 .78.45 2 2 0 0 1 .51.74 2.64 2.64 0 0 1 .18 1 3.66 3.66 0 0 1 0 .52 5 5 0 0 1-.1.58Zm2.56-1.11a.37.37 0 0 0 0-.11v-.11a.82.82 0 0 0-.26-.62 1.06 1.06 0 0 0-.76-.25 1.35 1.35 0 0 0-.55.11 1.75 1.75 0 0 0-.42.26 1.64 1.64 0 0 0-.3.35 1.6 1.6 0 0 0-.15.37ZM31.44 22.08a1.82 1.82 0 0 0-.65-.5 1.87 1.87 0 0 0-.79-.18 2.56 2.56 0 0 0-.39 0 1.11 1.11 0 0 0-.36.13.88.88 0 0 0-.26.25.67.67 0 0 0-.11.39.58.58 0 0 0 .09.33.69.69 0 0 0 .24.24 2.36 2.36 0 0 0 .39.19l.51.17.85.3a3.24 3.24 0 0 1 .8.43 2.27 2.27 0 0 1 .59.68 1.86 1.86 0 0 1 .24 1 2.58 2.58 0 0 1-.25 1.19 2.33 2.33 0 0 1-.69.83 2.91 2.91 0 0 1-1 .49 4.22 4.22 0 0 1-1.13.15 4.65 4.65 0 0 1-1.66-.3 3.31 3.31 0 0 1-1.29-.87l1.26-1.28a2.34 2.34 0 0 0 .77.6 2.13 2.13 0 0 0 1 .24 1.84 1.84 0 0 0 .41 0 1 1 0 0 0 .36-.15.78.78 0 0 0 .24-.27.84.84 0 0 0 .09-.4.71.71 0 0 0-.11-.39 1.26 1.26 0 0 0-.32-.28 2.52 2.52 0 0 0-.52-.24L29 24.6a7.81 7.81 0 0 1-.75-.3 2.37 2.37 0 0 1-.65-.43 2 2 0 0 1-.46-.64 2.13 2.13 0 0 1-.18-.92 2.29 2.29 0 0 1 .27-1.14 2.42 2.42 0 0 1 .71-.78 3.11 3.11 0 0 1 1-.44 4.17 4.17 0 0 1 1.11-.14 4.27 4.27 0 0 1 1.38.24 3.62 3.62 0 0 1 1.24.74ZM33.69 20.01h1.94v7.98h-1.94zM44.09 27.99l.05-5.65h-.04l-2.07 5.65h-1.35l-2.02-5.65h-.03l.04 5.65h-1.82v-7.98h2.75l1.81 5.12h.05l1.74-5.12h2.79v7.98h-1.9z"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ESIM56 = (ESIM56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/InternetExtras104.tsx


var InternetExtras104_excluded = ["className"];
function InternetExtras104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function InternetExtras104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InternetExtras104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InternetExtras104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function InternetExtras104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternetExtras104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", InternetExtras104_objectSpread(InternetExtras104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M72.94 10.18a20.88 20.88 0 0 0-2.74 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M80.12 12a21.18 21.18 0 0 0-3.59-1.25"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M86.14 16.16a20.23 20.23 0 0 0-2.89-2.4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M90.33 22.17a20 20 0 0 0-1.86-3.24"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M92.15 29.36a21 21 0 0 0-.6-3.75"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M72.15 15.65h-1.58"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M79.12 17.64a15.6 15.6 0 0 0-3.51-1.46"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M84.36 22.68A14.81 14.81 0 0 0 82 19.82"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M86.65 29.71a14.94 14.94 0 0 0-.7-3.64"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M71.49 21.13h-.55"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M77.92 23.51a9.51 9.51 0 0 0-3.09-1.82"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M81.18 30.1a9.75 9.75 0 0 0-1-3.57"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m74.92 72.6-.49 1.85c-.26 1-.89 1.67-1.85 1.41-1-.26-1.19-1.17-.93-2.15l.48-1.86a2.65 2.65 0 0 1 2.68-4.36 2.69 2.69 0 0 1 .19 5.18ZM53.45 79.91H15.71a3.38 3.38 0 0 0-3.38 3.38v.08a3.38 3.38 0 0 0 3.38 3.38h41.95a3.47 3.47 0 0 0 1.21-.23l-4.55-5.38a9.44 9.44 0 0 1-.87-1.23Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M12.68 47.26c0-1.67 1.86-2 2.34-.4 3.25 13 2.83 24.42 14.25 31 .61.35.41 1.47-.28 1.47H12.68Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M57.24 69.48 61 45.82l-8 26.61a9.3 9.3 0 0 0 1.86 8.71L67.4 96l-8.21-15.29a17.69 17.69 0 0 1-1.95-11.23Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.57 86.75v2.49h-4.96v-2.49"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M12.33 80.21h40.73"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M59 86.64H16.05a3.72 3.72 0 0 1-3.72-3.72V31.74A3.72 3.72 0 0 1 16.05 28h53.61a3.73 3.73 0 0 1 3.72 3.72V44"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m70.33 61.29 1.24-4.74a5.71 5.71 0 0 1 7-4.09 5.72 5.72 0 0 1 4.07 7L81.42 64"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m83.4 65.17-15.08-3.88a2.85 2.85 0 0 0-3.49 2l-3.15 12.09a2.83 2.83 0 0 0 2 3.47l15.1 4a2.84 2.84 0 0 0 3.47-2l3.16-12.08a2.87 2.87 0 0 0-.26-2.2 2.82 2.82 0 0 0-1.75-1.4Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m67.17 96.33 18.57-6.91a9.27 9.27 0 0 0 5.89-6.68L98 54.88a1.43 1.43 0 0 0-1-1.67A23.59 23.59 0 0 1 81.9 40a23.58 23.58 0 0 1-19.67 4 1.42 1.42 0 0 0-1.65 1l-8.12 27.43a9.3 9.3 0 0 0 1.86 8.71Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.54 75.14h6.65"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m74.92 72.6-.49 1.85c-.26 1-.89 1.67-1.85 1.41-1-.26-1.19-1.17-.93-2.15l.48-1.86a2.65 2.65 0 0 1 2.68-4.36 2.69 2.69 0 0 1 .19 5.18Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_InternetExtras104 = (InternetExtras104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/InternetExtras56.tsx


var InternetExtras56_excluded = ["className"];
function InternetExtras56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function InternetExtras56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InternetExtras56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InternetExtras56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function InternetExtras56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternetExtras56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", InternetExtras56_objectSpread(InternetExtras56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.27 5.48a12 12 0 0 0-1.47 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.14 6.45a10.75 10.75 0 0 0-1.93-.67"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.39 8.7a11.37 11.37 0 0 0-1.56-1.29"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.64 11.94a11.06 11.06 0 0 0-1-1.74"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.62 15.81a11.21 11.21 0 0 0-.33-2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.85 8.43a8 8 0 0 0-.85 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42.6 9.5a8 8 0 0 0-1.89-.79"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45.43 12.21a8.4 8.4 0 0 0-1.26-1.54"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.66 16a7.65 7.65 0 0 0-.38-2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.5 11.38h-.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42 12.66a5.32 5.32 0 0 0-1.67-1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.71 16.21a5.07 5.07 0 0 0-.51-1.92"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m40.34 39.09-.26 1c-.14.53-.48.9-1 .76-.53-.14-.64-.63-.5-1.16l.26-1a1.42 1.42 0 0 1-.34-1.35 1.45 1.45 0 0 1 1.78-1 1.45 1.45 0 0 1 .08 2.79ZM28.78 43H8.46a1.81 1.81 0 0 0-1.82 1.82 1.81 1.81 0 0 0 1.82 1.82h22.59a2 2 0 0 0 .65-.12l-2.45-2.9a5 5 0 0 1-.47-.62Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M6.83 25.45c0-.9 1-1.09 1.26-.22 1.75 7 1.52 13.15 7.67 16.7.33.19.22.79-.15.79H6.83Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m30.82 37.41 2-12.74L28.55 39a5 5 0 0 0 1 4.69l6.74 8-4.42-8.23a9.5 9.5 0 0 1-1.05-6.05Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M12.69 46.71v1.34h-2.67v-1.34"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M6.64 43.19h21.93"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.75 46.65H8.64a2 2 0 0 1-2-2V17.09a2 2 0 0 1 2-2h28.87a2 2 0 0 1 2 2v6.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m37.87 33 .67-2.55A3 3 0 0 1 40 28.57a3.06 3.06 0 0 1 2.33-.32A3.07 3.07 0 0 1 44.48 32l-.64 2.45"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.91 35.09 36.79 33a1.54 1.54 0 0 0-1.88 1.09l-1.7 6.5a1.54 1.54 0 0 0 1.09 1.87l8.13 2.13a1.54 1.54 0 0 0 1.87-1.09L46 37a1.5 1.5 0 0 0-.14-1.19 1.53 1.53 0 0 0-.95-.72Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m36.17 51.87 10-3.72a5 5 0 0 0 3.17-3.6l3.45-15a.77.77 0 0 0-.52-.9 12.68 12.68 0 0 1-8.17-7.11 12.71 12.71 0 0 1-10.59 2.16.76.76 0 0 0-.89.54L28.25 39a5 5 0 0 0 1 4.69Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21.29 40.46h3.58"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m40.34 39.09-.26 1c-.14.53-.48.9-1 .76-.53-.14-.64-.63-.5-1.16l.26-1a1.42 1.42 0 0 1-.34-1.35 1.45 1.45 0 0 1 1.78-1 1.45 1.45 0 0 1 .08 2.79Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_InternetExtras56 = (InternetExtras56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Laptop104.tsx


var Laptop104_excluded = ["className"];
function Laptop104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Laptop104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Laptop104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Laptop104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Laptop104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Laptop104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Laptop104_objectSpread(Laptop104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.06 30.25v43.47H56c.25-1.9-1.31-3.42-4.67-4.58-5-1.73-19.84-9.16-25.61-22.63s-4.6-18-7.56-18.84c-.22-.07-.43-.12-.64-.17a2.82 2.82 0 0 0-3.46 2.75Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M58.32 77.58H45.68M14.4 73.79V27a2.91 2.91 0 0 1 2.91-2.92h69.78A2.92 2.92 0 0 1 90 27v46.79M11 74.43h82a2 2 0 0 1 2 2v1.15a3.15 3.15 0 0 1-3.15 3.15h-79.7A3.15 3.15 0 0 1 9 77.58v-1.15a2 2 0 0 1 2-2Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "52",
        cy: "28.27",
        rx: "1.05",
        ry: "1.06",
        className: "strokeinverted"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Laptop104 = (Laptop104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Laptop56.tsx


var Laptop56_excluded = ["className"];
function Laptop56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Laptop56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Laptop56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Laptop56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Laptop56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Laptop56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Laptop56_objectSpread(Laptop56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M8.59 16.69v22.24h21.46c.12-1-.67-1.75-2.39-2.34-2.58-.89-10.15-4.69-13.1-11.59s-2.36-9.19-3.87-9.64l-.33-.09a1.45 1.45 0 0 0-1.77 1.42Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.24 40.93h-6.48M7.56 39.4h40.93a1 1 0 0 1 1 1v.31a1.8 1.8 0 0 1-1.8 1.8H8.36a1.8 1.8 0 0 1-1.8-1.8v-.31a1 1 0 0 1 1-1ZM8.75 39.24V14.78a1.34 1.34 0 0 1 1.34-1.34h36a1.34 1.34 0 0 1 1.33 1.34v24.46"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "28",
        cy: "15.86",
        rx: ".52",
        ry: ".53",
        className: "strokeinverted"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Laptop56 = (Laptop56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Mobile104.tsx


var Mobile104_excluded = ["className"];
function Mobile104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Mobile104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Mobile104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Mobile104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Mobile104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Mobile104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Mobile104_objectSpread(Mobile104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.59 88.09c-3-1.9-6.66-2.07-9.77-3.77-13.3-7-16.13-23-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46A7.57 7.57 0 0 0 36.56 94H65c.18-2.38-1.4-4.62-3.41-5.91Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "29",
          y: "10",
          width: "46",
          height: "84",
          rx: "6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50 14h4M46 90h12"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Mobile104 = (Mobile104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Mobile56.tsx


var Mobile56_excluded = ["className"];
function Mobile56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Mobile56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Mobile56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Mobile56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Mobile56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Mobile56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Mobile56_objectSpread(Mobile56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33 46.86c-1.54-1-3.45-1.07-5.05-2C21 41.31 19.56 33 18.51 26c-.31-1.74-.38-2.87-2.4-3v24c0 2.16.74 2.91 2.9 2.91h15.71A3.49 3.49 0 0 0 33 46.86Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "16",
          y: "6",
          width: "24",
          height: "44",
          rx: "3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27 8h2M25 48h6"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Mobile56 = (Mobile56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/SIM104.tsx


var SIM104_excluded = ["className"];
function SIM104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function SIM104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SIM104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SIM104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function SIM104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SIM104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", SIM104_objectSpread(SIM104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m22.26 34 .1 54.52c-.67 5.92 2.63 6 5.87 6h47a2 2 0 0 0 1.5-3.42 12.82 12.82 0 0 0-5-2.85c-6.69-2.38-28.74-12.57-36.41-31S29.2 32.62 25.27 31.42c-2.62-.8-3.01.97-3.01 2.58Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m43.24 72.92-.02 11.63M55.09 72.97l-.02 11.63M55.12 57.6l.02-11.71M43.27 57.55l.02-11.71M67.11 52.44v25.63a6.09 6.09 0 0 1-6.18 6L37.35 84a6.12 6.12 0 0 1-6.15-6.07l.05-25.62a6.09 6.09 0 0 1 6.18-6l23.53.1a6.12 6.12 0 0 1 6.15 6.03Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m59.91 72.79-21.53-.1A7 7 0 0 1 31.23 66v-1.78a6.92 6.92 0 0 1 7.16-6.65l21.54.09a7 7 0 0 1 7.14 6.71v1.76a7 7 0 0 1-7.16 6.66Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m82.69 28.74-.35 61.11c0 2.19-2.07 4-4.6 4l-51.91-.06c-2.53 0-4.57-1.79-4.56-4l.4-75c0-2.56 2.41-4.63 5.36-4.63h38a8.38 8.38 0 0 1 6 2l9.4 9.41c1.69 1.79 2.26 3.58 2.26 7.17Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SIM104 = (SIM104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/SIM56.tsx


var SIM56_excluded = ["className"];
function SIM56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function SIM56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SIM56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SIM56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function SIM56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SIM56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", SIM56_objectSpread(SIM56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.73 18.74v28c-.34 3 1.36 3.08 3 3.09h24.2a1 1 0 0 0 .77-1.75 6.51 6.51 0 0 0-2.56-1.46c-3.43-1.23-14.75-6.46-18.69-15.93s-3.16-12.64-5.17-13.25c-1.35-.44-1.55.49-1.55 1.3Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m23.5 38.74-.01 5.97M29.59 38.76l-.01 5.97M29.6 30.87l.01-6.01M23.52 30.85l.01-6.01M35.83 28.17v13.26a3.15 3.15 0 0 1-3.19 3.12l-12.18-.06a3.17 3.17 0 0 1-3.18-3.14V28.1a3.17 3.17 0 0 1 3.19-3.1h12.17a3.16 3.16 0 0 1 3.19 3.17Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m32 38.7-10.94-.05a3.56 3.56 0 0 1-3.62-3.47v-.91a3.54 3.54 0 0 1 3.64-3.44l10.92.05a3.56 3.56 0 0 1 3.62 3.47v.91A3.54 3.54 0 0 1 32 38.7Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m43.63 16.06-.18 31.39a2.22 2.22 0 0 1-2.34 2H14.7a2.21 2.21 0 0 1-2.33-2.05l.21-38.52a2.57 2.57 0 0 1 2.73-2.37h19.32a4.21 4.21 0 0 1 3 1l4.78 4.83c.93.96 1.22 1.88 1.22 3.72Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SIM56 = (SIM56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Tablet104.tsx


var Tablet104_excluded = ["className"];
function Tablet104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Tablet104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Tablet104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Tablet104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Tablet104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Tablet104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Tablet104_objectSpread(Tablet104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M56.06 93.77v-1s-4.14 0-15.54-8.29S27.05 63.73 26 51.3s0-17.43-5.18-17.43v51.19c0 6.69 1 8.71 8.7 8.71h26.6c-.03-.34-.06.35-.06 0Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.14 88.97h11.72"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "20.63",
          y: "10.16",
          width: "62.73",
          height: "83.68",
          rx: "5"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "15.01",
        r: "1.05",
        className: "strokeinverted"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Tablet104 = (Tablet104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Tablet56.tsx


var Tablet56_excluded = ["className"];
function Tablet56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Tablet56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Tablet56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Tablet56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Tablet56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Tablet56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Tablet56_objectSpread(Tablet56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.12 49.86v-.54S28 49.32 22 45s-7-10.86-7.6-17.37 0-9.11-2.7-9.11V45.3c0 3.5.53 4.56 4.56 4.56h13.91c-.03-.18-.05.14-.05 0Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.93 47.34h6.14"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "11.57",
          y: "6.09",
          width: "32.86",
          height: "43.83",
          rx: "2.51"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "8.65",
        r: ".51",
        className: "strokeinverted"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Tablet56 = (Tablet56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/TelstraLocator104.tsx


var TelstraLocator104_excluded = ["className"];
function TelstraLocator104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function TelstraLocator104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TelstraLocator104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TelstraLocator104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function TelstraLocator104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TelstraLocator104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", TelstraLocator104_objectSpread(TelstraLocator104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M57.57 28.13c.11 0-.28-.74-.34-.81a1.82 1.82 0 0 0-.83-.5 12.24 12.24 0 0 0-1.9-.36 6.88 6.88 0 0 1-4.32-3.07 11.39 11.39 0 0 1-1.25-2.46c-.64-1.75-.63-3.45-2.17-4.72a.47.47 0 0 0-.24-.13h-.09c-.66.16-.76 2.9-.78 3.27a59.88 59.88 0 0 0 .27 8.78ZM37.14 50.14c-7 6-5.57 17.18-5.57 17.18 5.57 28.32 29.69 16.25 29.69 16.25-37.14-3.71-24.12-33.43-24.12-33.43Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47.34 28.7v9.32M56.66 28.7v9.32M49.2 79.02V67.84H38.02l23.3-12.11L49.2 79.02z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "52",
          cy: "65.05",
          r: "21.37"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M77 33.8a14 14 0 0 1 11.15 12.79M75.85 37.47a10.73 10.73 0 0 1 8.49 9.78M27 33.8a14 14 0 0 0-11.15 12.79M28.15 37.47a10.73 10.73 0 0 0-8.49 9.78"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "52",
          cy: "65.05",
          r: "27.02"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45.38 18.37a6.63 6.63 0 0 1 13.24 0v9.41a.83.83 0 0 1-.85.81H46.23a.83.83 0 0 1-.85-.81Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "52",
          cy: "18.12",
          r: "2.05"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TelstraLocator104 = (TelstraLocator104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/TelstraLocator56.tsx


var TelstraLocator56_excluded = ["className"];
function TelstraLocator56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function TelstraLocator56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TelstraLocator56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TelstraLocator56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function TelstraLocator56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TelstraLocator56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", TelstraLocator56_objectSpread(TelstraLocator56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31 15.15c.06 0-.15-.4-.19-.44a1.05 1.05 0 0 0-.44-.27 5.85 5.85 0 0 0-1-.19A3.74 3.74 0 0 1 27 12.59a6.11 6.11 0 0 1-.68-1.32c-.32-.94-.32-1.86-1.14-2.54a.19.19 0 0 0-.13-.07H25c-.35.08-.41 1.56-.42 1.76a31.17 31.17 0 0 0 .15 4.73ZM20 27c-3.77 3.23-3 9.25-3 9.25C20 51.5 33 45 33 45c-20-2-13-18-13-18Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "28",
          cy: "35",
          r: "14.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.44 10a3.56 3.56 0 0 1 7.12 0v5a.45.45 0 0 1-.46.44h-6.2a.45.45 0 0 1-.46-.44ZM25.5 15.5v5M30.5 15.5v5M26.5 42.5v-6h-6L33 30l-6.5 12.5z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "28",
          cy: "35",
          r: "11.49"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "28",
          cy: "9.82",
          r: "1.17"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TelstraLocator56 = (TelstraLocator56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/WiFiBooster104.tsx


var WiFiBooster104_excluded = ["className"];
function WiFiBooster104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function WiFiBooster104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WiFiBooster104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WiFiBooster104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function WiFiBooster104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WiFiBooster104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", WiFiBooster104_objectSpread(WiFiBooster104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.57 22.46a1 1 0 0 0-.35.82L35.74 87.1v1.24c0 .8-.05 1.85.53 2.39s4.26.52 5 .47c0 0-.41-3 2.46-3h16.92c2.37 0 2 2.93 2 2.93h3.39c2.12 0 1.93-1.64 2.06-2.57C69.61 78 57.42 77.73 50.77 75.92c-7-1.88-7.25-12.22-7.54-18.15-.36-6.85.36-13.7 0-20.55-.27-4.89.47-12-3-14.74a.54.54 0 0 0-.35-.14.54.54 0 0 0-.31.12Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M64.53 13c0-.67-.4-1.22-.89-1.22H40.46c-.49 0-.89.55-.89 1.22L36.3 91a1.17 1.17 0 0 0 1.12 1.22h4.32v-.91a2 2 0 0 1 1.86-2h16.9a2 2 0 0 1 1.86 2v.91h4.32A1.17 1.17 0 0 0 67.8 91ZM84.39 34.07a29 29 0 0 1 0 32.34M78.65 37.88a22.15 22.15 0 0 1 0 24.73M19.61 66.41a29 29 0 0 1 0-32.34M25.35 62.61a22.15 22.15 0 0 1 0-24.73"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WiFiBooster104 = (WiFiBooster104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/WiFiBooster56.tsx


var WiFiBooster56_excluded = ["className"];
function WiFiBooster56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function WiFiBooster56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WiFiBooster56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WiFiBooster56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function WiFiBooster56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WiFiBooster56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", WiFiBooster56_objectSpread(WiFiBooster56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.2 12.63a.54.54 0 0 0-.18.43L19.2 46.41v.65c0 .42 0 1 .27 1.25a7.66 7.66 0 0 0 2.64.25S21.9 47 23.4 47h8.87c1.25 0 1.06 1.53 1.06 1.53h1.78c1.11 0 1-.86 1.08-1.35.77-5.57-5.63-5.69-9.11-6.64-3.66-1-3.8-6.39-4-9.49-.18-3.58.19-7.16 0-10.74-.14-2.56.25-6.26-1.55-7.7a.29.29 0 0 0-.19-.08.27.27 0 0 0-.14.1Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.38 7.75c0-.35-.21-.63-.47-.63H21.78c-.25 0-.46.28-.46.63l-1.71 40.5a.61.61 0 0 0 .58.63h2.26v-.47a1 1 0 0 1 1-1.06h8.84a1 1 0 0 1 1 1.06v.47h2.21a.61.61 0 0 0 .59-.63ZM44.77 18.68a15 15 0 0 1 0 16.81M41.77 20.66a11.45 11.45 0 0 1 0 12.85M10.88 35.49a15 15 0 0 1 0-16.81M13.87 33.51a11.49 11.49 0 0 1 0-12.85"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WiFiBooster56 = (WiFiBooster56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Security104.tsx


var Security104_excluded = ["className"];
function Security104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Security104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Security104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Security104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Security104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Security104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Security104_objectSpread(Security104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.1 65.1s2.7-2.6 4.4 2.6 6 12 13.5 15.1 14.3 8.1 13.7 11.5c-7.8-4-31.2-16.7-31.2-16.7l-.4-12.5z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.2 46.1c0-.5 1.1-1.3 1.5-1.3 2.7-.3 3.2 9.3 3.7 11.2.8 3.3 1.6 7.2 4 9.8 2.3 2.2 5.3 3.6 8.5 3.8 2.7.3 6.4.7 9.2 1.2 3.1.6 4 4-.1 4H33.6c-2.6-.4-4.5-2.6-4.4-5.2V46.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 45.2c-3.2 0-5.8 2.6-5.8 5.8 0 2 1 3.8 2.7 4.9v4c0 2.2.9 4 3.1 4s3.1-1.8 3.1-4v-4c2.7-1.7 3.5-5.3 1.7-8-1-1.7-2.8-2.7-4.8-2.7z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M67.8 22.8h12.9c1.6 0 2.9 1.3 2.9 2.9v50.5c0 1.1-.6 2.1-1.5 2.5L53.3 93.6c-.8.4-1.8.4-2.6 0L22 78.7c-1-.5-1.5-1.5-1.5-2.6V25.7c0-1.6 1.3-2.9 2.9-2.9h13.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.4 22.8h17.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.3 68.7c0 3.4 2.7 6.1 6.1 6.1h33.3c3.4 0 6.1-2.7 6.1-6.1V42.1c0-3.4-2.7-6.1-6.1-6.1H35.4c-3.4 0-6.1 2.7-6.1 6.1v26.6z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 45.2c-3.2 0-5.8 2.6-5.8 5.8 0 2 1 3.8 2.7 4.9v4c0 2.2.9 4 3.1 4s3.1-1.8 3.1-4v-4c2.7-1.7 3.5-5.3 1.7-8-1-1.7-2.8-2.7-4.8-2.7z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.1 36v-9.7c0-8.9 7.3-16.5 16.2-16.4 8.7.1 15.8 7.3 15.8 16V36h-6.7v-9.8c.1-5-3.8-9.2-8.8-9.5-5.1-.3-9.5 3.7-9.7 8.8V36h-6.8z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Security104 = (Security104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Security56.tsx


var Security56_excluded = ["className"];
function Security56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Security56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Security56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Security56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Security56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Security56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Security56_objectSpread(Security56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.38 35s1.44-1.39 2.38 1.4A13.46 13.46 0 0 0 21 44.57c4 1.68 7.72 4.34 7.38 6.16-4.2-2.17-16.78-9-16.78-9Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.74 24.81c0-.29.57-.7.82-.73 1.43-.15 1.71 5 2 6 .45 1.79.86 3.89 2.16 5.28a7.44 7.44 0 0 0 4.59 2.06c1.45.17 3.45.36 4.95.64 1.69.33 2.16 2.17 0 2.17H18.1a2.74 2.74 0 0 1-2.36-2.81V24.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28 24.3a3.11 3.11 0 0 0-1.67 5.7v2.18c0 1.17.5 2.13 1.67 2.13s1.68-1 1.68-2.13V30A3.11 3.11 0 0 0 28 24.3Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.51 12.27h6.93A1.54 1.54 0 0 1 45 13.81V41a1.56 1.56 0 0 1-.83 1.37l-15.44 8a1.55 1.55 0 0 1-1.42 0l-15.44-8A1.56 1.56 0 0 1 11 41V13.81a1.54 1.54 0 0 1 1.54-1.54h7.09"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.36 12.27h9.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.77 37a3.29 3.29 0 0 0 3.28 3.28H37A3.29 3.29 0 0 0 40.26 37V22.65A3.29 3.29 0 0 0 37 19.37H19.05a3.28 3.28 0 0 0-3.28 3.28Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28 24.3a3.11 3.11 0 0 0-1.67 5.7v2.18c0 1.17.5 2.13 1.67 2.13s1.68-1 1.68-2.13V30A3.11 3.11 0 0 0 28 24.3Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.44 19.37v-5.21a8.79 8.79 0 0 1 8.74-8.82 8.64 8.64 0 0 1 8.5 8.66v5.41h-3.63V14.1A5.09 5.09 0 0 0 28.31 9a5 5 0 0 0-5.24 5v5.41Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Security56 = (Security56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/SecurityHome104.tsx


var SecurityHome104_excluded = ["className"];
function SecurityHome104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function SecurityHome104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SecurityHome104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SecurityHome104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function SecurityHome104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SecurityHome104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", SecurityHome104_objectSpread(SecurityHome104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M58.07 93.1c-17.29-2.47-31.95-13.51-36.91-29.87a40.06 40.06 0 0 1-1.63-14.18h-1l.08 40.69v3.36Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.08 11.22a2.78 2.78 0 0 1 3.63-.22l.21.18 40.86 39a2.79 2.79 0 0 1-3.63 4.22l-.22-.19L52 17.09 13.07 54.25a2.79 2.79 0 0 1-3.74.11l-.2-.2A2.79 2.79 0 0 1 9 50.43l.2-.21Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.23 67.17s1.54-1.48 2.54 1.51a14.42 14.42 0 0 0 7.78 8.71c4.29 1.85 8.25 4.61 7.9 6.61-4.57-2.32-18-9.51-18-9.51Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39 56.27c0-.31.61-.74.87-.78 1.53-.17 1.86 5.35 2.1 6.46a12.4 12.4 0 0 0 2.31 5.58 8 8 0 0 0 4.9 2.19c1.54.18 3.71.37 5.29.68s2.3 2.33 0 2.33H41.4a3 3 0 0 1-2.4-2.94V56.27"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M52 55.73a3.33 3.33 0 0 0-3.32 3.33 3.25 3.25 0 0 0 1.46 2.78v2.34c0 1.25.54 2.27 1.86 2.27 1.25 0 1.86-1 1.86-2.27v-2.34a3.28 3.28 0 0 0 1.54-2.78 3.33 3.33 0 0 0-3.4-3.33Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M52 55.73a3.33 3.33 0 0 0-3.32 3.33 3.25 3.25 0 0 0 1.46 2.78v2.34c0 1.25.54 2.27 1.86 2.27 1.25 0 1.86-1 1.86-2.27v-2.34a3.28 3.28 0 0 0 1.54-2.78 3.33 3.33 0 0 0-3.4-3.33Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M85.43 49.05V93.1H18.65v-3.36l-.08-40.69M11.14 93.1h81.72M23.54 36.51V18.82h9.66v8.53l-9.66 9.16z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.08 11.22a2.78 2.78 0 0 1 3.63-.22l.21.18 40.86 39a2.79 2.79 0 0 1-3.63 4.22l-.22-.19L52 17.09 13.07 54.25a2.79 2.79 0 0 1-3.74.11l-.2-.2A2.79 2.79 0 0 1 9 50.43l.2-.21Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M61.08 42.9h7.43a1.68 1.68 0 0 1 1.17.47 1.64 1.64 0 0 1 .48 1.16V73.6a1.6 1.6 0 0 1-.89 1.45l-16.53 8.52a1.58 1.58 0 0 1-1.52 0l-16.49-8.52a1.6 1.6 0 0 1-.89-1.45V44.52a1.65 1.65 0 0 1 .48-1.17 1.68 1.68 0 0 1 1.17-.47h7.56"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47.02 42.88h10.01"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "38.91",
          y: "50.46",
          width: "26.17",
          height: "22.34",
          rx: "3.51"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42.84 50.46v-5.57a9.22 9.22 0 1 1 18.43-.13V50"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M57.39 50.14v-5.38a5.43 5.43 0 0 0-5.07-5.48 5.36 5.36 0 0 0-5.58 5.33v5.77"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SecurityHome104 = (SecurityHome104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/SecurityHome56.tsx


var SecurityHome56_excluded = ["className"];
function SecurityHome56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function SecurityHome56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SecurityHome56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SecurityHome56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function SecurityHome56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SecurityHome56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", SecurityHome56_objectSpread(SecurityHome56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.27 50.13C22 48.8 14.07 42.86 11.39 34.05a21.73 21.73 0 0 1-.87-7.64H10v23.72Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27 6a1.49 1.49 0 0 1 2-.09V6l22 21a1.5 1.5 0 0 1-2 2.27l-.12-.1L28 9.2l-21 20a1.5 1.5 0 0 1-2 .06l-.12-.11a1.5 1.5 0 0 1 0-2L5 27Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.43 36.17s.83-.8 1.37.81a7.72 7.72 0 0 0 4.2 4.69c2.31 1 4.44 2.5 4.25 3.55-2.47-1.22-9.7-5.12-9.7-5.12Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21 30.3c0-.17.33-.4.47-.42.82-.09 1 2.88 1.13 3.48a6.69 6.69 0 0 0 1.24 3 4.3 4.3 0 0 0 2.64 1.18c.83.1 2 .2 2.85.37s1.24 1.25 0 1.25h-7A1.59 1.59 0 0 1 21 37.58V30.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28 30a1.79 1.79 0 0 0-1.8 1.8 1.77 1.77 0 0 0 .8 1.5v1.26c0 .67.29 1.22 1 1.22.67 0 1-.55 1-1.22V33.3a1.76 1.76 0 0 0 .83-1.5A1.79 1.79 0 0 0 28 30Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28 30a1.79 1.79 0 0 0-1.8 1.8 1.77 1.77 0 0 0 .8 1.5v1.26c0 .67.29 1.22 1 1.22.67 0 1-.55 1-1.22V33.3a1.76 1.76 0 0 0 .83-1.5A1.79 1.79 0 0 0 28 30Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46 26.41v23.72H10.04v-1.81L10 26.41M6 50.13h44M12.68 19.66v-9.53h5.2v4.6l-5.2 4.93z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27 6a1.49 1.49 0 0 1 2-.09V6l22 21a1.5 1.5 0 0 1-2 2.27l-.12-.1L28 9.2l-21 20a1.5 1.5 0 0 1-2 .06l-.12-.11a1.5 1.5 0 0 1 0-2L5 27Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.89 23.1h4a.91.91 0 0 1 .63.25.88.88 0 0 1 .26.63v15.65a.86.86 0 0 1-.48.78L28.4 45a.85.85 0 0 1-.82 0l-8.88-4.59a.86.86 0 0 1-.48-.78V24a.88.88 0 0 1 .26-.63.91.91 0 0 1 .63-.25h4.07"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M25.32 23.09h5.39"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "20.95",
          y: "27.17",
          width: "14.09",
          height: "12.03",
          rx: "1.89"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.07 27.17v-3a5 5 0 0 1 5-5.07 5 5 0 0 1 4.92 5v2.81"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.9 27v-2.9a2.92 2.92 0 0 0-2.73-3 2.89 2.89 0 0 0-3 2.87v3.11"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SecurityHome56 = (SecurityHome56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/SecurityInternet104.tsx


var SecurityInternet104_excluded = ["className"];
function SecurityInternet104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function SecurityInternet104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SecurityInternet104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SecurityInternet104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function SecurityInternet104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SecurityInternet104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", SecurityInternet104_objectSpread(SecurityInternet104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29.43 23.62a1 1 0 0 1 1.45-.82c4.8 2.81 5.75 10 6.11 15 .5 7-.5 14 0 20.93.4 6 1 16.58 8.31 18.49 7.07 1.85 19.94 2.09 18.39 13-.14 1-1 2.62-2.18 2.62H32.64a3 3 0 0 1-3.21-2.91V23.66Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M57.14 56.87s1.51-1.45 2.47 1.45A14 14 0 0 0 67 66.77c4.18 1.85 8 4.51 7.67 6.4-4.36-2.24-17.42-9.28-17.42-9.28Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M61.6 46.26c0-.29.6-.72.86-.74 1.48-.17 1.76 5.2 2 6.26a12.05 12.05 0 0 0 2.25 5.57 7.58 7.58 0 0 0 4.75 2.14c1.5.18 3.58.37 5.14.66s2.25 2.25 0 2.25H64.05a2.85 2.85 0 0 1-2.45-2.9V46.26"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M74.34 45.74a3.23 3.23 0 0 0-1.74 5.95V54c0 1.21.53 2.21 1.74 2.21s1.73-1 1.73-2.21v-2.31a3.22 3.22 0 0 0-1.73-5.95Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M70.15 33.24h8.47"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M63.71 73.45V91a1.85 1.85 0 0 1-1.85 1.85H31.35A1.85 1.85 0 0 1 29.49 91V12.89A1.85 1.85 0 0 1 31.35 11h30.51a1.85 1.85 0 0 1 1.85 1.85v14.78M17.52 64.17a30.38 30.38 0 0 1 0-34.23M23.65 60.14a23.26 23.26 0 0 1 0-26.17M41.85 83.34h9.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M83.55 33.24h6.84A1.62 1.62 0 0 1 92 34.86v28.23a1.61 1.61 0 0 1-.87 1.43l-16 8.28a1.67 1.67 0 0 1-1.48 0l-16-8.3a1.62 1.62 0 0 1-.87-1.43V34.79a1.62 1.62 0 0 1 1.6-1.62h6.89"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M65 40.62h18.61a3.4 3.4 0 0 1 3.47 3.45v14.86a3.4 3.4 0 0 1-3.4 3.4H65.11a3.42 3.42 0 0 1-2.44-1 3.37 3.37 0 0 1-1-2.42V44.07A3.38 3.38 0 0 1 65 40.62Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M74.34 45.74a3.23 3.23 0 0 0-1.74 5.95V54c0 1.21.53 2.21 1.74 2.21s1.73-1 1.73-2.21v-2.31a3.22 3.22 0 0 0-1.73-5.95Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M65.45 40.62v-5.41a9.1 9.1 0 0 1 9.08-9.15 9 9 0 0 1 8.84 9v5.57h-3.72v-5.47a5.26 5.26 0 0 0-4.92-5.33A5.2 5.2 0 0 0 69.27 35v5.57Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SecurityInternet104 = (SecurityInternet104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/SecurityInternet56.tsx


var SecurityInternet56_excluded = ["className"];
function SecurityInternet56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function SecurityInternet56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SecurityInternet56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SecurityInternet56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function SecurityInternet56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SecurityInternet56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", SecurityInternet56_objectSpread(SecurityInternet56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M15.85 12.71a.51.51 0 0 1 .78-.44c2.58 1.51 3.09 5.4 3.29 8.09.27 3.75-.27 7.51 0 11.27.21 3.25.53 8.93 4.47 10s10.74 1.12 9.9 7c-.07.52-.55 1.41-1.17 1.41H17.58a1.62 1.62 0 0 1-1.73-1.57V12.79Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.77 30.61s.81-.78 1.33.78a7.54 7.54 0 0 0 4 4.55c2.25 1 4.32 2.43 4.13 3.45-2.35-1.21-9.38-5-9.38-5Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.17 24.9c0-.16.32-.39.46-.4.8-.09.95 2.8 1.1 3.37a6.43 6.43 0 0 0 1.21 3A4.11 4.11 0 0 0 38.5 32c.81.1 1.93.2 2.77.36s1.21 1.21 0 1.21h-6.78A1.54 1.54 0 0 1 33.17 32v-7.1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40 24.62a1.74 1.74 0 0 0-.94 3.2V29c0 .65.29 1.19.94 1.19.65 0 .93-.54.93-1.19v-1.18a1.73 1.73 0 0 0-.93-3.2Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.77 17.89h4.57"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.31 39v9.47a1 1 0 0 1-1 1H16.88a1 1 0 0 1-1-1v-41a1 1 0 0 1 1-1h16.43a1 1 0 0 1 1 1v7.4M9.43 34.54a16.37 16.37 0 0 1 0-18.43M12.74 32.37a12.52 12.52 0 0 1 0-14.09M22.53 44.86h5.12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45 17.89h3.68a.87.87 0 0 1 .86.87V34a.87.87 0 0 1-.47.77l-8.63 4.46a.93.93 0 0 1-.8 0L31 34.72a.87.87 0 0 1-.47-.77V18.72a.87.87 0 0 1 .86-.87h3.71"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35 21.86h10a1.83 1.83 0 0 1 1.87 1.86v8a1.83 1.83 0 0 1-1.83 1.83h-10a1.83 1.83 0 0 1-1.87-1.83v-8a1.8 1.8 0 0 1 .53-1.31 1.82 1.82 0 0 1 1.3-.55Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40 24.62a1.74 1.74 0 0 0-.94 3.2V29c0 .65.29 1.19.94 1.19.65 0 .93-.54.93-1.19v-1.18a1.73 1.73 0 0 0-.93-3.2Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.24 21.86V19a4.9 4.9 0 0 1 4.89-5 4.84 4.84 0 0 1 4.76 4.82v3h-2v-2.9a2.83 2.83 0 0 0-2.65-2.87 2.8 2.8 0 0 0-2.94 2.79v3Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SecurityInternet56 = (SecurityInternet56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/SecurityMobile104.tsx


var SecurityMobile104_excluded = ["className"];
function SecurityMobile104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function SecurityMobile104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SecurityMobile104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SecurityMobile104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function SecurityMobile104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SecurityMobile104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", SecurityMobile104_objectSpread(SecurityMobile104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M51.72 56.87s1.5-1.45 2.47 1.45a14 14 0 0 0 7.42 8.45c4.18 1.85 8 4.51 7.67 6.4-4.36-2.24-17.42-9.28-17.42-9.28Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M56.17 46.26c0-.29.6-.72.86-.74 1.48-.17 1.76 5.2 2 6.26a12.05 12.05 0 0 0 2.25 5.57 7.58 7.58 0 0 0 4.75 2.14c1.51.18 3.59.37 5.15.66s2.24 2.25 0 2.25H58.62a2.85 2.85 0 0 1-2.45-2.9V46.26"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M55.63 87c-2.87-1.83-6.4-2-9.39-3.62-12.77-6.69-15.5-22.07-17.45-35.05-.57-3.24-.71-5.33-4.46-5.64v44.62c0 4 1.37 5.4 5.38 5.41h29.18A6.52 6.52 0 0 0 55.63 87Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M68.91 45.74a3.23 3.23 0 0 0-1.74 5.95V54c0 1.21.54 2.21 1.74 2.21 1.21 0 1.73-1 1.73-2.21v-2.31a3.22 3.22 0 0 0-1.73-5.95Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M64.72 33.24h8.47"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M78.12 33.24H85a1.63 1.63 0 0 1 1.6 1.62v28.23a1.63 1.63 0 0 1-.88 1.43l-16 8.28a1.7 1.7 0 0 1-1.49 0l-16-8.3a1.62 1.62 0 0 1-.87-1.43V34.79a1.62 1.62 0 0 1 1.6-1.62h6.89"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M59.61 40.62h18.57a3.4 3.4 0 0 1 3.47 3.45v14.86a3.4 3.4 0 0 1-3.4 3.4H59.68a3.42 3.42 0 0 1-2.44-1 3.37 3.37 0 0 1-1-2.42V44.07a3.42 3.42 0 0 1 1-2.44 3.37 3.37 0 0 1 2.42-1Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M68.91 45.74a3.23 3.23 0 0 0-1.74 5.95V54c0 1.21.54 2.21 1.74 2.21 1.21 0 1.73-1 1.73-2.21v-2.31a3.22 3.22 0 0 0-1.73-5.95Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M60 40.62v-5.41a9.1 9.1 0 0 1 9.08-9.15 9 9 0 0 1 8.84 9v5.57h-3.7v-5.47a5.26 5.26 0 0 0-4.92-5.33A5.2 5.2 0 0 0 63.84 35v5.57Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M68.7 78v9.29a5.57 5.57 0 0 1-5.57 5.57H29.7a5.57 5.57 0 0 1-5.57-5.57V16.73a5.57 5.57 0 0 1 5.57-5.57h33.43a5.57 5.57 0 0 1 5.57 5.57v3.72M44.56 14.88h3.71M40.84 89.16h11.15"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SecurityMobile104 = (SecurityMobile104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/SecurityMobile56.tsx


var SecurityMobile56_excluded = ["className"];
function SecurityMobile56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function SecurityMobile56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SecurityMobile56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SecurityMobile56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function SecurityMobile56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SecurityMobile56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", SecurityMobile56_objectSpread(SecurityMobile56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.77 30.61s.81-.78 1.33.78a7.54 7.54 0 0 0 4 4.55c2.25 1 4.32 2.43 4.13 3.45-2.35-1.21-9.38-5-9.38-5Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.17 24.9c0-.16.32-.39.46-.4.8-.09.95 2.8 1.1 3.37a6.43 6.43 0 0 0 1.21 3A4.11 4.11 0 0 0 35.5 32c.81.1 1.93.2 2.77.36s1.21 1.21 0 1.21h-6.78A1.54 1.54 0 0 1 30.17 32v-7.1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30 46.86c-1.54-1-3.44-1.07-5.05-2C18 41.31 16.55 33 15.5 26c-.3-1.74-.38-2.87-2.4-3v24c0 2.16.73 2.91 2.89 2.91h15.72A3.49 3.49 0 0 0 30 46.86Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37 24.62a1.74 1.74 0 0 0-.94 3.2V29c0 .65.29 1.19.94 1.19.65 0 .93-.54.93-1.19v-1.18a1.73 1.73 0 0 0-.93-3.2Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.77 17.89h4.57"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42 17.89h3.68a.87.87 0 0 1 .86.87V34a.87.87 0 0 1-.47.77l-8.63 4.46a.93.93 0 0 1-.8 0L28 34.72a.87.87 0 0 1-.47-.77V18.72a.87.87 0 0 1 .86-.87h3.71"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32 21.86h10a1.83 1.83 0 0 1 1.87 1.86v8a1.83 1.83 0 0 1-1.83 1.83h-10a1.83 1.83 0 0 1-1.87-1.83v-8a1.8 1.8 0 0 1 .53-1.31 1.82 1.82 0 0 1 1.3-.55Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37 24.62a1.74 1.74 0 0 0-.94 3.2V29c0 .65.29 1.19.94 1.19.65 0 .93-.54.93-1.19v-1.18a1.73 1.73 0 0 0-.93-3.2Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.24 21.86V19a4.9 4.9 0 0 1 4.89-5 4.84 4.84 0 0 1 4.76 4.82v3h-2v-2.9a2.83 2.83 0 0 0-2.65-2.87 2.8 2.8 0 0 0-2.94 2.79v3Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37 42v5a3 3 0 0 1-3 3H16a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v2M23.99 8h2M21.99 48h6"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SecurityMobile56 = (SecurityMobile56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/AddPhone104.tsx


var AddPhone104_excluded = ["className"];
function AddPhone104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function AddPhone104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? AddPhone104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AddPhone104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function AddPhone104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AddPhone104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AddPhone104_objectSpread(AddPhone104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M55.64 87.02c-2.86-1.83-6.4-1.99-9.38-3.63-12.77-6.68-15.5-22.07-17.46-35.05-.57-3.24-.7-5.33-4.46-5.63v44.57c0 4.01 1.37 5.41 5.38 5.41h29.19c.19-2.29-1.33-4.44-3.26-5.68Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.71 65v22.29c0 3.08-2.49 5.57-5.57 5.57H29.71c-3.08 0-5.57-2.49-5.57-5.57V16.71c0-3.08 2.49-5.57 5.57-5.57h33.43c3.08 0 5.57 2.49 5.57 5.57v5.57M44.57 14.86h3.72M40.86 89.14H52"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "73.22",
        cy: "43.41",
        r: "14.62"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.22 37.41v12M67.22 43.41h12"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AddPhone104 = (AddPhone104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/AddPhone56.tsx


var AddPhone56_excluded = ["className"];
function AddPhone56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function AddPhone56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? AddPhone56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AddPhone56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function AddPhone56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AddPhone56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AddPhone56_objectSpread(AddPhone56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.96 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37 35v12c0 1.66-1.34 3-3 3H16c-1.66 0-3-1.34-3-3V9c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v3M24 8h2M22 48h6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "39.55",
        cy: "23.5",
        r: "8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.55 20.22v6.56M36.27 23.5h6.56"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AddPhone56 = (AddPhone56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/AppMyTelstra104.tsx


var AppMyTelstra104_excluded = ["className"];
function AppMyTelstra104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function AppMyTelstra104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? AppMyTelstra104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AppMyTelstra104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function AppMyTelstra104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AppMyTelstra104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", AppMyTelstra104_objectSpread(AppMyTelstra104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M13.93 55.31c.07.5.13 1 .2 1.51s.17 1.19.27 1.78.24 1.34.37 2 .31 1.46.49 2.19.4 1.56.62 2.33.51 1.63.79 2.43.62 1.68 1 2.5.75 1.7 1.17 2.53a33 33 0 0 0 19.21 16.54 38.14 38.14 0 0 0 4 1c1.44.29 2.9.51 4.37.66.68.07 1.36.11 2 .19a6.07 6.07 0 0 1 3.25 1.37c.06 0 .25.27.33.27l-24.81.26s-16.86-.8-16.32-21.8V51.98l.24.06a3.81 3.81 0 0 1 2.82 3.27ZM36.78 42.21s-8.23 2.87-1.86 18.44c-3.01-4.08-9.3-16.93 1.86-18.44ZM36.29 62.4c-.09-.08-.24 0-.16.14C45.89 75.12 61 80.33 67 76.43c1.7-5.06-13.86 1.97-30.71-14.03ZM53.41 64c-5.06.09-7-5.5-5.46-13 .29-1.4.17-2 .1-2s-2.67 15-2.67 15ZM70.8 30.11l-.88 4.8c.23-1.46-2-3.62-7-4s-4.92-.8-4.92-.8h13"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.14 44.25c-3.62-1.68-7.32-2.79-10.26-2.79s-5.08.77-6.59 2.63a7.46 7.46 0 0 0-1.6 4.91c0 5.8 4.47 13.85 12.13 20.41 6.82 5.81 14.33 9.06 19.79 9.06A8 8 0 0 0 68 75.88a7.38 7.38 0 0 0 1.59-5c0-5.63-4.51-13.53-11.76-20"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42.35 29.39a2.86 2.86 0 0 0-2.8 2.4l-1.21 6.73h10.82l-4.65 26.14h8.61A2.76 2.76 0 0 0 56 62.11l3.93-23.59h7.79a2.86 2.86 0 0 0 2.81-2.4l1.21-6.73Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "10.99",
          y: "11",
          width: "82",
          height: "82",
          rx: "19.09"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AppMyTelstra104 = (AppMyTelstra104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/AppMyTelstra56.tsx


var AppMyTelstra56_excluded = ["className"];
function AppMyTelstra56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function AppMyTelstra56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? AppMyTelstra56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : AppMyTelstra56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function AppMyTelstra56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AppMyTelstra56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", AppMyTelstra56_objectSpread(AppMyTelstra56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M8.07 29.73c0 .27.06.53.1.8s.09.62.14.93.13.7.2 1 .16.76.25 1.14.21.82.33 1.22.26.85.41 1.28.33.87.51 1.31.39.89.61 1.32a17.26 17.26 0 0 0 10.08 8.71 21 21 0 0 0 2.07.54c.76.15 1.52.26 2.29.34l1.07.1a3.2 3.2 0 0 1 1.7.72s.13.14.17.14l-13 .14S6.18 49 6.46 38V28h.12a2 2 0 0 1 1.49 1.73ZM20 22.87s-4.3 1.5-1 9.66c-1.52-2.13-4.81-8.87 1-9.66ZM19.78 33.45c-.05-.05-.13 0-.09.07 5.12 6.59 13 9.32 16.2 7.27.87-2.65-7.28 1.04-16.11-7.34ZM28.75 34.28c-2.65 0-3.67-2.88-2.86-6.8.15-.73.09-1.07.05-1s-1.4 7.84-1.4 7.84ZM37.85 16.53l-.46 2.52c.13-.77-1.07-1.9-3.67-2.09s-2.59-.43-2.59-.43h6.8"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26 23.94a13.78 13.78 0 0 0-5.38-1.46 4.19 4.19 0 0 0-3.45 1.37 3.94 3.94 0 0 0-.84 2.56c0 3 2.34 7.25 6.35 10.69 3.58 3 7.51 4.74 10.37 4.74a4.2 4.2 0 0 0 3.34-1.33 3.89 3.89 0 0 0 .83-2.6c0-2.95-2.36-7.09-6.16-10.45"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23 16.16a1.5 1.5 0 0 0-1.47 1.26l-.63 3.52h5.67l-2.48 13.69h4.5a1.43 1.43 0 0 0 1.48-1.33l2.07-12.36h4.07a1.5 1.5 0 0 0 1.48-1.26l.63-3.52Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "6.58",
          y: "6.58",
          width: "42.84",
          height: "42.84",
          rx: "10"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AppMyTelstra56 = (AppMyTelstra56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Appointment104.tsx


var Appointment104_excluded = ["className"];
function Appointment104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Appointment104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Appointment104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Appointment104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Appointment104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Appointment104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Appointment104_objectSpread(Appointment104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M14.84 45.12c12.45-26.78 24.91-27.44 24.91-27.44l-18.51-1.19-5.87 6.71Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.31 58.11H22.2A1.14 1.14 0 0 1 21.06 57v-6.86A1.14 1.14 0 0 1 22.2 49h9.11a1.14 1.14 0 0 1 1.14 1.14V57a1.14 1.14 0 0 1-1.14 1.14"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M64.67 58.11h-9.11A1.14 1.14 0 0 1 54.42 57v-6.86A1.14 1.14 0 0 1 55.56 49h9.11a1.14 1.14 0 0 1 1.14 1.14V57a1.14 1.14 0 0 1-1.14 1.14"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48 58.11h-9.12A1.14 1.14 0 0 1 37.74 57v-6.86A1.14 1.14 0 0 1 38.88 49H48a1.14 1.14 0 0 1 1.14 1.14V57A1.14 1.14 0 0 1 48 58.11"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M81.36 58.11h-9.11A1.14 1.14 0 0 1 71.11 57v-6.86A1.14 1.14 0 0 1 72.25 49h9.11a1.15 1.15 0 0 1 1.14 1.14V57a1.15 1.15 0 0 1-1.14 1.14"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.31 71.1H22.2a1.14 1.14 0 0 1-1.14-1.1v-6.87A1.14 1.14 0 0 1 22.2 62h9.11a1.14 1.14 0 0 1 1.14 1.14V70a1.14 1.14 0 0 1-1.14 1.13"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M64.67 71.1h-9.11a1.14 1.14 0 0 1-1.14-1.1v-6.87A1.14 1.14 0 0 1 55.56 62h9.11a1.14 1.14 0 0 1 1.14 1.14V70a1.14 1.14 0 0 1-1.14 1.13"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48 71.1h-9.12a1.14 1.14 0 0 1-1.14-1.1v-6.87A1.14 1.14 0 0 1 38.88 62H48a1.14 1.14 0 0 1 1.14 1.14V70A1.14 1.14 0 0 1 48 71.1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.31 84.1H22.2a1.14 1.14 0 0 1-1.14-1.1v-6.87A1.14 1.14 0 0 1 22.2 75h9.11a1.14 1.14 0 0 1 1.14 1.14V83a1.14 1.14 0 0 1-1.14 1.14"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M64.67 84.1h-9.11a1.14 1.14 0 0 1-1.14-1.1v-6.87A1.14 1.14 0 0 1 55.56 75h9.11a1.14 1.14 0 0 1 1.14 1.14V83a1.14 1.14 0 0 1-1.14 1.14"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48 84.1h-9.12a1.14 1.14 0 0 1-1.14-1.1v-6.87A1.14 1.14 0 0 1 38.88 75H48a1.14 1.14 0 0 1 1.14 1.14V83A1.14 1.14 0 0 1 48 84.1"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M88.22 73.91v8a8.09 8.09 0 0 1-8.1 8.1H23.43a8.1 8.1 0 0 1-8.1-8.1v-56.7a8.1 8.1 0 0 1 8.1-8.1h56.69a8.09 8.09 0 0 1 8.1 8.1v27.11"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M67.85 9.77v16.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.46 9.77v16.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M15.33 42.17h72.89"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M96.78 54.92a3.55 3.55 0 0 1 1.27 2.85l-17 17a9.52 9.52 0 0 1-6.64 2.44 9.52 9.52 0 0 1 2.44-6.64l17-17a3.56 3.56 0 0 1 2.85 1.27Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m91.7 56.33 3.99 3.72"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m77.05 70.98 3.75 3.75"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Appointment104 = (Appointment104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Appointment56.tsx


var Appointment56_excluded = ["className"];
function Appointment56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Appointment56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Appointment56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Appointment56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Appointment56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Appointment56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Appointment56_objectSpread(Appointment56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M9.79 24.5C16 11.24 22.13 10.92 22.13 10.92L13 10.33l-2.9 3.32Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18 30.93h-4.56a.57.57 0 0 1-.57-.56V27a.58.58 0 0 1 .57-.57H18a.57.57 0 0 1 .56.57v3.38a.56.56 0 0 1-.56.56"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.47 30.93H30a.57.57 0 0 1-.57-.56V27a.58.58 0 0 1 .57-.57h4.51A.57.57 0 0 1 35 27v3.38a.56.56 0 0 1-.56.56"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.21 30.93H21.7a.57.57 0 0 1-.57-.56V27a.58.58 0 0 1 .57-.57h4.51a.57.57 0 0 1 .56.57v3.38a.56.56 0 0 1-.56.56"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42.73 30.93h-4.51a.57.57 0 0 1-.57-.56V27a.58.58 0 0 1 .57-.57h4.51a.57.57 0 0 1 .56.57v3.38a.56.56 0 0 1-.56.56"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18 37.37h-4.56a.58.58 0 0 1-.57-.57v-3.38a.57.57 0 0 1 .57-.56H18a.56.56 0 0 1 .56.56v3.38a.57.57 0 0 1-.56.57"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.47 37.37H30a.58.58 0 0 1-.57-.57v-3.38a.57.57 0 0 1 .57-.56h4.51a.56.56 0 0 1 .56.56v3.38a.57.57 0 0 1-.56.57"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.21 37.37H21.7a.58.58 0 0 1-.57-.57v-3.38a.57.57 0 0 1 .57-.56h4.51a.56.56 0 0 1 .56.56v3.38a.57.57 0 0 1-.56.57"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18 43.8h-4.56a.57.57 0 0 1-.57-.56v-3.39a.57.57 0 0 1 .57-.56H18a.56.56 0 0 1 .56.56v3.39a.56.56 0 0 1-.56.56"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.47 43.8H30a.57.57 0 0 1-.57-.56v-3.39a.57.57 0 0 1 .57-.56h4.51a.56.56 0 0 1 .56.56v3.39a.56.56 0 0 1-.56.56"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.21 43.8H21.7a.57.57 0 0 1-.57-.56v-3.39a.57.57 0 0 1 .57-.56h4.51a.56.56 0 0 1 .56.56v3.39a.56.56 0 0 1-.56.56"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.13 38.75v4a4 4 0 0 1-4 4H14.05a4 4 0 0 1-4-4V14.64a4 4 0 0 1 4-4h28.07a4 4 0 0 1 4 4v13.43"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36.04 7v8.02"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20 7v8.02"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M10.04 23.04h36.09"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.36 29.35a1.75 1.75 0 0 1 .64 1.41l-8.39 8.4a4.74 4.74 0 0 1-3.29 1.21 4.68 4.68 0 0 1 1.21-3.29l8.4-8.39a1.77 1.77 0 0 1 1.41.62Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m47.85 30.05 1.98 1.84"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m40.6 37.31 1.85 1.85"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Appointment56 = (Appointment56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Bundles104.tsx


var Bundles104_excluded = ["className"];
function Bundles104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Bundles104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Bundles104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Bundles104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Bundles104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Bundles104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Bundles104_objectSpread(Bundles104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M76.38 60.39c-.79-1.15-2.1-1.79-3-2.89-3.75-4.6-2.29-10.85-.92-16.08.31-1.32.6-2.13-.77-2.85v.1l-6.88 16a3 3 0 0 0 1.57 3.92l4.91 2.11h5.31ZM41.83 59.91l-.17-.52s-2.11.69-9.29-1.62-10.32-8.28-12.93-14.43-2.92-8.86-5.55-8l.06.18 8.3 25.23h17ZM56.55 73.28 52.4 61.77 52 91.32h8.57s5.44-13.55 23-13.17v-4.87ZM19.26 76.47h26.53a1.56 1.56 0 0 0 1.5-.78l.81-2.19H19.26Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m56.83 28.53-4.43 4.66c-.54.45-.26.72 0 1l4 3.83a.24.24 0 0 0 .41-.17 1.53 1.53 0 0 0-.2-.65c-.37-.75-1.42-3.41-.58-5.61s1.49-2.6 1.25-3-.28-.2-.45-.06Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M58.44 57.18a.94.94 0 0 1-.63-.23 1 1 0 0 1-.14-1.4 12.4 12.4 0 0 0 .75-1 1 1 0 0 1 1.66 1.12c-.26.39-.55.77-.86 1.15a1 1 0 0 1-.78.36ZM60.73 53.09a.79.79 0 0 1-.3-.05 1 1 0 0 1-.66-1.25 9.48 9.48 0 0 0 .45-2.89 1.07 1.07 0 0 1 1-1.07 1 1 0 0 1 1 .93v.07a11.63 11.63 0 0 1-.54 3.56 1 1 0 0 1-.95.7ZM60.68 46.46a1 1 0 0 1-1-.71A10.43 10.43 0 0 0 58.44 43a1 1 0 0 1 1.62-1.17 12.52 12.52 0 0 1 1.58 3.33 1 1 0 0 1-.64 1.25 1 1 0 0 1-.32.05Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "26.62",
        cy: "20.64",
        r: ".68",
        className: "strokeinverted"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m71.29 60.76-5.37-2.31a2.49 2.49 0 0 1-1.31-3.28l11.11-25.91A2.5 2.5 0 0 1 79 27.94l12.11 5.2a2.49 2.49 0 0 1 1.31 3.28L82.07 60.56M83.46 33l1.46.63M70.7 57.12l4.36 1.87M35.98 58.55l5.97-1.97M22.14 60.76 10.76 26.17a3 3 0 0 1 1.91-3.79l26.2-8.63a3 3 0 0 1 3.79 1.91l12.13 36.87a3 3 0 0 1-1.91 3.78l-13.42 4.42"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20.09 60.73h31.92v30.59H20.09V74"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M83.86 74.15v17.17H51.99V60.73h31.87"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m20.11 60.75-7.1 12.53h34.5l4.52-12.53H20.11zM83.9 60.75l7.09 12.53H56.55l-4.52-12.53H83.9zM62.42 33l-5 5.19a.52.52 0 0 1-.72 0l-4.42-4.23a.5.5 0 0 1-.07-.71l6.15-6.37a.59.59 0 0 1 .83 0L62.42 30a1 1 0 0 1 .35.65v1.57a1 1 0 0 1-.35.78Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Bundles104 = (Bundles104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Bundles56.tsx


var Bundles56_excluded = ["className"];
function Bundles56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Bundles56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Bundles56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Bundles56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Bundles56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Bundles56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Bundles56_objectSpread(Bundles56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41.13 32.52c-.43-.62-1.13-1-1.6-1.56-2-2.47-1.23-5.84-.49-8.66.17-.71.32-1.14-.42-1.53v.05l-3.71 8.64a1.62 1.62 0 0 0 .85 2.12l2.64 1.13h2.86ZM22.53 32.26l-.1-.28s-1.13.37-5-.87-5.56-4.46-7-7.77S8.9 18.56 7.48 19v.09L12 32.71h9.17ZM30.45 39.46l-2.24-6.2L28 49.17h4.61s2.93-7.3 12.37-7.09v-2.62ZM10.37 41.17h14.29a.83.83 0 0 0 .8-.41l.44-1.18H10.37Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m30.6 15.36-2.38 2.51c-.29.24-.15.39 0 .53l2.16 2.07a.13.13 0 0 0 .22-.09.89.89 0 0 0-.1-.35 4.21 4.21 0 0 1-.32-3c.46-1.18.8-1.4.67-1.63s-.18-.11-.25-.04Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.47 30.79a.54.54 0 0 1-.34-.12.55.55 0 0 1-.08-.76 6.42 6.42 0 0 0 .41-.54.54.54 0 0 1 .89.6c-.14.21-.3.42-.46.62a.56.56 0 0 1-.42.2ZM32.7 28.59a.45.45 0 0 1-.16 0 .53.53 0 0 1-.35-.67 5.18 5.18 0 0 0 .24-1.56.56.56 0 0 1 .53-.57.5.5 0 0 1 .53.5 6.07 6.07 0 0 1-.29 1.92.53.53 0 0 1-.5.38ZM32.68 25a.55.55 0 0 1-.52-.38 6.19 6.19 0 0 0-.69-1.49.53.53 0 0 1 .12-.75.54.54 0 0 1 .75.12 7 7 0 0 1 .85 1.8.54.54 0 0 1-.35.67Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "14.33",
        cy: "11.11",
        r: ".37",
        className: "strokeinverted"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m38.39 32.71-2.9-1.24a1.34 1.34 0 0 1-.7-1.76l6-14a1.34 1.34 0 0 1 1.77-.7l6.52 2.79a1.36 1.36 0 0 1 .71 1.77l-5.58 13M44.94 17.77l.78.34M38.07 30.76l2.35 1M19.37 31.52l3.22-1.05M11.92 32.71 5.79 14.09a1.61 1.61 0 0 1 1-2l14.14-4.68a1.62 1.62 0 0 1 2 1l6.57 19.87a1.62 1.62 0 0 1-1 2l-7.25 2.42"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M10.82 32.7h17.19v16.47H10.82v-9.32"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45.16 39.93v9.24H27.99V32.7h17.17"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m10.83 32.71-3.82 6.75h18.57l2.44-6.75H10.83zM45.18 32.71l3.81 6.75H30.45l-2.43-6.75h17.16zM33.61 17.77l-2.7 2.79a.27.27 0 0 1-.38 0l-2.39-2.28a.27.27 0 0 1 0-.38l3.31-3.43a.33.33 0 0 1 .45 0l1.74 1.67a.54.54 0 0 1 .19.35v.85a.55.55 0 0 1-.22.43Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Bundles56 = (Bundles56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/DataPacks104.tsx


var DataPacks104_excluded = ["className"];
function DataPacks104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function DataPacks104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DataPacks104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DataPacks104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function DataPacks104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, DataPacks104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", DataPacks104_objectSpread(DataPacks104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.59 88.09c-3-1.9-6.66-2.07-9.77-3.77-13.3-7-16.13-23-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46A7.57 7.57 0 0 0 30.56 94H59c.18-2.38-1.4-4.62-3.41-5.91Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42 38v12M36 44h12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "44.61",
          y: "42.56",
          width: "22.88",
          height: "6",
          rx: ".38",
          transform: "rotate(-90 56.05 45.56)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "52.75",
          y: "39.7",
          width: "28.6",
          height: "6",
          rx: ".38",
          transform: "rotate(-90 67.05 42.7)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "69.47",
          y: "45.42",
          width: "17.16",
          height: "6",
          rx: ".38",
          transform: "rotate(-90 78.05 48.42)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M69 63v25a6 6 0 0 1-6 6H29a6 6 0 0 1-6-6V16a6 6 0 0 1 6-6h34a6 6 0 0 1 6 6v6M44 14h4M40 90h12"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_DataPacks104 = (DataPacks104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/DataPacks56.tsx


var DataPacks56_excluded = ["className"];
function DataPacks56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function DataPacks56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DataPacks56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DataPacks56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function DataPacks56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, DataPacks56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", DataPacks56_objectSpread(DataPacks56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30 46.86c-1.54-1-3.45-1.07-5.05-2C18 41.31 16.56 33 15.51 26c-.31-1.74-.38-2.87-2.4-3v24c0 2.16.74 2.91 2.9 2.91h15.71A3.49 3.49 0 0 0 30 46.86Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.48 20.5v6M19.48 23.5h6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "24.36",
          y: "23.38",
          width: "11.25",
          height: "3",
          rx: ".19",
          transform: "rotate(-90 29.98 24.88)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "28.95",
          y: "21.97",
          width: "14.07",
          height: "3",
          rx: ".19",
          transform: "rotate(-90 35.985 23.475)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "37.74",
          y: "24.79",
          width: "8.44",
          height: "3",
          rx: ".19",
          transform: "rotate(-90 41.965 26.285)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37 34v13a3 3 0 0 1-3 3H16a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v4M24 8h2M22 48h6"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_DataPacks56 = (DataPacks56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/DataPool104.tsx


var DataPool104_excluded = ["className"];
function DataPool104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function DataPool104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DataPool104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DataPool104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function DataPool104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, DataPool104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", DataPool104_objectSpread(DataPool104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.88 85c-1.56-.38-3.14.11-4.72-.16-6.72-1-10.48-7.58-13.51-13.17-.79-1.38-1.2-2.31-2.9-1.85l.05.13 7.39 20.13c.67 1.82 1.5 2.24 3.26 1.6L40.26 87a3.17 3.17 0 0 0-2.38-2ZM74.44 87.93C73.5 86.65 72 86 71 84.79c-4.46-5.08-3.1-12.52-1.8-18.75.29-1.57.58-2.54-1-3.28l-.05.13-7.38 20.19c-.67 1.83-.3 2.68 1.44 3.32L74.92 91a3.19 3.19 0 0 0-.48-3.07Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.8 23.63a32 32 0 0 1 32.92-9.9q1 .29 2 .63M20.77 51.5a32.16 32.16 0 0 1 3.63-23.13M48.71 76.44a32.33 32.33 0 0 1-5.33-1c-.85-.24-1.68-.51-2.5-.81M63.47 74.51a32.11 32.11 0 0 1-9.44 2M68.23 16.91a32 32 0 0 1 15.1 34.59M42.1 86.45l-14.57 5.26a2.65 2.65 0 0 1-3.4-1.58L12.31 58a2.63 2.63 0 0 1 1.59-3.38l14.56-5.26a2.67 2.67 0 0 1 3.41 1.58l11.82 32.13a2.63 2.63 0 0 1-1.59 3.38ZM21.49 55.31l1.63-.59M31.32 87.22l4.89-1.77M81.07 54.65l1.62.59M68.08 85.38l4.85 1.77M76.69 91.77 62.24 86.5a2.66 2.66 0 0 1-1.58-3.39l11.73-32.29a2.64 2.64 0 0 1 3.38-1.58l14.45 5.27a2.64 2.64 0 0 1 1.57 3.39L80.07 90.19a2.64 2.64 0 0 1-3.38 1.58Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m50.17 51.5-.34-1.74a4.62 4.62 0 0 1-4 2A6.08 6.08 0 0 1 41.16 50c-1.65-1.72-2-3.83-2-6.42s.33-4.64 2-6.35a6.76 6.76 0 0 1 4.7-1.85 6.51 6.51 0 0 1 4.68 1.8A4.77 4.77 0 0 1 52 40.4h-2.95a2.39 2.39 0 0 0-.69-1.4 3.18 3.18 0 0 0-2.52-1 3.7 3.7 0 0 0-2.58 1.07C42.16 40.2 42 42.16 42 43.61s.16 3.48 1.25 4.61a3.6 3.6 0 0 0 2.56 1 3.2 3.2 0 0 0 2.37-.92 4.07 4.07 0 0 0 1-3.07h-3.72v-2.38H52v8.65ZM64.38 50.45a6.61 6.61 0 0 1-4.22 1.07h-6.28V35.7h6.28a6.7 6.7 0 0 1 3.66.86A4.12 4.12 0 0 1 65.65 40a3.6 3.6 0 0 1-1.94 3.34A3.87 3.87 0 0 1 66 46.91a4.26 4.26 0 0 1-1.62 3.54Zm-4.11-12.28h-3.54v4h3.61c1.29 0 2.39-.47 2.39-2s-1.16-2-2.46-2Zm.09 6.38h-3.63v4.39h3.54c1.34 0 2.79-.49 2.79-2.1s-1.18-2.29-2.7-2.29Z"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_DataPool104 = (DataPool104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/DataPool56.tsx


var DataPool56_excluded = ["className"];
function DataPool56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function DataPool56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DataPool56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DataPool56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function DataPool56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, DataPool56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", DataPool56_objectSpread(DataPool56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.45 40.53c-.79-.53-1.77-.58-2.59-1.05-3.53-1.93-4.28-6.38-4.86-10.13-.16-.94-.2-1.54-1.23-1.63v8.57a7.91 7.91 0 0 1-1.64-.62c-3.53-1.93-4.28-6.38-4.82-10.13-.16-.94-.2-1.54-1.24-1.63V36.8c0 1.16.38 1.56 1.49 1.56h6.21v2.25c0 1.16.37 1.56 1.48 1.56h8.06a1.91 1.91 0 0 0-.86-1.64Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20.79 7.91a21.25 21.25 0 0 1 22.27 4.92c.32.32.64.66.94 1M15.82 45.26a20.73 20.73 0 0 1-2.75-2.32 21.26 21.26 0 0 1 4.22-33.38M46.37 17.1a21.26 21.26 0 0 1-27.51 29.95M25.75 38.41h-6.12a1.57 1.57 0 0 1-1.57-1.57V16.36a1.58 1.58 0 0 1 1.57-1.58h9.16a1.58 1.58 0 0 1 1.58 1.58v2.23M23.7 16.73h1.03M22.68 36.59h3.07"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "25.75",
          y: "18.59",
          width: "12.31",
          height: "23.63",
          rx: "1.57"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.39 20.53h1.03M30.37 40.4h3.08"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_DataPool56 = (DataPool56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/DeviceLocator104.tsx


var DeviceLocator104_excluded = ["className"];
function DeviceLocator104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function DeviceLocator104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DeviceLocator104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DeviceLocator104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function DeviceLocator104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, DeviceLocator104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", DeviceLocator104_objectSpread(DeviceLocator104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M61.59 88.09c-3-1.9-6.66-2.07-9.77-3.77-13.3-7-16.13-23-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46A7.57 7.57 0 0 0 36.56 94H65c.18-2.38-1.4-4.62-3.41-5.91ZM60.81 64.89a1.76 1.76 0 0 0 1.53 1l-8.24-14.6a17.34 17.34 0 0 1-2.43-8.93c0-7.13 4.16-13.17 9.88-15.2A14.07 14.07 0 0 0 50.72 49.1Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M61.76 66.65a1.92 1.92 0 0 0 3.44 0l11.14-17A14.82 14.82 0 0 0 79 41.16a15.5 15.5 0 0 0-31 0 14.82 14.82 0 0 0 2.66 8.49Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "63.6",
          cy: "41.27",
          rx: "7.8",
          ry: "7.64"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M75 63v25a6 6 0 0 1-6 6H35a6 6 0 0 1-6-6V16a6 6 0 0 1 6-6h34a6 6 0 0 1 6 6v6M50 14h4M46 90h12"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_DeviceLocator104 = (DeviceLocator104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/DeviceLocator56.tsx


var DeviceLocator56_excluded = ["className"];
function DeviceLocator56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function DeviceLocator56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DeviceLocator56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DeviceLocator56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function DeviceLocator56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, DeviceLocator56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", DeviceLocator56_objectSpread(DeviceLocator56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33 46.86c-1.54-1-3.45-1.07-5.05-2C21 41.31 19.56 33 18.51 26c-.31-1.74-.38-2.87-2.4-3v24c0 2.16.74 2.91 2.9 2.91h15.71A3.49 3.49 0 0 0 33 46.86ZM34.1 35.94a1 1 0 0 0 .87.56l-4.68-8.28a9.83 9.83 0 0 1-1.37-5.07 9 9 0 0 1 5.61-8.63A8 8 0 0 0 28.37 27Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M25 48h6M34.1 35.94a1 1 0 0 0 .89.56 1 1 0 0 0 .89-.56l5.75-9a8 8 0 1 0-13.26 0Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "35",
          cy: "22.5",
          r: "4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40 34v13a3 3 0 0 1-3 3H19a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v4M27 8h2"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_DeviceLocator56 = (DeviceLocator56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/DeviceProtect104.tsx


var DeviceProtect104_excluded = ["className"];
function DeviceProtect104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function DeviceProtect104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DeviceProtect104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DeviceProtect104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function DeviceProtect104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, DeviceProtect104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", DeviceProtect104_objectSpread(DeviceProtect104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M61.32 65.61a14.75 14.75 0 0 1-7.89-8.92c-1-3-2.6-1.52-2.6-1.52l.22 7.36S64.8 70 69.4 72.35c.36-1.99-3.68-4.9-8.08-6.74Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M71.43 58.54c-1.65-.31-3.83-.52-5.42-.71a8.09 8.09 0 0 1-5-2.24c-1.43-1.52-1.87-3.82-2.36-5.77-.28-1.13-.58-6.78-2.15-6.61-.27 0-.89.48-.89.8v13.83a3 3 0 0 0 2.57 3.07h13.2c2.41 0 1.9-2.02.05-2.37ZM55.59 88.09c-3-1.9-6.66-2.07-9.77-3.77-13.3-7-16.13-23-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46A7.57 7.57 0 0 0 30.56 94H59c.18-2.38-1.4-4.62-3.41-5.91Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M69 43.46a3.39 3.39 0 0 0-1.83 6.25v2.39c0 1.28.55 2.32 1.83 2.32s1.83-1 1.83-2.32v-2.39a3.36 3.36 0 0 0 1.57-2.85 3.4 3.4 0 0 0-3.4-3.4Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M78.31 30.3h7.57a1.69 1.69 0 0 1 1.68 1.7v29.73a1.67 1.67 0 0 1-.91 1.49L69.77 72a1.67 1.67 0 0 1-1.54 0l-16.88-8.78a1.67 1.67 0 0 1-.91-1.49V32a1.69 1.69 0 0 1 1.68-1.69h7.75M63.93 30.3h10.23"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "55.63",
          y: "38.06",
          width: "26.78",
          height: "22.85",
          rx: "3.59"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M59.64 38.06v-5.7a9.61 9.61 0 0 1 9.55-9.64 9.46 9.46 0 0 1 9.3 9.43v5.91h-4V32.3a5.57 5.57 0 0 0-5.18-5.61 5.47 5.47 0 0 0-5.73 5.46v5.91Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M69 78v10a6 6 0 0 1-6 6H29a6 6 0 0 1-6-6V16a6 6 0 0 1 6-6h34a6 6 0 0 1 6 6v1M44 14h4M40 90h12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M69 43.46a3.39 3.39 0 0 0-1.83 6.25v2.39c0 1.28.55 2.32 1.83 2.32s1.83-1 1.83-2.32v-2.39a3.36 3.36 0 0 0 1.57-2.85 3.4 3.4 0 0 0-3.4-3.4Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_DeviceProtect104 = (DeviceProtect104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/DeviceProtect56.tsx


var DeviceProtect56_excluded = ["className"];
function DeviceProtect56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function DeviceProtect56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? DeviceProtect56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DeviceProtect56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function DeviceProtect56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, DeviceProtect56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", DeviceProtect56_objectSpread(DeviceProtect56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33 36.5a7.77 7.77 0 0 1-4.15-4.69c-.54-1.61-1.37-.81-1.37-.81l.12 3.88s7.23 3.92 9.65 5.17C37.4 39 35.27 37.47 33 36.5Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.28 32.78c-.87-.17-2-.28-2.85-.37a4.31 4.31 0 0 1-2.64-1.18 6.68 6.68 0 0 1-1.24-3c-.15-.6-.31-3.57-1.13-3.48-.14 0-.47.25-.47.42v7.28A1.56 1.56 0 0 0 31.3 34h7c1.22 0 .95-1-.02-1.22ZM30 46.86c-1.54-1-3.45-1.07-5.05-2C18 41.31 16.56 33 15.51 26c-.31-1.74-.38-2.87-2.4-3v24c0 2.16.74 2.91 2.9 2.91h15.71A3.49 3.49 0 0 0 30 46.86Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37 24.84a1.78 1.78 0 0 0-1 3.29v1.26c0 .67.29 1.22 1 1.22.67 0 1-.55 1-1.22v-1.26a1.78 1.78 0 0 0-1-3.29Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41.9 17.91h4a.89.89 0 0 1 .89.89v15.65a.87.87 0 0 1-.48.79l-8.88 4.59a.85.85 0 0 1-.82 0l-8.88-4.59a.87.87 0 0 1-.48-.79V18.8a.89.89 0 0 1 .89-.89h4.07M34.33 17.91h5.39"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "29.96",
          y: "22",
          width: "14.09",
          height: "12.03",
          rx: "1.89"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.08 22v-3a5.05 5.05 0 0 1 5-5.07 5 5 0 0 1 4.9 5V22h-2.07v-3a2.92 2.92 0 0 0-2.73-3 2.87 2.87 0 0 0-3 2.87V22Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37 43v4a3 3 0 0 1-3 3H16a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v2M24 8h2M22 48h6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37 24.84a1.78 1.78 0 0 0-1 3.29v1.26c0 .67.29 1.22 1 1.22.67 0 1-.55 1-1.22v-1.26a1.78 1.78 0 0 0-1-3.29Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_DeviceProtect56 = (DeviceProtect56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Gift104.tsx


var Gift104_excluded = ["className"];
function Gift104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Gift104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Gift104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Gift104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Gift104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Gift104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Gift104_objectSpread(Gift104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.79 48.56c1.28 0 4.82-.65 5.74.25a2.54 2.54 0 0 1 .51.85c2.21 5.24 4.29 10.56 7.16 15.46 3.47 5.94 8.51 9.7 13.31 14.36a25.67 25.67 0 0 1 3.77 4 14 14 0 0 1 2.09 4.85h-29a3.61 3.61 0 0 1-3.62-3.61Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M51.99 39.3v48.99M51.94 37.36c-.06-.22-1.08-.3-1.27-.33a62.4 62.4 0 0 1-10-2.73c-5.24-1.87-12.27-4.61-14.91-9.95-2.92-5.93 2.47-11 8.21-9.54C40.58 16.51 45 24 48.07 29.5c.71 1.27 1.38 2.57 2 3.88a23.93 23.93 0 0 1 1.87 3.98ZM52 37.36c.06-.22 1.08-.3 1.26-.33a61.84 61.84 0 0 0 10-2.73c5.24-1.87 12.28-4.61 14.91-9.95 2.93-5.93-2.46-11-8.2-9.54-6.61 1.7-11.06 9.19-14.11 14.69-.7 1.27-1.37 2.57-2 3.88A24.72 24.72 0 0 0 52 37.36ZM86.29 48.47V85.7a3.15 3.15 0 0 1-3.14 3.14h-62.3a3.15 3.15 0 0 1-3.14-3.14V48.47"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "14.02",
          y: "38.47",
          width: "75.96",
          height: "9.02",
          rx: "1"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Gift104 = (Gift104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Gift56.tsx


var Gift56_excluded = ["className"];
function Gift56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Gift56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Gift56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Gift56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Gift56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Gift56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Gift56_objectSpread(Gift56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M9.58 26.15c.69 0 2.59-.35 3.09.13a1.53 1.53 0 0 1 .28.46 71.46 71.46 0 0 0 3.85 8.33c1.87 3.19 4.58 5.22 7.17 7.73a14.1 14.1 0 0 1 2 2.13 7.43 7.43 0 0 1 1.12 2.61H11.53a1.94 1.94 0 0 1-1.95-1.94Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.99 21.16v26.38M28 20.12c0-.12-.58-.17-.68-.18a33.4 33.4 0 0 1-5.4-1.47c-2.82-1-6.61-2.48-8-5.36-1.63-3.19 1.27-5.92 4.36-5.11 3.57.91 6 4.94 7.61 7.9.38.69.74 1.39 1.08 2.09A13.51 13.51 0 0 1 28 20.12ZM28 20.12c0-.12.58-.17.68-.18a34 34 0 0 0 5.4-1.47c2.82-1 6.61-2.48 8-5.36 1.6-3.19-1.3-5.92-4.4-5.11-3.56.91-6 4.94-7.6 7.9-.38.69-.74 1.39-1.09 2.09a13.46 13.46 0 0 0-.99 2.13ZM46.51 25.85v18.88a3.14 3.14 0 0 1-3.13 3.14H12.62a3.14 3.14 0 0 1-3.13-3.14V25.85"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "7.46",
          y: "20.67",
          width: "41.09",
          height: "4.96",
          rx: "1"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Gift56 = (Gift56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/InternationalCalls104.tsx


var InternationalCalls104_excluded = ["className"];
function InternationalCalls104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function InternationalCalls104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InternationalCalls104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InternationalCalls104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function InternationalCalls104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternationalCalls104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", InternationalCalls104_objectSpread(InternationalCalls104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M63.17 82.29a8.2 8.2 0 0 1 2 .25c1 .27 1.69 1.17 2.71 1.48a13.26 13.26 0 0 0 1.41.37 15 15 0 0 0 4 .27 16.22 16.22 0 0 0 10.56-5.31 26.94 26.94 0 0 0 3.41-4.54s-5.93 15.54-17.42 14.94c0 0-9.51.54-6.67-7.46ZM18.67 30.61S12.42 71.82 55.9 87.78c0 0-43.74 7.55-43-43.63a66.82 66.82 0 0 1 5.77-13.54Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M56.43 14.09c-3.38 2.18-6.88 4.15-10.19 6.46-5.2 3.62.27 3.75-1.3 8.91S41 38.37 36.51 40c-2.42.9-9.95 2-10.34 4.59-.53 3.53 2.07 7.57 2.76 11 .76 3.74 1.35 8.16 4.79 9.94a109.35 109.35 0 0 0 12.3 5c2.12.79 1.13 6.54 1.13 8.64M66.93 17.86a9.42 9.42 0 0 0 2.91 9.28"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M56.49 87A37.14 37.14 0 1 1 83.7 34.83"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M76.18 88.72c3.93-2 9.33-6.92 13.2-19 7.23-22.52-4.12-28.27-4.6-28.5l-3.39-1.09a4.7 4.7 0 0 0-5.71 2.93L73.45 50a4.51 4.51 0 0 0 2.88 5.69l3.17 1.1a42.16 42.16 0 0 1-1.7 8.67l-.32 1a38.92 38.92 0 0 1-3.67 8l-3.12-1A4.7 4.7 0 0 0 65 76.47l-2.23 6.94a4.59 4.59 0 0 0 .27 3.53 4.77 4.77 0 0 0 2.71 2.27s6.55 1.48 10.39-.49Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_InternationalCalls104 = (InternationalCalls104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/InternationalCalls56.tsx


var InternationalCalls56_excluded = ["className"];
function InternationalCalls56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function InternationalCalls56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InternationalCalls56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InternationalCalls56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function InternationalCalls56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternationalCalls56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", InternationalCalls56_objectSpread(InternationalCalls56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34 44.31a4.75 4.75 0 0 1 1.07.14c.54.14.91.63 1.46.79a6.53 6.53 0 0 0 .76.2 8.25 8.25 0 0 0 2.16.15 8.74 8.74 0 0 0 5.69-2.86A15.08 15.08 0 0 0 47 40.28s-3.2 8.37-9.38 8c-.01.05-5.13.34-3.62-3.97ZM10.06 16.48s-3.37 22.19 20 30.79c0 0-23.55 4.06-23.18-23.49a36.16 36.16 0 0 1 3.18-7.3Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.38 7.59c-1.82 1.17-3.7 2.23-5.48 3.48-2.8 1.95.15 2-.7 4.79s-2.11 4.8-4.54 5.7c-1.31.49-5.36 1.1-5.57 2.47-.28 1.9 1.12 4.08 1.49 5.91.41 2 .72 4.39 2.58 5.35A60.86 60.86 0 0 0 24.78 38c1.14.42.61 3.52.61 4.65M36 9.61a5.08 5.08 0 0 0 1.57 5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.42 46.86a20 20 0 1 1 14.65-28.11"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41 47.77c2.12-1.08 5-3.73 7.11-10.21 3.89-12.12-2.2-15.22-2.46-15.34l-1.83-.59a2.53 2.53 0 0 0-3.07 1.58l-1.2 3.73A2.43 2.43 0 0 0 41.1 30l1.7.58a22.74 22.74 0 0 1-.91 4.68l-.17.53a21.15 21.15 0 0 1-2 4.33l-1.68-.54a2.53 2.53 0 0 0-3.04 1.6l-1.2 3.73a2.47 2.47 0 0 0 .15 1.9A2.59 2.59 0 0 0 35.42 48s3.53.8 5.6-.27Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_InternationalCalls56 = (InternationalCalls56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/InternationalMobileCalls104.tsx


var InternationalMobileCalls104_excluded = ["className"];
function InternationalMobileCalls104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function InternationalMobileCalls104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InternationalMobileCalls104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InternationalMobileCalls104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function InternationalMobileCalls104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternationalMobileCalls104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", InternationalMobileCalls104_objectSpread(InternationalMobileCalls104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M83.39 88.1c-1.84-1.17-4.11-1.28-6-2.33-8.19-4.29-9.94-14.16-11.2-22.49-.36-2.08-.45-3.42-2.86-3.61v28.6c0 2.58.87 3.47 3.45 3.47h18.7a4.16 4.16 0 0 0-2.09-3.64ZM18.64 31.11s-4.56 41.48 39.58 55.65c0 0-43.44 9.35-44.84-41.87a67.31 67.31 0 0 1 5.26-13.78Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "63.12",
          y: "39.41",
          width: "28.72",
          height: "52.44",
          rx: "4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M76.28 43.65h2.39M73.9 87.61h7.15M56.71 14c-3.38 2.18-6.87 4.15-10.19 6.46-5.2 3.62.28 3.75-1.3 8.91s-3.91 8.86-8.42 10.53c-2.43.9-10 2-10.35 4.59-.53 3.52 2.08 7.57 2.77 11 .75 3.75 1.34 8.17 4.78 10a110.63 110.63 0 0 0 12.31 5c2.11.78 1.12 6.54 1.12 8.64M67.21 17.71A9.43 9.43 0 0 0 70.13 27"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M58.87 86.18a37.14 37.14 0 1 1 24.4-53.56"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_InternationalMobileCalls104 = (InternationalMobileCalls104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/InternationalMobileCalls56.tsx


var InternationalMobileCalls56_excluded = ["className"];
function InternationalMobileCalls56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function InternationalMobileCalls56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InternationalMobileCalls56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InternationalMobileCalls56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function InternationalMobileCalls56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternationalMobileCalls56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", InternationalMobileCalls56_objectSpread(InternationalMobileCalls56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.9 47.44c-1-.63-2.21-.69-3.24-1.25-4.42-2.31-5.36-7.63-6-12.12-.2-1.11-.25-1.84-1.55-1.94v15.4c0 1.39.48 1.87 1.86 1.87H46a2.25 2.25 0 0 0-1.1-1.96ZM10 16.75s-2.46 22.33 21.31 30c0 0-23.39 5-24.14-22.55A36 36 0 0 1 10 16.75Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "33.99",
          y: "21.22",
          width: "15.46",
          height: "28.24",
          rx: "1.93"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41.08 23.5h1.28M39.79 47.17h3.85M30.54 7.51c-1.82 1.18-3.7 2.24-5.49 3.48-2.8 1.95.15 2-.7 4.8s-2.11 4.79-4.54 5.69c-1.3.49-5.36 1.1-5.57 2.48-.28 1.89 1.12 4.07 1.49 5.9.41 2 .72 4.4 2.58 5.35a57.09 57.09 0 0 0 6.62 2.7c1.14.43.61 3.53.61 4.66M36.19 9.54a5.08 5.08 0 0 0 1.57 5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.7 46.41a20 20 0 1 1 13.14-28.85"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_InternationalMobileCalls56 = (InternationalMobileCalls56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Internet104.tsx


var Internet104_excluded = ["className"];
function Internet104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Internet104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Internet104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Internet104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Internet104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Internet104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Internet104_objectSpread(Internet104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M16.3 53.7c1.7 2.7 2.3 5.7 4 8.9C26.5 74.5 35.1 80.9 50 80.9c3.1 0 7.5.3 8.2 3.2l-.3-1.1H18.4c-8 0-6.8 1.2-6.8-6.8V50.8c2.2-.1 3.5 1.1 4.7 2.9z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M54.8 73C44.5 73 36 64.6 36 54.3c0-4.3 1.5-8.5 4.2-11.9-8.1 6.5-9.4 18.3-2.9 26.4s18.3 9.4 26.4 2.9c1.1-.8 2-1.8 2.9-2.9-3.3 2.7-7.5 4.2-11.8 4.2"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "16.6",
          cy: "25",
          r: "1.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "21.6",
          cy: "25",
          r: "1.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "26.6",
          cy: "25",
          r: "1.6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M70.8 57c0 10.4-8.4 18.8-18.8 18.8S33.2 67.4 33.2 57 41.6 38.2 52 38.2 70.8 46.6 70.8 57z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45.8 74.7c-1.4-2.2-2.6-4.5-3.7-6.9-.1-.1-.1-.2-.1-.4-1.2-3.4-1.9-6.9-2-10.5-.2-6.1 1.4-12.2 4.7-17.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M66.6 45.3c-1.3.6-2.7 1.2-4.1 1.7-3.4 1.1-7 1.6-10.6 1.5-3.6-.1-7.1-.8-10.4-2.1-1.3-.5-2.5-1.1-3.7-1.7"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.9 69.4c1.3-.7 2.7-1.4 4.1-1.9 3.2-1.2 6.6-1.9 10-1.9 3.4-.1 6.9.4 10.2 1.4 1.5.5 3 1.1 4.5 1.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M58.2 74.7c1.5-2.3 2.8-4.8 3.8-7.4.1-.1.1-.3.1-.4 1.1-3.2 1.7-6.6 1.8-10 .1-3.4-.4-6.8-1.4-10.1-.8-2.6-1.9-5-3.3-7.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M52 75.8V38.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M70.8 57H33.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M14 20h76c1.7 0 3 1.3 3 3v58c0 1.7-1.3 3-3 3H14c-1.7 0-3-1.3-3-3V23c0-1.7 1.3-3 3-3zM11 30h82"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Internet104 = (Internet104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Internet56.tsx


var Internet56_excluded = ["className"];
function Internet56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Internet56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Internet56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Internet56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Internet56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Internet56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Internet56_objectSpread(Internet56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31 45a20 20 0 0 1-15.56-32.56 20 20 0 1 0 28.12 28.12A20 20 0 0 1 31 45"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48 28A20 20 0 1 1 28 8a20 20 0 0 1 20 20Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21.42 46.89a65 65 0 0 1-3.91-7.33 2.08 2.08 0 0 1-.15-.4A35.69 35.69 0 0 1 15.29 28a33.29 33.29 0 0 1 1.64-11.33 32.83 32.83 0 0 1 3.38-7.14"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.6 15.49a34.23 34.23 0 0 1-4.35 1.78A33.09 33.09 0 0 1 28 18.89a32.83 32.83 0 0 1-11.07-2.22 28.49 28.49 0 0 1-4-1.85"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M13 41.18a29.56 29.56 0 0 1 4.4-2 32.93 32.93 0 0 1 10.64-2 33.27 33.27 0 0 1 10.8 1.42 32.4 32.4 0 0 1 4.76 1.91"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.6 46.87A50.89 50.89 0 0 0 38.69 39c.06-.15.09-.27.15-.42A36.2 36.2 0 0 0 40.71 28a32.85 32.85 0 0 0-1.46-10.73 31.52 31.52 0 0 0-3.56-7.74"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28 48V8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48 28H8"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Internet56 = (Internet56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Landline104.tsx


var Landline104_excluded = ["className"];
function Landline104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Landline104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Landline104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Landline104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Landline104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Landline104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Landline104_objectSpread(Landline104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M59.62 39a10.69 10.69 0 0 1-7.52-6.39L49.62 24v15.76A2.24 2.24 0 0 0 51.86 42h18.76ZM41.31 17.41h3.06v71.12h-3.06zM32.64 89.68c-12.54-3.66-12-14-12-14s-1-46.21-1-51.45-3.16-11.76-3.16-11.76v5.34a2.19 2.19 0 0 0-1.29-.42h-2a2.19 2.19 0 0 0-2.2 2.2v66.74a2.2 2.2 0 0 0 2.2 2.2h2a2.19 2.19 0 0 0 1.52-.53c.3 5.57 4.1 4.71 4.1 4.71h13.9a4.08 4.08 0 0 0-2.07-3.03Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M16.52 89.16h-.85A4.67 4.67 0 0 1 11 84.49v-63.1a4.67 4.67 0 0 1 4.67-4.67h.58M41.31 16.72h47A4.67 4.67 0 0 1 93 21.39v63.1a4.67 4.67 0 0 1-4.67 4.67h-47"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "49.14",
          y: "24.34",
          width: "36.23",
          height: "18.03",
          rx: "2.24"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "16.52",
          y: "11",
          width: "24.79",
          height: "81.98",
          rx: "3.85"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41.31 89.06a3.85 3.85 0 0 1-3.84 3.85H20.36a3.85 3.85 0 0 1-3.84-3.85V14.84A3.84 3.84 0 0 1 20.36 11h17.11a3.84 3.84 0 0 1 3.84 3.84v74.22"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "49.14",
          y: "49.13",
          width: "9.69",
          height: "7.63",
          rx: "1.45"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "62.41",
          y: "49.13",
          width: "9.69",
          height: "7.63",
          rx: "1.45"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "75.68",
          y: "49.13",
          width: "9.69",
          height: "7.63",
          rx: "1.45"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "49.3",
          y: "62.47",
          width: "9.69",
          height: "7.63",
          rx: "1.45"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "62.57",
          y: "62.47",
          width: "9.69",
          height: "7.63",
          rx: "1.45"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "75.84",
          y: "62.47",
          width: "9.69",
          height: "7.63",
          rx: "1.45"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "49.3",
          y: "75.82",
          width: "9.69",
          height: "7.63",
          rx: "1.45"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "62.57",
          y: "75.82",
          width: "9.69",
          height: "7.63",
          rx: "1.45"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "75.84",
          y: "75.82",
          width: "9.69",
          height: "7.63",
          rx: "1.45"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Landline104 = (Landline104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Landline56.tsx


var Landline56_excluded = ["className"];
function Landline56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Landline56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Landline56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Landline56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Landline56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Landline56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Landline56_objectSpread(Landline56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.82 21.2a5.35 5.35 0 0 1-3.76-3.2l-1.24-4.3v7.88a1.12 1.12 0 0 0 1.12 1.12h9.38ZM22.39 9.86H24v37.3h-1.61zM17.85 47.77c-6.58-1.92-6.28-7.33-6.28-7.33s-.52-24.24-.52-27a17.36 17.36 0 0 0-1.66-6.16v2.83a1.09 1.09 0 0 0-.67-.25H7.65A1.16 1.16 0 0 0 6.5 11v35a1.16 1.16 0 0 0 1.15 1.16h1.08a1.11 1.11 0 0 0 .76-.31c.16 2.93 2.15 2.48 2.15 2.48h7.29a2.12 2.12 0 0 0-1.08-1.56Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.77 9.5h24.28A2.45 2.45 0 0 1 49.5 12v33.1a2.45 2.45 0 0 1-2.45 2.45H22.39M9.39 47.5H9a2.45 2.45 0 0 1-2.5-2.45V12A2.45 2.45 0 0 1 9 9.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "26.5",
          y: "13.5",
          width: "19",
          height: "9.46",
          rx: "1.18"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "9.39",
          y: "6.5",
          width: "13",
          height: "43",
          rx: "2.02"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "9.39",
          y: "6.5",
          width: "13",
          height: "42.96",
          rx: "2.02"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "26.5",
          y: "26.5",
          width: "5.08",
          height: "4",
          rx: ".76"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "33.46",
          y: "26.5",
          width: "5.08",
          height: "4",
          rx: ".76"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "40.42",
          y: "26.5",
          width: "5.08",
          height: "4",
          rx: ".76"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "26.58",
          y: "33.5",
          width: "5.08",
          height: "4",
          rx: ".76"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "33.54",
          y: "33.5",
          width: "5.08",
          height: "4",
          rx: ".76"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "40.5",
          y: "33.5",
          width: "5.08",
          height: "4",
          rx: ".76"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "26.58",
          y: "40.5",
          width: "5.08",
          height: "4",
          rx: ".76"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "33.54",
          y: "40.5",
          width: "5.08",
          height: "4",
          rx: ".76"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "40.5",
          y: "40.5",
          width: "5.08",
          height: "4",
          rx: ".76"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Landline56 = (Landline56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Legal104.tsx


var Legal104_excluded = ["className"];
function Legal104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Legal104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Legal104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Legal104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Legal104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Legal104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Legal104_objectSpread(Legal104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M69.48 53.46c0-.7 8.62 10.47 26.41 5.18 0 0-.58 8-12.83 8.27 0 0-12.93-.1-13.58-13.45ZM7.27 60.82c0-.63 8.2 9.92 26.14 5.83 0 0-.88 7.25-13.11 7 0 .02-12.88-.65-13.03-12.83Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M52 29.22v61.7M40.06 90.92h23.77M58 23.25a6 6 0 1 1-6-6 6 6 0 0 1 6 6ZM7 59.74l14.32-32.72 14.26 32.72M45.57 23.25l-30.89 3.78M89.32 17.93 58.43 21.7M35.64 59.75a14.32 14.32 0 0 1-28.64 0ZM97 52.58 82.68 19.86 68.42 52.58M68.36 52.59a14.32 14.32 0 1 0 28.64 0Z"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Legal104 = (Legal104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Legal56.tsx


var Legal56_excluded = ["className"];
function Legal56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Legal56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Legal56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Legal56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Legal56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Legal56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Legal56_objectSpread(Legal56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36.93 28.8c0-.35 4.4 5.35 13.49 2.65 0 0-.3 4.07-6.55 4.23 0 0-6.61-.06-6.94-6.88ZM5.15 32.57c0-.33 4.19 5.06 13.35 3 0 0-.45 3.7-6.69 3.59 0-.03-6.58-.36-6.66-6.59Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28 16.42v31.52M21.9 47.94h12.14M31.05 13.37a3.05 3.05 0 1 1-3.05-3 3 3 0 0 1 3.05 3ZM5.02 32.01l7.31-16.71 7.28 16.71M24.72 13.37 8.94 15.3M47.06 10.65l-15.78 1.93"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19.64 32A7.32 7.32 0 0 1 5 32ZM50.98 28.36l-7.31-16.72-7.29 16.72M36.36 28.36a7.32 7.32 0 0 0 14.63 0Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Legal56 = (Legal56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/MBBRoaming104.tsx


var MBBRoaming104_excluded = ["className"];
function MBBRoaming104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function MBBRoaming104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MBBRoaming104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MBBRoaming104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function MBBRoaming104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MBBRoaming104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", MBBRoaming104_objectSpread(MBBRoaming104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.07 83A100.64 100.64 0 0 1 31 80.93a19.53 19.53 0 0 1-10.31-5.64 13.78 13.78 0 0 1-2.44-5.35c-.51-2-.84-4.08-1.5-6-.55-1.58-1.43-4-3.34-4.39-.82-.16-2.7-.22-2.7 1v24.63c0 1.55 1.6 7.32 6.64 7.32h47.33c.95 0 .58-2.79.45-3.18-2-4.27-7.81-3.9-11.72-4.92-3.35-.58-6.91-.93-10.34-1.4Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47.38 20.77H48a8.19 8.19 0 0 1 3.18.86c-.45 2.18-.9 4.37-1.33 6.54h2.85a1.28 1.28 0 0 0 .55 0 1 1 0 0 0 .43-.45 3.53 3.53 0 0 0 .13-.63c.2-1.07.38-2.15.55-3.22a13.57 13.57 0 0 1 3.11 3.91 7.51 7.51 0 0 1 .53 1.54 4 4 0 0 1 .12 1.29 2.58 2.58 0 0 1-.41 1.13 2.29 2.29 0 0 1-.45.43 3.22 3.22 0 0 1-2 .49 8.71 8.71 0 0 1-2.13-.51 13.76 13.76 0 0 1-4.41-2.79 12.16 12.16 0 0 1-2.83-3.63 6.8 6.8 0 0 1-.63-2.07 3.35 3.35 0 0 1 0-1 2.21 2.21 0 0 1 .57-1.05 2.49 2.49 0 0 1 1.55-.84Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.82 11h66.37A7.81 7.81 0 0 1 93 18.82v66.36A7.81 7.81 0 0 1 85.19 93H18.82A7.8 7.8 0 0 1 11 85.18V18.82A7.8 7.8 0 0 1 18.82 11Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M58.84 56.22v5.54M52.98 58.46v3.12M64.7 52.23v9.35M70.55 50.05v11.71"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28.58 38.34h46.85a3.9 3.9 0 0 1 3.91 3.9v27.33a3.91 3.91 0 0 1-3.91 3.9H28.58a3.91 3.91 0 0 1-3.9-3.9V42.24a3.9 3.9 0 0 1 3.9-3.9Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M51.68 81.28a3.59 3.59 0 1 0 3.59 3.57 3.58 3.58 0 0 0-3.59-3.57Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M56.3 16.86h2.52c-.14.73-.25 1.43-.39 2.15a.91.91 0 0 1-.47.64 1 1 0 0 1-.58.12H55c-.23 1.31-.44 2.64-.66 3.91s-.37 2.14-.55 3.24a3.3 3.3 0 0 1-.15.62.82.82 0 0 1-.41.43 1.37 1.37 0 0 1-.57 0H49.8c.45-2.19.9-4.37 1.33-6.54.12-.6.23-1.19.37-1.79H48c.15-.71.27-1.43.43-2.13a1 1 0 0 1 .35-.59 1.07 1.07 0 0 1 .6-.17h6.92Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.63 52.47a1.38 1.38 0 0 0-.39-1 1.43 1.43 0 0 0-1-.41 5.62 5.62 0 0 0-3 2L35 52a.62.62 0 0 0-.49.16l-1.33 1.32a.63.63 0 0 0-.14.51.57.57 0 0 0 .32.43L37.47 56 36 57.56l-1.52-.39a.59.59 0 0 0-.55.14l-.88.9a.54.54 0 0 0 .1.84l2.09 1.34 1.33 2.09a.54.54 0 0 0 .41.26.64.64 0 0 0 .39-.16l1-.82a.55.55 0 0 0 .14-.55L38 59.75l1.58-1.46 1.56 4.08a.58.58 0 0 0 .92.19l1.35-1.33a.61.61 0 0 0 .15-.48l-.89-5.2c.55-.55 1.92-1.93 1.96-3.08Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MBBRoaming104 = (MBBRoaming104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/MBBRoaming56.tsx


var MBBRoaming56_excluded = ["className"];
function MBBRoaming56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function MBBRoaming56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MBBRoaming56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MBBRoaming56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function MBBRoaming56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MBBRoaming56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", MBBRoaming56_objectSpread(MBBRoaming56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.42 43.89a51.82 51.82 0 0 1-6.2-1.07 10 10 0 0 1-5.28-2.89 7.12 7.12 0 0 1-1.25-2.74c-.26-1-.43-2.09-.77-3.1-.28-.81-.73-2.07-1.71-2.25-.42-.08-1.38-.11-1.38.52V45c0 .79.82 3.75 3.4 3.75h24.26c.49 0 .3-1.43.23-1.63-1-2.19-4-2-6-2.52-1.72-.3-3.54-.48-5.3-.71Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M25.63 12h.29a4.21 4.21 0 0 1 1.63.44c-.23 1.12-.46 2.24-.68 3.35h1.46a.66.66 0 0 0 .28 0 .45.45 0 0 0 .22-.23 1.65 1.65 0 0 0 .07-.32c.1-.55.19-1.1.28-1.65a6.86 6.86 0 0 1 1.59 2 3.78 3.78 0 0 1 .3.79 2.11 2.11 0 0 1 .06.66 1.2 1.2 0 0 1-.21.58.8.8 0 0 1-.23.22 1.62 1.62 0 0 1-1.05.25 4.56 4.56 0 0 1-1.09-.26 6.94 6.94 0 0 1-2.26-1.43 6.11 6.11 0 0 1-1.45-1.86 3.26 3.26 0 0 1-.32-1.06 1.46 1.46 0 0 1 0-.51 1.06 1.06 0 0 1 .29-.54 1.29 1.29 0 0 1 .82-.43Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M11 7h34a4 4 0 0 1 4 4v34a4 4 0 0 1-4 4H11a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.5 30.16V33M28.5 31.31v1.6M34.5 28.12v4.79M37.5 27v6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M16 21h24a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H16a2 2 0 0 1-2-2V23a2 2 0 0 1 2-2Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.83 43a1.83 1.83 0 1 0 1.3.53 1.83 1.83 0 0 0-1.3-.53Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.2 10h1.29c-.07.37-.13.73-.2 1.1a.48.48 0 0 1-.24.33.52.52 0 0 1-.3.06h-1.22c-.12.67-.23 1.35-.34 2s-.19 1.1-.28 1.66a1.67 1.67 0 0 1-.08.32.38.38 0 0 1-.21.22.71.71 0 0 1-.29 0h-1.46c.23-1.12.46-2.24.68-3.35.06-.31.12-.61.19-.92h-1.81c.08-.36.14-.73.22-1.09a.49.49 0 0 1 .18-.3.56.56 0 0 1 .31-.09h3.56Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.22 28.24a.69.69 0 0 0-.2-.53.7.7 0 0 0-.53-.21 2.91 2.91 0 0 0-1.54 1l-2.66-.5a.33.33 0 0 0-.25.08l-.68.68a.31.31 0 0 0-.07.26.27.27 0 0 0 .16.22l2.1.8-.77.81-.78-.2a.29.29 0 0 0-.28.07l-.45.46a.27.27 0 0 0 .05.43l1.07.69.68 1.07a.3.3 0 0 0 .21.13.32.32 0 0 0 .2-.08L21 33a.29.29 0 0 0 .07-.28l-.23-.72.81-.75.8 2.09a.3.3 0 0 0 .21.17.31.31 0 0 0 .26-.07l.69-.68a.33.33 0 0 0 .08-.25l-.46-2.66c.27-.32.97-1.02.99-1.61Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MBBRoaming56 = (MBBRoaming56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/MobileAccelerator104.tsx


var MobileAccelerator104_excluded = ["className"];
function MobileAccelerator104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function MobileAccelerator104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MobileAccelerator104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MobileAccelerator104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function MobileAccelerator104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MobileAccelerator104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", MobileAccelerator104_objectSpread(MobileAccelerator104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M55.64 87c-2.87-1.83-6.4-2-9.38-3.62-12.78-6.67-15.5-22.05-17.46-35.03-.57-3.24-.7-5.33-4.46-5.64v44.58c0 4 1.37 5.4 5.38 5.41H58.9c.19-2.29-1.33-4.44-3.26-5.7Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M52.45 49c-.64 2.16-4.43 1.64-3.78-.55 3.27-10.93 12.55-16.65 24.66-16.83 2.41 0 2.84 3.47.39 3.51-10.19.1-18.45 4.37-21.27 13.87Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M65.35 50.42a3.76 3.76 0 0 0 3.77 3.76 3.76 3.76 0 0 0 3.77-3.76 3.77 3.77 0 0 0-3.77-3.77 3.77 3.77 0 0 0-3.77 3.77Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M68.71 65v22.29a5.57 5.57 0 0 1-5.57 5.57H29.71a5.58 5.58 0 0 1-5.57-5.57V16.71a5.58 5.58 0 0 1 5.57-5.57h33.43a5.57 5.57 0 0 1 5.57 5.57v5.58M44.57 14.86h3.72M40.86 89.14H52"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M51.23 53h-3.47a21.36 21.36 0 0 1 42.71-.18h-3.53"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m54.08 38.05 2.32 2.12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M69.03 31.57v3.57"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m84.01 38.05-2.34 2.12"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m86.45 46-16.72 6.85a2.51 2.51 0 0 1-1.51-4.78l.28-.07Z"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MobileAccelerator104 = (MobileAccelerator104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/MobileAccelerator56.tsx


var MobileAccelerator56_excluded = ["className"];
function MobileAccelerator56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function MobileAccelerator56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MobileAccelerator56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MobileAccelerator56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function MobileAccelerator56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MobileAccelerator56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", MobileAccelerator56_objectSpread(MobileAccelerator56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30 46.86c-1.54-1-3.44-1.07-5.05-2C18 41.31 16.55 33 15.5 26c-.3-1.74-.38-2.87-2.4-3v24c0 2.16.73 2.91 2.89 2.91h15.72A3.49 3.49 0 0 0 30 46.86Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28.24 26.36c-.35 1.16-2.39.88-2-.3C28 20.18 33 17.1 39.48 17c1.3 0 1.53 1.87.21 1.89-5.49.11-9.94 2.38-11.45 7.47Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.18 27.15a2 2 0 0 0 2 2 2 2 0 0 0 2-2 2 2 0 0 0-2-2 2 2 0 0 0-2 2Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37 35v12a3 3 0 0 1-3 3H16a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v3M23.99 8h2M21.99 48h6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.58 28.55h-1.87a11.5 11.5 0 1 1 23-.1h-1.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m29.12 20.49 1.24 1.14"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.17 17v1.92"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m45.23 20.49-1.26 1.14"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m46.54 24.79-9 3.67a1.35 1.35 0 0 1-.81-2.58h.15Z"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MobileAccelerator56 = (MobileAccelerator56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/MoveHouse104.tsx


var MoveHouse104_excluded = ["className"];
function MoveHouse104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function MoveHouse104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MoveHouse104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MoveHouse104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function MoveHouse104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MoveHouse104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", MoveHouse104_objectSpread(MoveHouse104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m35 38.29 4.56 12.52 12.64-4.6S37.24 44.55 35 38.29ZM66.21 75.5l-8.8 3.2A9.38 9.38 0 0 0 47 74.46l-3.41-9.37c3.03 8.22 22.62 10.41 22.62 10.41Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m31.47 28.19 25.46-9.27 7.87 21.62"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m48.3 22.36 2.08 5.68-5.12.48-4.22 2.92-2.07-5.69M39.53 50l32.94-11.99 11.37 31.24"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m61.14 42.52 2.72 7.47-6.72.62-5.54 3.84-2.72-7.47M57.49 78.85 90.17 67a2.43 2.43 0 0 1 3.12 1.46v.06a2.43 2.43 0 0 1-1.46 3.12l-33.08 12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "49.37",
          cy: "83.56",
          r: "9.4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M54.37 85.87A5.75 5.75 0 1 1 43.94 81M47.73 73.81 29 22.47A5.35 5.35 0 0 0 24 19a5.57 5.57 0 0 0-1.84.32l-11.49 4.14a2.46 2.46 0 0 0-1.46 3.19 2.45 2.45 0 0 0 3.14 1.44l11.91-4.33 19 52.05"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MoveHouse104 = (MoveHouse104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/MoveHouse56.tsx


var MoveHouse56_excluded = ["className"];
function MoveHouse56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function MoveHouse56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MoveHouse56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MoveHouse56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function MoveHouse56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MoveHouse56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", MoveHouse56_objectSpread(MoveHouse56_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m17.5 18.8 3.4 9.3 9.4-3.4c0-.1-11.1-1.3-12.8-5.9zM41.8 39.2l-8.9 3.2c0-.1-.1-.2-.1-.3-1.1-3.1-4.5-4.6-7.6-3.5-.1.1-.3.1-.4.2l-3.2-8.9c2.6 7.3 20.2 9.3 20.2 9.3z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m16.7 16.1 13.7-5L34.7 23"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m21.2 27.9 17.6-6.4 5.9 16M32.8 42.1l-.1-.2 16.7-6.1c.8-.3 1.7.1 2 .9v.1c.3.8-.1 1.7-.9 2L33 45.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29.2 49.6c-3.1 1.1-6.4-.4-7.6-3.5-.9-2.4-.1-5.1 1.9-6.7.3-.2.5-.4.9-.6.2-.1.5-.3.8-.3 3.1-.9 6.4.9 7.3 4 .9 2.9-.5 6-3.3 7.1z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m24.9 38.5-9.8-26.3c-.4-1-1.3-1.7-2.4-1.7-.3 0-.6.1-.9.1l-5.4 2c-.6.2-.9.9-.7 1.5.2.4.6.7 1.1.7.1 0 .3 0 .4-.1l5.6-2 10.1 27"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MoveHouse56 = (MoveHouse56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/NBN104.tsx


var NBN104_excluded = ["className"];
function NBN104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function NBN104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NBN104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NBN104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function NBN104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NBN104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", NBN104_objectSpread(NBN104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M58.4 85.6c-22.1 0-40-18-40-40 0-9 3.1-17.8 8.7-24.8C9.7 34.4 6.8 59.6 20.5 76.9s38.8 20.3 56.2 6.6c2.5-1.9 4.7-4.2 6.6-6.6-7.1 5.7-15.9 8.7-24.9 8.7z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "52",
          cy: "52",
          r: "40.9"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36.4 61.5v-9.9c0-1.9-.6-3-2.7-3-1.3 0-2.4.9-2.8 2.1-.5 1.4-.6 2.9-.5 4.3v6.6h-3.9V45.3h3.4l.3 2.1c1-1.6 2.8-2.5 4.8-2.4 2.9-.1 5.4 2.2 5.5 5.1V61.5h-4.1z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M56.9 60.5c-1.1.9-2.5 1.4-3.9 1.4-1.8.1-3.5-.7-4.5-2.1l-.2 1.7h-3.4V39.1h3.9v7.5c1.1-1.1 2.7-1.6 4.2-1.5 1.4 0 2.8.4 4 1.3 2 1.8 3.1 4.5 2.9 7.2.1 2.6-1 5.2-3 6.9zm-2-11c-.6-.8-1.6-1.3-2.6-1.3-3 0-3.7 2.9-3.7 5.2-.2 1.6.4 3.2 1.4 4.4 1.4 1.2 3.6 1.1 4.8-.4 0 0 0-.1.1-.1.7-1.2 1.1-2.6 1-3.9.1-1.4-.3-2.7-1-3.9z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M73.4 61.5v-9.9c0-1.9-.6-3-2.7-3-1.3 0-2.4.9-2.8 2.1-.5 1.4-.6 2.9-.5 4.3v6.6h-3.9V45.3h3.2l.3 2.1c1.7-2.6 5.2-3.2 7.7-1.5 1.6 1.1 2.5 2.9 2.5 4.8v10.8h-3.8z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NBN104 = (NBN104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/NBN56.tsx


var NBN56_excluded = ["className"];
function NBN56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function NBN56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? NBN56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : NBN56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function NBN56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NBN56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", NBN56_objectSpread(NBN56_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.4 46.1c-11.9 0-21.5-9.6-21.5-21.5 0-4.9 1.6-9.6 4.7-13.4-9.3 7.4-10.8 21-3.3 30.2s21 10.8 30.2 3.3c1.2-1 2.4-2.1 3.3-3.3-3.8 3-8.5 4.7-13.4 4.7z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "stroke",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "28",
          cy: "28",
          r: "22"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19.6 33.1v-5.3c0-1-.3-1.6-1.4-1.6-.7 0-1.3.5-1.5 1.1-.3.7-.3 1.5-.3 2.3v3.5h-2.1v-8.7h1.8l.1 1.1c.6-.9 1.5-1.4 2.6-1.3.8 0 1.6.3 2.2.9.6.6.8 1.4.8 2.2v5.8h-2.2z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.7 32.6c-.6.5-1.3.8-2.1.8-1 0-1.9-.4-2.4-1.2l-.2.9h-1.8V21h2.1v4c.6-.6 1.4-.9 2.3-.9.8 0 1.5.2 2.1.7 1.1 1 1.6 2.4 1.5 3.9.1 1.5-.5 2.9-1.5 3.9zm-1.2-5.9c-.3-.4-.9-.7-1.4-.7-1.6 0-2 1.5-2 2.8-.1.9.2 1.7.8 2.4.8.7 1.9.6 2.6-.2v-.1c.4-.6.6-1.4.5-2.1.1-.8-.1-1.5-.5-2.1z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.5 33.1v-5.3c0-1-.3-1.6-1.4-1.6-.7 0-1.3.5-1.5 1.1-.2.7-.3 1.5-.3 2.3v3.5h-2.1v-8.7H36l.2 1.1c.9-1.4 2.8-1.8 4.2-.8.9.6 1.4 1.6 1.3 2.6v5.8h-2.2z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NBN56 = (NBN56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/News104.tsx


var News104_excluded = ["className"];
function News104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function News104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? News104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : News104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function News104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, News104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", News104_objectSpread(News104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M84.8 81.4c-3.8-1.7-6.6-3.8-6.6-11.3V49.3c.2-2.4-1.5-4.5-3.9-4.8h-1.2v27.9c0 5.2 4.2 9.5 9.4 9.6H25.4 84.7c.1 0 .3-.1.3-.2s0-.3-.2-.4z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M63.9 62.2H20.1c-.5 0-.9-.4-.9-.9s.4-.9.9-.9H64c.5 0 .9.4.9.9s-.4.9-1 .9zM63.9 53.4h-19c-.5 0-.9-.4-.9-.9s.4-.9.9-.9H64c.5 0 .9.4.9.9s-.4.9-1 .9zM63.9 44.5h-19c-.5.1-1-.3-1-.8s.3-1 .8-1H64c.5-.1 1 .3 1 .8s-.3 1-.8 1h-.3zM63.9 35.7h-19c-.5.1-1-.3-1-.8s.3-1 .8-1H64c.5-.1 1 .3 1 .8s-.3 1-.8 1h-.3zM63.9 71.1H20.1c-.5 0-.9-.4-.9-.9s.4-.9.9-.9H64c.5 0 .9.4.9.9s-.4.9-1 .9z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m31.4 41.8-.7 4.8c-.1.6-.6 1.1-1.3 1.1h-3.9l1.6-8.8c-1.4-.7-2.9-1.1-4.5-1.2-1.1-.1-2.2.3-2.9 1.1-.5.6-.7 1.3-.7 2.1 0 2.5 1.9 6 5.3 8.8 2.4 2.2 5.5 3.6 8.7 3.9 1 .1 2.1-.3 2.8-1.1.5-.6.8-1.4.7-2.1.2-2.5-1.8-5.9-5.1-8.6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.6 32.5c-.6 0-1.1.4-1.2 1l-.5 2.9h4.8l-2 11.3h3.9c.6 0 1.2-.4 1.3-1.1l1.7-10.2H36c.6 0 1.1-.4 1.2-1l.5-2.9H24.6z",
        className: "strokeinverted"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M73.2 72.4c0 5.3 4.3 9.6 9.7 9.6h.1c5.3 0 9.7-4.3 9.7-9.7V38"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M83.5 38v34.4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20.1 59.9h43.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.9 51.1h19"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.9 42.3h19"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.9 33.4h19"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20.1 68.8h43.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M73.2 72.4V23.3c0-2.1-1.7-3.9-3.9-3.9h-54c-2.1 0-3.9 1.7-3.9 3.9v49c0 5.3 4.3 9.6 9.6 9.7h61.5c-5.1-.1-9.3-4.4-9.3-9.6z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_News104 = (News104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/News56.tsx


var News56_excluded = ["className"];
function News56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function News56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? News56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : News56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function News56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, News56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", News56_objectSpread(News56_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45.7 43.8c-2-.9-3.5-2.1-3.5-6.1V26.5c.1-1.3-.8-2.4-2.1-2.5h-.6v15c0 2.8 2.2 5.1 5.1 5.2H13.7 45.6c.1 0 .2-.1.2-.1 0-.1 0-.2-.1-.3z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.4 33.5H10.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h23.6c.3 0 .5.2.5.5s-.2.5-.5.5zM34.4 28.7H24.2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h10.3c.3 0 .5.2.5.5-.1.3-.3.5-.6.5zM34.4 24H24.2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h10.3c.3 0 .5.2.5.5-.1.3-.3.5-.6.5zM34.4 19.2H24.2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h10.3c.3 0 .5.2.5.5-.1.3-.3.5-.6.5zM34.4 38.3H10.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h23.6c.3 0 .5.2.5.5 0 .2-.2.5-.5.5z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m16.9 22.5-.4 2.6c0 .3-.3.6-.7.6h-2.1l.9-4.7c-.8-.4-1.6-.6-2.4-.6-.6-.1-1.2.2-1.6.6-.2.3-.4.7-.4 1.1 0 1.4 1 3.2 2.9 4.7 1.3 1.2 2.9 1.9 4.7 2.1.6 0 1.1-.2 1.5-.6.3-.3.4-.7.4-1.1 0-1.4-1-3.2-2.8-4.7"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.3 17.5c-.3 0-.6.2-.7.6l-.3 1.5h2.6l-1.1 6.1h2.1c.3 0 .6-.2.7-.6l.9-5.5h1.8c.4 0 .7-.2.7-.6l.3-1.6-7 .1z",
        className: "strokeinverted"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.4 39c0 2.9 2.3 5.2 5.2 5.2h.1c2.9 0 5.2-2.3 5.2-5.2V20.4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45 20.4V39"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M10.8 32.3h23.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.2 27.5h10.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.2 22.8h10.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.2 18h10.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M10.8 37h23.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.4 39V12.5c0-1.2-.9-2.1-2.1-2.1H8.2c-1.2 0-2.1.9-2.1 2.1V39c0 2.9 2.3 5.2 5.2 5.2h33.1c-2.8-.1-5-2.4-5-5.2z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_News56 = (News56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/OneNumber104.tsx


var OneNumber104_excluded = ["className"];
function OneNumber104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function OneNumber104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? OneNumber104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : OneNumber104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function OneNumber104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, OneNumber104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", OneNumber104_objectSpread(OneNumber104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M55.59 88.09c-3-1.9-6.66-2.07-9.77-3.77-13.3-7-16.13-23-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46A7.57 7.57 0 0 0 30.56 94H59c.18-2.38-1.4-4.62-3.41-5.91Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m49.07 62.38 15.24 4.74c.47-1-.13-2.12-1.85-3.33C60 61.94 53.17 55.36 52.33 47s.58-10.72-.91-11.7l-.26-.17a1.64 1.64 0 0 0-1.43-.13 1.61 1.61 0 0 0-1 1l-4.79 15.48c-.69 2.52.84 9.52 5.13 10.9Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41.73 54.38c-7-9.6 1.49-21.75 1.49-21.75l-5.22.8-5.46 15.62Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m80.64 25.89-2.19 4.53"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m87.4 30.96-3.77 3.36"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m91.69 38.24-4.76 1.67"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M69 74v14a6 6 0 0 1-6 6H29a6 6 0 0 1-6-6V16a6 6 0 0 1 6-6h34a6 6 0 0 1 6 6v12M44 14h4M40 90h12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "45.4",
          y: "32.55",
          width: "33.43",
          height: "33.43",
          rx: "9.29",
          transform: "rotate(-73.45 62.119 49.255)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m51 33.58-10-1.14a4.19 4.19 0 0 0-4.23 2.72l-3.69 11.25a4.14 4.14 0 0 0 1.85 4.7l8.66 5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m73.21 65 9.92 1.13a4.2 4.2 0 0 0 4.16-2.76L91 52.09a4.17 4.17 0 0 0-1.86-4.7l-8.65-5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m56.77 38.72 5.46 10.85 6.78-3.42"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "45.4",
          y: "32.55",
          width: "33.43",
          height: "33.43",
          rx: "9.29",
          transform: "rotate(-73.45 62.119 49.255)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m51 33.58-10-1.14a4.19 4.19 0 0 0-4.23 2.72l-3.69 11.25a4.14 4.14 0 0 0 1.85 4.7l8.66 5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m73.21 65 9.92 1.13a4.2 4.2 0 0 0 4.16-2.76L91 52.09a4.17 4.17 0 0 0-1.86-4.7l-8.65-5"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_OneNumber104 = (OneNumber104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/OneNumber56.tsx


var OneNumber56_excluded = ["className"];
function OneNumber56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function OneNumber56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? OneNumber56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : OneNumber56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function OneNumber56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, OneNumber56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", OneNumber56_objectSpread(OneNumber56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30 46.86c-1.54-1-3.45-1.07-5.05-2C18 41.31 16.56 33 15.51 26c-.31-1.74-.38-2.87-2.4-3v24c0 2.16.74 2.91 2.9 2.91h15.71A3.49 3.49 0 0 0 30 46.86Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m26.42 33.59 8.21 2.55c.25-.54-.07-1.14-1-1.79-1.33-1-5-4.54-5.45-9.07s.31-5.77-.49-6.3l-.14-.09a.88.88 0 0 0-1.3.49l-2.59 8.34c-.37 1.35.45 5.15 2.76 5.87Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.47 29.28c-3.79-5.17.8-11.71.8-11.71l-2.81.43-2.94 8.41Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m43.42 13.94-1.18 2.44"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m47.06 16.67-2.03 1.81"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m49.37 20.59-2.56.9"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37 40v7a3 3 0 0 1-3 3H16a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v6M24 8h2M22 48h6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "24.45",
          y: "17.52",
          width: "18",
          height: "18",
          rx: "5",
          transform: "rotate(-73.45 33.45 26.52)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m27.44 18.08-5.35-.61a2.25 2.25 0 0 0-2.28 1.46l-2 6.06a2.23 2.23 0 0 0 1 2.53l4.66 2.7"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m39.42 35 5.34.61A2.26 2.26 0 0 0 47 34.12l2-6.07a2.26 2.26 0 0 0-1-2.53l-4.66-2.69"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m30.57 20.85 2.94 5.84 3.65-1.84"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "24.45",
          y: "17.52",
          width: "18",
          height: "18",
          rx: "5",
          transform: "rotate(-73.45 33.45 26.52)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m27.44 18.08-5.35-.61a2.25 2.25 0 0 0-2.28 1.46l-2 6.06a2.23 2.23 0 0 0 1 2.53l4.66 2.7"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m39.42 35 5.34.61A2.26 2.26 0 0 0 47 34.12l2-6.07a2.26 2.26 0 0 0-1-2.53l-4.66-2.69"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_OneNumber56 = (OneNumber56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/PeaceOfMind104.tsx


var PeaceOfMind104_excluded = ["className"];
function PeaceOfMind104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PeaceOfMind104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PeaceOfMind104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PeaceOfMind104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function PeaceOfMind104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PeaceOfMind104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", PeaceOfMind104_objectSpread(PeaceOfMind104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M55.93 13.44C34.36 4.19 11.31 17.82 19 30.56c8.22 13.69 51.36-6.17 45.54 19.51"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M13 75.46s11.84.27 17.55 7.49 12.25 9.38 16.19 9.93l-36.06-5.56Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M53.53 80.83s-8.32-7.28-4.16-14.56 12.38-8.21 12.38-8.21-6.41 2.36-8.87 6.85-2.71 9.81 7.06 13.25c-1.27 1.68-6.41 2.67-6.41 2.67"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m59.37 77.89 5.84-5.11a4.27 4.27 0 0 0 1-5.25l-2.89-7.16a2 2 0 0 1 3.41-2.17l4.61 3.8a5.13 5.13 0 0 1 1.55 2.23l3.47 8.49"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m51.06 81.56 20-4.56 10-5.53a7.28 7.28 0 0 0 2.25-1.92l5.69-7.3a2 2 0 0 1 2.59-.71 2 2 0 0 1 1 2.63L88.66 73a5.86 5.86 0 0 1-1.49 2.06C84.1 77.82 74.5 86.2 68.54 88.89c-4.49 2-15.62 3.89-19.51 4.49a8.8 8.8 0 0 1-2.71 0l-35.64-6.06"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m16.9 68.9 15.43 2.86a7 7 0 0 0 6.41-2.25l9.38-10.46a8.31 8.31 0 0 1 3.69-2.38l7.38-2.32a2.62 2.62 0 0 1 .68 5.2l-7.44 5.7-1 7.63 9.29 5.28"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M75.72 74.58s5.43-.23 4.93 6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M17.81 88.71C15.69 92.14 13.55 94 12 93.44c-2.47-.87-2.06-8.68 1-17.44s7.11-14.32 10-14.34c0 0 2.8 1.33.55 7.81"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m12.78 58.71 10.19 2.93"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PeaceOfMind104 = (PeaceOfMind104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/PeaceOfMind56.tsx


var PeaceOfMind56_excluded = ["className"];
function PeaceOfMind56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PeaceOfMind56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PeaceOfMind56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PeaceOfMind56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function PeaceOfMind56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PeaceOfMind56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", PeaceOfMind56_objectSpread(PeaceOfMind56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M8.11 40.49s6.14.14 9.1 3.88a12.9 12.9 0 0 0 8.4 5.15L6.9 46.64Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29.12 43.27S24.8 39.5 27 35.72a9.19 9.19 0 0 1 6.42-4.26s-3.32 1.23-4.6 3.56-1.4 5.09 3.66 6.87c-.66.87-3.32 1.38-3.32 1.38"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.36 8.33C19.17 3.53 7.22 10.6 11.18 17.2c4.26 7.1 26.63-3.2 23.62 10.12",
        className: "shadeinverted"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m32.14 41.75 3-2.65a2.22 2.22 0 0 0 .54-2.73l-1.5-3.71a1.06 1.06 0 0 1 .33-1.35 1 1 0 0 1 1.44.22l2.38 2a2.67 2.67 0 0 1 .8 1.16L41 39.06"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m27.83 43.65 10.38-2.36 5.2-2.87a3.87 3.87 0 0 0 1.17-1l2.92-3.79a1.07 1.07 0 0 1 1.34-.36 1 1 0 0 1 .5 1.36l-2 4.59a3.11 3.11 0 0 1-.77 1.06C45 41.71 40 46.05 36.9 47.45c-2.33 1-8.1 2-10.12 2.33a4.69 4.69 0 0 1-1.4 0L6.9 46.64"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m10.12 37.09 8 1.48a3.67 3.67 0 0 0 3.32-1.17l4.87-5.4a4.34 4.34 0 0 1 1.91-1.24l3.83-1.2a1.36 1.36 0 1 1 .35 2.7l-3.86 2.95-.51 4 4.81 2.74"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40.62 40s2.81-.12 2.56 3.14"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M10.59 47.36c-1.1 1.78-2.21 2.72-3 2.45-1.3-.45-1.09-4.5.48-9.05s3.68-7.43 5.19-7.44c0 0 1.45.69.28 4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m7.98 31.8 5.29 1.52"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PeaceOfMind56 = (PeaceOfMind56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Perfect104.tsx


var Perfect104_excluded = ["className"];
function Perfect104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Perfect104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Perfect104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Perfect104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Perfect104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Perfect104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Perfect104_objectSpread(Perfect104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45.28 29.78a52.28 52.28 0 0 1 7.06 2.72l.5 3.29-7.14-2.45Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M52.84 25.87c.88 8.36 5.07 9.65 5.07 9.65l.39 3-5.56-2.23Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M59.44 31.72c0 5.67 1.76 6 1.76 6l-.57 4-2-3s.81-14.61.78-7"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m51.78 85-3.57-15.88s2.09.36 4.63-2.67C53.7 77.77 59.2 83 59.2 83Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.64 53.55a26.73 26.73 0 0 1-4.83 4.36c-1.21.86-7.05 1.11-10.05-.61S28 47.94 28 47.94a32.82 32.82 0 0 0 6.18 6.23c2.57 2 7.11 3.55 10.06.95 1.5-1.32 1.71-4.49 2.84-7.57 1.63 1.18 2.6 6 2.6 6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M51.76 84a101.51 101.51 0 0 0-3.55-14.88C44.77 69.64 33.76 64 33.76 64a29.34 29.34 0 0 1-5.5-6.42L25.06 51a2.48 2.48 0 0 1 1.8-3A2.55 2.55 0 0 1 30 49.7l6.46 6.14 7.47-.11 3.7-8L42.44 42c-1.46-1.22-4-.4-5.6.74l-6.52 3.65a2 2 0 0 1-2.6-.23 1.85 1.85 0 0 1 .06-2.64l3.09-4.78A5 5 0 0 1 32.79 37a70.57 70.57 0 0 1 7.73-4.38c2.53-.92 17.16 4.69 18.14 6.15 2.62 3.94 5.72 19.27 6.07 20.93 2 9.24 5 18.82 5 18.82"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M68.21 72.18c3.88-.28 5.32.41 5.72 1.86.66 2.41-5.79 6.46-14.41 9s-15.24 2.53-16.81.31c0 0-1.41-3.62 7.7-6.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m45.85 92.86-3.14-9.47"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m45.7 33.34-1.2-10.25-3.1-10.4a2.65 2.65 0 0 1 5-1.69l4.42 11.73 2 13.06"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m52.84 35.79.07-10.63-1-10a2.6 2.6 0 0 1 5.16-.64l1.57 10.78v13.45"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m58.64 31.65.72-2.81.91-7.84a2.09 2.09 0 0 1 4.16.38l-.57 8.93-3.1 13.54"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m73.93 74.04 5.1 15.8"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Perfect104 = (Perfect104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Perfect56.tsx


var Perfect56_excluded = ["className"];
function Perfect56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Perfect56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Perfect56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Perfect56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Perfect56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Perfect56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Perfect56_objectSpread(Perfect56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.38 16a28.15 28.15 0 0 1 3.8 1.47l.27 1.77L24.61 18Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28.45 13.93c.48 4.5 2.73 5.2 2.73 5.2l.21 1.61-3-1.2Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32 17.08c0 3.05 1 3.25 1 3.25l-.31 2.16-1.06-1.62S32 13 32 17.08"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.88 45.79 26 37.22s1.13.19 2.49-1.44c.47 6.09 3.43 8.92 3.43 8.92Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.73 28.84a14.68 14.68 0 0 1-2.6 2.34c-.65.46-3.8.6-5.41-.32s-3.66-5.05-3.66-5.05a17.4 17.4 0 0 0 3.33 3.36c1.38 1.09 3.82 1.91 5.41.51.81-.71.92-2.42 1.53-4.08.88.64 1.4 3.24 1.4 3.24"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.87 45.23a55 55 0 0 0-1.91-8c-1.85.28-7.78-2.76-7.78-2.76a15.56 15.56 0 0 1-3-3.46l-1.73-3.52a1.35 1.35 0 0 1 1-1.64 1.37 1.37 0 0 1 1.69.92l3.47 3.31 4-.06 2-4.31-2.79-3.11c-.78-.66-2.18-.21-3 .4l-3.51 2a1.1 1.1 0 0 1-1.4-.13 1 1 0 0 1 0-1.42l1.67-2.57a2.65 2.65 0 0 1 1.05-.94 37.94 37.94 0 0 1 4.16-2.35c1.36-.5 9.24 2.52 9.77 3.31 1.44 2.1 3.1 10.34 3.3 11.24 1.06 5 2.71 10.13 2.71 10.13"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36.73 38.87c2.09-.15 2.86.22 3.08 1 .35 1.3-3.12 3.47-7.76 4.86s-8.21 1.37-9 .17c0 0-.76-1.94 4.14-3.39"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.69 50 23 44.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.61 18 24 12.43l-1.71-5.59A1.43 1.43 0 0 1 25 5.92l2.38 6.32 1.08 7"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28.45 19.27v-5.72L28 8.18a1.4 1.4 0 0 1 2.78-.34l.84 5.78v7.25"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m31.57 17 .43-1.47.49-4.24a1.12 1.12 0 0 1 2.24.2l-.3 4.81-1.67 7.29"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m39.81 39.87 2.74 8.51"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Perfect56 = (Perfect56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/PortMobile104.tsx


var PortMobile104_excluded = ["className"];
function PortMobile104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PortMobile104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PortMobile104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PortMobile104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function PortMobile104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PortMobile104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", PortMobile104_objectSpread(PortMobile104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.64 87c-2.87-1.83-6.4-2-9.38-3.62-12.78-6.67-15.5-22.05-17.46-35.03-.57-3.24-.7-5.33-4.46-5.64v44.58c0 4 1.37 5.4 5.38 5.41H58.9c.19-2.29-1.33-4.44-3.26-5.7Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M68.71 65v22.29a5.57 5.57 0 0 1-5.57 5.57H29.71a5.58 5.58 0 0 1-5.57-5.57V16.71a5.58 5.58 0 0 1 5.57-5.57h33.43a5.57 5.57 0 0 1 5.57 5.57v5.58M44.57 14.86h3.72M40.86 89.14H52"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M60.14 50.31a14.59 14.59 0 0 0 27.7-6.67M86.69 37.85a14.6 14.6 0 0 0-28.1 5.79"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m83.45 47.6 4.39-4.95 4.39 4.95"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m62.98 40.67-4.39 4.95-4.39-4.95"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PortMobile104 = (PortMobile104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/PortMobile56.tsx


var PortMobile56_excluded = ["className"];
function PortMobile56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PortMobile56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PortMobile56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PortMobile56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function PortMobile56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PortMobile56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", PortMobile56_objectSpread(PortMobile56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30 46.86c-1.54-1-3.45-1.07-5.05-2C18 41.31 16.56 33 15.51 26c-.31-1.74-.38-2.87-2.4-3v24c0 2.16.74 2.91 2.9 2.91h15.71A3.49 3.49 0 0 0 30 46.86Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37 35v12a3 3 0 0 1-3 3H16a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v3M24 8h2M22 48h6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.39 27.09a7.85 7.85 0 0 0 7 4.41 7.94 7.94 0 0 0 7.88-8M46.68 20.38a7.86 7.86 0 0 0-15.13 3.12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m44.94 25.63 2.36-2.66 2.36 2.66"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m33.91 21.9-2.36 2.67-2.36-2.67"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PortMobile56 = (PortMobile56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/PortPhone104.tsx


var PortPhone104_excluded = ["className"];
function PortPhone104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PortPhone104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PortPhone104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PortPhone104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function PortPhone104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PortPhone104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", PortPhone104_objectSpread(PortPhone104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.47 36.19c6.12 2.11 17.74 32.16 31.47 38.63 11.11 5.23 21.33-2.84 25.42 0S69 84.34 65.3 84s-22-2.1-36.46-22.55-11.23-27.19-6.37-25.26"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M65.29 84c-6.62 0-17.2-2.84-30.61-16.26C9.59 42.67 20.79 27.21 21.26 26.57c.28-.29 3.79-3.78 3.79-3.78a7.06 7.06 0 0 1 9.63 0l7.73 7.73a6.76 6.76 0 0 1 .06 9.57l-.06.06-3.47 3.63a62.21 62.21 0 0 0 8.21 10.41l1.1 1.11a58.7 58.7 0 0 0 10.42 8.21L62.14 60a7.08 7.08 0 0 1 9.63 0l7.73 7.74a6.92 6.92 0 0 1 2.06 4.89 7.19 7.19 0 0 1-2.06 4.89S71.77 84 65.3 84Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M59.12 37a12.07 12.07 0 0 0 23.06-5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M81.05 26.94A12.07 12.07 0 0 0 58 32"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m78.72 34.82 3.46-3.45 3.45 3.45"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m61.49 29.64-3.45 3.45-3.46-3.45"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PortPhone104 = (PortPhone104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/PortPhone56.tsx


var PortPhone56_excluded = ["className"];
function PortPhone56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PortPhone56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PortPhone56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PortPhone56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function PortPhone56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PortPhone56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", PortPhone56_objectSpread(PortPhone56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M12.1 19.49c3.29 1.13 9.55 17.32 17 20.8 6 2.82 11.48-1.53 13.68 0s-5.56 5.12-7.57 5-11.92-1.17-19.68-12.19-6-14.65-3.43-13.61"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.16 45.24c-3.57 0-9.26-1.53-16.49-8.75C5.16 23 11.19 14.65 11.45 14.31l2-2a3.8 3.8 0 0 1 5.18 0l4.17 4.16a3.66 3.66 0 0 1 0 5.16L21 23.57a33.29 33.29 0 0 0 4.42 5.61l.59.6a31.57 31.57 0 0 0 5.61 4.42l1.87-1.87a3.8 3.8 0 0 1 5.18 0l4.17 4.16a3.72 3.72 0 0 1 1.1 2.64 3.9 3.9 0 0 1-1.1 2.63s-4.17 3.48-7.65 3.48Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.83 20a6.5 6.5 0 0 0 12.42-2.7"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.64 14.5a6.5 6.5 0 0 0-12.39 2.75"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m42.39 18.75 1.86-1.86 1.86 1.86"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m33.11 15.96-1.86 1.86-1.86-1.86"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PortPhone56 = (PortPhone56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/PortSIM104.tsx


var PortSIM104_excluded = ["className"];
function PortSIM104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PortSIM104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PortSIM104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PortSIM104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function PortSIM104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PortSIM104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", PortSIM104_objectSpread(PortSIM104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m16.22 34.81.09 52c-.64 5.64 2.51 5.72 5.6 5.72h44.82a2 2 0 0 0 1.42-3.26 12.17 12.17 0 0 0-4.75-2.72C57 84.3 36 74.59 28.69 57s-5.86-23.47-9.6-24.61c-2.5-.77-2.87.92-2.87 2.42Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M66.68 52.36a12.07 12.07 0 0 0 23.06-5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M88.61 42.26a12.08 12.08 0 0 0-23 5.1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m86.28 50.14 3.46-3.45 3.45 3.45"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m69.05 44.96-3.46 3.45-3.45-3.45"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m36.22 71.94-.02 11.09M47.52 71.99l-.02 11.09M47.54 57.34l.02-11.17M36.25 57.29l.02-11.17M59.11 52.32v24.63a5.86 5.86 0 0 1-5.94 5.78l-22.61-.1a5.89 5.89 0 0 1-5.91-5.83V52.18a5.85 5.85 0 0 1 5.94-5.78l22.61.09a5.89 5.89 0 0 1 5.91 5.83Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m52 71.87-20.31-.09A6.64 6.64 0 0 1 25 65.33v-1.68a6.58 6.58 0 0 1 6.76-6.39l20.24.08a6.63 6.63 0 0 1 6.73 6.45v1.69A6.59 6.59 0 0 1 52 71.87Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m73.41 64.23-.15 23.88a4.11 4.11 0 0 1-4.35 3.79l-49-.05a4.08 4.08 0 0 1-4.31-3.8l.38-71.53c0-2.44 2.28-4.42 5.07-4.42l35.88.05a7.79 7.79 0 0 1 5.6 1.85l8.88 9c1.65 1.71 2.19 3.42 2.18 6.84"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PortSIM104 = (PortSIM104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/PortSIM56.tsx


var PortSIM56_excluded = ["className"];
function PortSIM56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PortSIM56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PortSIM56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PortSIM56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function PortSIM56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PortSIM56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", PortSIM56_objectSpread(PortSIM56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M8.73 18.74v28c-.34 3 1.36 3.08 3 3.09h24.2a1 1 0 0 0 .77-1.75 6.51 6.51 0 0 0-2.56-1.46c-3.43-1.23-14.75-6.46-18.69-15.93s-3.16-12.64-5.17-13.25c-1.35-.44-1.55.49-1.55 1.3Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.9 28.2a6.5 6.5 0 0 0 12.42-2.7"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47.71 22.76a6.5 6.5 0 0 0-12.39 2.74"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m46.46 27 1.86-1.86L50.18 27"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m37.18 24.21-1.86 1.86-1.86-1.86"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m19.5 38.74-.01 5.97M25.59 38.76l-.01 5.97M25.6 30.87l.01-6.01M19.52 30.85l.01-6.01M31.83 28.17v13.26a3.15 3.15 0 0 1-3.19 3.12l-12.18-.06a3.17 3.17 0 0 1-3.18-3.14V28.1a3.17 3.17 0 0 1 3.19-3.1h12.17a3.16 3.16 0 0 1 3.19 3.17Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m28 38.7-10.94-.05a3.56 3.56 0 0 1-3.62-3.47v-.91a3.54 3.54 0 0 1 3.64-3.44l10.92.05a3.56 3.56 0 0 1 3.62 3.47v.91A3.54 3.54 0 0 1 28 38.7Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m39.53 34.58-.08 12.87a2.22 2.22 0 0 1-2.34 2H10.7a2.21 2.21 0 0 1-2.33-2.05l.21-38.51a2.57 2.57 0 0 1 2.73-2.37h19.32a4.21 4.21 0 0 1 3 1l4.78 4.83c.89.92 1.18 1.84 1.18 3.68"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PortSIM56 = (PortSIM56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/PostPaid104.tsx


var PostPaid104_excluded = ["className"];
function PostPaid104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PostPaid104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PostPaid104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PostPaid104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function PostPaid104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PostPaid104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", PostPaid104_objectSpread(PostPaid104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "59",
          y: "46",
          width: "5",
          height: "4",
          rx: ".5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "59",
          y: "52",
          width: "5",
          height: "4",
          rx: ".5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "67",
          y: "40",
          width: "5",
          height: "4",
          rx: ".5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "67",
          y: "46",
          width: "5",
          height: "4",
          rx: ".5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "67",
          y: "52",
          width: "5",
          height: "4",
          rx: ".5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "75",
          y: "40",
          width: "5",
          height: "4",
          rx: ".5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "75",
          y: "46",
          width: "5",
          height: "4",
          rx: ".5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M55.59 88.09c-3-1.9-6.66-2.07-9.77-3.77-13.3-7-16.13-23-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46A7.57 7.57 0 0 0 30.56 94H59c.18-2.38-1.4-4.62-3.41-5.91Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "55",
          y: "30",
          width: "29",
          height: "29",
          rx: "3.22"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M75.9 28v4M63.01 28v4M55 36.96h29M69 65v23a6 6 0 0 1-6 6H29a6 6 0 0 1-6-6V16a6 6 0 0 1 6-6h34a6 6 0 0 1 6 6v6M44 14h4M40 90h12"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PostPaid104 = (PostPaid104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/PostPaid56.tsx


var PostPaid56_excluded = ["className"];
function PostPaid56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PostPaid56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PostPaid56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PostPaid56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function PostPaid56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PostPaid56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", PostPaid56_objectSpread(PostPaid56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.92 29.18c-.34-.3-.76-.33-1.12-.6-1.52-1.08-1.8-3.58-2.08-5.7-.07-.53-.08-.87-.53-.92v7.26c0 .65.16.88.64.88h3.48a1.18 1.18 0 0 0-.39-.92ZM30 46.86c-1.54-1-3.45-1.07-5.05-2C18 41.31 16.56 33 15.51 26c-.31-1.74-.38-2.87-2.4-3v24c0 2.16.74 2.91 2.9 2.91h15.71A3.49 3.49 0 0 0 30 46.86Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.67 16.49h11.66A1.61 1.61 0 0 1 46 18v10.9a1.62 1.62 0 0 1-1.67 1.56H32.67A1.62 1.62 0 0 1 31 28.94V18a1.61 1.61 0 0 1 1.67-1.51ZM42.25 15.5v2M34.75 15.5v2M31 20.18h15"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37 34v13a3 3 0 0 1-3 3H16a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v3M24 8h2M22 48h6"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PostPaid56 = (PostPaid56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/PrePaid104.tsx


var PrePaid104_excluded = ["className"];
function PrePaid104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PrePaid104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PrePaid104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PrePaid104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function PrePaid104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PrePaid104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PrePaid104_objectSpread(PrePaid104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.6 28.21A15.33 15.33 0 0 0 56 43.41 15 15 0 0 0 58.69 52L63 55.29l-.55-1a18.52 18.52 0 0 1-2.66-9.66c-.05-7.69 4.51-14.23 10.81-16.42ZM55.59 88.09c-3-1.9-6.66-2.07-9.77-3.77-13.3-7-16.13-23-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46A7.57 7.57 0 0 0 30.56 94H59c.18-2.38-1.4-4.62-3.41-5.91Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "71.51",
        cy: "43.42",
        rx: "15.49",
        ry: "15.26"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69 65v23a6 6 0 0 1-6 6H29a6 6 0 0 1-6-6V16a6 6 0 0 1 6-6h34a6 6 0 0 1 6 6v6M44 14h4M40 90h12"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M74.71 40.39a1 1 0 0 1-1.09-.85 1.89 1.89 0 0 0-2.06-1.77h-.14a2 2 0 0 0-.73 3.82l3 1.51a4.19 4.19 0 0 1-1.22 7.9v1a1.07 1.07 0 0 1-2.13 0v-1A4.08 4.08 0 0 1 67 46.86a1 1 0 0 1 1.09-1 1.07 1.07 0 0 1 1.13 1A2 2 0 0 0 71.4 49h.22a2 2 0 0 0 2.18-2 2.18 2.18 0 0 0-1.44-2l-2.91-1.48a3.84 3.84 0 0 1-2.15-3.67 4.05 4.05 0 0 1 3-3.87v-1a1.07 1.07 0 0 1 2.13 0v.94a3.66 3.66 0 0 1 3.3 3.54 1 1 0 0 1-1.02.93Z",
      className: "strokeinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PrePaid104 = (PrePaid104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/PrePaid56.tsx


var PrePaid56_excluded = ["className"];
function PrePaid56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function PrePaid56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PrePaid56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PrePaid56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function PrePaid56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PrePaid56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", PrePaid56_objectSpread(PrePaid56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.53 15.52A8 8 0 0 0 32.37 28l2.21 1.75-.29-.5a9.83 9.83 0 0 1-1.37-5.07 9 9 0 0 1 5.61-8.66ZM30 46.86c-1.54-1-3.45-1.07-5.05-2C18 41.31 16.56 33 15.51 26c-.31-1.74-.38-2.87-2.4-3v24c0 2.16.74 2.91 2.9 2.91h15.71A3.49 3.49 0 0 0 30 46.86Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "39",
          cy: "23.5",
          r: "8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37 35v12a3 3 0 0 1-3 3H16a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v3M24 8h2M22 48h6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.65 21.91c-.39 0-.53-.2-.56-.44a1 1 0 0 0-1.09-.93 1 1 0 0 0-.37 2l1.53.79a2.16 2.16 0 0 1 1.23 2 2.11 2.11 0 0 1-1.85 2.14V28a.54.54 0 0 1-.55.53.54.54 0 0 1-.55-.53v-.5a2.13 2.13 0 0 1-1.73-2.17.54.54 0 0 1 .56-.55.56.56 0 0 1 .59.55 1.07 1.07 0 0 0 1.13 1.15h.12a1 1 0 0 0 1.12-1.1 1.14 1.14 0 0 0-.74-1.07l-1.51-.77a2 2 0 0 1-1.11-1.93 2.11 2.11 0 0 1 1.57-2V19a.54.54 0 0 1 .55-.53.54.54 0 0 1 .55.53v.49a1.91 1.91 0 0 1 1.71 1.86.52.52 0 0 1-.6.56Z",
        className: "strokeinverted"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PrePaid56 = (PrePaid56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Roaming104.tsx


var Roaming104_excluded = ["className"];
function Roaming104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Roaming104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Roaming104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Roaming104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Roaming104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Roaming104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Roaming104_objectSpread(Roaming104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41.9 58h-9.3c-.7 0-1.4 0-2.1-.2-.9-.2-1 .1-1.5-.6-2.8-3.6-5.6-7.2-8.3-10.8-3.1-4.2-5.7-9.3-9.4-13-.5-.5-1-1.1-.7-1.7.3-.4.9-.6 1.3-.4.5.2.8.6 1.1 1 5.6 6.8 11.5 14.5 19 19 4.6 2.7 9.4 5 14.4 6.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.8 83.4h-6.3c-1.6 0-3.7.5-5.2-.3-3.9-2 1.6-5.3 4.1-4.7 2.2.5 3.6 1.5 6 1.4 2.1 0 4.2-.5 6.2-.5 3 0 8.7-.3 10.2 3.7-1.7.9-4.5.3-6.4.3h-8.6z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.3 48.3c0 .2-.2.5-.5.5-.2 0-.5-.2-.5-.5 0-.2.2-.5.5-.5s.5.2.5.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45.9 48.3c0 .2-.2.5-.5.5-.2 0-.5-.2-.5-.5 0-.2.2-.5.5-.5s.5.2.5.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42.4 48.3c0 .2-.2.5-.5.5-.2 0-.5-.2-.5-.5 0-.2.2-.5.5-.5s.5.2.5.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M52.7 48.3c0 .2-.2.5-.5.5-.2 0-.5-.2-.5-.5 0-.2.2-.5.5-.5s.5.2.5.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M56.2 48.3c0 .2-.2.5-.5.5-.2 0-.5-.2-.5-.5 0-.2.2-.5.5-.5s.5.2.5.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M59.6 48.3c0 .2-.2.5-.5.5-.2 0-.5-.2-.5-.5 0-.2.2-.5.5-.5s.5.2.5.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M63.1 48.3c0 .2-.2.5-.5.5-.2 0-.5-.2-.5-.5 0-.2.2-.5.5-.5s.5.2.5.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M66.5 48.3c0 .2-.2.5-.5.5-.2 0-.4-.2-.4-.5 0-.2.2-.5.5-.5.2 0 .4.2.4.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M69.9 48.3c0 .2-.2.5-.5.5-.2 0-.4-.2-.4-.5 0-.2.2-.5.5-.5.2 0 .4.2.4.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M73.4 48.3c0 .2-.2.5-.5.5-.2 0-.4-.2-.4-.5 0-.2.2-.5.5-.5.2 0 .4.2.4.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M76.8 48.3c0 .2-.2.4-.5.4-.2 0-.4-.2-.4-.5 0-.2.2-.4.5-.4.2 0 .4.2.4.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M80.2 48.3c0 .2-.2.4-.5.4-.2 0-.4-.2-.4-.5 0-.2.2-.4.5-.4s.5.2.4.5c.1 0 .1 0 0 0"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21.5 34.8c9.8-16.6 31.2-22.2 47.8-12.5 8.3 4.9 14.3 13 16.4 22.5M23.6 73.2C17 64.4 15 53.1 18.1 42.6M86 58.4c-3.3 19-21.4 31.7-40.4 28.4-3.1-.5-6.1-1.5-8.9-2.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.4 58.4h-15c-.8 0-1.6-.4-2.1-1l-19-24.8c-.2-.3-.2-.7.1-1 .1-.1.3-.1.4-.1h5c.5 0 1 .2 1.4.5l15.2 12.7c.2.1.4.2.6.2 10 0 20 .1 30 .1 4.6 0 9.2-.1 13.8-.2 6.1-.1 19 .3 16.4 8.4-2.4 7.6-20.1 5.2-27 5.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m70.5 50.7-21 22.1c-.3.3-.7.5-1.1.5h-6c-.8 0-1.4-.7-1.4-1.5 0-.3.1-.5.2-.7L55 51.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m46.6 42.5-7.3-7.3c-.1-.1-.1-.3 0-.4.1-.1.1-.1.2-.1h7.1l13.3 7.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.7 51.8h22.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M73.6 51.8h19.7"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M12.5 83.6H38c1.6 0 2.9-1.3 2.9-2.9 0-1-.6-2-1.4-2.5-2-1-4.2-1.5-6.4-1.4 0 0-6.7-8.8-16.8 1.2 0 0-3.3-.6-5.4 1.1-1.1.9-1.3 2.4-.4 3.5.5.7 1.2 1 2 1z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Roaming104 = (Roaming104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Roaming56.tsx


var Roaming56_excluded = ["className"];
function Roaming56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Roaming56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Roaming56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Roaming56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Roaming56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Roaming56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Roaming56_objectSpread(Roaming56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.36 18.57S9 41 33.12 47.46c0 0-23.12 6.17-25.23-21.34a36.1 36.1 0 0 1 2.47-7.55Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47.71 31.41a20 20 0 1 1-3.24-14.75"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.33 8.6c-1.82 1.17-3.7 2.23-5.49 3.48-2.8 1.95.15 2-.7 4.79s-2.1 4.8-4.53 5.7c-1.31.49-5.36 1.1-5.57 2.47-.29 1.9 1.11 4.08 1.49 5.91.4 2 .72 4.39 2.57 5.35a61 61 0 0 0 6.63 2.7c1.14.42.61 3.52.61 4.65"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m27.51 28.66-4.62-2.06-3.48 2 7.93 5.12 7.9-3.11-3.35 8.69 4-2 4.82-8.8 6-2.65A2.22 2.22 0 0 0 45 21.7Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m38.55 24.25-7.07-4.43-3.54 1.83 6.43 4.28M37 10.62a5.06 5.06 0 0 0 1.56 5"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Roaming56 = (Roaming56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/RoamingOn104.tsx


var RoamingOn104_excluded = ["className"];
function RoamingOn104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function RoamingOn104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? RoamingOn104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RoamingOn104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function RoamingOn104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, RoamingOn104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", RoamingOn104_objectSpread(RoamingOn104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M61.57 88.09c-3-1.9-6.66-2.07-9.76-3.77-13.3-7-16.14-23-18.18-36.49C33 44.46 32.9 42.28 29 42v44.43A7.57 7.57 0 0 0 36.55 94H65c.16-2.38-1.41-4.62-3.43-5.91Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.99 14h4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m68 58.41-3.87-6.09L58 48.45l2.13-2.05 5.29 1.6 7.07-7.76-14.13-5.42 3.28-3.39 16.15 2.79.25-.3c.19-.23 4.86-5.49 7.9-5.49h.12A1.89 1.89 0 0 1 88 30.58c0 3-5.3 7.63-5.49 7.83l-.3.25 2.84 16-3.37 3.24-5.51-14.14L68.39 51 70 56.33Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M75 57v31a6 6 0 0 1-6 6H35a6 6 0 0 1-6-6V16a6 6 0 0 1 6-6h34a6 6 0 0 1 6 6v11M45.99 90h12"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_RoamingOn104 = (RoamingOn104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/RoamingOn56.tsx


var RoamingOn56_excluded = ["className"];
function RoamingOn56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function RoamingOn56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? RoamingOn56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RoamingOn56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function RoamingOn56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, RoamingOn56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", RoamingOn56_objectSpread(RoamingOn56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33 46.86c-1.54-1-3.45-1.07-5.05-2C21 41.31 19.56 33 18.51 26c-.31-1.74-.38-2.87-2.4-3v24c0 2.16.74 2.91 2.9 2.91h15.71A3.49 3.49 0 0 0 33 46.86Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40 31v16a3 3 0 0 1-3 3H19a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v6M27 8h2M25 48h6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m36.58 31.45-2.08-3.28-3.28-2.08L32.37 25l2.85.88 3.78-4.2-7.61-2.93 1.77-1.83 8.69 1.51.14-.16c.1-.13 2.61-3 4.25-3h.06a1 1 0 0 1 1 1.16c0 1.61-2.85 4.11-3 4.21l-.16.14 1.53 8.62L44 31.18l-3-7.62-4.19 3.92.88 2.85Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_RoamingOn56 = (RoamingOn56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/SmartHome104.tsx


var SmartHome104_excluded = ["className"];
function SmartHome104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function SmartHome104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SmartHome104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SmartHome104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function SmartHome104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SmartHome104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", SmartHome104_objectSpread(SmartHome104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M58 93c-17.13-2.45-31.68-13.4-36.6-29.63a40 40 0 0 1-1.62-14.08h-1l.08 40.38V93Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.09 11.76a2.77 2.77 0 0 1 3.61-.17l.21.17 40.54 38.7a2.76 2.76 0 0 1-3.6 4.18l-.22-.18L52 17.58 13.37 54.46a2.76 2.76 0 0 1-3.7.1l-.21-.19a2.76 2.76 0 0 1-.1-3.7l.19-.21Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.28 74.9A2.29 2.29 0 1 1 52 72.61a2.28 2.28 0 0 1 2.28 2.29",
        className: "strokeinverted"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.87 56.52a26 26 0 0 1 36.26 0M43 65.63a13.15 13.15 0 0 1 18 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M85.17 49.29V93H18.91v-3.33l-.08-40.38M11.46 93h81.08M23.76 36.85V19.3h9.59v8.46l-9.59 9.09z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.09 11.76a2.77 2.77 0 0 1 3.61-.17l.21.17 40.54 38.7a2.76 2.76 0 0 1-3.6 4.18l-.22-.18L52 17.58 13.37 54.46a2.76 2.76 0 0 1-3.7.1l-.21-.19a2.76 2.76 0 0 1-.1-3.7l.19-.21Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SmartHome104 = (SmartHome104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/SmartHome56.tsx


var SmartHome56_excluded = ["className"];
function SmartHome56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function SmartHome56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SmartHome56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SmartHome56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function SmartHome56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SmartHome56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", SmartHome56_objectSpread(SmartHome56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.27 50.13C22 48.8 14.07 42.86 11.39 34.05a21.73 21.73 0 0 1-.87-7.64H10v23.72Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27 6a1.49 1.49 0 0 1 2-.09V6l22 21a1.5 1.5 0 0 1-2 2.27l-.12-.1L28 9.2l-21 20a1.5 1.5 0 0 1-2 .06l-.12-.11a1.5 1.5 0 0 1 0-2L5 27Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.24 40.3A1.24 1.24 0 1 1 28 39.06a1.25 1.25 0 0 1 1.24 1.24",
        className: "strokeinverted"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46 26.41v23.72H10.04v-1.81L10 26.41M6 50.13h44M12.68 19.66v-9.53h5.2v4.6l-5.2 4.93z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27 6a1.49 1.49 0 0 1 2-.09V6l22 21a1.5 1.5 0 0 1-2 2.27l-.12-.1L28 9.2l-21 20a1.5 1.5 0 0 1-2 .06l-.12-.11a1.5 1.5 0 0 1 0-2L5 27Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.16 30.33a14.1 14.1 0 0 1 19.68 0M23.1 35.28a7.13 7.13 0 0 1 9.8 0"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SmartHome56 = (SmartHome56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Telstra104.tsx


var Telstra104_excluded = ["className"];
function Telstra104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Telstra104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Telstra104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Telstra104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Telstra104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Telstra104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Telstra104_objectSpread(Telstra104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.72 44.41C8.22 46.48 17 64.1 21.14 69.68c-8.84-21.34 2.58-25.27 2.58-25.27ZM22.66 71.34c-.13-.12-.33 0-.22.19 13.41 17 33.83 24.23 42.46 18.81 2.29-6.85-19.09 2.66-42.24-19ZM38.66 56.22c.39-1.87.23-2.74.13-2.66s-3.62 20.06-3.62 20.06h10.9c-6.87.12-9.51-7.37-7.41-17.4ZM59.11 29.36c6.74.48 9.84 3.38 9.53 5.34l1.19-6.43H52.39s.16.62 6.72 1.09Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M60 11.05v6.73M82.21 40h7.84M88.29 29.15l-7.32 2.77M81.84 18.95l-5.61 5.4M72.12 12.7l-3.28 7.02M52.19 56.21l-2.53 14.93c-.52 2.68-2.28 3.41-3.84 3.41H34.13l4.93-27.34c-4.92-2.26-9.94-3.74-13.94-3.74-3.81 0-6.9 1-8.95 3.52A9.93 9.93 0 0 0 14 53.52c0 7.77 6.07 18.55 16.47 27.35C39.74 88.65 49.93 93 57.35 93c3.7 0 6.69-1.14 8.65-3.42A9.75 9.75 0 0 0 68.16 83c0-7.61-6.16-18.19-15.97-26.79Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.2 27.3a3.85 3.85 0 0 0-3.81 3.22l-1.65 9h14.7l-6.31 35h11.69c1.56 0 3.32-.73 3.84-3.41L55 39.53h10.58a3.86 3.86 0 0 0 3.81-3.21l1.66-9Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Telstra104 = (Telstra104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Telstra56.tsx


var Telstra56_excluded = ["className"];
function Telstra56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Telstra56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Telstra56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Telstra56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Telstra56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Telstra56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Telstra56_objectSpread(Telstra56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M12.85 24.51c-7.74 1-3.38 10-1.29 12.79-4.41-10.8 1.29-12.79 1.29-12.79ZM12.51 38.51c-.06-.06-.16 0-.11.1 6.77 8.72 17.22 12.33 21.43 9.62 1.17-3.5-9.63 1.37-21.32-9.72ZM20.6 30.61c.2-1 .11-1.42.07-1.38s-1.86 10.38-1.86 10.38h5.57c-3.5.06-4.86-3.81-3.78-9ZM31 16.69c3.44.25 5 1.75 4.86 2.76l.61-3.33h-8.9s.05.32 3.43.57Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.64 6.62v3.49M42.89 21.58h4M46 16.04l-3.74 1.44M42.71 10.76l-2.87 2.8M37.74 7.53l-1.67 3.63M27.43 30.59l-1.29 7.72a1.91 1.91 0 0 1-2 1.77h-6l2.52-14.15A18.14 18.14 0 0 0 13.61 24 5.58 5.58 0 0 0 9 25.81a5.2 5.2 0 0 0-1.1 3.38c0 4 3.1 9.6 8.4 14.16 4.73 4 9.94 6.27 13.73 6.27a5.53 5.53 0 0 0 4.41-1.77 5.05 5.05 0 0 0 1.1-3.43c.04-3.91-3.08-9.42-8.11-13.83Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M16.71 15.62a2 2 0 0 0-1.94 1.67L13.93 22h7.5l-3.22 18.08h6a1.91 1.91 0 0 0 2-1.77L28.87 22h5.4a2 2 0 0 0 1.94-1.66l.85-4.67Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Telstra56 = (Telstra56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Unlimited104.tsx


var Unlimited104_excluded = ["className"];
function Unlimited104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Unlimited104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Unlimited104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Unlimited104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Unlimited104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Unlimited104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Unlimited104_objectSpread(Unlimited104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.63 38.85c5.31 0 10 3.77 14.12 8.81 2.36 2.85 6.83.87 3.85-2.11-6.36-6.36-11.91-11-18-11a16.55 16.55 0 0 0-10.3 3.38 23.24 23.24 0 0 0-6.49 8.71c-1 2.24 2.47 2.77 3.52.52 0 0 3.85-8.31 13.3-8.31"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M69.59 38.15A13.26 13.26 0 0 1 83 43c2.47 3.82 4.1 9.59 1.06 14.64-1.16 1.92 2.14 7.21 4.58 3.69 4.16-6 2.59-15.47-2-21.42a14.34 14.34 0 0 0-8-4.87 20.27 20.27 0 0 0-9.77-.41c-2.1.47-1.35 4 .75 3.51"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M71.72 28.75V21.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m78.02 29.57 1.79-6.71"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m83.88 32 3.47-6.02"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m88.92 35.86 4.91-4.92"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m92.79 40.89 6.01-3.48"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m95.22 46.75 6.71-1.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M96.05 53.04H103"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m52.88 47.43 7.61-7.63a17.78 17.78 0 1 1 0 25.18l-.25-.19-24.93-25a17.78 17.78 0 1 0 0 25.18L42.24 58",
        className: "stroke"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Unlimited104 = (Unlimited104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Unlimited56.tsx


var Unlimited56_excluded = ["className"];
function Unlimited56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Unlimited56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Unlimited56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Unlimited56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Unlimited56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Unlimited56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Unlimited56_objectSpread(Unlimited56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M4.2 29.61a9.45 9.45 0 0 1 4.92-8.49c2.78-1.14 6.68-1.41 9.49 1.41 1.07 1.08 4.07.23 2.15-2a10.79 10.79 0 0 0-13.12-2.34A10.55 10.55 0 0 0 3 22.85a15.27 15.27 0 0 0-1.1 6.76 1.17 1.17 0 0 0 2.34 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M52 28.06a8.06 8.06 0 0 1-4.59 7.37c-2.6 1-6.24 1.23-8.87-1.23-1-.93-3.79-.2-2 1.71A10.6 10.6 0 0 0 48.74 38a9.48 9.48 0 0 0 4.37-4 12.33 12.33 0 0 0 1-5.87c0-1.31-2.21-1.31-2.19 0"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31 25.18 4.64-4.65a10.84 10.84 0 1 1 0 15.35l-.15-.12-15.16-15.23a10.84 10.84 0 1 0 0 15.35l4.22-4.23",
        className: "stroke"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Unlimited56 = (Unlimited56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/WeCare104.tsx


var WeCare104_excluded = ["className"];
function WeCare104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function WeCare104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WeCare104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WeCare104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function WeCare104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WeCare104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", WeCare104_objectSpread(WeCare104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m55.48 61.09.13-.69a.08.08 0 0 1 0-.07c.26-.17.49-.32.66-.45 1.67-1.3 4.32-2.53 5.52-3.78 3.71-3.65 6.5-8.55 6.65-12.34.13-3.48-2.14-5.95-3-7.91a.11.11 0 0 1 .09-.15c1.77-.11 3.94 3.35 4.43 4.19 7.34 12.34-12.31 20.49-14.39 21.32a.11.11 0 0 1-.09-.12ZM32.32 57.71s-7.32-3.83-12.7 4.56l-4.07 7.22 5.51 2.92 2-5.81 4.85-4.29 7.89-.62 9.95 4.1.16-.29a.27.27 0 0 0-.1-.37Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.75 32.26a79.16 79.16 0 0 1 6.06-6.68A17 17 0 0 1 42 22.81c2.28-.78 5.14-.71 6.15.61.69.9.61 3.06-2.52 4.39"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M10.72 65.4s7-11.48 9.1-15.45c2.68-5.13 6.48-14.07 12.7-19.36a13.48 13.48 0 0 1 14.63-2.17 10.73 10.73 0 0 1 4.42 4.39 2.7 2.7 0 0 1 0 2.57 2.79 2.79 0 0 1-3.84 1 5 5 0 0 1-1-.85 5.19 5.19 0 0 0-3.76-1.64c-1.45 0-3.21 1.1-4.21 1.85a3.15 3.15 0 0 0-1.12 1.52 43.05 43.05 0 0 0-1.92 6.52 2.51 2.51 0 0 0 .11 1 43.06 43.06 0 0 0 2.28 4.93 23.49 23.49 0 0 0 6.87 8c.81.6 1.67 1.25 2.53 1.91 1.33 1 5.35 2.81 3.59 5.72s-5 .89-6.38.15c-.94-.48-2.89-1.29-3.83-1.76-10.47-5.27-16 .92-16.83 2.3l-.23.42-2.72 4.92"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m4.11 67.15 3.2-6.27"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m23.59 78.73 3.36-6.51"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.61 67c2.56 2.15 3.94 4.15 3.34 5.19-.9 1.57-6 .31-11.46-2.82s-9.08-7-8.18-8.52c.56-1 2.69-.86 5.51.07M73.23 32.24a78.69 78.69 0 0 0-6-6.66A17 17 0 0 0 62 22.81c-2.28-.78-5.14-.71-6.15.61-.69.9-.61 3.06 2.52 4.39"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M93.28 65.4s-7-11.48-9.1-15.45c-2.68-5.13-6.48-14.07-12.7-19.36a13.48 13.48 0 0 0-14.63-2.17 10.73 10.73 0 0 0-4.42 4.39 2.7 2.7 0 0 0 0 2.57 2.79 2.79 0 0 0 3.84 1 5 5 0 0 0 1-.85 5.19 5.19 0 0 1 3.76-1.64c1.45 0 3.21 1.1 4.21 1.85a3.15 3.15 0 0 1 1.12 1.52 43.05 43.05 0 0 1 1.92 6.52 2.51 2.51 0 0 1-.11 1 43.06 43.06 0 0 1-2.28 4.93 23.49 23.49 0 0 1-6.87 8c-.81.6-1.67 1.25-2.53 1.91-1.33 1-5.35 2.81-3.59 5.72s5 .89 6.38.15c.94-.48 2.89-1.29 3.83-1.76 10.47-5.27 16 .92 16.83 2.3l.23.42 2.72 4.92"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m99.89 67.15-3.2-6.27"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m80.41 78.73-3.36-6.51"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M80.39 67c-2.56 2.15-3.94 4.15-3.34 5.19.9 1.57 6 .31 11.46-2.82s9.08-7 8.18-8.52c-.56-1-2.69-.86-5.51.07"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WeCare104 = (WeCare104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/WeCare56.tsx


var WeCare56_excluded = ["className"];
function WeCare56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function WeCare56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WeCare56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WeCare56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function WeCare56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WeCare56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", WeCare56_objectSpread(WeCare56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m29.88 32.89.06-.37.35-.24a33.08 33.08 0 0 0 3-2c2-2 3.51-4.61 3.58-6.65.08-1.87-1.15-3.2-1.6-4.26a.06.06 0 0 1 0-.08c1-.06 2.12 1.81 2.38 2.26 3.95 6.64-6.63 11-7.75 11.48a.06.06 0 0 1-.02-.14ZM17.4 31.07s-3.94-2.07-6.84 2.46l-2.18 3.89 3 1.57 1.06-3.13L15 33.55l4.25-.33 5.36 2.21.09-.16a.15.15 0 0 0-.06-.2Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M16.56 17.37a40.26 40.26 0 0 1 3.26-3.59 9 9 0 0 1 2.78-1.5c1.23-.42 2.77-.38 3.31.33.37.49.33 1.65-1.36 2.36"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M5.77 35.22s3.78-6.22 4.9-8.32c1.45-2.76 3.49-7.58 6.84-10.43a7.26 7.26 0 0 1 7.88-1.17 5.78 5.78 0 0 1 2.38 2.36 1.49 1.49 0 0 1 0 1.39 1.51 1.51 0 0 1-2.07.53 2.49 2.49 0 0 1-.55-.46 2.79 2.79 0 0 0-2-.88 4.42 4.42 0 0 0-2.27 1 1.78 1.78 0 0 0-.61.82 25 25 0 0 0-1 3.51 1.46 1.46 0 0 0 .06.55 24.47 24.47 0 0 0 1.23 2.66 12.62 12.62 0 0 0 3.7 4.32c.43.32.9.67 1.36 1 .72.55 2.88 1.51 1.93 3.07s-2.67.48-3.43.09c-.51-.27-1.56-.7-2.06-1-5.64-2.83-8.64.5-9.06 1.24l-.13.23-1.46 2.65"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m2.21 36.16 1.73-3.38"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m12.7 42.39 1.81-3.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M12.71 36.09c1.38 1.16 2.13 2.24 1.8 2.8-.49.84-3.25.16-6.17-1.52s-4.89-3.74-4.4-4.59c.3-.52 1.45-.46 3 0M39.43 17.36a40 40 0 0 0-3.25-3.58 9 9 0 0 0-2.78-1.5c-1.23-.42-2.77-.38-3.31.33-.37.49-.33 1.65 1.36 2.36"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.23 35.22s-3.78-6.22-4.9-8.32c-1.45-2.76-3.49-7.58-6.84-10.43a7.26 7.26 0 0 0-7.88-1.17 5.78 5.78 0 0 0-2.38 2.36 1.49 1.49 0 0 0 0 1.39 1.51 1.51 0 0 0 2.07.53 2.49 2.49 0 0 0 .55-.46 2.79 2.79 0 0 1 2-.88 4.42 4.42 0 0 1 2.27 1 1.78 1.78 0 0 1 .61.82 25 25 0 0 1 1 3.51 1.46 1.46 0 0 1-.06.55 24.47 24.47 0 0 1-1.23 2.66 12.62 12.62 0 0 1-3.7 4.32c-.43.32-.9.67-1.36 1-.72.55-2.88 1.51-1.93 3.07s2.67.48 3.43.09c.51-.27 1.56-.7 2.06-1 5.64-2.83 8.64.5 9.06 1.24l.13.23 1.46 2.65"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m53.79 36.16-1.73-3.38"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m43.3 42.39-1.81-3.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.29 36.09c-1.38 1.16-2.13 2.24-1.8 2.8.49.84 3.25.16 6.17-1.52s4.89-3.74 4.4-4.59c-.3-.52-1.45-.46-3 0"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WeCare56 = (WeCare56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Building104.tsx


var Building104_excluded = ["className"];
function Building104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Building104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Building104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Building104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Building104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Building104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Building104_objectSpread(Building104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M16.58 20.14v73.01l7.15-.17-1.84-5.89-1.01-66.95h-4.3z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m30.56 10 1 9.25 1.84.86-7.15.03V10h4.31z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M55.89 30.61v62.03l7.14-.14-1.83-4.96-1.01-56.93h-4.3z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M10.14 93.17h83.7v-.04h-83.7v.04z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.24 20.14h28.97v-9.66H26.24v9.66z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M55.21 93.15H87.4V31.4H55.21v61.75z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M64.87 31.4V20.14H16.58v73.01h38.63V31.4h9.66z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M55.21 41.08h22.54v-.04H55.21v.04z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M55.21 50.73h22.54v-.03H55.21v.03z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M55.21 60.39h22.54v-.03H55.21v.03z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M55.21 70.05h22.54v-.03H55.21v.03z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M55.21 79.7h22.54v-.03H55.21v.03z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.22 35.72h.04V32.5h-.04v3.22z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.88 35.72h.03V32.5h-.03v3.22z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45.54 35.72h.03V32.5h-.03v3.22z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.22 46.99h.04v-3.22h-.04v3.22z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.88 46.99h.03v-3.22h-.03v3.22z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45.54 46.99h.03v-3.22h-.03v3.22z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.22 58.26h.04v-3.23h-.04v3.23z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.88 58.26h.03v-3.23h-.03v3.23z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45.54 58.26h.03v-3.23h-.03v3.23z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.22 69.52h.04V66.3h-.04v3.22z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.88 69.52h.03V66.3h-.03v3.22z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45.54 69.52h.03V66.3h-.03v3.22z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.22 80.79h.04v-3.22h-.04v3.22z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.88 80.79h.03v-3.22h-.03v3.22z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45.54 80.79h.03v-3.22h-.03v3.22z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Building104 = (Building104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Building56.tsx


var Building56_excluded = ["className"];
function Building56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Building56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Building56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Building56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Building56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Building56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Building56_objectSpread(Building56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M9.37 11.45v38.4l3.76-.09-.97-3.1-.53-35.21H9.37z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m16.72 6.12.53 4.86.97.46-3.76.01V6.12h2.26z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.05 16.96v32.62l3.75-.07-.96-2.61-.53-29.94h-2.26z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M5.99 49.86h44.02v-.02H5.99v.02z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M14.45 11.45h15.24V6.37H14.45v5.08z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29.69 49.85h16.93V17.38H29.69v32.47z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.77 17.38v-5.93H9.37v38.4h20.32V17.38h5.08z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29.69 22.46h11.85v-.01H29.69v.01z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29.69 27.54h11.85v-.02H29.69v.02z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29.69 32.62h11.85v-.02H29.69v.02z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29.69 37.7h11.85v-.02H29.69v.02z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29.69 42.78h11.85v-.02H29.69v.02z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M14.44 19.64h.02v-1.69h-.02v1.69z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19.52 19.64h.02v-1.69h-.02v1.69z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.6 19.64h.02v-1.69h-.02v1.69z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M14.44 25.57h.02v-1.69h-.02v1.69z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19.52 25.57h.02v-1.69h-.02v1.69z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.6 25.57h.02v-1.69h-.02v1.69z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M14.44 31.5h.02v-1.7h-.02v1.7z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19.52 31.5h.02v-1.7h-.02v1.7z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.6 31.5h.02v-1.7h-.02v1.7z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M14.44 37.42h.02v-1.69h-.02v1.69z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19.52 37.42h.02v-1.69h-.02v1.69z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.6 37.42h.02v-1.69h-.02v1.69z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M14.44 43.35h.02v-1.69h-.02v1.69z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19.52 43.35h.02v-1.69h-.02v1.69z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.6 43.35h.02v-1.69h-.02v1.69z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Building56 = (Building56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BusinessIdeas104.tsx


var BusinessIdeas104_excluded = ["className"];
function BusinessIdeas104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BusinessIdeas104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BusinessIdeas104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BusinessIdeas104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BusinessIdeas104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BusinessIdeas104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BusinessIdeas104_objectSpread(BusinessIdeas104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60 74.75v1.2a2.77 2.77 0 0 1-2.77 2.77H45.12c-2.19 0-3.97-1.78-3.97-3.97.01-.88.72-1.59 1.6-1.6h.84v1.91c.01.79.64 1.42 1.43 1.43h13.1c.79 0 1.44-.64 1.45-1.43v-1.53c.3.33.45.77.42 1.22Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.94 93.48H21.11c-2.67 0-4.83-1.56-4.83-3.53V66.11c.02 1.41.36 2.79 1.01 4.04.04.07.11.11.19.11h26.44c-.26.27-.4.64-.4 1.01v1.16H21.37c-.63.03-1.12.56-1.09 1.19.01.26.11.52.29.71 8.16 7.74 26.07 13.35 38.01 16.5 1.98.48 1.47 2.63-.65 2.63ZM87.98 70.38v1.77c0 .11-.08.19-.19.19H59.5v-1.16c0-.38-.14-.74-.4-1.01h28.61c.11-.03.23.03.26.14v.07Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.82 37.69c1.46.3 1.29.24 1.64.06-1.71-1.17-4.59-2.45-4.58-7.16 0-2.23.43-4.17.98-5.76.33-.95-.95-1.63-1.53-.8-1.18 1.68-2.05 3.83-2.21 6.94-.08 1.61-.02 3.18.34 4.69-.09-.04-.14-.07-.14-.07.64 2.62 2.01 5.03 4.01 6.94 1.9 1.81 3.16 4.27 3.6 6.96.04.26.19.49.4.63.25.17.41.43.39.72l-.16 2.66c0 .4.72.83 1.12.83l.39.03c.46 1.49 1.13 2.2 1.82 2.55.64.32 1.32-.27 1.21-.98-.08-.52.06-1.09.56-1.61h-.41c-.28 0-.55-.13-.71-.36-.74-1.05-.44-2.34-.15-3.12.13-.34.45-.57.82-.57h6.05c.46 0 .85-.33.93-.79.45-2.67 1.75-5.14 3.76-7.12 1.5-1.48 2.58-3.32 3.28-5.28.25-.69-.43-1.35-1.13-1.1-8.98 3.21-15.89 2.76-20.29 1.71Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.67 36.35H35.3a3.817 3.817 0 0 0-3.97 3.53v6.37h5.34v-3.24c0-1.05.85-1.91 1.91-1.91h19.34M87.22 72.42v19.34c0 .96-.78 1.74-1.74 1.74H18.42c-.95 0-1.72-.77-1.72-1.72V72.42"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.39 73.15h-24.8c-1.45 0-2.63-1.18-2.63-2.63V48.95c0-1.45 1.18-2.63 2.63-2.63h43.7M59.51 73.15h25.9c1.45 0 2.63-1.18 2.63-2.63V47.25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "43.52",
        y: "69.73",
        width: "15.98",
        height: "6.81",
        rx: "2.75",
        ry: "2.75"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M87.75 35.36c-17.3 6.86-27.42.21-27.42.21"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M59.88 30.67c.61-6.69 5.86-12.08 12.48-12.82.55-.06 1.09-.09 1.64-.09 3.49 0 6.79 1.26 9.42 3.63 3 2.7 4.72 6.58 4.72 10.63s-1.51 7.49-4.27 10.19c-2.01 1.98-3.3 4.45-3.75 7.12-.08.46-.47.79-.93.79H68.78c-.46 0-.86-.34-.93-.79-.44-2.69-1.7-5.15-3.6-6.96-3.18-3.03-4.76-7.29-4.36-11.7Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M78.1 54.32h-8.46c-.62 0-1.12-.5-1.12-1.12v-2.81c0-.07.05-.12.12-.12h10.58c.12 0 .21.1.21.21v2.5c0 .74-.6 1.34-1.34 1.34Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M70.44 54.32c.26 1.68 1.7 2.98 3.46 2.98s3.2-1.29 3.46-2.98h-6.92Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m93.07 23.94-3.24 1.57m-4.99-11.05-2.17 2.87m-8.69-6.31v3.59m-10.37-.42 1.93 3.03m-10.42 4.91 3.11 1.81"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BusinessIdeas104 = (BusinessIdeas104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BusinessIdeas56.tsx


var BusinessIdeas56_excluded = ["className"];
function BusinessIdeas56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BusinessIdeas56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BusinessIdeas56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BusinessIdeas56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BusinessIdeas56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BusinessIdeas56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BusinessIdeas56_objectSpread(BusinessIdeas56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.13 40v.64c0 .81-.66 1.48-1.48 1.48h-6.46c-1.17 0-2.12-.95-2.12-2.12 0-.47.38-.85.85-.85h.45v1.02c0 .42.34.76.76.76h6.99c.42 0 .77-.34.77-.76v-.81c.16.18.24.41.22.65Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.03 49.99H11.38c-1.42 0-2.57-.83-2.57-1.88V35.39c0 .75.19 1.49.54 2.16.02.04.06.06.1.06h14.1a.78.78 0 0 0-.21.54v.62H11.53a.6.6 0 0 0-.58.64c0 .14.06.28.16.38 4.36 4.13 13.91 7.12 20.28 8.8 1.06.25.78 1.4-.35 1.4ZM47.05 37.67v.95a.1.1 0 0 1-.1.1H31.86v-.62c0-.2-.08-.39-.21-.54h15.26c.06-.02.12.02.14.08v.03Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.23 20.23c.78.16.69.13.87.03-.91-.62-2.45-1.31-2.45-3.82 0-1.19.23-2.23.52-3.07.18-.51-.51-.87-.81-.43-.63.9-1.09 2.05-1.18 3.7-.04.86-.01 1.7.18 2.5s-.07-.04-.07-.04a7.56 7.56 0 0 0 2.14 3.7c1.01.97 1.68 2.28 1.92 3.71.02.14.1.26.21.33.13.09.22.23.21.39l-.08 1.42c0 .21.39.44.6.44l.21.02c.25.8.6 1.18.97 1.36.34.17.71-.14.65-.52-.04-.28.03-.58.3-.86h-.22c-.15 0-.29-.07-.38-.19-.39-.56-.23-1.25-.08-1.67.07-.18.24-.3.44-.3h3.23c.25 0 .46-.18.5-.42.24-1.42.93-2.74 2-3.8.8-.79 1.38-1.77 1.75-2.82a.466.466 0 0 0-.6-.59c-4.79 1.71-8.48 1.47-10.82.91Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.82 19.51H18.95c-1.1-.05-2.04.79-2.12 1.88v3.4h2.85v-1.73c0-.56.46-1.02 1.02-1.02h10.32M46.65 38.76v10.32c0 .51-.41.93-.93.93H9.94c-.51 0-.92-.41-.92-.92V38.76"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.26 39.14H10.03c-.78 0-1.4-.63-1.4-1.4V26.23c0-.78.63-1.4 1.4-1.4h23.31M31.86 39.14h13.82c.78 0 1.4-.63 1.4-1.4V25.33"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "23.33",
        y: "37.32",
        width: "8.53",
        height: "3.63",
        rx: "1.47",
        ry: "1.47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.93 18.99c-9.23 3.66-14.63.11-14.63.11"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.06 16.48c.32-3.57 3.13-6.44 6.66-6.84.29-.03.58-.05.87-.05 1.86 0 3.62.67 5.03 1.94 1.6 1.44 2.52 3.51 2.52 5.67s-.81 4-2.28 5.44a6.914 6.914 0 0 0-2 3.8c-.04.24-.25.42-.5.42h-5.55c-.25 0-.46-.18-.5-.42-.24-1.43-.91-2.75-1.92-3.71-1.69-1.61-2.54-3.89-2.33-6.24Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41.78 29.1h-4.51c-.33 0-.6-.27-.6-.6V27s.03-.06.06-.06h5.64c.06 0 .11.05.11.11v1.33c0 .39-.32.71-.71.71Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.69 29.1c.14.9.91 1.59 1.84 1.59s1.71-.69 1.85-1.59h-3.69Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m49.77 12.89-1.73.84m-2.66-5.9-1.16 1.53M39.58 6v1.92m-5.53-.23 1.03 1.62m-5.56 2.62 1.66.97"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BusinessIdeas56 = (BusinessIdeas56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BusinessOperation104.tsx


var BusinessOperation104_excluded = ["className"];
function BusinessOperation104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BusinessOperation104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BusinessOperation104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BusinessOperation104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BusinessOperation104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BusinessOperation104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BusinessOperation104_objectSpread(BusinessOperation104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.95 30.01c-2.89 28.6 17.81 20.65 17.12 32.01v4h-2.48c-.63-.04-1.11-.57-1.1-1.19V59.4c-2.46-.53-4.81-1.5-6.93-2.87l-3.85 3.85c-.46.46-1.21.46-1.67 0l-4.68-4.83c-.46-.46-.46-1.21 0-1.67l3.85-3.85a21.49 21.49 0 0 1-2.81-6.89h-5.41c-.65 0-1.17-.53-1.17-1.17v-6.66c0-.65.53-1.17 1.17-1.17h5.39c.35-1.52.75-2.99 1.33-4.39.19-.89 1.43-.62 1.24.27Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.64 73.17c4.44 18.3 15.86 8.96 17.88 16.4l.87 2.58-1.62.5c-.41.1-.83-.13-.96-.54l-1.15-3.48c-1.7.18-3.42.05-5.08-.37l-1.67 3.29c-.2.4-.68.56-1.08.37l-4.1-2.06c-.4-.2-.56-.68-.37-1.08l1.65-3.27a14.362 14.362 0 0 1-3.31-3.85l-3.5 1.14a.786.786 0 0 1-1.01-.47v-.03l-1.42-4.35c-.15-.41.06-.86.47-1.01h.03l3.48-1.15c-.09-.87-.16-1.74-.15-2.61 0-.83.92-.86 1.06 0Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m16.74 21.39 4.81-4.77c.47-.46 1.22-.46 1.69 0l3.85 3.85c2.13-1.36 4.49-2.32 6.97-2.85v-4.83c-.01-.98.77-1.78 1.75-1.79h5.64c.99 0 1.79.8 1.79 1.79v4.96c2.47.55 4.82 1.52 6.95 2.89l3.85-3.85c.46-.47 1.22-.47 1.69 0l4.77 4.81c.47.46.47 1.22 0 1.69l-3.85 3.85c1.36 2.13 2.33 4.49 2.85 6.97h5.45c.66 0 1.19.53 1.19 1.19v6.79a1.21 1.21 0 0 1-1.21 1.19h-5.47c-.55 2.47-1.53 4.82-2.91 6.95l3.85 3.85c.46.47.46 1.22 0 1.69l-4.81 4.79c-.46.47-1.22.47-1.69 0l-3.85-3.85a21.153 21.153 0 0 1-6.97 2.85v5.45a1.21 1.21 0 0 1-1.21 1.19h-6.79c-.66 0-1.19-.53-1.19-1.19v-5.56c-2.47-.54-4.83-1.53-6.95-2.91l-3.85 3.85c-.47.46-1.22.46-1.69 0l-4.77-4.81c-.46-.47-.46-1.22 0-1.69l3.85-3.85c-1.35-2.14-2.31-4.5-2.85-6.97h-5.47a1.21 1.21 0 0 1-1.19-1.21v-6.77c-.01-.66.51-1.2 1.17-1.21h5.52c.54-2.47 1.52-4.82 2.89-6.95l-3.85-3.85c-.46-.47-.44-1.23.03-1.69Zm13.65 8.05c-5.02 4.53-5.42 12.27-.89 17.29s12.27 5.42 17.29.89 5.42-12.27.89-17.29c-.28-.31-.58-.61-.89-.89-4.66-4.19-11.73-4.19-16.4 0Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m56.56 67.96 2.08-4.14c.19-.4.68-.57 1.08-.37h.02l3.33 1.67c1.07-1.34 2.38-2.48 3.85-3.37l-1.04-3.14c-.21-.65.14-1.34.78-1.56l3.62-1.19c.64-.22 1.34.13 1.56.77l1.04 3.16c1.71-.2 3.45-.07 5.12.37l1.67-3.33c.21-.39.7-.55 1.1-.35l4.16 2.08c.4.2.55.69.35 1.09l-1.65 3.31a14.69 14.69 0 0 1 3.35 3.85l3.54-1.17c.42-.14.88.09 1.02.52L93 70.62c.14.43-.09.89-.52 1.04l-3.52 1.15c.18 1.72.05 3.46-.37 5.14l3.31 1.65c.4.21.56.71.37 1.12l-2.1 4.14c-.21.4-.69.56-1.1.37l-3.31-1.67a14.607 14.607 0 0 1-3.85 3.37l1.15 3.52c.15.42-.07.88-.49 1.03h-.03l-4.39 1.46a.829.829 0 0 1-1.04-.52l-1.17-3.48c-1.72.18-3.46.06-5.14-.37l-1.65 3.31c-.19.4-.68.57-1.08.37h-.02l-4.16-2.08a.837.837 0 0 1-.37-1.1l1.67-3.31a14.69 14.69 0 0 1-3.35-3.85l-3.5 1.06a.85.85 0 0 1-1.04-.52l-1.44-4.41c-.14-.42.08-.88.51-1.02.02 0 .03-.01.05-.02l3.52-1.15c-.19-1.72-.08-3.46.33-5.14l-3.31-1.67a.831.831 0 0 1-.4-1.1Zm10.6 2.25c-2.28 4.01-.87 9.11 3.14 11.39 4.01 2.28 9.11.87 11.39-3.14 2.28-4.01.87-9.11-3.14-11.39a8.353 8.353 0 0 0-11.38 3.14Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BusinessOperation104 = (BusinessOperation104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BusinessOperation56.tsx


var BusinessOperation56_excluded = ["className"];
function BusinessOperation56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BusinessOperation56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BusinessOperation56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BusinessOperation56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BusinessOperation56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BusinessOperation56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BusinessOperation56_objectSpread(BusinessOperation56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.34 16.2c-1.55 15.35 9.56 11.08 9.19 17.18v2.15H19.2a.629.629 0 0 1-.59-.64v-2.91c-1.32-.29-2.58-.81-3.72-1.54l-2.07 2.07c-.25.25-.65.25-.9 0l-2.51-2.59a.634.634 0 0 1 0-.9l2.07-2.07c-.71-1.13-1.22-2.39-1.51-3.7h-2.9c-.35 0-.63-.28-.63-.63v-3.57c0-.35.28-.63.63-.63H9.96c.19-.82.4-1.61.71-2.36.1-.48.77-.33.67.14Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.17 39.36c2.38 9.82 8.51 4.81 9.59 8.8l.46 1.38-.87.27a.44.44 0 0 1-.52-.29l-.62-1.87c-.91.09-1.84.03-2.73-.2l-.9 1.77c-.11.21-.36.3-.58.2l-2.2-1.1a.443.443 0 0 1-.2-.58l.89-1.76a7.85 7.85 0 0 1-1.78-2.07l-1.88.61a.419.419 0 0 1-.54-.25v-.01l-.76-2.33c-.08-.22.03-.46.25-.54h.01l1.87-.62c-.05-.47-.09-.93-.08-1.4 0-.45.49-.46.57 0Z",
        className: "shadesecondary"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m9.08 11.58 2.58-2.56c.25-.25.66-.25.91 0l2.07 2.07c1.15-.73 2.41-1.24 3.74-1.53V6.97c0-.52.41-.95.94-.96h3.02c.53 0 .96.43.96.96v2.66c1.32.29 2.59.82 3.73 1.55l2.07-2.07c.25-.25.65-.25.91 0l2.56 2.58c.25.25.25.65 0 .91l-2.07 2.07c.73 1.14 1.25 2.41 1.53 3.74h2.92c.35 0 .64.29.64.64v3.65c0 .36-.3.64-.65.64h-2.93c-.29 1.33-.82 2.59-1.56 3.73l2.07 2.07c.25.25.25.66 0 .91l-2.58 2.57c-.25.25-.65.25-.91 0l-2.07-2.07c-1.14.73-2.41 1.25-3.74 1.53V35c0 .36-.3.64-.65.64h-3.65c-.35 0-.64-.29-.64-.64v-2.98c-1.33-.29-2.59-.82-3.73-1.56l-2.07 2.07c-.25.25-.66.25-.91 0l-2.56-2.58a.646.646 0 0 1 0-.91l2.07-2.07c-.72-1.15-1.24-2.41-1.53-3.74H6.62c-.36 0-.64-.3-.64-.65v-3.63c0-.35.28-.64.63-.65h2.96c.29-1.32.82-2.59 1.55-3.73L9.05 12.5a.637.637 0 0 1 .02-.91Zm7.32 4.31a6.575 6.575 0 0 0-.48 9.28 6.575 6.575 0 0 0 9.28.48 6.575 6.575 0 0 0 0-9.76 6.58 6.58 0 0 0-8.8 0Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m30.45 36.56 1.12-2.22c.1-.22.36-.31.58-.2l1.79.9c.58-.72 1.27-1.33 2.07-1.81l-.56-1.68c-.11-.35.07-.72.42-.84l1.94-.64c.34-.12.72.07.84.41l.56 1.69c.92-.1 1.85-.04 2.75.2l.9-1.79c.11-.21.37-.29.59-.19l2.23 1.12c.21.11.3.37.19.58l-.89 1.78c.71.58 1.32 1.28 1.8 2.07l1.9-.63c.23-.07.47.05.55.28l.78 2.4c.08.23-.05.48-.28.56l-1.89.62c.09.92.03 1.86-.2 2.76l1.78.89c.22.11.3.38.2.6l-1.13 2.22c-.11.21-.37.3-.59.2l-1.78-.9c-.58.72-1.27 1.33-2.07 1.81l.62 1.89c.08.23-.04.47-.27.55h-.01l-2.35.78a.444.444 0 0 1-.56-.28l-.63-1.87c-.92.1-1.86.03-2.76-.2l-.89 1.78c-.1.22-.36.31-.58.2l-2.23-1.12a.455.455 0 0 1-.2-.59l.9-1.78a8.114 8.114 0 0 1-1.8-2.07l-1.88.57a.457.457 0 0 1-.56-.28l-.77-2.36c-.08-.23.05-.47.27-.55h.03l1.89-.62c-.1-.92-.04-1.86.18-2.76l-1.78-.9a.45.45 0 0 1-.22-.59Zm5.69 1.21a4.484 4.484 0 0 0 1.68 6.11c2.15 1.22 4.89.47 6.11-1.68 1.22-2.15.47-4.89-1.68-6.11-.13-.08-.27-.14-.41-.21-2.1-.92-4.57-.11-5.7 1.89Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BusinessOperation56 = (BusinessOperation56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BusinessSoftware104.tsx


var BusinessSoftware104_excluded = ["className"];
function BusinessSoftware104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BusinessSoftware104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BusinessSoftware104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BusinessSoftware104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BusinessSoftware104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BusinessSoftware104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BusinessSoftware104_objectSpread(BusinessSoftware104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m73.02 63.86-.97 2.22-1.38-.6a.706.706 0 0 1-.32-.93l1.31-3.01c-1.24-.89-2.3-2-3.15-3.26l-3.06 1.2a.728.728 0 0 1-.93-.4l-1.42-3.81c-.14-.37.04-.78.4-.93l3.06-1.2c-.23-1.49-.19-3.02.11-4.5l-3-1.31a.712.712 0 0 1-.37-.93l1.61-3.69c.16-.36.57-.52.93-.37h.01l2.98 1.3c.89-1.2 1.98-2.23 3.23-3.05-10.13 16.5 4.16 16.94.94 23.26ZM46.77 58.81l-.14 1.64-1.02-.11a.486.486 0 0 1-.4-.53l.2-2.21c-.99-.31-1.91-.8-2.73-1.43l-1.72 1.42c-.21.17-.51.15-.69-.06L38.5 55.4a.491.491 0 0 1 .06-.69l1.71-1.41c-.47-.92-.78-1.91-.9-2.93l-2.22-.22a.488.488 0 0 1-.45-.51v-.02l.26-2.75c.02-.26.24-.46.51-.45h.02l2.21.2c.31-.98.8-1.9 1.44-2.71-3 12.92 6.35 10.09 5.64 14.9Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.06 30.25v43.46H56c.25-1.89-1.31-3.42-4.68-4.57-5.04-1.73-19.84-9.16-25.61-22.63-5.77-13.47-4.6-17.97-7.56-18.84-.22-.06-.43-.12-.64-.17-1.77-.43-3.46.95-3.46 2.75Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.32 77.58H45.68M90 70.75v3.04M14.4 73.79V26.98c0-1.61 1.31-2.91 2.91-2.91h69.77c1.61 0 2.91 1.31 2.91 2.91v3.84M11 74.43h82c1.1 0 2 .9 2 2v1.15a3.15 3.15 0 0 1-3.15 3.15h-79.7A3.15 3.15 0 0 1 9 77.58v-1.15c0-1.1.9-2 2-2Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "52",
        cy: "28.27",
        rx: "1.05",
        ry: "1.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m71.02 36.19 3.82-1.48c.37-.14.79.04.94.41l1.2 3.06c1.51-.24 3.05-.2 4.55.1l1.17-2.68c.23-.54.86-.8 1.4-.57h.02l3.1 1.35c.55.24.8.88.56 1.42l-1.2 2.75c1.24.9 2.3 2.01 3.15 3.28l3.06-1.2c.37-.15.79.03.94.4l1.48 3.82c.15.37-.03.79-.4.94l-3.06 1.2c.24 1.51.21 3.05-.1 4.55l3.02 1.32c.37.16.53.58.37.95l-1.64 3.77c-.17.36-.59.53-.96.37l-3.03-1.32c-.9 1.24-2.01 2.3-3.29 3.15l1.2 3.06c.14.37-.04.79-.41.94l-3.82 1.49a.722.722 0 0 1-.94-.4l-1.2-3.06c-1.51.24-3.05.2-4.55-.1l-1.32 3.02c-.17.36-.59.53-.96.37l-3.77-1.64c-.37-.16-.53-.58-.37-.95v-.01l1.34-3.07c-1.24-.9-2.31-2.01-3.15-3.29l-3.06 1.2a.735.735 0 0 1-.94-.41l-1.48-3.82c-.14-.37.04-.79.41-.94l3.06-1.2c-.23-1.51-.2-3.05.1-4.55l-3.03-1.32a.738.738 0 0 1-.37-.96l1.64-3.75a.72.72 0 0 1 .94-.39h.01l3.05 1.33c.9-1.24 2.01-2.3 3.28-3.15l-1.2-3.06c-.14-.37.05-.79.43-.93Zm5.62 7.75a7.398 7.398 0 0 0-4.67 9.37 7.398 7.398 0 0 0 9.37 4.67 7.398 7.398 0 0 0 4.39-10.08 7.41 7.41 0 0 0-9.09-3.96ZM39.27 41.28l2.15-1.79a.49.49 0 0 1 .69.05l1.44 1.73c.92-.49 1.92-.8 2.95-.94l.18-1.99c.04-.41.4-.71.81-.67l2.29.21c.41.04.71.39.68.8l-.19 2c1 .31 1.93.79 2.75 1.44l1.73-1.44a.5.5 0 0 1 .69.07l1.8 2.16c.17.21.14.52-.07.69l-1.72 1.43c.48.92.79 1.91.93 2.94l2.25.2c.27.03.47.26.44.53l-.27 2.83c-.03.27-.27.47-.54.45l-2.23-.21c-.32 1-.81 1.93-1.44 2.76l1.43 1.72c.17.22.14.53-.07.71l-2.16 1.79c-.21.17-.52.14-.7-.06l-1.43-1.73c-.92.49-1.92.8-2.95.94l-.21 2.23c-.02.27-.25.47-.52.45h-.02l-2.79-.25a.508.508 0 0 1-.45-.54l.19-2.21c-1-.31-1.93-.8-2.76-1.44l-1.72 1.43a.49.49 0 0 1-.69-.05l-1.8-2.16a.513.513 0 0 1 .06-.7l1.73-1.43c-.48-.92-.79-1.91-.93-2.94l-2.2-.26a.508.508 0 0 1-.45-.54l.26-2.79c.02-.27.26-.47.53-.44h.03l2.23.21c.31-1 .79-1.93 1.42-2.77l-1.43-1.73a.514.514 0 0 1 .04-.71Zm5.33 3.81a5.054 5.054 0 0 0-1.01 7.07 5.054 5.054 0 0 0 7.07 1.01 5.054 5.054 0 0 0 1.01-7.07 5.046 5.046 0 0 0-7.07-1.01Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BusinessSoftware104 = (BusinessSoftware104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BusinessSoftware56.tsx


var BusinessSoftware56_excluded = ["className"];
function BusinessSoftware56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BusinessSoftware56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BusinessSoftware56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BusinessSoftware56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BusinessSoftware56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BusinessSoftware56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BusinessSoftware56_objectSpread(BusinessSoftware56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m38.79 33.35-.48 1.1-.68-.3a.35.35 0 0 1-.16-.46l.65-1.49c-.61-.44-1.14-.99-1.55-1.61l-1.51.59a.358.358 0 0 1-.46-.2l-.7-1.88c-.07-.18.02-.39.2-.46l1.51-.59c-.11-.74-.09-1.49.05-2.22l-1.48-.65c-.18-.08-.26-.28-.18-.46l.79-1.82c.08-.18.28-.26.46-.18l1.47.64c.44-.59.98-1.1 1.6-1.51-5 8.15 2.06 8.37.47 11.49ZM25.82 30.86l-.07.81-.5-.06a.24.24 0 0 1-.2-.26l.1-1.09a4.37 4.37 0 0 1-1.35-.71l-.85.7c-.1.09-.25.07-.34-.03l-.88-1.05c-.09-.1-.07-.25.03-.34l.84-.7c-.23-.45-.39-.94-.45-1.45l-1.09-.11c-.13 0-.23-.12-.22-.25l.13-1.36c0-.13.12-.23.25-.22l1.09.1c.15-.49.39-.94.71-1.34-1.48 6.38 3.14 4.99 2.79 7.36Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M8.59 16.69v22.24h21.46c.13-.97-.67-1.75-2.39-2.34-2.58-.89-10.15-4.69-13.1-11.58-2.95-6.89-2.35-9.2-3.87-9.64l-.33-.09c-.9-.22-1.77.49-1.77 1.41Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.24 40.93h-6.48M7.56 39.4h40.93c.55 0 1 .45 1 1v.31c0 .99-.81 1.8-1.8 1.8H8.36c-.99 0-1.8-.81-1.8-1.8v-.31c0-.55.45-1 1-1ZM47.45 36.84v2.4M8.75 39.24V14.78c0-.73.6-1.33 1.33-1.33h36.03c.73 0 1.33.6 1.33 1.33v2.47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "28",
        cy: "15.86",
        rx: ".52",
        ry: ".53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m37.8 19.68 1.89-.73c.18-.07.39.02.46.2l.59 1.51a6.3 6.3 0 0 1 2.25.05l.58-1.32c.11-.27.42-.39.69-.28h.01l1.53.67c.27.12.39.43.28.7l-.59 1.36c.61.44 1.14.99 1.56 1.62l1.51-.59c.18-.07.39.02.46.2l.73 1.89c.07.18-.02.39-.2.46l-1.51.59c.12.75.1 1.51-.05 2.25l1.49.65c.18.08.26.29.18.47l-.81 1.86c-.08.18-.29.26-.47.18l-1.5-.65a6.21 6.21 0 0 1-1.63 1.56l.59 1.51c.07.18-.02.39-.2.46l-1.89.74a.358.358 0 0 1-.46-.2l-.59-1.51a6.3 6.3 0 0 1-2.25-.05l-.65 1.49c-.08.18-.29.26-.47.18l-1.86-.81c-.18-.08-.26-.29-.18-.47l.66-1.52a6.21 6.21 0 0 1-1.56-1.63l-1.51.59a.358.358 0 0 1-.46-.2l-.73-1.89c-.07-.18.02-.39.2-.46l1.51-.59c-.11-.75-.1-1.51.05-2.25l-1.5-.65c-.18-.08-.26-.29-.18-.47l.81-1.86c.08-.18.28-.27.47-.19l1.51.66c.44-.61.99-1.14 1.62-1.56l-.59-1.51c-.07-.18.03-.39.21-.46Zm2.78 3.83a3.655 3.655 0 0 0-2.31 4.63 3.655 3.655 0 0 0 4.63 2.31 3.655 3.655 0 0 0 2.17-4.98 3.67 3.67 0 0 0-4.49-1.96ZM22.12 22.2l1.06-.88c.1-.09.25-.07.34.03l.71.86c.45-.24.95-.4 1.46-.46l.09-.98c.02-.2.2-.35.4-.33l1.13.11c.2.02.35.19.33.4l-.09.99c.49.15.95.39 1.36.71l.86-.71c.11-.08.26-.07.34.04l.89 1.07c.08.1.07.26-.03.34l-.85.71c.24.45.39.95.46 1.45l1.11.1c.13.01.23.13.22.26l-.13 1.4c-.01.13-.13.23-.27.22l-1.1-.1c-.16.49-.4.95-.71 1.36l.71.85c.08.11.07.26-.03.35l-1.07.88c-.1.08-.26.07-.34-.03l-.71-.85c-.45.24-.95.4-1.46.46l-.1 1.1c0 .13-.13.23-.26.22l-1.38-.12a.248.248 0 0 1-.22-.27l.09-1.09c-.49-.15-.96-.4-1.36-.71l-.85.71c-.1.09-.25.07-.34-.03l-.89-1.07c-.08-.1-.07-.26.03-.34l.85-.71c-.24-.45-.39-.95-.46-1.45l-1.09-.13a.254.254 0 0 1-.22-.27l.13-1.38c.01-.13.13-.23.26-.22h.02l1.1.1c.15-.49.39-.96.7-1.37l-.71-.85c-.09-.1-.08-.26.02-.35Zm2.63 1.88c-1.1.83-1.33 2.39-.5 3.49.83 1.1 2.39 1.33 3.49.5 1.1-.83 1.33-2.39.5-3.49-.05-.07-.11-.13-.16-.2a2.493 2.493 0 0 0-3.33-.3Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BusinessSoftware56 = (BusinessSoftware56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BusinessStrategy104.tsx


var BusinessStrategy104_excluded = ["className"];
function BusinessStrategy104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BusinessStrategy104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BusinessStrategy104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BusinessStrategy104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BusinessStrategy104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BusinessStrategy104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BusinessStrategy104_objectSpread(BusinessStrategy104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M83.95 26H73.86C72.28 26 71 24.48 71 22.61V10c0-.55-.45-1-1-1s-1 .45-1 1v12.61c0 2.97 2.18 5.39 4.86 5.39h10.09c.55 0 1-.45 1-1s-.45-1-1-1ZM19.04 60.45l1.15 26.68c0 3.09 2.51 5.6 5.6 5.6h25.17c2.04 0 2.61-2.79.73-3.58-10.53-4.43-24.81-12.09-29.22-27.58-1.02-4.07-3.45-1.78-3.43-1.11Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.05 50.23c-5.25-1.95-8.3-6.9-9.41-11.5-.23-.94-1.52-.97-1.8-.04-.5 1.65-.67 4.11.59 7.39 1.63 4.21 6.75 5.83 10.27 5.96 1.07.04 1.35-1.43.35-1.81Z",
        className: "shadesecondary"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29.19 65.02h43.33M29.19 78.12h30.33M70.97 9.95v11.43c0 2.33 1.76 4.21 3.94 4.21h10.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M85.22 52.27V24.93c0-.52-.19-1.02-.54-1.4L72.07 9.81c-.37-.4-.89-.63-1.43-.63H23.78c-2.17 0-3.94 1.82-3.94 4.06v75.38c0 2.23 1.77 4.06 3.94 4.06h29.6M72.12 92.68h9.16c2.16 0 3.94-1.83 3.94-4.06v-9.18M48.06 92.68h.62"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "41.89",
        cy: "40.18",
        r: "12.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m35.93 41 3.43 3.43 7.6-7.61"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M95.93 55.82c1.93 1.93 2.24 3.73 2.11 4.73L69.86 88.72c-4.44 4.44-11.04 4.06-11.04 4.06s-.37-6.6 4.06-11.04l28.18-28.18c1-.12 2.81.19 4.73 2.11l.13.13Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m87.48 58.16 6.64 6.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m63.15 82.51 6.23 6.23"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BusinessStrategy104 = (BusinessStrategy104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/BusinessStrategy56.tsx


var BusinessStrategy56_excluded = ["className"];
function BusinessStrategy56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function BusinessStrategy56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BusinessStrategy56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BusinessStrategy56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function BusinessStrategy56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BusinessStrategy56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BusinessStrategy56_objectSpread(BusinessStrategy56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m11.01 32.64.59 13.81c0 1.6 1.3 2.9 2.9 2.9h13.03c1.06 0 1.35-1.45.38-1.86-5.45-2.3-12.85-6.26-15.13-14.28-.53-2.11-1.79-.92-1.77-.58Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.41 27.34c-2.72-1.01-4.3-3.57-4.87-5.95a.48.48 0 0 0-.93-.02c-.26.86-.35 2.13.31 3.83.84 2.18 3.49 3.02 5.32 3.08.56.02.7-.74.18-.94Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.27 35h22.44M16.27 41.78h15.7M37.9 6.49v5.92c0 1.2.91 2.18 2.04 2.18h5.33"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.28 28.4V14.24c0-.27-.1-.53-.28-.72l-6.53-7.1a1 1 0 0 0-.74-.33H13.47c-1.13 0-2.04.94-2.04 2.1v39.03c0 1.16.92 2.1 2.04 2.1H28.8M38.5 49.32h4.75c1.12 0 2.04-.95 2.04-2.1v-4.76M26.04 49.32h.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.85",
        cy: "22.14",
        r: "6.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m19.76 22.57 1.77 1.77 3.94-3.94"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.83 30.24c1 1 1.16 1.93 1.09 2.45L37.33 47.28c-2.3 2.3-5.71 2.1-5.71 2.1s-.19-3.42 2.1-5.71l14.59-14.59c.52-.06 1.45.1 2.45 1.09l.07.07Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m46.45 31.45 3.44 3.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m33.85 44.06 3.23 3.23"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BusinessStrategy56 = (BusinessStrategy56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Store104.tsx


var Store104_excluded = ["className"];
function Store104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Store104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Store104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Store104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Store104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Store104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Store104_objectSpread(Store104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m28.25 28.49-1.19 16.58v.38a5 5 0 0 0 5 4.92 5 5 0 0 0 5-4.92v-.38l1-16.58Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M75.78 28.48 77 45.06v.38a5 5 0 0 1-5 5 5 5 0 0 1-5-5v-.38l-1-16.58Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47 28.48v16.95a5 5 0 0 0 10 0v-16.9Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m53.68 18.88-.47 2.63a.66.66 0 0 1-.71.59h-2.14l.85-4.8a7.07 7.07 0 0 0-2.57-.66 2.12 2.12 0 0 0-1.64.62 1.74 1.74 0 0 0-.4 1.15c0 1.36 1.12 3.26 3 4.8a8.69 8.69 0 0 0 4.94 2.14 2.09 2.09 0 0 0 1.6-.61 1.66 1.66 0 0 0 .4-1.16c0-1.32-1.14-3.19-2.94-4.7"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.81 13.8a.71.71 0 0 0-.74.61l-.3 1.59h2.71l-1.16 6.15h2.14a.67.67 0 0 0 .71-.59l1-5.55h1.94a.71.71 0 0 0 .71-.57l.3-1.59Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M84 50.08V93.5M20 93.51V50.27"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M51 60.5h26v23H51z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.97 71.8h26"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.99 60.45h18v33h-18z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27 76.71h18"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.61 73.65v6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M61 24.5h20.93a3 3 0 0 1 3 3v1H19v-1a3 3 0 0 1 3-3h21"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M77 28.49H19l-2 16.9a5 5 0 0 0 10 0 5 5 0 0 0 10 .08 5 5 0 0 0 10 0 5 5 0 0 0 2.47 4.32 5 5 0 0 0 5 0A5 5 0 0 0 57 45.53a5 5 0 0 0 10 0 5 5 0 0 0 10 0 5 5 0 0 0 5 5 5 5 0 0 0 5-5l-2-16.9Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45 10.5h14a2 2 0 0 1 2 2v16H43v-16a2 2 0 0 1 2-2Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M17 93.5h70"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Store104 = (Store104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Store56.tsx


var Store56_excluded = ["className"];
function Store56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Store56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Store56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Store56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Store56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Store56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Store56_objectSpread(Store56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M7.21 21.45a4 4 0 0 0 4.21 3.8 4 4 0 0 0 4.21-3.8l1.48-13.3h-6.82A1.1 1.1 0 0 0 9.21 9Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.21 21.45a4 4 0 0 1-4.21 3.8 4 4 0 0 1-4.21-3.8l-1.48-13.3h6a2 2 0 0 1 2.08 1.63Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.08 21.45a4 4 0 0 0 4.21 3.8 4 4 0 0 0 4.21-3.8V8.15h-8.42Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.31 47.93h-29.1V25.09"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.91 29.95h10v18h-10z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.14 8.12a2 2 0 0 0-2.08 1.63L7.21 21.42a4 4 0 0 0 4.21 3.79 4 4 0 0 0 4.19-3.57 4 4 0 0 0 4.18 3.57A4 4 0 0 0 24 21.64a4 4 0 0 0 4.23 3.57 4 4 0 0 0 4.18-3.57 4 4 0 0 0 4.19 3.57 4 4 0 0 0 4.18-3.57 4.24 4.24 0 0 0 8.4-.22L47.27 9.75a2 2 0 0 0-2.06-1.63Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.21 25.09v22.84h-29.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.82 29.95h13.61v10.58H28.82z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Store56 = (Store56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/StoreAddress104.tsx


var StoreAddress104_excluded = ["className"];
function StoreAddress104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function StoreAddress104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? StoreAddress104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : StoreAddress104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function StoreAddress104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, StoreAddress104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", StoreAddress104_objectSpread(StoreAddress104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m28.25 28.49-1.19 16.58v.38a5 5 0 0 0 5 4.92 5 5 0 0 0 5-4.92v-.38l1-16.58Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M75.78 28.48 77 45.06v.38a5 5 0 0 1-5 5 5 5 0 0 1-5-5v-.38l-1-16.58Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47 28.48v16.95a5 5 0 0 0 10 0v-16.9Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m53.68 18.88-.47 2.63a.66.66 0 0 1-.71.59h-2.14l.85-4.8a7.07 7.07 0 0 0-2.57-.66 2.12 2.12 0 0 0-1.64.62 1.74 1.74 0 0 0-.4 1.15c0 1.36 1.12 3.26 3 4.8a8.69 8.69 0 0 0 4.94 2.14 2.09 2.09 0 0 0 1.6-.61 1.66 1.66 0 0 0 .4-1.16c0-1.32-1.14-3.19-2.94-4.7"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M74.57 80.46a15.28 15.28 0 0 1-2.11-7.81 13.87 13.87 0 0 1 8.64-13.32 12.34 12.34 0 0 0-9.49 19.22l8.84 13.82a1.53 1.53 0 0 0 1.34.87Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.81 13.8a.71.71 0 0 0-.74.61l-.3 1.59h2.71l-1.16 6.15h2.14a.67.67 0 0 0 .71-.59l1-5.55h2a.71.71 0 0 0 .7-.57l.3-1.59Z",
        className: "strokeinverted"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M84 50.41v3.89M20 93.46V49.94"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M65 83.5H51v-23h20"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.97 71.8H64"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.99 60.45h18v33h-18z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27 76.71h18"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.61 73.65v6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M61 24.5h20.93a3 3 0 0 1 3 3v1H19v-1a3 3 0 0 1 3-3h21"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M77 28.49H19l-2 16.9a5 5 0 0 0 10 0 5 5 0 0 0 10 .08 5 5 0 0 0 10 0 5 5 0 0 0 2.47 4.32 5 5 0 0 0 5 0A5 5 0 0 0 57 45.53a5 5 0 0 0 10 0 5 5 0 0 0 10 0 5 5 0 0 0 5 5 5 5 0 0 0 5-5l-2-16.9Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45 10.5h14a2 2 0 0 1 2 2v16H43v-16a2 2 0 0 1 2-2Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M80.45 92.37a1.51 1.51 0 0 0 2.75 0l8.87-13.82a12.34 12.34 0 1 0-20.46 0Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "81.86",
          cy: "71.64",
          r: "5.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M17 93.5h55"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_StoreAddress104 = (StoreAddress104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/StoreAddress56.tsx


var StoreAddress56_excluded = ["className"];
function StoreAddress56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function StoreAddress56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? StoreAddress56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : StoreAddress56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function StoreAddress56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, StoreAddress56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", StoreAddress56_objectSpread(StoreAddress56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40 43a10.15 10.15 0 0 1-1.4-5.18A9.21 9.21 0 0 1 44.33 29 8.19 8.19 0 0 0 38 41.76l5.86 9.16a1 1 0 0 0 .89.58Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M7.21 21.45a4 4 0 0 0 4.21 3.8 4 4 0 0 0 4.21-3.8l1.48-13.3h-6.82A1.1 1.1 0 0 0 9.21 9Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.21 21.45a4 4 0 0 1-4.21 3.8 4 4 0 0 1-4.21-3.8l-1.48-13.3h6a2 2 0 0 1 2.08 1.63Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.08 21.45a4 4 0 0 0 4.21 3.8 4 4 0 0 0 4.21-3.8V8.15h-8.42Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.21 25v1.77"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.31 47.93h-29.1V25.09"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M14.91 29.95h10v18h-10z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.76 40.53h-5.94V29.95h7.84"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.9 50.92a1 1 0 0 0 1.82 0l5.88-9.16a8.18 8.18 0 1 0-13.56 0Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "44.83",
          cy: "37.18",
          r: "3.51"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M11.14 8.12a2 2 0 0 0-2.08 1.63L7.21 21.42a4 4 0 0 0 4.21 3.79 4 4 0 0 0 4.19-3.57 4 4 0 0 0 4.18 3.57A4 4 0 0 0 24 21.64a4 4 0 0 0 4.23 3.57 4 4 0 0 0 4.18-3.57 4 4 0 0 0 4.19 3.57 4 4 0 0 0 4.18-3.57 4.24 4.24 0 0 0 8.4-.22L47.27 9.75a2 2 0 0 0-2.06-1.63Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_StoreAddress56 = (StoreAddress56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/EmptyStateBox104.tsx


var EmptyStateBox104_excluded = ["className"];
function EmptyStateBox104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function EmptyStateBox104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? EmptyStateBox104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EmptyStateBox104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function EmptyStateBox104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EmptyStateBox104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", EmptyStateBox104_objectSpread(EmptyStateBox104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.48 57.69 17 52v6.47l27.65 5.37a2.17 2.17 0 0 0 2.48-1.46L52 47.48l-.87-.16ZM52.72 47.07l-.72.12 3.82 14a2.18 2.18 0 0 0 2.48 1.57L87 57.63V52l-28.48 5.69ZM86.97 41.39 52 36.84l-34.97 4.55L52 45.94l34.97-4.55z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.68 53.04V70.6L52 78.48l35.32-7.88V53.04M52 78.28V48"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.88 42.06 7 50.84l38.41 7.68 6.44-11.8M87.12 42.06 97 50.84l-38.41 7.68-6.42-11.76M52 37.47l6.59-6.58 35.32 4.59-6.79 6.58"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m52.2 37.47-6.58-6.58-35.33 4.59 6.79 6.58"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M87.32 42.06 52 46.65l-35.32-4.59L52 37.47l35.32 4.59z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EmptyStateBox104 = (EmptyStateBox104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/EmptyStateBox56.tsx


var EmptyStateBox56_excluded = ["className"];
function EmptyStateBox56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function EmptyStateBox56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? EmptyStateBox56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EmptyStateBox56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function EmptyStateBox56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EmptyStateBox56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", EmptyStateBox56_objectSpread(EmptyStateBox56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.49 31.06 9.17 28v3.48l14.89 2.9a1.17 1.17 0 0 0 1.33-.79l2.61-8-.47-.08ZM28.39 25.34l-.39.07L30.06 33a1.17 1.17 0 0 0 1.33.84L46.83 31v-3l-15.32 3.06ZM46.83 22.29 28 19.84 9.17 22.29 28 24.73l18.83-2.44z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M8.98 28.56v9.46L28 42.26l19.02-4.24v-9.46M28 42.15v-16.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m9.09 22.65-5.32 4.73 20.68 4.13 3.47-6.35M46.91 22.65l5.32 4.73-20.68 4.13-3.46-6.33M28 20.18l3.55-3.55 19.02 2.47-3.66 3.55"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m28.11 20.18-3.55-3.55L5.54 19.1l3.66 3.55"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47.02 22.65 28 25.12 8.98 22.65 28 20.18l19.02 2.47z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EmptyStateBox56 = (EmptyStateBox56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/EmptyStateTray104.tsx


var EmptyStateTray104_excluded = ["className"];
function EmptyStateTray104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function EmptyStateTray104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? EmptyStateTray104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EmptyStateTray104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function EmptyStateTray104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EmptyStateTray104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", EmptyStateTray104_objectSpread(EmptyStateTray104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.73 80.56c-2-1.27-4.45-1.38-6.52-2.52-8.86-4.64-10.75-15.31-12.11-24.32-.39-2.25-.49-3.7-3.1-3.91v29.64a5 5 0 0 0 5 5h19a4.5 4.5 0 0 0-2.27-3.89Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M81 50.28H70.78v6.79a2 2 0 0 1-2 2H35.21a2 2 0 0 1-2-2v-6.79H23.08L26.45 36a4 4 0 0 1 3.9-3.13h43.33a4 4 0 0 1 3.9 3.13Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M89 84.19H15.05a4 4 0 0 1-4-4v-30a3 3 0 0 1 .27-1.19l13.05-28.91a1 1 0 0 1 .92-.59h53.62a1 1 0 0 1 .91.59L92.69 49a3 3 0 0 1 .31 1.19v30a4 4 0 0 1-4 4Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m79 19.5 7.39 26.83a3 3 0 0 1-2.84 4H71.28a.5.5 0 0 0-.5.5v6.29a2 2 0 0 1-2 2H35.21a2 2 0 0 1-2-2v-6.34a.5.5 0 0 0-.5-.5H20.48a3 3 0 0 1-2.84-4L25 19.5"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EmptyStateTray104 = (EmptyStateTray104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/EmptyStateTray56.tsx


var EmptyStateTray56_excluded = ["className"];
function EmptyStateTray56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function EmptyStateTray56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? EmptyStateTray56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EmptyStateTray56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function EmptyStateTray56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EmptyStateTray56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", EmptyStateTray56_objectSpread(EmptyStateTray56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.16 43.38c-1.07-.69-2.39-.74-3.51-1.36-4.77-2.49-5.79-8.24-6.52-13.09-.21-1.22-.26-2-1.67-2.11v16a2.72 2.72 0 0 0 2.72 2.68h10.2a2.43 2.43 0 0 0-1.22-2.12Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.59 27.07h-5.48v3.66A1.07 1.07 0 0 1 37 31.81H19a1.08 1.08 0 0 1-1.08-1.08v-3.66h-5.49l1.81-7.67a2.15 2.15 0 0 1 2.1-1.69h23.33a2.14 2.14 0 0 1 2.1 1.69Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47.9 45.33H8.1A2.15 2.15 0 0 1 6 43.18V27a1.71 1.71 0 0 1 .14-.67l7-15.54a.54.54 0 0 1 .5-.32h28.85a.54.54 0 0 1 .49.32l6.93 15.55a1.66 1.66 0 0 1 .14.66v16.18a2.15 2.15 0 0 1-2.15 2.15Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m42.54 10.5 4 14.45A1.61 1.61 0 0 1 45 27.07h-6.62a.27.27 0 0 0-.27.27v3.39A1.07 1.07 0 0 1 37 31.81H19a1.08 1.08 0 0 1-1.08-1.08v-3.39a.27.27 0 0 0-.26-.27H11a1.61 1.61 0 0 1-1.5-2.13l4-14.44"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EmptyStateTray56 = (EmptyStateTray56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Error104.tsx


var Error104_excluded = ["className"];
function Error104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Error104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Error104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Error104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Error104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Error104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Error104_objectSpread(Error104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M62.5 85.51c-5-2.09-11.1-2.27-16.28-4.14-22.15-7.65-26.89-25.23-30.28-40.07-.74-2.79-1.06-4.83-3.94-5.82v33.09L35.43 92h32.73c.33-2.61-2.3-5.08-5.66-6.49Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.43 12 12 35.43v33.14L35.43 92h33.14L92 68.57V35.43L68.57 12H35.43z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m57.39 52 10.77-10.77a3.81 3.81 0 1 0-5.39-5.39L52 46.61 41.23 35.84a3.81 3.81 0 0 0-5.39 0 3.81 3.81 0 0 0 0 5.39L46.61 52 35.84 62.77a3.81 3.81 0 0 0 0 5.39 3.81 3.81 0 0 0 5.39 0L52 57.39l10.77 10.77a3.81 3.81 0 1 0 5.39-5.39Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Error104 = (Error104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Error56.tsx


var Error56_excluded = ["className"];
function Error56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Error56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Error56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Error56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Error56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Error56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Error56_objectSpread(Error56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.25 44.76c-2.48-1-5.55-1.14-8.14-2.08C14 38.86 11.67 30.07 10 22.65c-.37-1.39-.53-2.42-2-2.91v16.54L19.72 48h16.36c.16-1.31-1.15-2.54-2.83-3.24Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19.72 8 8 19.72v16.56L19.72 48h16.56L48 36.28V19.72L36.28 8H19.72z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m30.55 28 5.1-5.1a1.8 1.8 0 0 0-2.55-2.55l-5.1 5.1-5.1-5.1a1.79 1.79 0 0 0-2.55 0 1.79 1.79 0 0 0 0 2.55l5.1 5.1-5.1 5.1a1.79 1.79 0 0 0 0 2.55 1.79 1.79 0 0 0 2.55 0l5.1-5.1 5.1 5.1a1.8 1.8 0 0 0 2.55-2.55Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Error56 = (Error56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Information104.tsx


var Information104_excluded = ["className"];
function Information104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Information104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Information104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Information104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Information104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Information104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Information104_objectSpread(Information104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.74 92.23c-22.57.2-41-17.6-41.24-39.76S29.44 12.18 52 12c0 0-29.39 16-29.17 40.39s29.9 39.86 29.9 39.86",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M51.37 46.64v28.32"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M92.5 51.89a40.13 40.13 0 1 1-40.12-40.13A40.12 40.12 0 0 1 92.5 51.89Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M53.38 34.85a2 2 0 1 0-2 2 2 2 0 0 0 2-2"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Information104 = (Information104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Information56.tsx


var Information56_excluded = ["className"];
function Information56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Information56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Information56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Information56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Information56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Information56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Information56_objectSpread(Information56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.37 48.43A20.38 20.38 0 1 1 28 7.68s-14.66 8.13-14.55 20.5 14.92 20.25 14.92 20.25",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.69 24.96v14.11"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.19 27.57a20 20 0 1 1-20-20 20 20 0 0 1 20 20Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.69 19.08a1 1 0 0 0-2 0 1 1 0 1 0 2 0",
        className: "strokeinverted"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Information56 = (Information56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/SomethingWentWrong104.tsx


var SomethingWentWrong104_excluded = ["className"];
function SomethingWentWrong104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function SomethingWentWrong104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SomethingWentWrong104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SomethingWentWrong104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function SomethingWentWrong104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SomethingWentWrong104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", SomethingWentWrong104_objectSpread(SomethingWentWrong104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 92.55a40.55 40.55 0 0 1 0-81.1S22.7 27.37 22.7 52 52 92.55 52 92.55",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M92.55 52A40.55 40.55 0 1 1 52 11.45 40.55 40.55 0 0 1 92.55 52Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.22 68.84a18.07 18.07 0 0 1 25.56 0"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45.8 42.68a4.3 4.3 0 1 1-4.3-4.3 4.3 4.3 0 0 1 4.3 4.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M66.8 42.68a4.3 4.3 0 1 1-4.3-4.3 4.31 4.31 0 0 1 4.3 4.3"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SomethingWentWrong104 = (SomethingWentWrong104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/SomethingWentWrong56.tsx


var SomethingWentWrong56_excluded = ["className"];
function SomethingWentWrong56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function SomethingWentWrong56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SomethingWentWrong56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SomethingWentWrong56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function SomethingWentWrong56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SomethingWentWrong56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", SomethingWentWrong56_objectSpread(SomethingWentWrong56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.89 48a20 20 0 0 1 0-40s-14.45 7.85-14.45 20 14.45 20 14.45 20",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48 28A20 20 0 1 1 28 8a20 20 0 0 1 20 20Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21.7 36.31a8.89 8.89 0 0 1 12.6 0"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.78 23.4a2.05 2.05 0 1 1-2.05-2 2 2 0 0 1 2.05 2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.32 23.4a2.05 2.05 0 1 1-2-2 2.05 2.05 0 0 1 2 2"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SomethingWentWrong56 = (SomethingWentWrong56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Success104.tsx


var Success104_excluded = ["className"];
function Success104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Success104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Success104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Success104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Success104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Success104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Success104_objectSpread(Success104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M54.15 86.18A36.55 36.55 0 0 1 17.77 49.8a36.14 36.14 0 0 1 7.52-22 36.32 36.32 0 1 0 50.89 50.86 36.14 36.14 0 0 1-22 7.52"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M58.99 11.91V2.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m67.69 13.05 2.49-9.29"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m75.8 16.4 4.8-8.32"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m82.77 21.73 6.79-6.79"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m88.12 28.69 8.32-4.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m91.48 36.8 9.28-2.49"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M92.64 45.5h9.6"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M83.15 50.31a36.09 36.09 0 0 1 .55 6.31 36.37 36.37 0 1 1-18.19-31.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m79.66 32.7-35.7 35.74-10.71-10.71"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Success104 = (Success104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Success56.tsx


var Success56_excluded = ["className"];
function Success56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Success56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Success56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Success56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Success56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Success56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Success56_objectSpread(Success56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M16.69 12.38c-13.78 21.3 4.6 39 25.59 31.07-2.53 2-17.1 13.43-29.6-2.17-10.23-12.78-2-24 4-28.9"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42.89 6.06v2.78"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m47.47 6.97-1.06 2.57"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m51.36 9.57-1.97 1.97"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m53.95 13.46-2.57 1.06"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M54.86 18.04h-2.78"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.57 25a21 21 0 0 1 .31 3.54 20.38 20.38 0 1 1-10.19-17.69"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m46.61 15.1-20 20.02-6-6"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Success56 = (Success56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Warning104.tsx


var Warning104_excluded = ["className"];
function Warning104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Warning104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Warning104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Warning104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Warning104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Warning104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Warning104_objectSpread(Warning104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.46 66.45C33.66 73 35 80.8 40.44 85c1.44 1.09 2.42 2 2.37 3.79-2.74-.18-32.79-.26-32.8-.49-.35-9.41 12-22 16.56-30.11C33 46.83 41.19 34.4 47.94 23.24c1.4-2.31 2.67-4.95 4.51-8a17.86 17.86 0 0 1 0 17.19c-6.84 11.31-13.5 21.13-17 34",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m8 88.32 44.45-73.7L96 88.32H8z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M52 65.71V40.59"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M54 75.39a2 2 0 1 1-2-2 2 2 0 0 1 2 2"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Warning104 = (Warning104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Warning56.tsx


var Warning56_excluded = ["className"];
function Warning56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Warning56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Warning56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Warning56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Warning56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Warning56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Warning56_objectSpread(Warning56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.73 35.38c-.9 3.27-.24 7.18 2.49 9.26.72.55 1.21 1 1.18 1.89C22 46.44 7 46.4 7 46.29c-.17-4.71 6-11 8.29-15 3.22-5.67 7.3-11.88 10.68-17.46.7-1.16 1.33-2.48 2.26-4a9 9 0 0 1 0 8.6c-3.43 5.65-6.76 10.56-8.52 17",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29 39.85a1 1 0 1 1-1-1 1 1 0 0 1 1 1"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M6 46.32 28.23 9.47 50 46.32H6z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28 35.01V22.45"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Warning56 = (Warning56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Help104.tsx


var Help104_excluded = ["className"];
function Help104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Help104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Help104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Help104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Help104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Help104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Help104_objectSpread(Help104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26 22S6 75.9 54 92c0 0-31.65 0-39.83-27C14.17 65 6 36 26 22Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.82 73.82A1.82 1.82 0 0 1 52 75.64a1.82 1.82 0 0 1-1.82-1.82A1.81 1.81 0 0 1 52 72a1.81 1.81 0 0 1 1.82 1.82Z",
        className: "strokeinverted"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41.09 42.91A10.91 10.91 0 1 1 52 53.82v10.91"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M92.12 52A40.12 40.12 0 1 1 52 11.88 40.12 40.12 0 0 1 92.12 52Z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Help104 = (Help104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Help56.tsx


var Help56_excluded = ["className"];
function Help56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Help56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Help56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Help56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Help56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Help56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Help56_objectSpread(Help56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15 13S5 40 29 48c0 0-15.83 0-19.91-13.48C9.09 34.5 5 20 15 13Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "28",
          cy: "28",
          r: "20"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.55 23.45A5.45 5.45 0 1 1 28 28.91v5.45"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.91 38.91a.91.91 0 0 1-.91.91.91.91 0 0 1-.91-.91A.91.91 0 0 1 28 38a.91.91 0 0 1 .91.91Z",
        className: "strokeinverted"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Help56 = (Help56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Installation104.tsx


var Installation104_excluded = ["className"];
function Installation104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Installation104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Installation104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Installation104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Installation104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Installation104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Installation104_objectSpread(Installation104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.62 12.89s1.56-1.41 2 .32 0 2.21.73 4.55 1 21.73 1 21.73h-1.59l-.5-20.21-1.55-3.57ZM74.37 28.2s3.46-1.05 2.56 2.46.12 6.69 1.65 8 1.24 3.89-1 7.83-6.98 13.64-6.98 13.64l-5.13-.28 9.79-19.16.37-.57s-5.27-4.22-1.26-11.92ZM56.9 59.78c-.48-1.31-.54-4.26-.85-5.62a7.76 7.76 0 0 0-1-2.09A11.37 11.37 0 0 1 53.5 48a7.19 7.19 0 0 1 1.18-4.23l-.11-3.94c0-.61-.53 0-1.13 0l-4.35.17A1.1 1.1 0 0 0 48 41.11l.08 2.45a.5.5 0 0 0 .17.38l2.86 2.8a1.1 1.1 0 0 1 .08 1.49L48.5 51.5c-.08.1.14 8.43.14 8.57s8.44.21 8.26-.29ZM33.1 50.99l3.35 9.07-5.64.05-.92-2.49 1.71-6.68 1.5.05zM11.44 32.46s1.22-1.64 2.3-.12 2.19 4.36 6.18 3.08l-.8 2.35-3.89 1.62a2.14 2.14 0 0 1-1.68-1.19ZM19.78 30s.95-2.3 2.28-.79 2.72 3.69 5.79 2.93 3.07 1.62 3.07 1.62l-7 2.63s-1.74.08-2.13-1S19.78 30 19.78 30ZM52.51 61.27 52.12 92H61s5.64-14.09 23.83-13.69v-5.06h-28ZM18.14 76.56h27.52a1.61 1.61 0 0 0 1.55-.81l.84-2.27H18.14Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m51.38 43.84 3.27-.11M52.09 60.19V92h33.06V73.48M73.07 60.07l8.82-16.63a9.51 9.51 0 0 0 8.6-15.81.56.56 0 0 0-1 .32l-.58 5.81a.55.55 0 0 1-.24.4l-4.27 3.08a.57.57 0 0 1-.59 0l-4.16-2.16a.55.55 0 0 1-.3-.5v-5.25a.59.59 0 0 1 .19-.43l4.39-3.83a.57.57 0 0 0-.31-1A9.46 9.46 0 0 0 74 29.15a9.58 9.58 0 0 0 1.73 11.11L65.58 60ZM57.91 43.63l-3.26.1M52.81 39.83l-.65-20.07-1.52-2.68-.14-4.36a.61.61 0 0 1 .63-.57l4.75-.15a.6.6 0 0 1 .65.53l.14 4.36-1.34 2.76.67 20.08ZM61.71 60.07l-.28-8.63a.61.61 0 0 0-.15-.36L58.36 48a1.1 1.1 0 0 1 0-1.5l2.68-3a.52.52 0 0 0 .14-.39l-.08-2.46a1.1 1.1 0 0 0-1.1-1.03L49.09 40A1.1 1.1 0 0 0 48 41.11l.08 2.45a.5.5 0 0 0 .17.38l2.86 2.8a1.1 1.1 0 0 1 .08 1.49L48.5 51.5a.53.53 0 0 0-.12.37l.26 8.2ZM43 60.07l-2.35-6.42-5.6-3.98-3.45 1.27-1.71 6.68.92 2.49L43 60.07z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m35.05 49.67-3.45 1.27-5.63-15.35 3.45-1.27 5.63 15.35zM21.37 34.29a3 3 0 0 0-1.95 2.57 1.71 1.71 0 0 1-1.09 1.54l-2.33.86a1.89 1.89 0 0 1-2.45-1.06l-2.44-6.66a1.9 1.9 0 0 1 1.18-2.4l2.9-1.06a.81.81 0 0 1 1 .32 2.91 2.91 0 0 0 3.43 1Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m19.61 29.43-.39-1.07a1.66 1.66 0 0 1 1-2.13l17.08-6.3A1.89 1.89 0 0 1 39.74 21a.59.59 0 0 1-.38.76c-2.13.7-9.27 3.42-7.55 8.11l.58 1.58a1.68 1.68 0 0 1-1 2.14l-7.48 2.75a1.65 1.65 0 0 1-2.13-1l-.4-1.06ZM19.02 60.21l-7.36 13.04h35.78l4.7-13.04H19.02z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m85.19 60.21 7.35 13.04H56.82l-4.69-13.04h33.06zM52.03 60.19V92H18.97V73.48"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Installation104 = (Installation104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Installation56.tsx


var Installation56_excluded = ["className"];
function Installation56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Installation56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Installation56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Installation56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Installation56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Installation56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Installation56_objectSpread(Installation56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m28.4 30 7.6 7.44S34 46.71 41 49c0 0-9.06-1.42-6.53-10.18L27 31.31M24.8 29.06l-7.73-7.8S10.36 24 8 16.94A12.42 12.42 0 0 0 17 19l9 8.8M10.83 41.56s-.58 3.37 5.87 1.83L12 48.18s-2.29 1.76-3.79-.26c0 0-1.51-1.58-.35-3Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m24.03 32.19 18.05-18.3.8-2.24 3.6-3.44-1.26-1.15-3.83 3.57-.75 2.77-17.49 17.51.88 1.28z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m23.15 30.91 17-17.16 1.22-3.12 3.45-3.41a.6.6 0 0 1 .86 0l3.13 3.27a.63.63 0 0 1 0 .87l-3.46 3.41-3.1 1.15-17 17.16ZM12.14 48a3 3 0 0 1-4.14.33 3 3 0 0 1 .32-4.2l13.87-14L26 34ZM20.24 28.17l7.68 7.76"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m27 31.3.66.66 6.79 6.86a7.38 7.38 0 0 0 1.54 8 7.21 7.21 0 0 0 8.01 1.6l-3.68-3.86V40.9h3.62l3.9 3.64a7.38 7.38 0 0 0-1.54-8 7.19 7.19 0 0 0-8-1.56l-6.78-6.86-.66-.66M28.36 24.88l-.67-.68-6.78-6.85a7.4 7.4 0 0 0-1.55-8 7 7 0 0 0-7.81-1.56l3.66 3.86v3.78h-3.9l-3.74-3.66a7.27 7.27 0 0 0 1.55 8 7.16 7.16 0 0 0 8 1.53l6.78 6.84.64.64"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Installation56 = (Installation56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/SupportPhone104.tsx


var SupportPhone104_excluded = ["className"];
function SupportPhone104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function SupportPhone104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SupportPhone104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SupportPhone104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function SupportPhone104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SupportPhone104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SupportPhone104_objectSpread(SupportPhone104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M69.93 34.79c-.43-2.42-.77-4.75-2.65-7 3-5.34.92-7.95-.37-10.27-3.8 2.44-11.25.95-15.43.4-3.92-.52-8-.9-11.42 1.28-5.85 3.71-7.06 9.13-7.64 15.63 0 0 1.66 0 2 3v-.07s4.77-16 18.13-16C65 21.7 68.93 38 69.16 42.74c0-8.66.73-7.85.77-8",
      className: "shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.93 34.79a13.11 13.11 0 0 0-2.65-7C72.59 19.2 62.57 13 62.57 13c-3 2.9-8.07 2.64-11.33 2.64-12.9 0-18.43 9.48-18.82 19.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.82 45.72c0 3.54 2.3 3.71 2.3 5.75s-2.39 2.12-2.39 2.12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.36 42.18a4.73 4.73 0 0 1 6.28 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55 42.18a4.73 4.73 0 0 1 6.28 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.49 59.43a4.08 4.08 0 0 1-4.69-.71"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.82 21.7c9.58 0 17.34 10.3 17.34 23.07S61.4 67.83 51.82 67.83 34.48 57.51 34.48 44.77 42.25 21.7 51.82 21.7Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.06 95a20.83 20.83 0 0 1 8.39-11.51 119.72 119.72 0 0 1 11.86-6.28c5.41-2.7 9-5.62 9.7-11.85"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60 65.13c.61 6.39 4.25 9.34 9.72 12.08a120.84 120.84 0 0 1 11.86 6.28A20.83 20.83 0 0 1 89.94 95"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m61.6 70.6 7.74 17.67a65.77 65.77 0 0 0-9.47-1.59c-3.36-.09-6.72 1.5-7.87 4.69Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 95v-3.54"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m42.39 70.62-7.73 17.65a65.77 65.77 0 0 1 9.47-1.59c3.36-.09 6.72 1.5 7.87 4.69Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.57 38c0-16 10.12-29 22.6-29s22.6 13 22.6 29"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.48 52.51V34.79h-3.54s-5.31 0-5.31 5.32v7.09s0 5.31 5.31 5.31Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.16 34.79v17.72h3.55s5.29 0 5.29-5.31v-7.09s0-5.32-5.31-5.32Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.71 52.51s-.11 7.37-11.5 7.37"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.59 62.37h-3A1.63 1.63 0 0 1 55 60.75V59a1.63 1.63 0 0 1 1.63-1.62h3A1.63 1.63 0 0 1 61.21 59v1.73a1.63 1.63 0 0 1-1.62 1.64Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.36 44.13a1.59 1.59 0 1 1-1.59 1.59 1.6 1.6 0 0 1 1.59-1.59"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58 44.13a1.59 1.59 0 1 1-1.6 1.59 1.59 1.59 0 0 1 1.6-1.59"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SupportPhone104 = (SupportPhone104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/SupportPhone56.tsx


var SupportPhone56_excluded = ["className"];
function SupportPhone56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function SupportPhone56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SupportPhone56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SupportPhone56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function SupportPhone56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SupportPhone56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", SupportPhone56_objectSpread(SupportPhone56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M15.87 34.87c-.88-.52-1.95-.33-2.84-1-1.51-1.16-2-3.23-2-5 0-2.27.1-5.06-2.85-5.35a.29.29 0 0 1 0 .09c-.35 1.53 0 3.55 0 5.12v5.24c-.5 2 3.27 3.61 3.27 3.61l5.31.09c.05-.97.02-2.26-.89-2.8ZM31.92 46.87a3.17 3.17 0 0 1-.61-.07 2.89 2.89 0 0 1-.95-.37 2.64 2.64 0 0 1-1-1.13 2.11 2.11 0 0 1-.22-.64l-.31.19a1.31 1.31 0 0 0-.25.22l-.07.09a1.14 1.14 0 0 0-.19.45 2.07 2.07 0 0 0 .29 1.3 2 2 0 0 0 .9.93 2.47 2.47 0 0 0 1.45.1 1.38 1.38 0 0 0 .78-.47c.07-.07.42-.5.33-.59s-.07 0-.15-.01ZM48 33.55c-6.65 2.22-8.63-5-8.63-5v9h4.31c4.56-.3 4.32-4 4.32-4Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.83 46.09h2.91c3.79 0 6.86-2.22 6.86-6.25v-2.22"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "30.2",
          cy: "45.87",
          rx: "2.16",
          ry: "2.12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M16.72 37.62H12.4c-2.38 0-4.31-1.52-4.31-3.39V24.06c0-1.87 1.93-3.39 4.31-3.39h4.32ZM39.37 37.62h4.31c2.39 0 4.32-1.52 4.32-3.39V24.06c0-1.87-1.93-3.39-4.32-3.39h-4.31Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M14 20.71C14 13.69 20.29 8 28 8s14 5.69 14 12.71"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SupportPhone56 = (SupportPhone56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Technician104.tsx


var Technician104_excluded = ["className"];
function Technician104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Technician104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Technician104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Technician104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Technician104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Technician104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Technician104_objectSpread(Technician104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.19 15a13.93 13.93 0 0 0-1.92 1.28 15.76 15.76 0 0 0-5.27 6.2 14.39 14.39 0 0 0-1.16 3.85c-.14.89-.14 7.15-1.71 6.41-1.82-.85-3.42 2.26-1.59 3.11 1.34.63 4.12.35 4.33.35 2.64-.07 6.72.33 7.33-3.27.36-2.16 0-4.6 0-6.78s.51-4.59.48-6.86c.28-.53.21-2.21.52-2.73.97-1.69.09-3.1-1.01-1.56ZM33.61 76.87l-4.37 2.55c3.19 2.48 7.05 6.87 9.12 15.58l5.41-.11C41.64 84.1 37.23 78.7 33.61 76.87ZM70.39 76.87c-3.62 1.83-8 7.23-10.16 18l5.41.11c2.07-8.71 5.93-13.1 9.12-15.58Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M58.75 13.93c12.47 3.87 11.13 18.65 11.13 18.65h1.82a1.78 1.78 0 1 1 0 3.55H32.57a1.78 1.78 0 0 1 0-3.55h1.82S33.05 17.8 45.51 13.93"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.24 32.58V20.13s0-8.89 8.9-8.89S61 20.13 61 20.13v12.45"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M68.79 52c2.23.12 4.64-1.65 5.81-4.46 1.39-3.36.48-6.93-2-8a4 4 0 0 0-2.47-.16"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.17 39.5a4.08 4.08 0 0 0-2.82.06c-2.51 1-3.43 4.61-2 8 1.23 3 3.84 4.76 6.16 4.43"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.49 58.3a4.32 4.32 0 0 0 4.93-.74"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.63 36.13a33.15 33.15 0 0 0-.58 6.22C34.05 56 42.14 67 52.13 67s18.09-11 18.09-24.65a33.15 33.15 0 0 0-.58-6.22"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.63 36.13a33.15 33.15 0 0 0-.58 6.22C34.05 56 42.14 67 52.13 67s18.09-11 18.09-24.65a33.15 33.15 0 0 0-.58-6.22Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42.26 70.3s1.67 4.12 10.21 4.12S62 70.3 62 70.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M12.7 94.89a21.42 21.42 0 0 1 8.62-11.44 133.74 133.74 0 0 1 12.33-6.58c1-.48 1.85-1 2.69-1.47 4.23-2.54 6.95-5.6 7.49-11.15"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20.52 84.84c3 2.23 4.09 5.57 4.46 9.76"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29.24 79.42c3.19 2.48 7.05 6.87 9.12 15.58"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.77 94.89c-2.13-10.79-6.54-16.19-10.16-18"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42.27 40.24a5 5 0 0 1 6.58 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M55.42 40.24a5 5 0 0 1 6.58 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m52.93 44.11 2.16 4.32a2.19 2.19 0 0 1-.55 2.68l-1.26 1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M91.3 94.89a21.42 21.42 0 0 0-8.62-11.44 133.74 133.74 0 0 0-12.33-6.58c-.95-.48-1.85-1-2.69-1.47-4.23-2.54-6.95-5.6-7.49-11.15"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M63.78 73.68c-6.3 3.15-10.24 10.73-11.66 21.19-1.42-10.46-5.6-18-11.9-21.19"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M83.48 84.84c-3 2.23-4.09 5.57-4.46 9.76"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M74.76 79.42c-3.19 2.48-7.05 6.87-9.12 15.58"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M60.23 94.89c2.13-10.79 6.54-16.19 10.16-18"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47.11 44a1.68 1.68 0 1 1-1.67-1.67A1.68 1.68 0 0 1 47.11 44"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M60.32 44a1.68 1.68 0 1 1-1.67-1.67A1.68 1.68 0 0 1 60.32 44"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Technician104 = (Technician104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Technician56.tsx


var Technician56_excluded = ["className"];
function Technician56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Technician56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Technician56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Technician56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Technician56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Technician56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Technician56_objectSpread(Technician56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.81 18.93a14.91 14.91 0 0 0-2 1.33 16.22 16.22 0 0 0-5.41 6.43 14.91 14.91 0 0 0-1.19 4c-.14.91-.14 7.36-1.77 6.6-1.85-.91-3.44 2.29-1.61 3.18 1.38.64 4.24.35 4.46.35 2.72-.07 6.92.35 7.55-3.37.37-2.22 0-4.74-.05-7s.53-4.73.49-7.06c.29-.55.22-2.28.54-2.82 1-1.74.12-3.19-1-1.66",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.84 17.89c12.83 4 11.45 19.2 11.45 19.2h1.88a1.83 1.83 0 0 1 0 3.66H7.87a1.83 1.83 0 0 1 0-3.66h1.88S8.37 21.87 21.2 17.89"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.86 37.09V24.27s0-9.16 9.16-9.16 9.16 9.16 9.16 9.16v12.82"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Technician56 = (Technician56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Troubleshoot104.tsx


var Troubleshoot104_excluded = ["className"];
function Troubleshoot104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Troubleshoot104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Troubleshoot104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Troubleshoot104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Troubleshoot104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Troubleshoot104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Troubleshoot104_objectSpread(Troubleshoot104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.49 22s-20 53.94 28 70c0 0-31.68.07-39.86-27 .02 0-8.16-29 11.86-43Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M89 15 73.69 30.31M15 15l15.31 15.31M15 89l15.31-15.31M89 89 73.69 73.69"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M92.12 52A40.12 40.12 0 1 1 52 11.88 40.12 40.12 0 0 1 92.12 52Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M52.38 59.14V30.82"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.37 70.93a2 2 0 1 0 2-2 2 2 0 0 0-2 2"
        })
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Troubleshoot104 = (Troubleshoot104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Troubleshoot56.tsx


var Troubleshoot56_excluded = ["className"];
function Troubleshoot56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Troubleshoot56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Troubleshoot56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Troubleshoot56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Troubleshoot56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Troubleshoot56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Troubleshoot56_objectSpread(Troubleshoot56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15 13S5 40 29 48c0 0-15.83 0-19.91-13.47C9.09 34.53 5 20 15 13Z",
        className: "shade"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m47.13 8.87-8.24 8.24M8.87 8.87l8.24 8.24M8.87 47.13l8.24-8.24M47.13 47.13l-8.24-8.24"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "28",
          cy: "28",
          r: "20"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28 31.61V17.5"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27 37.49a1 1 0 0 0 1 1 1 1 0 1 0-1-1",
        className: "strokeinverted"
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Troubleshoot56 = (Troubleshoot56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Calendar104.tsx


var Calendar104_excluded = ["className"];
function Calendar104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Calendar104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Calendar104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Calendar104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Calendar104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Calendar104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Calendar104_objectSpread(Calendar104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M14.82 45.12c12.46-26.78 24.92-27.44 24.92-27.44l-18.52-1.19-5.86 6.71Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M64.66 56.11h-9.11A1.14 1.14 0 0 1 54.41 55v-6.86A1.14 1.14 0 0 1 55.55 47h9.11a1.14 1.14 0 0 1 1.14 1.14V55a1.14 1.14 0 0 1-1.14 1.14"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48 56.11h-9.14A1.14 1.14 0 0 1 37.73 55v-6.86A1.14 1.14 0 0 1 38.86 47H48a1.14 1.14 0 0 1 1.13 1.14V55A1.14 1.14 0 0 1 48 56.11"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M81.34 56.11h-9.11A1.14 1.14 0 0 1 71.09 55v-6.86A1.14 1.14 0 0 1 72.23 47h9.11a1.14 1.14 0 0 1 1.14 1.14V55a1.14 1.14 0 0 1-1.14 1.14"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.29 69.1h-9.11A1.14 1.14 0 0 1 21 68v-6.87A1.15 1.15 0 0 1 22.18 60h9.11a1.14 1.14 0 0 1 1.14 1.14V68a1.14 1.14 0 0 1-1.14 1.13"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M64.66 69.1h-9.11a1.14 1.14 0 0 1-1.14-1.1v-6.87A1.14 1.14 0 0 1 55.55 60h9.11a1.14 1.14 0 0 1 1.14 1.14V68a1.14 1.14 0 0 1-1.14 1.13"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M81.34 69.1h-9.11a1.14 1.14 0 0 1-1.14-1.1v-6.87A1.14 1.14 0 0 1 72.23 60h9.11a1.14 1.14 0 0 1 1.14 1.14V68a1.14 1.14 0 0 1-1.14 1.13"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48 69.1h-9.14a1.14 1.14 0 0 1-1.13-1.1v-6.87A1.14 1.14 0 0 1 38.86 60H48a1.14 1.14 0 0 1 1.13 1.14V68A1.14 1.14 0 0 1 48 69.1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.29 82.1h-9.11A1.15 1.15 0 0 1 21 81v-6.87A1.15 1.15 0 0 1 22.18 73h9.11a1.14 1.14 0 0 1 1.14 1.14V81a1.14 1.14 0 0 1-1.14 1.14"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M64.66 82.1h-9.11a1.14 1.14 0 0 1-1.14-1.1v-6.87A1.14 1.14 0 0 1 55.55 73h9.11a1.14 1.14 0 0 1 1.14 1.14V81a1.14 1.14 0 0 1-1.14 1.14"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48 82.1h-9.14a1.14 1.14 0 0 1-1.13-1.1v-6.87A1.14 1.14 0 0 1 38.86 73H48a1.14 1.14 0 0 1 1.13 1.14V81A1.14 1.14 0 0 1 48 82.1"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M88.21 51.91v30a8.1 8.1 0 0 1-8.1 8.1H23.42a8.09 8.09 0 0 1-8.1-8.1v-56.7a8.09 8.09 0 0 1 8.1-8.1h56.69a8.1 8.1 0 0 1 8.1 8.1v27.11"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M67.84 9.77v16.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.44 9.77v16.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M15.32 38.17h72.89"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Calendar104 = (Calendar104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Calendar56.tsx


var Calendar56_excluded = ["className"];
function Calendar56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Calendar56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Calendar56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Calendar56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Calendar56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Calendar56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Calendar56_objectSpread(Calendar56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M8 24.27C14.7 9.85 21.4 9.5 21.4 9.5l-10-.64-3.12 3.61Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.82 29.27h-4.9a.62.62 0 0 1-.62-.62V25a.62.62 0 0 1 .62-.61h4.9a.62.62 0 0 1 .62.61v3.68a.62.62 0 0 1-.62.62"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M25.84 29.27h-4.91a.62.62 0 0 1-.61-.62V25a.62.62 0 0 1 .61-.61h4.91a.61.61 0 0 1 .61.61v3.68a.61.61 0 0 1-.61.62"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.81 29.27H38.9a.61.61 0 0 1-.61-.62V25a.61.61 0 0 1 .61-.61h4.91a.62.62 0 0 1 .61.61v3.68a.62.62 0 0 1-.61.62"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M16.86 36.26H12a.61.61 0 0 1-.61-.61V32a.61.61 0 0 1 .61-.61h4.91a.61.61 0 0 1 .61.61v3.68a.61.61 0 0 1-.61.61"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.82 36.26h-4.9a.61.61 0 0 1-.62-.61V32a.61.61 0 0 1 .62-.61h4.9a.61.61 0 0 1 .62.61v3.68a.61.61 0 0 1-.62.61"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.81 36.26H38.9a.61.61 0 0 1-.61-.61V32a.61.61 0 0 1 .61-.61h4.91a.61.61 0 0 1 .61.61v3.68a.61.61 0 0 1-.61.61"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M25.84 36.26h-4.91a.61.61 0 0 1-.61-.61V32a.61.61 0 0 1 .61-.61h4.91a.61.61 0 0 1 .61.61v3.68a.61.61 0 0 1-.61.61"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M16.86 43.26H12a.61.61 0 0 1-.61-.61V39a.61.61 0 0 1 .61-.62h4.91a.61.61 0 0 1 .61.62v3.68a.61.61 0 0 1-.61.61"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.82 43.26h-4.9a.62.62 0 0 1-.62-.61V39a.62.62 0 0 1 .62-.62h4.9a.62.62 0 0 1 .62.62v3.68a.62.62 0 0 1-.62.61"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M25.84 43.26h-4.91a.62.62 0 0 1-.61-.61V39a.62.62 0 0 1 .61-.62h4.91a.61.61 0 0 1 .61.62v3.68a.61.61 0 0 1-.61.61"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47.5 27.93v16.15a4.36 4.36 0 0 1-4.36 4.36H12.62a4.36 4.36 0 0 1-4.36-4.36V13.55a4.36 4.36 0 0 1 4.36-4.36h30.52a4.36 4.36 0 0 1 4.36 4.36v14.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36.54 5.24v8.72"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19.09 5.24v8.72"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M8.26 18.68H47.5"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Calendar56 = (Calendar56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Clock104.tsx


var Clock104_excluded = ["className"];
function Clock104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Clock104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Clock104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Clock104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Clock104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Clock104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Clock104_objectSpread(Clock104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M57.87 77.24a31.33 31.33 0 0 1-31.09-31.1 30.91 30.91 0 0 1 6.46-18.87 31.09 31.09 0 1 0 43.53 43.52 30.94 30.94 0 0 1-18.9 6.45Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M52 29.22v22.75h16.56"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "52",
          cy: "52",
          r: "38"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "52",
          cy: "52",
          r: "31.09"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Clock104 = (Clock104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Clock56.tsx


var Clock56_excluded = ["className"];
function Clock56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Clock56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Clock56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Clock56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Clock56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Clock56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Clock56_objectSpread(Clock56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31 41a16 16 0 0 1-12.68-25.76 16 16 0 1 0 22.46 22.45A16 16 0 0 1 31 41Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "19.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28 16.25v11.73h8.54"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "16.04"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Clock56 = (Clock56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/History104.tsx


var History104_excluded = ["className"];
function History104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function History104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? History104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : History104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function History104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, History104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", History104_objectSpread(History104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.8 73.9C44 73.8 31.2 61 31.1 45.2c0-3.5.6-7 1.9-10.2.5-1.2-1.2-2.1-2-1-4.7 6.5-6.5 14.8-4.8 22.9 2.4 11 11 19.6 22 22 8.1 1.8 16.4-.1 22.9-4.8 1.1-.8.2-2.5-1.1-2-3.2 1.2-6.6 1.8-10.2 1.8z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53 33v19h14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.7 88.5c-2.4.7-4.9 1.3-7.4 1.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16 60.5c-.3-1.2-.5-2.5-.7-3.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.6 74.7c-1.4-2-2.7-4.1-3.8-6.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.3 85.2c-2.3-1.3-4.4-2.8-6.3-4.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.9 90c-2.4-.3-4.7-.8-7-1.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.9 43.9c3.7-17.3 19-30.2 37.4-30.2 21.1 0 38.3 17.1 38.3 38.3 0 17.2-11.3 31.7-26.9 36.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "53.3",
        cy: "52",
        r: "27.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.3 41.6 15.4 45l-3.3-6.9"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_History104 = (History104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/History56.tsx


var History56_excluded = ["className"];
function History56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function History56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? History56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : History56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function History56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, History56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", History56_objectSpread(History56_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.4 39.9c-8.6-.1-15.5-7-15.6-15.6 0-1.9.4-3.8 1-5.5.3-.7-.7-1.2-1.1-.6-2.5 3.5-3.5 8-2.6 12.4 1.3 6 5.9 10.6 11.9 11.9 4.4 1 8.9 0 12.4-2.6.6-.4.1-1.3-.6-1.1-1.6.7-3.4 1.1-5.4 1.1z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.7 17.7V28h7.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M8.6 32.6c-.1-.7-.3-1.3-.4-2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.2 40.2c-.8-1.1-1.5-2.2-2-3.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.5 45.9c-1.2-.7-2.3-1.5-3.4-2.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.3 48.5c-1.3-.1-2.5-.4-3.7-.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.8 47.7c-1.3.4-2.6.7-4 .8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M8.6 23.7c2-9.3 10.2-16.3 20.1-16.3 11.4 0 20.6 9.2 20.6 20.6 0 9.2-6.1 17.1-14.5 19.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28.7",
        cy: "28",
        r: "14.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m12 22.4-3.7 1.8-1.8-3.7"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_History56 = (History56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Bus104.tsx


var Bus104_excluded = ["className"];
function Bus104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Bus104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Bus104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Bus104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Bus104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Bus104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Bus104_objectSpread(Bus104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.62 70.22c.54 0 .06 2.61 2 3.48 1.16.52 2.42.09 2.67.52s-.73 1.41-1.87 1.54A3.81 3.81 0 0 1 23 73.59c-.82-1.59.17-3.38.62-3.37ZM76.11 70.22c.54 0 .06 2.61 2 3.48 1.16.52 2.42.09 2.67.52s-.73 1.41-1.87 1.54a3.81 3.81 0 0 1-3.46-2.17c-.78-1.59.21-3.38.66-3.37ZM35.34 73c.38 0 0 2.16 1.41 2.88.81.42 1.68.06 1.85.42s-.5 1.16-1.3 1.28c-1 .15-2-.91-2.41-1.8-.56-1.34.11-2.78.45-2.78ZM66 73c.38 0 0 2.16 1.41 2.88.81.42 1.68.06 1.85.42s-.5 1.16-1.29 1.28c-1 .15-2-.91-2.42-1.8C65 74.44 65.69 73 66 73ZM30.54 63.11c-3.24.56-10.46 2-12.54-1.11a4.53 4.53 0 0 1-.59-2.3c-.8-8.85-1.23-6.79-1.28-11C16 40.89 17.49 32 18.25 32c.56 0 0 4.9 1.75 12.52.85 3.69 1.58 6.87 3 9.12 3.57 5.68 11.88 6.15 27.58 6.83C72.93 61.43 86 62 86 62.43s-8.52.92-10 1c-32.23 1.93-31.21-2.78-45.46-.32ZM40.38 23.64c-1.36 0-2.25.45-2.49 0a1 1 0 0 1-.07-.48 14.83 14.83 0 0 0 0-1.79 4 4 0 0 1 0-.53c.07-.62.6-1.76.8-1.7s0 .2.06.73a4 4 0 0 0 .22 1.54c.32.63 1.31.72 1.72.76 10.77.95 16.14.86 16.14.86 4-.06 8.07.13 8.08.32S58.76 24 56 24a20.37 20.37 0 0 0-2.39 0A7.08 7.08 0 0 1 51 24c-.2 0-.32-.08-.43-.11a14.72 14.72 0 0 0-6.12-.08 10.28 10.28 0 0 1-1.55.19 4.33 4.33 0 0 1-.51 0c-1.05-.1-1.08-.33-2.01-.36Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M17 25.11v50.18a7 7 0 0 0 6.8 7.24h56.37A7 7 0 0 0 87 75.29V25.13a7.23 7.23 0 0 0-4.44-6.79 83 83 0 0 0-61.1 0A7.22 7.22 0 0 0 17 25.11ZM23.91 83.2V90c0 .85 1.15 1.54 2.56 1.54h3.75c1.41 0 2.56-.69 2.56-1.54v-6.8M71.19 83.2V90c0 .85 1.15 1.54 2.56 1.54h3.75c1.42 0 2.57-.69 2.57-1.54v-6.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.17 18.8H66.8v5.64H37.26Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "78.05",
          cy: "72.33",
          rx: "3.62",
          ry: "3.85"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M17 29.92h70v33.52H17.21ZM46.94 71.12H57V76H47Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "67.32",
          cy: "74.94",
          rx: "2.79",
          ry: "2.98"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "25.92",
          cy: "72.33",
          rx: "3.62",
          ry: "3.85"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "36.65",
          cy: "74.94",
          rx: "2.79",
          ry: "2.98"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.46 24.72h7.69M72.8 24.04h7.69"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Bus104 = (Bus104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Bus56.tsx


var Bus56_excluded = ["className"];
function Bus56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Bus56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Bus56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Bus56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Bus56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Bus56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Bus56_objectSpread(Bus56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M12.12 38c.3 0 0 1.44 1.11 1.92.64.28 1.33 0 1.47.28s-.4.78-1 .85a2.1 2.1 0 0 1-1.9-1.19c-.47-.86.07-1.86.32-1.86ZM41 38c.3 0 0 1.44 1.11 1.92.64.28 1.33 0 1.47.28s-.4.78-1 .85a2.11 2.11 0 0 1-1.91-1.19C40.2 39 40.74 38 41 38ZM18.56 39.54c.21 0 0 1.19.78 1.59.44.23.93 0 1 .23s-.28.64-.71.7-1.13-.5-1.33-1c-.3-.72.09-1.52.26-1.52ZM35.43 39.54c.21 0 0 1.19.77 1.59.45.23.93 0 1 .23s-.27.64-.71.7-1.13-.5-1.33-1c-.28-.72.1-1.52.27-1.52ZM16.05 34.1c-1.79.31-5.76 1.13-6.9-.61a2.55 2.55 0 0 1-.32-1.26c-.16-1.77-.59-2.62-.42-3.51a7.11 7.11 0 0 0 .22-1.18 4.9 4.9 0 0 0-.13-1.48c-.42-1.75.32-9.09.79-9.07.28 0 0 2.68 1 6.89a17.15 17.15 0 0 0 1.65 5c2 3.12 6.53 3.38 15.17 3.75 12.29.53 19.48.82 19.48 1.08s-4.69.51-5.5.55c-17.76 1.08-17.21-1.51-25.04-.16ZM21.31 12.64c-.75 0-1.21 0-1.34-.23a.55.55 0 0 1 0-.27 7 7 0 0 0 0-1 2.37 2.37 0 0 1 0-.29c0-.34.32-1 .43-.94s0 .11 0 .4a2.15 2.15 0 0 0 .12.85c.18.34.72.4.94.42 5.92.52 8.88.47 8.88.47a15.57 15.57 0 0 1 4.54.55c0 .13-3.42 0-4.95 0a11 11 0 0 0-1.31 0 4 4 0 0 1-1.44 0c-.11 0-.48.17-.54.16a5.8 5.8 0 0 0-2.9.11 2.52 2.52 0 0 0-1-.27h-.28c-.59-.06-.64.05-1.15.04Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M8.75 13.21v27.6a3.87 3.87 0 0 0 3.74 4h31a3.86 3.86 0 0 0 3.74-4V13.22a4 4 0 0 0-2.44-3.73 45.63 45.63 0 0 0-33.6 0 4 4 0 0 0-2.44 3.72ZM12.55 45.16v3.72c0 .46.63.85 1.41.85H16c.78 0 1.41-.39 1.41-.85v-3.72M38.55 45.16v3.72c0 .46.64.85 1.42.85H42c.78 0 1.42-.39 1.42-.85v-3.72"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19.84 9.74h16.3v3.1H19.89Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "42.33",
          cy: "39.18",
          rx: "1.99",
          ry: "2.12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M8.75 15.86h38.48v18.43H8.87ZM25.22 38.52h5.55v2.65h-5.54Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "36.42",
          cy: "40.62",
          rx: "1.54",
          ry: "1.64"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "13.66",
          cy: "39.18",
          rx: "1.99",
          ry: "2.12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "19.56",
          cy: "40.62",
          rx: "1.54",
          ry: "1.64"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M12.3 13h4.23M39.44 12.62h4.23"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Bus56 = (Bus56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Train104.tsx


var Train104_excluded = ["className"];
function Train104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Train104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Train104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Train104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Train104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Train104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Train104_objectSpread(Train104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M59.9 22.39c3.47.1 6.3.29 8.14.42l-2.57.19-29.28.1C36.11 21 36 19 36 17a4.78 4.78 0 0 1 1.32 1.58 7.13 7.13 0 0 1 .52 2c.59 1.84 6 1.66 10.84 1.64-.04-.04 3.67-.06 11.22.17ZM26.9 33.8c-.18 17.36 4.31 23.53 8.45 26 4.79 2.79 9.57.83 24.65 2.25 5.87.55 10.61 1.36 13.61 1.94l-44.46-.78L24 35.3ZM28 72.26c.7 0 .07 3.39 2.61 4.52 1.51.67 3.13.1 3.45.66s-.93 1.83-2.41 2c-1.93.23-3.8-1.43-4.49-2.82-1.01-2.09.27-4.37.84-4.36ZM70 72.26c.7 0 .07 3.39 2.61 4.52 1.51.67 3.13.1 3.45.66s-.93 1.83-2.41 2c-1.93.23-3.8-1.43-4.49-2.82-1.01-2.09.27-4.37.84-4.36Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m12.52 24.5 6.92 57.13a4.18 4.18 0 0 0 4.16 3.68h56.78a4.18 4.18 0 0 0 4.15-3.68l6.92-57.11a7.66 7.66 0 0 0-5-7.19 99.16 99.16 0 0 0-68.92 0 7.65 7.65 0 0 0-5.01 7.17Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.27 17.81H68.7v6H35.37q-.04-3-.1-6Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "79.01",
          cy: "24.36",
          r: "3.15"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "24.96",
          cy: "24.36",
          r: "3.15"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m23.27 37 5 25.4c.19.93 1.49 1.64 3 1.64h41.37c1.55 0 2.84-.71 3-1.64L80.7 37c0-1.43-1.45-2.71-3.64-3.2a115.94 115.94 0 0 0-50.16 0c-2.18.49-3.63 1.77-3.63 3.2ZM46.94 77.57H57"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "31",
          cy: "75",
          rx: "4.69",
          ry: "4.99"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "73",
          cy: "75",
          rx: "4.69",
          ry: "4.99"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M73.13 85.28 74.51 97h9l-3.43-11.6M30.52 92h43M30.87 85.29 29.49 97h-9l3.4-11.56"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Train104 = (Train104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/Train56.tsx


var Train56_excluded = ["className"];
function Train56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function Train56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Train56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Train56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function Train56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Train56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", Train56_objectSpread(Train56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.26 12.06c1.86 0 3.39.15 4.38.22l-1.39.08-15.76.05c0-1.09-.09-2.19-.13-3.29a2.59 2.59 0 0 1 .71.86 3.38 3.38 0 0 1 .28 1.08c.32 1 3.24.89 5.84.88 0 0 2-.01 6.07.12ZM14.49 18.2c-.1 9.35 2.31 12.67 4.54 14 2.59 1.51 5.16.45 13.28 1.21 3.16.3 5.71.74 7.33 1l-24-.42L12.92 19ZM15.09 38.91c.38 0 0 1.83 1.41 2.43.81.36 1.68.06 1.85.36s-.5 1-1.3 1.08a2.65 2.65 0 0 1-2.41-1.52c-.56-1.13.13-2.36.45-2.35ZM37.7 38.91c.38 0 0 1.83 1.41 2.43.81.36 1.69.06 1.86.36s-.51 1-1.3 1.08a2.68 2.68 0 0 1-2.42-1.52c-.55-1.13.14-2.36.45-2.35Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M6.74 13.19 10.47 44a2.26 2.26 0 0 0 2.24 2h30.57a2.27 2.27 0 0 0 2.24-2l3.72-30.8a4.12 4.12 0 0 0-2.69-3.87 53.46 53.46 0 0 0-37.12 0 4.12 4.12 0 0 0-2.69 3.86Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19 9.59h18v3.22H19.05Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "42.54",
          cy: "13.12",
          r: "1.7"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "13.44",
          cy: "13.12",
          r: "1.7"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m12.53 19.92 2.71 13.68c.1.5.8.88 1.63.88h22.25c.83 0 1.53-.38 1.62-.88l2.71-13.67c0-.77-.78-1.46-2-1.73a62.31 62.31 0 0 0-27 0c-1.14.27-1.92.95-1.92 1.72ZM25.28 41.77h5.43"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "16.69",
          cy: "40.38",
          rx: "2.52",
          ry: "2.69"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "39.31",
          cy: "40.38",
          rx: "2.52",
          ry: "2.69"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m39.38 45.92.74 6.31H45L43.12 46M16.44 49.54h23.13M16.62 45.93l-.74 6.28H11L12.87 46"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Train56 = (Train56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/TruckFire104.tsx


var TruckFire104_excluded = ["className"];
function TruckFire104_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function TruckFire104_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TruckFire104_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TruckFire104_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function TruckFire104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TruckFire104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", TruckFire104_objectSpread(TruckFire104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m22.3 60.8 1.3-15.6S26 52.7 30.8 56c3.7 2.3 7.8 4 12 4.8H22.3z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.9 74.5c-5 0-9.7 0-14 .1-2.5 1.9-6 2-8.6.2-9.3.4-15.3.9-15.3 1.5 0 1 16.9 1.7 37.8 1.7s37.8-.8 37.8-1.7-16.8-1.8-37.7-1.8"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M76 20.1V24"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m68.3 23 3.3 2.7"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m83.6 23-3.2 2.7"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M9.1 49.4H6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.2 49.4H14"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M94.5 48.9c-1.1-2.1-6.4-10.8-6.4-10.8-.4-.6-1-1.1-1.6-1.5-1-.6-3-.5-5.6-.6-5.9-.1-16.3.2-16.3.2l-.8 8.8H23.1l-1.3 16h-3.2v5.6h4.8c1.1-3.9 5.1-6.2 9-5.1 2.5.7 4.4 2.6 5.1 5.1h37.2c1.1-3.9 5.1-6.2 9-5.1 2.5.7 4.5 2.6 5.1 5.1h4l2.6-14c.1-1.2-.3-2.5-.9-3.7z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.9 30.3h-9.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20.3 42.2H5.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M16 36.1h-5.8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.8 68.8c0 4.1-3.3 7.4-7.4 7.4S23 72.9 23 68.8c0-4.1 3.3-7.4 7.4-7.4 4.1 0 7.4 3.3 7.4 7.4z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M89.2 68.8c0 4.1-3.3 7.4-7.4 7.4-4.1 0-7.4-3.3-7.4-7.4 0-4.1 3.3-7.4 7.4-7.4 4 0 7.3 3.3 7.4 7.4z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.3 68.8c0 2.1-1.7 3.9-3.8 3.9s-3.9-1.7-3.9-3.8 1.7-3.9 3.8-3.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M85.6 68.8c0 2.1-1.7 3.9-3.8 3.9s-3.9-1.7-3.9-3.8 1.7-3.9 3.8-3.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21.6 61.2h40.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m63.8 44.7-1.4 16v5.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M90.7 50.6c-.1.2-12.7.1-12.7.1-.7 0-1.2-.5-1.2-1.1v-.1l.7-8.6c.1-.7.7-1.3 1.4-1.3h4.4c.8 0 1.5.5 1.9 1.1.2 0 5.6 9.7 5.5 9.9z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M68.2 50.8c-.5 0-.9-.6-.9-1.3l.8-8.6c0-.6.4-1.2 1-1.3h4.4c.5 0 .9.6.9 1.3l-.8 8.6c0 .6-.4 1.2-1.1 1.3h-4.3z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m31.1 34.5-.6 7M36.4 34.5l-.7 7M41.6 34.5l-.6 7M46.9 34.5l-.7 7M52.1 34.5l-.6 7M57.3 34.5l-.6 7M27.4 33.8h33.5M59.7 42.3H26.3M78.9 33s0-5-3-5c-3.2 0-2.9 5-2.9 5h5.9zM71.6 36.1V33h8.8v3.1z"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TruckFire104 = (TruckFire104);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/TruckFire56.tsx


var TruckFire56_excluded = ["className"];
function TruckFire56_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function TruckFire56_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TruckFire56_ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TruckFire56_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function TruckFire56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TruckFire56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TruckFire56_objectSpread(TruckFire56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "5.95",
        y: "40.13",
        width: "40.74",
        height: "1.87",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M5.95 40.13h40.74V42H5.95v-1.87z"
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m12 32.75.72-8.4s1.3 4 3.86 5.79a20 20 0 0 0 6.49 2.61Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.32 40.13c-2.66 0-5.2 0-7.53.07a3.93 3.93 0 0 1-2.38.81 4 4 0 0 1-2.24-.69c-5 .17-8.22.44-8.22.75 0 .51 9.12.93 20.37.93s20.37-.42 20.37-.93-9.12-.94-20.37-.94"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.91 10.85v2.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m36.8 12.4 1.73 1.46"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m45.03 12.4-1.74 1.46"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.87 26.34c-.6-1.12-3.43-5.8-3.43-5.8a3.31 3.31 0 0 0-.85-.78 8.11 8.11 0 0 0-3-.31c-3.18 0-8.78.12-8.78.12l-.45 4.74H12.44l-.69 8.61H10v3h2.58a3.94 3.94 0 0 1 7.6 0h20a4 4 0 0 1 7.63 0H50l1.38-7.54a4.07 4.07 0 0 0-.51-2.04Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.86 16.31H8.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.92 22.74H3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M8.6 19.42H5.49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M9.82 26.59H4.75"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.38 37.05a4 4 0 1 1-4-4 4 4 0 0 1 4 4Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48 37.05a4 4 0 1 1-4-4 4 4 0 0 1 4 4Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.47 37.07A2.09 2.09 0 1 1 16.39 35"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.12 37.07A2.08 2.08 0 1 1 44 35"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.65 32.93h21.79"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m34.36 24.09-.76 8.61v3.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.85 27.23c-.06.12-6.82.07-6.82.07a.64.64 0 0 1-.65-.69l.39-4.61a.77.77 0 0 1 .76-.69h2.39a1.34 1.34 0 0 1 1.06.61s2.93 5.2 2.87 5.31Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.7 27.33c-.29 0-.51-.31-.49-.69l.44-4.64a.67.67 0 0 1 .56-.69h2.36c.29 0 .51.31.49.69l-.43 4.64a.67.67 0 0 1-.56.69Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m16.76 18.6-.35 3.75M19.59 18.6l-.36 3.75M22.41 18.6l-.36 3.75M25.23 18.6l-.35 3.75M28.06 18.6l-.36 3.75M30.88 18.6l-.35 3.75M14.73 18.18h18.05M32.16 22.75H14.17M42.51 17.75s0-2.7-1.61-2.7-1.58 2.7-1.58 2.7ZM38.53 17.75h4.77v1.69h-4.77z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TruckFire56 = (TruckFire56);
;// CONCATENATED MODULE: ./src/Picto/GeneratedPictoComponents/index.tsx































































































































































































































































































































































/***/ }),

/***/ 4184:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 6608:
/***/ (() => {



/***/ }),

/***/ 8779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 3838:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/objectWithoutProperties");

/***/ }),

/***/ 6689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 997:
/***/ ((module) => {

"use strict";
module.exports = require("react/jsx-runtime");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Accessories104: () => (/* reexport */ GeneratedPictoComponents/* Accessories104 */.XTd),
  Accessories56: () => (/* reexport */ GeneratedPictoComponents/* Accessories56 */.RSN),
  AccountsPayments104: () => (/* reexport */ GeneratedPictoComponents/* AccountsPayments104 */.aco),
  AccountsPayments56: () => (/* reexport */ GeneratedPictoComponents/* AccountsPayments56 */.BaD),
  Add104: () => (/* reexport */ GeneratedPictoComponents/* Add104 */.x5q),
  Add56: () => (/* reexport */ GeneratedPictoComponents/* Add56 */.DrC),
  AddPhone104: () => (/* reexport */ GeneratedPictoComponents/* AddPhone104 */.N5_),
  AddPhone56: () => (/* reexport */ GeneratedPictoComponents/* AddPhone56 */.ZPK),
  AdultFemale104: () => (/* reexport */ GeneratedPictoComponents/* AdultFemale104 */.jrd),
  AdultFemale56: () => (/* reexport */ GeneratedPictoComponents/* AdultFemale56 */.OGy),
  AdultMale104: () => (/* reexport */ GeneratedPictoComponents/* AdultMale104 */.CDJ),
  AdultMale56: () => (/* reexport */ GeneratedPictoComponents/* AdultMale56 */.l1h),
  AppMyTelstra104: () => (/* reexport */ GeneratedPictoComponents/* AppMyTelstra104 */.i$),
  AppMyTelstra56: () => (/* reexport */ GeneratedPictoComponents/* AppMyTelstra56 */.UNI),
  Appointment104: () => (/* reexport */ GeneratedPictoComponents/* Appointment104 */._qg),
  Appointment56: () => (/* reexport */ GeneratedPictoComponents/* Appointment56 */.QaO),
  Australia104: () => (/* reexport */ GeneratedPictoComponents/* Australia104 */.qiP),
  Australia56: () => (/* reexport */ GeneratedPictoComponents/* Australia56 */.nLT),
  Baby104: () => (/* reexport */ GeneratedPictoComponents/* Baby104 */.wDL),
  Baby56: () => (/* reexport */ GeneratedPictoComponents/* Baby56 */.d$r),
  Bank104: () => (/* reexport */ GeneratedPictoComponents/* Bank104 */.a95),
  Bank56: () => (/* reexport */ GeneratedPictoComponents/* Bank56 */.WwZ),
  BillEmail56: () => (/* reexport */ GeneratedPictoComponents/* BillEmail56 */.wf1),
  BillEmails104: () => (/* reexport */ GeneratedPictoComponents/* BillEmails104 */.brd),
  BillEmails56: () => (/* reexport */ GeneratedPictoComponents/* BillEmails56 */.X2R),
  BillOverview104: () => (/* reexport */ GeneratedPictoComponents/* BillOverview104 */.Bih),
  BillOverview56: () => (/* reexport */ GeneratedPictoComponents/* BillOverview56 */.Nhf),
  BillPaid104: () => (/* reexport */ GeneratedPictoComponents/* BillPaid104 */.Mz6),
  BillPaid56: () => (/* reexport */ GeneratedPictoComponents/* BillPaid56 */.xzN),
  BillSummary104: () => (/* reexport */ GeneratedPictoComponents/* BillSummary104 */.l2v),
  BillSummary56: () => (/* reexport */ GeneratedPictoComponents/* BillSummary56 */.JG$),
  BroadbandEnterpriseSim104: () => (/* reexport */ GeneratedPictoComponents/* BroadbandEnterpriseSim104 */.jxJ),
  BroadbandEnterpriseSim56: () => (/* reexport */ GeneratedPictoComponents/* BroadbandEnterpriseSim56 */.mWg),
  BroadbandHome104: () => (/* reexport */ GeneratedPictoComponents/* BroadbandHome104 */.HhU),
  BroadbandHome56: () => (/* reexport */ GeneratedPictoComponents/* BroadbandHome56 */.UBi),
  BroadbandMobile104: () => (/* reexport */ GeneratedPictoComponents/* BroadbandMobile104 */.mUK),
  BroadbandMobile56: () => (/* reexport */ GeneratedPictoComponents/* BroadbandMobile56 */.ocJ),
  BroadbandMobileSim104: () => (/* reexport */ GeneratedPictoComponents/* BroadbandMobileSim104 */.H$s),
  BroadbandMobileSim56: () => (/* reexport */ GeneratedPictoComponents/* BroadbandMobileSim56 */.JZA),
  Building104: () => (/* reexport */ GeneratedPictoComponents/* Building104 */.McE),
  Building56: () => (/* reexport */ GeneratedPictoComponents/* Building56 */.Dy2),
  Bundles104: () => (/* reexport */ GeneratedPictoComponents/* Bundles104 */.b$e),
  Bundles56: () => (/* reexport */ GeneratedPictoComponents/* Bundles56 */.yMS),
  Bus104: () => (/* reexport */ GeneratedPictoComponents/* Bus104 */.ai7),
  Bus56: () => (/* reexport */ GeneratedPictoComponents/* Bus56 */.pAV),
  BusinessIdeas104: () => (/* reexport */ GeneratedPictoComponents/* BusinessIdeas104 */.CQI),
  BusinessIdeas56: () => (/* reexport */ GeneratedPictoComponents/* BusinessIdeas56 */.Cpv),
  BusinessOperation104: () => (/* reexport */ GeneratedPictoComponents/* BusinessOperation104 */.bK0),
  BusinessOperation56: () => (/* reexport */ GeneratedPictoComponents/* BusinessOperation56 */.DRJ),
  BusinessSoftware104: () => (/* reexport */ GeneratedPictoComponents/* BusinessSoftware104 */.adf),
  BusinessSoftware56: () => (/* reexport */ GeneratedPictoComponents/* BusinessSoftware56 */.CHF),
  BusinessStrategy104: () => (/* reexport */ GeneratedPictoComponents/* BusinessStrategy104 */.ey7),
  BusinessStrategy56: () => (/* reexport */ GeneratedPictoComponents/* BusinessStrategy56 */.mpB),
  Calendar104: () => (/* reexport */ GeneratedPictoComponents/* Calendar104 */.brU),
  Calendar56: () => (/* reexport */ GeneratedPictoComponents/* Calendar56 */.wNk),
  CardAdded104: () => (/* reexport */ GeneratedPictoComponents/* CardAdded104 */.HGG),
  CardAdded56: () => (/* reexport */ GeneratedPictoComponents/* CardAdded56 */.ein),
  Cart104: () => (/* reexport */ GeneratedPictoComponents/* Cart104 */.s8S),
  Cart56: () => (/* reexport */ GeneratedPictoComponents/* Cart56 */.eDy),
  ChangePlan104: () => (/* reexport */ GeneratedPictoComponents/* ChangePlan104 */.RSg),
  ChangePlan56: () => (/* reexport */ GeneratedPictoComponents/* ChangePlan56 */.wQf),
  Chat104: () => (/* reexport */ GeneratedPictoComponents/* Chat104 */.lwL),
  Chat56: () => (/* reexport */ GeneratedPictoComponents/* Chat56 */.OWV),
  Child104: () => (/* reexport */ GeneratedPictoComponents/* Child104 */.YI6),
  Child56: () => (/* reexport */ GeneratedPictoComponents/* Child56 */.r$N),
  Clock104: () => (/* reexport */ GeneratedPictoComponents/* Clock104 */.lWq),
  Clock56: () => (/* reexport */ GeneratedPictoComponents/* Clock56 */.M1_),
  Compare104: () => (/* reexport */ GeneratedPictoComponents/* Compare104 */.DQC),
  Compare56: () => (/* reexport */ GeneratedPictoComponents/* Compare56 */.BUq),
  CoverageMap104: () => (/* reexport */ GeneratedPictoComponents/* CoverageMap104 */.aQe),
  CoverageMap56: () => (/* reexport */ GeneratedPictoComponents/* CoverageMap56 */._mb),
  CoverageMobile104: () => (/* reexport */ GeneratedPictoComponents/* CoverageMobile104 */.ETy),
  CoverageMobile56: () => (/* reexport */ GeneratedPictoComponents/* CoverageMobile56 */.aSB),
  CoverageNetwork104: () => (/* reexport */ GeneratedPictoComponents/* CoverageNetwork104 */.fs4),
  CoverageNetwork56: () => (/* reexport */ GeneratedPictoComponents/* CoverageNetwork56 */.t9q),
  DataPacks104: () => (/* reexport */ GeneratedPictoComponents/* DataPacks104 */.W7S),
  DataPacks56: () => (/* reexport */ GeneratedPictoComponents/* DataPacks56 */.DSZ),
  DataPool104: () => (/* reexport */ GeneratedPictoComponents/* DataPool104 */.YE_),
  DataPool56: () => (/* reexport */ GeneratedPictoComponents/* DataPool56 */.Xx6),
  Deal104: () => (/* reexport */ GeneratedPictoComponents/* Deal104 */.Ok$),
  Deal56: () => (/* reexport */ GeneratedPictoComponents/* Deal56 */.SuH),
  Delivery104: () => (/* reexport */ GeneratedPictoComponents/* Delivery104 */.GTG),
  Delivery56: () => (/* reexport */ GeneratedPictoComponents/* Delivery56 */.tRm),
  DeviceLocator104: () => (/* reexport */ GeneratedPictoComponents/* DeviceLocator104 */.K5k),
  DeviceLocator56: () => (/* reexport */ GeneratedPictoComponents/* DeviceLocator56 */.bsC),
  DeviceProtect104: () => (/* reexport */ GeneratedPictoComponents/* DeviceProtect104 */.GvT),
  DeviceProtect56: () => (/* reexport */ GeneratedPictoComponents/* DeviceProtect56 */.Vtl),
  Devices104: () => (/* reexport */ GeneratedPictoComponents/* Devices104 */.oZ8),
  Devices56: () => (/* reexport */ GeneratedPictoComponents/* Devices56 */.IN7),
  Disruptions104: () => (/* reexport */ GeneratedPictoComponents/* Disruptions104 */.li3),
  Disruptions56: () => (/* reexport */ GeneratedPictoComponents/* Disruptions56 */.D5U),
  Document104: () => (/* reexport */ GeneratedPictoComponents/* Document104 */.qXr),
  Document56: () => (/* reexport */ GeneratedPictoComponents/* Document56 */.rBW),
  Download104: () => (/* reexport */ GeneratedPictoComponents/* Download104 */.zIi),
  Download56: () => (/* reexport */ GeneratedPictoComponents/* Download56 */.ieA),
  ESIM104: () => (/* reexport */ GeneratedPictoComponents/* ESIM104 */.Ajh),
  ESIM56: () => (/* reexport */ GeneratedPictoComponents/* ESIM56 */.rZ2),
  EarnPoints104: () => (/* reexport */ GeneratedPictoComponents/* EarnPoints104 */.IAd),
  EarnPoints56: () => (/* reexport */ GeneratedPictoComponents/* EarnPoints56 */.n2T),
  Edit104: () => (/* reexport */ GeneratedPictoComponents/* Edit104 */.CKo),
  Edit56: () => (/* reexport */ GeneratedPictoComponents/* Edit56 */.Z1W),
  Electricity104: () => (/* reexport */ GeneratedPictoComponents/* Electricity104 */.zJi),
  Electricity56: () => (/* reexport */ GeneratedPictoComponents/* Electricity56 */.rzt),
  ElectricityMeter104: () => (/* reexport */ GeneratedPictoComponents/* ElectricityMeter104 */.LwD),
  ElectricityMeter56: () => (/* reexport */ GeneratedPictoComponents/* ElectricityMeter56 */.BRD),
  EmptyStateBox104: () => (/* reexport */ GeneratedPictoComponents/* EmptyStateBox104 */.g$g),
  EmptyStateBox56: () => (/* reexport */ GeneratedPictoComponents/* EmptyStateBox56 */.e$j),
  EmptyStateTray104: () => (/* reexport */ GeneratedPictoComponents/* EmptyStateTray104 */.scW),
  EmptyStateTray56: () => (/* reexport */ GeneratedPictoComponents/* EmptyStateTray56 */.LOC),
  Energy104: () => (/* reexport */ GeneratedPictoComponents/* Energy104 */.mwz),
  Energy56: () => (/* reexport */ GeneratedPictoComponents/* Energy56 */.cxZ),
  EnergySolar104: () => (/* reexport */ GeneratedPictoComponents/* EnergySolar104 */.PEY),
  EnergySolar56: () => (/* reexport */ GeneratedPictoComponents/* EnergySolar56 */.Eg3),
  EnergyWind104: () => (/* reexport */ GeneratedPictoComponents/* EnergyWind104 */.IGW),
  EnergyWind56: () => (/* reexport */ GeneratedPictoComponents/* EnergyWind56 */.uRb),
  EnterpriseCloud104: () => (/* reexport */ GeneratedPictoComponents/* EnterpriseCloud104 */.Y0F),
  EnterpriseCloud56: () => (/* reexport */ GeneratedPictoComponents/* EnterpriseCloud56 */.Pae),
  Entertainment104: () => (/* reexport */ GeneratedPictoComponents/* Entertainment104 */.CVp),
  Entertainment56: () => (/* reexport */ GeneratedPictoComponents/* Entertainment56 */.Akg),
  EntertainmentPackages104: () => (/* reexport */ GeneratedPictoComponents/* EntertainmentPackages104 */.g2b),
  EntertainmentPackages56: () => (/* reexport */ GeneratedPictoComponents/* EntertainmentPackages56 */.rSd),
  Error104: () => (/* reexport */ GeneratedPictoComponents/* Error104 */.q3E),
  Error56: () => (/* reexport */ GeneratedPictoComponents/* Error56 */.y8Q),
  FailedConnection104: () => (/* reexport */ GeneratedPictoComponents/* FailedConnection104 */.kSh),
  FailedConnection56: () => (/* reexport */ GeneratedPictoComponents/* FailedConnection56 */.bqd),
  Feedback104: () => (/* reexport */ GeneratedPictoComponents/* Feedback104 */.Qo6),
  Feedback56: () => (/* reexport */ GeneratedPictoComponents/* Feedback56 */.PzP),
  Foxtel104: () => (/* reexport */ GeneratedPictoComponents/* Foxtel104 */.ozX),
  Foxtel56: () => (/* reexport */ GeneratedPictoComponents/* Foxtel56 */.R7k),
  Gaming104: () => (/* reexport */ GeneratedPictoComponents/* Gaming104 */.F_x),
  Gaming56: () => (/* reexport */ GeneratedPictoComponents/* Gaming56 */.QbW),
  Gas104: () => (/* reexport */ GeneratedPictoComponents/* Gas104 */.sxi),
  Gas56: () => (/* reexport */ GeneratedPictoComponents/* Gas56 */.SLv),
  GasMeter104: () => (/* reexport */ GeneratedPictoComponents/* GasMeter104 */.Jqg),
  GasMeter56: () => (/* reexport */ GeneratedPictoComponents/* GasMeter56 */.ciy),
  Gift104: () => (/* reexport */ GeneratedPictoComponents/* Gift104 */.ZeT),
  Gift56: () => (/* reexport */ GeneratedPictoComponents/* Gift56 */.ezu),
  GlobalNetworks104: () => (/* reexport */ GeneratedPictoComponents/* GlobalNetworks104 */.WHB),
  GlobalNetworks56: () => (/* reexport */ GeneratedPictoComponents/* GlobalNetworks56 */.Ici),
  GreenEnergy104: () => (/* reexport */ GeneratedPictoComponents/* GreenEnergy104 */.Vi6),
  GreenEnergy56: () => (/* reexport */ GeneratedPictoComponents/* GreenEnergy56 */.FMV),
  Help104: () => (/* reexport */ GeneratedPictoComponents/* Help104 */.iUm),
  Help56: () => (/* reexport */ GeneratedPictoComponents/* Help56 */.wal),
  History104: () => (/* reexport */ GeneratedPictoComponents/* History104 */.hF6),
  History56: () => (/* reexport */ GeneratedPictoComponents/* History56 */.a8D),
  Home104: () => (/* reexport */ GeneratedPictoComponents/* Home104 */.ri0),
  Home56: () => (/* reexport */ GeneratedPictoComponents/* Home56 */.hjU),
  IOT104: () => (/* reexport */ GeneratedPictoComponents/* IOT104 */.TdW),
  IOT56: () => (/* reexport */ GeneratedPictoComponents/* IOT56 */.lqr),
  IOTUpdate104: () => (/* reexport */ GeneratedPictoComponents/* IOTUpdate104 */._bn),
  IOTUpdate56: () => (/* reexport */ GeneratedPictoComponents/* IOTUpdate56 */.Sb8),
  Information104: () => (/* reexport */ GeneratedPictoComponents/* Information104 */.BRu),
  Information56: () => (/* reexport */ GeneratedPictoComponents/* Information56 */.Cuv),
  Installation104: () => (/* reexport */ GeneratedPictoComponents/* Installation104 */.EAo),
  Installation56: () => (/* reexport */ GeneratedPictoComponents/* Installation56 */.vxn),
  InternationalCalls104: () => (/* reexport */ GeneratedPictoComponents/* InternationalCalls104 */.eN1),
  InternationalCalls56: () => (/* reexport */ GeneratedPictoComponents/* InternationalCalls56 */.fY1),
  InternationalMobileCalls104: () => (/* reexport */ GeneratedPictoComponents/* InternationalMobileCalls104 */.FbT),
  InternationalMobileCalls56: () => (/* reexport */ GeneratedPictoComponents/* InternationalMobileCalls56 */.ONF),
  Internet104: () => (/* reexport */ GeneratedPictoComponents/* Internet104 */.bJI),
  Internet56: () => (/* reexport */ GeneratedPictoComponents/* Internet56 */.I46),
  InternetExtras104: () => (/* reexport */ GeneratedPictoComponents/* InternetExtras104 */.SGn),
  InternetExtras56: () => (/* reexport */ GeneratedPictoComponents/* InternetExtras56 */.NYS),
  InternetOptimiser104: () => (/* reexport */ GeneratedPictoComponents/* InternetOptimiser104 */.B1),
  InternetOptimiser56: () => (/* reexport */ GeneratedPictoComponents/* InternetOptimiser56 */.ert),
  Landline104: () => (/* reexport */ GeneratedPictoComponents/* Landline104 */.lvw),
  Landline56: () => (/* reexport */ GeneratedPictoComponents/* Landline56 */.Bz),
  Laptop104: () => (/* reexport */ GeneratedPictoComponents/* Laptop104 */.SX5),
  Laptop56: () => (/* reexport */ GeneratedPictoComponents/* Laptop56 */.Yon),
  Legal104: () => (/* reexport */ GeneratedPictoComponents/* Legal104 */.iTQ),
  Legal56: () => (/* reexport */ GeneratedPictoComponents/* Legal56 */.TXk),
  MBBRoaming104: () => (/* reexport */ GeneratedPictoComponents/* MBBRoaming104 */._To),
  MBBRoaming56: () => (/* reexport */ GeneratedPictoComponents/* MBBRoaming56 */.wpg),
  Mail104: () => (/* reexport */ GeneratedPictoComponents/* Mail104 */.bcY),
  Mail56: () => (/* reexport */ GeneratedPictoComponents/* Mail56 */.dSo),
  MapMarkeGlobal104: () => (/* reexport */ GeneratedPictoComponents/* MapMarkeGlobal104 */.BGl),
  MapMarkeGlobal56: () => (/* reexport */ GeneratedPictoComponents/* MapMarkeGlobal56 */._v0),
  MapMarker104: () => (/* reexport */ GeneratedPictoComponents/* MapMarker104 */.WI3),
  MapMarker56: () => (/* reexport */ GeneratedPictoComponents/* MapMarker56 */.rnZ),
  Membership104: () => (/* reexport */ GeneratedPictoComponents/* Membership104 */.ZV$),
  Membership56: () => (/* reexport */ GeneratedPictoComponents/* Membership56 */.Btd),
  Mobile104: () => (/* reexport */ GeneratedPictoComponents/* Mobile104 */.hB6),
  Mobile56: () => (/* reexport */ GeneratedPictoComponents/* Mobile56 */.Lvx),
  MobileAccelerator104: () => (/* reexport */ GeneratedPictoComponents/* MobileAccelerator104 */.D7f),
  MobileAccelerator56: () => (/* reexport */ GeneratedPictoComponents/* MobileAccelerator56 */.exz),
  MobileSim104: () => (/* reexport */ GeneratedPictoComponents/* MobileSim104 */.qt4),
  MobileSim56: () => (/* reexport */ GeneratedPictoComponents/* MobileSim56 */.JqI),
  MoveHouse104: () => (/* reexport */ GeneratedPictoComponents/* MoveHouse104 */.jS_),
  MoveHouse56: () => (/* reexport */ GeneratedPictoComponents/* MoveHouse56 */.PFt),
  Movies104: () => (/* reexport */ GeneratedPictoComponents/* Movies104 */.Ll5),
  Movies56: () => (/* reexport */ GeneratedPictoComponents/* Movies56 */.rAw),
  Music104: () => (/* reexport */ GeneratedPictoComponents/* Music104 */.L6o),
  Music56: () => (/* reexport */ GeneratedPictoComponents/* Music56 */.lck),
  NBN104: () => (/* reexport */ GeneratedPictoComponents/* NBN104 */.btj),
  NBN56: () => (/* reexport */ GeneratedPictoComponents/* NBN56 */.VDp),
  NetworkSpeed104: () => (/* reexport */ GeneratedPictoComponents/* NetworkSpeed104 */.J6z),
  NetworkSpeed56: () => (/* reexport */ GeneratedPictoComponents/* NetworkSpeed56 */.G0x),
  NetworkSpeeds104: () => (/* reexport */ GeneratedPictoComponents/* NetworkSpeeds104 */.q_V),
  NetworkSpeeds56: () => (/* reexport */ GeneratedPictoComponents/* NetworkSpeeds56 */.g9s),
  News104: () => (/* reexport */ GeneratedPictoComponents/* News104 */.v_5),
  News56: () => (/* reexport */ GeneratedPictoComponents/* News56 */.w6e),
  NotificationCall104: () => (/* reexport */ GeneratedPictoComponents/* NotificationCall104 */.bYv),
  NotificationCall56: () => (/* reexport */ GeneratedPictoComponents/* NotificationCall56 */.XHb),
  NotificationEmail104: () => (/* reexport */ GeneratedPictoComponents/* NotificationEmail104 */.duM),
  NotificationEmail56: () => (/* reexport */ GeneratedPictoComponents/* NotificationEmail56 */.eE8),
  NotificationMessage104: () => (/* reexport */ GeneratedPictoComponents/* NotificationMessage104 */.or5),
  NotificationMessage56: () => (/* reexport */ GeneratedPictoComponents/* NotificationMessage56 */.vj9),
  NotificationReminder104: () => (/* reexport */ GeneratedPictoComponents/* NotificationReminder104 */.sow),
  NotificationReminder56: () => (/* reexport */ GeneratedPictoComponents/* NotificationReminder56 */.hSV),
  Notifications104: () => (/* reexport */ GeneratedPictoComponents/* Notifications104 */.P0R),
  Notifications56: () => (/* reexport */ GeneratedPictoComponents/* Notifications56 */.Qt7),
  OneNumber104: () => (/* reexport */ GeneratedPictoComponents/* OneNumber104 */.QDA),
  OneNumber56: () => (/* reexport */ GeneratedPictoComponents/* OneNumber56 */.IeU),
  Payment104: () => (/* reexport */ GeneratedPictoComponents/* Payment104 */.Anw),
  Payment56: () => (/* reexport */ GeneratedPictoComponents/* Payment56 */.Hql),
  PaymentCalendar104: () => (/* reexport */ GeneratedPictoComponents/* PaymentCalendar104 */.v5q),
  PaymentCalendar56: () => (/* reexport */ GeneratedPictoComponents/* PaymentCalendar56 */.QvZ),
  PaymentHelp104: () => (/* reexport */ GeneratedPictoComponents/* PaymentHelp104 */.i8x),
  PaymentHelp56: () => (/* reexport */ GeneratedPictoComponents/* PaymentHelp56 */.fVQ),
  PaymentPlan104: () => (/* reexport */ GeneratedPictoComponents/* PaymentPlan104 */.DoT),
  PaymentPlan56: () => (/* reexport */ GeneratedPictoComponents/* PaymentPlan56 */.R9p),
  PeaceOfMind104: () => (/* reexport */ GeneratedPictoComponents/* PeaceOfMind104 */.na2),
  PeaceOfMind56: () => (/* reexport */ GeneratedPictoComponents/* PeaceOfMind56 */.Dj1),
  Perfect104: () => (/* reexport */ GeneratedPictoComponents/* Perfect104 */.YuB),
  Perfect56: () => (/* reexport */ GeneratedPictoComponents/* Perfect56 */.spX),
  Phone104: () => (/* reexport */ GeneratedPictoComponents/* Phone104 */.rAN),
  Phone56: () => (/* reexport */ GeneratedPictoComponents/* Phone56 */.tcf),
  Picto4G104: () => (/* reexport */ GeneratedPictoComponents/* Picto4G104 */.BHA),
  Picto4G56: () => (/* reexport */ GeneratedPictoComponents/* Picto4G56 */.KXb),
  Picto4GX104: () => (/* reexport */ GeneratedPictoComponents/* Picto4GX104 */.NHx),
  Picto4GX56: () => (/* reexport */ GeneratedPictoComponents/* Picto4GX56 */.Bfj),
  Picto5G104: () => (/* reexport */ GeneratedPictoComponents/* Picto5G104 */.Wvn),
  Picto5G56: () => (/* reexport */ GeneratedPictoComponents/* Picto5G56 */.bOI),
  Pin104: () => (/* reexport */ GeneratedPictoComponents/* Pin104 */.gh0),
  Pin56: () => (/* reexport */ GeneratedPictoComponents/* Pin56 */.kbu),
  Placeholder104: () => (/* reexport */ GeneratedPictoComponents/* Placeholder104 */.TzK),
  Placeholder56: () => (/* reexport */ GeneratedPictoComponents/* Placeholder56 */.JN5),
  PortMobile104: () => (/* reexport */ GeneratedPictoComponents/* PortMobile104 */.Q8U),
  PortMobile56: () => (/* reexport */ GeneratedPictoComponents/* PortMobile56 */.OCc),
  PortPhone104: () => (/* reexport */ GeneratedPictoComponents/* PortPhone104 */.lep),
  PortPhone56: () => (/* reexport */ GeneratedPictoComponents/* PortPhone56 */.A8I),
  PortSIM104: () => (/* reexport */ GeneratedPictoComponents/* PortSIM104 */.$PY),
  PortSIM56: () => (/* reexport */ GeneratedPictoComponents/* PortSIM56 */.Ci1),
  PostPaid104: () => (/* reexport */ GeneratedPictoComponents/* PostPaid104 */.vE2),
  PostPaid56: () => (/* reexport */ GeneratedPictoComponents/* PostPaid56 */.raY),
  PrePaid104: () => (/* reexport */ GeneratedPictoComponents/* PrePaid104 */.GWJ),
  PrePaid56: () => (/* reexport */ GeneratedPictoComponents/* PrePaid56 */.FB_),
  Preferences104: () => (/* reexport */ GeneratedPictoComponents/* Preferences104 */.Xgg),
  Preferences56: () => (/* reexport */ GeneratedPictoComponents/* Preferences56 */.rBF),
  Profile104: () => (/* reexport */ GeneratedPictoComponents/* Profile104 */.qMn),
  Profile56: () => (/* reexport */ GeneratedPictoComponents/* Profile56 */.jih),
  PromoCombined104: () => (/* reexport */ GeneratedPictoComponents/* PromoCombined104 */.o2s),
  PromoCombined56: () => (/* reexport */ GeneratedPictoComponents/* PromoCombined56 */.QDR),
  PromoData104: () => (/* reexport */ GeneratedPictoComponents/* PromoData104 */.TzJ),
  PromoData56: () => (/* reexport */ GeneratedPictoComponents/* PromoData56 */.Wao),
  PromoDiscount104: () => (/* reexport */ GeneratedPictoComponents/* PromoDiscount104 */.cFO),
  PromoDiscount56: () => (/* reexport */ GeneratedPictoComponents/* PromoDiscount56 */.GDA),
  RecurringPayment104: () => (/* reexport */ GeneratedPictoComponents/* RecurringPayment104 */.rj2),
  RecurringPayment56: () => (/* reexport */ GeneratedPictoComponents/* RecurringPayment56 */.$Xz),
  RedeemPoints104: () => (/* reexport */ GeneratedPictoComponents/* RedeemPoints104 */.g42),
  RedeemPoints56: () => (/* reexport */ GeneratedPictoComponents/* RedeemPoints56 */.ytt),
  Rewards104: () => (/* reexport */ GeneratedPictoComponents/* Rewards104 */.b8o),
  Rewards56: () => (/* reexport */ GeneratedPictoComponents/* Rewards56 */.Tp2),
  Roaming104: () => (/* reexport */ GeneratedPictoComponents/* Roaming104 */.j9x),
  Roaming56: () => (/* reexport */ GeneratedPictoComponents/* Roaming56 */.DLp),
  RoamingOn104: () => (/* reexport */ GeneratedPictoComponents/* RoamingOn104 */.Pzb),
  RoamingOn56: () => (/* reexport */ GeneratedPictoComponents/* RoamingOn56 */.Kzt),
  SIM104: () => (/* reexport */ GeneratedPictoComponents/* SIM104 */.g09),
  SIM56: () => (/* reexport */ GeneratedPictoComponents/* SIM56 */.ZtF),
  Search104: () => (/* reexport */ GeneratedPictoComponents/* Search104 */.bGH),
  Search56: () => (/* reexport */ GeneratedPictoComponents/* Search56 */.Js7),
  Security104: () => (/* reexport */ GeneratedPictoComponents/* Security104 */.kQo),
  Security56: () => (/* reexport */ GeneratedPictoComponents/* Security56 */.Wme),
  SecurityHome104: () => (/* reexport */ GeneratedPictoComponents/* SecurityHome104 */.YY6),
  SecurityHome56: () => (/* reexport */ GeneratedPictoComponents/* SecurityHome56 */.aU7),
  SecurityInternet104: () => (/* reexport */ GeneratedPictoComponents/* SecurityInternet104 */.qnS),
  SecurityInternet56: () => (/* reexport */ GeneratedPictoComponents/* SecurityInternet56 */.CL6),
  SecurityMobile104: () => (/* reexport */ GeneratedPictoComponents/* SecurityMobile104 */.Sc0),
  SecurityMobile56: () => (/* reexport */ GeneratedPictoComponents/* SecurityMobile56 */.ylJ),
  Services104: () => (/* reexport */ GeneratedPictoComponents/* Services104 */.ANW),
  Services56: () => (/* reexport */ GeneratedPictoComponents/* Services56 */.rFN),
  Settings104: () => (/* reexport */ GeneratedPictoComponents/* Settings104 */.RXT),
  Settings56: () => (/* reexport */ GeneratedPictoComponents/* Settings56 */.OZf),
  Shop104: () => (/* reexport */ GeneratedPictoComponents/* Shop104 */.xOX),
  Shop56: () => (/* reexport */ GeneratedPictoComponents/* Shop56 */.KrX),
  SmartHome104: () => (/* reexport */ GeneratedPictoComponents/* SmartHome104 */.Bu9),
  SmartHome56: () => (/* reexport */ GeneratedPictoComponents/* SmartHome56 */.z2T),
  SomethingWentWrong104: () => (/* reexport */ GeneratedPictoComponents/* SomethingWentWrong104 */.it4),
  SomethingWentWrong56: () => (/* reexport */ GeneratedPictoComponents/* SomethingWentWrong56 */.phD),
  Sporting104: () => (/* reexport */ GeneratedPictoComponents/* Sporting104 */.hp9),
  Sporting56: () => (/* reexport */ GeneratedPictoComponents/* Sporting56 */.W8u),
  Store104: () => (/* reexport */ GeneratedPictoComponents/* Store104 */.VxG),
  Store56: () => (/* reexport */ GeneratedPictoComponents/* Store56 */.Z72),
  StoreAddress104: () => (/* reexport */ GeneratedPictoComponents/* StoreAddress104 */.O0i),
  StoreAddress56: () => (/* reexport */ GeneratedPictoComponents/* StoreAddress56 */.qW$),
  Success104: () => (/* reexport */ GeneratedPictoComponents/* Success104 */.vuq),
  Success56: () => (/* reexport */ GeneratedPictoComponents/* Success56 */.RJ1),
  SupportPhone104: () => (/* reexport */ GeneratedPictoComponents/* SupportPhone104 */.P7G),
  SupportPhone56: () => (/* reexport */ GeneratedPictoComponents/* SupportPhone56 */.sBE),
  Switch104: () => (/* reexport */ GeneratedPictoComponents/* Switch104 */.osG),
  Switch56: () => (/* reexport */ GeneratedPictoComponents/* Switch56 */.TSZ),
  TV104: () => (/* reexport */ GeneratedPictoComponents/* TV104 */.mjY),
  TV56: () => (/* reexport */ GeneratedPictoComponents/* TV56 */.m1N),
  Tablet104: () => (/* reexport */ GeneratedPictoComponents/* Tablet104 */.q9Z),
  Tablet56: () => (/* reexport */ GeneratedPictoComponents/* Tablet56 */.lwP),
  TabletSim104: () => (/* reexport */ GeneratedPictoComponents/* TabletSim104 */.TjP),
  TabletSim56: () => (/* reexport */ GeneratedPictoComponents/* TabletSim56 */.zbW),
  Technician104: () => (/* reexport */ GeneratedPictoComponents/* Technician104 */.GGM),
  Technician56: () => (/* reexport */ GeneratedPictoComponents/* Technician56 */.Pfq),
  Teen104: () => (/* reexport */ GeneratedPictoComponents/* Teen104 */.qDb),
  Teen56: () => (/* reexport */ GeneratedPictoComponents/* Teen56 */.qVu),
  Telstra104: () => (/* reexport */ GeneratedPictoComponents/* Telstra104 */.qrC),
  Telstra56: () => (/* reexport */ GeneratedPictoComponents/* Telstra56 */.UeK),
  TelstraAir104: () => (/* reexport */ GeneratedPictoComponents/* TelstraAir104 */.oE8),
  TelstraAir56: () => (/* reexport */ GeneratedPictoComponents/* TelstraAir56 */.SkN),
  TelstraLocator104: () => (/* reexport */ GeneratedPictoComponents/* TelstraLocator104 */.MJX),
  TelstraLocator56: () => (/* reexport */ GeneratedPictoComponents/* TelstraLocator56 */.EjF),
  TelstraPlus104: () => (/* reexport */ GeneratedPictoComponents/* TelstraPlus104 */.rJf),
  TelstraPlus56: () => (/* reexport */ GeneratedPictoComponents/* TelstraPlus56 */.Xlr),
  TelstraTV104: () => (/* reexport */ GeneratedPictoComponents/* TelstraTV104 */.O$r),
  TelstraTV56: () => (/* reexport */ GeneratedPictoComponents/* TelstraTV56 */.L0t),
  Ticket104: () => (/* reexport */ GeneratedPictoComponents/* Ticket104 */.VDC),
  Ticket56: () => (/* reexport */ GeneratedPictoComponents/* Ticket56 */.WQb),
  TrackOrder104: () => (/* reexport */ GeneratedPictoComponents/* TrackOrder104 */.Lx),
  TrackOrder56: () => (/* reexport */ GeneratedPictoComponents/* TrackOrder56 */.ao0),
  Train104: () => (/* reexport */ GeneratedPictoComponents/* Train104 */.wMQ),
  Train56: () => (/* reexport */ GeneratedPictoComponents/* Train56 */.xuq),
  TransferRequest104: () => (/* reexport */ GeneratedPictoComponents/* TransferRequest104 */.eUC),
  TransferRequest56: () => (/* reexport */ GeneratedPictoComponents/* TransferRequest56 */.gYY),
  Troubleshoot104: () => (/* reexport */ GeneratedPictoComponents/* Troubleshoot104 */.Sjn),
  Troubleshoot56: () => (/* reexport */ GeneratedPictoComponents/* Troubleshoot56 */.Bax),
  TruckFire104: () => (/* reexport */ GeneratedPictoComponents/* TruckFire104 */.N_L),
  TruckFire56: () => (/* reexport */ GeneratedPictoComponents/* TruckFire56 */.yFu),
  UnifiedComms104: () => (/* reexport */ GeneratedPictoComponents/* UnifiedComms104 */.WPl),
  UnifiedComms56: () => (/* reexport */ GeneratedPictoComponents/* UnifiedComms56 */.vzL),
  Unlimited104: () => (/* reexport */ GeneratedPictoComponents/* Unlimited104 */.zVv),
  Unlimited56: () => (/* reexport */ GeneratedPictoComponents/* Unlimited56 */.HLs),
  VIP104: () => (/* reexport */ GeneratedPictoComponents/* VIP104 */.Efi),
  VIP56: () => (/* reexport */ GeneratedPictoComponents/* VIP56 */.sHA),
  Warning104: () => (/* reexport */ GeneratedPictoComponents/* Warning104 */.x4L),
  Warning56: () => (/* reexport */ GeneratedPictoComponents/* Warning56 */.QrA),
  WeCare104: () => (/* reexport */ GeneratedPictoComponents/* WeCare104 */.kKL),
  WeCare56: () => (/* reexport */ GeneratedPictoComponents/* WeCare56 */.N9Y),
  WiFi104: () => (/* reexport */ GeneratedPictoComponents/* WiFi104 */.uHO),
  WiFi56: () => (/* reexport */ GeneratedPictoComponents/* WiFi56 */.bDU),
  WiFiBooster104: () => (/* reexport */ GeneratedPictoComponents/* WiFiBooster104 */.Fr0),
  WiFiBooster56: () => (/* reexport */ GeneratedPictoComponents/* WiFiBooster56 */.qdE),
  Window104: () => (/* reexport */ GeneratedPictoComponents/* Window104 */.orh),
  Window56: () => (/* reexport */ GeneratedPictoComponents/* Window56 */.DLU),
  "default": () => (/* binding */ src_Picto)
});

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(8779);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);
// EXTERNAL MODULE: external "@babel/runtime/helpers/objectWithoutProperties"
var objectWithoutProperties_ = __webpack_require__(3838);
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties_);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(6689);
// EXTERNAL MODULE: external "react/jsx-runtime"
var jsx_runtime_ = __webpack_require__(997);
;// CONCATENATED MODULE: ./src/Picto/Picto.tsx


var _excluded = ["className", "theme", "children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { defineProperty_default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



/**
 *
 * Illustrations help convey complex ideas in a simple way.
 * They should be meaningful and reflect a user's context and emotional state.
 * We use them to make technical information feel more human, and add some personality to the way we communicate.
 *
 * [View the Picto documentation on Confluence](https://confluence.tools.telstra.com/display/DCSYS/A1+Pictograms+and+Illustrations)
 *
 * @version 1.0.0
 */

function Picto(props) {
  var className = props.className,
    theme = props.theme,
    children = props.children,
    other = objectWithoutProperties_default()(props, _excluded);
  var classes = classnames_default()('able-picto', "able-picto--".concat(theme), className);
  var childProps = _objectSpread({
    className: classes,
    focusable: 'false',
    'aria-hidden': 'true'
  }, other);
  var SelectedPictogram = function SelectedPictogram() {
    return /*#__PURE__*/(0,external_react_.cloneElement)(children, childProps);
  };
  return /*#__PURE__*/(0,jsx_runtime_.jsx)(SelectedPictogram, {});
}
/* harmony default export */ const Picto_Picto = (Picto);
// EXTERNAL MODULE: ./src/Picto/Picto.scss
var src_Picto_Picto = __webpack_require__(6608);
// EXTERNAL MODULE: ./src/Picto/GeneratedPictoComponents/index.tsx + 349 modules
var GeneratedPictoComponents = __webpack_require__(4022);
;// CONCATENATED MODULE: ./src/Picto/index.ts



/* harmony default export */ const src_Picto = (Picto_Picto);
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});